webpackJsonp([0],{

/***/ "+7wu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      active: '0',
      Registration: [{ 'title': '参与的', 'id': '0', 'router': '/myparticipate/0' }, { 'title': '关注的', 'id': '1', 'router': '/myfollow' }, { 'title': '上传的', 'id': '2', 'router': '/myupload' }, { 'title': '@我的', 'id': '3', 'router': '/mynotice' }],
      initUtil: {
        bodyEl: document.body,
        topNum: 0,
        stopBodyScroll: function stopBodyScroll(isFixed) {
          var _this = this;
          if (isFixed) {
            _this.topNum = window.scrollY;
            _this.bodyEl.style.position = 'fixed';
            _this.bodyEl.style.overflow = 'hidden';
            _this.bodyEl.style.top = -_this.topNum + 'px';
          } else {
            _this.bodyEl.style.position = '';
            _this.bodyEl.style.top = '';
            _this.bodyEl.style.overflow = '';
            window.scrollTo(0, _this.topNum); // 回到原先的top;
          }
        }
      },
      userId: ''
    };
  },

  methods: {
    //操作按钮事件
    //返回顶部
    fnBack: function fnBack() {
      this.$router.back(-1);
    },
    fn: function fn() {
      $('html,body').stop().animate({ scrollTop: '0px' }, 500);
    },
    prompt: function prompt() {
      location.reload();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = false;
    next();
  },

  created: function created() {
    var that = this;
    if (that.IsPC()) {
      window.location.href = API.IsPcName;
    }
    //账户

    var urlArr = window.location.href.split('/');
    var len = urlArr.length;
    var name = urlArr[len - 1].toLowerCase();
    that.userId = that.getCookie('userSeqId');
    if (!that.loginFn()) {
      that.$router.push({ name: 'login_SignIn' });
    }
  },
  mounted: function mounted() {
    //操作DOM
    //刷新页面
    var that = this;
    $('.router-link-exact-active').addClass('nav-on').siblings().removeClass('nav-on');
    //文本输入框根据内容自动变高
    $('textarea').unbind('input');
    $('textarea').bind('input', function () {
      handleTextareaHeight(this);
    });

    function handleTextareaHeight(element) {
      var textareaMinHeight = 72;
      element.style.height = textareaMinHeight + 'px';
      if (element.scrollHeight > textareaMinHeight) {
        element.style.height = element.scrollHeight + 'px';
      }
    }

    var dataName = {
      title: "央视喊你上电视", //分享标题
      desc: '央视热门栏目面向广大网友征集原创作品啦！要上电视？那就来吧！一个舞台不一样的精彩。', //metas[1].content,//分享简介(内容)
      imgAddress: "http://img.itv.cctvpic.com/ishow/2018/08/17/9777171c5917ffa6a2b31a5f65aed241.jpg", //分享图片地址
      Retain: '', //保留
      url: API.UrlName //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
    };
    that.weixinShare(dataName);
    // that.$http.get(API.GetShareInfo, {params: {module: 'home'}})
    //   .then(function (res) {
    //     if (res.code == 0) {
    //       var title = '',
    //         desc = '';
    //       if (res.data.share_title) {
    //         title = res.data.share_title
    //       } else {
    //         title = '央视喊你上电视'
    //       }
    //       if (res.data.share_contents) {
    //         desc = res.data.share_contents
    //       } else {
    //         desc = '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动';
    //       }
    //       var dataName = {
    //         title: title,  //分享标题
    //         desc: that.removeTAG(desc, 110),//metas[1].content,//分享简介(内容)
    //         imgAddress: res.data.share_pic || 'http://ishow.cctv.com/images/poster-img.jpg',//分享图片地址
    //         Retain: '',//保留
    //         url: API.UrlName //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
    //       };
    //       that.weixinShare(dataName)
    //     }
    //   })
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "+FNL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+W+0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+XoV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ugV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newestTpl_vue__ = __webpack_require__("4xHO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9cd9e58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newestTpl_vue__ = __webpack_require__("aG0c");
function injectStyle (ssrContext) {
  __webpack_require__("RUXs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newestTpl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9cd9e58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newestTpl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0JSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "release",
  props: ["detailsTxte", "twoNumbers"],
  data: function data() {
    return {
      tablesName: '',
      tables: '',
      tablesTitle: ''
    };
  },

  methods: {
    // 操作按钮事件
  },
  created: function created() {
    var that = this;
    var pageConfig = that.detailsTxte.page_config;
    var id = this.$route.params.id;
    if (pageConfig && pageConfig.popular && pageConfig.popular.is_show == 1) {
      //GetActivities
      that.$http.get(API.GetActivities, {
        params: {
          progress: 'on',
          page: 1,
          pagesize: 6,
          version: 2
        }
      }).then(function (res) {
        if (res.code == '0') {
          that.tablesTitle = pageConfig.popular.title;
          that.tablesName = Math.floor(res.data.length / 2);
          that.tables = res.data;
          //console.log(res.data)
          that.$nextTick(function () {
            var picWimg = $('.pic-box').width();
            var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
            $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });

            var swiperPoll = new Swiper('.show-poll-swiper', {
              loop: true,
              autoplayDisableOnInteraction: false
            });
          });
        }
      });
    } else {
      $('#hotActivity').hide();
    }
  },
  mounted: function mounted() {
    // 操作DOM
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "0RFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myActivity_vue__ = __webpack_require__("+7wu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5709a2e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myActivity_vue__ = __webpack_require__("27t3");
function injectStyle (ssrContext) {
  __webpack_require__("tFxH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myActivity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5709a2e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myActivity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0miA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-tem",attrs:{"id":"loading"}},[_c('div',{staticClass:"content index-content"},[_c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1odT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['item_data'],
  data: function data() {
    return {
      // arr: arrAll,
      prov: '',
      city: '',
      options: [],
      item_name: '',
      selectedOptions: [],
      idx: -1
    };
  },

  computed: {
    options1: function options1() {
      return this.idx >= 0 ? this.options[this.idx].children : [];
    }

  },
  methods: {
    onClickMe1: function onClickMe1(event) {
      // console.log(event.target.value);
      $('.selmul').removeClass('font');
      var val = event.target.value;
      this.city = '';
      this.findIdx(val);
      this.$emit('change', {
        value: [this.prov],
        name: this.item_name
      });
    },
    onClickMe2: function onClickMe2() {
      $('.selmul').removeClass('font');
      this.$emit('change', {
        value: [this.prov, this.city],
        name: this.item_name
      });
    },

    parseData: function parseData() {
      var opts = JSON.parse(this.item_data.option_json);
      var optArr = [];
      var idx = 0;
      opts.forEach(function (item) {
        if (item.level == '1') {
          var obj = {
            value: item.val,
            label: item.val,
            children: []
          };
          optArr.push(obj);
          idx = optArr.length - 1;
        } else {
          optArr[idx].children.push({
            value: item.val,
            label: item.val
          });
        }
      });
      this.options = optArr;
    },
    initData: function initData() {
      var that = this;
      that.item_name = that.item_data.name;
      var def_val = that.item_data.isChoose;
      if (def_val) {
        that.selectedOptions = def_val.split(',');
        that.prov = that.selectedOptions[0] || '';
        that.city = that.selectedOptions[1] || '';
        if (this.prov) {
          this.findIdx(this.prov);
        }
        that.$emit('change', {
          value: that.selectedOptions,
          name: that.item_name
        });
      }
    },
    findIdx: function findIdx(val) {
      this.idx = this.options.findIndex(function (v, i) {
        return val == v.value;
      });
    }
  },

  created: function created() {
    var that = this;
    that.parseData();
    that.initData();
  },
  mounted: function mounted() {
    //操作DOM

  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "23u4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nf-box"},[_c('div',{staticClass:"header detail-header"},[_c('a',{staticClass:"f-l",attrs:{"href":"javascript:void(0);"}},[_c('router-link',{staticClass:"icon-logo",attrs:{"to":"/home","tag":"i"}})],1),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/sds.png',"alt":""}})]),_vm._v(" "),_c('a',{staticClass:"f-r",attrs:{"href":"javascript:void(0)"}},[_c('router-link',{staticClass:"icon-menu",attrs:{"to":"/find","tag":"i"}})],1)]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/xx.png',"alt":""}})]),_vm._v(" "),_c('p',{staticClass:"nf-word"},[_vm._v("呀，活动找不到了！")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "27t3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myActivity"},[_c('div',{staticClass:"header ay-header"},[_c('div',{staticClass:"nav"},_vm._l((_vm.Registration),function(item,ind){return _c('router-link',{class:ind == _vm.active?'id-nav-recom nav-on':'id-nav-recom',attrs:{"exact":"","to":item.router,"replace":""},nativeOn:{"click":function($event){_vm.active =ind}}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])})),_vm._v(" "),_c('router-link',{staticClass:"icon-back",attrs:{"to":"/mymessage","tag":"a"}})],1),_vm._v(" "),_c('div',{staticClass:"content ay-content"},[(_vm.userId)?_c('router-view',{attrs:{"userId":_vm.userId,"initUtil":_vm.initUtil}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"back-top",staticStyle:{"display":"none"},on:{"click":_vm.fn}},[_vm._v("\n    返回顶部\n  ")]),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"Prompt","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.prompt()}}},[_vm._v("确定")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"Prompt-p"},[_vm._v("\n                修改成功 "),_c('br'),_vm._v("\n                正在审核中\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2YR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videoList_vue__ = __webpack_require__("hCSf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f39a561e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videoList_vue__ = __webpack_require__("l+9E");
function injectStyle (ssrContext) {
  __webpack_require__("P5R9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f39a561e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videoList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f39a561e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videoList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2cs+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__ = __webpack_require__("xBaD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db76c916_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__ = __webpack_require__("Uac2");
function injectStyle (ssrContext) {
  __webpack_require__("Q9Fz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db76c916_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3NbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voteAlert_vue__ = __webpack_require__("vi+G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4462e86a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voteAlert_vue__ = __webpack_require__("x3XZ");
function injectStyle (ssrContext) {
  __webpack_require__("RgoS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voteAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4462e86a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voteAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3OcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"follow",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"10","infinite-scroll-throttle-delay":"1000"}},[(_vm.MyFollow.length)?_c('div',{staticClass:"ay-content-list"},_vm._l((_vm.MyFollow),function(item,ind){return _c('div',{staticClass:"ay-link ay-cor"},[(item.status !=='2')?_c('div',{staticClass:"foll"},[_c('p',{staticClass:"ay-title-time"},[_vm._v(_vm._s(_vm._f("datetime")(item.create_time)))]),_vm._v(" "),_c('router-link',{staticClass:"ay-inr",attrs:{"tag":"div","to":{name:'Detail',params: {id:item.id,route:item.playbill}}}},[_c('div',{staticClass:"ay-pic-box"},[_c('img',{staticClass:"ay-pic",attrs:{"src":item.playbill.playbill_small_h5 +'?p=3&o=2&w=350&h=197',"alt":""}}),_vm._v(" "),_c('i',{staticClass:"ay-pic-t"})]),_vm._v(" "),_c('p',{staticClass:"ay-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(item.end_time != '')?_c('p',{staticClass:"ay-time"},[_vm._v(_vm._s(_vm._f("orderBys")(item.end_time,item.start_time)))]):_c('p',{staticClass:"ay-time"},[_vm._v("永久活动")])]),_vm._v(" "),_c('div',{staticClass:"btn-ay"},[_c('a',{staticClass:"btn-ay-red",attrs:{"href":"javascript:void(0);","attr-id":item.id}},[_vm._v("取消关注")])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ay-atten"},[(item.hostunit)?_c('img',{staticClass:"ay-atten-pic",attrs:{"src":item.hostunit.host_avatar,"alt":""}}):_vm._e(),_vm._v(" "),(item.hostunit)?_c('p',[_vm._v(_vm._s(item.hostunit.channel_title)+" "+_vm._s(item.hostunit.column_name))]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"ay-more",attrs:{"to":"/find"}},[_vm._v("更多活动")])],1)])})):_c('div',{staticClass:"foll_div"},[_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.busy),expression:"!busy"}],staticClass:"content index-content",staticStyle:{"padding-top":"5px"}},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"editModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_c('h3',{staticClass:"Prompt-p"},[_vm._v("你确定要取消关注？  ")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.editcComplete()}}},[_vm._v("完成")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("取消")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content index-content"},[_c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3XOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ifv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "42xm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.MSIE)?_c('div',{attrs:{"id":"alert"}},[_c('img',{attrs:{"src":_vm.globalUrl + '/static/dist/img/alert.png',"alt":""}})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "49Y+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entryform_vue__ = __webpack_require__("j/yj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f33b27a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entryform_vue__ = __webpack_require__("Lh0K");
function injectStyle (ssrContext) {
  __webpack_require__("uSqW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entryform_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f33b27a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entryform_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4H4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_series_vue__ = __webpack_require__("kSqn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0efd75_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_series_vue__ = __webpack_require__("ySwH");
function injectStyle (ssrContext) {
  __webpack_require__("wUpx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d0efd75"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_series_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0efd75_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_series_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Pb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__ = __webpack_require__("AHUE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76de52ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__ = __webpack_require__("A1Lt");
function injectStyle (ssrContext) {
  __webpack_require__("HQlB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76de52ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4skC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vote",
  props: ["detailsTxte", "twoNumbers"],
  data: function data() {
    return {
      activity: '', // 为他投票活动
      activityTitle: '', // 投票Title---
      activityName: '' // 为他投票数量/2
    };
  },

  methods: {
    // 操作按钮事件
  },
  created: function created() {
    var that = this;
    var pageConfig = that.detailsTxte.page_config;
    var id = this.$route.params.id;
    // 投票展示
    if (that.detailsTxte.is_vote == 1 && pageConfig && pageConfig.vote && pageConfig.vote.is_show == 1 && that.detailsTxte.type != 1) {
      that.activityTitle = pageConfig.vote.title;
      // 网友投票信息
      var getVoteList = {
        activity_id: id,
        page: 1,
        pagesize: 10,
        order: 'vote_count',
        sort: 'SORT_DESC'
      };
      // 为他投票
      that.$http.get(API.GetGetVoteList, { params: getVoteList }).then(function (res) {
        if (res.code == 0) {
          that.activityName = Math.floor(res.data.length / 2);
          that.activity = res.data;
          that.$nextTick(function () {
            // internet friend poll
            var swiperPoll = new Swiper('.show-poll-swiper', {
              loop: true
            });
            new Swiper('.show-activiy-swiper', {
              loop: true
            });
            // 图片比例
            that.PictureRatio();
          });
        } else {
          // console.log('为他投票-请求数据信息出错')
        }
      });
    } else {
      $('.dl-message').hide();
      $('.btn-detail-poll').hide();
    }
  },
  mounted: function mounted() {
    // 操作DOM
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "4xHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['tables', 'tablesName'],
  data: function data() {
    return {
      twoNumbers: 2
    };
  },

  methods: {
    //操作按钮事件
  },
  mounted: function mounted() {
    //操作DOM
  }

});

/***/ }),

/***/ "51ZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"participate"},[_c('p',{staticClass:"text_uid",staticStyle:{"font-size":"15px","margin":"0","color":"#999","padding-left":"10px"}},[_vm._v("参与ID："),_c('span',{staticStyle:{"color":"#b40000","line-height":"35px"}},[_vm._v(_vm._s(_vm.userId))])]),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],attrs:{"id":"ay-content","infinite-scroll-immediate-check":"false","immediate-check":"false","infinite-scroll-disabled":"busy","infinite-scroll-distance":"10","infinite-scroll-throttle-delay":"1000"}},[(_vm.participate.length)?_c('div',{staticClass:"ay-content-list activity-list"},[_vm._l((_vm.participate),function(item,ind){return _c('div',{staticClass:"ay-link ay-cor"},[_c('div',{class:item.is_delete == 1?'':'ay-close',attrs:{"attr-id":item.form_id,"attr-type":item.file_type}}),_vm._v(" "),_c('p',{staticClass:"ay-title-time"},[_vm._v(_vm._s(_vm._f("datetime")(item.create_time)))]),_vm._v(" "),_c('div',{staticClass:"ay-inr"},[_c('router-link',{staticClass:"ay-pic-box",attrs:{"tag":"div","to":{name:'Detail',params: {id:item.activity_mini.id}}}},[(item.activity_mini.playbill)?_c('img',{staticClass:"ay-pic",attrs:{"src":item.activity_mini.playbill.playbill_small_h5 + '?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"ay-pic-t"})]),_vm._v(" "),(item.activity_mini)?_c('p',{staticClass:"ay-title"},[_vm._v(_vm._s(item.activity_mini.title))]):_vm._e(),_vm._v(" "),(item.activity_mini)?_c('p',{staticClass:"ay-time"},[_vm._v(_vm._s(_vm._f("orderBys")(item.activity_mini.end_time,item.activity_mini.start_time)))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"btn-ay btn-ay-box"},[(new Date(item.activity_mini.end_time)/1 >new Date(new Date()).getTime())?_c('a',{staticClass:"btn-ay-red",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.modify(item.activity_mini.id,item.form_id,item.uploadimg,item.uploadvideo)}}},[_vm._v("修改报名表")]):_c('a',{staticClass:"btn-ay-end",attrs:{"href":"javascript:void(0);"}},[_vm._v("修改报名表")]),_vm._v(" "),(new Date(item.activity_mini.end_time)/1 >new Date(new Date()).getTime())?_c('a',{staticClass:"btn-ay-red btn-admin-work",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.WorkManagement(item)}}},[_vm._v("管理作品")]):_c('a',{staticClass:"btn-ay-end",attrs:{"href":"javascript:void(0);"}},[_vm._v("管理作品")]),_vm._v(" "),(_vm.iswx)?_c('a',{staticClass:"btn-ay-red btn-admin-work",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.wxShare(item.activity_mini)}}},[_vm._v("分享")]):_vm._e()])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.busy),expression:"!busy"}],staticClass:"content index-content"},[_vm._m(0)])],2):_vm._e(),_vm._v(" "),(_vm.participate.length == 0)?_c('div',{staticClass:"foll_div"},[_vm._m(1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ay-content-modal"},[_c('div',{staticClass:"ay-modal-close"},[_c('span',{on:{"click":_vm.end}},[_vm._v("返回")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.titel))])]),_vm._v(" "),_c('div',{staticClass:"ay-content-list ay-content-file"},[_vm._l((_vm.MyUpload),function(item,ind){return (_vm.MyUpload.length > 0)?_c('div',{staticClass:"ay-link ay-cor"},[(_vm.canEdit)?_c('div',{class:item.is_delete == 1?'':'ay-close ay-file',attrs:{"attr-id":item.uuid,"id":item.id,"attr-type":item.file_type}}):_vm._e(),_vm._v(" "),(item.file_type == 'video')?_c('p',{staticClass:"ay-title-time"},[_vm._v(_vm._s(_vm._f("datetime")(item.file.upload_datetime)))]):_vm._e(),_vm._v(" "),(item.file_type == 'image')?_c('p',{staticClass:"ay-title-time"},[_vm._v(_vm._s(_vm._f("datetime")(item.file.upload_time)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ay-inr"},[_c('div',{staticClass:"ay-pic-box",on:{"click":function($event){_vm.video(item)}}},[(item.file_type == 'video')?_c('img',{staticClass:"ay-pic",attrs:{"src":item.file.thumb_url + '?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),(item.file_type == 'image')?_c('img',{staticClass:"ay-pic",attrs:{"src":item.file.image_url + '?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),(item.file.time_span)?_c('i',{staticClass:"ay-pic-t"},[_vm._v(_vm._s(_vm._f("formatSeconds")(item.file.time_span)))]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"ay-title"},[_vm._v(_vm._s(item.file.title))]),_vm._v(" "),_c('div',{staticClass:"btn-ay"},[(_vm.canEdit&& item.file.status == 'approved')?_c('a',{staticClass:"btn-ay-red btn-ay-edit",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.edit(item.id,item.file_type,item.file.title,item.file.description,item.file_id)}}},[_vm._v("编辑")]):_vm._e()])]),_vm._v(" "),(item.file)?_c('div',{staticClass:"ay-inr-bottom"},[(item.file.status == 'approved')?_c('span',{staticClass:"icon-ygs"},[(item.file.is_edit == '1')?_c('i',{staticStyle:{"font-style":"normal"}},[_vm._v("审核中（编辑）")]):_c('i',{staticStyle:{"font-style":"normal"}},[_vm._v("审核通过")])]):_vm._e(),_vm._v(" "),(item.file.status == 'none' && item.file.audit_level === 0)?_c('span',{staticClass:"icon-ygs"},[_c('i',{staticStyle:{"font-style":"normal"}},[_vm._v("上传成功")])]):_vm._e(),_vm._v(" "),(item.file.status == 'none'  && item.file.audit_level !== 0)?_c('span',{staticClass:"icon-ygs"},[_c('i',{staticStyle:{"font-style":"normal"}},[_vm._v("审核中")])]):_vm._e(),_vm._v(" "),(item.file.status == 'rejected')?_c('span',{staticClass:"icon-ygs"},[_vm._v("\n              审核未通过\n          ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon-poll"},[_vm._v("\n                  "+_vm._s(_vm._f("ticket")(item.file.vote_num))+"\n          ")]),_vm._v(" "),(item.is_recommend == 1)?_c('span',{staticClass:"icon-btj"},[_vm._v("\n                  被推荐\n          ")]):_vm._e(),_vm._v(" "),(item.is_recommend == 1)?_c('span',{staticClass:"icon-bxy"},[_vm._v("\n                  被选用\n          ")]):_vm._e()]):_vm._e()]):_vm._e()}),_vm._v(" "),(_vm.MyUpload.length == 0)?_c('div',{staticClass:"content index-content",staticStyle:{"text-align":"center","color":"#888"}},[_vm._m(2)]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"editModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.editcComplete}},[_vm._v("完成")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("取消")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"editModalactive","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_c('h3',{staticClass:"Prompt-p"},[_vm._v("你确定要删除参与的活动？  ")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw",staticStyle:{"padding-bottom":"0"}},[_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.DelActive}},[_vm._v("完成")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("取消")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"editModals","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_c('h3',{staticClass:"Prompt-p",attrs:{"id":"file-h3"}},[_vm._v("你确定要删除上传文件？  ")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.DelFile}},[_vm._v("完成")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("取消")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"picture-content",on:{"click":_vm.pictureHide}},[_vm._m(5),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('Filedetails',{attrs:{"fileItem":_vm.fileItem,"data":_vm.data,"tops":_vm.tops}}),_vm._v(" "),_c('div',{staticClass:"shart",on:{"click":_vm.shareHide}},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/weixin.png',"alt":""}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content index-content"},[_c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("名称")]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('input',{attrs:{"type":"text","id":"titleName","placeholder":"请输入名称"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("描述")]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('textarea',{attrs:{"rows":"3","id":"descriptionName","placeholder":"请输入描述信息"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picture-content-div"},[_c('img',{staticClass:"picture-img",attrs:{"src":__webpack_require__("n7la"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picture-ph"},[_c('h3',{staticClass:"picture-h3"},[_vm._v("详情title")]),_vm._v(" "),_c('p',{staticClass:"picture-p"},[_vm._v("详情title详情title详情title")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5DNw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_filedetails_vue__ = __webpack_require__("LjJY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import message from './MyParticipate-message.vue'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userId', 'initUtil'],
  data: function data() {
    return {
      participate: [],
      MyUpload: [],
      titel: '',
      page: 1,
      pages: 0,
      pageChl: 1,
      pagesize: '10',
      FileByUserid: null,
      ByUserid: null,
      scrill: false,
      scrills: false,
      ind: '',
      inds: '',
      fileId: '',
      id: '',
      file_type: '',
      form_id: '',
      total: 0,
      busy: false,
      countArr: [],
      fileItem: '',
      tops: '',
      data: '',
      detailsTxte: '',
      globalUrl: API.GlobalUrl,
      canEdit: true
    };
  },


  methods: {
    //操作按钮事件


    pictureHide: function pictureHide() {
      $('.picture-content').hide();
    },

    //跳转播放页面
    video: function video(item) {
      var that = this;
      that.fileItem = item;
      if (item.file.status == 'approved' || item.file.is_edit == 0 && item.file.status != 'rejected') {
        if (item.file_type == 'video') {
          this.data = new Date();
          this.setShareInfo(item);
        } else if (item.file_type == 'image') {
          this.data = new Date();
        }
        $('.preview-file').addClass('preview-active');
        // $('.dl-video-title').show();
        this.tops = $(document).scrollTop();
      }
    },


    /**
     * 设置分享信息
     * @param {[type]} fileInfo [description]
     */
    setShareInfo: function setShareInfo(item) {
      var dataName = {
        title: item.file.title,
        // desc: this.removeTAG(item.file.description, 110),
        desc: this.removeTAG('我参与了【' + item.activity_mini.title + '】', 110),
        imgAddress: item.file.thumb_url,
        Retain: '', // 保留
        url: API.UrlName + 'videoName/' + item.activity_id + '/' + item.file_id + '/video'
      };

      this.weixinShare(dataName);
    },

    //修改报名表
    modify: function modify(id, form_id, uploadImg, uploadVideo) {
      //console.log(id,form_id)
      // this.id=id;
      // this.form_id=form_id;
      this.$router.push({ name: 'Revise', params: { id: id, form_id: form_id } }); //继续参与
      // this.countArr.push(uploadImg,uploadVideo)
      // $('.entry-content').show();
      // $('body').css('overflow','hidden')
    },

    //删除参与活动
    DelActive: function DelActive() {
      var that = this;
      var Active = {
        form_id: that.id,
        user_id: that.userId
      };
      // console.log(Active)
      this.$http.get(API.DelActivityForm, { params: Active }).then(function (res) {
        //  console.log(res);
        if (res.code == 0) {
          $('.ay-close').eq(that.ind).parents('.ay-cor').remove();
          $('#editModalactive').modal('hide');
          window.location.reload();
          /*  if($('.activity-list').children('.ay-cor').length == 0){
              that.participate = []
            }*/
        }
      });
    },

    //删除上传文件
    DelFile: function DelFile() {
      //删除视频
      var that = this;
      /*    $('.ay-file').eq(that.ind).parents('.ay-link').remove();
          $('#editModals').modal('hide');*/
      /*     if(that.file_type == '1'){
             var edit = API.DelEteVideo
           }else{
             //删除图片
             var edit = API.DelEteImage
           }*/
      this.$http.get(API.DelActivityFile, { params: { id: that.ID } }).then(function (res) {
        if (res.code == 0) {
          $('.ay-file').eq(that.ind).parents('.ay-link').remove();
          $('#editModals').modal('hide');
        }
      });
    },

    //作品管理
    WorkManagement: function WorkManagement(item) {
      // console.log(ind,title)
      var ind = item.activity_mini.id,
          title = item.activity_mini.title;
      // edit
      if (item.edit_form && item.edit_form.is_show == 0) {
        this.canEdit = false;
      }
      $('.icon-back').addClass('pointerEve');
      var that = this;
      //活动id
      that.titel = title;
      that.inds = ind;
      $('.ay-content-modal').addClass('ay-modal-show');
      that.initUtil.stopBodyScroll(true);
      that.MyUpload = [];
      that.ByUserid = {
        activity_id: that.inds,
        page: 1,
        pagesize: that.pagesize
      };
      //console.log(that.ByUserid)
    },
    edit: function edit(ind, file_type, title, description, uuid) {
      $('.btn-modal-tw').attr('data-id', uuid).attr('file_type', file_type);
      $('#editModal').modal('show');
      $('#titleName').val(title);
      $('#descriptionName').val(description);
      //selected
      $('#editModal').find('option').eq(--file_type).prop('selected', 'selected');
    },
    editcComplete: function editcComplete() {
      //编辑
      //title  description
      var that = this;
      if ($('#titleName').val() == '') {
        $('#titleName').focus();
      } else if ($('#descriptionName').val() == '') {
        $('#descriptionName').focus();
      } else {
        var ActivityFile = {
          title: $('#titleName').val(),
          description: $('#descriptionName').val(),
          fileId: $('.btn-modal-tw').attr('data-id')
        };
        //console.log($('.btn-modal-tw').attr('data-id'));
        var edit;
        //判断类型  是图片还是视频
        if ($('.btn-modal-tw').attr('file_type') == 'video') {
          edit = API.UpdataVideoAudit;
        } else {
          edit = API.UpdataImageAudit;
        }
        //console.log(ActivityFile)
        $.ajax({
          'url': edit,
          'data': ActivityFile,
          'type': 'POST',
          'dataType': 'json',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          success: function success(res) {
            //console.log(res)
            if (res.code == '0') {
              $('#editModal').modal('hide');
              $('#Prompt').modal('show');
              that.MyUpload = [];
              that.ByUserid = {
                activity_id: that.inds,
                page: 1,
                pagesize: that.pagesize
              };
            }
          }
        });
      }
    },
    end: function end() {
      $('.icon-back').removeClass('pointerEve');;
      //  关闭作品管理
      $('.ay-content-modal').removeClass('ay-modal-show');
      this.initUtil.stopBodyScroll(false);
      //重新获取数据
    },

    //参与活动
    loadMore: function loadMore() {
      var _this = this;

      this.busy = true;
      // 多次加载数据
      setTimeout(function () {
        _this.pages++;
        _this.ajaxMore(true);
      }, 500);
    },
    ajaxMore: function ajaxMore(flag) {
      var that = this;
      that.FileByUserid = {
        page: that.pages,
        pagesize: that.pagesize
      };
      this.$http.get(API.GetActivitieByUserid, { params: that.FileByUserid }).then(function (res) {
        // console.log(res)
        if (res.code == 0) {
          if (flag) {
            for (var i = 0; i < res.data.length; i++) {
              that.participate.push(res.data[i]);
            }
            that.$nextTick(function () {
              if (res.data.length === 0 || that.participate.length === res.total) {
                that.busy = true;
              } else {
                that.busy = false;
              }
            });
          }
          if (res.data.total == '0') {
            $('.foll_div').html('您还没有参与活动！');
          }
          // console.log(res.data)
        }
      });
    },
    shareHide: function shareHide() {
      $('.shart').hide();
    },
    wxShare: function wxShare(item) {
      var that = this;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (isWeixin) {
        $('.shart').show();
      }

      that.$http.get(API.GetActivitieById, { params: { id: item.id } }).then(function (res) {
        console.log(res);
        // return;
        if (res.code == 0) {

          var dataTime = new Date(res.data.end_time).getTime() / 1 - new Date().getTime();
          if (dataTime < 0) {
            that.$router.push({ name: 'Detail', params: { id: that.id } });
          }
          var detailsTxte = res.data;
          // that.route = detailsTxte.playbill.playbill;

          //分享微信
          var title = '',
              desc = '',
              img = '';
          if (detailsTxte.share_config) {
            var activity = detailsTxte.share_config.activity;
            if (activity && activity.share_title) {
              title = activity.share_title;
            } else if (detailsTxte.share_config.share_title) {
              title = detailsTxte.share_config.share_title;
            } else {
              title = detailsTxte.title;
            }
            if (activity && activity.share_contents) {
              desc = activity.share_contents;
            } else if (detailsTxte.share_config.share_contents) {
              desc = detailsTxte.share_config.share_contents;
            } else {
              desc = detailsTxte.description;
            }
            if (activity.share_pic) {
              img = activity.share_pic;
            }
          } else {
            title = detailsTxte.title;
            desc = detailsTxte.description;
            img = detailsTxte.playbill.playbill_h5;
          }
          document.title = title;
          var metas = $('head').children('meta');
          metas[1].content = desc;
          if (img == '' && detailsTxte.playbill && detailsTxte.playbill.playbill_h5) {
            img = detailsTxte.playbill.playbill_h5;
          }
          console.log(img);
          var dataName = {
            title: title, //分享标题
            desc: /*'央视热门栏目面向广大网友征集原创作品啦！要上电视？那就来吧！一个舞台不一样的精彩。',*/metas[1].content, //分享简介(内容)
            imgAddress: img, //分享图片地址
            Retain: '', //保留
            url: API.UrlName + 'detail/' + detailsTxte.id //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
          };
          console.log(dataName);
          that.weixinShare(dataName);
        }
      });
    }
  },
  computed: {
    iswx: function iswx() {
      var ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('micromessenger') != -1;
    }
  },
  //message
  components: {
    // Message: message,
    Filedetails: __WEBPACK_IMPORTED_MODULE_0__template_filedetails_vue__["a" /* default */]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = true;
    next();
  },

  created: function created() {
    //console.log(this.userId)
    //ajax数据请求
    var id = this.$route.params.id;
    var that = this;
    //暂时固定
    // if(id && id > 0){
    //   that.id = id;
    //   this.$http.get(API.GetMyActiviteInfo, {params: {activity_id: that.id}})
    //     .then(function (res) {
    //       if(res.code == 0){
    //         setTimeout(function(){
    //           that.form_id = res.data[0].form_id;
    //          //  that.countArr = '[0,0]';
    //           $('.entry-content').show();
    //         },1300)
    //       }
    //     });
    //   // 判断安卓机去掉动画
    //    that.isAndroid();
    //    //分享微信
    //    that.$http.get(API.GetActivitieById, {params: {id: that.id}})
    //      .then(function (res) {
    //        //   console.log(res)
    //        if (res.code == 0) {
    //          if (!res.data || res.data.length == 0) {
    //            that.$router.push({name: 'HomeIndex'})
    //          }
    //          var dataTime = new Date(res.data.end_time).getTime() / 1  - new Date().getTime();
    //          if (dataTime < 0) {
    //            that.$router.push({name: 'Detail', params: {id: that.id}});
    //          }
    //          var  detailsTxte = res.data;
    //          // that.route = detailsTxte.playbill.playbill;

    //          //分享微信
    //          var title = '', desc = '';
    //          if (detailsTxte.share_config) {
    //            var activity = detailsTxte.share_config.activity;
    //            if (activity && activity.share_title) {
    //              title = activity.share_title
    //            } else if (detailsTxte.share_config.share_title) {
    //              title = detailsTxte.share_config.share_title;
    //            } else {
    //              title = detailsTxte.title;
    //            }
    //            if (activity && activity.share_contents) {
    //              desc = activity.share_contents
    //            } else if (detailsTxte.share_config.share_contents) {
    //              desc = detailsTxte.share_config.share_contents
    //            } else {
    //              desc = detailsTxte.description
    //            }
    //          } else {
    //            title = detailsTxte.title;
    //            desc = detailsTxte.description
    //          }
    //          document.title = title;
    //          let metas = $('head').children('meta');
    //          metas[1].content = desc;
    //          var img = '';
    //          if (res.data.share_pic) {
    //            img = res.data.share_pic
    //          } else if (detailsTxte.playbill && detailsTxte.playbill.playbill_h5) {
    //            img = detailsTxte.playbill.playbill_h5
    //          }
    //          var dataName = {
    //            title: title,  //分享标题
    //            desc: that.removeTAG(desc, 110),//metas[1].content,//分享简介(内容)
    //            imgAddress: img,//分享图片地址
    //            Retain: '',//保留
    //            url: API.UrlName + 'detail/' + that.id//点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
    //          };
    //          that.weixinShare(dataName)
    //        }
    //      });
    // }
    //活动上传文件
    that.loadMore();
    $('.icon-back').removeClass('pointerEve');
    that.$watch('ByUserid', function () {
      //console.log(that.ByUserid)
      this.$http.get(API.GetActivityFileByUserid, { params: that.ByUserid }).then(function (res) {
        //console.log(res);
        if (res.code == 0) {
          that.total = res.total;
          for (var i = 0; i < res.data.length; i++) {
            // if(res.data[i].status ==="none"){
            //     if(res.data[i].file_type==='video'){
            //         res.data[i].file.thumb_url =API.GlobalUrl + 'static/dist/img/audit_1.jpg';
            //     }
            //     else {
            //         res.data[i].file.image_url=API.GlobalUrl + 'static/dist/img/audit_1.jpg';
            //     }

            // }
            // if(res.data[i].status ==="rejected"){
            //    if(res.data[i].file_type==='video'){
            //         res.data[i].file.thumb_url =API.GlobalUrl + 'static/dist/img/reject_1.jpg.png';
            //     }
            //     else {
            //         res.data[i].file.image_url=API.GlobalUrl + 'static/dist/img/reject_1.jpg';
            //     }
            // }

            that.MyUpload.push(res.data[i]);
            // console.log(i)
          }
          if (res.total == 0) {
            $('.ay-content-file .index-content').html('未查找到报名数据！');
          }
        }
      });
      //console.log(that.MyUpload.length)
    });
  },

  mounted: function mounted() {
    //操作DOM
    var that = this;
    var len = this.pagesize,
        lens = this.pagesize;

    //活动滚动事件，加载数据
    $(window).scroll(function () {
      if ($(window).scrollTop() > 1000) {
        $('.back-top').show();
      } else {
        $('.back-top').hide();
      }
    });
    $('.nav').children('.id-nav-recom').eq(0).addClass('nav-on').siblings().removeClass('nav-on');
    $('.nav').find('.id-nav-recom').eq(0).addClass('router-link-exact-active').siblings().removeClass('router-link-exact-active');

    //活动上传文件
    $('.ay-content-modal').scroll(function () {
      if (that.MyUpload.length >= lens || that.MyUpload.length < that.total) {
        that.scrills = true;
      }
      var H = $('.ay-content-file').outerHeight() - document.body.clientHeight;
      //滚动加载数据
      if ($('.ay-content-modal').scrollTop() > H && that.scrills) {
        that.scrills = false;
        lens = lens / 1 + 10;
        var pageChl = ++that.pageChl;
        //参与活动
        that.ByUserid = {
          activity_id: that.inds,
          page: pageChl,
          pagesize: that.pagesize
        };
      }
    });

    //删除参与的
    $('#ay-content').on('click', '.ay-close', function () {
      that.id = $(this).attr('attr-id');
      that.ind = $(this).parents().index();
      //console.log(that.id,that.ind);
      $('#editModalactive').modal('show');
    });
    //删除上传文件
    //   $('#editModals').modal('show');
    $('.participate').on('click', '.ay-file', function () {

      that.fileId = $(this).attr('attr-id');
      that.ID = $(this).attr('id');
      that.ind = $(this).parents().index();
      that.file_type = $(this).attr('attr-type');
      //console.log(that.fileId,that.ID);
      $('#editModals').modal('show');
    });
    this.initUtil.stopBodyScroll(false);

    //微信分享

    var metas = $('head').children('meta');
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "5Uqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login",staticStyle:{"height":"100%","position":"fixed","top":"0","left":"0","width":"100%","min-height":"100vh","display":"flex","flex-direction":"column"}},[_c('div',{staticClass:"quick-alert",staticStyle:{"flex":"1"}},[_c('Quick')],1),_vm._v(" "),_c('div',{staticClass:"signIn-alert",staticStyle:{"display":"none","flex":"1"}},[_c('SignIn')],1),_vm._v(" "),(_vm.thirdParty)?_c('div',{staticClass:"third"},[_c('Thirdparty')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5eia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EntryformVue"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content entry-content"},[(_vm.router)?_c('div',{staticClass:"et-banner dl-banner"},[_c('img',{attrs:{"src":_vm.router,"alt":""}}),_vm._v(" "),_c('i',{staticClass:"et-modal-white"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"et-tabinner"},[_c('router-view')],1)])]),_vm._v(" "),_c('div',{staticClass:"back-top",staticStyle:{"display":"none"},on:{"click":_vm.ReturnTop}},[_vm._v("\n    返回顶部\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5zCw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__ = __webpack_require__("txGb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b852d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__ = __webpack_require__("toje");
function injectStyle (ssrContext) {
  __webpack_require__("3ifv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b852d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "68N7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by Administrator on 2017/11/16.
 */
var api = '',
    url = '',
    IsPC = '',
    apiNew = '',
    DomainName = 'http://';
//  DomainName = '//';
var hostUrl = document.location.href;
DomainName = 'https:' == document.location.protocol ? "https://" : "http://";
// if (hostUrl.split(':')[0] == 'https') {
//   DomainName = 'https://';
// } else {
//   DomainName = 'http://';
// }
// $.ajax({
//   url: '../../../../../static/api.json',
//   // url: '../../../../../h5/static/api.json',//打包用
//   async: false,
//   success: function (data) {
//     var hostUrl = document.location.href;

//     if (hostUrl.split(':')[0] == 'https') {
//       DomainName = 'https://'
//     } else {
//       DomainName = 'http://'
//     }
//     api = DomainName + data.status;
//     url = DomainName + data.address;
//     IsPC = data.IsPC;
//     apiNew = DomainName + data.apiNew
//   }
// });

api = DomainName + "api.ishow.cctv.com/";
apiNew = DomainName + "common.ishow.cctv.com/";
url = DomainName + "act.ishow.cctv.com/";
// console.log(api);
// console.log(apiNew);
// console.log(url);
var UrlName = url + 'h5/';
var GlobalUrl = '/h5/';

var IsPcName = url;

var GetShareInfo = apiNew + 'recommend/getShareInfo'; // 添加title，meta
var UploadToken = api + 'Manage/videoToken'; // 上传VideoToken请求地址
var ImageToken = api + 'Manage/imageToken'; // 上传图片
var WorldToken = api + 'Manage/worldToken'; // 上传文档
var GetAliToken = api + "Uploadali/getStsToken"; // 阿里token
var RecommendFile = api + 'recommend/file'; // 获取首页推荐作品
var GetRecommend = api + 'recommend/index'; // 获取首页轮播
var GetHomeOnList = api + 'recommend/gethotlist'; // 首页正在进行
var GetChannelList = apiNew + 'channel/getChannelList'; // 央视频道
var GetHomeChannel = apiNew + 'channel/getHomeChannel'; // 央视频道-首页推荐导航
var GetActivities = api + 'activity/getActivities'; // 活动列表
var GetHotActivity = api + 'activity/getHotActivity'; // 活动热门
var GetActivitieById = apiNew + 'activity/getActivityById'; //活 动详情
var UploadNew = api + 'ActivityFile/uploadNew'; // 最新上传
var VideoModel = api + 'ActivityFile/recommend'; // 最新上传 -- 优秀作品 d
var VideoLatest = api + '/ActivityFile/latestUploads'; //最新上传视频
var GetGetVCode = api + 'vote/getVCode'; // 生成验证码
var GetValidvode = api + 'vote/validvode'; // 验证验证码
var GetVoteConfig = api + 'vote/getVoteConfig'; // 获取投票配置信息
var GetIpLimit = api + 'vote/ipLimit'; // 投票--ip限制和更新投票数、记录投票信息
var GetGetVoteList = api + 'vote/getVoteList'; // 获取投票信息列表
var VoteActivity = api + 'vote/voteActivity'; // 获取投票单个文件信息
var GetRelatedVideo = api + 'activityFile/RelatedVideo'; // 活动进展
var FileRelatedVideo = api + 'ActivityFile/fileList'; // 相关视频d  ---获取一个活动里的优秀作品/精彩图集
var GetVideoInfo = api + 'Video/getVideoInfo'; // 视频详情
var GetImageInfo = api + 'Image/getImageInfo'; // 图片详情

/*var GetActivityFormFields = apiNew + 'ActivityFormFields/getActivityFormFieldsList'; */
var GetActivityFormFields = apiNew + 'Activity/getActivityFormFieldsList'; // 新请求报名字段
var GetUserActivityInfo = api + 'ActivityFormFields/getUserActivityInfo'; // 用户信息
var IsJoin = api + 'ActivityFormFields/isJoin'; // isJoin 是否报名

var AddActivityForm = api + 'ActivityForm/addActivityForm'; // 添加报名信息，用户报名
var GetActivityForms = api + 'ActivityForm/getActivityForms'; // 活动信息列表
var GetActivityFormContent = api + 'ActivityForm/getActivityFormContent'; // 我参与--修改报名表
var GetActivitieByUserid = api + 'My/getActivitie'; // 我的活动（参与的)
var GetMyActiviteInfo = api + 'My/getMyActiviteInfo'; // 我的活动（参与的-搜索)
var GetUploadFileForMe = api + 'Manage/getUploadFile'; // 我的活动（上传的）
var GetActivityFileByUserid = api + 'My/getActivityFile'; // 我的活动（参与的--管理作品)
var GetActivitieFollowByUserid = api + 'My/getActivitieFollow'; // 我的活动（关注的)
var GetActivityMsgList = api + 'ActivityMsg/getActivityMsgList'; // 我的活动（@我的)
var UpdataVideoAudit = api + 'Manage/updateVideo'; // 编辑视频
var UpdataImageAudit = api + 'Manage/updateImage'; // 编辑图片
var DelEteVideo = api + 'Manage/deleteVideo'; // 删除上传视频
var DelEteImage = api + 'Manage/deleteImage'; // 删除上传图片
var DelActivityFile = api + 'My/delActivityFile'; // 删除上传文件
var DelActivityMsgById = api + 'ActivityMsg/delActivityMsgById'; // 删除@我的
var DelActivityFollow = api + 'ActivityFollow/delActivityFollow'; // 取消关注
var AddActivityFollow = api + 'ActivityFollow/addActivityFollow'; // 添加关注
var IsFollowByUserid = api + 'ActivityFollow/isFollowByUserId'; // 是否关注过
var DelActivityForm = api + 'ActivityForm/delActivityForm'; // 取消参与
var UpdateActivityForm = api + 'ActivityForm/updateActivityForm'; // 编辑参与的
var GetCountByUserid = api + 'User/getUserInfo'; // 我的统计数
var SaveActivityUser = api + 'User/updataActivityUser'; // 我的信息修改
var ShowActivityUser = api + 'User/getUserInfo'; // 我的信息获取
var FileList = api + 'ActivityFile/fileList'; // 发现文件-瀑布流
var VideoFavorite = api + 'video/videoFavorite'; // 视频点赞接口d
var ImageFavorite = api + 'Image/favorite'; //  图片点赞接口d
/* harmony default export */ __webpack_exports__["a"] = ({
  DomainName: DomainName,
  UrlName: UrlName,
  IsPcName: IsPcName,
  GlobalUrl: GlobalUrl,
  GetShareInfo: GetShareInfo,
  UploadToken: UploadToken,
  ImageToken: ImageToken,
  WorldToken: WorldToken,
  GetAliToken: GetAliToken,
  RecommendFile: RecommendFile,
  GetRecommend: GetRecommend,
  GetHomeOnList: GetHomeOnList,
  GetChannelList: GetChannelList,
  GetHomeChannel: GetHomeChannel,
  GetActivities: GetActivities,
  GetHotActivity: GetHotActivity,
  GetActivitieById: GetActivitieById,
  UploadNew: UploadNew,
  VideoModel: VideoModel,
  VideoLatest: VideoLatest,
  GetGetVCode: GetGetVCode,
  GetValidvode: GetValidvode,
  GetVoteConfig: GetVoteConfig,
  GetIpLimit: GetIpLimit,
  GetGetVoteList: GetGetVoteList,
  VoteActivity: VoteActivity,
  GetRelatedVideo: GetRelatedVideo,
  FileRelatedVideo: FileRelatedVideo,
  GetVideoInfo: GetVideoInfo,
  GetImageInfo: GetImageInfo,
  GetActivityFormFields: GetActivityFormFields,
  GetUserActivityInfo: GetUserActivityInfo,
  IsJoin: IsJoin,
  AddActivityForm: AddActivityForm,
  GetActivityForms: GetActivityForms,
  GetActivityFormContent: GetActivityFormContent,
  GetActivitieByUserid: GetActivitieByUserid,
  GetMyActiviteInfo: GetMyActiviteInfo,
  GetUploadFileForMe: GetUploadFileForMe,
  GetActivityFileByUserid: GetActivityFileByUserid,
  GetActivitieFollowByUserid: GetActivitieFollowByUserid,
  GetActivityMsgList: GetActivityMsgList,
  UpdataVideoAudit: UpdataVideoAudit,
  UpdataImageAudit: UpdataImageAudit,
  DelEteVideo: DelEteVideo,
  DelEteImage: DelEteImage,
  DelActivityFile: DelActivityFile,
  DelActivityMsgById: DelActivityMsgById,
  DelActivityFollow: DelActivityFollow,
  AddActivityFollow: AddActivityFollow,
  IsFollowByUserid: IsFollowByUserid,
  DelActivityForm: DelActivityForm,
  GetCountByUserid: GetCountByUserid,
  UpdateActivityForm: UpdateActivityForm,
  SaveActivityUser: SaveActivityUser,
  ShowActivityUser: ShowActivityUser,
  FileList: FileList,
  VideoFavorite: VideoFavorite,
  ImageFavorite: ImageFavorite
});

/***/ }),

/***/ "6LLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_SignIn"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"header login-header"},[_c('a',{staticClass:"icon-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.fn}}),_vm._v(" "),_vm._v("央视账号登录\n    ")]),_vm._v(" "),_c('div',{staticClass:"line-gray"}),_vm._v(" "),_c('div',{staticClass:"content login-content"},[_c('form',{staticClass:"lg-tabbox",attrs:{"id":"punishformID"}},[_c('div',{staticClass:"group-item"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-box input-tel"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],attrs:{"type":"text","placeholder":"请输入邮箱或手机","name":"username","id":"username"},domProps:{"value":(_vm.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userName!= ''),expression:"userName!= ''"}],staticClass:"btn-del",staticStyle:{"display":"none"},on:{"click":function($event){_vm.userName = ''}}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger uname",staticStyle:{"display":"none"}},[_vm._v("输入格式有误，请使用邮箱或手机号登录")]),_vm._v(" "),_c('div',{staticClass:"group-item"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"input-box input-tel"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"请输入密码","name":"password","id":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.password!= ''),expression:"password!= ''"}],staticClass:"btn-del",staticStyle:{"display":"none"},on:{"click":function($event){_vm.password = ''}}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger upass",staticStyle:{"display":"none"}},[_vm._v("密码错误，请重输。")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"group-mess"},[_c('router-link',{attrs:{"to":"/repassword","tag":"a"}},[_vm._v("\n            忘记密码\n          ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/quick","tag":"a"}},[_vm._v("\n            无账号手机登录\n          ")])],1)])]),_vm._v(" "),(_vm.thirdParty)?_c('div',{staticClass:"login-other"},[_c('p',{staticClass:"lg-tit"},[_vm._v("第三方登录")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"icon-lg-accout"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"icon-lg-password"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-info"},[_c('a',{staticClass:"font-lgr",attrs:{"href":"javascript:void(0);"}},[_vm._v("登  录")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://oauth.passport.cntv.cn/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=https://act.ishow.cctv.com/h5/mymessage"}},[_c('img',{attrs:{"src":__webpack_require__("sgvI")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://oauth.passport.cntv.cn/OAuthSinaClient/OAuthSinaClientServlet.do?cntv_callback=https://act.ishow.cctv.com/h5/mymessage"}},[_c('img',{attrs:{"src":__webpack_require__("WrP+")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://reg.cctv.com/OauthAlipay/OauthAlipayServlet.action?method=login&cntv_callback=https://act.ishow.cctv.com/h5/mymessage"}},[_c('img',{attrs:{"src":__webpack_require__("IGXn")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6sZU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7D4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content entry-content",attrs:{"id":"entry-content"}},[_c('div',{staticClass:"et-tabox"},[_c('h3',{staticClass:"tabox-h3"},[_vm._v("修改报名信息 ")]),_vm._v(" "),_c('div',{staticClass:"form"},_vm._l((_vm.RegistrationForm),function(item,ind){return _c('div',[(item.field_type == 'text')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"et-typebox et-typeText"},[_c('input',{staticClass:"form-control",attrs:{"is_require":item.is_require,"type":item.field_type,"name":item.name,"placeholder":item.tip},domProps:{"value":item.isChoose},on:{"keyup":function($event){_vm.SmallKeyup($event,item.rule_type)}}}),_vm._v(" "),_c('p',{staticClass:"prompt",staticStyle:{"font-size":"14px","color":"#C8494E","line-height":"25px","display":"none"}},[_vm._v("\n              请输入正确的"+_vm._s(item.title)+"格式！")]),_vm._v(" "),_c('i',{staticClass:"icon-delete",on:{"click":function($event){_vm.SmallDelete(ind)}}})])]):_vm._e(),_vm._v(" "),(item.field_type == 'textarea')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"et-trbox"},[_c('textarea',{staticClass:"form-control",attrs:{"rows":"3","is_require":item.is_require,"name":item.name,"placeholder":item.tip},domProps:{"value":item.isChoose}}),_vm._v(" "),_c('i',{staticClass:"icon-delete"})])]):_vm._e(),_vm._v(" "),(item.field_type == 'radio')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),(JSON.parse(item.option_json))?_c('ul',{staticClass:"et-radiolink"},_vm._l((Math.ceil(JSON.parse(item.option_json).length/2)),function(val,ind){return (item.option_json)?_c('li',_vm._l((2),function(val,i){return (JSON.parse(item.option_json)[ind*2 + i])?_c('div',{staticClass:"et-libox",on:{"click":function($event){_vm.sexOn(ind*2 + i,JSON.parse(item.option_json)[ind*2 + i],item.name)}}},[_c('div',{class:JSON.parse(item.option_json)[ind*2 + i] == item.isChoose?'radio-box radio-on'+' '+item.name:'radio-box'+' '+item.name,attrs:{"is_require":item.is_require,"name":item.name}},[_c('input',{attrs:{"type":item.field_type,"name":item.name}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(JSON.parse(item.option_json)[ind*2 + i]))])]):_vm._e()})):_vm._e()})):_vm._e()]):_vm._e(),_vm._v(" "),(item.field_type == 'checkbox')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('ul',{staticClass:"et-checklink",attrs:{"is_require":item.is_require,"name":item.name}},_vm._l((JSON.parse(item.option_json)),function(val,ind){return (item.option_json)?_c('li',[(item.isChoose)?_c('div',{class:JSON.parse(item.isChoose).indexOf(val) != -1?'check-box check-on':'check-box',attrs:{"attr-name":val}},[_c('input',{attrs:{"type":"checkbox","name":item.name}})]):_c('div',{staticClass:"check-box",attrs:{"attr-name":val}},[_c('input',{attrs:{"type":"checkbox","name":item.name}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(val))])]):_vm._e()}))]):_vm._e(),_vm._v(" "),(item.field_type == 'select')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"et-slebox form-control"},[_c('select',{staticClass:"form-control select",attrs:{"name":item.name,"is_require":item.is_require},domProps:{"value":item.isChoose}},_vm._l((JSON.parse(item.option_json)),function(val,ind){return (item.option_json)?_c('option',{domProps:{"value":val}},[_vm._v(_vm._s(val)+"\n              ")]):_vm._e()})),_vm._v(" "),_c('i',{staticClass:"icon-select"})])]):_vm._e(),_vm._v(" "),(item.field_type == 'date')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"et-typebox et-typeData"},[_c('input',{staticClass:"form-control date-new-show",attrs:{"type":"date","name":item.name,"is_require":item.is_require},domProps:{"value":item.isChoose}})])]):_vm._e(),_vm._v(" "),(item.field_type == 'address')?_c('div',{staticClass:"group content-block"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('Linkage',{attrs:{"text":item.isChoose},on:{"message":_vm.listenToMyBoy}}),_vm._v(" "),_c('input',{staticClass:"demo1",staticStyle:{"display":"none"},attrs:{"title":item.title,"name":item.name,"is_require":item.is_require,"type":"text"}}),_vm._v(" "),_c('div',{staticClass:"group detailed",staticStyle:{"display":"block"}},[_c('label',[_vm._v("详细地址"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_vm._m(0,true)])],1):_vm._e(),_vm._v(" "),(item.field_type == 'selectmul')?_c('div',{staticClass:"group group-selmul content-block",attrs:{"is_require":item.is_require,"name":item.name}},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('Selectmul',{attrs:{"item_data":item},on:{"change":_vm.casChange}})],1):_vm._e(),_vm._v(" "),(item.field_type == 'upload' && _vm.thirdParty)?_c('Upload',{attrs:{"UpFile":item,"type":"1","id":_vm.id,"countArr":_vm.countArr,"appId":_vm.appId,"audit_level":_vm.audit_level}}):_vm._e(),_vm._v(" "),(item.field_type == 'uploadvideo' && _vm.thirdParty)?_c('VideoUpload',{attrs:{"UpFile":item,"type":"1","id":_vm.id,"countArr":_vm.countArr,"appId":_vm.appId,"audit_level":_vm.audit_level}}):_vm._e(),_vm._v(" "),(item.field_type == 'uploadimg' && _vm.thirdParty)?_c('ImageUpload',{attrs:{"UpFile":item,"type":"1","id":_vm.id,"countArr":_vm.countArr,"appId":_vm.appId,"audit_level":_vm.audit_level}}):_vm._e(),_vm._v(" "),(item.field_type == 'uploadfile' && _vm.thirdParty)?_c('FileUpload',{attrs:{"UpFile":item,"type":"1","id":_vm.id,"appId":_vm.appId,"audit_level":_vm.audit_level}}):_vm._e()],1)})),_vm._v(" "),_c('a',{class:['et-complete',_vm.loading||_vm.noEdit ?'bg_grey': ''],staticStyle:{"margin-top":"10px"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.complete}},[_vm._v("\n      "+_vm._s(_vm.doEdit)+"\n    ")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"process-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.4)"},attrs:{"id":"processModal","role":"dialog","data-backdrop":"static","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"0"}},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('a',{staticClass:"btn-pl-giveup",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.CloseUpload}},[_vm._v("取  消")])])])])])]),_vm._v(" "),_c('div',{staticClass:"entry-modal large-info-modal modal fade",attrs:{"id":"entryModal","role":"dialog","data-backdrop":"static","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"50px"}},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('i',{staticClass:"icon-man"}),_vm._v(" "),_c('p',{staticClass:"el-txt"},[_vm._v(_vm._s(_vm.modalTit))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#666","text-align":"center"}},[_vm._v("参与ID："),_c('span',{staticStyle:{"color":"#cf5454"}},[_vm._v(_vm._s(_vm.userId))])]),_vm._v(" "),(_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.form_back&&_vm.detailsTxte.page_config.form_back.is_show!='1')?_c('a',{staticClass:"el-avt",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.myActivitys}},[_c('i',{staticClass:"icon-entry"}),_vm._v("进入我的活动查看进度")]):_vm._e(),_vm._v(" "),(_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.form_back&&_vm.detailsTxte.page_config.form_back.is_show=='1')?_c('a',{staticClass:"btn-el-red btn-el-continue",staticStyle:{"font-size":"16px"},attrs:{"href":_vm.detailsTxte.page_config.form_back.url}},[_vm._v(_vm._s(_vm.detailsTxte.page_config.form_back.title))]):_c('a',{staticClass:"btn-el-red btn-el-continue",staticStyle:{"font-size":"16px"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.myActivity}},[_vm._v("继续参与")]),_vm._v(" "),_c('a',{staticClass:"btn-el-red btn-el-share",staticStyle:{"font-size":"16px"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.share}},[_vm._v("分享")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{attrs:{"id":"nativeShare"}})])])])])]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"shart",on:{"click":_vm.shareHide}},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/weixin.png',"alt":""}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"et-typebox"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"请输入详细地址"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"editModalsAler","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('p',{staticClass:"Prompt-p",attrs:{"id":"fileMessageM"}},[_vm._v("你确定要删除此条信息？ ")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"btn-pl-start",staticStyle:{"width":"50%","display":"inline-block"},attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("确定")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"pl-num"},[_vm._v("已完成："),_c('span',[_vm._v("85")]),_vm._v("%")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-progress"},[_c('div',{staticClass:"pl-gro-bar",staticStyle:{"width":"80%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-ms-box"},[_c('p',[_vm._v("总大小："),_c('span',{staticClass:"SizeBox"},[_vm._v("20")]),_vm._v("M")]),_vm._v(" "),_c('p',[_vm._v("已上传："),_c('span',{staticClass:"SecondBox"},[_vm._v("2")]),_vm._v("M")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"share",staticStyle:{"display":"none","text-align":"center","padding-left":"3px"}},[_c('span',{attrs:{"id":"share_1","data-mode":"prepend","data-image":"","data-sites":"weibo,qq,qzone"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry-modal large-info-modal modal fade",attrs:{"id":"Alert","role":"dialog","data-backdrop":"static","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"Prompt-p"},[_vm._v("请确定信息是否填写完成！")]),_vm._v(" "),_c('button',{staticClass:"buttonZ buttonDiv",attrs:{"data-dismiss":"modal"}},[_vm._v("确  定")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "86ij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "collection",
  props: ["detailsTxte", "twoNumbers", "globalUrl"],
  data: function data() {
    return {
      excellentTitle: [], // 优秀作品title---
      excellent: '', // 优秀作品
      excellentStyle: [], // 是否单双列
      excellentMore: [], // 显示多少条
      excellentMost: [], // 最多显示几条
      excellentName: '', // 优秀作品数量/2
      numbers: [], // 最新上传数量/2
      imgTable: [] // 最新上传
    };
  },

  methods: {
    // 操作按钮事件
    // 作品集锦显示个数
    // 当前 总数  最多显示个数
    more: function more(index, all, max) {
      var that = this;
      $('.detail-highlights').eq(index).find('li').show();
      $('.highlights-More').eq(index).hide();
    }
  },
  created: function created() {
    var that = this;
    var pageConfig = that.detailsTxte.page_config;
    var id = this.$route.params.id;
    // 视频展示
    if (pageConfig) {
      // debugger;
      var latest = pageConfig.upload && pageConfig.upload[0]; //最新上传
      var vied = pageConfig.video;

      if (latest && latest.is_show == 1) {
        latest.isLate = true; ///最新上传模块标记
        vied.push(latest); //
      }
      if (vied.length > 0) {
        dealvds(vied);
      }
    }
    function dealvds(vied) {
      var t = 0;
      var imgArr = [];
      var numArr = [];
      vied = vied.filter(function (item, i) {
        return item.is_show == 1;
      });
      //循环获取分类视频
      for (var i = 0; i < vied.length; i++) {
        //使用闭包保存变量，保证请求数据顺序
        (function (idx) {
          var url,
              curTit = '',
              isLatest = false;
          // 作品集锦
          var pagesize = '';

          // if (vied && vied[i].is_show == 1) {

          // 默认展示多少条
          if (vied[i].count == 'twenty' || vied[i].count == '20') {
            pagesize = 20;
            that.excellentMost.push(20);
          } else {
            pagesize = 10;
            that.excellentMost.push(10);
          }
          // 判断是否单行
          if (vied[i].style == 'one_line') {
            that.excellentStyle.push(1);
          } else {
            that.excellentStyle.push(2);
          }
          /*   console.log(that.excellentStyle) */
          // 默认单排显示三个--展示更多展示剩余数量
          that.excellentMore.push(3);
          that.excellentTitle.push(vied[i].title);
          var indexvideo = {
            type: 1,
            activity_id: id,
            pagesize: pagesize,
            page: 1,
            key: vied[i].id,
            is_recommend: 1,
            version: 2,
            order: vied[i].order
          };

          //判断是否是最新上传模块
          curTit = vied[i].isLate;
          if (curTit) {
            url = API.VideoLatest; //请求latest
            isLatest = true;
          } else {
            url = API.VideoModel; //请求recommend
            isLatest = false;
          }
          that.$http.get(url, { params: indexvideo }).then(function (res) {
            if (res.code == 0) {
              //res.data = res.data.filter(function(item,i){return item.file&&item.file.time_span > 4})
              numArr[idx] = Math.floor(res.data.length / 2);
              that.numbers = [].concat(numArr);
              t += Math.floor(res.data.length / 2);
              imgArr[idx] = res.data;
              if (isLatest) {
                imgArr[idx].latest = true;
              }
              that.imgTable = [].concat(imgArr);
              // that.$forceUpdate();
              that.$nextTick(function () {
                new Swiper('.show-work-swiper1', {
                  pagination: '.swiper-pagination1',
                  autoplay: 4000,
                  loop: true
                });
                // 图片比例
                var picWimg = $('.pic-box').width();
                var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
                var picWimgs = $('.pic-boxs').width();
                var picHimgs = Math.ceil($('.pic-boxs').width() / 16 * 9);
                $('.pic-boxs img').css({ width: picWimgs, height: picHimgs, visibility: 'visible' });
              });

              if (t >= 1) {
                $('.show-Title').show();
              } else {
                $('.show-Title').prev().hide();
                $('.show-Title').hide();
              }
            } else {
              console.log('作品集锦-请求数据信息出错');
              $('.show-Title').hide();
            }
          });
          // }
        })(i);
      }
    }
  },
  mounted: function mounted() {
    // 操作DOM
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "8KO+":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(r){"use strict";function t(t,e,n,o){function i(r,t){return r-=o,t-=o,!(0>r||r>=u||0>t||t>=u)&&a.isDark(r,t)}var a=r(n,e);a.addData(t),a.make(),o=o||0;var u=a.getModuleCount(),f=a.getModuleCount()+2*o,c=function(r,t,e,n){var o=this.isDark,i=1/f;this.isDark=function(a,u){var f=u*i,c=a*i,s=f+i,l=c+i;return o(a,u)&&(r>s||f>e||t>l||c>n)}};this.text=t,this.level=e,this.version=n,this.moduleCount=f,this.isDark=i,this.addBlank=c}function e(r,e,n,o,i){n=Math.max(1,n||1),o=Math.min(40,o||40);for(var a=n;o>=a;a+=1)try{return new t(r,e,a,i)}catch(r){}}function n(r,t,e){var n=e.size,o="bold "+e.mSize*n+"px "+e.fontname,i=p("<canvas/>")[0].getContext("2d");i.font=o;var a=i.measureText(e.label).width,u=e.mSize,f=a/n,c=(1-f)*e.mPosX,s=(1-u)*e.mPosY,l=c+f,h=s+u,d=.01;1===e.mode?r.addBlank(0,s-d,n,h+d):r.addBlank(c-d,s-d,l+d,h+d),t.fillStyle=e.fontcolor,t.font=o,t.fillText(e.label,c*n,s*n+.75*e.mSize*n)}function o(r,t,e){var n=e.size,o=e.image.naturalWidth||1,i=e.image.naturalHeight||1,a=e.mSize,u=a*o/i,f=(1-u)*e.mPosX,c=(1-a)*e.mPosY,s=f+u,l=c+a,h=.01;3===e.mode?r.addBlank(0,c-h,n,l+h):r.addBlank(f-h,c-h,s+h,l+h),t.drawImage(e.image,f*n,c*n,u*n,a*n)}function i(r,t,e){p(e.background).is("img")?t.drawImage(e.background,0,0,e.size,e.size):e.background&&(t.fillStyle=e.background,t.fillRect(e.left,e.top,e.size,e.size));var i=e.mode;1===i||2===i?n(r,t,e):(3===i||4===i)&&o(r,t,e)}function a(r,t,e,n,o,i,a,u){r.isDark(a,u)&&t.rect(n,o,i,i)}function u(r,t,e,n,o,i,a,u,f,c){a?r.moveTo(t+i,e):r.moveTo(t,e),u?(r.lineTo(n-i,e),r.arcTo(n,e,n,o,i)):r.lineTo(n,e),f?(r.lineTo(n,o-i),r.arcTo(n,o,t,o,i)):r.lineTo(n,o),c?(r.lineTo(t+i,o),r.arcTo(t,o,t,e,i)):r.lineTo(t,o),a?(r.lineTo(t,e+i),r.arcTo(t,e,n,e,i)):r.lineTo(t,e)}function f(r,t,e,n,o,i,a,u,f,c){a&&(r.moveTo(t+i,e),r.lineTo(t,e),r.lineTo(t,e+i),r.arcTo(t,e,t+i,e,i)),u&&(r.moveTo(n-i,e),r.lineTo(n,e),r.lineTo(n,e+i),r.arcTo(n,e,n-i,e,i)),f&&(r.moveTo(n-i,o),r.lineTo(n,o),r.lineTo(n,o-i),r.arcTo(n,o,n-i,o,i)),c&&(r.moveTo(t+i,o),r.lineTo(t,o),r.lineTo(t,o-i),r.arcTo(t,o,t+i,o,i))}function c(r,t,e,n,o,i,a,c){var s=r.isDark,l=n+i,h=o+i,d=e.radius*i,g=a-1,v=a+1,p=c-1,w=c+1,m=s(a,c),T=s(g,p),y=s(g,c),E=s(g,w),A=s(a,w),B=s(v,w),k=s(v,c),b=s(v,p),C=s(a,p);m?u(t,n,o,l,h,d,!y&&!C,!y&&!A,!k&&!A,!k&&!C):f(t,n,o,l,h,d,y&&C&&T,y&&A&&E,k&&A&&B,k&&C&&b)}function s(r,t,e){var n,o,i=r.moduleCount,u=e.size/i,f=a;for(m&&e.radius>0&&e.radius<=.5&&(f=c),t.beginPath(),n=0;i>n;n+=1)for(o=0;i>o;o+=1){var s=e.left+o*u,l=e.top+n*u,h=u;f(r,t,e,s,l,h,n,o)}if(p(e.fill).is("img")){t.strokeStyle="rgba(0,0,0,0.5)",t.lineWidth=2,t.stroke();var d=t.globalCompositeOperation;t.globalCompositeOperation="destination-out",t.fill(),t.globalCompositeOperation=d,t.clip(),t.drawImage(e.fill,0,0,e.size,e.size),t.restore()}else t.fillStyle=e.fill,t.fill()}function l(r,t){var n=e(t.text,t.ecLevel,t.minVersion,t.maxVersion,t.quiet);if(!n)return null;var o=p(r).data("qrcode",n),a=o[0].getContext("2d");return i(n,a,t),s(n,a,t),o}function h(r){var t=p("<canvas/>").attr("width",r.size).attr("height",r.size);return l(t,r)}function d(r){return p("<img/>").attr("src",h(r)[0].toDataURL("image/png"))}function g(r){var t=e(r.text,r.ecLevel,r.minVersion,r.maxVersion,r.quiet);if(!t)return null;var n,o,i=r.size,a=r.background,u=Math.floor,f=t.moduleCount,c=u(i/f),s=u(.5*(i-c*f)),l={position:"relative",left:0,top:0,padding:0,margin:0,width:i,height:i},h={position:"absolute",padding:0,margin:0,width:c,height:c,"background-color":r.fill},d=p("<div/>").data("qrcode",t).css(l);for(a&&d.css("background-color",a),n=0;f>n;n+=1)for(o=0;f>o;o+=1)t.isDark(n,o)&&p("<div/>").css(h).css({left:s+o*c,top:s+n*c}).appendTo(d);return d}function v(r){return w&&"canvas"===r.render?h(r):w&&"image"===r.render?d(r):g(r)}var p=jQuery,w=function(){var r=document.createElement("canvas");return Boolean(r.getContext&&r.getContext("2d"))}(),m="[object Opera]"!==Object.prototype.toString.call(window.opera),T={render:"canvas",minVersion:1,maxVersion:40,ecLevel:"L",left:0,top:0,size:200,fill:"#000",background:null,text:"no text",radius:0,quiet:0,mode:0,mSize:.1,mPosX:.5,mPosY:.5,label:"no label",fontname:"sans",fontcolor:"#000",image:null};p.fn.qrcode=function(r){var t=p.extend({},T,r);return this.each(function(){"canvas"===this.nodeName.toLowerCase()?l(this,t):p(this).append(v(t))})}}(function(){var r=function(){function r(t,e){if("undefined"==typeof t.length)throw new Error(t.length+"/"+e);var n=function(){for(var r=0;r<t.length&&0==t[r];)r+=1;for(var n=new Array(t.length-r+e),o=0;o<t.length-r;o+=1)n[o]=t[o+r];return n}(),o={};return o.getAt=function(r){return n[r]},o.getLength=function(){return n.length},o.multiply=function(t){for(var e=new Array(o.getLength()+t.getLength()-1),n=0;n<o.getLength();n+=1)for(var i=0;i<t.getLength();i+=1)e[n+i]^=a.gexp(a.glog(o.getAt(n))+a.glog(t.getAt(i)));return r(e,0)},o.mod=function(t){if(o.getLength()-t.getLength()<0)return o;for(var e=a.glog(o.getAt(0))-a.glog(t.getAt(0)),n=new Array(o.getLength()),i=0;i<o.getLength();i+=1)n[i]=o.getAt(i);for(var i=0;i<t.getLength();i+=1)n[i]^=a.gexp(a.glog(t.getAt(i))+e);return r(n,0).mod(t)},o}var t=function(t,e){var o=236,a=17,s=t,l=n[e],h=null,d=0,v=null,p=new Array,w={},m=function(r,t){d=4*s+17,h=function(r){for(var t=new Array(r),e=0;r>e;e+=1){t[e]=new Array(r);for(var n=0;r>n;n+=1)t[e][n]=null}return t}(d),T(0,0),T(d-7,0),T(0,d-7),A(),E(),k(r,t),s>=7&&B(r),null==v&&(v=M(s,l,p)),b(v,t)},T=function(r,t){for(var e=-1;7>=e;e+=1)if(!(-1>=r+e||r+e>=d))for(var n=-1;7>=n;n+=1)-1>=t+n||t+n>=d||(e>=0&&6>=e&&(0==n||6==n)||n>=0&&6>=n&&(0==e||6==e)||e>=2&&4>=e&&n>=2&&4>=n?h[r+e][t+n]=!0:h[r+e][t+n]=!1)},y=function(){for(var r=0,t=0,e=0;8>e;e+=1){m(!0,e);var n=i.getLostPoint(w);(0==e||r>n)&&(r=n,t=e)}return t},E=function(){for(var r=8;d-8>r;r+=1)null==h[r][6]&&(h[r][6]=r%2==0);for(var t=8;d-8>t;t+=1)null==h[6][t]&&(h[6][t]=t%2==0)},A=function(){for(var r=i.getPatternPosition(s),t=0;t<r.length;t+=1)for(var e=0;e<r.length;e+=1){var n=r[t],o=r[e];if(null==h[n][o])for(var a=-2;2>=a;a+=1)for(var u=-2;2>=u;u+=1)-2==a||2==a||-2==u||2==u||0==a&&0==u?h[n+a][o+u]=!0:h[n+a][o+u]=!1}},B=function(r){for(var t=i.getBCHTypeNumber(s),e=0;18>e;e+=1){var n=!r&&1==(t>>e&1);h[Math.floor(e/3)][e%3+d-8-3]=n}for(var e=0;18>e;e+=1){var n=!r&&1==(t>>e&1);h[e%3+d-8-3][Math.floor(e/3)]=n}},k=function(r,t){for(var e=l<<3|t,n=i.getBCHTypeInfo(e),o=0;15>o;o+=1){var a=!r&&1==(n>>o&1);6>o?h[o][8]=a:8>o?h[o+1][8]=a:h[d-15+o][8]=a}for(var o=0;15>o;o+=1){var a=!r&&1==(n>>o&1);8>o?h[8][d-o-1]=a:9>o?h[8][15-o-1+1]=a:h[8][15-o-1]=a}h[d-8][8]=!r},b=function(r,t){for(var e=-1,n=d-1,o=7,a=0,u=i.getMaskFunction(t),f=d-1;f>0;f-=2)for(6==f&&(f-=1);;){for(var c=0;2>c;c+=1)if(null==h[n][f-c]){var s=!1;a<r.length&&(s=1==(r[a]>>>o&1));var l=u(n,f-c);l&&(s=!s),h[n][f-c]=s,o-=1,-1==o&&(a+=1,o=7)}if(n+=e,0>n||n>=d){n-=e,e=-e;break}}},C=function(t,e){for(var n=0,o=0,a=0,u=new Array(e.length),f=new Array(e.length),c=0;c<e.length;c+=1){var s=e[c].dataCount,l=e[c].totalCount-s;o=Math.max(o,s),a=Math.max(a,l),u[c]=new Array(s);for(var h=0;h<u[c].length;h+=1)u[c][h]=255&t.getBuffer()[h+n];n+=s;var d=i.getErrorCorrectPolynomial(l),g=r(u[c],d.getLength()-1),v=g.mod(d);f[c]=new Array(d.getLength()-1);for(var h=0;h<f[c].length;h+=1){var p=h+v.getLength()-f[c].length;f[c][h]=p>=0?v.getAt(p):0}}for(var w=0,h=0;h<e.length;h+=1)w+=e[h].totalCount;for(var m=new Array(w),T=0,h=0;o>h;h+=1)for(var c=0;c<e.length;c+=1)h<u[c].length&&(m[T]=u[c][h],T+=1);for(var h=0;a>h;h+=1)for(var c=0;c<e.length;c+=1)h<f[c].length&&(m[T]=f[c][h],T+=1);return m},M=function(r,t,e){for(var n=u.getRSBlocks(r,t),c=f(),s=0;s<e.length;s+=1){var l=e[s];c.put(l.getMode(),4),c.put(l.getLength(),i.getLengthInBits(l.getMode(),r)),l.write(c)}for(var h=0,s=0;s<n.length;s+=1)h+=n[s].dataCount;if(c.getLengthInBits()>8*h)throw new Error("code length overflow. ("+c.getLengthInBits()+">"+8*h+")");for(c.getLengthInBits()+4<=8*h&&c.put(0,4);c.getLengthInBits()%8!=0;)c.putBit(!1);for(;!(c.getLengthInBits()>=8*h)&&(c.put(o,8),!(c.getLengthInBits()>=8*h));)c.put(a,8);return C(c,n)};return w.addData=function(r){var t=c(r);p.push(t),v=null},w.isDark=function(r,t){if(0>r||r>=d||0>t||t>=d)throw new Error(r+","+t);return h[r][t]},w.getModuleCount=function(){return d},w.make=function(){m(!1,y())},w.createTableTag=function(r,t){r=r||2,t="undefined"==typeof t?4*r:t;var e="";e+='<table style="',e+=" border-width: 0px; border-style: none;",e+=" border-collapse: collapse;",e+=" padding: 0px; margin: "+t+"px;",e+='">',e+="<tbody>";for(var n=0;n<w.getModuleCount();n+=1){e+="<tr>";for(var o=0;o<w.getModuleCount();o+=1)e+='<td style="',e+=" border-width: 0px; border-style: none;",e+=" border-collapse: collapse;",e+=" padding: 0px; margin: 0px;",e+=" width: "+r+"px;",e+=" height: "+r+"px;",e+=" background-color: ",e+=w.isDark(n,o)?"#000000":"#ffffff",e+=";",e+='"/>';e+="</tr>"}return e+="</tbody>",e+="</table>"},w.createImgTag=function(r,t){r=r||2,t="undefined"==typeof t?4*r:t;var e=w.getModuleCount()*r+2*t,n=t,o=e-t;return g(e,e,function(t,e){if(t>=n&&o>t&&e>=n&&o>e){var i=Math.floor((t-n)/r),a=Math.floor((e-n)/r);return w.isDark(a,i)?0:1}return 1})},w};t.stringToBytes=function(r){for(var t=new Array,e=0;e<r.length;e+=1){var n=r.charCodeAt(e);t.push(255&n)}return t},t.createStringToBytes=function(r,t){var e=function(){for(var e=h(r),n=function(){var r=e.read();if(-1==r)throw new Error;return r},o=0,i={};;){var a=e.read();if(-1==a)break;var u=n(),f=n(),c=n(),s=String.fromCharCode(a<<8|u),l=f<<8|c;i[s]=l,o+=1}if(o!=t)throw new Error(o+" != "+t);return i}(),n="?".charCodeAt(0);return function(r){for(var t=new Array,o=0;o<r.length;o+=1){var i=r.charCodeAt(o);if(128>i)t.push(i);else{var a=e[r.charAt(o)];"number"==typeof a?(255&a)==a?t.push(a):(t.push(a>>>8),t.push(255&a)):t.push(n)}}return t}};var e={MODE_NUMBER:1,MODE_ALPHA_NUM:2,MODE_8BIT_BYTE:4,MODE_KANJI:8},n={L:1,M:0,Q:3,H:2},o={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7},i=function(){var t=[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],n=1335,i=7973,u=21522,f={},c=function(r){for(var t=0;0!=r;)t+=1,r>>>=1;return t};return f.getBCHTypeInfo=function(r){for(var t=r<<10;c(t)-c(n)>=0;)t^=n<<c(t)-c(n);return(r<<10|t)^u},f.getBCHTypeNumber=function(r){for(var t=r<<12;c(t)-c(i)>=0;)t^=i<<c(t)-c(i);return r<<12|t},f.getPatternPosition=function(r){return t[r-1]},f.getMaskFunction=function(r){switch(r){case o.PATTERN000:return function(r,t){return(r+t)%2==0};case o.PATTERN001:return function(r,t){return r%2==0};case o.PATTERN010:return function(r,t){return t%3==0};case o.PATTERN011:return function(r,t){return(r+t)%3==0};case o.PATTERN100:return function(r,t){return(Math.floor(r/2)+Math.floor(t/3))%2==0};case o.PATTERN101:return function(r,t){return r*t%2+r*t%3==0};case o.PATTERN110:return function(r,t){return(r*t%2+r*t%3)%2==0};case o.PATTERN111:return function(r,t){return(r*t%3+(r+t)%2)%2==0};default:throw new Error("bad maskPattern:"+r)}},f.getErrorCorrectPolynomial=function(t){for(var e=r([1],0),n=0;t>n;n+=1)e=e.multiply(r([1,a.gexp(n)],0));return e},f.getLengthInBits=function(r,t){if(t>=1&&10>t)switch(r){case e.MODE_NUMBER:return 10;case e.MODE_ALPHA_NUM:return 9;case e.MODE_8BIT_BYTE:return 8;case e.MODE_KANJI:return 8;default:throw new Error("mode:"+r)}else if(27>t)switch(r){case e.MODE_NUMBER:return 12;case e.MODE_ALPHA_NUM:return 11;case e.MODE_8BIT_BYTE:return 16;case e.MODE_KANJI:return 10;default:throw new Error("mode:"+r)}else{if(!(41>t))throw new Error("type:"+t);switch(r){case e.MODE_NUMBER:return 14;case e.MODE_ALPHA_NUM:return 13;case e.MODE_8BIT_BYTE:return 16;case e.MODE_KANJI:return 12;default:throw new Error("mode:"+r)}}},f.getLostPoint=function(r){for(var t=r.getModuleCount(),e=0,n=0;t>n;n+=1)for(var o=0;t>o;o+=1){for(var i=0,a=r.isDark(n,o),u=-1;1>=u;u+=1)if(!(0>n+u||n+u>=t))for(var f=-1;1>=f;f+=1)0>o+f||o+f>=t||(0!=u||0!=f)&&a==r.isDark(n+u,o+f)&&(i+=1);i>5&&(e+=3+i-5)}for(var n=0;t-1>n;n+=1)for(var o=0;t-1>o;o+=1){var c=0;r.isDark(n,o)&&(c+=1),r.isDark(n+1,o)&&(c+=1),r.isDark(n,o+1)&&(c+=1),r.isDark(n+1,o+1)&&(c+=1),(0==c||4==c)&&(e+=3)}for(var n=0;t>n;n+=1)for(var o=0;t-6>o;o+=1)r.isDark(n,o)&&!r.isDark(n,o+1)&&r.isDark(n,o+2)&&r.isDark(n,o+3)&&r.isDark(n,o+4)&&!r.isDark(n,o+5)&&r.isDark(n,o+6)&&(e+=40);for(var o=0;t>o;o+=1)for(var n=0;t-6>n;n+=1)r.isDark(n,o)&&!r.isDark(n+1,o)&&r.isDark(n+2,o)&&r.isDark(n+3,o)&&r.isDark(n+4,o)&&!r.isDark(n+5,o)&&r.isDark(n+6,o)&&(e+=40);for(var s=0,o=0;t>o;o+=1)for(var n=0;t>n;n+=1)r.isDark(n,o)&&(s+=1);var l=Math.abs(100*s/t/t-50)/5;return e+=10*l},f}(),a=function(){for(var r=new Array(256),t=new Array(256),e=0;8>e;e+=1)r[e]=1<<e;for(var e=8;256>e;e+=1)r[e]=r[e-4]^r[e-5]^r[e-6]^r[e-8];for(var e=0;255>e;e+=1)t[r[e]]=e;var n={};return n.glog=function(r){if(1>r)throw new Error("glog("+r+")");return t[r]},n.gexp=function(t){for(;0>t;)t+=255;for(;t>=256;)t-=255;return r[t]},n}(),u=function(){var r=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12,7,37,13],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]],t=function(r,t){var e={};return e.totalCount=r,e.dataCount=t,e},e={},o=function(t,e){switch(e){case n.L:return r[4*(t-1)+0];case n.M:return r[4*(t-1)+1];case n.Q:return r[4*(t-1)+2];case n.H:return r[4*(t-1)+3];default:return}};return e.getRSBlocks=function(r,e){var n=o(r,e);if("undefined"==typeof n)throw new Error("bad rs block @ typeNumber:"+r+"/errorCorrectLevel:"+e);for(var i=n.length/3,a=new Array,u=0;i>u;u+=1)for(var f=n[3*u+0],c=n[3*u+1],s=n[3*u+2],l=0;f>l;l+=1)a.push(t(c,s));return a},e}(),f=function(){var r=new Array,t=0,e={};return e.getBuffer=function(){return r},e.getAt=function(t){var e=Math.floor(t/8);return 1==(r[e]>>>7-t%8&1)},e.put=function(r,t){for(var n=0;t>n;n+=1)e.putBit(1==(r>>>t-n-1&1))},e.getLengthInBits=function(){return t},e.putBit=function(e){var n=Math.floor(t/8);r.length<=n&&r.push(0),e&&(r[n]|=128>>>t%8),t+=1},e},c=function(r){var n=e.MODE_8BIT_BYTE,o=t.stringToBytes(r),i={};return i.getMode=function(){return n},i.getLength=function(r){return o.length},i.write=function(r){for(var t=0;t<o.length;t+=1)r.put(o[t],8)},i},s=function(){var r=new Array,t={};return t.writeByte=function(t){r.push(255&t)},t.writeShort=function(r){t.writeByte(r),t.writeByte(r>>>8)},t.writeBytes=function(r,e,n){e=e||0,n=n||r.length;for(var o=0;n>o;o+=1)t.writeByte(r[o+e])},t.writeString=function(r){for(var e=0;e<r.length;e+=1)t.writeByte(r.charCodeAt(e))},t.toByteArray=function(){return r},t.toString=function(){var t="";t+="[";for(var e=0;e<r.length;e+=1)e>0&&(t+=","),t+=r[e];return t+="]"},t},l=function(){var r=0,t=0,e=0,n="",o={},i=function(r){n+=String.fromCharCode(a(63&r))},a=function(r){if(0>r);else{if(26>r)return 65+r;if(52>r)return 97+(r-26);if(62>r)return 48+(r-52);if(62==r)return 43;if(63==r)return 47}throw new Error("n:"+r)};return o.writeByte=function(n){for(r=r<<8|255&n,t+=8,e+=1;t>=6;)i(r>>>t-6),t-=6},o.flush=function(){if(t>0&&(i(r<<6-t),r=0,t=0),e%3!=0)for(var o=3-e%3,a=0;o>a;a+=1)n+="="},o.toString=function(){return n},o},h=function(r){var t=r,e=0,n=0,o=0,i={};i.read=function(){for(;8>o;){if(e>=t.length){if(0==o)return-1;throw new Error("unexpected end of file./"+o)}var r=t.charAt(e);if(e+=1,"="==r)return o=0,-1;r.match(/^\s$/)||(n=n<<6|a(r.charCodeAt(0)),o+=6)}var i=n>>>o-8&255;return o-=8,i};var a=function(r){if(r>=65&&90>=r)return r-65;if(r>=97&&122>=r)return r-97+26;if(r>=48&&57>=r)return r-48+52;if(43==r)return 62;if(47==r)return 63;throw new Error("c:"+r)};return i},d=function(r,t){var e=r,n=t,o=new Array(r*t),i={};i.setPixel=function(r,t,n){o[t*e+r]=n},i.write=function(r){r.writeString("GIF87a"),r.writeShort(e),r.writeShort(n),r.writeByte(128),r.writeByte(0),r.writeByte(0),r.writeByte(0),r.writeByte(0),r.writeByte(0),r.writeByte(255),r.writeByte(255),r.writeByte(255),r.writeString(","),r.writeShort(0),r.writeShort(0),r.writeShort(e),r.writeShort(n),r.writeByte(0);var t=2,o=u(t);r.writeByte(t);for(var i=0;o.length-i>255;)r.writeByte(255),r.writeBytes(o,i,255),i+=255;r.writeByte(o.length-i),r.writeBytes(o,i,o.length-i),r.writeByte(0),r.writeString(";")};var a=function(r){var t=r,e=0,n=0,o={};return o.write=function(r,o){if(r>>>o!=0)throw new Error("length over");for(;e+o>=8;)t.writeByte(255&(r<<e|n)),o-=8-e,r>>>=8-e,n=0,e=0;n|=r<<e,e+=o},o.flush=function(){e>0&&t.writeByte(n)},o},u=function(r){for(var t=1<<r,e=(1<<r)+1,n=r+1,i=f(),u=0;t>u;u+=1)i.add(String.fromCharCode(u));i.add(String.fromCharCode(t)),i.add(String.fromCharCode(e));var c=s(),l=a(c);l.write(t,n);var h=0,d=String.fromCharCode(o[h]);for(h+=1;h<o.length;){var g=String.fromCharCode(o[h]);h+=1,i.contains(d+g)?d+=g:(l.write(i.indexOf(d),n),i.size()<4095&&(i.size()==1<<n&&(n+=1),i.add(d+g)),d=g)}return l.write(i.indexOf(d),n),l.write(e,n),l.flush(),c.toByteArray()},f=function(){var r={},t=0,e={};return e.add=function(n){if(e.contains(n))throw new Error("dup key:"+n);r[n]=t,t+=1},e.size=function(){return t},e.indexOf=function(t){return r[t]},e.contains=function(t){return"undefined"!=typeof r[t]},e};return i},g=function(r,t,e,n){for(var o=d(r,t),i=0;t>i;i+=1)for(var a=0;r>a;a+=1)o.setPixel(a,i,e(a,i));var u=s();o.write(u);for(var f=l(),c=u.toByteArray(),h=0;h<c.length;h+=1)f.writeByte(c[h]);f.flush();var g="";return g+="<img",g+=' src="',g+="data:image/gif;base64,",g+=f,g+='"',g+=' width="',g+=r,g+='"',g+=' height="',g+=t,g+='"',n&&(g+=' alt="',g+=n,g+='"'),g+="/>"};return t}();return function(r){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (r),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports&&(module.exports=r())}(function(){return r}),!function(r){r.stringToBytes=function(r){function t(r){for(var t=[],e=0;e<r.length;e++){var n=r.charCodeAt(e);128>n?t.push(n):2048>n?t.push(192|n>>6,128|63&n):55296>n||n>=57344?t.push(224|n>>12,128|n>>6&63,128|63&n):(e++,n=65536+((1023&n)<<10|1023&r.charCodeAt(e)),t.push(240|n>>18,128|n>>12&63,128|n>>6&63,128|63&n))}return t}return t(r)}}(r),r}()),function(r){r.fn.share=function(t){function e(t,e){var n=o(e);"prepend"==e.mode?n.reverse():n,n.length&&r.each(n,function(n,o){var a=i(o,e),u=e.initialized?t.find(".icon-"+o):r('<a class="social-share-icon icon-'+o+'"></a>');return!u.length||(u.prop("aria-label","分享到 "+h[o]),u.prop("href",a),"wechat"===o?u.prop("tabindex",-1):u.prop("target","_blank"),void(e.initialized||("prepend"==e.mode?t.prepend(u):t.append(u))))})}function n(r,t){var e=r.find("a.icon-wechat");e.length&&(e.append('<div class="wechat-qrcode"><h4>'+t.wechatQrcodeTitle+'</h4><div class="qrcode"></div><div class="help">'+t.wechatQrcodeHelper+"</div></div>"),e.find(".qrcode").qrcode({render:"image",size:t.wechatQrcodeSize,text:t.url}),e.offset().top<100&&e.find(".wechat-qrcode").addClass("bottom"))}function o(t){0===t.mobileSites.length&&t.sites.length&&(t.mobileSites=t.sites);var e=(u()?t.mobileSites:t.sites.length?t.sites:[]).slice(0),n=t.disabled;return"string"==typeof e&&(e=e.split(/\s*,\s*/)),"string"==typeof n&&(n=n.split(/\s*,\s*/)),a()&&n.push("wechat"),n.length&&r.each(n,function(t,n){var o=r.inArray(n,e);o!==-1&&e.splice(o,1)}),e}function i(r,t){var e=l[r];t.summary=t.description;for(var n in t)if(t.hasOwnProperty(n)){var o=r+n.replace(/^[a-z]/,function(r){return r.toUpperCase()}),i=encodeURIComponent(void 0===t[o]?t[n]:t[o]);e=e.replace(new RegExp("{{"+n.toUpperCase()+"}}","g"),i)}return e}function a(){return/MicroMessenger/i.test(navigator.userAgent)}function u(){return r(window).width()<=768}var f=r(document.head),c={url:location.href,site_url:location.origin,source:f.find("[name=site], [name=Site]").attr("content")||document.title,title:f.find("[name=title], [name=Title]").attr("content")||document.title,description:f.find("[name=description], [name=Description]").attr("content")||"",image:r("img:first").prop("src")||"",imageSelector:void 0,weiboKey:"",wechatQrcodeTitle:"微信扫一扫：分享",wechatQrcodeHelper:"<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",wechatQrcodeSize:100,mobileSites:[],sites:["weibo","qq","wechat","tencent","douban","qzone","linkedin","diandian","facebook","twitter","google"],disabled:[],initialized:!1},s=r.extend({},c,t),l={qzone:"http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={{URL}}&title={{TITLE}}&desc={{DESCRIPTION}}&summary={{SUMMARY}}&site={{SOURCE}}",qq:"http://connect.qq.com/widget/shareqq/index.html?url={{URL}}&title={{TITLE}}&source={{SOURCE}}&desc={{DESCRIPTION}}&pics={{IMAGE}}",tencent:"http://share.v.t.qq.com/index.php?c=share&a=index&title={{TITLE}}&url={{URL}}&pic={{IMAGE}}",weibo:"http://service.weibo.com/share/share.php?url={{URL}}&title={{TITLE}}&pic={{IMAGE}}&appkey={{WEIBOKEY}}",wechat:"javascript:;",douban:"http://shuo.douban.com/!service/share?href={{URL}}&name={{TITLE}}&text={{DESCRIPTION}}&image={{IMAGE}}&starid=0&aid=0&style=11",diandian:"http://www.diandian.com/share?lo={{URL}}&ti={{TITLE}}&type=link",linkedin:"http://www.linkedin.com/shareArticle?mini=true&ro=true&title={{TITLE}}&url={{URL}}&summary={{SUMMARY}}&source={{SOURCE}}&armin=armin",facebook:"https://www.facebook.com/sharer/sharer.php?u={{URL}}&title={{TITLE}}&description={{DESCRIPTION}}&caption={{SUBHEAD}}&link={{URL}}&picture={{IMAGE}}",twitter:"https://twitter.com/intent/tweet?text={{TITLE}}&url={{URL}}&via={{SITE_URL}}",google:"https://plus.google.com/share?url={{URL}}"},h={qzone:"QQ空间",qq:"QQ",tencent:"腾讯微博",weibo:"微博",wechat:"微信",douban:"豆瓣",diandian:"点点",linkedin:"LinkedIn",facebook:"Facebook",twitter:"Twitter",google:"Google"};this.each(function(){if(r(this).data("initialized"))return!0;var t=r.extend({},s,r(this).data());t.imageSelector&&(t.image=r(t.imageSelector).map(function(){return r(this).prop("src")}).get().join("||"));var o=r(this).addClass("share-component social-share");e(o,t),n(o,t),r(this).data("initialized",!0)})},r(function(){r(".share-component,.social-share").share()})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "8N4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8T4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Txb":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {// /**
//  * Created by Administrator on 2018/6/5.
//  */
//
(function ($) {
  $.fn.extend({
    "uploadManager":null,
     "preFileType":0,
    "initUploaderManager": function (fileType,getTokenComplete,startCallback,Progress,completeCallback) {
       if(this.preFileType != fileType){
           this.uploadManager = null;
           this.preFileType = fileType;
       }
       this.uploadManager = new VODUpload({
          // 文件上传失败
          'onUploadFailed': function (uploadInfo, code, message) {
            completeCallback(false,code,message);
            console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message);
          },
          // 文件上传完成
          'onUploadSucceed': function (uploadInfo) {
            completeCallback(true,0,uploadInfo);
            console.log("complete:",uploadInfo);
            console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
          },
          // 文件上传进度
          'onUploadProgress': function (uploadInfo, totalSize, uploadedSize) {
            var res = {
               size : totalSize,
               loaded : uploadedSize,
               percent:Math.ceil(uploadedSize * 100 / totalSize)
            }
            Progress && Progress(res)
            console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(uploadedSize * 100 / totalSize) + "%");
          },
          // STS临时账号会过期，过期时触发函数
          'onUploadTokenExpired': function () {
            var that = this
            console.log("onUploadTokenExpired");
            var httpServer = API.GetAliToken;
            this.ajax({
              url: httpServer,
              success: function (data) {
                if (data.code == 0) {
                  const stsToken = data;
                  that.uploadManager.resumeUploadWithToken(stsToken.data.AccessKeyId, stsToken.data.AccessKeySecret, stsToken.data.SecurityToken, stsToken.data.Expiration);
                }
              },
            });
          },
          // 开始上传
          'onUploadstarted': function (uploadInfo) {
            startCallback()
            console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
          }
        });
        const that = this
      var httpServer = API.GetAliToken;
        // var httpServer =  "http://t.api.ishow.cctv.com/Uploadali/getStsToken";
        this.ajax({
          url: httpServer,
          data:{file_type : fileType},
          success: function (data) {
            if (data.code == 0) {
              const stsToken = data;
              console.log(data);
              that.uploadManager.init(stsToken.data.AccessKeyId, stsToken.data.AccessKeySecret, stsToken.data.SecurityToken, stsToken.data.Expiration);
               getTokenComplete( data )
            }else {
               getTokenComplete(null)
            }
          },
        });
    },
    "uploadHandle":function ( content , startUpload, Progress , complete) {
      var that = this
      var key = content.file.name;   //文件总名
      var name = key.split('.');
      var ext = name[name.length-1].toLowerCase();
      var cookieArrays = document.cookie.split(";")
      var verifyCode =  "";
      for (var cookieIndex  in  cookieArrays){
           var cookieString = cookieArrays[cookieIndex]
          if(cookieString.indexOf("verifycode") !== -1) {
              verifyCode = cookieString.split("=")[1];
              break;
          }
      }
      var userData = {
        "Vod": {
          "UserData": {
            "title": content.Biography.title,
            "description": content.Biography.description,
            "activity_id": content.Biography.activity_id,
            "source": content.Biography.source,
            "audit_level": content.Biography.audit_level,
            "app_id": content.Biography.app_id,
            "file_type": content.file_type,
            "verifycode":verifyCode
          }
        }
      }
      this.initUploaderManager( content.file_type,function (res) {

          if(res != null){
            const info = res.data;
            userData.Vod.UserData.file_type = info.file_type;
            userData.Vod.UserData.file_id = info.file_id;
            userData.Vod.UserData.user_id = info.user_id;
            userData.Vod.UserData.user_name = info.user_name;

            const endPoint = "https://" + info.endpoint;
            const bucket = "hudong-ishow";
            const object = info.pre_dir + info.file_id + "." + ext;
            console.log("userData：",userData,endPoint,bucket,object)
            that.uploadManager.addFile(content.file,endPoint,bucket,object,JSON.stringify(userData));
            that.uploadManager.startUpload();
          }else{
              complete(false,-99,"获取token失败，请重新上传")
          }
      },function () {
          startUpload()
      },Progress,complete)
     },
    "cancleUploadFile":function () {
       this.uploadManager.cancelFile(0);
    },
    "deleteUploadFile":function () {
       this.uploadManager.deleteFile(0);
    },
    "stopUploadFile":function () {
      this.uploadManager.stopUpload();
    },
    "ajax": function (opts) {
      var browser = navigator.appName
      var b_version = navigator.appVersion
      var version = b_version.split(";");
      if (version[1] != undefined) {
        var trim_Version = version[1].replace(/[ ]/g, "");
      }
      if (opts.type && browser == "Microsoft Internet Explorer" && (trim_Version == "MSIE8.0" || trim_Version == "MSIE9.0")) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", opts.url, true);
        xhr.withCredentials = true; //支持跨域发送cookies
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        var sendName = "";

        if (opts.data != undefined) {
          if (typeof opts.data == "object") {
            for (var o in opts.data) {
              sendName += o + "=" + opts.data[o] + "&"
            }
          } else {
            sendName = opts.data
          }
        }
        xhr.send(sendName);
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) {
            var txt = xhr.responseText;
            console.log(txt)
            opts.success && opts.success(JSON.parse(txt));
          }
        }
      } else {
        // jQuery.support.cors = true
        var dataType = opts.dataType || 'json'
        if (browser == "Microsoft Internet Explorer" && (trim_Version == "MSIE8.0" || trim_Version == "MSIE9.0")) {
          dataType = 'jsonp'
        }
        $.ajax({
          url: opts.url,
          type: opts.type || 'get',
          dataType: dataType,
          jsonp: opts.jsonp || 'jsoncallback',
          data: opts.data,
          xhrFields: {
            withCredentials: true // 这里设置了withCredentials
          },
          beforeSend: function (XHR) {
            opts.beforeSend && opts.beforeSend(XHR);
          },
          success: function (data) {
            opts.success && opts.success(data);
          },
          complete: function (event, xhr, options) {
            opts.complete && opts.complete(event);
          },
          error: function (xhr, errormsg, event) {
            opts.error && opts.error(xhr, errormsg, event);
          }
        })
      }
    }
  })
})(jQuery)
// (function ($) {
//   $.fn.extend({
//))"uploadHandle": function (content) {
//       var data = null;
//       var key = content.file.name;        //文件总名
//       var name = key.split('.');  // 截取
//       var ext = name[name.length - 1].toLowerCase();
//
//       var params = key.split('.')[0]; //文件名
//       var domain = 'upload-cc';  //域名
//       var appServer = 'http://t.api.ishow.cctv.com/Uploadali/getStsToken?file_type=' + content.file_type;
//       var bucket = 'hudong-ishow';
//       var region = 'oss-cn-beijing';
//
//
//       var userData = {
//         "Vod": {
//           "UserData": {
//             "title": content.Biography.title,
//             "description": content.Biography.description,
//             "activity_id": content.Biography.activity_id,
//             "source": content.Biography.source,
//             "audit_level": content.Biography.audit_level,
//             "app_id": content.Biography.app_id,
//             "file_type": content.file_type,
//           }
//         }
//       }
//
//       this.applyTokenDo(appServer, function (creds) {
//
//         userData.Vod.UserData.file_id = creds.file_id;
//         var OSS = require('ali-oss');
//         var client = OSS({
//           region: region,
//           accessKeyId: creds.AccessKeyId,
//           accessKeySecret: creds.AccessKeySecret,
//           stsToken: creds.SecurityToken,
//           bucket: bucket
//         });
//         console.log(client);
//         var headers = {'x-oss-notification': new Buffer(JSON.stringify(userData)).toString('base64')}
//         console.log(headers);
//         client.multipartUpload(creds.pre_dir + creds.file_id, content.file, {
//           partSize: 1048576,
//           progress: function (p) {
//             return function (done) {
//               console.log("progress:", p, Math.floor(p * 100))
//               done();
//             }
//           },
//           headers: headers
//         }).then(function (res) {
//           console.log('upload success: %j', res);
//           // callback || callback(res)
//         });
//       })
//       //
//       // if (!content.uuid) {
//       //     data = {
//       //         code: 1,
//       //         msg: '网络错误（请求上传token失败），请关闭弹窗刷新页面'
//       //     };
//       //     callback && callback(data);
//       //     return false;
//       // } else if (!content.token) {
//       //     data = {
//       //         code: 1,
//       //         msg: '网络错误（请求上传token失败），请关闭弹窗刷新页面'
//       //     };
//       //     callback && callback(data);
//       //     return false
//       // } else {
//       //
//       //     call && call(data)
//       // }
//
//     },
//     "applyTokenDo": function (appServer, getTokenCompelete) {
//       this.ajax({
//         url: appServer,
//         success: function (data) {
//           if (data.code == 0) {
//             console.log(data);
//             const creds = data.data;
//             console.log(creds);
//             getTokenCompelete(creds)
//           }
//         },
//         error: function (xhr, errormsg, event) {
//
//         }
//       });
//     },
//     "ajax": function (opts) {
//       var browser = navigator.appName
//       var b_version = navigator.appVersion
//       var version = b_version.split(";");
//       if (version[1] != undefined) {
//         var trim_Version = version[1].replace(/[ ]/g, "");
//       }
//       if (opts.type && browser == "Microsoft Internet Explorer" && (trim_Version == "MSIE8.0" || trim_Version == "MSIE9.0")) {
//         var xhr = new XMLHttpRequest();
//         xhr.open("POST", opts.url, true);
//         xhr.withCredentials = true; //支持跨域发送cookies
//         xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
//         var sendName = "";
//
//         if (opts.data != undefined) {
//           if (typeof opts.data == "object") {
//             for (var o in opts.data) {
//               sendName += o + "=" + opts.data[o] + "&"
//             }
//           } else {
//             sendName = opts.data
//           }
//         }
//         xhr.send(sendName);
//         xhr.onreadystatechange = function () {
//           if (xhr.readyState == 4) {
//             var txt = xhr.responseText;
//             console.log(txt)
//             opts.success && opts.success(JSON.parse(txt));
//           }
//         }
//       } else {
//         // jQuery.support.cors = true
//         var dataType = opts.dataType || 'json'
//         if (browser == "Microsoft Internet Explorer" && (trim_Version == "MSIE8.0" || trim_Version == "MSIE9.0")) {
//           dataType = 'jsonp'
//         }
//         $.ajax({
//           url: opts.url,
//           type: opts.type || 'get',
//           dataType: dataType,
//           jsonp: opts.jsonp || 'jsoncallback',
//           data: opts.data,
//           xhrFields: {
//             withCredentials: true // 这里设置了withCredentials
//           },
//           beforeSend: function (XHR) {
//             opts.beforeSend && opts.beforeSend(XHR);
//           },
//           success: function (data) {
//             opts.success && opts.success(data);
//           },
//           complete: function (event, xhr, options) {
//             opts.complete && opts.complete(event);
//           },
//           error: function (xhr, errormsg, event) {
//             opts.error && opts.error(xhr, errormsg, event);
//           }
//         })
//       }
//     }
//   })
// })(jQuery)

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "8egW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9f9p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9jx/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A1Lt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('div',{staticClass:"et-tabhead"},[_c('span',{staticClass:"et-back",on:{"click":_vm.detail}},[_c('i',{staticClass:"icon-back"}),_vm._v("\n          返回\n        ")]),_vm._v(" "),_c('div',{staticClass:"et-tabtn"},[_c('div',{staticClass:"et-tabtn",attrs:{"id":"but-tabtn"}},[_c('span',{staticClass:"btn-et-form et-form-on",on:{"click":function($event){_vm.form(1)}}},[_c('i',{staticClass:"icon-form"}),_vm._v("投票\n                ")]),_vm._v(" "),_c('span',{staticClass:"btn-et-form",on:{"click":function($event){_vm.form(2)}}},[_c('i',{staticClass:"icon-vote"}),_vm._v("排名\n            ")])])])]),_vm._v(" "),(_vm.itemName)?_c('div',{staticClass:"preview-conten preview-contenNext",staticStyle:{"margin-top":"16px"}},[_c('div',{staticClass:"preview-user"},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/Head-portrait.jpg',"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.itemName.nickname))])]),_vm._v(" "),(_vm.typeName != 2)?_c('div',{staticClass:"video_left",attrs:{"id":"myFlash"}}):_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"myImg"}},[_c('img',{staticStyle:{"width":"100%","height":"auto","min-height":"50px"},attrs:{"id":"asImg","src":_vm.asImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"preview-text"},[_c('h4',[_vm._v(_vm._s(_vm.itemName.title))]),_vm._v(" "),_c('p',{staticClass:"preview-p"},[_c('span',{staticClass:"preview-span"},[_vm._v(_vm._s(_vm.itemName.description))])])]),_vm._v(" "),_c('p',{staticClass:"show-v-more",on:{"click":_vm.showVmore}},[_c('i',{staticClass:"icon-vs-show"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"show-box"},[(_vm.itemName)?_c('div',{staticClass:"show-list"},[_c('div',{staticClass:"show-btn-poll",staticStyle:{"padding":"10px","font-size":"20px"},attrs:{"activity_id":_vm.activity_id,"data-id":_vm.uuid}},[_vm._m(0),_vm._v("投票\n        ")]),_vm._v(" "),_c('p',{staticClass:"show-poll"},[_c('span',[_vm._v(_vm._s(_vm.vote_count))]),_vm._v("票  ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"yaVideo",staticStyle:{"display":"none","text-align":"center","padding":"50px 0"}},[_vm._v("呀！作品找不到了！")]),_vm._v(" "),_c('VoteAlert')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-poll"},[_c('em',[_vm._v("+1")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AHUE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_voteAlert_vue__ = __webpack_require__("3NbP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      itemName: null,
      detailsTxte: '',
      showVmoreName: false,
      asImg: "",
      globalUrl: API.GlobalUrl,
      typeName: 2,
      data: '',
      vote_count: '0',
      activity_id: '',
      uuid: ''
    };
  },

  components: {
    VoteAlert: __WEBPACK_IMPORTED_MODULE_0__template_voteAlert_vue__["a" /* default */]
  },
  methods: {
    //操作按钮事件
    //详情更多
    showVmore: function showVmore() {
      this.showVmoreName = !this.showVmoreName;
      if (this.showVmoreName) {
        $('.preview-p').css({ 'max-height': 'none' });
        $('.show-v-more').css({ 'transform': 'rotate(180deg)' });
      } else {
        $('.preview-p').css({ 'max-height': '60px' });
        $('.show-v-more').css({ 'transform': 'rotate(0deg)' });
      }
    },
    detail: function detail() {
      var img = $('.dl-banner').children('img').attr('src');
      // this.$router.push({name: 'list_vote', params: {id:  this.id,active: 1}})
      this.$router.go(-1);
    },
    form: function form(val) {
      var img = $('.dl-banner').children('img').attr('src');
      this.$router.push({ name: 'list_vote', params: { id: this.id, active: val } });
    }
  },
  created: function created() {
    this.id = this.$route.params.id;
    this.typeName = this.$route.params.ind;
    this.activity_id = this.$route.params.activityId;
    var type = this.$route.params.ind;
    var uuid = this.$route.params.uuid;
    this.uuid = this.$route.params.uuid;
    var that = this;

    var getVideoInfo = '',
        APIName = '';
    if (type == 2) {
      //图片
      APIName = API.GetImageInfo;
    } else {
      //视频
      APIName = API.GetVideoInfo;
    }
    getVideoInfo = {
      file_id: uuid,
      version: 2
    };
    console.log(this.activity_id, uuid);
    that.$http.get(API.VoteActivity, { params: { activity_id: this.activity_id, file_id: uuid } }).then(function (res) {
      console.log(res);
      if (res.code == 0) {
        that.data = res.data;
        that.vote_count = that.data.vote_count;
        var cyrrend = new Date().getTime(),
            end_time = new Date(that.data.end_time).getTime(),
            start_time = new Date(that.data.start_time).getTime();
        //判断是否在投票时间内
        if (!cyrrend < end_time && !cyrrend > start_time) {
          $('.show-btn-poll').addClass('show-btn-poll-over');
        }
      }
    });
    that.$http.get(APIName, { params: getVideoInfo }).then(function (res) {
      // console.log(res)
      if (res.code == 0) {
        that.itemName = res.data;
        if (type == 2) {
          that.asImg = that.itemName.image_url;
        } else {
          var w = $('.et-tabhead').width() - 32,
              h = Math.ceil(w / 1.78);
          that.VideoPlay(uuid, w, h);
        }
        that.$nextTick(function () {
          if ($('.preview-span').height() > 60) {
            $('.show-v-more').show();
          } else {
            $('.show-v-more').hide();
          }
        });
      } else {
        $('.yaVideo').show();
      }
    });
    $.getJSON(API.GetActivitieById + '?jsoncallback=?&id=' + that.id, function (res) {
      that.detailsTxte = res.data;
      if (res.code == 0) {
        //分享微信
        var title = '',
            desc = '';
        if (that.detailsTxte.share_config) {
          var activity = that.detailsTxte.share_config.activity;
          if (activity != 'undefined' && activity && activity.share_title) {
            title = activity.share_title;
          } else {
            title = that.detailsTxte.title;
          }
          if (activity != 'undefined' && activity && activity.share_contents) {
            desc = activity.share_contents;
          } else {
            desc = that.detailsTxte.description;
          }
        } else {
          title = that.detailsTxte.title;
          desc = that.detailsTxte.description;
        }
        document.title = title;
        var metas = $('head').children('meta');
        metas[1].content = desc;
        var dataName = {
          title: '我参加' + title + '活动，快帮我投票',
          desc: desc,
          imgAddress: that.route,
          Retain: '', // 保留
          url: window.location.href
        };
        that.weixinShare(dataName);
      }
    });
  },
  mounted: function mounted() {
    //操作DOM
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "ANZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_vue__ = __webpack_require__("O60Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8010b594_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_vue__ = __webpack_require__("TSqV");
function injectStyle (ssrContext) {
  __webpack_require__("hL7r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8010b594_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B1Td":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_linkage_vue__ = __webpack_require__("gqHj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__myMessage_userContenr_vue__ = __webpack_require__("llRM");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyMessage',
  data: function data() {
    return {
      cancel: false,
      MyPortrait: true,
      total: 0, // 上传个数
      Tables: '', // 首页最新征集推荐
      TablesName: '', // 首页最新征集推荐数量
      TwoNumbers: 2,
      userId: '',
      count: '',
      countmes: '',
      nickname: '',
      headPortrait: '',
      region: '',
      address: '',
      myMessage: '',
      sexCheck: ''
    };
  },

  methods: {
    route: function route(id) {
      var url = '';
      var hrefHTML = this.hrefHTML(0, id);
      if (hrefHTML) {
        window.location.href = hrefHTML;
      } else {
        window.location.href = API.UrlName + 'detail/' + id;
      }
    },
    login: function login() {
      var that = this;
      // if (!that.loginFn()) {
      that.$router.push({ name: 'login_Quick' });
      // }
    },
    sexCheckfn: function sexCheckfn(i) {
      if (i == 1) {
        this.sexCheck = '男';
      } else {
        this.sexCheck = '女';
      }
    },
    fn: function fn() {
      // this.$router.push({name: 'HomeIndex'})
      this.$router.go(-1);
    },

    // 操作按钮事件
    signOut: function signOut() {
      // 退出
      var that = this;
      var from = 'passport';
      passport.logout(from, fn);

      function fn() {
        window.sessionStorage.setItem('userId', '');
        that.$router.push({ name: 'HomeIndex' });
      }
      setTimeout(function () {
        window.sessionStorage.setItem('userId', '');
        that.$router.push({ name: 'HomeIndex' });
      }, 1000);
    },
    listenToMyBoy: function listenToMyBoy(somedata) {
      this.region = somedata;
    },

    // 获取信息
    showActivityUser: function showActivityUser() {
      $('#modal_content').css('left', '0');
      var that = this;
      this.$http.get(API.ShowActivityUser).then(function (res) {
        //console.log(res)
        if (res.code == 0) {
          if (res.data.content) {
            that.myMessage = res.data.content;
            /// console.log(that.myMessage)
            that.sexCheck = that.myMessage.sex;
            if (that.myMessage && that.myMessage.address) {
              that.address = that.myMessage.address;
            } else {
              that.address = '';
            }
          }
        }
      });
      $('#detailAlert').modal('show');
    },
    SmallKeyup: function SmallKeyup(event) {
      var itself = event.target,
          val = $(itself).val();
      var reg = /^[1][3,4,5,7,8][0-9]{9}$/;

      if (!reg.test(val)) {
        $(itself).next().show();
        $('#Button1').css('pointer-events', 'none');
        return false;
      } else {
        $(itself).next().hide();
        $('#Button1').css('pointer-events', 'visible');
      }
    },

    // 修改信息
    myHas: function myHas(val) {
      if (val == 0) {
        $('#modal_content').css('left', '-120%');
        return false;
      }
      var sex = $('input[name="myGender"]:checked').val();
      var demolName = $('.form-control');
      if (demolName.length > 0) {
        for (var i = 0; i < demolName.length; i++) {
          var sel = $('.example').eq(i).find('select'),
              selName = '';
          for (var v = 0; v < 3; v++) {
            if (sel.eq(v).val() == '请选择') {
              var etSlebox = $('.content-block').offset().top;
              $('.example').addClass('font');
              $(window).scrollTop(etSlebox);
              return false;
            }
            if (sel.eq(v).length) {
              selName += sel.eq(v).val() + ',';
            } else {
              selName += '--' + ',';
            }
          }
          selName += $('.detailed').find('input').val();
        }
      }
      var content = {
        name: $('.myName').val(),
        sex: sex,
        address: selName || this.address,
        mobile: $('.myTelephone').val()
      };
      $.ajax({
        'url': API.SaveActivityUser,
        'data': { data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content) },
        'type': 'POST',
        'dataType': 'json',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function success(res) {
          // console.log(res)
          if (res.code == 0) {
            $('#modal_content').css('left', '-120%');
          }
        }
      });
    }
  },
  components: { // 渲染页面
    Linkage: __WEBPACK_IMPORTED_MODULE_1__template_linkage_vue__["a" /* default */],
    UserContentr: __WEBPACK_IMPORTED_MODULE_2__myMessage_userContenr_vue__["a" /* default */]
  },
  created: function created() {

    var that = this;
    if (that.IsPC()) {
      window.location.href = API.IsPcName;
    }
    if (window.isThisClient('cbox')) {
      console.log("mymessage");
      that.cboxregisterhandler();
    }
    if (that.loginFn()) {
      // console.log('login_check_success');
      that.MyPortrait = true;
      // 登录之后
      that.$http.get(API.GetCountByUserid).then(function (res) {

        if (res.code == 0) {
          that.count = res.data;
          that.countmes = res.data.msg;
          that.nickname = res.data.nick_name;
          that.headPortrait = res.data.face_url;
          that.userId = res.data.user_id;
        } else {
          that.MyPortrait = false;
        }
      });
    } else {
      that.MyPortrait = false;
    }

    var GetActivities = {
      pagesize: '10',
      page: 1,
      progress: 'on'
    };
    // 最新征集推荐
    that.$http.get(API.GetActivities, { params: GetActivities }).then(function (res) {
      if (res.code == '0') {
        that.TablesName = Math.floor(res.data.length / 2);
        that.Tables = res.data;
        that.$nextTick(function () {
          var swiperPoll = new Swiper('.show-poll-swiper', {
            loop: true,
            autoplayDisableOnInteraction: false
          });
          var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
          $('.pic-box').find('img').css({ height: picHimg, visibility: 'visible' });
        });
      }
    });
    that.FileByUserid = {
      page: 1,
      pagesize: 1
    };
    // 获取上传个数
    that.$http.get(API.GetUploadFileForMe, { params: that.FileByUserid }).then(function (res) {
      if (res.code == 0) {
        that.total = res.total;
      }
    });
  },
  mounted: function mounted() {
    // 操作DOM
    var that = this;
    if (window.isThisClient('cbox')) {
      $('.cbox').hide();
    }
    window.addEventListener("popstate", function (e) {
      $(".modal-backdrop").remove();
      var urlArr = window.location.href.split('/');
      var len = urlArr.length;
      var name = urlArr[len - 1].toLowerCase();
      if (name == 'mymessage' || name == 'index') {
        window.location.reload();
      }
    }, false);
    // 微信分享
    var metas = $('head').children('meta');
    var dataName = {
      title: document.title,
      desc: that.removeTAG(metas[1].content, 110),
      imgAddress: 'http://userface.img.cctvpic.com/G01/M00/3E/0E/CkcBPVpAcZiAQwHXAAAJR49Qvog771.jpg',
      Retain: '', // 保留
      url: window.location.href
    };
    that.weixinShare(dataName);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "B7vk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_discovery_vue__ = __webpack_require__("c9m6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0082bc70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_discovery_vue__ = __webpack_require__("rkZJ");
function injectStyle (ssrContext) {
  __webpack_require__("EKrH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_discovery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0082bc70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_discovery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BI2M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    //操作按钮事件
    backFn: function backFn() {
      $('#container').hide();
    }
  },
  created: function created() {
    var that = this;
    this.$http.get(API.ShowActivityUser).then(function (res) {
      console.log(res);
      if (res.code == 0) {
        if (res.data.content) {
          that.myMessage = JSON.parse(res.data.content);
          if (that.myMessage && that.myMessage.address) {
            that.address = that.myMessage.address;
          } else {
            that.address = '';
          }
        }
      }
    });
  },
  mounted: function mounted() {
    //操作DOM
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "BICJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BvAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collection_vue__ = __webpack_require__("86ij");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e55b014c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collection_vue__ = __webpack_require__("hugo");
function injectStyle (ssrContext) {
  __webpack_require__("djmg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e55b014c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e55b014c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CZzb":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {var _XYloadJS = function (params) {
  var head = document.getElementsByTagName("head")[0];
  var script = document.createElement('script');
  script.onload = script.onreadystatechange = script.onerror = function () {
    if (script && script.readyState && /^(?!(?:loaded|complete)$)/.test(script.readyState)) return;
    script.onload = script.onreadystatechange = script.onerror = null;
    script.src = '';
    script.parentNode.removeChild(script);
    script = null;
    if (params.callback) params.callback()
  };
  script.charset = params.charset || document.charset || document.characterSet || 'utf-8';
  script.src = params.src;
  try {
    head.appendChild(script)
  } catch (exp) {
  }
};
var hostUrl = document.location.href;
var domainName = 'http://';
if(hostUrl.split(':')[0] == 'https'){
  domainName = 'https://'
}else{
  domainName = 'http://'
}
var jQueryLoaded = typeof jQuery != "undefined";
if (!jQueryLoaded) _XYloadJS({src: domainName + 'ishow.cctv.com/js/jquery-1.8.0.min.js'});
var _XYVideoPlayer = null;
(function ($) {
  $.fn.xyPlayer = function (options, callback) {
    var defaults = {
      id: '',
      item_id: '',
      width: 640,
      height: 385,
      type: 'out',
      autoplay: true,
      order: 'asc',
      version: '3.096',
      controls: true,
      static_url: domainName + 'ishow.cctv.com/',
      configxml: 'player.xml',
      pid: '100',
      time: 0,
      extend: true,
      skin: 'default',
      lang: 'zh-CN',
      params: '',
      list_url: '',
      callback: false,
      hideRelationlist: false,
      playrelationlist: false
    };
    var $base = this;
    var $video;
    options = $.extend(true, defaults, options);
    if (callback) {
      options.callback = callback
    }
    this.init = function () {
      // if (isIOS()) {
        if (!jQuery().bxPlayer) {
          $.getScript(options.static_url + 'js/jquery.bxPlayer.js?ver=' + options.version, function () {
            $video = loadBxPlayer()
          })
        } else {
          $video = loadBxPlayer()
        }
      // } else {
      //   if (!jQuery().flash) {
      //     $.getScript(options.static_url + 'js/jquery.swfobject.min.js?ver=' + options.version, function () {
      //       $video = loadFlashPlayer()
      //     })
      //   } else {
      //     $video = loadFlashPlayer()
      //   }
      // }
      return
    };
    this.play = function () {
      try {
        return $video.play()
      } catch (e) {
        return false
      }
    };
    this.pause = function () {
      try {
        return $video.pause()
      } catch (e) {
        return false
      }
    };
    this.getData = function () {
      if (isIOS()) {
        return $video.getData()
      } else {
        var data = $video.getVideoData().replace(/\"\=\"/gi, "\":\"").replace(/\'/gi, "\\'");
        return eval('(' + data + ')')
      }
    };
    this.getStats = function () {
      try {
        return $video.getStats()
      } catch (e) {
        return false
      }
    };
    this.getPlaylist = function () {
      try {
        return $video.getPlaylist()
      } catch (e) {
        return null
      }
    };
    this.changeVideo = function (id) {
      if (isIOS()) {
        return $video.changeVideo(id)
      } else {
        return $video.changeVideoByJS(id)
      }
    };
    this.changeVideo = function (id, time) {
      if (isIOS()) {
        return $video.changeVideo(id)
      } else {
        return $video.changeVideoByJS(id, time)
      }
    };
    this.setAutoPlaylist = function (bool) {
      if (isIOS()) {
        $video.setListAutoPlay(bool)
      } else {
        $video.setListAutoPlay(bool)
      }
    };
    this.getTime = function () {
      if (isIOS()) {
        return 0
      } else {
        return $video.getTime()
      }
    };
    this.getVideoId = function () {
      try {
        return this.getData().videoId
      } catch (e) {
        return null
      }
    };
    this.isLoaded = function () {
      if (isIOS()) {
        return ($video.getStats().code == 200)
      } else {
        return ($video.PercentLoaded() == 100)
      }
    };
    this.resize = function (w, h) {
      if (isIOS()) {
        $video.resize(w, (h - 25))
      } else {
        $('#__XYFlashPlayer__').attr({'width': w, 'height': h})
      }
      return
    };
    this.isPlay = function () {
      try {
        return $video.isPlay()
      } catch (e) {
        return null
      }
    };
    this.getTime = function () {
      try {
        return $video.getTime()
      } catch (e) {
        return null
      }
    };
    this.seek = function (time) {
      try {
        return $video.seek(time)
      } catch (e) {
        return null
      }
    };
    this.getStaticData = function () {
      var xiyouplayTraceerImg = document.getElementById("xiyouplayTraceerImg");
      xiyouplayTraceerImg.src = $video.getStaticData() + "&rand=" + Math.random()
    };
    this.snsPostData = function () {
      try {
        return $video.snsPostData()
      } catch (e) {
        return null
      }
    };

    function isIOS() {
      return /(iphone|ipad|ipod|ios|android)/i.test(navigator.userAgent)
    }

    function loadBxPlayer() {
      $base.empty();
      return $base.bxPlayer({
        id: options.id,
        pid: options.pid,
        width: options.width,
        height: options.height,
        type: options.type,
        item_id: options.item_id,
        order: options.order,
        skin: options.skin,
        lang: options.lang,
        params: options.params,
        autoplay: options.autoplay,
        controls: options.controls,
        callback: options.callback,
        use_hls: options.use_hls
      })
    }

    function loadFlashPlayer() {
      if (options.list_url != '') {
        options.list_url = encodeURIComponent(options.list_url)
      }
      $base.flash({
        id: '__XYFlashPlayer__',
        swf: options.static_url + 'flash/player.swf?ver=' + options.version,
        flashvars: {
          id: options.id,
          item_id: options.item_id,
          pid: options.pid,
          type: options.type,
          order: options.order,
          skin: options.skin,
          lang: options.lang,
          params: options.params,
          autoplay: options.autoplay,
          list_url: options.list_url,
          time: options.time,
          hideRelationlist: options.hideRelationlist,
          playrelationlist: options.playrelationlist,
          extend: options.extend,
          config: options.static_url + 'flash/' + options.configxml + '?ver=' + options.version
        },
        alternative: true,
        width: options.width,
        height: options.height,
        wmode: 'opaque',
        menu: false,
        quality: 'best',
        allowFullScreen: true,
        allowScriptAccess: 'always',
        hasVersion: 10,
        expressInstall: options.static_url + 'flash/expressInstall.swf?ver=' + options.version
      });
      return $('#__XYFlashPlayer__').get(0)
    }

    return this.each(function () {
      $base.init()
    });
    return this
  }
})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "DUjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_vue__ = __webpack_require__("4skC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4385ba0d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_vue__ = __webpack_require__("vHxh");
function injectStyle (ssrContext) {
  __webpack_require__("3XOP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4385ba0d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4385ba0d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E5lx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgList"},[_c('div',{staticClass:"et-tabhead"},[_c('span',{staticClass:"et-back",on:{"click":_vm.detail}},[_c('i',{staticClass:"icon-back"}),_vm._v("\n        详情\n      ")]),_vm._v(" "),_c('div',{staticClass:"et-tabtn"},[_c('div',{staticClass:"et-tabtn",attrs:{"id":"but-tabtn"}},[_c('span',{staticClass:"btn-et-form",staticStyle:{"padding-right":"10px","border-right":"none"}},[_vm._v("\n             共"),_c('span',{staticStyle:{"border-right":"none"}},[_vm._v(_vm._s(_vm.current)+"/"+_vm._s(_vm.total-_vm.currentName))]),_vm._v("个作品\n         ")])])])]),_vm._v(" "),_c('div',{staticClass:"imgConen"},[_c('div',{staticClass:"Exhibition"},[_c('div',{staticClass:"swiper-container swiper-pic"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.total),function(item,key){return _c('div',{staticClass:"swiper-slide"},[(_vm.imgList[key])?_c('img',{staticClass:"swiper-img",staticStyle:{"min-height":"100px"},attrs:{"src":_vm.imgList[key].file.image_url,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.imgList[key])?_c('h3',{staticClass:"img-title"},[_vm._v(_vm._s(_vm.imgList[key].file.title))]):_vm._e(),_vm._v(" "),(_vm.imgList[key] && _vm.imgList[key].user.nick_name)?_c('div',{staticClass:"img-user"},[_c('img',{staticStyle:{"min-height":"0"},attrs:{"src":_vm.imgList[key].user.face_url,"alt":""}}),_vm._v(_vm._s(_vm.imgList[key].user.nick_name)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.imgList[key])?_c('p',{staticClass:"img-detail"},[_vm._v(_vm._s(_vm.imgList[key].file.description))]):_vm._e()])}))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EDux":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EKrH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EPHU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ERql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_filedetails_vue__ = __webpack_require__("LjJY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userId', 'initUtil'],
  data: function data() {
    return {
      MyUpload: [],
      page: '0',
      pagesize: '10',
      id: '',
      ID: '',
      ind: '',
      FileByUserid: null,
      busy: false,
      file_type: '',
      total: '',
      fileItem: null,
      tops: '0',
      data: '',
      globalUrl: API.GlobalUrl,
      pngSds: API.GlobalUrl + 'static/dist/img/audit_1.jpg',
      reject_img: API.GlobalUrl + 'static/dist/img/reject_1.jpg'
    };
  },

  components: { //渲染页面
    Filedetails: __WEBPACK_IMPORTED_MODULE_0__template_filedetails_vue__["a" /* default */]
  },
  methods: {
    //操作按钮事件
    pictureHide: function pictureHide() {
      $('.picture-content').hide();
    },
    loadMore: function loadMore() {
      var _this = this;

      this.busy = true;
      // 多次加载数据
      setTimeout(function () {
        _this.page++;
        _this.ajaxMore(true);
      }, 500);
    },
    ajaxMore: function ajaxMore(flag) {
      var that = this;
      that.FileByUserid = {
        page: that.page,
        pagesize: that.pagesize,
        version: 2
      };
      this.$http.get(API.GetUploadFileForMe, { params: that.FileByUserid }).then(function (res) {
        //console.log(res)
        if (res.code == 0) {
          if (flag) {
            for (var i = 0; i < res.data.length; i++) {
              that.MyUpload.push(res.data[i]);
            }
            if (res.data.length === 0 || that.MyUpload.length === res.total) {
              that.busy = true;
            } else {
              that.busy = false;
            }
          }
          if (res.total == 0) {
            $('.foll_div').html('您还没有上传过文件！');
          }
          //   console.log(that.MyUpload)
        }
      });
    },

    //视频跳转
    video: function video(val, id, uuid, type, item, status) {
      var that = this;
      if (val == 'approved') {
        if (type == 'video') {
          this.data = new Date();
          that.fileItem = {
            file_type: 'video',
            file_id: item.file_id,
            activity_id: item.ids,
            file: item.file,
            activity_mini: {
              title: ''
            }
          };
          that.setShareInfo(that.fileItem);
        } else if (type == 'image') {
          this.data = new Date();
          that.fileItem = {
            file_type: 'image',
            file_id: item.file_id,
            activity_id: item.ids,
            activity_mini: {
              title: ''
            }
          };
        }
        $('.preview-file').addClass('preview-active');
        // $('.dl-video-title').show();
        this.tops = $(document).scrollTop();
      }
    },


    /**
     * 设置分享信息
     * @param {[type]} fileInfo [description]
     */
    setShareInfo: function setShareInfo(item) {
      var dataName = {
        title: item.file.title,
        // desc: this.removeTAG(item.file.description, 110),
        desc: '央视喊你上电视啦',
        imgAddress: item.file.thumb_url,
        Retain: '', // 保留
        url: API.UrlName + 'videoName/' + item.activity_id + '/' + item.file_id + '/video'
      };

      this.weixinShare(dataName);
    },

    //删除s上传文件
    DelFile: function DelFile() {
      var that = this;
      $('#editModals').modal('hide');
      //删除视频
      var edit;
      if (that.file_type == '1') {
        edit = API.DelEteVideo;
      } else {
        //删除图片
        edit = API.DelEteImage;
      }
      this.$http.get(edit, { params: { fileId: that.id } }).then(function (res) {
        // console.log(res)
        if (res.code == 0) {
          $('#editModals').modal('hide');
          $('.ay-close').eq(that.ind - 1).parents('.ay-link').remove();
        } else {
          alert('删除失败，该文件不存在');
        }
      });
    },

    //显示编辑
    edit: function edit(ind, file_type, data) {
      //console.log(data);
      $('.btn-modal-tw').attr('data-id', ind).attr('file_type', file_type);
      $('#editModal').modal('show');
      $('#titleName').val(data.file.title);
      $('#descriptionName').val(data.file.description);
    },
    editcComplete: function editcComplete() {
      //编辑
      //title  description
      var that = this;
      //不能为空
      if ($('#titleName').val() == '') {
        $('#titleName').focus();
      } else if ($('#descriptionName').val() == '') {
        $('#descriptionName').focus();
      } else {
        //传参数
        var ActivityFile = {
          title: $('#titleName').val(),
          description: $('#descriptionName').val(),
          fileId: $('.btn-modal-tw').attr('data-id')
        };
        var edit;
        //判断类型  是图片还是视频
        if ($('.btn-modal-tw').attr('file_type') == 'video') {
          edit = API.UpdataVideoAudit;
        } else {
          edit = API.UpdataImageAudit;
        }
        $.ajax({
          'url': edit,
          'data': ActivityFile,
          'type': 'POST',
          'dataType': 'json',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          success: function success(res) {
            // console.log(res)
            if (res.code == '0') {
              $('#editModal').modal('hide');
              $('#Prompt').modal('show');
            } else {
              console.log(res.msg);
            }
          }
        });
      }
    }
  },

  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = true;
    next();
  },

  created: function created() {
    $('.icon-back').removeClass('pointerEve');
  },
  mounted: function mounted() {
    this.userId = this.getCookie('userSeqId');
    $('#picture').modal('show');
    //操作DOM
    $('.icon-back').show();
    var that = this;
    //滚动事件，加载数据
    $(window).scroll(function () {
      if ($(window).scrollTop() > 1000) {
        $('.back-top').show();
      } else {
        $('.back-top').hide();
      }
    });

    $('.nav').children('.id-nav-recom').eq(2).addClass('nav-on').siblings().removeClass('nav-on');
    $('.nav').find('.id-nav-recom').eq(2).addClass('router-link-exact-active').siblings().removeClass('router-link-exact-active');

    //显示提示框，并传值
    $('.ay-content-list').on('click', '.ay-close', function () {
      that.id = $(this).attr('attr-id');
      that.ID = $(this).attr('id');
      that.ind = $(this).parents().index();
      that.file_type = $(this).attr('attr-type');
      $('#editModals').modal('show');
    });
    this.initUtil.stopBodyScroll(false);
    //微信分享
    var metas = $('head').children('meta');
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      navOn: 'index', //导航选中
      channel: '', //导航渲染
      allchannel: '',
      allChannelsShow: false,
      globalUrl: API.GlobalUrl,
      upward: false
    };
  },

  methods: {
    //操作按钮事件
    fnTable: function fnTable(id) {
      //切换头部按钮
      this.navOn = id;
      if (id == 'index') {
        this.$router.push({ name: 'HomeIndex' });
      } else {
        this.$router.push({ name: 'HomeChannel', params: { id: id } });
        if (this.allChannelsShow === true) {
          this.allChannelsShow = false;
        }
      }
    },
    menu: function menu() {
      //是否显示回到顶部按钮
      if (document.body.scrollTop > 800) {
        this.upward = true;
      } else {
        this.upward = false;
      }
    },
    returnTop: function returnTop() {
      //返回顶部
      $('html,body').stop().animate({ scrollTop: '0px' }, 500);
    }
  },
  created: function created() {
    //ajax请求
    // var id = this.$route.params.id;
    // console.log(id);
    // if(typeof id === 'undefined' || id==='index'){
    this.$router.push('/');
    // }
    // else {
    //   this.navOn = id;
    //   this.$router.push('/channel/' + id);
    // }

    $(document).unbind("scroll");
    var that = this;
    //判断pc移动
    if (that.IsPC()) {
      window.location.href = API.IsPcName;
    }

    that.channel = [{
      id: "index",
      slug: "发现"
    }];
    //所有央视频道
    // this.$http.get(API.GetChannelList)
    //   .then(function (res) {
    //   if (res.code == '0') {
    //     that.allchannel = res.data;
    //   }
    // });
    // // //table央视频道
    // this.$http.get(API.GetHomeChannel)
    //   .then(function (res) {
    //   // console.log(res)
    //   if (res.code == '0') {
    //     that.channel = res.data;
    //   }
    // });
  },
  mounted: function mounted() {
    //操作DOM
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Fo7c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GO9e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GTmt":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, __webpack_provided_window_dot_jQuery) {/**
 * Swiper 3.4.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * 
 * http://www.idangero.us/swiper/
 * 
 * Copyright 2017, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 * 
 * Licensed under MIT
 * 
 * Released on: March 10, 2017
 */
!function(){"use strict";var e,a=function(t,s){function r(e){return Math.floor(e)}function i(){var e=x.params.autoplay,a=x.slides.eq(x.activeIndex);a.attr("data-swiper-autoplay")&&(e=a.attr("data-swiper-autoplay")||x.params.autoplay),x.autoplayTimeoutId=setTimeout(function(){x.params.loop?(x.fixLoop(),x._slideNext(),x.emit("onAutoplay",x)):x.isEnd?s.autoplayStopOnLast?x.stopAutoplay():(x._slideTo(0),x.emit("onAutoplay",x)):(x._slideNext(),x.emit("onAutoplay",x))},e)}function n(a,t){var s=e(a.target);if(!s.is(t))if("string"==typeof t)s=s.parents(t);else if(t.nodeType){var r;return s.parents().each(function(e,a){a===t&&(r=t)}),r?t:void 0}if(0!==s.length)return s[0]}function o(e,a){a=a||{};var t=window.MutationObserver||window.WebkitMutationObserver,s=new t(function(e){e.forEach(function(e){x.onResize(!0),x.emit("onObserverUpdate",x,e)})});s.observe(e,{attributes:void 0===a.attributes||a.attributes,childList:void 0===a.childList||a.childList,characterData:void 0===a.characterData||a.characterData}),x.observers.push(s)}function l(e){e.originalEvent&&(e=e.originalEvent);var a=e.keyCode||e.charCode;if(!x.params.allowSwipeToNext&&(x.isHorizontal()&&39===a||!x.isHorizontal()&&40===a))return!1;if(!x.params.allowSwipeToPrev&&(x.isHorizontal()&&37===a||!x.isHorizontal()&&38===a))return!1;if(!(e.shiftKey||e.altKey||e.ctrlKey||e.metaKey||document.activeElement&&document.activeElement.nodeName&&("input"===document.activeElement.nodeName.toLowerCase()||"textarea"===document.activeElement.nodeName.toLowerCase()))){if(37===a||39===a||38===a||40===a){var t=!1;if(x.container.parents("."+x.params.slideClass).length>0&&0===x.container.parents("."+x.params.slideActiveClass).length)return;var s={left:window.pageXOffset,top:window.pageYOffset},r=window.innerWidth,i=window.innerHeight,n=x.container.offset();x.rtl&&(n.left=n.left-x.container[0].scrollLeft);for(var o=[[n.left,n.top],[n.left+x.width,n.top],[n.left,n.top+x.height],[n.left+x.width,n.top+x.height]],l=0;l<o.length;l++){var p=o[l];p[0]>=s.left&&p[0]<=s.left+r&&p[1]>=s.top&&p[1]<=s.top+i&&(t=!0)}if(!t)return}x.isHorizontal()?(37!==a&&39!==a||(e.preventDefault?e.preventDefault():e.returnValue=!1),(39===a&&!x.rtl||37===a&&x.rtl)&&x.slideNext(),(37===a&&!x.rtl||39===a&&x.rtl)&&x.slidePrev()):(38!==a&&40!==a||(e.preventDefault?e.preventDefault():e.returnValue=!1),40===a&&x.slideNext(),38===a&&x.slidePrev()),x.emit("onKeyPress",x,a)}}function p(e){var a=0,t=0,s=0,r=0;return"detail"in e&&(t=e.detail),"wheelDelta"in e&&(t=-e.wheelDelta/120),"wheelDeltaY"in e&&(t=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(a=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(a=t,t=0),s=10*a,r=10*t,"deltaY"in e&&(r=e.deltaY),"deltaX"in e&&(s=e.deltaX),(s||r)&&e.deltaMode&&(1===e.deltaMode?(s*=40,r*=40):(s*=800,r*=800)),s&&!a&&(a=s<1?-1:1),r&&!t&&(t=r<1?-1:1),{spinX:a,spinY:t,pixelX:s,pixelY:r}}function d(e){e.originalEvent&&(e=e.originalEvent);var a=0,t=x.rtl?-1:1,s=p(e);if(x.params.mousewheelForceToAxis)if(x.isHorizontal()){if(!(Math.abs(s.pixelX)>Math.abs(s.pixelY)))return;a=s.pixelX*t}else{if(!(Math.abs(s.pixelY)>Math.abs(s.pixelX)))return;a=s.pixelY}else a=Math.abs(s.pixelX)>Math.abs(s.pixelY)?-s.pixelX*t:-s.pixelY;if(0!==a){if(x.params.mousewheelInvert&&(a=-a),x.params.freeMode){var r=x.getWrapperTranslate()+a*x.params.mousewheelSensitivity,i=x.isBeginning,n=x.isEnd;if(r>=x.minTranslate()&&(r=x.minTranslate()),r<=x.maxTranslate()&&(r=x.maxTranslate()),x.setWrapperTransition(0),x.setWrapperTranslate(r),x.updateProgress(),x.updateActiveIndex(),(!i&&x.isBeginning||!n&&x.isEnd)&&x.updateClasses(),x.params.freeModeSticky?(clearTimeout(x.mousewheel.timeout),x.mousewheel.timeout=setTimeout(function(){x.slideReset()},300)):x.params.lazyLoading&&x.lazy&&x.lazy.load(),x.emit("onScroll",x,e),x.params.autoplay&&x.params.autoplayDisableOnInteraction&&x.stopAutoplay(),0===r||r===x.maxTranslate())return}else{if((new window.Date).getTime()-x.mousewheel.lastScrollTime>60)if(a<0)if(x.isEnd&&!x.params.loop||x.animating){if(x.params.mousewheelReleaseOnEdges)return!0}else x.slideNext(),x.emit("onScroll",x,e);else if(x.isBeginning&&!x.params.loop||x.animating){if(x.params.mousewheelReleaseOnEdges)return!0}else x.slidePrev(),x.emit("onScroll",x,e);x.mousewheel.lastScrollTime=(new window.Date).getTime()}return e.preventDefault?e.preventDefault():e.returnValue=!1,!1}}function m(a,t){a=e(a);var s,r,i,n=x.rtl?-1:1;s=a.attr("data-swiper-parallax")||"0",r=a.attr("data-swiper-parallax-x"),i=a.attr("data-swiper-parallax-y"),r||i?(r=r||"0",i=i||"0"):x.isHorizontal()?(r=s,i="0"):(i=s,r="0"),r=r.indexOf("%")>=0?parseInt(r,10)*t*n+"%":r*t*n+"px",i=i.indexOf("%")>=0?parseInt(i,10)*t+"%":i*t+"px",a.transform("translate3d("+r+", "+i+",0px)")}function u(e){return 0!==e.indexOf("on")&&(e=e[0]!==e[0].toUpperCase()?"on"+e[0].toUpperCase()+e.substring(1):"on"+e),e}if(!(this instanceof a))return new a(t,s);var c={direction:"horizontal",touchEventsTarget:"container",initialSlide:0,speed:300,autoplay:!1,autoplayDisableOnInteraction:!0,autoplayStopOnLast:!1,iOSEdgeSwipeDetection:!1,iOSEdgeSwipeThreshold:20,freeMode:!1,freeModeMomentum:!0,freeModeMomentumRatio:1,freeModeMomentumBounce:!0,freeModeMomentumBounceRatio:1,freeModeMomentumVelocityRatio:1,freeModeSticky:!1,freeModeMinimumVelocity:.02,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",coverflow:{rotate:50,stretch:0,depth:100,modifier:1,slideShadows:!0},flip:{slideShadows:!0,limitRotation:!0},cube:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94},fade:{crossFade:!1},parallax:!1,zoom:!1,zoomMax:3,zoomMin:1,zoomToggle:!0,scrollbar:null,scrollbarHide:!0,scrollbarDraggable:!1,scrollbarSnapOnRelease:!1,keyboardControl:!1,mousewheelControl:!1,mousewheelReleaseOnEdges:!1,mousewheelInvert:!1,mousewheelForceToAxis:!1,mousewheelSensitivity:1,mousewheelEventsTarged:"container",hashnav:!1,hashnavWatchState:!1,history:!1,replaceState:!1,breakpoints:void 0,spaceBetween:0,slidesPerView:1,slidesPerColumn:1,slidesPerColumnFill:"column",slidesPerGroup:1,centeredSlides:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,onlyExternal:!1,threshold:0,touchMoveStopPropagation:!0,touchReleaseOnEdges:!1,uniqueNavElements:!0,pagination:null,paginationElement:"span",paginationClickable:!1,paginationHide:!1,paginationBulletRender:null,paginationProgressRender:null,paginationFractionRender:null,paginationCustomRender:null,paginationType:"bullets",resistance:!0,resistanceRatio:.85,nextButton:null,prevButton:null,watchSlidesProgress:!1,watchSlidesVisibility:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,lazyLoading:!1,lazyLoadingInPrevNext:!1,lazyLoadingInPrevNextAmount:1,lazyLoadingOnTransitionStart:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,control:void 0,controlInverse:!1,controlBy:"slide",normalizeSlideIndex:!0,allowSwipeToPrev:!0,allowSwipeToNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",passiveListeners:!0,containerModifierClass:"swiper-container-",slideClass:"swiper-slide",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",bulletClass:"swiper-pagination-bullet",bulletActiveClass:"swiper-pagination-bullet-active",buttonDisabledClass:"swiper-button-disabled",paginationCurrentClass:"swiper-pagination-current",paginationTotalClass:"swiper-pagination-total",paginationHiddenClass:"swiper-pagination-hidden",paginationProgressbarClass:"swiper-pagination-progressbar",paginationClickableClass:"swiper-pagination-clickable",paginationModifierClass:"swiper-pagination-",lazyLoadingClass:"swiper-lazy",lazyStatusLoadingClass:"swiper-lazy-loading",lazyStatusLoadedClass:"swiper-lazy-loaded",lazyPreloaderClass:"swiper-lazy-preloader",notificationClass:"swiper-notification",preloaderClass:"preloader",zoomContainerClass:"swiper-zoom-container",observer:!1,observeParents:!1,a11y:!1,prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",runCallbacksOnInit:!0},g=s&&s.virtualTranslate;s=s||{};var h={};for(var v in s)if("object"!=typeof s[v]||null===s[v]||(s[v].nodeType||s[v]===window||s[v]===document||"undefined"!=typeof Dom7&&s[v]instanceof Dom7||"undefined"!=typeof jQuery&&s[v]instanceof jQuery))h[v]=s[v];else{h[v]={};for(var f in s[v])h[v][f]=s[v][f]}for(var w in c)if(void 0===s[w])s[w]=c[w];else if("object"==typeof s[w])for(var y in c[w])void 0===s[w][y]&&(s[w][y]=c[w][y]);var x=this;if(x.params=s,x.originalParams=h,x.classNames=[],void 0!==e&&"undefined"!=typeof Dom7&&(e=Dom7),(void 0!==e||(e="undefined"==typeof Dom7?window.Dom7||window.Zepto||__webpack_provided_window_dot_jQuery:Dom7))&&(x.$=e,x.currentBreakpoint=void 0,x.getActiveBreakpoint=function(){if(!x.params.breakpoints)return!1;var e,a=!1,t=[];for(e in x.params.breakpoints)x.params.breakpoints.hasOwnProperty(e)&&t.push(e);t.sort(function(e,a){return parseInt(e,10)>parseInt(a,10)});for(var s=0;s<t.length;s++)(e=t[s])>=window.innerWidth&&!a&&(a=e);return a||"max"},x.setBreakpoint=function(){var e=x.getActiveBreakpoint();if(e&&x.currentBreakpoint!==e){var a=e in x.params.breakpoints?x.params.breakpoints[e]:x.originalParams,t=x.params.loop&&a.slidesPerView!==x.params.slidesPerView;for(var s in a)x.params[s]=a[s];x.currentBreakpoint=e,t&&x.destroyLoop&&x.reLoop(!0)}},x.params.breakpoints&&x.setBreakpoint(),x.container=e(t),0!==x.container.length)){if(x.container.length>1){var T=[];return x.container.each(function(){T.push(new a(this,s))}),T}x.container[0].swiper=x,x.container.data("swiper",x),x.classNames.push(x.params.containerModifierClass+x.params.direction),x.params.freeMode&&x.classNames.push(x.params.containerModifierClass+"free-mode"),x.support.flexbox||(x.classNames.push(x.params.containerModifierClass+"no-flexbox"),x.params.slidesPerColumn=1),x.params.autoHeight&&x.classNames.push(x.params.containerModifierClass+"autoheight"),(x.params.parallax||x.params.watchSlidesVisibility)&&(x.params.watchSlidesProgress=!0),x.params.touchReleaseOnEdges&&(x.params.resistanceRatio=0),["cube","coverflow","flip"].indexOf(x.params.effect)>=0&&(x.support.transforms3d?(x.params.watchSlidesProgress=!0,x.classNames.push(x.params.containerModifierClass+"3d")):x.params.effect="slide"),"slide"!==x.params.effect&&x.classNames.push(x.params.containerModifierClass+x.params.effect),"cube"===x.params.effect&&(x.params.resistanceRatio=0,x.params.slidesPerView=1,x.params.slidesPerColumn=1,x.params.slidesPerGroup=1,x.params.centeredSlides=!1,x.params.spaceBetween=0,x.params.virtualTranslate=!0),"fade"!==x.params.effect&&"flip"!==x.params.effect||(x.params.slidesPerView=1,x.params.slidesPerColumn=1,x.params.slidesPerGroup=1,x.params.watchSlidesProgress=!0,x.params.spaceBetween=0,void 0===g&&(x.params.virtualTranslate=!0)),x.params.grabCursor&&x.support.touch&&(x.params.grabCursor=!1),x.wrapper=x.container.children("."+x.params.wrapperClass),x.params.pagination&&(x.paginationContainer=e(x.params.pagination),x.params.uniqueNavElements&&"string"==typeof x.params.pagination&&x.paginationContainer.length>1&&1===x.container.find(x.params.pagination).length&&(x.paginationContainer=x.container.find(x.params.pagination)),"bullets"===x.params.paginationType&&x.params.paginationClickable?x.paginationContainer.addClass(x.params.paginationModifierClass+"clickable"):x.params.paginationClickable=!1,x.paginationContainer.addClass(x.params.paginationModifierClass+x.params.paginationType)),(x.params.nextButton||x.params.prevButton)&&(x.params.nextButton&&(x.nextButton=e(x.params.nextButton),x.params.uniqueNavElements&&"string"==typeof x.params.nextButton&&x.nextButton.length>1&&1===x.container.find(x.params.nextButton).length&&(x.nextButton=x.container.find(x.params.nextButton))),x.params.prevButton&&(x.prevButton=e(x.params.prevButton),x.params.uniqueNavElements&&"string"==typeof x.params.prevButton&&x.prevButton.length>1&&1===x.container.find(x.params.prevButton).length&&(x.prevButton=x.container.find(x.params.prevButton)))),x.isHorizontal=function(){return"horizontal"===x.params.direction},x.rtl=x.isHorizontal()&&("rtl"===x.container[0].dir.toLowerCase()||"rtl"===x.container.css("direction")),x.rtl&&x.classNames.push(x.params.containerModifierClass+"rtl"),x.rtl&&(x.wrongRTL="-webkit-box"===x.wrapper.css("display")),x.params.slidesPerColumn>1&&x.classNames.push(x.params.containerModifierClass+"multirow"),x.device.android&&x.classNames.push(x.params.containerModifierClass+"android"),x.container.addClass(x.classNames.join(" ")),x.translate=0,x.progress=0,x.velocity=0,x.lockSwipeToNext=function(){x.params.allowSwipeToNext=!1,x.params.allowSwipeToPrev===!1&&x.params.grabCursor&&x.unsetGrabCursor()},x.lockSwipeToPrev=function(){x.params.allowSwipeToPrev=!1,x.params.allowSwipeToNext===!1&&x.params.grabCursor&&x.unsetGrabCursor()},x.lockSwipes=function(){x.params.allowSwipeToNext=x.params.allowSwipeToPrev=!1,x.params.grabCursor&&x.unsetGrabCursor()},x.unlockSwipeToNext=function(){x.params.allowSwipeToNext=!0,x.params.allowSwipeToPrev===!0&&x.params.grabCursor&&x.setGrabCursor()},x.unlockSwipeToPrev=function(){x.params.allowSwipeToPrev=!0,x.params.allowSwipeToNext===!0&&x.params.grabCursor&&x.setGrabCursor()},x.unlockSwipes=function(){x.params.allowSwipeToNext=x.params.allowSwipeToPrev=!0,x.params.grabCursor&&x.setGrabCursor()},x.setGrabCursor=function(e){x.container[0].style.cursor="move",x.container[0].style.cursor=e?"-webkit-grabbing":"-webkit-grab",x.container[0].style.cursor=e?"-moz-grabbin":"-moz-grab",x.container[0].style.cursor=e?"grabbing":"grab"},x.unsetGrabCursor=function(){x.container[0].style.cursor=""},x.params.grabCursor&&x.setGrabCursor(),x.imagesToLoad=[],x.imagesLoaded=0,x.loadImage=function(e,a,t,s,r,i){function n(){i&&i()}var o;e.complete&&r?n():a?(o=new window.Image,o.onload=n,o.onerror=n,s&&(o.sizes=s),t&&(o.srcset=t),a&&(o.src=a)):n()},x.preloadImages=function(){function e(){void 0!==x&&null!==x&&x&&(void 0!==x.imagesLoaded&&x.imagesLoaded++,x.imagesLoaded===x.imagesToLoad.length&&(x.params.updateOnImagesReady&&x.update(),x.emit("onImagesReady",x)))}x.imagesToLoad=x.container.find("img");for(var a=0;a<x.imagesToLoad.length;a++)x.loadImage(x.imagesToLoad[a],x.imagesToLoad[a].currentSrc||x.imagesToLoad[a].getAttribute("src"),x.imagesToLoad[a].srcset||x.imagesToLoad[a].getAttribute("srcset"),x.imagesToLoad[a].sizes||x.imagesToLoad[a].getAttribute("sizes"),!0,e)},x.autoplayTimeoutId=void 0,x.autoplaying=!1,x.autoplayPaused=!1,x.startAutoplay=function(){return void 0===x.autoplayTimeoutId&&(!!x.params.autoplay&&(!x.autoplaying&&(x.autoplaying=!0,x.emit("onAutoplayStart",x),void i())))},x.stopAutoplay=function(e){x.autoplayTimeoutId&&(x.autoplayTimeoutId&&clearTimeout(x.autoplayTimeoutId),x.autoplaying=!1,x.autoplayTimeoutId=void 0,x.emit("onAutoplayStop",x))},x.pauseAutoplay=function(e){x.autoplayPaused||(x.autoplayTimeoutId&&clearTimeout(x.autoplayTimeoutId),x.autoplayPaused=!0,0===e?(x.autoplayPaused=!1,i()):x.wrapper.transitionEnd(function(){x&&(x.autoplayPaused=!1,x.autoplaying?i():x.stopAutoplay())}))},x.minTranslate=function(){return-x.snapGrid[0]},x.maxTranslate=function(){return-x.snapGrid[x.snapGrid.length-1]},x.updateAutoHeight=function(){var e,a=[],t=0;if("auto"!==x.params.slidesPerView&&x.params.slidesPerView>1)for(e=0;e<Math.ceil(x.params.slidesPerView);e++){var s=x.activeIndex+e;if(s>x.slides.length)break;a.push(x.slides.eq(s)[0])}else a.push(x.slides.eq(x.activeIndex)[0]);for(e=0;e<a.length;e++)if(void 0!==a[e]){var r=a[e].offsetHeight;t=r>t?r:t}t&&x.wrapper.css("height",t+"px")},x.updateContainerSize=function(){var e,a;e=void 0!==x.params.width?x.params.width:x.container[0].clientWidth,a=void 0!==x.params.height?x.params.height:x.container[0].clientHeight,0===e&&x.isHorizontal()||0===a&&!x.isHorizontal()||(e=e-parseInt(x.container.css("padding-left"),10)-parseInt(x.container.css("padding-right"),10),a=a-parseInt(x.container.css("padding-top"),10)-parseInt(x.container.css("padding-bottom"),10),x.width=e,x.height=a,x.size=x.isHorizontal()?x.width:x.height)},x.updateSlidesSize=function(){x.slides=x.wrapper.children("."+x.params.slideClass),x.snapGrid=[],x.slidesGrid=[],x.slidesSizesGrid=[];var e,a=x.params.spaceBetween,t=-x.params.slidesOffsetBefore,s=0,i=0;if(void 0!==x.size){"string"==typeof a&&a.indexOf("%")>=0&&(a=parseFloat(a.replace("%",""))/100*x.size),x.virtualSize=-a,x.rtl?x.slides.css({marginLeft:"",marginTop:""}):x.slides.css({marginRight:"",marginBottom:""});var n;x.params.slidesPerColumn>1&&(n=Math.floor(x.slides.length/x.params.slidesPerColumn)===x.slides.length/x.params.slidesPerColumn?x.slides.length:Math.ceil(x.slides.length/x.params.slidesPerColumn)*x.params.slidesPerColumn,"auto"!==x.params.slidesPerView&&"row"===x.params.slidesPerColumnFill&&(n=Math.max(n,x.params.slidesPerView*x.params.slidesPerColumn)));var o,l=x.params.slidesPerColumn,p=n/l,d=p-(x.params.slidesPerColumn*p-x.slides.length);for(e=0;e<x.slides.length;e++){o=0;var m=x.slides.eq(e);if(x.params.slidesPerColumn>1){var u,c,g;"column"===x.params.slidesPerColumnFill?(c=Math.floor(e/l),g=e-c*l,(c>d||c===d&&g===l-1)&&++g>=l&&(g=0,c++),u=c+g*n/l,m.css({"-webkit-box-ordinal-group":u,"-moz-box-ordinal-group":u,"-ms-flex-order":u,"-webkit-order":u,order:u})):(g=Math.floor(e/p),c=e-g*p),m.css("margin-"+(x.isHorizontal()?"top":"left"),0!==g&&x.params.spaceBetween&&x.params.spaceBetween+"px").attr("data-swiper-column",c).attr("data-swiper-row",g)}"none"!==m.css("display")&&("auto"===x.params.slidesPerView?(o=x.isHorizontal()?m.outerWidth(!0):m.outerHeight(!0),x.params.roundLengths&&(o=r(o))):(o=(x.size-(x.params.slidesPerView-1)*a)/x.params.slidesPerView,x.params.roundLengths&&(o=r(o)),x.isHorizontal()?x.slides[e].style.width=o+"px":x.slides[e].style.height=o+"px"),x.slides[e].swiperSlideSize=o,x.slidesSizesGrid.push(o),x.params.centeredSlides?(t=t+o/2+s/2+a,0===s&&0!==e&&(t=t-x.size/2-a),0===e&&(t=t-x.size/2-a),Math.abs(t)<.001&&(t=0),i%x.params.slidesPerGroup==0&&x.snapGrid.push(t),x.slidesGrid.push(t)):(i%x.params.slidesPerGroup==0&&x.snapGrid.push(t),x.slidesGrid.push(t),t=t+o+a),x.virtualSize+=o+a,s=o,i++)}x.virtualSize=Math.max(x.virtualSize,x.size)+x.params.slidesOffsetAfter;var h;if(x.rtl&&x.wrongRTL&&("slide"===x.params.effect||"coverflow"===x.params.effect)&&x.wrapper.css({width:x.virtualSize+x.params.spaceBetween+"px"}),x.support.flexbox&&!x.params.setWrapperSize||(x.isHorizontal()?x.wrapper.css({width:x.virtualSize+x.params.spaceBetween+"px"}):x.wrapper.css({height:x.virtualSize+x.params.spaceBetween+"px"})),x.params.slidesPerColumn>1&&(x.virtualSize=(o+x.params.spaceBetween)*n,x.virtualSize=Math.ceil(x.virtualSize/x.params.slidesPerColumn)-x.params.spaceBetween,x.isHorizontal()?x.wrapper.css({width:x.virtualSize+x.params.spaceBetween+"px"}):x.wrapper.css({height:x.virtualSize+x.params.spaceBetween+"px"}),x.params.centeredSlides)){for(h=[],e=0;e<x.snapGrid.length;e++)x.snapGrid[e]<x.virtualSize+x.snapGrid[0]&&h.push(x.snapGrid[e]);x.snapGrid=h}if(!x.params.centeredSlides){for(h=[],e=0;e<x.snapGrid.length;e++)x.snapGrid[e]<=x.virtualSize-x.size&&h.push(x.snapGrid[e]);x.snapGrid=h,Math.floor(x.virtualSize-x.size)-Math.floor(x.snapGrid[x.snapGrid.length-1])>1&&x.snapGrid.push(x.virtualSize-x.size)}0===x.snapGrid.length&&(x.snapGrid=[0]),0!==x.params.spaceBetween&&(x.isHorizontal()?x.rtl?x.slides.css({marginLeft:a+"px"}):x.slides.css({marginRight:a+"px"}):x.slides.css({marginBottom:a+"px"})),x.params.watchSlidesProgress&&x.updateSlidesOffset()}},x.updateSlidesOffset=function(){for(var e=0;e<x.slides.length;e++)x.slides[e].swiperSlideOffset=x.isHorizontal()?x.slides[e].offsetLeft:x.slides[e].offsetTop},x.currentSlidesPerView=function(){var e,a,t=1;if(x.params.centeredSlides){var s,r=x.slides[x.activeIndex].swiperSlideSize;for(e=x.activeIndex+1;e<x.slides.length;e++)x.slides[e]&&!s&&(r+=x.slides[e].swiperSlideSize,t++,r>x.size&&(s=!0));for(a=x.activeIndex-1;a>=0;a--)x.slides[a]&&!s&&(r+=x.slides[a].swiperSlideSize,t++,r>x.size&&(s=!0))}else for(e=x.activeIndex+1;e<x.slides.length;e++)x.slidesGrid[e]-x.slidesGrid[x.activeIndex]<x.size&&t++;return t},x.updateSlidesProgress=function(e){if(void 0===e&&(e=x.translate||0),0!==x.slides.length){void 0===x.slides[0].swiperSlideOffset&&x.updateSlidesOffset();var a=-e;x.rtl&&(a=e),x.slides.removeClass(x.params.slideVisibleClass);for(var t=0;t<x.slides.length;t++){var s=x.slides[t],r=(a+(x.params.centeredSlides?x.minTranslate():0)-s.swiperSlideOffset)/(s.swiperSlideSize+x.params.spaceBetween);if(x.params.watchSlidesVisibility){var i=-(a-s.swiperSlideOffset),n=i+x.slidesSizesGrid[t];(i>=0&&i<x.size||n>0&&n<=x.size||i<=0&&n>=x.size)&&x.slides.eq(t).addClass(x.params.slideVisibleClass)}s.progress=x.rtl?-r:r}}},x.updateProgress=function(e){void 0===e&&(e=x.translate||0);var a=x.maxTranslate()-x.minTranslate(),t=x.isBeginning,s=x.isEnd;0===a?(x.progress=0,x.isBeginning=x.isEnd=!0):(x.progress=(e-x.minTranslate())/a,x.isBeginning=x.progress<=0,x.isEnd=x.progress>=1),x.isBeginning&&!t&&x.emit("onReachBeginning",x),x.isEnd&&!s&&x.emit("onReachEnd",x),x.params.watchSlidesProgress&&x.updateSlidesProgress(e),x.emit("onProgress",x,x.progress)},x.updateActiveIndex=function(){var e,a,t,s=x.rtl?x.translate:-x.translate;for(a=0;a<x.slidesGrid.length;a++)void 0!==x.slidesGrid[a+1]?s>=x.slidesGrid[a]&&s<x.slidesGrid[a+1]-(x.slidesGrid[a+1]-x.slidesGrid[a])/2?e=a:s>=x.slidesGrid[a]&&s<x.slidesGrid[a+1]&&(e=a+1):s>=x.slidesGrid[a]&&(e=a);x.params.normalizeSlideIndex&&(e<0||void 0===e)&&(e=0),t=Math.floor(e/x.params.slidesPerGroup),t>=x.snapGrid.length&&(t=x.snapGrid.length-1),e!==x.activeIndex&&(x.snapIndex=t,x.previousIndex=x.activeIndex,x.activeIndex=e,x.updateClasses(),x.updateRealIndex())},x.updateRealIndex=function(){x.realIndex=parseInt(x.slides.eq(x.activeIndex).attr("data-swiper-slide-index")||x.activeIndex,10)},x.updateClasses=function(){x.slides.removeClass(x.params.slideActiveClass+" "+x.params.slideNextClass+" "+x.params.slidePrevClass+" "+x.params.slideDuplicateActiveClass+" "+x.params.slideDuplicateNextClass+" "+x.params.slideDuplicatePrevClass);var a=x.slides.eq(x.activeIndex);a.addClass(x.params.slideActiveClass),s.loop&&(a.hasClass(x.params.slideDuplicateClass)?x.wrapper.children("."+x.params.slideClass+":not(."+x.params.slideDuplicateClass+')[data-swiper-slide-index="'+x.realIndex+'"]').addClass(x.params.slideDuplicateActiveClass):x.wrapper.children("."+x.params.slideClass+"."+x.params.slideDuplicateClass+'[data-swiper-slide-index="'+x.realIndex+'"]').addClass(x.params.slideDuplicateActiveClass));var t=a.next("."+x.params.slideClass).addClass(x.params.slideNextClass);x.params.loop&&0===t.length&&(t=x.slides.eq(0),t.addClass(x.params.slideNextClass));var r=a.prev("."+x.params.slideClass).addClass(x.params.slidePrevClass);if(x.params.loop&&0===r.length&&(r=x.slides.eq(-1),r.addClass(x.params.slidePrevClass)),s.loop&&(t.hasClass(x.params.slideDuplicateClass)?x.wrapper.children("."+x.params.slideClass+":not(."+x.params.slideDuplicateClass+')[data-swiper-slide-index="'+t.attr("data-swiper-slide-index")+'"]').addClass(x.params.slideDuplicateNextClass):x.wrapper.children("."+x.params.slideClass+"."+x.params.slideDuplicateClass+'[data-swiper-slide-index="'+t.attr("data-swiper-slide-index")+'"]').addClass(x.params.slideDuplicateNextClass),r.hasClass(x.params.slideDuplicateClass)?x.wrapper.children("."+x.params.slideClass+":not(."+x.params.slideDuplicateClass+')[data-swiper-slide-index="'+r.attr("data-swiper-slide-index")+'"]').addClass(x.params.slideDuplicatePrevClass):x.wrapper.children("."+x.params.slideClass+"."+x.params.slideDuplicateClass+'[data-swiper-slide-index="'+r.attr("data-swiper-slide-index")+'"]').addClass(x.params.slideDuplicatePrevClass)),x.paginationContainer&&x.paginationContainer.length>0){var i,n=x.params.loop?Math.ceil((x.slides.length-2*x.loopedSlides)/x.params.slidesPerGroup):x.snapGrid.length;if(x.params.loop?(i=Math.ceil((x.activeIndex-x.loopedSlides)/x.params.slidesPerGroup),i>x.slides.length-1-2*x.loopedSlides&&(i-=x.slides.length-2*x.loopedSlides),i>n-1&&(i-=n),i<0&&"bullets"!==x.params.paginationType&&(i=n+i)):i=void 0!==x.snapIndex?x.snapIndex:x.activeIndex||0,"bullets"===x.params.paginationType&&x.bullets&&x.bullets.length>0&&(x.bullets.removeClass(x.params.bulletActiveClass),x.paginationContainer.length>1?x.bullets.each(function(){e(this).index()===i&&e(this).addClass(x.params.bulletActiveClass)}):x.bullets.eq(i).addClass(x.params.bulletActiveClass)),"fraction"===x.params.paginationType&&(x.paginationContainer.find("."+x.params.paginationCurrentClass).text(i+1),x.paginationContainer.find("."+x.params.paginationTotalClass).text(n)),"progress"===x.params.paginationType){var o=(i+1)/n,l=o,p=1;x.isHorizontal()||(p=o,l=1),x.paginationContainer.find("."+x.params.paginationProgressbarClass).transform("translate3d(0,0,0) scaleX("+l+") scaleY("+p+")").transition(x.params.speed)}"custom"===x.params.paginationType&&x.params.paginationCustomRender&&(x.paginationContainer.html(x.params.paginationCustomRender(x,i+1,n)),x.emit("onPaginationRendered",x,x.paginationContainer[0]))}x.params.loop||(x.params.prevButton&&x.prevButton&&x.prevButton.length>0&&(x.isBeginning?(x.prevButton.addClass(x.params.buttonDisabledClass),x.params.a11y&&x.a11y&&x.a11y.disable(x.prevButton)):(x.prevButton.removeClass(x.params.buttonDisabledClass),x.params.a11y&&x.a11y&&x.a11y.enable(x.prevButton))),x.params.nextButton&&x.nextButton&&x.nextButton.length>0&&(x.isEnd?(x.nextButton.addClass(x.params.buttonDisabledClass),x.params.a11y&&x.a11y&&x.a11y.disable(x.nextButton)):(x.nextButton.removeClass(x.params.buttonDisabledClass),x.params.a11y&&x.a11y&&x.a11y.enable(x.nextButton))))},x.updatePagination=function(){if(x.params.pagination&&x.paginationContainer&&x.paginationContainer.length>0){var e="";if("bullets"===x.params.paginationType){for(var a=x.params.loop?Math.ceil((x.slides.length-2*x.loopedSlides)/x.params.slidesPerGroup):x.snapGrid.length,t=0;t<a;t++)e+=x.params.paginationBulletRender?x.params.paginationBulletRender(x,t,x.params.bulletClass):"<"+x.params.paginationElement+' class="'+x.params.bulletClass+'"></'+x.params.paginationElement+">";x.paginationContainer.html(e),x.bullets=x.paginationContainer.find("."+x.params.bulletClass),x.params.paginationClickable&&x.params.a11y&&x.a11y&&x.a11y.initPagination()}"fraction"===x.params.paginationType&&(e=x.params.paginationFractionRender?x.params.paginationFractionRender(x,x.params.paginationCurrentClass,x.params.paginationTotalClass):'<span class="'+x.params.paginationCurrentClass+'"></span> / <span class="'+x.params.paginationTotalClass+'"></span>',x.paginationContainer.html(e)),"progress"===x.params.paginationType&&(e=x.params.paginationProgressRender?x.params.paginationProgressRender(x,x.params.paginationProgressbarClass):'<span class="'+x.params.paginationProgressbarClass+'"></span>',x.paginationContainer.html(e)),"custom"!==x.params.paginationType&&x.emit("onPaginationRendered",x,x.paginationContainer[0])}},x.update=function(e){function a(){x.rtl,x.translate;t=Math.min(Math.max(x.translate,x.maxTranslate()),x.minTranslate()),x.setWrapperTranslate(t),x.updateActiveIndex(),x.updateClasses()}if(x){x.updateContainerSize(),x.updateSlidesSize(),x.updateProgress(),x.updatePagination(),x.updateClasses(),x.params.scrollbar&&x.scrollbar&&x.scrollbar.set();var t;if(e){x.controller&&x.controller.spline&&(x.controller.spline=void 0),x.params.freeMode?(a(),x.params.autoHeight&&x.updateAutoHeight()):(("auto"===x.params.slidesPerView||x.params.slidesPerView>1)&&x.isEnd&&!x.params.centeredSlides?x.slideTo(x.slides.length-1,0,!1,!0):x.slideTo(x.activeIndex,0,!1,!0))||a()}else x.params.autoHeight&&x.updateAutoHeight()}},x.onResize=function(e){x.params.onBeforeResize&&x.params.onBeforeResize(x),x.params.breakpoints&&x.setBreakpoint();var a=x.params.allowSwipeToPrev,t=x.params.allowSwipeToNext;x.params.allowSwipeToPrev=x.params.allowSwipeToNext=!0,x.updateContainerSize(),x.updateSlidesSize(),("auto"===x.params.slidesPerView||x.params.freeMode||e)&&x.updatePagination(),x.params.scrollbar&&x.scrollbar&&x.scrollbar.set(),x.controller&&x.controller.spline&&(x.controller.spline=void 0);var s=!1;if(x.params.freeMode){var r=Math.min(Math.max(x.translate,x.maxTranslate()),x.minTranslate());x.setWrapperTranslate(r),x.updateActiveIndex(),x.updateClasses(),x.params.autoHeight&&x.updateAutoHeight()}else x.updateClasses(),s=("auto"===x.params.slidesPerView||x.params.slidesPerView>1)&&x.isEnd&&!x.params.centeredSlides?x.slideTo(x.slides.length-1,0,!1,!0):x.slideTo(x.activeIndex,0,!1,!0);x.params.lazyLoading&&!s&&x.lazy&&x.lazy.load(),x.params.allowSwipeToPrev=a,x.params.allowSwipeToNext=t,x.params.onAfterResize&&x.params.onAfterResize(x)},x.touchEventsDesktop={start:"mousedown",move:"mousemove",end:"mouseup"},window.navigator.pointerEnabled?x.touchEventsDesktop={start:"pointerdown",move:"pointermove",end:"pointerup"}:window.navigator.msPointerEnabled&&(x.touchEventsDesktop={start:"MSPointerDown",move:"MSPointerMove",end:"MSPointerUp"}),x.touchEvents={start:x.support.touch||!x.params.simulateTouch?"touchstart":x.touchEventsDesktop.start,move:x.support.touch||!x.params.simulateTouch?"touchmove":x.touchEventsDesktop.move,end:x.support.touch||!x.params.simulateTouch?"touchend":x.touchEventsDesktop.end},(window.navigator.pointerEnabled||window.navigator.msPointerEnabled)&&("container"===x.params.touchEventsTarget?x.container:x.wrapper).addClass("swiper-wp8-"+x.params.direction),x.initEvents=function(e){var a=e?"off":"on",t=e?"removeEventListener":"addEventListener",r="container"===x.params.touchEventsTarget?x.container[0]:x.wrapper[0],i=x.support.touch?r:document,n=!!x.params.nested;if(x.browser.ie)r[t](x.touchEvents.start,x.onTouchStart,!1),i[t](x.touchEvents.move,x.onTouchMove,n),i[t](x.touchEvents.end,x.onTouchEnd,!1);else{if(x.support.touch){var o=!("touchstart"!==x.touchEvents.start||!x.support.passiveListener||!x.params.passiveListeners)&&{passive:!0,capture:!1};r[t](x.touchEvents.start,x.onTouchStart,o),r[t](x.touchEvents.move,x.onTouchMove,n),r[t](x.touchEvents.end,x.onTouchEnd,o)}(s.simulateTouch&&!x.device.ios&&!x.device.android||s.simulateTouch&&!x.support.touch&&x.device.ios)&&(r[t]("mousedown",x.onTouchStart,!1),document[t]("mousemove",x.onTouchMove,n),document[t]("mouseup",x.onTouchEnd,!1))}window[t]("resize",x.onResize),x.params.nextButton&&x.nextButton&&x.nextButton.length>0&&(x.nextButton[a]("click",x.onClickNext),x.params.a11y&&x.a11y&&x.nextButton[a]("keydown",x.a11y.onEnterKey)),x.params.prevButton&&x.prevButton&&x.prevButton.length>0&&(x.prevButton[a]("click",x.onClickPrev),x.params.a11y&&x.a11y&&x.prevButton[a]("keydown",x.a11y.onEnterKey)),x.params.pagination&&x.params.paginationClickable&&(x.paginationContainer[a]("click","."+x.params.bulletClass,x.onClickIndex),x.params.a11y&&x.a11y&&x.paginationContainer[a]("keydown","."+x.params.bulletClass,x.a11y.onEnterKey)),(x.params.preventClicks||x.params.preventClicksPropagation)&&r[t]("click",x.preventClicks,!0)},x.attachEvents=function(){x.initEvents()},x.detachEvents=function(){x.initEvents(!0)},x.allowClick=!0,x.preventClicks=function(e){x.allowClick||(x.params.preventClicks&&e.preventDefault(),x.params.preventClicksPropagation&&x.animating&&(e.stopPropagation(),e.stopImmediatePropagation()))},x.onClickNext=function(e){e.preventDefault(),x.isEnd&&!x.params.loop||x.slideNext()},x.onClickPrev=function(e){e.preventDefault(),x.isBeginning&&!x.params.loop||x.slidePrev()},x.onClickIndex=function(a){a.preventDefault();var t=e(this).index()*x.params.slidesPerGroup
;x.params.loop&&(t+=x.loopedSlides),x.slideTo(t)},x.updateClickedSlide=function(a){var t=n(a,"."+x.params.slideClass),s=!1;if(t)for(var r=0;r<x.slides.length;r++)x.slides[r]===t&&(s=!0);if(!t||!s)return x.clickedSlide=void 0,void(x.clickedIndex=void 0);if(x.clickedSlide=t,x.clickedIndex=e(t).index(),x.params.slideToClickedSlide&&void 0!==x.clickedIndex&&x.clickedIndex!==x.activeIndex){var i,o=x.clickedIndex,l="auto"===x.params.slidesPerView?x.currentSlidesPerView():x.params.slidesPerView;if(x.params.loop){if(x.animating)return;i=parseInt(e(x.clickedSlide).attr("data-swiper-slide-index"),10),x.params.centeredSlides?o<x.loopedSlides-l/2||o>x.slides.length-x.loopedSlides+l/2?(x.fixLoop(),o=x.wrapper.children("."+x.params.slideClass+'[data-swiper-slide-index="'+i+'"]:not(.'+x.params.slideDuplicateClass+")").eq(0).index(),setTimeout(function(){x.slideTo(o)},0)):x.slideTo(o):o>x.slides.length-l?(x.fixLoop(),o=x.wrapper.children("."+x.params.slideClass+'[data-swiper-slide-index="'+i+'"]:not(.'+x.params.slideDuplicateClass+")").eq(0).index(),setTimeout(function(){x.slideTo(o)},0)):x.slideTo(o)}else x.slideTo(o)}};var b,C,S,z,M,P,E,I,k,D,L="input, select, textarea, button, video",B=Date.now(),H=[];x.animating=!1,x.touches={startX:0,startY:0,currentX:0,currentY:0,diff:0};var G,X;x.onTouchStart=function(a){if(a.originalEvent&&(a=a.originalEvent),(G="touchstart"===a.type)||!("which"in a)||3!==a.which){if(x.params.noSwiping&&n(a,"."+x.params.noSwipingClass))return void(x.allowClick=!0);if(!x.params.swipeHandler||n(a,x.params.swipeHandler)){var t=x.touches.currentX="touchstart"===a.type?a.targetTouches[0].pageX:a.pageX,s=x.touches.currentY="touchstart"===a.type?a.targetTouches[0].pageY:a.pageY;if(!(x.device.ios&&x.params.iOSEdgeSwipeDetection&&t<=x.params.iOSEdgeSwipeThreshold)){if(b=!0,C=!1,S=!0,M=void 0,X=void 0,x.touches.startX=t,x.touches.startY=s,z=Date.now(),x.allowClick=!0,x.updateContainerSize(),x.swipeDirection=void 0,x.params.threshold>0&&(I=!1),"touchstart"!==a.type){var r=!0;e(a.target).is(L)&&(r=!1),document.activeElement&&e(document.activeElement).is(L)&&document.activeElement.blur(),r&&a.preventDefault()}x.emit("onTouchStart",x,a)}}}},x.onTouchMove=function(a){if(a.originalEvent&&(a=a.originalEvent),!G||"mousemove"!==a.type){if(a.preventedByNestedSwiper)return x.touches.startX="touchmove"===a.type?a.targetTouches[0].pageX:a.pageX,void(x.touches.startY="touchmove"===a.type?a.targetTouches[0].pageY:a.pageY);if(x.params.onlyExternal)return x.allowClick=!1,void(b&&(x.touches.startX=x.touches.currentX="touchmove"===a.type?a.targetTouches[0].pageX:a.pageX,x.touches.startY=x.touches.currentY="touchmove"===a.type?a.targetTouches[0].pageY:a.pageY,z=Date.now()));if(G&&x.params.touchReleaseOnEdges&&!x.params.loop)if(x.isHorizontal()){if(x.touches.currentX<x.touches.startX&&x.translate<=x.maxTranslate()||x.touches.currentX>x.touches.startX&&x.translate>=x.minTranslate())return}else if(x.touches.currentY<x.touches.startY&&x.translate<=x.maxTranslate()||x.touches.currentY>x.touches.startY&&x.translate>=x.minTranslate())return;if(G&&document.activeElement&&a.target===document.activeElement&&e(a.target).is(L))return C=!0,void(x.allowClick=!1);if(S&&x.emit("onTouchMove",x,a),!(a.targetTouches&&a.targetTouches.length>1)){if(x.touches.currentX="touchmove"===a.type?a.targetTouches[0].pageX:a.pageX,x.touches.currentY="touchmove"===a.type?a.targetTouches[0].pageY:a.pageY,void 0===M){var t;x.isHorizontal()&&x.touches.currentY===x.touches.startY||!x.isHorizontal()&&x.touches.currentX===x.touches.startX?M=!1:(t=180*Math.atan2(Math.abs(x.touches.currentY-x.touches.startY),Math.abs(x.touches.currentX-x.touches.startX))/Math.PI,M=x.isHorizontal()?t>x.params.touchAngle:90-t>x.params.touchAngle)}if(M&&x.emit("onTouchMoveOpposite",x,a),void 0===X&&(x.touches.currentX===x.touches.startX&&x.touches.currentY===x.touches.startY||(X=!0)),b){if(M)return void(b=!1);if(X){x.allowClick=!1,x.emit("onSliderMove",x,a),a.preventDefault(),x.params.touchMoveStopPropagation&&!x.params.nested&&a.stopPropagation(),C||(s.loop&&x.fixLoop(),E=x.getWrapperTranslate(),x.setWrapperTransition(0),x.animating&&x.wrapper.trigger("webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd"),x.params.autoplay&&x.autoplaying&&(x.params.autoplayDisableOnInteraction?x.stopAutoplay():x.pauseAutoplay()),D=!1,!x.params.grabCursor||x.params.allowSwipeToNext!==!0&&x.params.allowSwipeToPrev!==!0||x.setGrabCursor(!0)),C=!0;var r=x.touches.diff=x.isHorizontal()?x.touches.currentX-x.touches.startX:x.touches.currentY-x.touches.startY;r*=x.params.touchRatio,x.rtl&&(r=-r),x.swipeDirection=r>0?"prev":"next",P=r+E;var i=!0;if(r>0&&P>x.minTranslate()?(i=!1,x.params.resistance&&(P=x.minTranslate()-1+Math.pow(-x.minTranslate()+E+r,x.params.resistanceRatio))):r<0&&P<x.maxTranslate()&&(i=!1,x.params.resistance&&(P=x.maxTranslate()+1-Math.pow(x.maxTranslate()-E-r,x.params.resistanceRatio))),i&&(a.preventedByNestedSwiper=!0),!x.params.allowSwipeToNext&&"next"===x.swipeDirection&&P<E&&(P=E),!x.params.allowSwipeToPrev&&"prev"===x.swipeDirection&&P>E&&(P=E),x.params.threshold>0){if(!(Math.abs(r)>x.params.threshold||I))return void(P=E);if(!I)return I=!0,x.touches.startX=x.touches.currentX,x.touches.startY=x.touches.currentY,P=E,void(x.touches.diff=x.isHorizontal()?x.touches.currentX-x.touches.startX:x.touches.currentY-x.touches.startY)}x.params.followFinger&&((x.params.freeMode||x.params.watchSlidesProgress)&&x.updateActiveIndex(),x.params.freeMode&&(0===H.length&&H.push({position:x.touches[x.isHorizontal()?"startX":"startY"],time:z}),H.push({position:x.touches[x.isHorizontal()?"currentX":"currentY"],time:(new window.Date).getTime()})),x.updateProgress(P),x.setWrapperTranslate(P))}}}}},x.onTouchEnd=function(a){if(a.originalEvent&&(a=a.originalEvent),S&&x.emit("onTouchEnd",x,a),S=!1,b){x.params.grabCursor&&C&&b&&(x.params.allowSwipeToNext===!0||x.params.allowSwipeToPrev===!0)&&x.setGrabCursor(!1);var t=Date.now(),s=t-z;if(x.allowClick&&(x.updateClickedSlide(a),x.emit("onTap",x,a),s<300&&t-B>300&&(k&&clearTimeout(k),k=setTimeout(function(){x&&(x.params.paginationHide&&x.paginationContainer.length>0&&!e(a.target).hasClass(x.params.bulletClass)&&x.paginationContainer.toggleClass(x.params.paginationHiddenClass),x.emit("onClick",x,a))},300)),s<300&&t-B<300&&(k&&clearTimeout(k),x.emit("onDoubleTap",x,a))),B=Date.now(),setTimeout(function(){x&&(x.allowClick=!0)},0),!b||!C||!x.swipeDirection||0===x.touches.diff||P===E)return void(b=C=!1);b=C=!1;var r;if(r=x.params.followFinger?x.rtl?x.translate:-x.translate:-P,x.params.freeMode){if(r<-x.minTranslate())return void x.slideTo(x.activeIndex);if(r>-x.maxTranslate())return void(x.slides.length<x.snapGrid.length?x.slideTo(x.snapGrid.length-1):x.slideTo(x.slides.length-1));if(x.params.freeModeMomentum){if(H.length>1){var i=H.pop(),n=H.pop(),o=i.position-n.position,l=i.time-n.time;x.velocity=o/l,x.velocity=x.velocity/2,Math.abs(x.velocity)<x.params.freeModeMinimumVelocity&&(x.velocity=0),(l>150||(new window.Date).getTime()-i.time>300)&&(x.velocity=0)}else x.velocity=0;x.velocity=x.velocity*x.params.freeModeMomentumVelocityRatio,H.length=0;var p=1e3*x.params.freeModeMomentumRatio,d=x.velocity*p,m=x.translate+d;x.rtl&&(m=-m);var u,c=!1,g=20*Math.abs(x.velocity)*x.params.freeModeMomentumBounceRatio;if(m<x.maxTranslate())x.params.freeModeMomentumBounce?(m+x.maxTranslate()<-g&&(m=x.maxTranslate()-g),u=x.maxTranslate(),c=!0,D=!0):m=x.maxTranslate();else if(m>x.minTranslate())x.params.freeModeMomentumBounce?(m-x.minTranslate()>g&&(m=x.minTranslate()+g),u=x.minTranslate(),c=!0,D=!0):m=x.minTranslate();else if(x.params.freeModeSticky){var h,v=0;for(v=0;v<x.snapGrid.length;v+=1)if(x.snapGrid[v]>-m){h=v;break}m=Math.abs(x.snapGrid[h]-m)<Math.abs(x.snapGrid[h-1]-m)||"next"===x.swipeDirection?x.snapGrid[h]:x.snapGrid[h-1],x.rtl||(m=-m)}if(0!==x.velocity)p=x.rtl?Math.abs((-m-x.translate)/x.velocity):Math.abs((m-x.translate)/x.velocity);else if(x.params.freeModeSticky)return void x.slideReset();x.params.freeModeMomentumBounce&&c?(x.updateProgress(u),x.setWrapperTransition(p),x.setWrapperTranslate(m),x.onTransitionStart(),x.animating=!0,x.wrapper.transitionEnd(function(){x&&D&&(x.emit("onMomentumBounce",x),x.setWrapperTransition(x.params.speed),x.setWrapperTranslate(u),x.wrapper.transitionEnd(function(){x&&x.onTransitionEnd()}))})):x.velocity?(x.updateProgress(m),x.setWrapperTransition(p),x.setWrapperTranslate(m),x.onTransitionStart(),x.animating||(x.animating=!0,x.wrapper.transitionEnd(function(){x&&x.onTransitionEnd()}))):x.updateProgress(m),x.updateActiveIndex()}return void((!x.params.freeModeMomentum||s>=x.params.longSwipesMs)&&(x.updateProgress(),x.updateActiveIndex()))}var f,w=0,y=x.slidesSizesGrid[0];for(f=0;f<x.slidesGrid.length;f+=x.params.slidesPerGroup)void 0!==x.slidesGrid[f+x.params.slidesPerGroup]?r>=x.slidesGrid[f]&&r<x.slidesGrid[f+x.params.slidesPerGroup]&&(w=f,y=x.slidesGrid[f+x.params.slidesPerGroup]-x.slidesGrid[f]):r>=x.slidesGrid[f]&&(w=f,y=x.slidesGrid[x.slidesGrid.length-1]-x.slidesGrid[x.slidesGrid.length-2]);var T=(r-x.slidesGrid[w])/y;if(s>x.params.longSwipesMs){if(!x.params.longSwipes)return void x.slideTo(x.activeIndex);"next"===x.swipeDirection&&(T>=x.params.longSwipesRatio?x.slideTo(w+x.params.slidesPerGroup):x.slideTo(w)),"prev"===x.swipeDirection&&(T>1-x.params.longSwipesRatio?x.slideTo(w+x.params.slidesPerGroup):x.slideTo(w))}else{if(!x.params.shortSwipes)return void x.slideTo(x.activeIndex);"next"===x.swipeDirection&&x.slideTo(w+x.params.slidesPerGroup),"prev"===x.swipeDirection&&x.slideTo(w)}}},x._slideTo=function(e,a){return x.slideTo(e,a,!0,!0)},x.slideTo=function(e,a,t,s){void 0===t&&(t=!0),void 0===e&&(e=0),e<0&&(e=0),x.snapIndex=Math.floor(e/x.params.slidesPerGroup),x.snapIndex>=x.snapGrid.length&&(x.snapIndex=x.snapGrid.length-1);var r=-x.snapGrid[x.snapIndex];if(x.params.autoplay&&x.autoplaying&&(s||!x.params.autoplayDisableOnInteraction?x.pauseAutoplay(a):x.stopAutoplay()),x.updateProgress(r),x.params.normalizeSlideIndex)for(var i=0;i<x.slidesGrid.length;i++)-Math.floor(100*r)>=Math.floor(100*x.slidesGrid[i])&&(e=i);return!(!x.params.allowSwipeToNext&&r<x.translate&&r<x.minTranslate())&&(!(!x.params.allowSwipeToPrev&&r>x.translate&&r>x.maxTranslate()&&(x.activeIndex||0)!==e)&&(void 0===a&&(a=x.params.speed),x.previousIndex=x.activeIndex||0,x.activeIndex=e,x.updateRealIndex(),x.rtl&&-r===x.translate||!x.rtl&&r===x.translate?(x.params.autoHeight&&x.updateAutoHeight(),x.updateClasses(),"slide"!==x.params.effect&&x.setWrapperTranslate(r),!1):(x.updateClasses(),x.onTransitionStart(t),0===a||x.browser.lteIE9?(x.setWrapperTranslate(r),x.setWrapperTransition(0),x.onTransitionEnd(t)):(x.setWrapperTranslate(r),x.setWrapperTransition(a),x.animating||(x.animating=!0,x.wrapper.transitionEnd(function(){x&&x.onTransitionEnd(t)}))),!0)))},x.onTransitionStart=function(e){void 0===e&&(e=!0),x.params.autoHeight&&x.updateAutoHeight(),x.lazy&&x.lazy.onTransitionStart(),e&&(x.emit("onTransitionStart",x),x.activeIndex!==x.previousIndex&&(x.emit("onSlideChangeStart",x),x.activeIndex>x.previousIndex?x.emit("onSlideNextStart",x):x.emit("onSlidePrevStart",x)))},x.onTransitionEnd=function(e){x.animating=!1,x.setWrapperTransition(0),void 0===e&&(e=!0),x.lazy&&x.lazy.onTransitionEnd(),e&&(x.emit("onTransitionEnd",x),x.activeIndex!==x.previousIndex&&(x.emit("onSlideChangeEnd",x),x.activeIndex>x.previousIndex?x.emit("onSlideNextEnd",x):x.emit("onSlidePrevEnd",x))),x.params.history&&x.history&&x.history.setHistory(x.params.history,x.activeIndex),x.params.hashnav&&x.hashnav&&x.hashnav.setHash()},x.slideNext=function(e,a,t){if(x.params.loop){if(x.animating)return!1;x.fixLoop();x.container[0].clientLeft;return x.slideTo(x.activeIndex+x.params.slidesPerGroup,a,e,t)}return x.slideTo(x.activeIndex+x.params.slidesPerGroup,a,e,t)},x._slideNext=function(e){return x.slideNext(!0,e,!0)},x.slidePrev=function(e,a,t){if(x.params.loop){if(x.animating)return!1;x.fixLoop();x.container[0].clientLeft;return x.slideTo(x.activeIndex-1,a,e,t)}return x.slideTo(x.activeIndex-1,a,e,t)},x._slidePrev=function(e){return x.slidePrev(!0,e,!0)},x.slideReset=function(e,a,t){return x.slideTo(x.activeIndex,a,e)},x.disableTouchControl=function(){return x.params.onlyExternal=!0,!0},x.enableTouchControl=function(){return x.params.onlyExternal=!1,!0},x.setWrapperTransition=function(e,a){x.wrapper.transition(e),"slide"!==x.params.effect&&x.effects[x.params.effect]&&x.effects[x.params.effect].setTransition(e),x.params.parallax&&x.parallax&&x.parallax.setTransition(e),x.params.scrollbar&&x.scrollbar&&x.scrollbar.setTransition(e),x.params.control&&x.controller&&x.controller.setTransition(e,a),x.emit("onSetTransition",x,e)},x.setWrapperTranslate=function(e,a,t){var s=0,i=0;x.isHorizontal()?s=x.rtl?-e:e:i=e,x.params.roundLengths&&(s=r(s),i=r(i)),x.params.virtualTranslate||(x.support.transforms3d?x.wrapper.transform("translate3d("+s+"px, "+i+"px, 0px)"):x.wrapper.transform("translate("+s+"px, "+i+"px)")),x.translate=x.isHorizontal()?s:i;var n,o=x.maxTranslate()-x.minTranslate();n=0===o?0:(e-x.minTranslate())/o,n!==x.progress&&x.updateProgress(e),a&&x.updateActiveIndex(),"slide"!==x.params.effect&&x.effects[x.params.effect]&&x.effects[x.params.effect].setTranslate(x.translate),x.params.parallax&&x.parallax&&x.parallax.setTranslate(x.translate),x.params.scrollbar&&x.scrollbar&&x.scrollbar.setTranslate(x.translate),x.params.control&&x.controller&&x.controller.setTranslate(x.translate,t),x.emit("onSetTranslate",x,x.translate)},x.getTranslate=function(e,a){var t,s,r,i;return void 0===a&&(a="x"),x.params.virtualTranslate?x.rtl?-x.translate:x.translate:(r=window.getComputedStyle(e,null),window.WebKitCSSMatrix?(s=r.transform||r.webkitTransform,s.split(",").length>6&&(s=s.split(", ").map(function(e){return e.replace(",",".")}).join(", ")),i=new window.WebKitCSSMatrix("none"===s?"":s)):(i=r.MozTransform||r.OTransform||r.MsTransform||r.msTransform||r.transform||r.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),t=i.toString().split(",")),"x"===a&&(s=window.WebKitCSSMatrix?i.m41:16===t.length?parseFloat(t[12]):parseFloat(t[4])),"y"===a&&(s=window.WebKitCSSMatrix?i.m42:16===t.length?parseFloat(t[13]):parseFloat(t[5])),x.rtl&&s&&(s=-s),s||0)},x.getWrapperTranslate=function(e){return void 0===e&&(e=x.isHorizontal()?"x":"y"),x.getTranslate(x.wrapper[0],e)},x.observers=[],x.initObservers=function(){if(x.params.observeParents)for(var e=x.container.parents(),a=0;a<e.length;a++)o(e[a]);o(x.container[0],{childList:!1}),o(x.wrapper[0],{attributes:!1})},x.disconnectObservers=function(){for(var e=0;e<x.observers.length;e++)x.observers[e].disconnect();x.observers=[]},x.createLoop=function(){x.wrapper.children("."+x.params.slideClass+"."+x.params.slideDuplicateClass).remove();var a=x.wrapper.children("."+x.params.slideClass);"auto"!==x.params.slidesPerView||x.params.loopedSlides||(x.params.loopedSlides=a.length),x.loopedSlides=parseInt(x.params.loopedSlides||x.params.slidesPerView,10),x.loopedSlides=x.loopedSlides+x.params.loopAdditionalSlides,x.loopedSlides>a.length&&(x.loopedSlides=a.length);var t,s=[],r=[];for(a.each(function(t,i){var n=e(this);t<x.loopedSlides&&r.push(i),t<a.length&&t>=a.length-x.loopedSlides&&s.push(i),n.attr("data-swiper-slide-index",t)}),t=0;t<r.length;t++)x.wrapper.append(e(r[t].cloneNode(!0)).addClass(x.params.slideDuplicateClass));for(t=s.length-1;t>=0;t--)x.wrapper.prepend(e(s[t].cloneNode(!0)).addClass(x.params.slideDuplicateClass))},x.destroyLoop=function(){x.wrapper.children("."+x.params.slideClass+"."+x.params.slideDuplicateClass).remove(),x.slides.removeAttr("data-swiper-slide-index")},x.reLoop=function(e){var a=x.activeIndex-x.loopedSlides;x.destroyLoop(),x.createLoop(),x.updateSlidesSize(),e&&x.slideTo(a+x.loopedSlides,0,!1)},x.fixLoop=function(){var e;x.activeIndex<x.loopedSlides?(e=x.slides.length-3*x.loopedSlides+x.activeIndex,e+=x.loopedSlides,x.slideTo(e,0,!1,!0)):("auto"===x.params.slidesPerView&&x.activeIndex>=2*x.loopedSlides||x.activeIndex>x.slides.length-2*x.params.slidesPerView)&&(e=-x.slides.length+x.activeIndex+x.loopedSlides,e+=x.loopedSlides,x.slideTo(e,0,!1,!0))},x.appendSlide=function(e){if(x.params.loop&&x.destroyLoop(),"object"==typeof e&&e.length)for(var a=0;a<e.length;a++)e[a]&&x.wrapper.append(e[a]);else x.wrapper.append(e);x.params.loop&&x.createLoop(),x.params.observer&&x.support.observer||x.update(!0)},x.prependSlide=function(e){x.params.loop&&x.destroyLoop();var a=x.activeIndex+1;if("object"==typeof e&&e.length){for(var t=0;t<e.length;t++)e[t]&&x.wrapper.prepend(e[t]);a=x.activeIndex+e.length}else x.wrapper.prepend(e);x.params.loop&&x.createLoop(),x.params.observer&&x.support.observer||x.update(!0),x.slideTo(a,0,!1)},x.removeSlide=function(e){x.params.loop&&(x.destroyLoop(),x.slides=x.wrapper.children("."+x.params.slideClass));var a,t=x.activeIndex;if("object"==typeof e&&e.length){for(var s=0;s<e.length;s++)a=e[s],x.slides[a]&&x.slides.eq(a).remove(),a<t&&t--;t=Math.max(t,0)}else a=e,x.slides[a]&&x.slides.eq(a).remove(),a<t&&t--,t=Math.max(t,0);x.params.loop&&x.createLoop(),x.params.observer&&x.support.observer||x.update(!0),x.params.loop?x.slideTo(t+x.loopedSlides,0,!1):x.slideTo(t,0,!1)},x.removeAllSlides=function(){for(var e=[],a=0;a<x.slides.length;a++)e.push(a);x.removeSlide(e)},x.effects={fade:{setTranslate:function(){for(var e=0;e<x.slides.length;e++){var a=x.slides.eq(e),t=a[0].swiperSlideOffset,s=-t;x.params.virtualTranslate||(s-=x.translate);var r=0;x.isHorizontal()||(r=s,s=0);var i=x.params.fade.crossFade?Math.max(1-Math.abs(a[0].progress),0):1+Math.min(Math.max(a[0].progress,-1),0);a.css({opacity:i}).transform("translate3d("+s+"px, "+r+"px, 0px)")}},setTransition:function(e){if(x.slides.transition(e),x.params.virtualTranslate&&0!==e){var a=!1;x.slides.transitionEnd(function(){if(!a&&x){a=!0,x.animating=!1;for(var e=["webkitTransitionEnd","transitionend","oTransitionEnd","MSTransitionEnd","msTransitionEnd"],t=0;t<e.length;t++)x.wrapper.trigger(e[t])}})}}},flip:{setTranslate:function(){for(var a=0;a<x.slides.length;a++){var t=x.slides.eq(a),s=t[0].progress;x.params.flip.limitRotation&&(s=Math.max(Math.min(t[0].progress,1),-1));var r=t[0].swiperSlideOffset,i=-180*s,n=i,o=0,l=-r,p=0;if(x.isHorizontal()?x.rtl&&(n=-n):(p=l,l=0,o=-n,n=0),t[0].style.zIndex=-Math.abs(Math.round(s))+x.slides.length,x.params.flip.slideShadows){var d=x.isHorizontal()?t.find(".swiper-slide-shadow-left"):t.find(".swiper-slide-shadow-top"),m=x.isHorizontal()?t.find(".swiper-slide-shadow-right"):t.find(".swiper-slide-shadow-bottom");0===d.length&&(d=e('<div class="swiper-slide-shadow-'+(x.isHorizontal()?"left":"top")+'"></div>'),t.append(d)),0===m.length&&(m=e('<div class="swiper-slide-shadow-'+(x.isHorizontal()?"right":"bottom")+'"></div>'),t.append(m)),d.length&&(d[0].style.opacity=Math.max(-s,0)),m.length&&(m[0].style.opacity=Math.max(s,0))}t.transform("translate3d("+l+"px, "+p+"px, 0px) rotateX("+o+"deg) rotateY("+n+"deg)")}},setTransition:function(a){if(x.slides.transition(a).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(a),x.params.virtualTranslate&&0!==a){var t=!1;x.slides.eq(x.activeIndex).transitionEnd(function(){if(!t&&x&&e(this).hasClass(x.params.slideActiveClass)){t=!0,x.animating=!1;for(var a=["webkitTransitionEnd","transitionend","oTransitionEnd","MSTransitionEnd","msTransitionEnd"],s=0;s<a.length;s++)x.wrapper.trigger(a[s])}})}}},cube:{setTranslate:function(){var a,t=0;x.params.cube.shadow&&(x.isHorizontal()?(a=x.wrapper.find(".swiper-cube-shadow"),0===a.length&&(a=e('<div class="swiper-cube-shadow"></div>'),x.wrapper.append(a)),a.css({height:x.width+"px"})):(a=x.container.find(".swiper-cube-shadow"),0===a.length&&(a=e('<div class="swiper-cube-shadow"></div>'),x.container.append(a))));for(var s=0;s<x.slides.length;s++){var r=x.slides.eq(s),i=90*s,n=Math.floor(i/360);x.rtl&&(i=-i,n=Math.floor(-i/360));var o=Math.max(Math.min(r[0].progress,1),-1),l=0,p=0,d=0;s%4==0?(l=4*-n*x.size,d=0):(s-1)%4==0?(l=0,d=4*-n*x.size):(s-2)%4==0?(l=x.size+4*n*x.size,d=x.size):(s-3)%4==0&&(l=-x.size,d=3*x.size+4*x.size*n),x.rtl&&(l=-l),x.isHorizontal()||(p=l,l=0);var m="rotateX("+(x.isHorizontal()?0:-i)+"deg) rotateY("+(x.isHorizontal()?i:0)+"deg) translate3d("+l+"px, "+p+"px, "+d+"px)";if(o<=1&&o>-1&&(t=90*s+90*o,x.rtl&&(t=90*-s-90*o)),r.transform(m),x.params.cube.slideShadows){var u=x.isHorizontal()?r.find(".swiper-slide-shadow-left"):r.find(".swiper-slide-shadow-top"),c=x.isHorizontal()?r.find(".swiper-slide-shadow-right"):r.find(".swiper-slide-shadow-bottom");0===u.length&&(u=e('<div class="swiper-slide-shadow-'+(x.isHorizontal()?"left":"top")+'"></div>'),r.append(u)),0===c.length&&(c=e('<div class="swiper-slide-shadow-'+(x.isHorizontal()?"right":"bottom")+'"></div>'),r.append(c)),u.length&&(u[0].style.opacity=Math.max(-o,0)),c.length&&(c[0].style.opacity=Math.max(o,0))}}if(x.wrapper.css({"-webkit-transform-origin":"50% 50% -"+x.size/2+"px","-moz-transform-origin":"50% 50% -"+x.size/2+"px","-ms-transform-origin":"50% 50% -"+x.size/2+"px","transform-origin":"50% 50% -"+x.size/2+"px"}),x.params.cube.shadow)if(x.isHorizontal())a.transform("translate3d(0px, "+(x.width/2+x.params.cube.shadowOffset)+"px, "+-x.width/2+"px) rotateX(90deg) rotateZ(0deg) scale("+x.params.cube.shadowScale+")");else{var g=Math.abs(t)-90*Math.floor(Math.abs(t)/90),h=1.5-(Math.sin(2*g*Math.PI/360)/2+Math.cos(2*g*Math.PI/360)/2),v=x.params.cube.shadowScale,f=x.params.cube.shadowScale/h,w=x.params.cube.shadowOffset;a.transform("scale3d("+v+", 1, "+f+") translate3d(0px, "+(x.height/2+w)+"px, "+-x.height/2/f+"px) rotateX(-90deg)")}var y=x.isSafari||x.isUiWebView?-x.size/2:0;x.wrapper.transform("translate3d(0px,0,"+y+"px) rotateX("+(x.isHorizontal()?0:t)+"deg) rotateY("+(x.isHorizontal()?-t:0)+"deg)")},setTransition:function(e){x.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),x.params.cube.shadow&&!x.isHorizontal()&&x.container.find(".swiper-cube-shadow").transition(e)}},coverflow:{setTranslate:function(){for(var a=x.translate,t=x.isHorizontal()?-a+x.width/2:-a+x.height/2,s=x.isHorizontal()?x.params.coverflow.rotate:-x.params.coverflow.rotate,r=x.params.coverflow.depth,i=0,n=x.slides.length;i<n;i++){var o=x.slides.eq(i),l=x.slidesSizesGrid[i],p=o[0].swiperSlideOffset,d=(t-p-l/2)/l*x.params.coverflow.modifier,m=x.isHorizontal()?s*d:0,u=x.isHorizontal()?0:s*d,c=-r*Math.abs(d),g=x.isHorizontal()?0:x.params.coverflow.stretch*d,h=x.isHorizontal()?x.params.coverflow.stretch*d:0;Math.abs(h)<.001&&(h=0),Math.abs(g)<.001&&(g=0),Math.abs(c)<.001&&(c=0),Math.abs(m)<.001&&(m=0),Math.abs(u)<.001&&(u=0);var v="translate3d("+h+"px,"+g+"px,"+c+"px)  rotateX("+u+"deg) rotateY("+m+"deg)";if(o.transform(v),o[0].style.zIndex=1-Math.abs(Math.round(d)),x.params.coverflow.slideShadows){var f=x.isHorizontal()?o.find(".swiper-slide-shadow-left"):o.find(".swiper-slide-shadow-top"),w=x.isHorizontal()?o.find(".swiper-slide-shadow-right"):o.find(".swiper-slide-shadow-bottom");0===f.length&&(f=e('<div class="swiper-slide-shadow-'+(x.isHorizontal()?"left":"top")+'"></div>'),o.append(f)),0===w.length&&(w=e('<div class="swiper-slide-shadow-'+(x.isHorizontal()?"right":"bottom")+'"></div>'),o.append(w)),f.length&&(f[0].style.opacity=d>0?d:0),w.length&&(w[0].style.opacity=-d>0?-d:0)}}if(x.browser.ie){x.wrapper[0].style.perspectiveOrigin=t+"px 50%"}},setTransition:function(e){x.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)}}},x.lazy={initialImageLoaded:!1,loadImageInSlide:function(a,t){if(void 0!==a&&(void 0===t&&(t=!0),0!==x.slides.length)){var s=x.slides.eq(a),r=s.find("."+x.params.lazyLoadingClass+":not(."+x.params.lazyStatusLoadedClass+"):not(."+x.params.lazyStatusLoadingClass+")");!s.hasClass(x.params.lazyLoadingClass)||s.hasClass(x.params.lazyStatusLoadedClass)||s.hasClass(x.params.lazyStatusLoadingClass)||(r=r.add(s[0])),0!==r.length&&r.each(function(){var a=e(this);a.addClass(x.params.lazyStatusLoadingClass);var r=a.attr("data-background"),i=a.attr("data-src"),n=a.attr("data-srcset"),o=a.attr("data-sizes");x.loadImage(a[0],i||r,n,o,!1,function(){if(void 0!==x&&null!==x&&x){if(r?(a.css("background-image",'url("'+r+'")'),a.removeAttr("data-background")):(n&&(a.attr("srcset",n),a.removeAttr("data-srcset")),o&&(a.attr("sizes",o),a.removeAttr("data-sizes")),i&&(a.attr("src",i),a.removeAttr("data-src"))),a.addClass(x.params.lazyStatusLoadedClass).removeClass(x.params.lazyStatusLoadingClass),s.find("."+x.params.lazyPreloaderClass+", ."+x.params.preloaderClass).remove(),x.params.loop&&t){var e=s.attr("data-swiper-slide-index");if(s.hasClass(x.params.slideDuplicateClass)){var l=x.wrapper.children('[data-swiper-slide-index="'+e+'"]:not(.'+x.params.slideDuplicateClass+")");x.lazy.loadImageInSlide(l.index(),!1)}else{var p=x.wrapper.children("."+x.params.slideDuplicateClass+'[data-swiper-slide-index="'+e+'"]');x.lazy.loadImageInSlide(p.index(),!1)}}x.emit("onLazyImageReady",x,s[0],a[0])}}),x.emit("onLazyImageLoad",x,s[0],a[0])})}},load:function(){var a,t=x.params.slidesPerView;if("auto"===t&&(t=0),x.lazy.initialImageLoaded||(x.lazy.initialImageLoaded=!0),x.params.watchSlidesVisibility)x.wrapper.children("."+x.params.slideVisibleClass).each(function(){x.lazy.loadImageInSlide(e(this).index())});else if(t>1)for(a=x.activeIndex;a<x.activeIndex+t;a++)x.slides[a]&&x.lazy.loadImageInSlide(a);else x.lazy.loadImageInSlide(x.activeIndex);if(x.params.lazyLoadingInPrevNext)if(t>1||x.params.lazyLoadingInPrevNextAmount&&x.params.lazyLoadingInPrevNextAmount>1){var s=x.params.lazyLoadingInPrevNextAmount,r=t,i=Math.min(x.activeIndex+r+Math.max(s,r),x.slides.length),n=Math.max(x.activeIndex-Math.max(r,s),0);for(a=x.activeIndex+t;a<i;a++)x.slides[a]&&x.lazy.loadImageInSlide(a);for(a=n;a<x.activeIndex;a++)x.slides[a]&&x.lazy.loadImageInSlide(a)}else{var o=x.wrapper.children("."+x.params.slideNextClass);o.length>0&&x.lazy.loadImageInSlide(o.index());var l=x.wrapper.children("."+x.params.slidePrevClass);l.length>0&&x.lazy.loadImageInSlide(l.index())}},onTransitionStart:function(){x.params.lazyLoading&&(x.params.lazyLoadingOnTransitionStart||!x.params.lazyLoadingOnTransitionStart&&!x.lazy.initialImageLoaded)&&x.lazy.load()},onTransitionEnd:function(){x.params.lazyLoading&&!x.params.lazyLoadingOnTransitionStart&&x.lazy.load()}},x.scrollbar={isTouched:!1,setDragPosition:function(e){var a=x.scrollbar,t=x.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].pageX:e.pageX||e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].pageY:e.pageY||e.clientY,s=t-a.track.offset()[x.isHorizontal()?"left":"top"]-a.dragSize/2,r=-x.minTranslate()*a.moveDivider,i=-x.maxTranslate()*a.moveDivider;s<r?s=r:s>i&&(s=i),s=-s/a.moveDivider,x.updateProgress(s),x.setWrapperTranslate(s,!0)},dragStart:function(e){var a=x.scrollbar;a.isTouched=!0,e.preventDefault(),e.stopPropagation(),a.setDragPosition(e),clearTimeout(a.dragTimeout),a.track.transition(0),x.params.scrollbarHide&&a.track.css("opacity",1),x.wrapper.transition(100),a.drag.transition(100),x.emit("onScrollbarDragStart",x)},dragMove:function(e){var a=x.scrollbar;a.isTouched&&(e.preventDefault?e.preventDefault():e.returnValue=!1,a.setDragPosition(e),x.wrapper.transition(0),a.track.transition(0),a.drag.transition(0),x.emit("onScrollbarDragMove",x))},dragEnd:function(e){var a=x.scrollbar;a.isTouched&&(a.isTouched=!1,x.params.scrollbarHide&&(clearTimeout(a.dragTimeout),a.dragTimeout=setTimeout(function(){a.track.css("opacity",0),a.track.transition(400)},1e3)),x.emit("onScrollbarDragEnd",x),x.params.scrollbarSnapOnRelease&&x.slideReset())},draggableEvents:function(){return x.params.simulateTouch!==!1||x.support.touch?x.touchEvents:x.touchEventsDesktop}(),enableDraggable:function(){var a=x.scrollbar,t=x.support.touch?a.track:document;e(a.track).on(a.draggableEvents.start,a.dragStart),e(t).on(a.draggableEvents.move,a.dragMove),e(t).on(a.draggableEvents.end,a.dragEnd)},disableDraggable:function(){var a=x.scrollbar,t=x.support.touch?a.track:document;e(a.track).off(a.draggableEvents.start,a.dragStart),e(t).off(a.draggableEvents.move,a.dragMove),e(t).off(a.draggableEvents.end,a.dragEnd)},set:function(){if(x.params.scrollbar){var a=x.scrollbar;a.track=e(x.params.scrollbar),x.params.uniqueNavElements&&"string"==typeof x.params.scrollbar&&a.track.length>1&&1===x.container.find(x.params.scrollbar).length&&(a.track=x.container.find(x.params.scrollbar)),a.drag=a.track.find(".swiper-scrollbar-drag"),0===a.drag.length&&(a.drag=e('<div class="swiper-scrollbar-drag"></div>'),a.track.append(a.drag)),a.drag[0].style.width="",a.drag[0].style.height="",a.trackSize=x.isHorizontal()?a.track[0].offsetWidth:a.track[0].offsetHeight,a.divider=x.size/x.virtualSize,a.moveDivider=a.divider*(a.trackSize/x.size),a.dragSize=a.trackSize*a.divider,x.isHorizontal()?a.drag[0].style.width=a.dragSize+"px":a.drag[0].style.height=a.dragSize+"px",a.divider>=1?a.track[0].style.display="none":a.track[0].style.display="",x.params.scrollbarHide&&(a.track[0].style.opacity=0)}},setTranslate:function(){if(x.params.scrollbar){var e,a=x.scrollbar,t=(x.translate,a.dragSize);e=(a.trackSize-a.dragSize)*x.progress,x.rtl&&x.isHorizontal()?(e=-e,e>0?(t=a.dragSize-e,e=0):-e+a.dragSize>a.trackSize&&(t=a.trackSize+e)):e<0?(t=a.dragSize+e,e=0):e+a.dragSize>a.trackSize&&(t=a.trackSize-e),x.isHorizontal()?(x.support.transforms3d?a.drag.transform("translate3d("+e+"px, 0, 0)"):a.drag.transform("translateX("+e+"px)"),a.drag[0].style.width=t+"px"):(x.support.transforms3d?a.drag.transform("translate3d(0px, "+e+"px, 0)"):a.drag.transform("translateY("+e+"px)"),a.drag[0].style.height=t+"px"),x.params.scrollbarHide&&(clearTimeout(a.timeout),a.track[0].style.opacity=1,a.timeout=setTimeout(function(){a.track[0].style.opacity=0,a.track.transition(400)},1e3))}},setTransition:function(e){x.params.scrollbar&&x.scrollbar.drag.transition(e)}},x.controller={LinearSpline:function(e,a){var t=function(){var e,a,t;return function(s,r){for(a=-1,e=s.length;e-a>1;)s[t=e+a>>1]<=r?a=t:e=t;return e}}();this.x=e,this.y=a,this.lastIndex=e.length-1;var s,r;this.x.length;this.interpolate=function(e){return e?(r=t(this.x,e),s=r-1,(e-this.x[s])*(this.y[r]-this.y[s])/(this.x[r]-this.x[s])+this.y[s]):0}},getInterpolateFunction:function(e){x.controller.spline||(x.controller.spline=x.params.loop?new x.controller.LinearSpline(x.slidesGrid,e.slidesGrid):new x.controller.LinearSpline(x.snapGrid,e.snapGrid))},setTranslate:function(e,t){function s(a){e=a.rtl&&"horizontal"===a.params.direction?-x.translate:x.translate,"slide"===x.params.controlBy&&(x.controller.getInterpolateFunction(a),i=-x.controller.spline.interpolate(-e)),i&&"container"!==x.params.controlBy||(r=(a.maxTranslate()-a.minTranslate())/(x.maxTranslate()-x.minTranslate()),i=(e-x.minTranslate())*r+a.minTranslate()),x.params.controlInverse&&(i=a.maxTranslate()-i),a.updateProgress(i),a.setWrapperTranslate(i,!1,x),a.updateActiveIndex()}var r,i,n=x.params.control;if(Array.isArray(n))for(var o=0;o<n.length;o++)n[o]!==t&&n[o]instanceof a&&s(n[o]);else n instanceof a&&t!==n&&s(n)},setTransition:function(e,t){function s(a){a.setWrapperTransition(e,x),0!==e&&(a.onTransitionStart(),a.wrapper.transitionEnd(function(){i&&(a.params.loop&&"slide"===x.params.controlBy&&a.fixLoop(),a.onTransitionEnd())}))}var r,i=x.params.control;if(Array.isArray(i))for(r=0;r<i.length;r++)i[r]!==t&&i[r]instanceof a&&s(i[r]);else i instanceof a&&t!==i&&s(i)}},x.hashnav={onHashCange:function(e,a){var t=document.location.hash.replace("#","");t!==x.slides.eq(x.activeIndex).attr("data-hash")&&x.slideTo(x.wrapper.children("."+x.params.slideClass+'[data-hash="'+t+'"]').index())},attachEvents:function(a){var t=a?"off":"on";e(window)[t]("hashchange",x.hashnav.onHashCange)},setHash:function(){
if(x.hashnav.initialized&&x.params.hashnav)if(x.params.replaceState&&window.history&&window.history.replaceState)window.history.replaceState(null,null,"#"+x.slides.eq(x.activeIndex).attr("data-hash")||"");else{var e=x.slides.eq(x.activeIndex),a=e.attr("data-hash")||e.attr("data-history");document.location.hash=a||""}},init:function(){if(x.params.hashnav&&!x.params.history){x.hashnav.initialized=!0;var e=document.location.hash.replace("#","");if(e)for(var a=0,t=x.slides.length;a<t;a++){var s=x.slides.eq(a),r=s.attr("data-hash")||s.attr("data-history");if(r===e&&!s.hasClass(x.params.slideDuplicateClass)){var i=s.index();x.slideTo(i,0,x.params.runCallbacksOnInit,!0)}}x.params.hashnavWatchState&&x.hashnav.attachEvents()}},destroy:function(){x.params.hashnavWatchState&&x.hashnav.attachEvents(!0)}},x.history={init:function(){if(x.params.history){if(!window.history||!window.history.pushState)return x.params.history=!1,void(x.params.hashnav=!0);x.history.initialized=!0,this.paths=this.getPathValues(),(this.paths.key||this.paths.value)&&(this.scrollToSlide(0,this.paths.value,x.params.runCallbacksOnInit),x.params.replaceState||window.addEventListener("popstate",this.setHistoryPopState))}},setHistoryPopState:function(){x.history.paths=x.history.getPathValues(),x.history.scrollToSlide(x.params.speed,x.history.paths.value,!1)},getPathValues:function(){var e=window.location.pathname.slice(1).split("/"),a=e.length;return{key:e[a-2],value:e[a-1]}},setHistory:function(e,a){if(x.history.initialized&&x.params.history){var t=x.slides.eq(a),s=this.slugify(t.attr("data-history"));window.location.pathname.includes(e)||(s=e+"/"+s),x.params.replaceState?window.history.replaceState(null,null,s):window.history.pushState(null,null,s)}},slugify:function(e){return e.toString().toLowerCase().replace(/\s+/g,"-").replace(/[^\w\-]+/g,"").replace(/\-\-+/g,"-").replace(/^-+/,"").replace(/-+$/,"")},scrollToSlide:function(e,a,t){if(a)for(var s=0,r=x.slides.length;s<r;s++){var i=x.slides.eq(s),n=this.slugify(i.attr("data-history"));if(n===a&&!i.hasClass(x.params.slideDuplicateClass)){var o=i.index();x.slideTo(o,e,t)}}else x.slideTo(0,e,t)}},x.disableKeyboardControl=function(){x.params.keyboardControl=!1,e(document).off("keydown",l)},x.enableKeyboardControl=function(){x.params.keyboardControl=!0,e(document).on("keydown",l)},x.mousewheel={event:!1,lastScrollTime:(new window.Date).getTime()},x.params.mousewheelControl&&(x.mousewheel.event=navigator.userAgent.indexOf("firefox")>-1?"DOMMouseScroll":function(){var e="onwheel"in document;if(!e){var a=document.createElement("div");a.setAttribute("onwheel","return;"),e="function"==typeof a.onwheel}return!e&&document.implementation&&document.implementation.hasFeature&&document.implementation.hasFeature("","")!==!0&&(e=document.implementation.hasFeature("Events.wheel","3.0")),e}()?"wheel":"mousewheel"),x.disableMousewheelControl=function(){if(!x.mousewheel.event)return!1;var a=x.container;return"container"!==x.params.mousewheelEventsTarged&&(a=e(x.params.mousewheelEventsTarged)),a.off(x.mousewheel.event,d),x.params.mousewheelControl=!1,!0},x.enableMousewheelControl=function(){if(!x.mousewheel.event)return!1;var a=x.container;return"container"!==x.params.mousewheelEventsTarged&&(a=e(x.params.mousewheelEventsTarged)),a.on(x.mousewheel.event,d),x.params.mousewheelControl=!0,!0},x.parallax={setTranslate:function(){x.container.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(){m(this,x.progress)}),x.slides.each(function(){var a=e(this);a.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(){m(this,Math.min(Math.max(a[0].progress,-1),1))})})},setTransition:function(a){void 0===a&&(a=x.params.speed),x.container.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(){var t=e(this),s=parseInt(t.attr("data-swiper-parallax-duration"),10)||a;0===a&&(s=0),t.transition(s)})}},x.zoom={scale:1,currentScale:1,isScaling:!1,gesture:{slide:void 0,slideWidth:void 0,slideHeight:void 0,image:void 0,imageWrap:void 0,zoomMax:x.params.zoomMax},image:{isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},velocity:{x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0},getDistanceBetweenTouches:function(e){if(e.targetTouches.length<2)return 1;var a=e.targetTouches[0].pageX,t=e.targetTouches[0].pageY,s=e.targetTouches[1].pageX,r=e.targetTouches[1].pageY;return Math.sqrt(Math.pow(s-a,2)+Math.pow(r-t,2))},onGestureStart:function(a){var t=x.zoom;if(!x.support.gestures){if("touchstart"!==a.type||"touchstart"===a.type&&a.targetTouches.length<2)return;t.gesture.scaleStart=t.getDistanceBetweenTouches(a)}if(!(t.gesture.slide&&t.gesture.slide.length||(t.gesture.slide=e(this),0===t.gesture.slide.length&&(t.gesture.slide=x.slides.eq(x.activeIndex)),t.gesture.image=t.gesture.slide.find("img, svg, canvas"),t.gesture.imageWrap=t.gesture.image.parent("."+x.params.zoomContainerClass),t.gesture.zoomMax=t.gesture.imageWrap.attr("data-swiper-zoom")||x.params.zoomMax,0!==t.gesture.imageWrap.length)))return void(t.gesture.image=void 0);t.gesture.image.transition(0),t.isScaling=!0},onGestureChange:function(e){var a=x.zoom;if(!x.support.gestures){if("touchmove"!==e.type||"touchmove"===e.type&&e.targetTouches.length<2)return;a.gesture.scaleMove=a.getDistanceBetweenTouches(e)}a.gesture.image&&0!==a.gesture.image.length&&(x.support.gestures?a.scale=e.scale*a.currentScale:a.scale=a.gesture.scaleMove/a.gesture.scaleStart*a.currentScale,a.scale>a.gesture.zoomMax&&(a.scale=a.gesture.zoomMax-1+Math.pow(a.scale-a.gesture.zoomMax+1,.5)),a.scale<x.params.zoomMin&&(a.scale=x.params.zoomMin+1-Math.pow(x.params.zoomMin-a.scale+1,.5)),a.gesture.image.transform("translate3d(0,0,0) scale("+a.scale+")"))},onGestureEnd:function(e){var a=x.zoom;!x.support.gestures&&("touchend"!==e.type||"touchend"===e.type&&e.changedTouches.length<2)||a.gesture.image&&0!==a.gesture.image.length&&(a.scale=Math.max(Math.min(a.scale,a.gesture.zoomMax),x.params.zoomMin),a.gesture.image.transition(x.params.speed).transform("translate3d(0,0,0) scale("+a.scale+")"),a.currentScale=a.scale,a.isScaling=!1,1===a.scale&&(a.gesture.slide=void 0))},onTouchStart:function(e,a){var t=e.zoom;t.gesture.image&&0!==t.gesture.image.length&&(t.image.isTouched||("android"===e.device.os&&a.preventDefault(),t.image.isTouched=!0,t.image.touchesStart.x="touchstart"===a.type?a.targetTouches[0].pageX:a.pageX,t.image.touchesStart.y="touchstart"===a.type?a.targetTouches[0].pageY:a.pageY))},onTouchMove:function(e){var a=x.zoom;if(a.gesture.image&&0!==a.gesture.image.length&&(x.allowClick=!1,a.image.isTouched&&a.gesture.slide)){a.image.isMoved||(a.image.width=a.gesture.image[0].offsetWidth,a.image.height=a.gesture.image[0].offsetHeight,a.image.startX=x.getTranslate(a.gesture.imageWrap[0],"x")||0,a.image.startY=x.getTranslate(a.gesture.imageWrap[0],"y")||0,a.gesture.slideWidth=a.gesture.slide[0].offsetWidth,a.gesture.slideHeight=a.gesture.slide[0].offsetHeight,a.gesture.imageWrap.transition(0),x.rtl&&(a.image.startX=-a.image.startX),x.rtl&&(a.image.startY=-a.image.startY));var t=a.image.width*a.scale,s=a.image.height*a.scale;if(!(t<a.gesture.slideWidth&&s<a.gesture.slideHeight)){if(a.image.minX=Math.min(a.gesture.slideWidth/2-t/2,0),a.image.maxX=-a.image.minX,a.image.minY=Math.min(a.gesture.slideHeight/2-s/2,0),a.image.maxY=-a.image.minY,a.image.touchesCurrent.x="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,a.image.touchesCurrent.y="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,!a.image.isMoved&&!a.isScaling){if(x.isHorizontal()&&Math.floor(a.image.minX)===Math.floor(a.image.startX)&&a.image.touchesCurrent.x<a.image.touchesStart.x||Math.floor(a.image.maxX)===Math.floor(a.image.startX)&&a.image.touchesCurrent.x>a.image.touchesStart.x)return void(a.image.isTouched=!1);if(!x.isHorizontal()&&Math.floor(a.image.minY)===Math.floor(a.image.startY)&&a.image.touchesCurrent.y<a.image.touchesStart.y||Math.floor(a.image.maxY)===Math.floor(a.image.startY)&&a.image.touchesCurrent.y>a.image.touchesStart.y)return void(a.image.isTouched=!1)}e.preventDefault(),e.stopPropagation(),a.image.isMoved=!0,a.image.currentX=a.image.touchesCurrent.x-a.image.touchesStart.x+a.image.startX,a.image.currentY=a.image.touchesCurrent.y-a.image.touchesStart.y+a.image.startY,a.image.currentX<a.image.minX&&(a.image.currentX=a.image.minX+1-Math.pow(a.image.minX-a.image.currentX+1,.8)),a.image.currentX>a.image.maxX&&(a.image.currentX=a.image.maxX-1+Math.pow(a.image.currentX-a.image.maxX+1,.8)),a.image.currentY<a.image.minY&&(a.image.currentY=a.image.minY+1-Math.pow(a.image.minY-a.image.currentY+1,.8)),a.image.currentY>a.image.maxY&&(a.image.currentY=a.image.maxY-1+Math.pow(a.image.currentY-a.image.maxY+1,.8)),a.velocity.prevPositionX||(a.velocity.prevPositionX=a.image.touchesCurrent.x),a.velocity.prevPositionY||(a.velocity.prevPositionY=a.image.touchesCurrent.y),a.velocity.prevTime||(a.velocity.prevTime=Date.now()),a.velocity.x=(a.image.touchesCurrent.x-a.velocity.prevPositionX)/(Date.now()-a.velocity.prevTime)/2,a.velocity.y=(a.image.touchesCurrent.y-a.velocity.prevPositionY)/(Date.now()-a.velocity.prevTime)/2,Math.abs(a.image.touchesCurrent.x-a.velocity.prevPositionX)<2&&(a.velocity.x=0),Math.abs(a.image.touchesCurrent.y-a.velocity.prevPositionY)<2&&(a.velocity.y=0),a.velocity.prevPositionX=a.image.touchesCurrent.x,a.velocity.prevPositionY=a.image.touchesCurrent.y,a.velocity.prevTime=Date.now(),a.gesture.imageWrap.transform("translate3d("+a.image.currentX+"px, "+a.image.currentY+"px,0)")}}},onTouchEnd:function(e,a){var t=e.zoom;if(t.gesture.image&&0!==t.gesture.image.length){if(!t.image.isTouched||!t.image.isMoved)return t.image.isTouched=!1,void(t.image.isMoved=!1);t.image.isTouched=!1,t.image.isMoved=!1;var s=300,r=300,i=t.velocity.x*s,n=t.image.currentX+i,o=t.velocity.y*r,l=t.image.currentY+o;0!==t.velocity.x&&(s=Math.abs((n-t.image.currentX)/t.velocity.x)),0!==t.velocity.y&&(r=Math.abs((l-t.image.currentY)/t.velocity.y));var p=Math.max(s,r);t.image.currentX=n,t.image.currentY=l;var d=t.image.width*t.scale,m=t.image.height*t.scale;t.image.minX=Math.min(t.gesture.slideWidth/2-d/2,0),t.image.maxX=-t.image.minX,t.image.minY=Math.min(t.gesture.slideHeight/2-m/2,0),t.image.maxY=-t.image.minY,t.image.currentX=Math.max(Math.min(t.image.currentX,t.image.maxX),t.image.minX),t.image.currentY=Math.max(Math.min(t.image.currentY,t.image.maxY),t.image.minY),t.gesture.imageWrap.transition(p).transform("translate3d("+t.image.currentX+"px, "+t.image.currentY+"px,0)")}},onTransitionEnd:function(e){var a=e.zoom;a.gesture.slide&&e.previousIndex!==e.activeIndex&&(a.gesture.image.transform("translate3d(0,0,0) scale(1)"),a.gesture.imageWrap.transform("translate3d(0,0,0)"),a.gesture.slide=a.gesture.image=a.gesture.imageWrap=void 0,a.scale=a.currentScale=1)},toggleZoom:function(a,t){var s=a.zoom;if(s.gesture.slide||(s.gesture.slide=a.clickedSlide?e(a.clickedSlide):a.slides.eq(a.activeIndex),s.gesture.image=s.gesture.slide.find("img, svg, canvas"),s.gesture.imageWrap=s.gesture.image.parent("."+a.params.zoomContainerClass)),s.gesture.image&&0!==s.gesture.image.length){var r,i,n,o,l,p,d,m,u,c,g,h,v,f,w,y,x,T;void 0===s.image.touchesStart.x&&t?(r="touchend"===t.type?t.changedTouches[0].pageX:t.pageX,i="touchend"===t.type?t.changedTouches[0].pageY:t.pageY):(r=s.image.touchesStart.x,i=s.image.touchesStart.y),s.scale&&1!==s.scale?(s.scale=s.currentScale=1,s.gesture.imageWrap.transition(300).transform("translate3d(0,0,0)"),s.gesture.image.transition(300).transform("translate3d(0,0,0) scale(1)"),s.gesture.slide=void 0):(s.scale=s.currentScale=s.gesture.imageWrap.attr("data-swiper-zoom")||a.params.zoomMax,t?(x=s.gesture.slide[0].offsetWidth,T=s.gesture.slide[0].offsetHeight,n=s.gesture.slide.offset().left,o=s.gesture.slide.offset().top,l=n+x/2-r,p=o+T/2-i,u=s.gesture.image[0].offsetWidth,c=s.gesture.image[0].offsetHeight,g=u*s.scale,h=c*s.scale,v=Math.min(x/2-g/2,0),f=Math.min(T/2-h/2,0),w=-v,y=-f,d=l*s.scale,m=p*s.scale,d<v&&(d=v),d>w&&(d=w),m<f&&(m=f),m>y&&(m=y)):(d=0,m=0),s.gesture.imageWrap.transition(300).transform("translate3d("+d+"px, "+m+"px,0)"),s.gesture.image.transition(300).transform("translate3d(0,0,0) scale("+s.scale+")"))}},attachEvents:function(a){var t=a?"off":"on";if(x.params.zoom){var s=(x.slides,!("touchstart"!==x.touchEvents.start||!x.support.passiveListener||!x.params.passiveListeners)&&{passive:!0,capture:!1});x.support.gestures?(x.slides[t]("gesturestart",x.zoom.onGestureStart,s),x.slides[t]("gesturechange",x.zoom.onGestureChange,s),x.slides[t]("gestureend",x.zoom.onGestureEnd,s)):"touchstart"===x.touchEvents.start&&(x.slides[t](x.touchEvents.start,x.zoom.onGestureStart,s),x.slides[t](x.touchEvents.move,x.zoom.onGestureChange,s),x.slides[t](x.touchEvents.end,x.zoom.onGestureEnd,s)),x[t]("touchStart",x.zoom.onTouchStart),x.slides.each(function(a,s){e(s).find("."+x.params.zoomContainerClass).length>0&&e(s)[t](x.touchEvents.move,x.zoom.onTouchMove)}),x[t]("touchEnd",x.zoom.onTouchEnd),x[t]("transitionEnd",x.zoom.onTransitionEnd),x.params.zoomToggle&&x.on("doubleTap",x.zoom.toggleZoom)}},init:function(){x.zoom.attachEvents()},destroy:function(){x.zoom.attachEvents(!0)}},x._plugins=[];for(var Y in x.plugins){var A=x.plugins[Y](x,x.params[Y]);A&&x._plugins.push(A)}return x.callPlugins=function(e){for(var a=0;a<x._plugins.length;a++)e in x._plugins[a]&&x._plugins[a][e](arguments[1],arguments[2],arguments[3],arguments[4],arguments[5])},x.emitterEventListeners={},x.emit=function(e){x.params[e]&&x.params[e](arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]);var a;if(x.emitterEventListeners[e])for(a=0;a<x.emitterEventListeners[e].length;a++)x.emitterEventListeners[e][a](arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]);x.callPlugins&&x.callPlugins(e,arguments[1],arguments[2],arguments[3],arguments[4],arguments[5])},x.on=function(e,a){return e=u(e),x.emitterEventListeners[e]||(x.emitterEventListeners[e]=[]),x.emitterEventListeners[e].push(a),x},x.off=function(e,a){var t;if(e=u(e),void 0===a)return x.emitterEventListeners[e]=[],x;if(x.emitterEventListeners[e]&&0!==x.emitterEventListeners[e].length){for(t=0;t<x.emitterEventListeners[e].length;t++)x.emitterEventListeners[e][t]===a&&x.emitterEventListeners[e].splice(t,1);return x}},x.once=function(e,a){e=u(e);var t=function(){a(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4]),x.off(e,t)};return x.on(e,t),x},x.a11y={makeFocusable:function(e){return e.attr("tabIndex","0"),e},addRole:function(e,a){return e.attr("role",a),e},addLabel:function(e,a){return e.attr("aria-label",a),e},disable:function(e){return e.attr("aria-disabled",!0),e},enable:function(e){return e.attr("aria-disabled",!1),e},onEnterKey:function(a){13===a.keyCode&&(e(a.target).is(x.params.nextButton)?(x.onClickNext(a),x.isEnd?x.a11y.notify(x.params.lastSlideMessage):x.a11y.notify(x.params.nextSlideMessage)):e(a.target).is(x.params.prevButton)&&(x.onClickPrev(a),x.isBeginning?x.a11y.notify(x.params.firstSlideMessage):x.a11y.notify(x.params.prevSlideMessage)),e(a.target).is("."+x.params.bulletClass)&&e(a.target)[0].click())},liveRegion:e('<span class="'+x.params.notificationClass+'" aria-live="assertive" aria-atomic="true"></span>'),notify:function(e){var a=x.a11y.liveRegion;0!==a.length&&(a.html(""),a.html(e))},init:function(){x.params.nextButton&&x.nextButton&&x.nextButton.length>0&&(x.a11y.makeFocusable(x.nextButton),x.a11y.addRole(x.nextButton,"button"),x.a11y.addLabel(x.nextButton,x.params.nextSlideMessage)),x.params.prevButton&&x.prevButton&&x.prevButton.length>0&&(x.a11y.makeFocusable(x.prevButton),x.a11y.addRole(x.prevButton,"button"),x.a11y.addLabel(x.prevButton,x.params.prevSlideMessage)),e(x.container).append(x.a11y.liveRegion)},initPagination:function(){x.params.pagination&&x.params.paginationClickable&&x.bullets&&x.bullets.length&&x.bullets.each(function(){var a=e(this);x.a11y.makeFocusable(a),x.a11y.addRole(a,"button"),x.a11y.addLabel(a,x.params.paginationBulletMessage.replace(/{{index}}/,a.index()+1))})},destroy:function(){x.a11y.liveRegion&&x.a11y.liveRegion.length>0&&x.a11y.liveRegion.remove()}},x.init=function(){x.params.loop&&x.createLoop(),x.updateContainerSize(),x.updateSlidesSize(),x.updatePagination(),x.params.scrollbar&&x.scrollbar&&(x.scrollbar.set(),x.params.scrollbarDraggable&&x.scrollbar.enableDraggable()),"slide"!==x.params.effect&&x.effects[x.params.effect]&&(x.params.loop||x.updateProgress(),x.effects[x.params.effect].setTranslate()),x.params.loop?x.slideTo(x.params.initialSlide+x.loopedSlides,0,x.params.runCallbacksOnInit):(x.slideTo(x.params.initialSlide,0,x.params.runCallbacksOnInit),0===x.params.initialSlide&&(x.parallax&&x.params.parallax&&x.parallax.setTranslate(),x.lazy&&x.params.lazyLoading&&(x.lazy.load(),x.lazy.initialImageLoaded=!0))),x.attachEvents(),x.params.observer&&x.support.observer&&x.initObservers(),x.params.preloadImages&&!x.params.lazyLoading&&x.preloadImages(),x.params.zoom&&x.zoom&&x.zoom.init(),x.params.autoplay&&x.startAutoplay(),x.params.keyboardControl&&x.enableKeyboardControl&&x.enableKeyboardControl(),x.params.mousewheelControl&&x.enableMousewheelControl&&x.enableMousewheelControl(),x.params.hashnavReplaceState&&(x.params.replaceState=x.params.hashnavReplaceState),x.params.history&&x.history&&x.history.init(),x.params.hashnav&&x.hashnav&&x.hashnav.init(),x.params.a11y&&x.a11y&&x.a11y.init(),x.emit("onInit",x)},x.cleanupStyles=function(){x.container.removeClass(x.classNames.join(" ")).removeAttr("style"),x.wrapper.removeAttr("style"),x.slides&&x.slides.length&&x.slides.removeClass([x.params.slideVisibleClass,x.params.slideActiveClass,x.params.slideNextClass,x.params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-column").removeAttr("data-swiper-row"),x.paginationContainer&&x.paginationContainer.length&&x.paginationContainer.removeClass(x.params.paginationHiddenClass),x.bullets&&x.bullets.length&&x.bullets.removeClass(x.params.bulletActiveClass),x.params.prevButton&&e(x.params.prevButton).removeClass(x.params.buttonDisabledClass),x.params.nextButton&&e(x.params.nextButton).removeClass(x.params.buttonDisabledClass),x.params.scrollbar&&x.scrollbar&&(x.scrollbar.track&&x.scrollbar.track.length&&x.scrollbar.track.removeAttr("style"),x.scrollbar.drag&&x.scrollbar.drag.length&&x.scrollbar.drag.removeAttr("style"))},x.destroy=function(e,a){x.detachEvents(),x.stopAutoplay(),x.params.scrollbar&&x.scrollbar&&x.params.scrollbarDraggable&&x.scrollbar.disableDraggable(),x.params.loop&&x.destroyLoop(),a&&x.cleanupStyles(),x.disconnectObservers(),x.params.zoom&&x.zoom&&x.zoom.destroy(),x.params.keyboardControl&&x.disableKeyboardControl&&x.disableKeyboardControl(),x.params.mousewheelControl&&x.disableMousewheelControl&&x.disableMousewheelControl(),x.params.a11y&&x.a11y&&x.a11y.destroy(),x.params.history&&!x.params.replaceState&&window.removeEventListener("popstate",x.history.setHistoryPopState),x.params.hashnav&&x.hashnav&&x.hashnav.destroy(),x.emit("onDestroy"),e!==!1&&(x=null)},x.init(),x}};a.prototype={isSafari:function(){var e=window.navigator.userAgent.toLowerCase();return e.indexOf("safari")>=0&&e.indexOf("chrome")<0&&e.indexOf("android")<0}(),isUiWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),isArray:function(e){return"[object Array]"===Object.prototype.toString.apply(e)},browser:{ie:window.navigator.pointerEnabled||window.navigator.msPointerEnabled,ieTouch:window.navigator.msPointerEnabled&&window.navigator.msMaxTouchPoints>1||window.navigator.pointerEnabled&&window.navigator.maxTouchPoints>1,lteIE9:function(){var e=document.createElement("div");return e.innerHTML="<!--[if lte IE 9]><i></i><![endif]-->",1===e.getElementsByTagName("i").length}()},device:function(){var e=window.navigator.userAgent,a=e.match(/(Android);?[\s\/]+([\d.]+)?/),t=e.match(/(iPad).*OS\s([\d_]+)/),s=e.match(/(iPod)(.*OS\s([\d_]+))?/),r=!t&&e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);return{ios:t||r||s,android:a}}(),support:{touch:window.Modernizr&&Modernizr.touch===!0||function(){return!!("ontouchstart"in window||window.DocumentTouch&&document instanceof DocumentTouch)}(),transforms3d:window.Modernizr&&Modernizr.csstransforms3d===!0||function(){var e=document.createElement("div").style;return"webkitPerspective"in e||"MozPerspective"in e||"OPerspective"in e||"MsPerspective"in e||"perspective"in e}(),flexbox:function(){for(var e=document.createElement("div").style,a="alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "),t=0;t<a.length;t++)if(a[t]in e)return!0}(),observer:function(){return"MutationObserver"in window||"WebkitMutationObserver"in window}(),passiveListener:function(){var e=!1;try{var a=Object.defineProperty({},"passive",{get:function(){e=!0}});window.addEventListener("testPassiveListener",null,a)}catch(e){}return e}(),gestures:function(){return"ongesturestart"in window}()},plugins:{}};for(var t=["jQuery","Zepto","Dom7"],s=0;s<t.length;s++)window[t[s]]&&function(e){e.fn.swiper=function(t){var s;return e(this).each(function(){var e=new a(this,t);s||(s=e)}),s}}(window[t[s]]);var r;r="undefined"==typeof Dom7?window.Dom7||window.Zepto||__webpack_provided_window_dot_jQuery:Dom7,r&&("transitionEnd"in r.fn||(r.fn.transitionEnd=function(e){function a(i){if(i.target===this)for(e.call(this,i),t=0;t<s.length;t++)r.off(s[t],a)}var t,s=["webkitTransitionEnd","transitionend","oTransitionEnd","MSTransitionEnd","msTransitionEnd"],r=this;if(e)for(t=0;t<s.length;t++)r.on(s[t],a);return this}),"transform"in r.fn||(r.fn.transform=function(e){for(var a=0;a<this.length;a++){var t=this[a].style;t.webkitTransform=t.MsTransform=t.msTransform=t.MozTransform=t.OTransform=t.transform=e}return this}),"transition"in r.fn||(r.fn.transition=function(e){"string"!=typeof e&&(e+="ms");for(var a=0;a<this.length;a++){var t=this[a].style;t.webkitTransitionDuration=t.MsTransitionDuration=t.msTransitionDuration=t.MozTransitionDuration=t.OTransitionDuration=t.transitionDuration=e}return this}),"outerWidth"in r.fn||(r.fn.outerWidth=function(e){return this.length>0?e?this[0].offsetWidth+parseFloat(this.css("margin-right"))+parseFloat(this.css("margin-left")):this[0].offsetWidth:null})),window.Swiper=a}(), true?module.exports=window.Swiper:"function"==typeof define&&define.amd&&define([],function(){"use strict";return window.Swiper});
//# sourceMappingURL=maps/swiper.jquery.min.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("7t+N")))

/***/ }),

/***/ "Guh9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example uploa-bg",staticStyle:{"padding":"10px 0 10px 5%"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.prov),expression:"prov"}],staticStyle:{"height":"35px"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.prov=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onClickMe1]}},_vm._l((_vm.arr),function(option){return _c('option',{domProps:{"value":option.name}},[_vm._v("\n      "+_vm._s(option.name)+"\n    ")])})),_vm._v(" "),(_vm.cityArr)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticStyle:{"height":"35px"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.city=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onClickMe2]}},_vm._l((_vm.cityArr),function(option){return _c('option',{domProps:{"value":option.name}},[_vm._v("\n      "+_vm._s(option.name)+"\n    ")])})):_vm._e(),_vm._v(" "),(_vm.districtArr)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.district),expression:"district"}],staticClass:"districts",staticStyle:{"height":"35px"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.district=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onClickMe3]}},_vm._l((_vm.districtArr),function(option){return _c('option',{domProps:{"value":option.name}},[_vm._v("\n      "+_vm._s(option.name)+"\n    ")])})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H52a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H6Vf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("K/6q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d68276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("NWG5");
function injectStyle (ssrContext) {
  __webpack_require__("g409")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d68276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H715":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderByTime", function() { return orderByTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replace_em", function() { return replace_em; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ellipsis", function() { return ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderBy", function() { return orderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderBys", function() { return orderBys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatSeconds", function() { return formatSeconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "datetime", function() { return datetime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "status", function() { return status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ticket", function() { return ticket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeToMillion", function() { return timeToMillion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return format; });
/**
 * Created by Administrator on 2018/1/3.
 */

/*过滤器*/
//字数限定
var ellipsis = function ellipsis(str, num) {
  if (typeof str != 'string' || str == null || str == '') return '';
  return str.length > num ? str.slice(0, num) + '...' : str;
};
//qq表情
var replace_em = function replace_em(str) {
  str = str.replace(/\</g, '&lt;');
  str = str.replace(/\>/g, '&gt;');
  str = str.replace(/\n/g, '<br/>');
  str = str.replace(/\[em_([0-9]*)\]/g, '<img src="../../static/dist/arclist/1.gif" border="0" />');
  return str;
};
//活动是否开始结束
var timeToMillion = function timeToMillion(startStr, endStr) {
  var times;
  //如果是2个参数就是时间差
  if (endStr) {
    var startT = new Date(startStr).getTime();
    var endT = new Date(endStr).getTime();
    times = (endT - startT) / 1000;
    // 如果是一个参数，参数值是秒数
  } else {
    times = startStr;
  }
  var day, hour, minute, endOutStr;
  if (times > 0) {
    // console.log(times)
    day = Math.floor(times / (60 * 60 * 24));
    hour = Math.floor(times / (60 * 60)) - day * 24;
    minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60;
    // second = Math.floor(times) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
    if (parseInt(day) != 0) {
      if (day > 6) {
        endOutStr = day + '天前';
      } else {
        endOutStr = day + '天' + hour + '小時' + minute + '分钟前';
      }
    } else {
      if (parseInt(hour) != 0) {
        endOutStr = hour + '小時' + minute + '分钟前';
      } else {
        endOutStr = minute + '分钟前';
      }
    }
  } else {
    endOutStr = 0;
  }
  // if (day <= 9) day = '0' + day;
  // if (hour <= 9) hour = '0' + hour;
  // if (minute <= 9) minute = '0' + minute;
  // if (second <= 9) second = '0' + second;
  return endOutStr;
};
var orderBys = function orderBys(val, start) {
  var Time = new Date(val).getTime() - new Date().getTime() /*+ 86400000*/;
  var Not = new Date().getTime() - new Date(start).getTime();
  var days;
  if (Not >= 0) {
    if (Math.ceil(Time / 1000 / 60 / 60 / 24) > 0) {
      var dayS = Math.ceil(Time / 1000 / 60 / 60 / 24);
      if (dayS < 365) {
        days = '剩余' + dayS + '天';
      } else {
        days = '长期有效';
      }
    } else {
      days = '活动已结束';
    }
  } else {
    days = '活动未开始';
  }
  return days;
};
//活动是否开始结束
var orderBy = function orderBy(val, start) {
  var Time = new Date(val).getTime() - new Date().getTime() /*+ 86400000*/;
  var Not = new Date().getTime() - new Date(start).getTime();
  var days;
  if (Not >= 0) {
    if (Math.ceil(Time / 1000 / 60 / 60 / 24) > 0) {
      var dayS = Math.ceil(Time / 1000 / 60 / 60 / 24);
      if (dayS < 365) {
        days = '剩余' + dayS + '天';
      } else {
        days = '长期有效';
      }
    } else {
      days = '活动已结束';
    }
  } else {
    days = '活动未开始';
  }
  return days;
};
//活动是否显示时间
var orderByTime = function orderByTime(end, start) {
  var endTime = new Date(end).getTime() /*+ 86400000*/;
  var startTime = new Date(start).getTime();
  var dataTime = new Date().getTime();
  var days;
  if ((endTime - dataTime) / 1000 / 60 / 60 / 24 > 365) {
    days = '长期有效';
  } else if (endTime - startTime > 0) {
    days = end + '结束';
  } else {
    days = '已结束';
  }
  return days;
};
//时分秒
var formatSeconds = function formatSeconds(value) {
  var theTime = parseInt(value); // 秒
  var theTime1 = 0; // 分
  var theTime2 = 0; // 小时
  // alert(theTime);
  if (theTime > 60) {
    theTime1 = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    // alert(theTime1+'-'+theTime);
    if (theTime1 > 60) {
      theTime2 = parseInt(theTime1 / 60);
      theTime1 = parseInt(theTime1 % 60);
    }
  }
  var result = '' + parseInt(theTime);
  //分钟
  if (theTime1 > 0) {
    if (theTime1 >= 10) {
      if (result >= 10) {
        result = '00:' + parseInt(theTime1) + ':' + result;
      } else {
        result = '00:' + parseInt(theTime1) + ':0' + result;
      }
    } else {
      if (result >= 10) {
        result = '00:0' + parseInt(theTime1) + ':' + result;
      } else {
        result = '00:0' + parseInt(theTime1) + ':0' + result;
      }
    }
  } else {
    if (result >= 10) {
      result = '00:00:' + result;
    } else {
      result = '00:00:' + '0' + result;
    }
  }
  if (theTime2 > 0) {
    if (theTime2 >= 10) {
      result = parseInt(theTime2) + ':' + result.substring(2);
    } else {
      result = '0' + parseInt(theTime2) + result.substring(2);
    }
  } else {}
  return result;
};
//评论时间
var TimeName = function TimeName(val) {
  console.log(val);
  var days = Math.floor(val / 1000 / 60 / 60 / 24);
  var hour = Math.floor(val / 1000 / 60 / 60);
  var Minute = Math.floor(val / 1000 / 60);
  if (hour == 0) {
    return Minute + '分钟';
  } else if (days == 0) {
    return hour + '小时';
  } else {
    return days + '天前';
  }
};

//日期切割
var datetime = function datetime(val) {
  var n = '';
  if (val == null) {
    n = 'null';
  } else {
    n = val.split(' ')[0];
  }
  return n;
};
//活动状态
var status = function status(val) {
  if (val == 0) {
    return '未开始';
  } else if (val == 1) {
    return '活动中';
  } else if (val == 2) {
    return '已结束';
  }
};
//票数
var ticket = function ticket(val) {
  var v = val / 10000;
  if (v > 1) {
    return v.toFixed(2) + '万票';
  } else {
    return Number(val) + '票';
  }
};
var format = function format() {
  var dateStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return dateStr.replace(/\//g, '-');
};


/***/ }),

/***/ "HQlB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I1sH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notice_vue__ = __webpack_require__("i8r/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bda4ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notice_vue__ = __webpack_require__("VBaF");
function injectStyle (ssrContext) {
  __webpack_require__("+XoV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bda4ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I4t6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    //操作按钮事件
  },
  created: function created() {
    var that = this;
    if (that.IsPC()) {
      window.location.href = API.IsPcName;
    }
    if (!passport.isLoginedStatus()) {
      console.log('判断是否登录-未登录');
    } else {
      that.$http.get(API.GetCountByUserid).then(function (res) {
        if (res.code == 0) {
          that.$router.push({ name: 'MyMessage' });
        }
      });
    }
  },
  mounted: function mounted() {
    //操作DOM

  }

});

/***/ }),

/***/ "IGXn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ISSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"release"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tablesName),expression:"tablesName"}],staticClass:"line"}),_vm._v(" "),(_vm.tablesName)?_c('div',{staticClass:"show-box"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"tag":"a","to":{name:'Find'}}},[_c('h5',{staticClass:"show-tit"},[_vm._v("\n        "+_vm._s(_vm.tablesTitle)+"\n        "),_c('a',{staticClass:"show-linkmore",attrs:{"href":"javascript:void(0);"}},[_vm._v("更多")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-container show-poll-swiper show-id-swiper"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.tablesName),function(v,ind){return _c('div',{staticClass:"swiper-slide"},[_c('ul',{staticClass:"show-list"},_vm._l((_vm.twoNumbers),function(val,i){return _c('li',{staticClass:"dbroadcast",attrs:{"attr-item":JSON.stringify(_vm.tables[ind*2+i]),"attr-type":"tablesName"}},[_c('a',{attrs:{"href":"javascript:void(0);"}},[(_vm.tables[ind*2+i].hostunit)?_c('div',{staticClass:"show-remd-logo"},[_c('img',{attrs:{"src":_vm.tables[ind*2+i].hostunit.host_avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.tables[ind*2+i].hostunit)?_c('div',{staticClass:"show-remd-tit"},[_vm._v("\n                  "+_vm._s(_vm.tables[ind*2+i].hostunit.column_name)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.tables[ind*2+i].playbill)?_c('div',{staticClass:"pic-box"},[_c('img',{attrs:{"src":_vm.tables[ind*2+i].playbill.playbill_small || _vm.tables[ind*2+i].playbill.playbill,"alt":""}})]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.tables[ind*2+i].title))])])])}))])}))])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IpTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content fd-content"},[_c('span',{staticClass:"fd-search-result"},[_vm._v("共"+_vm._s(_vm.conductLength)+"个活动")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.numbers !=0),expression:"numbers !=0"}],staticClass:"show-box"},[_c('ul',{staticClass:"show-list"},_vm._l((_vm.conduct),function(item,ind){return (_vm.conduct)?_c('li',{staticClass:"show-list-li",staticStyle:{"height":"178px","margin-bottom":"15px"}},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.detail(item)}}},[_c('div',{staticClass:"show-remd-logo"},[(item.activity)?_c('img',{attrs:{"src":JSON.parse(item.activity.hostunit).host_avatar,"alt":""}}):_vm._e(),_vm._v(" "),(item.hostunit && item.hostunit.host_avatar)?_c('img',{attrs:{"src":item.hostunit.host_avatar,"alt":""}}):_vm._e()]),_vm._v(" "),(item.activity && item.activity.hostunit)?_c('div',{staticClass:"show-remd-tit"},[_vm._v("\n            "+_vm._s(JSON.parse(item.activity.hostunit).channel_name)+"\n          ")]):_vm._e(),_vm._v(" "),(item.hostunit && item.hostunit.channel_name)?_c('div',{staticClass:"show-remd-tit"},[_vm._v("\n            "+_vm._s(item.hostunit.channel_name)+"\n          ")]):_c('div',{staticClass:"show-remd-tit"}),_vm._v(" "),_c('div',{staticClass:"show-remd-bg"},[_c('div',{staticClass:"pic-box"},[(item.activity && item.activity.playbill)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(JSON.parse(item.activity.playbill).playbill_small_h5 + '?p=3&o=2&w=350&h=197'),expression:"JSON.parse(item.activity.playbill).playbill_small_h5 + '?p=3&o=2&w=350&h=197'"}],attrs:{"alt":""}}):_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.playbill.playbill_small_h5 + '?p=3&o=2&w=350&h=197'),expression:"item.playbill.playbill_small_h5 + '?p=3&o=2&w=350&h=197'"}]}),_vm._v(" "),(new Date(item.end_time).getTime()/1 - new Date().getTime() <= '0' || _vm.find.progress == 'off')?_c('em',{staticClass:"pic-box-em",staticStyle:{"top":"-4px","right":"-4px"}},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/off.png',"alt":""}})]):_vm._e()]),_vm._v(" "),(item.item_title)?_c('p',[_vm._v(_vm._s(_vm._f("ellipsis")(item.item_title,18)))]):_c('p',[_vm._v(_vm._s(_vm._f("ellipsis")(item.title,18)))])])])]):_vm._e()})),_vm._v(" "),(_vm.scrill)?_c('div',{staticClass:"content index-content",staticStyle:{"padding-top":"0"}},[_vm._m(0)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JDv8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/NotLogged.cedc2db.png";

/***/ }),

/***/ "K/6q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_newestTpl_vue__ = __webpack_require__("/ugV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tables: '', // 首页最新征集
      tablesName: '', // 首页最新征集数量
      recommend: '', // 首页轮播
      beSelected: '', // 作品展播
      videosName: '', // 作品展播
      twoNumbers: 2, // 轮播个数
      underway: [], // 正在进行
      underway2: [],
      fileItem: null,
      tops: '0',
      data: ''
    };
  },

  methods: {
    fiery: function fiery(type, id, route, customized) {
      // 操作按钮事件
      var hrefHTML = this.hrefHTML(type, id);
      if (customized == 2 || customized == 1) {
        if (hrefHTML) {
          window.location.href = hrefHTML;
        } else {
          this.$router.push({ name: 'Detail', params: { id: id } });
        }
      } else {
        if (hrefHTML) {
          window.location.href = hrefHTML;
        } else {
          if (type == 2) {
            this.$router.push({ name: 'Notice', params: { id: id } });
          } else if (type == 3) {
            this.$router.push({ name: 'list_vote', params: { id: id, active: 1 } });
          } else {
            this.$router.push({ name: 'Detail', params: { id: id } });
          }
        }
      }
    },
    detail: function detail(type, id, route, customized) {
      // 跳转详情页面
      var hrefHTML = this.hrefHTML(type, id);
      if (customized == 2 || customized == 1) {
        if (hrefHTML) {
          window.location.href = hrefHTML;
        } else {
          this.$router.push({ name: 'Detail', params: { id: id } });
        }
      } else {
        if (hrefHTML) {
          window.location.href = hrefHTML;
        } else {
          if (type == 2) {
            this.$router.push({ name: 'Notice', params: { id: id } });
          } else if (type == 3) {
            this.$router.push({ name: 'list_vote', params: { id: id, active: 1 } });
          } else {
            this.$router.push({ name: 'Detail', params: { id: id } });
          }
        }
      }
    },
    linkpic: function linkpic() {
      // 图片尺寸
      var linkpic = Math.ceil($('.linkpic-box').width() / 2);
      $('.linkpic-box').find('img').css('height', linkpic);

      // banner图片尺寸控制 2:1
      var bannerpic = Math.ceil($('.banner').width() / 2);
      $('.banner').find('img').css('height', bannerpic);

      // 图片尺寸控制 16:9
      var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
      $('.pic-box').find('img').css({ height: picHimg, visibility: 'visible' });
    }
  },
  components: { // 渲染页面
    NewestTpl: __WEBPACK_IMPORTED_MODULE_0__template_newestTpl_vue__["a" /* default */]
  },
  created: function created() {
    // 首页轮播
    var that = this;
    $('.id-nav-recom').eq(0).addClass('nav-on').siblings().removeClass('nav-on');
    var Recommend = {
      activity_id: '0',
      type: 'indexpic',
      pagesize: '6',
      page: 1
    };
    this.$http.get(API.GetRecommend, { params: Recommend }).then(function (res) {
      if (res.code == '0') {
        that.recommend = res.data;
        that.$nextTick(function () {
          var swiper1 = new Swiper('.banner', {
            pagination: '.swiper-pagination',
            paginationType: 'custom',
            paginationCustomRender: function paginationCustomRender(swiper, current, total) {
              var lineWidth = 100 / total - 0.4;
              var str = '';
              for (var i = 0; i < total; i++) {
                if (i == current - 1) {
                  str += "<span class='spanline-class spanline-active' style='width:" + lineWidth + "%'></span>";
                } else {
                  str += "<span class='spanline-class' style='width:" + lineWidth + "%'></span>";
                }
              }
              return str;
            },
            paginationClickable: true,
            autoplayDisableOnInteraction: false,
            autoplay: 4000,
            loop: true
          });
          setTimeout(function () {
            var linkpic = Math.ceil($('.linkpic-box').width() / 2);
            $('.linkpic-box').find('img').css('height', linkpic);
            that.linkpic();
          }, 200);
        });
        // 分享微信
        that.$http.get(API.GetShareInfo, { params: { module: 'home' } }).then(function (res) {
          if (res.code == 0) {
            var title = '',
                desc = '';
            var metas = $('head').children('meta');
            if (res.data.share_title) {
              title = res.data.share_title;
            } else {
              title = '央视喊你上电视';
            }
            if (res.data.share_contents) {
              desc = res.data.share_contents;
            } else {
              desc = '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动';
            }
            var dataName = {
              title: title,
              desc: desc,
              imgAddress: res.data.share_pic || that.recommend[0].img_path_h5,
              Retain: '', // 保留
              url: API.UrlName
            };
            that.weixinShare(dataName);
          }
        });
      }
    });
    // 作品展播
    /*
    var indexVideo = {
      activity_id: '0',
      type: 'indexvideo',
      pagesize: '10',
      page: 1
    };
    this.$http.get(API.RecommendFile, {params: indexVideo})
      .then(function (res) {
        if (res.code == '0') {
           that.videosName = Math.floor(res.data.length / 2);
          that.beSelected = res.data;
           that.$nextTick(function () {
            var swiper2 = new Swiper('.show-work', {
              autoplay: 4000,
              loop: true
            });
            // 图片尺寸控制 16:9
            var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
            $('.pic-box').find('img').css({height: picHimg, visibility: 'visible'});
          })
         }
      });
      */
    //首页最新征集
    /*
    var GetActivities = {
      pagesize: '4',
      page: 1,
      progress: 'on',
      version: 2
    };
    this.$http.get(API.GetActivities, {params: GetActivities})
      .then(function (res) {
        if (res.code == '0') {
          that.tablesName = Math.floor(res.data.length / 2);
          that.tables = res.data;
          that.$nextTick(function () {
            var swiperPoll = new Swiper('.show-poll-swiper', {
              loop: true,
              autoplayDisableOnInteraction: false
            });
            // 图片尺寸控制 16:9
            setTimeout(function () {
              var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
              $('.pic-box').find('img').css({height: picHimg, visibility: 'visible'});
            }, 200);
           });
        }
      });
    */
    // 正在进行
    this.$http.get(API.GetHomeOnList).then(function (res) {
      if (res.code == '0') {
        for (var i = 0; i < res.data.length; i++) {
          // if (i < 3 && res.data[i].item_id) {
          //   that.underway.push(res.data[i])
          // } else {
          //   that.underway2.push(res.data[i])
          // }
          that.underway.push(res.data[i]);
        }
        that.$nextTick(function () {
          var linkpic = Math.ceil($('.linkpic-box').width() / 2);
          $('.linkpic-box').find('img').css('height', linkpic);
        });
      }
    });
  },
  mounted: function mounted() {
    // 操作DOM
    var that = this;

    $(function () {
      $('.index-content').on('click', '.broadcast', function () {
        var item = JSON.parse($(this).attr('attr-item'));
        var type = $(this).attr('attr-type');
        if (type == 'recommend') {
          that.detail(item.url, item.item_id, item.img_path_h5, item.type);
        } else if (type == 'tablesName') {
          that.detail(item.url, item.id, item.img_path, item.type);
        }
      });
      setTimeout(function () {
        // 图片尺寸控制 2:1
        that.linkpic();
      }, 2000);
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "K31e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("I4t6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b3cf50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("Y5PF");
function injectStyle (ssrContext) {
  __webpack_require__("LgQP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b3cf50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KDTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loginAlert_quick_vue__ = __webpack_require__("dFj8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loginAlert_signIn_vue__ = __webpack_require__("T4fS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loginAlert_thirdparty_vue__ = __webpack_require__("cOOe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //thirdParty: navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1? false : true
      thirdParty: true
    };
  },

  methods: {
    //操作按钮事件
  },
  components: { //渲染页面
    Quick: __WEBPACK_IMPORTED_MODULE_0__loginAlert_quick_vue__["a" /* default */],
    SignIn: __WEBPACK_IMPORTED_MODULE_1__loginAlert_signIn_vue__["a" /* default */],
    Thirdparty: __WEBPACK_IMPORTED_MODULE_2__loginAlert_thirdparty_vue__["a" /* default */]
  },
  created: function created() {},
  mounted: function mounted() {
    //操作DOM
    var that = this;
    function ready() {
      if (window.__wxjs_environment === 'miniprogram') {
        that.thirdParty = false;
      }
    }
    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', ready, false);
    } else {
      ready();
    }
  }

});

/***/ }),

/***/ "KGJr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KupL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_footer_vue__ = __webpack_require__("YvlE");


var _data$methods$compone;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (_data$methods$compone = {
  data: function data() {
    return {
      videoDetails: '',
      progress: '',
      progress2: '',
      detailsTxte: '',
      UUID: '',
      contact: false
    };
  },

  methods: {
    contactFn: function contactFn() {
      var that = this;
      that.contact = !that.contact;
      if (that.contact) {
        $('.videoDetails-p').css({ 'height': 'auto' });
      } else {
        $('.videoDetails-p').css({ 'height': '0' });
      }
    },
    playup: function playup(uuid) {
      // 点赞
      var that = this;
      if (!$('.play-up').hasClass('play-uped')) {
        var videoFavorite = {
          file_id: uuid,
          version: 2
        };
        that.$http.get(API.VideoFavorite, { params: videoFavorite }).then(function (res) {
          if (res.code == 0) {
            $('.play-up').addClass('play-uped');
            $('.play-up').find('em').html('+1').addClass('em-animt');
            $('.play-up').find('span').text(parseInt($('.play-up').find('span').text()) + 1);
          }
        });
      } else {
        var videoFavorite = {
          file_id: uuid,
          version: 2
        };
        that.$http.get(API.VideoFavorite, { params: videoFavorite }).then(function (res) {
          if (res.code == 0) {
            $('.play-up').removeClass('play-uped');
            $('.play-up').find('span').text(parseInt($('.play-up').find('span').text()) - 1);
          }
        });
      }
    },
    fn: function fn() {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'Discovery' });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
    relatedVideo: function relatedVideo() {
      // 相关视频展开收起
      $('.show-v-more').hide();
      $('.show-list-all').show();
      $('.show-list-less').hide();
    },
    activityDeployment: function activityDeployment() {
      // 活动详情展开
      document.querySelector('.video-content-down').style.top = '120%';
      document.querySelector('.video-content').style.height = 'auto';
    },
    movableRetraction: function movableRetraction() {
      // 活动详情收起
      document.querySelector('.video-content-down').style.top = '0';
      document.querySelector('.video-content').style.height = '300px';
    },
    fetchData: function fetchData() {
      window.location.reload();
    }
  },
  components: { // 渲染页面
    PointFooter: __WEBPACK_IMPORTED_MODULE_1__template_footer_vue__["a" /* default */]

  },
  created: function created() {
    var self = this;
    self.fetchData();
  },

  watch: {
    '$route': 'fetchData'
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$methods$compone, 'created', function created() {
  //ajax
  $("#loading").show();
  var id = this.$route.params.id,
      that = this;
  that.UUID = this.$route.params.uuid;
  if (that.IsPC()) {
    window.location.href = API.IsPcName;
  }

  // 视频详情
  var getVideoInfo = {
    file_id: that.UUID,
    type: 1,
    version: 2
  };

  that.$http.get(API.GetVideoInfo, { params: getVideoInfo }).then(function (res) {
    if (res.code == 0) {
      that.videoDetails = res.data;
      // 微信分享
      that.$http.get(API.GetShareInfo, { params: { module: 'home' } }).then(function (res) {
        var title = '',
            desc = '';
        var metas = $('head').children('meta');
        if (res.data.share_title) {
          title = res.data.share_title;
        } else {
          if (that.videoDetails.activity_title) {
            title = that.videoDetails.activity_title;
          } else {
            title = '上电视';
          }
        }
        if (res.data.share_contents) {
          desc = res.data.share_contents;
        } else {
          desc = that.videoDetails.title;
        }
        document.title = that.videoDetails.title;
        metas[1].content = that.videoDetails.description;
        var dataName = {
          title: '我参加' + title + '活动',
          desc: that.removeTAG(desc, 110),
          imgAddress: that.videoDetails.thumb_path,
          Retain: '', // 保留
          url: API.UrlName + 'video/' + that.id + '/' + that.UUID
        };
        that.weixinShare(dataName);
      });
    }

    if (id && id != 'null') {
      that.$http.get(API.GetActivitieById, { params: { id: id } }).then(function (res) {
        if (res.code == 0) {
          that.detailsTxte = res.data;
        }
      });
      // 相关视频
      var getRelatedVideo = {
        type: 1,
        activity_id: id,
        pagesize: 4
      };
      that.$http.get(API.FileRelatedVideo, { params: getRelatedVideo }).then(function (res) {
        if (res.code == 0) {
          console.log(res);
          that.progress = res.data;
        } else {
          console.log('请求数据信息出错');
        }

        that.$nextTick(function () {
          // 图片尺寸控制 16:9
          var picWimg = $('.pic-box').width();
          var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
          $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
        });
      });
      var getRelatedVideo2 = {
        type: 1,
        activity_id: id,
        pagesize: 10
      };
      that.$http.get(API.FileRelatedVideo, { params: getRelatedVideo2 }).then(function (res) {
        if (res.code == 0) {
          that.progress2 = res.data;
          if (that.progress2 < 4) {
            $('.show-v-more').hide();
          }
        } else {
          console.log('请求数据信息出错');
        }
        that.$nextTick(function () {
          //图片尺寸控制 16:9
          var picWimg = $('.pic-box').width();
          var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
          $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
        });
      });
    } else {
      $('.show-box').hide();
      $('.v-head').hide();
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$methods$compone, 'mounted', function mounted() {
  // 操作DOM
  var that = this;
  // js判断是不是微信浏览器
  function isweixin() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  }

  setTimeout(function () {
    // 视频播放
    that.VideoPlay(that.UUID);
    var videoTit = document.querySelector('.v-tit');
    if (isweixin()) {
      videoTit.style.display = 'none';
    } else {
      videoTit.style.display = 'block';
    }
    $("#loading").hide();
  }, 500);
}), _data$methods$compone);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "LJJC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);

/**
 * http配置
 */



// axios 配置
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.timeout = 1000000;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true; //请求带上cookie
// axios.defaults.baseURL = 'http://api.yue360.cn'
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// http request 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  if (config.method === 'post') {
    config.data = __WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify(config.data);
  }
  // if (store.state.token) {
  //   config.headers.Authorization = `TBox token ${store.state.token}`
  // }
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

// http response 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  // token 已过期，重定向到登录页面
  /*  if (response.data.code === 1001) {
      router.replace({
        path: '/login',
        query: {redirect: router.currentRoute.fullPath}
      })
    }    if (response.data.code === 1001) {
      router.replace({
        path: '/login',
        query: {redirect: router.currentRoute.fullPath}
      })
    }*/
  return response.data;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 401 清除token信息并跳转到登录页面
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace({
          path: '/login',
          query: { redirect: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath }
        });
    }
  }
  console.log(error);
  // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ "LgQP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lh0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EntryformVue"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content entry-content content-entryform"},[_c('div',{staticClass:"et-banner dl-banner"},[(_vm.route)?_c('img',{attrs:{"src":_vm.route,"alt":""}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"et-modal-white"})]),_vm._v(" "),_c('div',{staticClass:"et-tabinner"},[_c('div',{staticClass:"et-tabhead"},[(_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.form_back&&_vm.detailsTxte.page_config.form_back.is_show=='1')?_c('span',{staticClass:"et-back"},[_c('i',{staticClass:"icon-back"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.detailsTxte.page_config.form_back.url}},[_vm._v(_vm._s(_vm.detailsTxte.page_config.form_back.title))])]):_c('span',{staticClass:"et-back",on:{"click":_vm.detail}},[_c('i',{staticClass:"icon-back"}),_vm._v("\n            详情\n          ")]),_vm._v(" "),_c('div',{staticClass:"et-tabtn"},[_c('div',{staticClass:"et-tabtn",attrs:{"id":"but-tabtn"}},[_c('span',{class:_vm.category?'btn-et-form et-form-on':_vm.btn-_vm.et-_vm.form,on:{"click":_vm.form}},[_c('i',{staticClass:"icon-form"}),_vm._v("表单\n              ")]),_vm._v(" "),(_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.attention_title&&_vm.detailsTxte.page_config.attention_title.is_show=='1')?_c('span',{class:_vm.category?'btn-et-form':'btn-et-form et-form-on',on:{"click":_vm.xz}},[_c('i',{staticClass:"icon-notice"}),_vm._v("\n                "+_vm._s(_vm.detailsTxte.page_config.attention_title.title)+"\n              ")]):_c('span',{class:_vm.category?'btn-et-form':'btn-et-form et-form-on',on:{"click":_vm.xz}},[_c('i',{staticClass:"icon-notice"}),_vm._v("须知\n              ")])])])]),_vm._v(" "),_c('router-view',{attrs:{"detailsTxte":_vm.detailsTxte,"userId":_vm.userId}})],1)]),_vm._v(" "),(_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.cctvheader&&_vm.detailsTxte.page_config.cctvheader.is_show!=0)?_c('PointFooter'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"process-modal large-info-modal modal fade",attrs:{"id":"processModal","role":"dialog","data-backdrop":"static","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"0"}},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('a',{staticClass:"btn-pl-giveup btn-pl-start",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.CloseUpload}},[_vm._v("取  消")])])])])])]),_vm._v(" "),_c('div',{staticClass:"entry-modal large-info-modal modal fade",attrs:{"id":"entryModal","role":"dialog","data-backdrop":"static","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"50px"}},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('i',{staticClass:"icon-man"}),_vm._v(" "),_c('p',{staticClass:"el-txt"},[_vm._v(_vm._s(_vm.modalTit))]),_vm._v(" "),_c('p',{staticStyle:{"color":"#666","text-align":"center"}},[_vm._v("参与ID："),_c('span',{staticStyle:{"color":"#cf5454"}},[_vm._v(_vm._s(_vm.userId))])]),_vm._v(" "),(_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.form_back&&_vm.detailsTxte.page_config.form_back.is_show!='1')?_c('a',{staticClass:"el-avt",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.myActivitys}},[_c('i',{staticClass:"icon-entry"}),_vm._v("进入我的活动查看进度")]):_vm._e(),_vm._v(" "),(_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.form_back&&_vm.detailsTxte.page_config.form_back.is_show=='1')?_c('a',{staticClass:"btn-el-red btn-el-continue",staticStyle:{"font-size":"16px"},attrs:{"href":_vm.detailsTxte.page_config.form_back.url}},[_vm._v(_vm._s(_vm.detailsTxte.page_config.form_back.title))]):_c('a',{staticClass:"btn-el-red btn-el-continue",staticStyle:{"font-size":"16px"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.myActivity}},[_vm._v("继续参与")]),_vm._v(" "),_c('a',{staticClass:"btn-el-red btn-el-share",staticStyle:{"font-size":"16px"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.share}},[_vm._v("分享")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{attrs:{"id":"nativeShare"}})])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"modal-confim large-info-modal modal fade",attrs:{"id":"login_Alert","role":"dialog","aria-hidden":"true","attr-type":"load"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"margin-top":"0","width":"100%","height":"100%"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"left":"-1%","top":"-1%","width":"102%","height":"102%"}},[_c('div',{staticClass:"modal-body"},[_c('LoginAler')],1)])])]),_vm._v(" "),_c('div',{staticClass:"shart",on:{"click":_vm.shareHide}},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/weixin.png',"alt":""}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"pl-num"},[_vm._v("已完成："),_c('span',[_vm._v("85")]),_vm._v("%")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-progress"},[_c('div',{staticClass:"pl-gro-bar",staticStyle:{"width":"80%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-ms-box"},[_c('p',[_vm._v("总大小："),_c('span',{staticClass:"SizeBox"},[_vm._v("20")]),_vm._v("M")]),_vm._v(" "),_c('p',[_vm._v("已上传："),_c('span',{staticClass:"SecondBox"},[_vm._v("2")]),_vm._v("M")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"share",staticStyle:{"display":"none","text-align":"center","padding-left":"3px"}},[_c('span',{attrs:{"id":"share_1","data-mode":"prepend","data-image":"","data-sites":"weibo,qq,qzone"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry-modal large-info-modal modal fade",attrs:{"id":"Alert","role":"dialog","data-backdrop":"static","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"Prompt-p"},[_vm._v("请确定信息是否填写完成！")]),_vm._v(" "),_c('button',{staticClass:"buttonZ buttonDiv",attrs:{"data-dismiss":"modal"}},[_vm._v("确  定")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry-modal large-info-modal modal fade",attrs:{"id":"AlertName","role":"dialog","data-backdrop":"static","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"Prompt-p"},[_vm._v("请选择上传文件")]),_vm._v(" "),_c('button',{staticClass:"buttonZ buttonDiv",attrs:{"data-dismiss":"modal"}},[_vm._v("确  定")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry-modal large-info-modal modal fade",attrs:{"id":"participate","role":"dialog","data-backdrop":"static","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"Prompt-p"},[_vm._v("您已经参与过该活动！")]),_vm._v(" "),_c('button',{staticClass:"buttonZ buttonDiv"},[_vm._v("确  定")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"samll-info-modal modal fade",attrs:{"id":"chatModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('i',{staticClass:"icon-modal"}),_vm._v(" "),_c('p',{staticClass:"info-mess"},[_vm._v("留言发布成功啦！")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LjJY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filedetails_vue__ = __webpack_require__("hG2x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1515a999_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filedetails_vue__ = __webpack_require__("e6YN");
function injectStyle (ssrContext) {
  __webpack_require__("qEs0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filedetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1515a999_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filedetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lshr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectmul_vue__ = __webpack_require__("1odT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b2e41a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectmul_vue__ = __webpack_require__("Ys5T");
function injectStyle (ssrContext) {
  __webpack_require__("8N4D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectmul_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b2e41a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectmul_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M4JT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8a4be8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("42xm");
function injectStyle (ssrContext) {
  __webpack_require__("qtTc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8a4be8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__("cTzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_globalFun_js__ = __webpack_require__("jBjh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_globalFun_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__router_globalFun_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_filters_js__ = __webpack_require__("H715");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll__ = __webpack_require__("bqTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_http_js__ = __webpack_require__("LJJC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_ajax_js__ = __webpack_require__("68N7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_uiqr_min_css__ = __webpack_require__("p+jy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_uiqr_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_css_uiqr_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_lib_native_nativeShare_css__ = __webpack_require__("TXEu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_lib_native_nativeShare_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_lib_native_nativeShare_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_swiper_min_css__ = __webpack_require__("GO9e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_css_swiper_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_css_pick_pcc_min_1_0_1_css__ = __webpack_require__("fyAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_css_pick_pcc_min_1_0_1_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_css_pick_pcc_min_1_0_1_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_lib_bootstrap_min_js__ = __webpack_require__("WVzJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_lib_bootstrap_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__static_lib_bootstrap_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_lib_swiper_jquery_min_js__ = __webpack_require__("GTmt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_lib_swiper_jquery_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_lib_swiper_jquery_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_lib_jquery_qqFace_js__ = __webpack_require__("SyNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_lib_jquery_qqFace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_lib_jquery_qqFace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_lib_jquery_share_min_js__ = __webpack_require__("8KO+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_lib_jquery_share_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__static_lib_jquery_share_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_lib_upload_js__ = __webpack_require__("8Txb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_lib_upload_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__static_lib_upload_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_lib_xiyou_player_js__ = __webpack_require__("CZzb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_lib_xiyou_player_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__static_lib_xiyou_player_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_lib_jquery_bxPlayer_js__ = __webpack_require__("SldU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_lib_jquery_bxPlayer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__static_lib_jquery_bxPlayer_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__statistic__ = __webpack_require__("btv/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__static_lib_JSbridge_js__ = __webpack_require__("jgrU");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





 // 全局函数
 // 过滤器

 // 拦截器
 // 全局ajax


//   <!-- css调用 -->











// import '../static/lib/jsddk.js';
/* 视频播放引入 */






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$bridge = __WEBPACK_IMPORTED_MODULE_22__static_lib_JSbridge_js__["a" /* default */];
// import VueBridgeWebview from 'vue-bridge-webview';
// Vue.use(VueBridgeWebview);

// // set default config 
// VueBridgeWebview.config(0,true);

// import VueJsBridge from 'vue-webview-js-bridge';
// Vue.use(VueJsBridge, {
//   debug: true,
//   delay: 200,
//   nativeHandlerName: 'callNativeHandler',
//   mock: false,
//   mockHandler (payload, next) {
//     next(Object.assign({ form: 'native' }, payload))
//   }
// })

// Vue.prototype.$bridge = VueJsBridge;
//import Bridge from '../static/lib/bridge.js';
//Vue.prototype.$bridge = Bridge;


// import { Cascader } from 'element-ui'
// Vue.use(Cascader)
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__router_globalFun_js___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default.a);

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__router_filters_js__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_6__router_filters_js__[key]);
});

//ajax请求
global.API = __WEBPACK_IMPORTED_MODULE_9__router_ajax_js__["a" /* default */];
global._XYVideoPlayer = __WEBPACK_IMPORTED_MODULE_19__static_lib_xiyou_player_js___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_8__router_http_js__["a" /* default */];

var that = this;
//动态添加首页title
__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  //添加mete
  var metas = $("head").children("meta");
  if (to.meta.keywords) {
    metas[1].content = to.meta.keywords;
  }
  //添加title
  document.title = to.meta.title;

  // statistic(to,from);

  next();
});
//统计
__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function (to, from) {
  // ...
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__statistic__["a" /* default */])(to, from);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("7t+N")))

/***/ }),

/***/ "NWG5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content index-content"},[_c('div',{staticClass:"swiper-container banner"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.recommend),function(item){return (_vm.recommend)?_c('div',{staticClass:"swiper-slide bg-cover broadcast",attrs:{"attr-item":JSON.stringify({url: item.url, item_id:item.item_id,img_path_h5: item.img_path_h5,type: item.activity_mini.type}),"attr-type":"recommend"}},[_c('img',{attrs:{"src":item.img_path_h5}}),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"}})]):_vm._e()})),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",staticStyle:{"height":"10px"}})]),_vm._v(" "),_c('div',{staticClass:"id-content-inner"},[(_vm.underway.length > 0)?_c('ul',{staticClass:"id-link",staticStyle:{"padding":"10px 10px 0px 10px"}},_vm._l((_vm.underway),function(item,ind){return _c('li',[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.fiery(item.url,item.id,item.img_path_h5,item.type)}}},[_c('div',{staticClass:"linkpic-box"},[(item.img_path_h5)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.img_path_h5+'?p=3&o=2&w=710&h=399'),expression:"item.img_path_h5+'?p=3&o=2&w=710&h=399'"}]}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"link-title"},[(item.end_time != '')?_c('div',{staticClass:"link-time"},[_c('em',{staticClass:"icon-time"}),_vm._v(_vm._s(_vm._f("orderBy")(item.end_time,item.start_time))+"\n              ")]):_c('div',{staticClass:"link-time"},[_c('em',{staticClass:"icon-time"}),_vm._v("永久有效")]),_vm._v(" "),_c('p',[(item.type == 1)?_c('em',{staticClass:"icon-card"}):_vm._e(),_vm._v(_vm._s(item.item_title))])])])])})):_vm._e(),_vm._v(" "),(_vm.underway2.length > 0)?_c('ul',{staticClass:"id-link",staticStyle:{"padding":"0 10px 10px 10px"},attrs:{"id":"indexUl"}},_vm._l((_vm.underway2),function(item,ind){return _c('li',[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.fiery(item.url,item.id,JSON.parse(item.playbill).playbill_big_h5,item.type)}}},[_c('div',{staticClass:"linkpic-box"},[(item.playbill)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(JSON.parse(item.playbill).playbill_big_h5+'?p=3&o=2&w=710&h=399'),expression:"JSON.parse(item.playbill).playbill_big_h5+'?p=3&o=2&w=710&h=399'"}]}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"link-title"},[(item.end_time != '')?_c('div',{staticClass:"link-time"},[_c('em',{staticClass:"icon-time"}),_vm._v("\n                "+_vm._s(_vm._f("orderBy")(item.end_time,item.start_time))+"\n              ")]):_c('div',{staticClass:"link-time"},[_c('em',{staticClass:"icon-time"}),_vm._v("永久有效")]),_vm._v(" "),_c('p',[(item.type == 1)?_c('em',{staticClass:"icon-card"}):_vm._e(),_vm._v(_vm._s(item.title))])])])])})):_vm._e(),_vm._v(" "),(_vm.underway2.length == 0 && _vm.underway.length == 0)?_c('div',{staticStyle:{"text-align":"center","line-height":"30px","font-size":"14px","color":"#999"}},[_vm._v("暂无数据\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O/Mm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O60Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mobilePhone: '', // 手机号
      telYzm: '', // 验证码
      Time: 11,
      falseHints: false,
      falseHintsHtml: '',
      yzmMess: false,
      clicked: true,
      //thirdParty: navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1? false : true,
      thirdParty: true,
      num: 180,
      telYzmMess: false,
      telYzmMessHtml: ''
    };
  },

  methods: {
    fn: function fn() {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'home' });
      } else {
        this.$router.back(-1);
      }
    },
    puts: function puts() {

      var that = this;
      if (that.num != 180) {
        return false;
      }
      that.num = 180;
      if (!that.mobilePhone) {
        that.falseHints = true;
        that.falseHintsHtml = '请输入手机号';
        return false;
      }
      // 验证手机号是否为空
      if (that.mobilePhone.match(/^1[3|5|6|7|8|9|][0-9]{9}$/) !== null) {
        that.falseHints = false;
      } else {
        that.falseHints = true;
        that.falseHintsHtml = '手机号格式不正确';
        return false;
      }
      var data = {
        method: 'getRequestVerifiCodeM',
        mobile: that.mobilePhone,
        verfiCodeType: '1',
        verificationCode: '4',
        isCheckCode: '1'
      };
      // https://reg.cctv.com/regist/getVerifiCode.action?p1
      $.ajax({
        url: 'https://reg.cctv.com/mobile/regist/getVerifiCode.action',
        data: data,
        dataType: 'jsonp',
        success: function success(mes) {
          console.log(mes);
          if (mes.errtype == 'success' || mes.errmsg == '成功') {
            var set = setInterval(function () {
              that.num = that.num - 1;
              $('.btn-yzm').html(that.num + '秒');
              if (that.num <= 0) {
                $('.btn-yzm').html('发送验证码');
                clearInterval(set);
                that.num = 180;
              }
            }, 1000);
          } else if (mes.errtype == 'sendagain') {
            that.falseHints = true;
            that.falseHintsHtml = '验证过于频繁,请稍后重试';
          }

          if (mes.errtype == 'mobilecodeerror') {
            that.falseHints = true;
            that.falseHintsHtml = '验证过于频繁,请稍后重试';
          }
          if (mes.errtype == 'ipsendagain') {
            that.falseHints = true;
            that.falseHintsHtml = '验证过于频繁,请稍后重试';
          }
          if (mes.errtype == 'mobileoften') {
            that.falseHints = true;
            that.falseHintsHtml = '验证过于频繁,请稍后重试';
          }
          if (mes.errtype == 'registered') {
            $('#phone-mess').show();
            $('#phone-mess').html(mes.errmsg);
          }
        }
      });
    },
    login: function login() {
      var that = this;
      that.falseHints = false;
      that.yzmMess = false;
      that.telYzmMess = false;
      if (!that.mobilePhone) {
        that.falseHints = true;
        that.falseHintsHtml = '请输入手机号';
        return false;
      }
      // 验证手机号是否为空
      if (that.mobilePhone.match(/^1[3|5|6|7|8|9|][0-9]{9}$/) !== null) {
        that.falseHints = false;
      } else {
        that.falseHints = true;
        that.falseHintsHtml = '手机号格式不正确';
        return false;
      }
      if (!that.telYzm) {
        that.telYzmMess = true;
        that.telYzmMessHtml = '请输入手机验证码';
        return false;
      }
      var url = encodeURI('https://ishow.xiyou.cctv.com/');
      $.ajax({
        url: 'https://reg.cctv.com/mobile/mobileRegAndLogin.action',
        data: {
          mobile: that.mobilePhone,
          verifyCode: that.telYzm,
          from: url,
          service: 'https://ishow.cctv.comindex.html#/home/index',
          checkCode: '1'
        },
        dataType: 'jsonp',
        success: function success(mes) {
          console.log(mes);
          if (mes.errType == '0' || mes.errMsg == '"成功"') {
            /*   that.setCookie('userSeqId',mes.user_seq_id);*/
            // that.$router.push({name: 'home'})


            //that.$router.push({name: 'MyMessage'})


            // console.log(that.$router);
            // console.log(that.$router.history.current.params.from);
            var fromPath = that.$router.history.current.params.from;
            console.log('fromPath:', fromPath);
            if (fromPath) {
              that.$router.push({ path: '' + fromPath });
            } else {
              that.$router.push({ name: 'MyMessage' });
            }
          }
          if (mes.errType != '0') {
            alert(mes.errMsg);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    // 判断是否是小程序
    var that = this;
    function ready() {
      if (window.__wxjs_environment === 'miniprogram') {
        that.thirdParty = false;
      }
    }
    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', ready, false);
    } else {
      ready();
    }
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "OO0n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_active_vue__ = __webpack_require__("u1cn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8271cfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_active_vue__ = __webpack_require__("QBPf");
function injectStyle (ssrContext) {
  __webpack_require__("Tn1W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_active_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8271cfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_active_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OVcu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notFound_vue__ = __webpack_require__("vhe0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5725b89c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notFound_vue__ = __webpack_require__("23u4");
function injectStyle (ssrContext) {
  __webpack_require__("jpCD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5725b89c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5725b89c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P5R9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PmP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_voteAlert_vue__ = __webpack_require__("3NbP");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: true,
      id: '',
      NumberName: 10,
      page: 0,
      type: 1,
      orderObj: {
        order: 'id',
        sort: 'SORT_DESC'
      },
      getVoteList: {},
      voteList: [],
      voteListL: [],
      voteListR: [],
      route: '',
      total: 0,
      voteActives: true,
      textSearck: '',
      busy: true,
      noMore: false,
      voteTable: false,
      getState: false,
      leave: false,
      LH: 0,
      RH: 0,
      LW: 0
    };
  },

  components: {
    VoteAlert: __WEBPACK_IMPORTED_MODULE_4__template_voteAlert_vue__["a" /* default */]
  },
  computed: {
    finite: function finite() {
      return this.busy || this.noMore || this.leave;
    }
  },
  methods: {
    //操作按钮事件
    fn: function fn() {
      // console.log(0)
      var num = [],
          that = this;
      var getVoteList = {
        type: 1,
        activity_id: that.id,
        page: 1,
        pagesize: that.NumberName,
        order: 'id',
        sort: 'SORT_DESC'
      };
      var getVoteList2 = {
        type: 2,
        activity_id: that.id,
        page: 1,
        pagesize: that.NumberName,
        order: 'id',
        sort: 'SORT_DESC'
      };
      var getList = function getList(params) {
        return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          that.$http.get(API.GetGetVoteList, { params: params }).then(function (res) {
            resolve(res);
          });
        });
      };
      var getLists = function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
          var video, image;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return getList(getVoteList);

                case 2:
                  video = _context.sent;
                  _context.next = 5;
                  return getList(getVoteList2);

                case 5:
                  image = _context.sent;
                  return _context.abrupt('return', { video: video, image: image });

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function getLists() {
          return _ref.apply(this, arguments);
        };
      }();
      getLists().then(function (res) {
        var video = res.video,
            image = res.image;

        if (video.code == 0 && image.code == 0) {
          if (video.total <= 0 && image.total <= 0) {
            that.$router.push({ name: 'Detail', params: { id: that.id } });
            return;
          }
          if (video.total > 0 && image.total > 0) {
            that.voteTable = true;
          }
          if (video.total > 0 && image.total <= 0) {
            that.type = 1;
            that.voteTable = false;
          }
          if (video.total <= 0 && image.total > 0) {
            that.type = 2;
            that.voteTable = false;
          }
          // that.getState = true;
          that.busy = false;
          that.loadMore();
        } else {
          console.log(res);
        }
      }).catch(function (e) {
        console.log(e);
      });

      // that.$http.get(API.GetGetVoteList, {params: getVoteList})
      //   .then(function (res) {
      //   if(res.code == 0 && res.total > 0){
      //     console.log('1')
      //     that.$http.get(API.GetGetVoteList, {params: getVoteList2})
      //       .then(function (res) {
      //         console.log('2')
      //         if(res.code == 0 && res.total > 0){
      //           // $('.vote-table').show()
      //           that.voteTable = true;
      //         }else{
      //           // $('.vote-table').hide()
      //           that.voteTable = false;
      //           that.type = 1;
      //         }
      //         that.getState = true;
      //         that.loadMore();
      //     })
      //   }else{
      //     that.$http.get(API.GetGetVoteList, {params: {...that.getVoteList,type:2}})
      //       .then(function (res) {
      //       if(res.code == 0 && res.total > 0){

      //         that.type = 2;
      //       }else{
      //           that.$router.push({name: 'Detail', params: {id: that.id}})
      //       }
      //       // $('.vote-table').hide();
      //       that.voteTable = false;
      //       that.voteActives = false;
      //       that.getState = true;
      //       that.loadMore();

      //     })
      //   }
      // });
    },
    searchCon: function searchCon() {
      // if(this.textSearck != ''){
      //   if(this.voteActives) {
      //     this.getVoteList = {
      //       activity_id: this.id,
      //       page: 1,
      //       type: val,
      //       pagesize: this.NumberName,
      //       order: 'id',
      //       sort: 'SORT_DESC'
      //     }
      //   }else{
      //     this.getVoteList = {
      //       activity_id: this.id,
      //       page: 2,
      //       type: val,
      //       pagesize: this.NumberName,
      //       order: 'id',
      //       sort: 'SORT_DESC'
      //     }
      //   }
      // }
    },
    preview: function preview(item) {
      /*  console.log(item)
        var item = item
        console.log()*/
    },
    detail: function detail() {
      this.$router.push({ name: 'Detail', params: { id: this.id } });
    },
    form: function form(val) {
      if (this.busy) return; //数据加载中...
      if (val == 1) {
        //判断是投票还是排名
        this.category = true;
        this.orderObj = {
          order: 'id',
          sort: 'SORT_DESC'
        };
      } else {
        this.category = false;
        this.orderObj = {
          order: 'vote_count',
          sort: 'SORT_DESC'
        };
      }
      this.page = 0;
      this.voteList = [];
      this.voteListL = [];
      this.voteListR = [];
      this.noMore = false;

      this.loadMore();
      //this.$router.push({name: 'Notice', query: {route: this.route, id: this.id}})
    },
    voteActive: function voteActive(val) {
      if (this.busy) return; //数据加载中...
      if (val == 1) {
        //判读是点击视频还是图片 （视频）
        this.voteActives = true;
        this.type = 1;
      } else {
        //判读是点击视频还是图片（图片）
        this.voteActives = false;
        this.type = 2;
      }

      this.page = 0;
      this.voteList = [];
      this.voteListL = [];
      this.voteListR = [];
      this.noMore = false;

      this.loadMore();
      // $('.footer').hide();
    },
    fetchData: function fetchData() {
      var that = this;
      that.getVoteList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, that.orderObj, {
        activity_id: that.id,
        page: that.page,
        type: that.type,
        pagesize: that.NumberName
      });
      that.$http.get(API.GetGetVoteList, { params: that.getVoteList }).then(function (res) {
        // console.log(4)
        if (res.code == 0) {
          var _data = res.data;
          that.total = res.total;

          that.loadImg(res);
        }
      });
    },
    loadImg: function loadImg(res) {
      var that = this;
      var data = res.data;
      var total = res.total;
      var idx = 0;
      var NH,
          NW,
          CH,
          OH = 100;
      var img = new Image();
      function loadNext(idx) {
        if (idx >= data.length) {
          that.busy = false;
          if (that.voteList.length >= total) {
            that.noMore = true;
          }
          return;
        }

        if (that.type == 1) {
          img.src = data[idx].thumb_path + '?p=3&o=2&w=350&h=197';
        } else {
          img.src = data[idx].file_path + '?p=3&o=2&w=350&h=197';
        }
        img.onload = img.onerror = function () {
          NW = img.naturalWidth;
          NH = img.naturalHeight;
          CH = NH / NW * that.LW || OH;
          if (that.getMinUl()) {
            that.voteListL.push(data[idx]);
            that.LH += CH;
          } else {
            that.voteListR.push(data[idx]);
            that.RH += CH;
          }
          that.voteList.push(data[idx]);
          idx++;
          loadNext(idx);
        };
      }
      loadNext(idx);
    },
    loadMore: function loadMore() {
      // console.log('3')
      // if(!this.getState) return;
      if (this.busy == false) {
        // setTimeout(() => {
        this.busy = true;
        this.page++;

        this.fetchData();
        // }, 500)
      }
    },
    getMinUl: function getMinUl() {
      //每次获取最短的ul,将图片放到其后

      // var L = this.$refs.listL;
      // var R = this.$refs.listR;
      // var LH = L.offsetHeight;
      // var RH = R.offsetHeight;
      // return LH <= RH ? true : false;
      return this.LH <= this.RH ? true : false;
    }
  },

  created: function created() {
    this.id = this.$route.params.id;

    var that = this;
    that.fn();

    //分享微信
    $.getJSON(API.GetActivitieById + '?jsoncallback=?&id=' + that.id, function (res) {
      that.detailsTxte = res.data;
      if (res.code == 0) {
        //分享微信
        var title = '',
            desc = '';
        if (that.detailsTxte.share_config) {
          var activity = that.detailsTxte.share_config.activity;
          if (activity != 'undefined' && activity && activity.share_title) {
            title = activity.share_title;
          } else {
            title = that.detailsTxte.title;
          }
          if (activity != 'undefined' && activity && activity.share_contents) {
            desc = activity.share_contents;
          } else {
            desc = that.detailsTxte.description;
          }
        } else {
          title = that.detailsTxte.title;
          desc = that.detailsTxte.description;
        }
        document.title = title;
        var metas = $('head').children('meta');
        metas[1].content = desc;
        var dataName = {
          title: '我参加' + title + '活动，快帮我投票', //分享标题
          desc: desc, //metas[1].content,//分享简介(内容)
          imgAddress: that.route, //分享图片地址
          Retain: '', //保留
          url: window.location.href //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
        };
        that.weixinShare(dataName);
      }
    });
  },
  mounted: function mounted() {
    //操作DOM
    var that = this;
    this.LW = this.$refs.listL.offsetWidth;
  },
  activated: function activated() {
    this.leave = false;
  },
  deactivated: function deactivated() {
    this.leave = true;
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Q9Fz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QBPf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"content index-content",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"10"}},[(_vm.items.length)?_c('div',{staticClass:"content fd-content",staticStyle:{"padding-top":"0"}},[_c('span',{staticClass:"fd-search-result"},[_vm._v("共"+_vm._s(_vm.itemTotal)+"个活动")]),_vm._v(" "),_c('div',{staticClass:"show-box"},[_c('ul',{staticClass:"show-list"},_vm._l((_vm.items),function(item,ind){return (_vm.items)?_c('li',{key:ind,staticClass:"show-list-li"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.route(item.id)}}},[_c('div',{staticClass:"show-remd-logo"},[(item.hostunit)?_c('img',{attrs:{"src":item.hostunit.host_avatar,"alt":""}}):_vm._e()]),_vm._v(" "),(item.hostunit)?_c('div',{staticClass:"show-remd-tit"},[_vm._v("\n                "+_vm._s(item.hostunit.channel_name)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"show-remd-bg"},[_c('div',{staticClass:"pic-box"},[(item.playbill)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.playbill.playbill_small_h5 +'?p=3&o=2&w=350&h=197'),expression:"item.playbill.playbill_small_h5 +'?p=3&o=2&w=350&h=197'"}]}):_vm._e()]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.title))])])])]):_vm._e()})),_vm._v(" "),_c('div',[_c('div',{staticClass:"id-content-inner"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.busy),expression:"!busy"}],staticClass:"loader"},[_vm._m(0)])])])])]):_c('div',{staticClass:"content fd-content",staticStyle:{"padding-top":"0","padding-bottom":"44px"}},[_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fd-search-none"},[_c('div',{staticClass:"content index-content"},[_c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QBsP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"voteList",attrs:{"infinite-scroll-disabled":"finite","infinite-scroll-distance":"40"}},[_c('div',{staticClass:"et-tabhead"},[_c('span',{staticClass:"et-back",on:{"click":_vm.detail}},[_c('i',{staticClass:"icon-back"}),_vm._v("\r\n          详情\r\n        ")]),_vm._v(" "),_c('div',{staticClass:"et-tabtn"},[_c('div',{staticClass:"et-tabtn",attrs:{"id":"but-tabtn"}},[_c('span',{class:_vm.category?'btn-et-form et-form-on':'btn-et-form',on:{"click":function($event){_vm.form(1)}}},[_c('i',{staticClass:"icon-form"}),_vm._v("投票\r\n                ")]),_vm._v(" "),_c('span',{class:_vm.category?'btn-et-form':'btn-et-form et-form-on',on:{"click":function($event){_vm.form(2)}}},[_c('i',{staticClass:"icon-vote"}),_vm._v("排名\r\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"list show-box",staticStyle:{"margin-top":"6px"}},[_c('div',{staticClass:"vote_search"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.voteTable),expression:"voteTable"}],staticClass:"vote-table"},[_c('span',{class:_vm.voteActives?'video voteActive':'video',on:{"click":function($event){_vm.voteActive(1)}}},[_vm._v("视频")]),_vm._v(" "),_c('span',{class:!_vm.voteActives?'image voteActive':'image',on:{"click":function($event){_vm.voteActive(2)}}},[_vm._v("图片")])]),_vm._v(" "),_c('ul',{ref:"listL",staticClass:"show-list"},_vm._l((_vm.voteListL),function(item,key){return _c('li',{},[_c('a',{staticClass:"VoteList-a vote-border video-border",attrs:{"href":"javascript:void(0);"}},[_c('router-link',{attrs:{"tag":"a","to":{name:'list_preview',params: {id: _vm.id,uuid:item.uuid,ind: item.file_type,activityId: item.activity_id}}}},[_c('div',{staticClass:"pic-box pic-margin"},[(item.file_type == 1)?_c('img',{attrs:{"src":item.thumb_path+'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),(item.file_type == 2)?_c('img',{attrs:{"src":item.file_path+'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),(!item.thumb_path && !item.file_path)?_c('img',{attrs:{"src":"","alt":""}}):_vm._e(),_vm._v(" "),(item.time_span)?_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(item.time_span)))]):_vm._e(),_vm._v(" "),(!_vm.category && item.rank < '100')?_c('em',{staticClass:"icon-ranknum",staticStyle:{"top":"-9px"}},[_vm._v(_vm._s(item.rank))]):_vm._e()]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"vode-user"},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":item.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(item.nickname,14))+"\r\n              ")])]),_vm._v(" "),(!_vm.category)?_c('div',[_c('div',{staticClass:"show-pro"},[_c('div',{staticClass:"show-bar",style:({width: item.vote_count/item.vote_sum*100+'%'})})]),_vm._v(" "),_c('p',{staticClass:"show-poll"},[_c('span',{staticClass:"ranking"},[_vm._v("票数 : "),_c('i',[_vm._v(_vm._s(item.vote_count))])]),_vm._v(" "),_c('span',{staticClass:"votesNumber"},[_vm._v("排名 : "),_c('i',[_vm._v(_vm._s(item.rank))])])])]):_c('div',[_c('div',{class:item.end_time/1 >(new Date()).getTime() && (new Date()).getTime()>item.start_time?'show-btn-poll':'show-btn-poll show-btn-poll-over',attrs:{"activity_id":item.activity_id,"data-id":item.uuid}},[_vm._m(0,true),_vm._v("投票\r\n            ")]),_vm._v(" "),_c('p',{staticClass:"show-poll"},[_c('span',[_vm._v(_vm._s(item.vote_count))]),_vm._v("票\r\n            ")])])],1),_vm._v(" "),_c('div',{staticClass:"vote_bg"})])})),_vm._v(" "),_c('ul',{ref:"listR",staticClass:"show-list"},_vm._l((_vm.voteListR),function(item,key){return _c('li',{},[_c('a',{staticClass:"VoteList-a vote-border video-border",attrs:{"href":"javascript:void(0);"}},[_c('router-link',{attrs:{"tag":"a","to":{name:'list_preview',params: {id: _vm.id,uuid:item.uuid,ind: item.file_type,activityId: item.activity_id}}}},[_c('div',{staticClass:"pic-box pic-margin"},[(item.file_type == 1)?_c('img',{attrs:{"src":item.thumb_path+'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),(item.file_type == 2)?_c('img',{attrs:{"src":item.file_path+'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),(!item.thumb_path && !item.file_path)?_c('img',{attrs:{"src":"","alt":""}}):_vm._e(),_vm._v(" "),(item.time_span)?_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(item.time_span)))]):_vm._e(),_vm._v(" "),(!_vm.category && item.rank < '100')?_c('em',{staticClass:"icon-ranknum",staticStyle:{"top":"-9px"}},[_vm._v(_vm._s(item.rank))]):_vm._e()]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"vode-user"},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":item.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(item.nickname,14))+"\r\n              ")])]),_vm._v(" "),(!_vm.category)?_c('div',[_c('div',{staticClass:"show-pro"},[_c('div',{staticClass:"show-bar",style:({width: item.vote_count/item.vote_sum*100+'%'})})]),_vm._v(" "),_c('p',{staticClass:"show-poll"},[_c('span',{staticClass:"ranking"},[_vm._v("票数 : "),_c('i',[_vm._v(_vm._s(item.vote_count))])]),_vm._v(" "),_c('span',{staticClass:"votesNumber"},[_vm._v("排名 : "),_c('i',[_vm._v(_vm._s(item.rank))])])])]):_c('div',[_c('div',{class:item.end_time/1 >(new Date()).getTime() && (new Date()).getTime()>item.start_time?'show-btn-poll':'show-btn-poll show-btn-poll-over',attrs:{"activity_id":item.activity_id,"data-id":item.uuid}},[_vm._m(1,true),_vm._v("投票\r\n            ")]),_vm._v(" "),_c('p',{staticClass:"show-poll"},[_c('span',[_vm._v(_vm._s(item.vote_count))]),_vm._v("票\r\n            ")])])],1),_vm._v(" "),_c('div',{staticClass:"vote_bg"})])}))]),_vm._v(" "),(_vm.busy)?_c('div',{staticClass:"content index-content",staticStyle:{"padding-top":"0"}},[_vm._m(2)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noMore),expression:"noMore"}],staticClass:"footer",staticStyle:{"text-align":"center","padding":"5px 0 10px 0","color":"#ccc"}},[_vm._v("没有更多了")]),_vm._v(" "),_c('VoteAlert')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-poll"},[_c('em',[_vm._v("+1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-poll"},[_c('em',[_vm._v("+1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R4xh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['show', 'url'],
  data: function data() {
    return {};
  },

  methods: {
    close: function close() {
      this.$emit('update:show', false);
    }
  },
  created: function created() {}
});

/***/ }),

/***/ "R6WS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signUp_vue__ = __webpack_require__("TpSe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c557dfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signUp_vue__ = __webpack_require__("dpmo");
function injectStyle (ssrContext) {
  __webpack_require__("EPHU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c557dfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RUXs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RgoS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rkrw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"scan-mask",on:{"click":_vm.close}},[_c('div',{staticClass:"scan-box"},[_c('img',{attrs:{"src":_vm.url}}),_c('span')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rtkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signIn_vue__ = __webpack_require__("q8Ye");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4c59cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signIn_vue__ = __webpack_require__("6LLI");
function injectStyle (ssrContext) {
  __webpack_require__("he/v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4c59cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rwq8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload uploadImg",attrs:{"is_require":this.UpFile.is_require,"name":this.UpFile.name}},[_c('div',{staticClass:"load-bl"},[_c('h5',{staticClass:"tit"},[_vm._v("\n      "+_vm._s(this.UpFile.title)+"\n      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.UpFile.is_require == 1),expression:"this.UpFile.is_require == 1"}],staticStyle:{"color":"#cf5454","margin-left":"5px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"uploa-bg"},[_c('div',{staticClass:"load-inner"},[_vm._l((_vm.MyUploadImg),function(item,ind){return (_vm.MyUploadImg.length > 0)?_c('div',{staticClass:"load-link load-over videoFile2",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"pic-b pic-v"},[_c('img',{attrs:{"src":item.file.image_url +'?p=3&o=2&w=1000&h=500',"alt":""},on:{"click":function($event){_vm.needScan(ind, item.file.image_url)}}})]),_vm._v(" "),_c('p',{staticClass:"fileName2",staticStyle:{"padding-left":"10px","max-height":"50px"},attrs:{"attr-uuid":item.file_id,"attr-type":"2"}},[_vm._v(_vm._s(item.file.title))])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.fileName2),function(item,ind){return _c('div',{staticClass:"load-link load-over videoFile2",staticStyle:{"margin-bottom":"15px"}},[_c('span',{staticClass:"pic-del",on:{"click":function($event){_vm.updateFile(ind)}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"pic-b pic-v",on:{"click":function($event){_vm.needScan(ind)}}},[_c('img',{attrs:{"src":"/images/audit_2.jpg","alt":""}})]),_vm._v(" "),_c('p',{staticClass:"fileName fileName2",staticStyle:{"padding-left":"10px","max-height":"50px"},attrs:{"attr-uuid":_vm.arrayUuid2[ind],"attr-type":"2"}},[_vm._v(_vm._s(_vm.arrayName2[ind]))])])}),_vm._v(" "),_vm._m(0)],2),_vm._v(" "),(this.UpFile.tip)?_c('p',{ref:"p_info",staticClass:"et-load-info et-img-info",class:_vm.classObj,on:{"click":_vm.allTetx2}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n        "+_vm._s(_vm.upfileTip)+"\n      ")]):_c('p',{staticClass:"et-load-info et-img-info",on:{"click":_vm.allTetx2}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n        支持JPG、GIF、PNG格式，大小不超过100mb的图片\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.4)"},attrs:{"id":"uploadModal2","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"0"}},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_c('div',{staticClass:"group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textName),expression:"textName"}],attrs:{"id":"Textimg","type":"text","placeholder":"请输入名称","maxlength":"20"},domProps:{"value":(_vm.textName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.textName=$event.target.value}}})])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('a',{staticClass:"btn-2 buttonW buttonR",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.cancel2}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start btn-pl-start2 buttonW buttonL",attrs:{"href":"javascript:void(0);"}},[_vm._v("开始上传")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"uploadFile","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"0"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body",attrs:{"id":"modal-body"}},[_c('ul',{staticClass:"uploadFile-ul clearfix",attrs:{"id":"uploadFile-ul"}},_vm._l((_vm.allchannel),function(item,v){return _c('li',[_c('dl',[_c('dt',{staticClass:"pic-box"},[_c('img',{staticStyle:{"border":"none"},attrs:{"src":item.image.thumb_url,"alt":""}})]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(item.image.title))])])])})),_vm._v(" "),(_vm.scrill)?_c('div',{staticClass:"content index-content",staticStyle:{"padding-top":"0"}},[_vm._m(4)]):_vm._e()])])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scan.isScan),expression:"scan.isScan"}],staticClass:"scan-mask",on:{"click":_vm.closeScan}},[_c('div',{staticClass:"scan-box"},[_c('img',{attrs:{"src":_vm.scan.url}}),_c('span')])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-link",attrs:{"id":"videoContainer2"}},[_c('div',{staticClass:"pic-b",attrs:{"id":"selectVideo2"}},[_c('input',{attrs:{"type":"file","accept":"image/*","id":"select2"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("名称"),_c('span',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("描述")]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('textarea',{attrs:{"id":"Textareaimg","rows":"3","placeholder":"请输入描述信息,100字以内","maxlength":"100"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-head"},[_vm._v("\n          我的视频\n          "),_c('span',{attrs:{"data-dismiss":"modal"}},[_vm._v("X")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.4)"},attrs:{"id":"uploadImg-al","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"100px"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"detailAlert-p Prompt-p"},[_vm._v("上传格式错误")]),_vm._v(" "),_c('a',{staticClass:"buttonZ",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("确定")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S0vE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S6Kv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_participate_vue__ = __webpack_require__("5DNw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf158cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_participate_vue__ = __webpack_require__("51ZV");
function injectStyle (ssrContext) {
  __webpack_require__("M4JT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_participate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf158cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_participate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SQkT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"44px"}},[_c('div',{staticClass:"MyHeader"},[_c('div',{staticClass:"cbox"},[(_vm.MyPortrait)?_c('div',{staticClass:"MyPortrait MyPortrait_top clearfix"},[_c('div',{staticClass:"MyPortrait_div"},[_c('span',{staticClass:"MyTop",on:{"click":function($event){_vm.fn()}}},[_c('a',{staticClass:"icon-back",attrs:{"href":"javascript:void(0);"}}),_vm._v(" "),_c('i',[_vm._v("返回")])]),_vm._v(" "),_c('div',{staticClass:"My_con"},[_c('img',{attrs:{"src":_vm.headPortrait,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"MyPortraitFile",on:{"click":_vm.showActivityUser}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cbox"},[(_vm.MyPortrait)?_c('div',{staticClass:"MyPortrait"},[_c('h4',[_vm._v(_vm._s(_vm.nickname)+" "),_c('span',{staticClass:"MyPortrait_pa",on:{"click":_vm.signOut}},[_vm._v("退出")])]),_vm._v(" "),_c('p',[_vm._v("用户ID : "+_vm._s(_vm.userId))])]):_c('div',{staticClass:"MyPortrait MyPortrait_top",on:{"click":_vm.login}},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"nav-on"},[_vm._v("点击登录或注册")]),_vm._v(" "),_c('p')])]),_vm._v(" "),(_vm.MyPortrait)?_c('div',{staticClass:"MyMenu"},[_c('router-link',{staticClass:"icon-title",attrs:{"to":"/myparticipate/0","tag":"dl"}},[_c('dd',[_vm._v(_vm._s(_vm.count.event_count))]),_vm._v(" "),_c('dt',[_vm._v("参与的")])]),_vm._v(" "),_c('router-link',{staticClass:"icon-title",attrs:{"to":"/myfollow","tag":"dl"}},[_c('dd',[_vm._v(_vm._s(_vm.count.fav_count))]),_vm._v(" "),_c('dt',[_vm._v("关注的")])]),_vm._v(" "),_c('router-link',{staticClass:"icon-title",attrs:{"to":"/myupload","tag":"dl"}},[_c('dd',[_vm._v(_vm._s(_vm.count.video_count))]),_vm._v(" "),_c('dt',[_vm._v("上传的")])]),_vm._v(" "),_c('router-link',{staticClass:"icon-title",attrs:{"to":"/mynotice","tag":"dl"}},[(_vm.count.msg)?_c('dd',[_vm._v(_vm._s(_vm.count.msg))]):_c('dd',[_vm._v("0")]),_vm._v(" "),_c('dt',[_vm._v("@我的")])])],1):_c('div',{staticClass:"MyMenu",on:{"click":_vm.login}},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"MyConent"},[_c('div',{staticClass:"cbox"},[(_vm.MyPortrait)?_c('div',{staticClass:"MyPerfect ",on:{"click":_vm.showActivityUser}},[_c('h5',[_vm._v("完善我的个人信息")]),_vm._v(" "),_c('p',[_vm._v("个人信息会在报名时自动匹配")])]):_c('div',{staticClass:"MyPerfect",on:{"click":_vm.login}},[_c('h5',[_vm._v("完善我的个人信息")]),_vm._v(" "),_c('p',[_vm._v("个人信息会在报名时自动匹配")])])]),_vm._v(" "),(_vm.TablesName)?_c('h5',{staticClass:"Newest-title"},[_vm._v("最新征集推荐")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"show-box"},[_c('div',{staticClass:"swiper-container show-poll-swiper show-id-swiper"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.TablesName),function(v,ind){return _c('div',{staticClass:"swiper-slide"},[_c('ul',{staticClass:"show-list"},_vm._l((_vm.TwoNumbers),function(val,i){return (_vm.Tables[ind*2+i])?_c('li',{on:{"click":function($event){_vm.route(_vm.Tables[ind*2+i].id)}}},[_c('a',{attrs:{"href":"javascript:void(0);"}},[(_vm.Tables[ind*2+i].hostunit)?_c('div',{staticClass:"show-remd-logo"},[_c('img',{attrs:{"src":_vm.Tables[ind*2+i].hostunit.host_avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.Tables[ind*2+i].hostunit)?_c('div',{staticClass:"show-remd-tit"},[_vm._v("\n                    "+_vm._s(_vm.Tables[ind*2+i].hostunit.channel_name)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{attrs:{"src":_vm.Tables[ind*2+i].playbill.playbill_small_h5 + '?p=3&o=2&w=350&h=197',"alt":""}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.Tables[ind*2+i].title))])])]):_vm._e()}))])}))])])]),_vm._v(" "),_c('div',{staticClass:"nav-bottom"},[_c('router-link',{staticClass:"icon-title",attrs:{"to":"/home"}},[_c('i',{staticClass:"icon-index"}),_vm._v("\n      发现\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"nav-on",attrs:{"to":"/mymessage"}},[_c('i',{staticClass:"icon-mine"}),_vm._v("\n      我的\n    ")])],1),_vm._v(" "),_c('div',{attrs:{"id":"modal_content"}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v("完善个人信息")]),_vm._v(" "),(_vm.myMessage)?_c('div',{staticClass:"z-content"},[_c('p',[_c('label',[_vm._v("姓名")]),_vm._v(" "),_c('input',{staticClass:"myName",attrs:{"type":"text","placeholder":"请输入姓名"},domProps:{"value":_vm.myMessage.name}})]),_vm._v(" "),_c('p'),_vm._v(" "),_c('label',[_vm._v("性别")]),_vm._v(" "),_c('div',{staticClass:"content-myGender"},[_c('span',{staticClass:"conten-span"},[_c('input',{staticClass:"sex",attrs:{"type":"radio","name":"myGender","value":"男"},domProps:{"checked":_vm.myMessage.sex == '男'}}),_vm._v("男")]),_vm._v(" "),_c('span',{staticClass:"conten-span"},[_c('input',{staticClass:"sex",attrs:{"type":"radio","name":"myGender","value":"女"},domProps:{"checked":_vm.myMessage.sex == '女'}}),_vm._v("女")])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("地址")]),_vm._v(" "),_c('Linkage',{attrs:{"text":_vm.address},on:{"message":_vm.listenToMyBoy}}),_vm._v(" "),_c('input',{staticClass:"address",staticStyle:{"display":"none"},attrs:{"type":"text"},domProps:{"value":_vm.region}})],1),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',[_c('label',[_vm._v("电话")]),_vm._v(" "),_c('input',{staticClass:"myTelephone",attrs:{"type":"text","placeholder":"请输入手机号"},domProps:{"value":_vm.myMessage.mobile},on:{"keyup":function($event){_vm.SmallKeyup($event)}}}),_vm._v(" "),_c('span',{staticStyle:{"display":"none","font-size":"14px","color":"#C8494E"}},[_vm._v("\n            请输入正确手机号！\n          ")])])]):_c('div',{staticClass:"z-content"},[_vm._m(6),_vm._v(" "),_vm._m(7),_c('div',{staticClass:"content-myGender 222"},[_c('span',{staticClass:"conten-span",on:{"click":function($event){_vm.sexCheckfn(1)}}},[_c('input',{staticClass:"sex",attrs:{"type":"radio","name":"myGender","value":"男"}}),_vm._v("男 ")]),_vm._v(" "),_c('span',{staticClass:"conten-span",on:{"click":function($event){_vm.sexCheckfn(2)}}},[_c('input',{staticClass:"sex",attrs:{"type":"radio","name":"myGender","value":"女"}}),_vm._v("女 ")])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',[_c('label',[_vm._v("地址")]),_vm._v(" "),_c('Linkage',{attrs:{"text":_vm.address},on:{"message":_vm.listenToMyBoy}}),_vm._v(" "),_c('input',{staticClass:"address",staticStyle:{"display":"none"},attrs:{"type":"text"},domProps:{"value":_vm.region}})],1),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_c('label',[_vm._v("电话")]),_vm._v(" "),_c('input',{staticClass:"myTelephone",attrs:{"type":"text","value":"","placeholder":"请输入手机号"},on:{"keyup":function($event){_vm.SmallKeyup($event)}}}),_vm._v(" "),_c('span',{staticStyle:{"display":"none","font-size":"14px","color":"#C8494E"}},[_vm._v("\n            请输入正确手机号码！\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw clearfix"},[_c('button',{staticClass:"btn-1 buttonW buttonL",attrs:{"id":"Button1","type":"button"},on:{"click":function($event){_vm.myHas(1)}}},[_vm._v("确定")]),_vm._v(" "),_c('button',{staticClass:"btn-2 buttonW buttonR",attrs:{"id":"cancel"},on:{"click":function($event){_vm.myHas(0)}}},[_vm._v("取消")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"My_con"},[_c('img',{attrs:{"src":__webpack_require__("JDv8"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"icon-title"},[_c('dd',[_vm._v("0")]),_vm._v(" "),_c('dt',[_vm._v("参与的")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"icon-title"},[_c('dd',[_vm._v("0")]),_vm._v(" "),_c('dt',[_vm._v("关注的")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"icon-title"},[_c('dd',[_vm._v("0")]),_vm._v(" "),_c('dt',[_vm._v("上传的")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"icon-title"},[_c('dd',[_vm._v("0")]),_vm._v(" "),_c('dt',[_vm._v("@我的")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group detailed"},[_c('label',[_vm._v("详细地址")]),_vm._v(" "),_c('div',{staticClass:"et-typebox"},[_c('input',{staticClass:"form-control",staticStyle:{"width":"100%","height":"45px","padding-left":"5px"},attrs:{"type":"text","placeholder":"请输入详细地址"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('label',[_vm._v("姓名")]),_vm._v(" "),_c('input',{staticClass:"myName",attrs:{"type":"text","value":"","placeholder":"请输入姓名"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"cotent-sex"},[_c('label',[_vm._v("性别")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group detailed"},[_c('label',[_vm._v("详细地址")]),_vm._v(" "),_c('div',{staticClass:"et-typebox"},[_c('input',{staticClass:"form-control",staticStyle:{"width":"100%","height":"45px","padding-left":"5px"},attrs:{"type":"text","placeholder":"请输入详细地址"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SXek":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SaI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text'],
  data: function data() {
    return {
      arr: arrAll,
      prov: '选择省份',
      city: '请选择',
      district: '',
      cityArr: [],
      districtArr: [],
      provArr: ''
    };
  },

  methods: {
    onClickMe1: function onClickMe1() {
      //  $('.detailed').hide();
      $('.example').remove('font');
      this.provArr = this.prov + ',' + this.city + ',' + this.district;
      this.$emit('message', this.provArr);
      if (this.prov == '海外' || this.prov == '其他') {
        $('.detailed').show();
      }
    },
    onClickMe2: function onClickMe2() {
      //$('.detailed').hide();
      $('.example').remove('font');
      this.provArr = this.prov + ',' + this.city + ',' + this.district;
      this.$emit('message', this.provArr);
      if (this.city == '请选择') {
        /* $('.detailed').hide();*/
      } else {
        if ($('.districts').length > 0 && $('.districts').val() == '请选择') {
          /*  $('.detailed').hide();*/
        } else {
          $('.detailed').show();
        }
      }
    },
    onClickMe3: function onClickMe3() {
      // $('.detailed').hide();
      $('.example').remove('font');
      this.provArr = this.prov + ',' + this.city + ',' + this.district;
      this.$emit('message', this.provArr);
      if (this.district == '请选择') {
        /*  $('.detailed').hide();*/
      } else {
        $('.detailed').show();
      }
    },
    updateCity: function updateCity() {
      var that = this;
      for (var i in this.arr) {
        var obj = this.arr[i];
        if (obj.name == this.prov) {
          this.cityArr = obj.sub;
          break;
        }
      }
      if (this.cityArr[1] && this.cityArr[1].name) {
        this.city = this.cityArr[1].name;
      } else {
        that.city = '请选择';
      }
    },
    updateDistrict: function updateDistrict() {
      for (var i in this.cityArr) {
        var obj = this.cityArr[i];
        if (obj.name == this.city) {
          this.districtArr = obj.sub;
          break;
        }
      }
      if (this.districtArr && this.districtArr.length > 0 && this.districtArr[1].name) {
        this.district = this.districtArr[1].name;
      } else {
        this.district = '请选择';
      }
    }
  },
  beforeMount: function beforeMount() {
    this.updateCity();
    this.updateDistrict();
  },
  watch: {
    prov: function prov() {
      this.updateCity();
      this.updateDistrict();
    },
    city: function city() {
      this.updateDistrict();
    }
  },
  created: function created() {
    var that = this;
    that.$watch(function () {
      setTimeout(function () {
        if (that.text && that.text != '') {
          var set = that.text.split(',');
          if (set[0] && set[0] != '选择省份' || set[0] && set[0] != '请选择' && set[0] != 'null') {
            that.prov = set[0];
          } else {
            that.prov = '北京市';
          }
          setTimeout(function () {
            if (set[0] == '海外') {
              that.city = '其他';
            } else if (set[1] && set[0] != '请选择' && set[0] != 'null') {
              that.city = set[1];
            } else {
              that.city = '北京市';
            }
          }, 200);
          setTimeout(function () {
            if (set[2] && set[2] != '请选择' && set[0] != 'null') {
              that.district = set[2];
            } else {
              that.district = '东城区';
            }
          }, 300);
          if (set[3] && set[3].trim() != '') {
            $('.detailed').show();
            $('.detailed').find('input').val(set[3]);
          }
        } else {
          that.prov = '北京市';
          that.city = '北京市';
          that.district = '东城区';
        }
      }, 1000);
    });
  },
  mounted: function mounted() {
    //操作DOM

  }

});
var arrAll = [{ name: "选择省份", sub: [{ name: "请选择" }],
  type: 0 }, {
  name: "海外",
  sub: [{ name: "请选择" }, { name: "其他" }],
  type: 0
}, {
  name: "北京市",
  sub: [{ name: "请选择", sub: [] }, {
    name: "北京市",
    sub: [{ name: "请选择" }, { name: "东城区" }, { name: "西城区" }, { name: "崇文区" }, { name: "宣武区" }, { name: "朝阳区" }, { name: "丰台区" }, { name: "石景山区" }, { name: "海淀区" }, { name: "门头沟区" }, { name: "房山区" }, { name: "通州区" }, { name: "顺义区" }, { name: "昌平区" }, { name: "大兴区" }, { name: "怀柔区" }, { name: "平谷区" }, { name: "密云县" }, { name: "延庆县" }],
    type: 0
  }], type: 1
}, {
  name: "广东省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "广州市",
    sub: [{ name: "请选择" }, { name: "荔湾区" }, { name: "越秀区" }, { name: "海珠区" }, { name: "天河区" }, { name: "白云区" }, { name: "黄埔区" }, { name: "番禺区" }, { name: "花都区" }, { name: "南沙区" }, { name: "萝岗区" }, { name: "从化市" }, { name: "增城市" }],
    type: 0
  }, {
    name: "深圳市",
    sub: [{ name: "请选择" }, { name: "罗湖区" }, { name: "福田区" }, { name: "南山区" }, { name: "宝安区" }, { name: "龙岗区" }, { name: "盐田区" }, { name: "龙华区" }, { name: "坪山区" }],
    type: 0
  }, {
    name: "珠海市",
    sub: [{ name: "请选择" }, { name: "香洲区" }, { name: "斗门区" }, { name: "金湾区" }],
    type: 0
  }, {
    name: "汕头市",
    sub: [{ name: "请选择" }, { name: "龙湖区" }, { name: "金平区" }, { name: "濠江区" }, { name: "潮阳区" }, { name: "潮南区" }, { name: "澄海区" }, { name: "南澳县" }],
    type: 0
  }, {
    name: "韶关市",
    sub: [{ name: "请选择" }, { name: "浈江区" }, { name: "武江区" }, { name: "曲江区" }, { name: "始兴县" }, { name: "仁化县" }, { name: "翁源县" }, { name: "新丰县" }, { name: "乐昌市" }, { name: "南雄市" }, { name: "乳源瑶族自治县" }],
    type: 0
  }, {
    name: "佛山市",
    sub: [{ name: "请选择" }, { name: "禅城区" }, { name: "南海区" }, { name: "顺德区" }, { name: "三水区" }, { name: "高明区" }],
    type: 0
  }, {
    name: "江门市",
    sub: [{ name: "请选择" }, { name: "蓬江区" }, { name: "江海区" }, { name: "新会区" }, { name: "恩平市" }, { name: "台山市" }, { name: "开平市" }, { name: "鹤山市" }],
    type: 0
  }, {
    name: "湛江市",
    sub: [{ name: "请选择" }, { name: "赤坎区" }, { name: "霞山区" }, { name: "坡头区" }, { name: "麻章区" }, { name: "吴川市" }, { name: "廉江市" }, { name: "雷州市" }, { name: "遂溪县" }, { name: "徐闻县" }],
    type: 0
  }, {
    name: "茂名市",
    sub: [{ name: "请选择" }, { name: "茂南区" }, { name: "茂港区" }, { name: "化州市" }, { name: "信宜市" }, { name: "高州市" }, { name: "电白县" }],
    type: 0
  }, {
    name: "肇庆市",
    sub: [{ name: "请选择" }, { name: "端州区" }, { name: "鼎湖区" }, { name: "高要市" }, { name: "四会市" }, { name: "广宁县" }, { name: "怀集县" }, { name: "封开县" }, { name: "德庆县" }],
    type: 0
  }, {
    name: "惠州市",
    sub: [{ name: "请选择" }, { name: "惠城区" }, { name: "惠阳区" }, { name: "博罗县" }, { name: "惠东县" }, { name: "龙门县" }],
    type: 0
  }, {
    name: "梅州市",
    sub: [{ name: "请选择" }, { name: "梅江区" }, { name: "梅县区" }, { name: "大埔县" }, { name: "丰顺县" }, { name: "五华县" }, { name: "平远县" }, { name: "蕉岭县" }, { name: "兴宁市" }],
    type: 0
  }, {
    name: "汕尾市",
    sub: [{ name: "请选择" }, { name: "城区" }, { name: "海丰县" }, { name: "陆河县" }, { name: "陆丰市" }],
    type: 0
  }, {
    name: "河源市",
    sub: [{ name: "请选择" }, { name: "源城区" }, { name: "紫金县" }, { name: "龙川县" }, { name: "连平县" }, { name: "和平县" }, { name: "东源县" }],
    type: 0
  }, {
    name: "阳江市",
    sub: [{ name: "请选择" }, { name: "江城区" }, { name: "阳西县" }, { name: "阳东县" }, { name: "阳春市" }],
    type: 0
  }, {
    name: "清远市",
    sub: [{ name: "请选择" }, { name: "清城区" }, { name: "清新县" }, { name: "佛冈县" }, { name: "阳山县" }, { name: "英德市" }, { name: "连州市" }, { name: "连山壮族瑶族自治县" }, { name: "连南瑶族自治县" }],
    type: 0
  }, {
    name: "东莞市",
    sub: [],
    type: 0
  }, {
    name: "中山市",
    sub: [],
    type: 0
  }, {
    name: "潮州市",
    sub: [{ name: "请选择" }, { name: "湘桥区" }, { name: "潮安区" }, { name: "饶平县" }],
    type: 0
  }, {
    name: "揭阳市",
    sub: [{ name: "请选择" }, { name: "榕城区" }, { name: "揭东县" }, { name: "揭西县" }, { name: "惠来县" }, { name: "普宁市" }],
    type: 0
  }, {
    name: "云浮市",
    sub: [{ name: "请选择" }, { name: "云城区" }, { name: "云安区" }, { name: "新兴县" }, { name: "郁南县" }, { name: "罗定市" }],
    type: 0
  }],
  type: 1
}, {
  name: "上海市",
  sub: [{ name: "请选择", sub: [] }, {
    name: "上海市",
    sub: [{ name: "请选择" }, { name: "黄浦区" }, { name: "普陀区" }, { name: "南汇区" }, { name: "卢湾区" }, { name: "徐汇区" }, { name: "长宁区" }, { name: "静安区" }, { name: "闸北区" }, { name: "虹口区" }, { name: "杨浦区" }, { name: "闵行区" }, { name: "宝山区" }, { name: "嘉定区" }, { name: "浦东新区" }, { name: "金山区" }, { name: "松江区" }, { name: "青浦区" }, { name: "奉贤区" }, { name: "崇明区" }],
    type: 0
  }], type: 1
}, {
  name: "天津市",
  sub: [{ name: "请选择", sub: [] }, {
    name: "天津市",
    sub: [{ name: "请选择" }, { name: "和平区" }, { name: "河东区" }, { name: "河西区" }, { name: "南开区" }, { name: "河北区" }, { name: "红桥区" }, { name: "塘沽区" }, { name: "汉沽区" }, { name: "大港区" }, { name: "东丽区" }, { name: "西青区" }, { name: "津南区" }, { name: "北辰区" }, { name: "武清区" }, { name: "宝坻区" }, { name: "滨海新区" }, { name: "宁河县" }, { name: "静海县" }, { name: "蓟州区" }],
    type: 0
  }], type: 1
}, {
  name: "重庆市",
  sub: [{ name: "请选择", sub: [] }, {
    name: "重庆市",
    sub: [{ name: "请选择" }, { name: "万州区" }, { name: "涪陵区" }, { name: "渝中区" }, { name: "大渡口区" }, { name: "江北区" }, { name: "沙坪坝区" }, { name: "九龙坡区" }, { name: "南岸区" }, { name: "北碚区" }, { name: "江北区" }, { name: "大足区" }, { name: "渝北区" }, { name: "巴南区" }, { name: "黔江区" }, { name: "长寿区" }, { name: "江津区" }, { name: "合川区" }, { name: "永川区" }, { name: "南川区" }, { name: "璧山区" }, { name: "铜梁区" }, { name: "潼南区" }, { name: "荣昌区" }, { name: "开州区" }, { name: "梁平区" }, { name: "武隆区" }, { name: "城口县" }, { name: "丰都县" }, { name: "垫江县" }, { name: "忠县" }, { name: "云阳县" }, { name: "奉节县" }, { name: "巫山县" }, { name: "巫溪县" }, { name: "双桥区" }, { name: "万盛区" }, { name: "綦江县" }, { name: "石柱土家族自治县" }, { name: "秀山土家族苗族自治县" }, { name: "酉阳土家族苗族自治县" }, { name: "彭水苗族土家族自治县" }],
    type: 0
  }], type: 1
}, {
  name: "辽宁省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "沈阳市",
    sub: [{ name: "请选择" }, { name: "和平区" }, { name: "沈河区" }, { name: "大东区" }, { name: "皇姑区" }, { name: "铁西区" }, { name: "苏家屯区" }, { name: "浑南区" }, { name: "沈北新区" }, { name: "于洪区" }, { name: "辽中区" }, { name: "康平县" }, { name: "法库县" }, { name: "新民市" }],
    type: 0
  }, {
    name: "大连市",
    sub: [{ name: "请选择" }, { name: "中山区" }, { name: "西岗区" }, { name: "沙河口区" }, { name: "甘井子区" }, { name: "旅顺口区" }, { name: "金州区" }, { name: "普兰店区" }, { name: "长海县" }, { name: "瓦房店市" }, { name: "庄河市" }],
    type: 0
  }, {
    name: "鞍山市",
    sub: [{ name: "请选择" }, { name: "铁东区" }, { name: "铁西区" }, { name: "立山区" }, { name: "千山区" }, { name: "海城市" }, { name: "台安县" }, { name: "岫岩满族自治县" }, { name: "其他" }],
    type: 0
  }, {
    name: "抚顺市",
    sub: [{ name: "请选择" }, { name: "新抚区" }, { name: "东洲区" }, { name: "望花区" }, { name: "顺城区" }, { name: "抚顺县" }, { name: "清原满族自治县" }, { name: "新宾满族自治县" }],
    type: 0
  }, {
    name: "本溪市",
    sub: [{ name: "请选择" }, { name: "平山区" }, { name: "溪湖区" }, { name: "明山区" }, { name: "南芬区" }, { name: "本溪满族自治县" }, { name: "桓仁满族自治县" }],
    type: 0
  }, {
    name: "丹东市",
    sub: [{ name: "请选择" }, { name: "元宝区" }, { name: "振兴区" }, { name: "振安区" }, { name: "宽甸满族自治县" }, { name: "东港市" }, { name: "凤城市" }],
    type: 0
  }, {
    name: "锦州市",
    sub: [{ name: "请选择" }, { name: "古塔区" }, { name: "凌河区" }, { name: "太和区" }, { name: "黑山县" }, { name: "义县" }, { name: "凌海市" }, { name: "北镇市" }],
    type: 0
  }, {
    name: "营口市",
    sub: [{ name: "请选择" }, { name: "站前区" }, { name: "西市区" }, { name: "鲅鱼圈区" }, { name: "老边区" }, { name: "大石桥市" }, { name: "盖州市" }],
    type: 0
  }, {
    name: "阜新市",
    sub: [{ name: "请选择" }, { name: "海州区" }, { name: "新邱区" }, { name: "太平区" }, { name: "清河门区" }, { name: "细河区" }, { name: "彰武县" }, { name: "阜新蒙古族自治县" }],
    type: 0
  }, {
    name: "辽阳市",
    sub: [{ name: "请选择" }, { name: "白塔区" }, { name: "文圣区" }, { name: "宏伟区" }, { name: "太子河区" }, { name: "弓长岭区" }, { name: "灯塔市" }, { name: "辽阳县" }],
    type: 0
  }, {
    name: "盘锦市",
    sub: [{ name: "请选择" }, { name: "双台子区" }, { name: "兴隆台区" }, { name: "盘山县" }, { name: "大洼县" }],
    type: 0
  }, {
    name: "铁岭市",
    sub: [{ name: "请选择" }, { name: "银州区" }, { name: "清河区" }, { name: "调兵山市" }, { name: "开原市" }, { name: "铁岭县" }, { name: "昌图县" }, { name: "西丰县" }, { name: "其他" }],
    type: 0
  }, {
    name: "朝阳市",
    sub: [{ name: "请选择" }, { name: "双塔区" }, { name: "龙城区" }, { name: "凌源市" }, { name: "北票市" }, { name: "朝阳县" }, { name: "建平县" }, { name: "喀喇沁左翼蒙古族自治县" }],
    type: 0
  }, {
    name: "葫芦岛市",
    sub: [{ name: "请选择" }, { name: "龙港区" }, { name: "南票区" }, { name: "连山区" }, { name: "兴城市" }, { name: "绥中县" }, { name: "建昌县" }],
    type: 0
  }, { name: "其他" }],
  type: 1
}, {
  name: "江苏省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "南京市",
    sub: [{ name: "请选择" }, { name: "玄武区" }, { name: "秦淮区" }, { name: "建邺区" }, { name: "鼓楼区" }, { name: "浦口区" }, { name: "栖霞区" }, { name: "雨花台区" }, { name: "江宁区" }, { name: "六合区" }, { name: "溧水区" }, { name: "高淳区" }],
    type: 0
  }, {
    name: "苏州市",
    sub: [{ name: "请选择" }, { name: "虎丘区" }, { name: "吴中区" }, { name: "相城区" }, { name: "姑苏区" }, { name: "吴江区" }, { name: "常熟市" }, { name: "张家港市" }, { name: "昆山市" }, { name: "太仓市" }],
    type: 0
  }, {
    name: "无锡市",
    sub: [{ name: "请选择" }, { name: "锡山区" }, { name: "惠山区" }, { name: "滨湖区" }, { name: "梁溪区" }, { name: "新吴区" }, { name: "江阴市" }, { name: "宜兴市" }],
    type: 0
  }, {
    name: "常州市",
    sub: [{ name: "请选择" }, { name: "天宁区" }, { name: "钟楼区" }, { name: "新北区" }, { name: "武进区" }, { name: "金坛市" }, { name: "溧阳市" }],
    type: 0
  }, {
    name: "镇江市",
    sub: [{ name: "请选择" }, { name: "京口区" }, { name: "润州区" }, { name: "丹徒区" }, { name: "丹阳市" }, { name: "扬中市" }, { name: "句容市" }],
    type: 0
  }, {
    name: "南通市",
    sub: [{ name: "请选择" }, { name: "崇川区" }, { name: "港闸区" }, { name: "通州市" }, { name: "如皋市" }, { name: "海门市" }, { name: "启东市" }, { name: "海安县" }, { name: "如东县" }],
    type: 0
  }, {
    name: "泰州市",
    sub: [{ name: "请选择" }, { name: "海陵区" }, { name: "高港区" }, { name: "姜堰区" }, { name: "泰兴市" }, { name: "靖江市" }, { name: "兴化市" }],
    type: 0
  }, {
    name: "扬州市",
    sub: [{ name: "请选择" }, { name: "广陵区" }, { name: "维扬区" }, { name: "邗江区" }, { name: "仪征市" }, { name: "高邮市" }, { name: "宝应县" }],
    type: 0
  }, {
    name: "盐城市",
    sub: [{ name: "请选择" }, { name: "亭湖区" }, { name: "盐都区" }, { name: "大丰区" }, { name: "东台市" }, { name: "响水县" }, { name: "滨海县" }, { name: "阜宁县" }, { name: "建湖县" }, { name: "射阳县" }],
    type: 0
  }, {
    name: "连云港市",
    sub: [{ name: "请选择" }, { name: "赣榆区" }, { name: "海州区" }, { name: "连云区" }, { name: "东海县" }, { name: "灌云县" }, { name: "灌南县" }],
    type: 0
  }, {
    name: "徐州市",
    sub: [{ name: "请选择" }, { name: "云龙区" }, { name: "鼓楼区" }, { name: "泉山区" }, { name: "铜山区" }, { name: "贾汪区" }, { name: "邳州市" }, { name: "新沂市" }, { name: "睢宁县" }, { name: "沛县" }, { name: "丰县" }],
    type: 0
  }, {
    name: "淮安市",
    sub: [{ name: "请选择" }, { name: "淮安区" }, { name: "淮阴区" }, { name: "清江浦区" }, { name: "洪泽区" }, { name: "涟水县" }, { name: "金湖县" }, { name: "盱眙县" }],
    type: 0
  }, {
    name: "宿迁市",
    sub: [{ name: "请选择" }, { name: "宿城区" }, { name: "宿豫区" }, { name: "沭阳县" }, { name: "泗阳县" }, { name: "泗洪县" }],
    type: 0
  }],
  type: 1
}, {
  name: "湖北省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "武汉市",
    sub: [{ name: "请选择" }, { name: "江岸区" }, { name: "江汉区" }, { name: "硚口区" }, { name: "汉阳区" }, { name: "武昌区" }, { name: "青山区" }, { name: "洪山区" }, { name: "东西湖区" }, { name: "汉南区" }, { name: "蔡甸区" }, { name: "江夏区" }, { name: "黄陂区" }, { name: "新洲区" }],
    type: 0
  }, {
    name: "黄石市",
    sub: [{ name: "请选择" }, { name: "黄石港区" }, { name: "西塞山区" }, { name: "下陆区" }, { name: "铁山区" }, { name: "大冶市" }, { name: "阳新县" }],
    type: 0
  }, {
    name: "十堰市",
    sub: [{ name: "请选择" }, { name: "茅箭区" }, { name: "张湾区" }, { name: "郧阳区" }, { name: "丹江口市" }, { name: "郧西县" }, { name: "竹山县" }, { name: "竹溪县" }, { name: "房县" }],
    type: 0
  }, {
    name: "荆州市",
    sub: [{ name: "请选择" }, { name: "沙市区" }, { name: "荆州区" }, { name: "洪湖市" }, { name: "石首市" }, { name: "松滋市" }, { name: "监利县" }, { name: "公安县" }, { name: "江陵县" }],
    type: 0
  }, {
    name: "宜昌市",
    sub: [{ name: "请选择" }, { name: "西陵区" }, { name: "伍家岗区" }, { name: "点军区" }, { name: "猇亭区" }, { name: "夷陵区" }, { name: "宜都市" }, { name: "当阳市" }, { name: "枝江市" }, { name: "秭归县" }, { name: "远安县" }, { name: "兴山县" }, { name: "五峰土家族自治县" }, { name: "长阳土家族自治县" }],
    type: 0
  }, {
    name: "襄阳市",
    sub: [{ name: "请选择" }, { name: "襄城区" }, { name: "樊城区" }, { name: "襄阳区" }, { name: "老河口市" }, { name: "枣阳市" }, { name: "宜城市" }, { name: "南漳县" }, { name: "谷城县" }, { name: "保康县" }],
    type: 0
  }, {
    name: "鄂州市",
    sub: [{ name: "请选择" }, { name: "鄂城区" }, { name: "华容区" }, { name: "梁子湖区" }],
    type: 0
  }, {
    name: "荆门市",
    sub: [{ name: "请选择" }, { name: "东宝区" }, { name: "掇刀区" }, { name: "钟祥市" }, { name: "京山县" }, { name: "沙洋县" }],
    type: 0
  }, {
    name: "孝感市",
    sub: [{ name: "请选择" }, { name: "孝南区" }, { name: "应城市" }, { name: "安陆市" }, { name: "汉川市" }, { name: "孝昌县" }, { name: "云梦县" }, { name: "大悟县" }],
    type: 0
  }, {
    name: "黄冈市",
    sub: [{ name: "请选择" }, { name: "黄州区" }, { name: "麻城市" }, { name: "武穴市" }, { name: "团风县" }, { name: "红安县" }, { name: "罗田县" }, { name: "浠水县" }, { name: "蕲春县" }, { name: "黄梅县" }, { name: "英山县" }],
    type: 0
  }, {
    name: "咸宁市",
    sub: [{ name: "请选择" }, { name: "咸安区" }, { name: "赤壁市" }, { name: "嘉鱼县" }, { name: "通山县" }, { name: "崇阳县" }, { name: "通城县" }],
    type: 0
  }, {
    name: "随州市",
    sub: [{ name: "请选择" }, { name: "曾都区" }, { name: "随县" }, { name: "广水市" }],
    type: 0
  }, {
    name: "恩施土家族苗族自治州",
    sub: [{ name: "请选择" }, { name: "恩施市" }, { name: "利川市" }, { name: "建始县" }, { name: "来凤县" }, { name: "巴东县" }, { name: "鹤峰县" }, { name: "宣恩县" }, { name: "咸丰县" }],
    type: 0
  }, {
    name: "仙桃市",
    sub: [],
    type: 0
  }, {
    name: "天门市",
    sub: [],
    type: 0
  }, {
    name: "潜江市",
    sub: [],
    type: 0
  }, {
    name: "神农架林区",
    sub: [],
    type: 0
  }],
  type: 1
}, {
  name: "四川省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "成都市",
    sub: [{ name: "请选择" }, { name: "青羊区" }, { name: "锦江区" }, { name: "金牛区" }, { name: "武侯区" }, { name: "成华区" }, { name: "龙泉驿区" }, { name: "青白江区" }, { name: "新都区" }, { name: "温江区" }, { name: "双流区" }, { name: "郫都区" }, { name: "都江堰市" }, { name: "彭州市" }, { name: "邛崃市" }, { name: "崇州市" }, { name: "简阳市" }, { name: "金堂县" }, { name: "新津县" }, { name: "蒲江县" }, { name: "大邑县" }],
    type: 0
  }, {
    name: "自贡市",
    sub: [{ name: "请选择" }, { name: "大安区" }, { name: "自流井区" }, { name: "贡井区" }, { name: "沿滩区" }, { name: "荣县" }, { name: "富顺县" }],
    type: 0
  }, {
    name: "攀枝花市",
    sub: [{ name: "请选择" }, { name: "仁和区" }, { name: "米易县" }, { name: "盐边县" }, { name: "东区" }, { name: "西区" }],
    type: 0
  }, {
    name: "泸州市",
    sub: [{ name: "请选择" }, { name: "江阳区" }, { name: "纳溪区" }, { name: "龙马潭区" }, { name: "泸县" }, { name: "合江县" }, { name: "叙永县" }, { name: "古蔺县" }],
    type: 0
  }, {
    name: "德阳市",
    sub: [{ name: "请选择" }, { name: "旌阳区" }, { name: "广汉市" }, { name: "什邡市" }, { name: "绵竹市" }, { name: "罗江县" }, { name: "中江县" }],
    type: 0
  }, {
    name: "绵阳市",
    sub: [{ name: "请选择" }, { name: "涪城区" }, { name: "游仙区" }, { name: "安州区" }, { name: "江油市" }, { name: "盐亭县" }, { name: "三台县" }, { name: "平武县" }, { name: "安县" }, { name: "梓潼县" }, { name: "北川羌族自治县" }],
    type: 0
  }, {
    name: "广元市",
    sub: [{ name: "请选择" }, { name: "利州区" }, { name: "朝天区" }, { name: "昭化区" }, { name: "旺苍县" }, { name: "剑阁县" }, { name: "青川县" }, { name: "苍溪县" }],
    type: 0
  }, {
    name: "遂宁市",
    sub: [{ name: "请选择" }, { name: "船山区" }, { name: "安居区" }, { name: "射洪县" }, { name: "蓬溪县" }, { name: "大英县" }],
    type: 0
  }, {
    name: "内江市",
    sub: [{ name: "请选择" }, { name: "市中区" }, { name: "东兴区" }, { name: "资中县" }, { name: "隆昌县" }, { name: "威远县" }],
    type: 0
  }, {
    name: "乐山市",
    sub: [{ name: "请选择" }, { name: "市中区" }, { name: "五通桥区" }, { name: "沙湾区" }, { name: "金口河区" }, { name: "峨眉山市" }, { name: "犍为县" }, { name: "井研县" }, { name: "夹江县" }, { name: "沐川县" }, { name: "马边彝族自治县" }, { name: "峨边彝族自治县" }],
    type: 0
  }, {
    name: "南充市",
    sub: [{ name: "请选择" }, { name: "顺庆区" }, { name: "高坪区" }, { name: "嘉陵区" }, { name: "阆中市" }, { name: "南部县" }, { name: "营山县" }, { name: "蓬安县" }, { name: "仪陇县" }, { name: "西充县" }],
    type: 0
  }, {
    name: "眉山市",
    sub: [{ name: "请选择" }, { name: "东坡区" }, { name: "彭山区" }, { name: "仁寿县" }, { name: "洪雅县" }, { name: "丹棱县" }, { name: "青神县" }],
    type: 0
  }, {
    name: "宜宾市",
    sub: [{ name: "请选择" }, { name: "翠屏区" }, { name: "南溪区" }, { name: "宜宾县" }, { name: "江安县" }, { name: "长宁县" }, { name: "兴文县" }, { name: "珙县" }, { name: "高县" }, { name: "筠连县" }, { name: "屏山县" }],
    type: 0
  }, {
    name: "广安市",
    sub: [{ name: "请选择" }, { name: "广安区" }, { name: "前锋区" }, { name: "华蓥市" }, { name: "岳池县" }, { name: "邻水县" }, { name: "武胜县" }],
    type: 0
  }, {
    name: "达州市",
    sub: [{ name: "请选择" }, { name: "通川区" }, { name: "达川区" }, { name: "万源市" }, { name: "渠县" }, { name: "宣汉县" }, { name: "开江县" }, { name: "大竹县" }],
    type: 0
  }, {
    name: "雅安市",
    sub: [{ name: "请选择" }, { name: "雨城区" }, { name: "名山区" }, { name: "芦山县" }, { name: "石棉县" }, { name: "天全县" }, { name: "荥经县" }, { name: "宝兴县" }, { name: "汉源县" }],
    type: 0
  }, {
    name: "巴中市",
    sub: [{ name: "请选择" }, { name: "巴州区" }, { name: "恩阳区" }, { name: "南江县" }, { name: "平昌县" }, { name: "通江县" }],
    type: 0
  }, {
    name: "资阳市",
    sub: [{ name: "请选择" }, { name: "雁江区" }, { name: "安岳县" }, { name: "乐至县" }],
    type: 0
  }, {
    name: "阿坝藏族羌族自治州",
    sub: [{ name: "请选择" }, { name: "马尔康县" }, { name: "汶川县" }, { name: "理县" }, { name: "茂县" }, { name: "松潘县" }, { name: "九寨沟县" }, { name: "金川县" }, { name: "小金县" }, { name: "黑水县" }, { name: "红原县" }, { name: "阿坝县" }, { name: "若尔盖县" }, { name: "壤塘县" }],
    type: 0
  }, {
    name: "甘孜藏族自治州",
    sub: [{ name: "请选择" }, { name: "康定县" }, { name: "泸定县" }, { name: "九龙县" }, { name: "雅江县" }, { name: "道孚县" }, { name: "炉霍县" }, { name: "甘孜县" }, { name: "新龙县" }, { name: "德格县" }, { name: "白玉县" }, { name: "石渠县" }, { name: "色达县" }, { name: "理塘县" }, { name: "巴塘县" }, { name: "乡城县" }, { name: "丹巴县" }, { name: "稻城县" }, { name: "得荣县" }],
    type: 0
  }, {
    name: "凉山彝族自治州",
    sub: [{ name: "请选择" }, { name: "西昌市" }, { name: "盐源县" }, { name: "德昌县" }, { name: "会理县" }, { name: "会东县" }, { name: "宁南县" }, { name: "普格县" }, { name: "布拖县" }, { name: "金阳县" }, { name: "昭觉县" }, { name: "喜德县" }, { name: "冕宁县" }, { name: "越西县" }, { name: "美姑县" }, { name: "甘洛县" }, { name: "雷波县" }, { name: "木里藏族自治县" }],
    type: 0
  }],
  type: 1
}, {
  name: "陕西省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "西安市",
    sub: [{ name: "请选择" }, { name: "莲湖区" }, { name: "新城区" }, { name: "碑林区" }, { name: "雁塔区" }, { name: "灞桥区" }, { name: "未央区" }, { name: "阎良区" }, { name: "临潼区" }, { name: "长安区" }, { name: "高陵区" }, { name: "鄠邑区" }, { name: "蓝田县" }, { name: "周至县" }],
    type: 0
  }, {
    name: "铜川市",
    sub: [{ name: "请选择" }, { name: "耀州区" }, { name: "王益区" }, { name: "印台区" }, { name: "宜君县" }],
    type: 0
  }, {
    name: "宝鸡市",
    sub: [{ name: "请选择" }, { name: "渭滨区" }, { name: "金台区" }, { name: "陈仓区" }, { name: "凤翔县" }, { name: "岐山县" }, { name: "扶风县" }, { name: "眉县" }, { name: "陇县" }, { name: "千阳县" }, { name: "太白县" }, { name: "麟游县" }, { name: "凤县" }],
    type: 0
  }, {
    name: "咸阳市",
    sub: [{ name: "请选择" }, { name: "秦都区" }, { name: "杨陵区" }, { name: "渭城区" }, { name: "三原县" }, { name: "泾阳县" }, { name: "乾县" }, { name: "礼泉县" }, { name: "永寿县" }, { name: "彬县" }, { name: "长武县" }, { name: "旬邑县" }, { name: "兴平市" }, { name: "武功县" }, { name: "淳化县" }],
    type: 0
  }, {
    name: "渭南市",
    sub: [{ name: "请选择" }, { name: "临渭区" }, { name: "华州区" }, { name: "韩城市" }, { name: "华阴市" }, { name: "蒲城县" }, { name: "潼关县" }, { name: "大荔县" }, { name: "合阳县" }, { name: "澄城县" }, { name: "白水县" }, { name: "富平县" }],
    type: 0
  }, {
    name: "延安市",
    sub: [{ name: "请选择" }, { name: "宝塔区" }, { name: "安塞区" }, { name: "延川县" }, { name: "延长县" }, { name: "子长县" }, { name: "志丹县" }, { name: "吴起县" }, { name: "甘泉县" }, { name: "洛川县" }, { name: "黄陵县" }, { name: "富县" }, { name: "宜川县" }, { name: "黄龙县" }],
    type: 0
  }, {
    name: "汉中市",
    sub: [{ name: "请选择" }, { name: "汉台区" }, { name: "南郑区" }, { name: "城固县" }, { name: "洋县" }, { name: "勉县" }, { name: "西乡县" }, { name: "宁强县" }, { name: "留坝县" }, { name: "镇巴县" }, { name: "佛坪县" }, { name: "略阳县" }],
    type: 0
  }, {
    name: "榆林市",
    sub: [{ name: "请选择" }, { name: "榆阳区" }, { name: "横山区" }, { name: "府谷县" }, { name: "靖边县" }, { name: "定边县" }, { name: "绥德县" }, { name: "米脂县" }, { name: "清涧县" }, { name: "神木县" }, { name: "佳县" }, { name: "子洲县" }, { name: "吴堡县" }, { name: "神木市" }],
    type: 0
  }, {
    name: "安康市",
    sub: [{ name: "请选择" }, { name: "汉滨区" }, { name: "汉阴县" }, { name: "石泉县" }, { name: "宁陕县" }, { name: "紫阳县" }, { name: "岚皋县" }, { name: "平利县" }, { name: "旬阳县" }, { name: "镇坪县" }, { name: "白河县" }],
    type: 0
  }, {
    name: "商洛市",
    sub: [{ name: "请选择" }, { name: "商州区" }, { name: "洛南县" }, { name: "商南县" }, { name: "丹凤县" }, { name: "镇安县" }, { name: "山阳县" }, { name: "柞水县" }],
    type: 0
  }],
  type: 1
}, {
  name: "河北省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "石家庄市",
    sub: [{ name: "请选择" }, { name: "长安区" }, { name: "桥东区" }, { name: "桥西区" }, { name: "栾城区" }, { name: "新华区" }, { name: "裕华区" }, { name: "井陉矿区" }, { name: "藁城区" }, { name: "鹿泉市" }, { name: "辛集市" }, { name: "晋州市" }, { name: "新乐市" }, { name: "井陉县" }, { name: "正定县" }, { name: "行唐县" }, { name: "灵寿县" }, { name: "高邑县" }, { name: "深泽县" }, { name: "赞皇县" }, { name: "无极县" }, { name: "平山县" }, { name: "元氏县" }, { name: "赵县" }],
    type: 0
  }, {
    name: "唐山市",
    sub: [{ name: "请选择" }, { name: "路北区" }, { name: "路南区" }, { name: "古冶区" }, { name: "开平区" }, { name: "丰南区" }, { name: "丰润区" }, { name: "曹妃甸区" }, { name: "遵化市" }, { name: "迁安市" }, { name: "滦县" }, { name: "滦南县" }, { name: "乐亭县" }, { name: "迁西县" }, { name: "玉田县" }],
    type: 0
  }, {
    name: "秦皇岛市",
    sub: [{ name: "请选择" }, { name: "海港区" }, { name: "山海关区" }, { name: "北戴河区" }, { name: "抚宁区" }, { name: "昌黎县" }, { name: "卢龙县" }, { name: "青龙满族自治县" }],
    type: 0
  }, {
    name: "邯郸市",
    sub: [{ name: "请选择" }, { name: "邯山区" }, { name: "丛台区" }, { name: "复兴区" }, { name: "峰峰矿区" }, { name: "肥乡区" }, { name: "永年区" }, { name: "武安市" }, { name: "临漳县" }, { name: "成安县" }, { name: "大名县" }, { name: "邱县" }, { name: "磁县" }, { name: "魏县" }, { name: "涉县" }, { name: "曲周县" }, { name: "鸡泽县" }, { name: "广平县" }, { name: "馆陶县" }],
    type: 0
  }, {
    name: "邢台市",
    sub: [{ name: "请选择" }, { name: "桥东区" }, { name: "桥西区" }, { name: "南宫市" }, { name: "沙河市" }, { name: "临西县" }, { name: "临城县" }, { name: "内丘县" }, { name: "柏乡县" }, { name: "隆尧县" }, { name: "任县" }, { name: "南和县" }, { name: "宁晋县" }, { name: "巨鹿县" }, { name: "新河县" }, { name: "广宗县" }, { name: "平乡县" }, { name: "威县" }, { name: "清河县" }, { name: "邢台县" }],
    type: 0
  }, {
    name: "保定市",
    sub: [{ name: "请选择" }, { name: "竞秀区" }, { name: "莲池区" }, { name: "满城区" }, { name: "徐水区" }, { name: "定州市" }, { name: "涿州市" }, { name: "安国市" }, { name: "高碑店市" }, { name: "涞水县" }, { name: "阜平县" }, { name: "定兴县" }, { name: "唐县" }, { name: "高阳县" }, { name: "容城县" }, { name: "涞源县" }, { name: "望都县" }, { name: "安新县" }, { name: "易县" }, { name: "曲阳县" }, { name: "蠡县" }, { name: "顺平县" }, { name: "博野县" }, { name: "雄县" }],
    type: 0
  }, {
    name: "张家口市",
    sub: [{ name: "请选择" }, { name: "桥东区" }, { name: "桥西区" }, { name: "宣化区" }, { name: "下花园区" }, { name: "万全区" }, { name: "崇礼区" }, { name: "张北县" }, { name: "康保县" }, { name: "沽源县" }, { name: "尚义县" }, { name: "蔚县" }, { name: "阳原县" }, { name: "怀安县" }, { name: "怀来县" }, { name: "赤城县" }, { name: "涿鹿县" }],
    type: 0
  }, {
    name: "承德市",
    sub: [{ name: "请选择" }, { name: "双桥区" }, { name: "双滦区" }, { name: "鹰手营子矿区" }, { name: "平泉市" }, { name: "承德县" }, { name: "兴隆县" }, { name: "滦平县" }, { name: "隆化县" }, { name: "丰宁满族自治县" }, { name: "宽城满族自治县" }, { name: "围场满族蒙古族自治县" }],
    type: 0
  }, {
    name: "沧州市",
    sub: [{ name: "请选择" }, { name: "新华区" }, { name: "运河区" }, { name: "泊头市" }, { name: "任丘市" }, { name: "黄骅市" }, { name: "河间市" }, { name: "沧县" }, { name: "青县" }, { name: "东光县" }, { name: "海兴县" }, { name: "盐山县" }, { name: "肃宁县" }, { name: "南皮县" }, { name: "吴桥县" }, { name: "献县" }, { name: "孟村回族自治县" }],
    type: 0
  }, {
    name: "廊坊市",
    sub: [{ name: "请选择" }, { name: "安次区" }, { name: "广阳区" }, { name: "霸州市" }, { name: "三河市" }, { name: "固安县" }, { name: "永清县" }, { name: "香河县" }, { name: "文安县" }, { name: "大城县" }, { name: "大厂回族自治县" }],
    type: 0
  }, {
    name: "衡水市",
    sub: [{ name: "请选择" }, { name: "桃城区" }, { name: "冀州市" }, { name: "深州市" }, { name: "枣强县" }, { name: "武邑县" }, { name: "武强县" }, { name: "饶阳县" }, { name: "安平县" }, { name: "故城县" }, { name: "景县" }, { name: "阜城县" }],
    type: 0
  }],
  type: 1
}, {
  name: "山西省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "太原市",
    sub: [{ name: "请选择" }, { name: "杏花岭区" }, { name: "小店区" }, { name: "迎泽区" }, { name: "尖草坪区" }, { name: "万柏林区" }, { name: "晋源区" }, { name: "古交市" }, { name: "阳曲县" }, { name: "清徐县" }, { name: "娄烦县" }],
    type: 0
  }, {
    name: "大同市",
    sub: [{ name: "请选择" }, { name: "城区" }, { name: "矿区" }, { name: "南郊区" }, { name: "新荣区" }, { name: "阳高县" }, { name: "天镇县" }, { name: "广灵县" }, { name: "大同县" }, { name: "灵丘县" }, { name: "左云县" }, { name: "浑源县" }],
    type: 0
  }, {
    name: "阳泉市",
    sub: [{ name: "请选择" }, { name: "城区" }, { name: "矿区" }, { name: "郊区" }, { name: "平定县" }, { name: "盂县" }],
    type: 0
  }, {
    name: "长治市",
    sub: [{ name: "请选择" }, { name: "城区" }, { name: "郊区" }, { name: "长治县" }, { name: "襄垣县" }, { name: "屯留县" }, { name: "平顺县" }, { name: "黎城县" }, { name: "壶关县" }, { name: "潞城市" }, { name: "长子县" }, { name: "沁源县" }, { name: "武乡县" }, { name: "沁县" }],
    type: 0
  }, {
    name: "晋城市",
    sub: [{ name: "请选择" }, { name: "城区" }, { name: "高平市" }, { name: "泽州县" }, { name: "陵川县" }, { name: "阳城县" }, { name: "沁水县" }],
    type: 0
  }, {
    name: "朔州市",
    sub: [{ name: "请选择" }, { name: "朔城区" }, { name: "平鲁区" }, { name: "山阴县" }, { name: "右玉县" }, { name: "应县" }, { name: "怀仁县" }],
    type: 0
  }, {
    name: "晋中市",
    sub: [{ name: "请选择" }, { name: "榆次区" }, { name: "榆社县" }, { name: "左权县" }, { name: "和顺县" }, { name: "昔阳县" }, { name: "寿阳县" }, { name: "太谷县" }, { name: "介休市" }, { name: "灵石县" }, { name: "祁县" }, { name: "平遥县" }],
    type: 0
  }, {
    name: "运城市",
    sub: [{ name: "请选择" }, { name: "盐湖区" }, { name: "河津市" }, { name: "永济市" }, { name: "万荣县" }, { name: "闻喜县" }, { name: "稷山县" }, { name: "新绛县" }, { name: "绛县" }, { name: "垣曲县" }, { name: "夏县" }, { name: "平陆县" }, { name: "芮城县" }, { name: "临猗县" }],
    type: 0
  }, {
    name: "忻州市",
    sub: [{ name: "请选择" }, { name: "忻府区" }, { name: "原平市" }, { name: "定襄县" }, { name: "五台县" }, { name: "代县" }, { name: "繁峙县" }, { name: "宁武县" }, { name: "静乐县" }, { name: "神池县" }, { name: "五寨县" }, { name: "岢岚县" }, { name: "河曲县" }, { name: "偏关县" }, { name: "保德县" }],
    type: 0
  }, {
    name: "临汾市",
    sub: [{ name: "请选择" }, { name: "尧都区" }, { name: "侯马市" }, { name: "霍州市" }, { name: "曲沃县" }, { name: "襄汾县" }, { name: "翼城县" }, { name: "汾西县" }, { name: "洪洞县" }, { name: "吉县" }, { name: "安泽县" }, { name: "浮山县" }, { name: "古县" }, { name: "乡宁县" }, { name: "大宁县" }, { name: "隰县" }, { name: "永和县" }, { name: "蒲县" }],
    type: 0
  }, {
    name: "吕梁市",
    sub: [{ name: "请选择" }, { name: "离石区" }, { name: "孝义市" }, { name: "汾阳市" }, { name: "文水县" }, { name: "交城县" }, { name: "兴县" }, { name: "临县" }, { name: "柳林县" }, { name: "石楼县" }, { name: "岚县" }, { name: "中阳县" }, { name: "方山县" }, { name: "交口县" }],
    type: 0
  }],
  type: 1
}, {
  name: "河南省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "郑州市",
    sub: [{ name: "请选择" }, { name: "中原区" }, { name: "金水区" }, { name: "二七区" }, { name: "管城回族区" }, { name: "上街区" }, { name: "惠济区" }, { name: "巩义市" }, { name: "新郑市" }, { name: "新密市" }, { name: "登封市" }, { name: "荥阳市" }, { name: "中牟县" }],
    type: 0
  }, {
    name: "开封市",
    sub: [{ name: "请选择" }, { name: "鼓楼区" }, { name: "龙亭区" }, { name: "顺河回族区" }, { name: "禹王台区" }, { name: "祥符区" }, { name: "尉氏县" }, { name: "兰考县" }, { name: "杞县" }, { name: "通许县" }],
    type: 0
  }, {
    name: "洛阳市",
    sub: [{ name: "请选择" }, { name: "西工区" }, { name: "老城区" }, { name: "涧西区" }, { name: "瀍河回族区" }, { name: "洛龙区" }, { name: "吉利区" }, { name: "偃师市" }, { name: "孟津县" }, { name: "新安县" }, { name: "栾川县" }, { name: "嵩县" }, { name: "汝阳县" }, { name: "伊川县" }, { name: "洛宁县" }, { name: "宜阳县" }],
    type: 0
  }, {
    name: "平顶山市",
    sub: [{ name: "请选择" }, { name: "新华区" }, { name: "卫东区" }, { name: "湛河区" }, { name: "石龙区" }, { name: "汝州市" }, { name: "舞钢市" }, { name: "宝丰县" }, { name: "叶县" }, { name: "郏县" }, { name: "鲁山县" }],
    type: 0
  }, {
    name: "安阳市",
    sub: [{ name: "请选择" }, { name: "北关区" }, { name: "文峰区" }, { name: "殷都区" }, { name: "龙安区" }, { name: "林州市" }, { name: "安阳县" }, { name: "滑县" }, { name: "内黄县" }, { name: "汤阴县" }],
    type: 0
  }, {
    name: "鹤壁市",
    sub: [{ name: "请选择" }, { name: "淇滨区" }, { name: "山城区" }, { name: "鹤山区" }, { name: "浚县" }, { name: "淇县" }],
    type: 0
  }, {
    name: "新乡市",
    sub: [{ name: "请选择" }, { name: "卫滨区" }, { name: "红旗区" }, { name: "凤泉区" }, { name: "牧野区" }, { name: "卫辉市" }, { name: "辉县市" }, { name: "新乡县" }, { name: "获嘉县" }, { name: "原阳县" }, { name: "长垣县" }, { name: "封丘县" }, { name: "延津县" }],
    type: 0
  }, {
    name: "焦作市",
    sub: [{ name: "请选择" }, { name: "解放区" }, { name: "中站区" }, { name: "马村区" }, { name: "山阳区" }, { name: "沁阳市" }, { name: "孟州市" }, { name: "修武县" }, { name: "温县" }, { name: "武陟县" }, { name: "博爱县" }],
    type: 0
  }, {
    name: "濮阳市",
    sub: [{ name: "请选择" }, { name: "华龙区" }, { name: "濮阳县" }, { name: "南乐县" }, { name: "台前县" }, { name: "清丰县" }, { name: "范县" }],
    type: 0
  }, {
    name: "许昌市",
    sub: [{ name: "请选择" }, { name: "魏都区" }, { name: "建安区" }, { name: "禹州市" }, { name: "长葛市" }, { name: "鄢陵县" }, { name: "襄城县" }],
    type: 0
  }, {
    name: "漯河市",
    sub: [{ name: "请选择" }, { name: "源汇区" }, { name: "郾城区" }, { name: "召陵区" }, { name: "临颍县" }, { name: "舞阳县" }],
    type: 0
  }, {
    name: "三门峡市",
    sub: [{ name: "请选择" }, { name: "湖滨区" }, { name: "陕州区" }, { name: "义马市" }, { name: "灵宝市" }, { name: "渑池县" }, { name: "卢氏县" }],
    type: 0
  }, {
    name: "南阳市",
    sub: [{ name: "请选择" }, { name: "卧龙区" }, { name: "宛城区" }, { name: "邓州市" }, { name: "南召县" }, { name: "方城县" }, { name: "西峡县" }, { name: "镇平县" }, { name: "内乡县" }, { name: "淅川县" }, { name: "社旗县" }, { name: "桐柏县" }, { name: "唐河县" }, { name: "新野县" }],
    type: 0
  }, {
    name: "商丘市",
    sub: [{ name: "请选择" }, { name: "梁园区" }, { name: "睢阳区" }, { name: "永城市" }, { name: "民权县" }, { name: "睢县" }, { name: "宁陵县" }, { name: "虞城县" }, { name: "夏邑县" }, { name: "柘城县" }],
    type: 0
  }, {
    name: "信阳市",
    sub: [{ name: "请选择" }, { name: "浉河区" }, { name: "平桥区" }, { name: "罗山县" }, { name: "光山县" }, { name: "新县" }, { name: "商城县" }, { name: "固始县" }, { name: "潢川县" }, { name: "淮滨县" }, { name: "息县" }],
    type: 0
  }, {
    name: "周口市",
    sub: [{ name: "请选择" }, { name: "川汇区" }, { name: "项城市" }, { name: "西华县" }, { name: "扶沟县" }, { name: "商水县" }, { name: "沈丘县" }, { name: "郸城县" }, { name: "淮阳县" }, { name: "太康县" }, { name: "鹿邑县" }],
    type: 0
  }, {
    name: "驻马店市",
    sub: [{ name: "请选择" }, { name: "驿城区" }, { name: "西平县" }, { name: "上蔡县" }, { name: "平舆县" }, { name: "正阳县" }, { name: "确山县" }, { name: "新蔡县" }, { name: "泌阳县" }, { name: "汝南县" }, { name: "遂平县" }],
    type: 0
  }, {
    name: "济源市",
    sub: [],
    type: 0
  }],
  type: 1
}, {
  name: "吉林省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "长春市",
    sub: [{ name: "请选择" }, { name: "朝阳区" }, { name: "宽城区" }, { name: "二道区" }, { name: "南关区" }, { name: "绿园区" }, { name: "双阳区" }, { name: "九台区" }, { name: "榆树市" }, { name: "德惠市" }, { name: "农安县" }],
    type: 0
  }, {
    name: "吉林市",
    sub: [{ name: "请选择" }, { name: "昌邑区" }, { name: "龙潭区" }, { name: "船营区" }, { name: "丰满区" }, { name: "永吉县" }, { name: "舒兰市" }, { name: "桦甸市" }, { name: "蛟河市" }, { name: "磐石市" }],
    type: 0
  }, {
    name: "四平市",
    sub: [{ name: "请选择" }, { name: "铁西区" }, { name: "铁东区" }, { name: "公主岭市" }, { name: "双辽市" }, { name: "梨树县" }, { name: "伊通满族自治县" }],
    type: 0
  }, {
    name: "辽源市",
    sub: [{ name: "请选择" }, { name: "龙山区" }, { name: "西安区" }, { name: "东辽县" }, { name: "东丰县" }],
    type: 0
  }, {
    name: "通化市",
    sub: [{ name: "请选择" }, { name: "东昌区" }, { name: "二道江区" }, { name: "梅河口市" }, { name: "集安市" }, { name: "通化县" }, { name: "辉南县" }, { name: "柳河县" }],
    type: 0
  }, {
    name: "白山市",
    sub: [{ name: "请选择" }, { name: "浑江区" }, { name: "江源区" }, { name: "临江市" }, { name: "靖宇县" }, { name: "抚松县" }, { name: "长白朝鲜族自治县" }],
    type: 0
  }, {
    name: "松原市",
    sub: [{ name: "请选择" }, { name: "宁江区" }, { name: "扶余市" }, { name: "乾安县" }, { name: "长岭县" }, { name: "前郭尔罗斯蒙古族自治县" }],
    type: 0
  }, {
    name: "白城市",
    sub: [{ name: "请选择" }, { name: "洮北区" }, { name: "大安市" }, { name: "洮南市" }, { name: "镇赉县" }, { name: "通榆县" }],
    type: 0
  }, {
    name: "延边朝鲜族自治州",
    sub: [{ name: "请选择" }, { name: "延吉市" }, { name: "图们市" }, { name: "敦化市" }, { name: "龙井市" }, { name: "珲春市" }, { name: "和龙市" }, { name: "安图县" }, { name: "汪清县" }],
    type: 0
  }],
  type: 1
}, {
  name: "黑龙江省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "哈尔滨市",
    sub: [{ name: "请选择" }, { name: "松北区" }, { name: "道里区" }, { name: "南岗区" }, { name: "道外区" }, { name: "平房区" }, { name: "香坊区" }, { name: "呼兰区" }, { name: "阿城区" }, { name: "双城区" }, { name: "尚志市" }, { name: "五常市" }, { name: "宾县" }, { name: "方正县" }, { name: "通河县" }, { name: "巴彦县" }, { name: "延寿县" }, { name: "木兰县" }, { name: "依兰县" }],
    type: 0
  }, {
    name: "齐齐哈尔市",
    sub: [{ name: "请选择" }, { name: "龙沙区" }, { name: "建华区" }, { name: "昂昂溪区" }, { name: "铁锋区" }, { name: "富拉尔基区" }, { name: "碾子山区" }, { name: "梅里斯达斡尔族区" }, { name: "讷河市" }, { name: "龙江县" }, { name: "依安县" }, { name: "泰来县" }, { name: "甘南县" }, { name: "富裕县" }, { name: "拜泉县" }, { name: "克山县" }, { name: "克东县" }],
    type: 0
  }, {
    name: "鹤岗市",
    sub: [{ name: "请选择" }, { name: "向阳区" }, { name: "工农区" }, { name: "兴山区" }, { name: "南山区" }, { name: "兴安区" }, { name: "东山区" }, { name: "萝北县" }, { name: "绥滨县" }],
    type: 0
  }, {
    name: "双鸭山市",
    sub: [{ name: "请选择" }, { name: "尖山区" }, { name: "岭东区" }, { name: "四方台区" }, { name: "宝山区" }, { name: "集贤县" }, { name: "宝清县" }, { name: "友谊县" }, { name: "饶河县" }],
    type: 0
  }, {
    name: "鸡西市",
    sub: [{ name: "请选择" }, { name: "鸡冠区" }, { name: "恒山区" }, { name: "城子河区" }, { name: "滴道区" }, { name: "梨树区" }, { name: "麻山区" }, { name: "密山市" }, { name: "虎林市" }, { name: "鸡东县" }],
    type: 0
  }, {
    name: "大庆市",
    sub: [{ name: "请选择" }, { name: "萨尔图区" }, { name: "红岗区" }, { name: "龙凤区" }, { name: "让胡路区" }, { name: "大同区" }, { name: "林甸县" }, { name: "肇州县" }, { name: "肇源县" }, { name: "杜尔伯特蒙古族自治县" }],
    type: 0
  }, {
    name: "伊春市",
    sub: [{ name: "请选择" }, { name: "伊春区" }, { name: "带岭区" }, { name: "南岔区" }, { name: "友好区" }, { name: "西林区" }, { name: "翠峦区" }, { name: "新青区" }, { name: "美溪区" }, { name: "金山屯区" }, { name: "五营区" }, { name: "汤旺河区" }, { name: "乌马河区" }, { name: "上甘岭区" }, { name: "红星区" }, { name: "乌伊岭区" }, { name: "铁力市" }, { name: "嘉荫县" }],
    type: 0
  }, {
    name: "牡丹江市",
    sub: [{ name: "请选择" }, { name: "爱民区" }, { name: "东安区" }, { name: "阳明区" }, { name: "西安区" }, { name: "绥芬河市" }, { name: "宁安市" }, { name: "海林市" }, { name: "穆棱市" }, { name: "东宁市" }, { name: "林口县" }],
    type: 0
  }, {
    name: "佳木斯市",
    sub: [{ name: "请选择" }, { name: "向阳区" }, { name: "前进区" }, { name: "东风区" }, { name: "郊区" }, { name: "同江市" }, { name: "富锦市" }, { name: "抚远市" }, { name: "桦川县" }, { name: "桦南县" }, { name: "汤原县" }],
    type: 0
  }, {
    name: "七台河市",
    sub: [{ name: "请选择" }, { name: "桃山区" }, { name: "新兴区" }, { name: "茄子河区" }, { name: "勃利县" }],
    type: 0
  }, {
    name: "黑河市",
    sub: [{ name: "请选择" }, { name: "爱辉区" }, { name: "北安市" }, { name: "五大连池市" }, { name: "逊克县" }, { name: "嫩江县" }, { name: "孙吴县" }],
    type: 0
  }, {
    name: "绥化市",
    sub: [{ name: "请选择" }, { name: "北林区" }, { name: "安达市" }, { name: "肇东市" }, { name: "海伦市" }, { name: "望奎县" }, { name: "青冈县" }, { name: "明水县" }, { name: "庆安县" }, { name: "绥棱县" }, { name: "兰西县" }],
    type: 0
  }, {
    name: "大兴安岭地区",
    sub: [{ name: "请选择" }, { name: "呼玛县" }, { name: "塔河县" }, { name: "漠河县" }],
    type: 0
  }],
  type: 1
}, {
  name: "内蒙古自治区",
  sub: [{ name: "请选择", sub: [] }, {
    name: "呼和浩特市",
    sub: [{ name: "请选择" }, { name: "回民区" }, { name: "玉泉区" }, { name: "新城区" }, { name: "赛罕区" }, { name: "托克托县" }, { name: "清水河县" }, { name: "武川县" }, { name: "和林格尔县" }, { name: "土默特左旗" }],
    type: 0
  }, {
    name: "包头市",
    sub: [{ name: "请选择" }, { name: "昆都仑区" }, { name: "青山区" }, { name: "东河区" }, { name: "九原区" }, { name: "石拐区" }, { name: "白云鄂博矿区" }, { name: "固阳县" }, { name: "土默特右旗" }, { name: "达尔罕茂明安联合旗" }],
    type: 0
  }, {
    name: "乌海市",
    sub: [{ name: "请选择" }, { name: "海勃湾区" }, { name: "乌达区" }, { name: "海南区" }],
    type: 0
  }, {
    name: "赤峰市",
    sub: [{ name: "请选择" }, { name: "红山区" }, { name: "元宝山区" }, { name: "松山区" }, { name: "阿鲁科尔沁旗" }, { name: "巴林左旗" }, { name: "巴林右旗" }, { name: "林西县" }, { name: "克什克腾旗" }, { name: "翁牛特旗" }, { name: "喀喇沁旗" }, { name: "宁城县" }, { name: "敖汉旗" }],
    type: 0
  }, {
    name: "通辽市",
    sub: [{ name: "请选择" }, { name: "科尔沁区" }, { name: "霍林郭勒市" }, { name: "开鲁县" }, { name: "科尔沁左翼中旗" }, { name: "科尔沁左翼后旗" }, { name: "库伦旗" }, { name: "奈曼旗" }, { name: "扎鲁特旗" }],
    type: 0
  }, {
    name: "鄂尔多斯市",
    sub: [{ name: "请选择" }, { name: "东胜区" }, { name: "康巴什区" }, { name: "达拉特旗" }, { name: "准格尔旗" }, { name: "鄂托克旗" }, { name: "鄂托克前旗" }, { name: "乌审旗" }, { name: "伊金霍洛旗" }, { name: "杭锦旗" }],
    type: 0
  }, {
    name: "呼伦贝尔市",
    sub: [{ name: "请选择" }, { name: "海拉尔区" }, { name: "扎赉诺尔区" }, { name: "满洲里市" }, { name: "牙克石市" }, { name: "扎兰屯市" }, { name: "根河市" }, { name: "额尔古纳市" }, { name: "阿荣旗" }, { name: "莫力达瓦达斡尔族自治旗" }, { name: "鄂伦春自治旗" }, { name: "鄂温克族自治旗" }, { name: "陈巴尔虎旗" }, { name: "新巴尔虎左旗" }, { name: "新巴尔虎右旗" }],
    type: 0
  }, {
    name: "巴彦淖尔市",
    sub: [{ name: "请选择" }, { name: "临河区" }, { name: "五原县" }, { name: "磴口县" }, { name: "杭锦后旗" }, { name: "乌拉特中旗" }, { name: "乌拉特前旗" }, { name: "乌拉特后旗" }],
    type: 0
  }, {
    name: "乌兰察布市",
    sub: [{ name: "请选择" }, { name: "集宁区" }, { name: "丰镇市" }, { name: "卓资县" }, { name: "化德县" }, { name: "商都县" }, { name: "兴和县" }, { name: "凉城县" }, { name: "四子王旗" }, { name: "察哈尔右翼前旗" }, { name: "察哈尔右翼中旗" }, { name: "察哈尔右翼后旗" }],
    type: 0
  }, {
    name: "锡林郭勒盟",
    sub: [{ name: "请选择" }, { name: "锡林浩特市" }, { name: "二连浩特市" }, { name: "多伦县" }, { name: "阿巴嘎旗" }, { name: "西乌珠穆沁旗" }, { name: "东乌珠穆沁旗" }, { name: "苏尼特左旗" }, { name: "苏尼特右旗" }, { name: "太仆寺旗" }, { name: "正镶白旗" }, { name: "正蓝旗" }, { name: "镶黄旗" }],
    type: 0
  }, {
    name: "兴安盟",
    sub: [{ name: "请选择" }, { name: "乌兰浩特市" }, { name: "阿尔山市" }, { name: "突泉县" }, { name: "扎赉特旗" }, { name: "科尔沁右翼前旗" }, { name: "科尔沁右翼中旗" }],
    type: 0
  }, {
    name: "阿拉善盟",
    sub: [{ name: "请选择" }, { name: "阿拉善左旗" }, { name: "阿拉善右旗" }, { name: "额济纳旗" }],
    type: 0
  }],
  type: 1
}, {
  name: "山东省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "济南市",
    sub: [{ name: "请选择" }, { name: "市中区" }, { name: "历下区" }, { name: "天桥区" }, { name: "槐荫区" }, { name: "历城区" }, { name: "长清区" }, { name: "章丘区" }, { name: "平阴县" }, { name: "济阳县" }, { name: "商河县" }],
    type: 0
  }, {
    name: "青岛市",
    sub: [{ name: "请选择" }, { name: "市南区" }, { name: "市北区" }, { name: "黄岛区" }, { name: "崂山区" }, { name: "李沧区" }, { name: "城阳区" }, { name: "胶州市" }, { name: "即墨区" }, { name: "平度市" }, { name: "莱西市" }],
    type: 0
  }, {
    name: "淄博市",
    sub: [{ name: "请选择" }, { name: "张店区" }, { name: "临淄区" }, { name: "淄川区" }, { name: "博山区" }, { name: "周村区" }, { name: "桓台县" }, { name: "高青县" }, { name: "沂源县" }],
    type: 0
  }, {
    name: "枣庄市",
    sub: [{ name: "请选择" }, { name: "市中区" }, { name: "山亭区" }, { name: "峄城区" }, { name: "台儿庄区" }, { name: "薛城区" }, { name: "滕州市" }],
    type: 0
  }, {
    name: "东营市",
    sub: [{ name: "请选择" }, { name: "东营区" }, { name: "河口区" }, { name: "垦利县" }, { name: "广饶县" }, { name: "利津县" }],
    type: 0
  }, {
    name: "烟台市",
    sub: [{ name: "请选择" }, { name: "芝罘区" }, { name: "福山区" }, { name: "牟平区" }, { name: "莱山区" }, { name: "长岛县" }, { name: "龙口市" }, { name: "莱阳市" }, { name: "莱州市" }, { name: "招远市" }, { name: "蓬莱市" }, { name: "栖霞市" }, { name: "海阳市" }],
    type: 0
  }, {
    name: "潍坊市",
    sub: [{ name: "请选择" }, { name: "潍城区" }, { name: "寒亭区" }, { name: "坊子区" }, { name: "奎文区" }, { name: "青州市" }, { name: "诸城市" }, { name: "寿光市" }, { name: "安丘市" }, { name: "高密市" }, { name: "昌邑市" }, { name: "昌乐县" }, { name: "临朐县" }],
    type: 0
  }, {
    name: "济宁市",
    sub: [{ name: "请选择" }, { name: "兖州区" }, { name: "任城区" }, { name: "曲阜市" }, { name: "邹城市" }, { name: "鱼台县" }, { name: "金乡县" }, { name: "嘉祥县" }, { name: "微山县" }, { name: "汶上县" }, { name: "泗水县" }, { name: "梁山县" }],
    type: 0
  }, {
    name: "泰安市",
    sub: [{ name: "请选择" }, { name: "泰山区" }, { name: "岱岳区" }, { name: "新泰市" }, { name: "肥城市" }, { name: "宁阳县" }, { name: "东平县" }],
    type: 0
  }, {
    name: "威海市",
    sub: [{ name: "请选择" }, { name: "环翠区" }, { name: "乳山市" }, { name: "文登市" }, { name: "荣成市" }],
    type: 0
  }, {
    name: "日照市",
    sub: [{ name: "请选择" }, { name: "东港区" }, { name: "岚山区" }, { name: "五莲县" }, { name: "莒县" }],
    type: 0
  }, {
    name: "莱芜市",
    sub: [{ name: "请选择" }, { name: "莱城区" }, { name: "钢城区" }],
    type: 0
  }, {
    name: "临沂市",
    sub: [{ name: "请选择" }, { name: "兰山区" }, { name: "罗庄区" }, { name: "河东区" }, { name: "沂南县" }, { name: "郯城县" }, { name: "沂水县" }, { name: "兰陵县" }, { name: "费县" }, { name: "平邑县" }, { name: "莒南县" }, { name: "蒙阴县" }, { name: "临沭县" }],
    type: 0
  }, {
    name: "德州市",
    sub: [{ name: "请选择" }, { name: "德城区" }, { name: "陵城区" }, { name: "乐陵市" }, { name: "禹城市" }, { name: "宁津县" }, { name: "庆云县" }, { name: "临邑县" }, { name: "齐河县" }, { name: "平原县" }, { name: "武城县" }, { name: "夏津县" }],
    type: 0
  }, {
    name: "聊城市",
    sub: [{ name: "请选择" }, { name: "东昌府区" }, { name: "临清市" }, { name: "高唐县" }, { name: "阳谷县" }, { name: "茌平县" }, { name: "莘县" }, { name: "东阿县" }, { name: "冠县" }],
    type: 0
  }, {
    name: "滨州市",
    sub: [{ name: "请选择" }, { name: "滨城区" }, { name: "沾化区" }, { name: "邹平县" }, { name: "惠民县" }, { name: "博兴县" }, { name: "阳信县" }, { name: "无棣县" }],
    type: 0
  }, {
    name: "菏泽市",
    sub: [{ name: "请选择" }, { name: "牡丹区" }, { name: "定陶区" }, { name: "鄄城县" }, { name: "单县" }, { name: "郓城县" }, { name: "曹县" }, { name: "巨野县" }, { name: "东明县" }, { name: "成武县" }],
    type: 0
  }],
  type: 1
}, {
  name: "安徽省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "合肥市",
    sub: [{ name: "请选择" }, { name: "庐阳区" }, { name: "瑶海区" }, { name: "蜀山区" }, { name: "包河区" }, { name: "长丰县" }, { name: "肥东县" }, { name: "肥西县" }, { name: "庐江县" }, { name: "巢湖市" }],
    type: 0
  }, {
    name: "芜湖市",
    sub: [{ name: "请选择" }, { name: "镜湖区" }, { name: "弋江区" }, { name: "鸠江区" }, { name: "三山区" }, { name: "芜湖县" }, { name: "南陵县" }, { name: "繁昌县" },, { name: "无为县" }],
    type: 0
  }, {
    name: "蚌埠市",
    sub: [{ name: "请选择" }, { name: "蚌山区" }, { name: "龙子湖区" }, { name: "禹会区" }, { name: "淮上区" }, { name: "怀远县" }, { name: "固镇县" }, { name: "五河县" }],
    type: 0
  }, {
    name: "淮南市",
    sub: [{ name: "请选择" }, { name: "田家庵区" }, { name: "大通区" }, { name: "谢家集区" }, { name: "八公山区" }, { name: "潘集区" }, { name: "凤台县" }, { name: "寿县" }],
    type: 0
  }, {
    name: "马鞍山市",
    sub: [{ name: "请选择" }, { name: "雨山区" }, { name: "花山区" }, { name: "博望区" }, { name: "含山县" }, { name: "和县" }, { name: "当涂县" }],
    type: 0
  }, {
    name: "淮北市",
    sub: [{ name: "请选择" }, { name: "相山区" }, { name: "杜集区" }, { name: "烈山区" }, { name: "濉溪县" }],
    type: 0
  }, {
    name: "铜陵市",
    sub: [{ name: "请选择" }, { name: "铜官区" }, { name: "义安区" }, { name: "郊区" }, { name: "枞阳县" }],
    type: 0
  }, {
    name: "安庆市",
    sub: [{ name: "请选择" }, { name: "迎江区" }, { name: "大观区" }, { name: "宜秀区" }, { name: "桐城市" }, { name: "怀宁县" }, { name: "潜山县" }, { name: "太湖县" }, { name: "宿松县" }, { name: "望江县" }, { name: "枞阳县" }, { name: "岳西县" }],
    type: 0
  }, {
    name: "黄山市",
    sub: [{ name: "请选择" }, { name: "屯溪区" }, { name: "黄山区" }, { name: "徽州区" }, { name: "休宁县" }, { name: "歙县" }, { name: "祁门县" }, { name: "黟县" }],
    type: 0
  }, {
    name: "滁州市",
    sub: [{ name: "请选择" }, { name: "琅琊区" }, { name: "南谯区" }, { name: "天长市" }, { name: "明光市" }, { name: "全椒县" }, { name: "来安县" }, { name: "定远县" }, { name: "凤阳县" }],
    type: 0
  }, {
    name: "阜阳市",
    sub: [{ name: "请选择" }, { name: "颍州区" }, { name: "颍东区" }, { name: "颍泉区" }, { name: "界首市" }, { name: "临泉县" }, { name: "颍上县" }, { name: "阜南县" }, { name: "太和县" }],
    type: 0
  }, {
    name: "宿州市",
    sub: [{ name: "请选择" }, { name: "埇桥区" }, { name: "萧县" }, { name: "泗县" }, { name: "砀山县" }, { name: "灵璧县" }],
    type: 0
  }, {
    name: "巢湖市",
    sub: [{ name: "请选择" }, { name: "居巢区" }, { name: "含山县" }, { name: "无为县" }, { name: "庐江县" }, { name: "和县" }],
    type: 0
  }, {
    name: "六安市",
    sub: [{ name: "请选择" }, { name: "金安区" }, { name: "裕安区" }, { name: "叶集区" }, { name: "霍山县" }, { name: "霍邱县" }, { name: "舒城县" }, { name: "金寨县" }],
    type: 0
  }, {
    name: "亳州市",
    sub: [{ name: "请选择" }, { name: "谯城区" }, { name: "利辛县" }, { name: "涡阳县" }, { name: "蒙城县" }],
    type: 0
  }, {
    name: "池州市",
    sub: [{ name: "请选择" }, { name: "贵池区" }, { name: "东至县" }, { name: "石台县" }, { name: "青阳县" }],
    type: 0
  }, {
    name: "宣城市",
    sub: [{ name: "请选择" }, { name: "宣州区" }, { name: "宁国市" }, { name: "广德县" }, { name: "郎溪县" }, { name: "泾县" }, { name: "旌德县" }, { name: "绩溪县" }],
    type: 0
  }],
  type: 1
}, {
  name: "浙江省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "杭州市",
    sub: [{ name: "请选择" }, { name: "上城区" }, { name: "下城区" }, { name: "江干区" }, { name: "拱墅区" }, { name: "西湖区" }, { name: "萧山区" }, { name: "滨江区" }, { name: "余杭区" }, { name: "富阳区" }, { name: "临安区" }, { name: "建德市" }, { name: "桐庐县" }, { name: "淳安县" }],
    type: 0
  }, {
    name: "宁波市",
    sub: [{ name: "请选择" }, { name: "海曙区" }, { name: "江北区" }, { name: "镇海区" }, { name: "北仑区" }, { name: "鄞州区" }, { name: "奉化区" }, { name: "余姚市" }, { name: "慈溪市" }, { name: "宁海县" }, { name: "象山县" }],
    type: 0
  }, {
    name: "温州市",
    sub: [{ name: "请选择" }, { name: "鹿城区" }, { name: "龙湾区" }, { name: "瓯海区" }, { name: "洞头区" }, { name: "瑞安市" }, { name: "乐清市" }, { name: "永嘉县" }, { name: "平阳县" }, { name: "苍南县" }, { name: "文成县" }, { name: "泰顺县" }],
    type: 0
  }, {
    name: "嘉兴市",
    sub: [{ name: "请选择" }, { name: "南湖区" }, { name: "秀洲区" }, { name: "海宁市" }, { name: "平湖市" }, { name: "桐乡市" }, { name: "嘉善县" }, { name: "海盐县" }],
    type: 0
  }, {
    name: "湖州市",
    sub: [{ name: "请选择" }, { name: "吴兴区" }, { name: "南浔区" }, { name: "长兴县" }, { name: "德清县" }, { name: "安吉县" }],
    type: 0
  }, {
    name: "绍兴市",
    sub: [{ name: "请选择" }, { name: "越城区" }, { name: "柯桥区" }, { name: "上虞区" }, { name: "诸暨市" }, { name: "嵊州市" }, { name: "新昌县" }],
    type: 0
  }, {
    name: "金华市",
    sub: [{ name: "请选择" }, { name: "婺城区" }, { name: "金东区" }, { name: "兰溪市" }, { name: "义乌市" }, { name: "东阳市" }, { name: "永康市" }, { name: "武义县" }, { name: "浦江县" }, { name: "磐安县" }],
    type: 0
  }, {
    name: "衢州市",
    sub: [{ name: "请选择" }, { name: "柯城区" }, { name: "衢江区" }, { name: "江山市" }, { name: "龙游县" }, { name: "常山县" }, { name: "开化县" }],
    type: 0
  }, {
    name: "舟山市",
    sub: [{ name: "请选择" }, { name: "定海区" }, { name: "普陀区" }, { name: "岱山县" }, { name: "嵊泗县" }],
    type: 0
  }, {
    name: "台州市",
    sub: [{ name: "请选择" }, { name: "椒江区" }, { name: "黄岩区" }, { name: "路桥区" }, { name: "临海市" }, { name: "温岭市" }, { name: "玉环市" }, { name: "天台县" }, { name: "仙居县" }, { name: "三门县" }],
    type: 0
  }, {
    name: "丽水市",
    sub: [{ name: "请选择" }, { name: "莲都区" }, { name: "龙泉市" }, { name: "缙云县" }, { name: "青田县" }, { name: "遂昌县" }, { name: "云和县" }, { name: "松阳县" }, { name: "庆元县" }, { name: "景宁畲族自治县" }],
    type: 0
  }],
  type: 1
}, {
  name: "福建省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "福州市",
    sub: [{ name: "请选择" }, { name: "鼓楼区" }, { name: "台江区" }, { name: "仓山区" }, { name: "马尾区" }, { name: "晋安区" }, { name: "长乐区" }, { name: "福清市" }, { name: "闽侯县" }, { name: "连江县" }, { name: "罗源县" }, { name: "闽清县" }, { name: "永泰县" }, { name: "平潭县" }],
    type: 0
  }, {
    name: "厦门市",
    sub: [{ name: "请选择" }, { name: "思明区" }, { name: "海沧区" }, { name: "湖里区" }, { name: "集美区" }, { name: "同安区" }, { name: "翔安区" }],
    type: 0
  }, {
    name: "莆田市",
    sub: [{ name: "请选择" }, { name: "城厢区" }, { name: "涵江区" }, { name: "荔城区" }, { name: "秀屿区" }, { name: "仙游县" }],
    type: 0
  }, {
    name: "三明市",
    sub: [{ name: "请选择" }, { name: "梅列区" }, { name: "三元区" }, { name: "永安市" }, { name: "明溪县" }, { name: "清流县" }, { name: "宁化县" }, { name: "大田县" }, { name: "尤溪县" }, { name: "沙县" }, { name: "将乐县" }, { name: "建宁县" }, { name: "泰宁县" }],
    type: 0
  }, {
    name: "泉州市",
    sub: [{ name: "请选择" }, { name: "鲤城区" }, { name: "丰泽区" }, { name: "洛江区" }, { name: "泉港区" }, { name: "石狮市" }, { name: "晋江市" }, { name: "南安市" }, { name: "惠安县" }, { name: "安溪县" }, { name: "永春县" }, { name: "德化县" }, { name: "金门县" }],
    type: 0
  }, {
    name: "漳州市",
    sub: [{ name: "请选择" }, { name: "芗城区" }, { name: "龙文区" }, { name: "龙海市" }, { name: "云霄县" }, { name: "漳浦县" }, { name: "诏安县" }, { name: "长泰县" }, { name: "东山县" }, { name: "平和县" }, { name: "南靖县" }, { name: "华安县" }],
    type: 0
  }, {
    name: "南平市",
    sub: [{ name: "请选择" }, { name: "延平区" }, { name: "建阳区" }, { name: "建瓯市" }, { name: "邵武市" }, { name: "武夷山市" }, { name: "顺昌县" }, { name: "浦城县" }, { name: "松溪县" }, { name: "光泽县" }, { name: "政和县" }],
    type: 0
  }, {
    name: "龙岩市",
    sub: [{ name: "请选择" }, { name: "新罗区" }, { name: "永定区" }, { name: "漳平市" }, { name: "长汀县" }, { name: "武平县" }, { name: "上杭县" }, { name: "连城县" }],
    type: 0
  }, {
    name: "宁德市",
    sub: [{ name: "请选择" }, { name: "蕉城区" }, { name: "福安市" }, { name: "福鼎市" }, { name: "霞浦县" }, { name: "古田县" }, { name: "屏南县" }, { name: "寿宁县" }, { name: "柘荣县" }, { name: "周宁县" }],
    type: 0
  }],
  type: 1
}, {
  name: "湖南省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "长沙市",
    sub: [{ name: "请选择" }, { name: "岳麓区" }, { name: "芙蓉区" }, { name: "天心区" }, { name: "开福区" }, { name: "雨花区" }, { name: "望城区" }, { name: "浏阳市" }, { name: "浏阳市" }, { name: "长沙县" }],
    type: 0
  }, {
    name: "株洲市",
    sub: [{ name: "请选择" }, { name: "天元区" }, { name: "荷塘区" }, { name: "芦淞区" }, { name: "石峰区" }, { name: "醴陵市" }, { name: "株洲县" }, { name: "炎陵县" }, { name: "茶陵县" }, { name: "攸县" }],
    type: 0
  }, {
    name: "湘潭市",
    sub: [{ name: "请选择" }, { name: "岳塘区" }, { name: "雨湖区" }, { name: "湘乡市" }, { name: "韶山市" }, { name: "湘潭县" }],
    type: 0
  }, {
    name: "衡阳市",
    sub: [{ name: "请选择" }, { name: "雁峰区" }, { name: "珠晖区" }, { name: "石鼓区" }, { name: "蒸湘区" }, { name: "南岳区" }, { name: "耒阳市" }, { name: "常宁市" }, { name: "衡阳县" }, { name: "衡东县" }, { name: "衡山县" }, { name: "衡南县" }, { name: "祁东县" }],
    type: 0
  }, {
    name: "邵阳市",
    sub: [{ name: "请选择" }, { name: "双清区" }, { name: "大祥区" }, { name: "北塔区" }, { name: "武冈市" }, { name: "邵东县" }, { name: "洞口县" }, { name: "新邵县" }, { name: "绥宁县" }, { name: "新宁县" }, { name: "邵阳县" }, { name: "隆回县" }, { name: "城步苗族自治县" }],
    type: 0
  }, {
    name: "岳阳市",
    sub: [{ name: "请选择" }, { name: "岳阳楼区" }, { name: "云溪区" }, { name: "君山区" }, { name: "临湘市" }, { name: "汨罗市" }, { name: "岳阳县" }, { name: "湘阴县" }, { name: "平江县" }, { name: "华容县" }],
    type: 0
  }, {
    name: "常德市",
    sub: [{ name: "请选择" }, { name: "武陵区" }, { name: "鼎城区" }, { name: "津市市" }, { name: "汉寿县" }, { name: "安乡县" }, { name: "澧县" }, { name: "临澧县" }, { name: "桃源县" }, { name: "石门县" }],
    type: 0
  }, {
    name: "张家界市",
    sub: [{ name: "请选择" }, { name: "永定区" }, { name: "武陵源区" }, { name: "慈利县" }, { name: "桑植县" }],
    type: 0
  }, {
    name: "益阳市",
    sub: [{ name: "请选择" }, { name: "赫山区" }, { name: "资阳区" }, { name: "沅江市" }, { name: "桃江县" }, { name: "南县" }, { name: "安化县" }],
    type: 0
  }, {
    name: "郴州市",
    sub: [{ name: "请选择" }, { name: "北湖区" }, { name: "苏仙区" }, { name: "资兴市" }, { name: "桂东县" }, { name: "宜章县" }, { name: "永兴县" }, { name: "嘉禾县" }, { name: "临武县" }, { name: "汝城县" }, { name: "桂阳县" }, { name: "安仁县" }],
    type: 0
  }, {
    name: "永州市",
    sub: [{ name: "请选择" }, { name: "冷水滩区" }, { name: "零陵区" }, { name: "祁阳县" }, { name: "东安县" }, { name: "双牌县" }, { name: "道县" }, { name: "江永县" }, { name: "宁远县" }, { name: "蓝山县" }, { name: "新田县" }, { name: "江华瑶族自治县" }],
    type: 0
  }, {
    name: "怀化市",
    sub: [{ name: "请选择" }, { name: "鹤城区" }, { name: "洪江市" }, { name: "中方县" }, { name: "沅陵县" }, { name: "辰溪县" }, { name: "溆浦县" }, { name: "会同县" }, { name: "新晃侗族自治县" }, { name: "芷江侗族自治县" }, { name: "通道侗族自治县" }, { name: "靖州苗族侗族自治县" }, { name: "麻阳苗族自治县" }],
    type: 0
  }, {
    name: "娄底市",
    sub: [{ name: "请选择" }, { name: "娄星区" }, { name: "冷水江市" }, { name: "涟源市" }, { name: "新化县" }, { name: "双峰县" }],
    type: 0
  }, {
    name: "湘西土家族苗族自治州",
    sub: [{ name: "请选择" }, { name: "吉首市" }, { name: "古丈县" }, { name: "龙山县" }, { name: "永顺县" }, { name: "凤凰县" }, { name: "泸溪县" }, { name: "保靖县" }, { name: "花垣县" }],
    type: 0
  }],
  type: 1
}, {
  name: "广西壮族自治区",
  sub: [{ name: "请选择", sub: [] }, {
    name: "南宁市",
    sub: [{ name: "请选择" }, { name: "青秀区" }, { name: "兴宁区" }, { name: "江南区" }, { name: "西乡塘区" }, { name: "良庆区" }, { name: "邕宁区" }, { name: "武鸣区" }, { name: "隆安县" }, { name: "马山县" }, { name: "上林县" }, { name: "宾阳县" }, { name: "横县" }],
    type: 0
  }, {
    name: "柳州市",
    sub: [{ name: "请选择" }, { name: "城中区" }, { name: "鱼峰区" }, { name: "柳北区" }, { name: "柳南区" }, { name: "柳江区" }, { name: "柳城县" }, { name: "鹿寨县" }, { name: "融安县" }, { name: "融水苗族自治县" }, { name: "三江侗族自治县" }],
    type: 0
  }, {
    name: "桂林市",
    sub: [{ name: "请选择" }, { name: "象山区" }, { name: "秀峰区" }, { name: "叠彩区" }, { name: "七星区" }, { name: "雁山区" }, { name: "阳朔区" }, { name: "临桂区" }, { name: "灵川县" }, { name: "全州县" }, { name: "平乐县" }, { name: "兴安县" }, { name: "永福县" }, { name: "灌阳县" }, { name: "荔浦县" }, { name: "资源县" }, { name: "龙胜各族自治县" }, { name: "恭城瑶族自治县" }],
    type: 0
  }, {
    name: "梧州市",
    sub: [{ name: "请选择" }, { name: "万秀区" }, { name: "蝶山区" }, { name: "长洲区" }, { name: "岑溪市" }, { name: "苍梧县" }, { name: "藤县" }, { name: "蒙山县" }],
    type: 0
  }, {
    name: "北海市",
    sub: [{ name: "请选择" }, { name: "海城区" }, { name: "银海区" }, { name: "铁山港区" }, { name: "合浦县" }],
    type: 0
  }, {
    name: "防城港市",
    sub: [{ name: "请选择" }, { name: "港口区" }, { name: "防城区" }, { name: "东兴市" }, { name: "上思县" }],
    type: 0
  }, {
    name: "钦州市",
    sub: [{ name: "请选择" }, { name: "钦南区" }, { name: "钦北区" }, { name: "灵山县" }, { name: "浦北县" }],
    type: 0
  }, {
    name: "贵港市",
    sub: [{ name: "请选择" }, { name: "港北区" }, { name: "港南区" }, { name: "覃塘区" }, { name: "桂平市" }, { name: "平南县" }],
    type: 0
  }, {
    name: "玉林市",
    sub: [{ name: "请选择" }, { name: "玉州区" }, { name: "福绵区" }, { name: "容县" }, { name: "陆川县" }, { name: "博白县" }, { name: "兴业县" }, { name: "北流市" }],
    type: 0
  }, {
    name: "百色市",
    sub: [{ name: "请选择" }, { name: "右江区" }, { name: "田林县" }, { name: "田阳县" }, { name: "平果县" }, { name: "德保县" }, { name: "那坡县" }, { name: "凌云县" }, { name: "乐业县" }, { name: "西林县" }, { name: "田东县" }, { name: "隆林各族自治县" }, { name: "靖西市" }],
    type: 0
  }, {
    name: "贺州市",
    sub: [{ name: "请选择" }, { name: "八步区" }, { name: "平桂区" }, { name: "钟山县" }, { name: "昭平县" }, { name: "富川瑶族自治县" }],
    type: 0
  }, {
    name: "河池市",
    sub: [{ name: "请选择" }, { name: "金城江区" }, { name: "宜州区" }, { name: "南丹县" }, { name: "天峨县" }, { name: "凤山县" }, { name: "东兰县" }, { name: "都安瑶族自治县" }, { name: "罗城仫佬族自治县" }, { name: "巴马瑶族自治县" }, { name: "环江毛南族自治县" }, { name: "大化瑶族自治县" }],
    type: 0
  }, {
    name: "来宾市",
    sub: [{ name: "请选择" }, { name: "兴宾区" }, { name: "合山市" }, { name: "象州县" }, { name: "武宣县" }, { name: "忻城县" }, { name: "金秀瑶族自治县" }],
    type: 0
  }, {
    name: "崇左市",
    sub: [{ name: "请选择" }, { name: "江州区" }, { name: "凭祥市" }, { name: "宁明县" }, { name: "扶绥县" }, { name: "龙州县" }, { name: "大新县" }, { name: "天等县" }],
    type: 0
  }],
  type: 1
}, {
  name: "江西省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "南昌市",
    sub: [{ name: "请选择" }, { name: "东湖区" }, { name: "西湖区" }, { name: "青云谱区" }, { name: "湾里区" }, { name: "青山湖区" }, { name: "新建区" }, { name: "南昌县" }, { name: "进贤县" }, { name: "安义县" }],
    type: 0
  }, {
    name: "景德镇市",
    sub: [{ name: "请选择" }, { name: "珠山区" }, { name: "昌江区" }, { name: "乐平市" }, { name: "浮梁县" }],
    type: 0
  }, {
    name: "萍乡市",
    sub: [{ name: "请选择" }, { name: "安源区" }, { name: "湘东区" }, { name: "莲花县" }, { name: "上栗县" }, { name: "芦溪县" }],
    type: 0
  }, {
    name: "九江市",
    sub: [{ name: "请选择" }, { name: "濂溪区" }, { name: "浔阳区" }, { name: "柴桑区" }, { name: "武宁县" }, { name: "修水县" }, { name: "永修县" }, { name: "德安县" }, { name: "都昌县" }, { name: "湖口县" }, { name: "彭泽县" }, { name: "瑞昌市" }, { name: "共青城市" }, { name: "庐山市" }],
    type: 0
  }, {
    name: "新余市",
    sub: [{ name: "请选择" }, { name: "渝水区" }, { name: "分宜县" }],
    type: 0
  }, {
    name: "鹰潭市",
    sub: [{ name: "请选择" }, { name: "月湖区" }, { name: "贵溪市" }, { name: "余江县" }],
    type: 0
  }, {
    name: "赣州市",
    sub: [{ name: "请选择" }, { name: "章贡区" }, { name: "南康区" }, { name: "赣县区" }, { name: "信丰县" }, { name: "大余县" }, { name: "上犹县" }, { name: "崇义县" }, { name: "安远县" }, { name: "龙南县" }, { name: "定南县" }, { name: "全南县" }, { name: "于都县" }, { name: "宁都县" }, { name: "兴国县" }, { name: "会昌县" }, { name: "寻乌县" }, { name: "石城县" }, { name: "瑞金市" }],
    type: 0
  }, {
    name: "吉安市",
    sub: [{ name: "请选择" }, { name: "吉州区" }, { name: "青原区" }, { name: "吉安县" }, { name: "吉水县" }, { name: "峡江县" }, { name: "新干县" }, { name: "永丰县" }, { name: "泰和县" }, { name: "遂川县" }, { name: "万安县" }, { name: "永新县" }, { name: "安福县" }, { name: "井冈山市" }],
    type: 0
  }, {
    name: "宜春市",
    sub: [{ name: "请选择" }, { name: "袁州区" }, { name: "丰城市" }, { name: "樟树市" }, { name: "高安市" }, { name: "奉新县" }, { name: "万载县" }, { name: "铜鼓县" }, { name: "靖安县" }, { name: "宜丰县" }, { name: "上高县" }],
    type: 0
  }, {
    name: "抚州市",
    sub: [{ name: "请选择" }, { name: "临川区" }, { name: "东乡区" }, { name: "南丰县" }, { name: "黎川县" }, { name: "南城县" }, { name: "崇仁县" }, { name: "乐安县" }, { name: "宜黄县" }, { name: "金溪县" }, { name: "资溪县" }, { name: "广昌县" }],
    type: 0
  }, {
    name: "上饶市",
    sub: [{ name: "请选择" }, { name: "信州区" }, { name: "广丰区" }, { name: "德兴市" }, { name: "上饶县" }, { name: "玉山县" }, { name: "铅山县" }, { name: "横峰县" }, { name: "弋阳县" }, { name: "余干县" }, { name: "鄱阳县" }, { name: "万年县" }, { name: "婺源县" }],
    type: 0
  }],
  type: 1
}, {
  name: "贵州省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "贵阳市",
    sub: [{ name: "请选择" }, { name: "南明区" }, { name: "云岩区" }, { name: "花溪区" }, { name: "乌当区" }, { name: "白云区" }, { name: "观山湖区" }, { name: "清镇市" }, { name: "开阳县" }, { name: "修文县" }, { name: "息烽县" }],
    type: 0
  }, {
    name: "六盘水市",
    sub: [{ name: "请选择" }, { name: "钟山区" }, { name: "六枝特区" }, { name: "水城县" }, { name: "盘州市" }],
    type: 0
  }, {
    name: "遵义市",
    sub: [{ name: "请选择" }, { name: "红花岗区" }, { name: "汇川区" }, { name: "播州区" }, { name: "桐梓县" }, { name: "绥阳县" }, { name: "正安县" }, { name: "凤冈县" }, { name: "湄潭县" }, { name: "余庆县" }, { name: "习水县" }, { name: "道真仡佬族苗族自治县" }, { name: "务川仡佬族苗族自治县" }, { name: "赤水市" }, { name: "仁怀市" }],
    type: 0
  }, {
    name: "安顺市",
    sub: [{ name: "请选择" }, { name: "西秀区" }, { name: "平坝区" }, { name: "普定县" }, { name: "镇宁布依族苗族自治县" }, { name: "紫云苗族布依族自治县" }, { name: "关岭布依族苗族自治县" }],
    type: 0
  }, {
    name: "铜仁市",
    sub: [{ name: "请选择" }, { name: "碧江区" }, { name: "万山区" }, { name: "江口县" }, { name: "玉屏侗族自治县" }, { name: "思南县" }, { name: "石阡县" }, { name: "印江土家族苗族自治县" }, { name: "松桃苗族自治县" }, { name: "沿河土家族自治县" }, { name: "德江县" }],
    type: 0
  }, {
    name: "毕节市",
    sub: [{ name: "请选择" }, { name: "七星关区" }, { name: "大方县" }, { name: "黔西县" }, { name: "织金县" }, { name: "金沙县" }, { name: "赫章县" }, { name: "纳雍县" }, { name: "威宁彝族回族苗族自治县" }],
    type: 0
  }, {
    name: "黔西南布依族苗族自治州",
    sub: [{ name: "请选择" }, { name: "兴义市" }, { name: "兴仁县" }, { name: "普安县" }, { name: "晴隆县" }, { name: "贞丰县" }, { name: "望谟县" }, { name: "册亨县" }, { name: "安龙县" }],
    type: 0
  }, {
    name: "黔东南苗族侗族自治州",
    sub: [{ name: "请选择" }, { name: "凯里市" }, { name: "黄平县" }, { name: "施秉县" }, { name: "三穗县" }, { name: "镇远县" }, { name: "岑巩县" }, { name: "天柱县" }, { name: "锦屏县" }, { name: "剑河县" }, { name: "台江县" }, { name: "黎平县" }, { name: "榕江县" }, { name: "从江县" }, { name: "麻江县" }, { name: "雷山县" }, { name: "丹寨县" }],
    type: 0
  }, {
    name: "黔南布依族苗族自治州",
    sub: [{ name: "请选择" }, { name: "都匀市" }, { name: "福泉市" }, { name: "荔波县" }, { name: "贵定县" }, { name: "瓮安县" }, { name: "独山县" }, { name: "平塘县" }, { name: "罗甸县" }, { name: "长顺县" }, { name: "龙里县" }, { name: "惠水县" }, { name: "三都水族自治县" }],
    type: 0
  }],
  type: 1
}, {
  name: "云南省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "昆明市",
    sub: [{ name: "请选择" }, { name: "盘龙区" }, { name: "五华区" }, { name: "官渡区" }, { name: "西山区" }, { name: "东川区" }, { name: "呈贡区" }, { name: "晋宁区" }, { name: "富民县" }, { name: "宜良县" }, { name: "嵩明县" }, { name: "石林彝族自治县" }, { name: "禄劝彝族苗族自治县" }, { name: "寻甸回族彝族自治县" }],
    type: 0
  }, {
    name: "曲靖市",
    sub: [{ name: "请选择" }, { name: "麒麟区" }, { name: "沾益县" }, { name: "宣威市" }, { name: "马龙县" }, { name: "陆良县" }, { name: "师宗县" }, { name: "罗平县" }, { name: "富源县" }, { name: "会泽县" }, { name: "宣威市" }],
    type: 0
  }, {
    name: "玉溪市",
    sub: [{ name: "请选择" }, { name: "红塔区" }, { name: "江川县" }, { name: "澄江县" }, { name: "通海县" }, { name: "华宁县" }, { name: "易门县" }, { name: "峨山彝族自治县" }, { name: "新平彝族傣族自治县" }, { name: "元江哈尼族彝族傣族自治县" }],
    type: 0
  }, {
    name: "保山市",
    sub: [{ name: "请选择" }, { name: "隆阳区" }, { name: "施甸县" }, { name: "龙陵县" }, { name: "昌宁县" }, { name: "腾冲市" }],
    type: 0
  }, {
    name: "昭通市",
    sub: [{ name: "请选择" }, { name: "昭阳区" }, { name: "鲁甸县" }, { name: "巧家县" }, { name: "盐津县" }, { name: "大关县" }, { name: "永善县" }, { name: "绥江县" }, { name: "镇雄县" }, { name: "彝良县" }, { name: "威信县" }, { name: "水富县" }],
    type: 0
  }, {
    name: "丽江市",
    sub: [{ name: "请选择" }, { name: "古城区" }, { name: "永胜县" }, { name: "华坪县" }, { name: "玉龙纳西族自治县" }, { name: "宁蒗彝族自治县" }],
    type: 0
  }, {
    name: "普洱市",
    sub: [{ name: "请选择" }, { name: "思茅区" }, { name: "宁洱哈尼族彝族自治县" }, { name: "墨江哈尼族自治县" }, { name: "景东彝族自治县" }, { name: "景谷傣族彝族自治县" }, { name: "镇沅彝族哈尼族拉祜族自治县" }, { name: "江城哈尼族彝族自治县" }, { name: "孟连傣族拉祜族佤族自治县" }, { name: "澜沧拉祜族自治县" }, { name: "西盟佤族自治县" }],
    type: 0
  }, {
    name: "临沧市",
    sub: [{ name: "请选择" }, { name: "临翔区" }, { name: "凤庆县" }, { name: "云县" }, { name: "永德县" }, { name: "镇康县" }, { name: "双江拉祜族佤族布朗族傣族自治县" }, { name: "耿马傣族佤族自治县" }, { name: "沧源佤族自治县" }],
    type: 0
  }, {
    name: "德宏傣族景颇族自治州",
    sub: [{ name: "请选择" }, { name: "芒市" }, { name: "瑞丽市" }, { name: "梁河县" }, { name: "盈江县" }, { name: "陇川县" }],
    type: 0
  }, {
    name: "怒江傈僳族自治州",
    sub: [{ name: "请选择" }, { name: "泸水县" }, { name: "福贡县" }, { name: "贡山独龙族怒族自治县" }, { name: "兰坪白族普米族自治县" }],
    type: 0
  }, {
    name: "迪庆藏族自治州",
    sub: [{ name: "请选择" }, { name: "香格里拉县" }, { name: "德钦县" }, { name: "维西傈僳族自治县" }],
    type: 0
  }, {
    name: "大理白族自治州",
    sub: [{ name: "请选择" }, { name: "大理市" }, { name: "漾濞彝族自治县" }, { name: "祥云县" }, { name: "宾川县" }, { name: "弥渡县" }, { name: "南涧彝族自治县" }, { name: "巍山彝族回族自治县" }, { name: "永平县" }, { name: "云龙县" }, { name: "洱源县" }, { name: "剑川县" }, { name: "鹤庆县" }],
    type: 0
  }, {
    name: "楚雄彝族自治州",
    sub: [{ name: "请选择" }, { name: "楚雄市" }, { name: "双柏县" }, { name: "牟定县" }, { name: "南华县" }, { name: "姚安县" }, { name: "大姚县" }, { name: "永仁县" }, { name: "元谋县" }, { name: "武定县" }, { name: "禄丰县" }],
    type: 0
  }, {
    name: "红河哈尼族彝族自治州",
    sub: [{ name: "请选择" }, { name: "蒙自县" }, { name: "个旧市" }, { name: "开远市" }, { name: "弥勒县" }, { name: "屏边苗族自治县" }, { name: "建水县" }, { name: "石屏县" }, { name: "泸西县" }, { name: "元阳县" }, { name: "红河县" }, { name: "金平苗族瑶族傣族自治县" }, { name: "河口瑶族自治县" }, { name: "绿春县" }],
    type: 0
  }, {
    name: "文山壮族苗族自治州",
    sub: [{ name: "请选择" }, { name: "文山县" }, { name: "砚山县" }, { name: "西畴县" }, { name: "麻栗坡县" }, { name: "马关县" }, { name: "丘北县" }, { name: "广南县" }, { name: "富宁县" }],
    type: 0
  }, {
    name: "西双版纳傣族自治州",
    sub: [{ name: "请选择" }, { name: "景洪市" }, { name: "勐海县" }, { name: "勐腊县" }],
    type: 0
  }],
  type: 1
}, {
  name: "西藏自治区",
  sub: [{ name: "请选择", sub: [] }, {
    name: "拉萨市",
    sub: [{ name: "请选择" }, { name: "城关区" }, { name: "堆龙德庆区" }, { name: "达孜区" }, { name: "林周县" }, { name: "当雄县" }, { name: "尼木县" }, { name: "曲水县" }, { name: "墨竹工卡县" }],
    type: 0
  }, {
    name: "那曲市",
    sub: [{ name: "请选择" }, { name: "色尼区" }, { name: "嘉黎县" }, { name: "比如县" }, { name: "聂荣县" }, { name: "安多县" }, { name: "申扎县" }, { name: "索县" }, { name: "班戈县" }, { name: "巴青县" }, { name: "尼玛县" }, { name: "双湖县" }],
    type: 0
  }, {
    name: "昌都市",
    sub: [{ name: "请选择" }, { name: "卡若区" }, { name: "江达县" }, { name: "贡觉县" }, { name: "类乌齐县" }, { name: "丁青县" }, { name: "察雅县" }, { name: "八宿县" }, { name: "左贡县" }, { name: "芒康县" }, { name: "洛隆县" }, { name: "边坝县" }],
    type: 0
  }, {
    name: "林芝市",
    sub: [{ name: "请选择" }, { name: "巴宜区" }, { name: "工布江达县" }, { name: "米林县" }, { name: "墨脱县" }, { name: "波密县" }, { name: "察隅县" }, { name: "朗县" }],
    type: 0
  }, {
    name: "山南市",
    sub: [{ name: "请选择" }, { name: "乃东县" }, { name: "扎囊县" }, { name: "贡嘎县" }, { name: "桑日县" }, { name: "琼结县" }, { name: "曲松县" }, { name: "措美县" }, { name: "洛扎县" }, { name: "加查县" }, { name: "隆子县" }, { name: "错那县" }, { name: "浪卡子县" }],
    type: 0
  }, {
    name: "日喀则市",
    sub: [{ name: "请选择" }, { name: "桑珠孜区" }, { name: "南木林县" }, { name: "江孜县" }, { name: "定日县" }, { name: "萨迦县" }, { name: "昂仁县" }, { name: "谢通门县" }, { name: "白朗县" }, { name: "仁布县" }, { name: "康马县" }, { name: "定结县" }, { name: "仲巴县" }, { name: "亚东县" }, { name: "吉隆县" }, { name: "聂拉木县" }, { name: "萨嘎县" }, { name: "岗巴县" }],
    type: 0
  }, {
    name: "阿里地区",
    sub: [{ name: "请选择" }, { name: "噶尔县" }, { name: "普兰县" }, { name: "札达县" }, { name: "日土县" }, { name: "革吉县" }, { name: "改则县" }, { name: "措勤县" }],
    type: 0
  }],
  type: 1
}, {
  name: "海南省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "海口市",
    sub: [{ name: "请选择" }, { name: "龙华区" }, { name: "秀英区" }, { name: "琼山区" }, { name: "美兰区" }],
    type: 0
  }, {
    name: "三亚市",
    sub: [{ name: "请选择" }, { name: "海棠区" }, { name: "吉阳区" }, { name: "天涯区" }, { name: "崖州区" }],
    type: 0
  }, {
    name: "三沙市",
    sub: [{ name: "请选择" }, { name: "西沙群岛" }, { name: "南沙群岛" }, { name: "中沙群岛" }, { name: "永乐群岛" }],
    type: 0
  }, {
    name: "儋州市",
    sub: [],
    type: 0
  }, {
    name: "五指山市",
    sub: [],
    type: 0
  }, {
    name: "琼海市",
    sub: [],
    type: 0
  }, {
    name: "文昌市",
    sub: [],
    type: 0
  }, {
    name: "万宁市",
    sub: [],
    type: 0
  }, {
    name: "东方市",
    sub: [],
    type: 0
  }, {
    name: "澄迈县",
    sub: [],
    type: 0
  }, {
    name: "定安县",
    sub: [],
    type: 0
  }, {
    name: "屯昌县",
    sub: [],
    type: 0
  }, {
    name: "澄迈县",
    sub: [],
    type: 0
  }, {
    name: "临高县",
    sub: [],
    type: 0
  }, {
    name: "白沙黎族自治县",
    sub: [],
    type: 0
  }, {
    name: "昌江黎族自治县",
    sub: [],
    type: 0
  }, {
    name: "乐东黎族自治县",
    sub: [],
    type: 0
  }, {
    name: "陵水黎族自治县",
    sub: [],
    type: 0
  }, {
    name: "保亭黎族苗族自治县",
    sub: [],
    type: 0
  }, {
    name: "琼中黎族苗族自治县",
    sub: [],
    type: 0
  }],
  type: 1
}, {
  name: "甘肃省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "兰州市",
    sub: [{ name: "请选择" }, { name: "城关区" }, { name: "七里河区" }, { name: "西固区" }, { name: "安宁区" }, { name: "红古区" }, { name: "永登县" }, { name: "皋兰县" }, { name: "榆中县" }],
    type: 0
  }, {
    name: "嘉峪关市",
    sub: [],
    type: 0
  }, {
    name: "金昌市",
    sub: [{ name: "请选择" }, { name: "金川区" }, { name: "永昌县" }],
    type: 0
  }, {
    name: "白银市",
    sub: [{ name: "请选择" }, { name: "白银区" }, { name: "平川区" }, { name: "靖远县" }, { name: "会宁县" }, { name: "景泰县" }],
    type: 0
  }, {
    name: "天水市",
    sub: [{ name: "请选择" }, { name: "秦州区" }, { name: "麦积区" }, { name: "清水县" }, { name: "秦安县" }, { name: "甘谷县" }, { name: "武山县" }, { name: "张家川回族自治县" }],
    type: 0
  }, {
    name: "武威市",
    sub: [{ name: "请选择" }, { name: "凉州区" }, { name: "民勤县" }, { name: "古浪县" }, { name: "天祝藏族自治县" }],
    type: 0
  }, {
    name: "酒泉市",
    sub: [{ name: "请选择" }, { name: "肃州区" }, { name: "金塔县" }, { name: "玉门市" }, { name: "敦煌市" }, { name: "肃北蒙古族自治县" }, { name: "阿克塞哈萨克族自治县" }, { name: "瓜州县" }],
    type: 0
  }, {
    name: "张掖市",
    sub: [{ name: "请选择" }, { name: "甘州区" }, { name: "民乐县" }, { name: "临泽县" }, { name: "高台县" }, { name: "山丹县" }, { name: "肃南裕固族自治县" }],
    type: 0
  }, {
    name: "庆阳市",
    sub: [{ name: "请选择" }, { name: "西峰区" }, { name: "庆城县" }, { name: "环县" }, { name: "华池县" }, { name: "合水县" }, { name: "正宁县" }, { name: "宁县" }, { name: "镇原县" }],
    type: 0
  }, {
    name: "平凉市",
    sub: [{ name: "请选择" }, { name: "崆峒区" }, { name: "泾川县" }, { name: "灵台县" }, { name: "崇信县" }, { name: "华亭县" }, { name: "庄浪县" }, { name: "静宁县" }],
    type: 0
  }, {
    name: "定西市",
    sub: [{ name: "请选择" }, { name: "安定区" }, { name: "通渭县" }, { name: "陇西县" }, { name: "渭源县" }, { name: "临洮县" }, { name: "漳县" }, { name: "岷县" }],
    type: 0
  }, {
    name: "陇南市",
    sub: [{ name: "请选择" }, { name: "武都区" }, { name: "成县" }, { name: "文县" }, { name: "宕昌县" }, { name: "康县" }, { name: "西和县" }, { name: "礼县" }, { name: "两当县" }, { name: "徽县" }],
    type: 0
  }, {
    name: "临夏回族自治州",
    sub: [{ name: "请选择" }, { name: "临夏市" }, { name: "临夏县" }, { name: "康乐县" }, { name: "永靖县" }, { name: "广河县" }, { name: "和政县" }, { name: "东乡族自治县" }, { name: "积石山保安族东乡族撒拉族自治县" }],
    type: 0
  }, {
    name: "甘南藏族自治州",
    sub: [{ name: "请选择" }, { name: "合作市" }, { name: "临潭县" }, { name: "卓尼县" }, { name: "舟曲县" }, { name: "迭部县" }, { name: "玛曲县" }, { name: "碌曲县" }, { name: "夏河县" }],
    type: 0
  }],
  type: 1
}, {
  name: "宁夏回族自治区",
  sub: [{ name: "请选择", sub: [] }, {
    name: "银川市",
    sub: [{ name: "请选择" }, { name: "兴庆区" }, { name: "西夏区" }, { name: "金凤区" }, { name: "灵武市" }, { name: "永宁县" }, { name: "贺兰县" }],
    type: 0
  }, {
    name: "石嘴山市",
    sub: [{ name: "请选择" }, { name: "大武口区" }, { name: "惠农区" }, { name: "平罗县" }],
    type: 0
  }, {
    name: "吴忠市",
    sub: [{ name: "请选择" }, { name: "利通区" }, { name: "红寺堡区" }, { name: "青铜峡市" }, { name: "盐池县" }, { name: "同心县" }],
    type: 0
  }, {
    name: "固原市",
    sub: [{ name: "请选择" }, { name: "原州区" }, { name: "西吉县" }, { name: "隆德县" }, { name: "泾源县" }, { name: "彭阳县" }],
    type: 0
  }, {
    name: "中卫市",
    sub: [{ name: "请选择" }, { name: "沙坡头区" }, { name: "中宁县" }, { name: "海原县" }],
    type: 0
  }],
  type: 1
}, {
  name: "青海省",
  sub: [{ name: "请选择", sub: [] }, {
    name: "西宁市",
    sub: [{ name: "请选择" }, { name: "城中区" }, { name: "城东区" }, { name: "城西区" }, { name: "城北区" }, { name: "湟源县" }, { name: "湟中县" }, { name: "大通回族土族自治县" }],
    type: 0
  }, {
    name: "海东市",
    sub: [{ name: "请选择" }, { name: "平安县" }, { name: "乐都县" }, { name: "民和回族土族自治县" }, { name: "互助土族自治县" }, { name: "化隆回族自治县" }, { name: "循化撒拉族自治县" }],
    type: 0
  }, {
    name: "海北藏族自治州",
    sub: [{ name: "请选择" }, { name: "海晏县" }, { name: "祁连县" }, { name: "刚察县" }, { name: "门源回族自治县" }],
    type: 0
  }, {
    name: "海南藏族自治州",
    sub: [{ name: "请选择" }, { name: "共和县" }, { name: "同德县" }, { name: "贵德县" }, { name: "兴海县" }, { name: "贵南县" }],
    type: 0
  }, {
    name: "黄南藏族自治州",
    sub: [{ name: "请选择" }, { name: "同仁县" }, { name: "尖扎县" }, { name: "泽库县" }, { name: "河南蒙古族自治县" }],
    type: 0
  }, {
    name: "果洛藏族自治州",
    sub: [{ name: "请选择" }, { name: "玛沁县" }, { name: "班玛县" }, { name: "甘德县" }, { name: "达日县" }, { name: "久治县" }, { name: "玛多县" }],
    type: 0
  }, {
    name: "玉树藏族自治州",
    sub: [{ name: "请选择" }, { name: "玉树县" }, { name: "杂多县" }, { name: "称多县" }, { name: "治多县" }, { name: "囊谦县" }, { name: "曲麻莱县" }],
    type: 0
  }, {
    name: "海西蒙古族藏族自治州",
    sub: [{ name: "请选择" }, { name: "德令哈市" }, { name: "格尔木市" }, { name: "乌兰县" }, { name: "都兰县" }, { name: "天峻县" }],
    type: 0
  }],
  type: 1
}, {
  name: "新疆维吾尔自治区",
  sub: [{ name: "请选择", sub: [] }, {
    name: "乌鲁木齐市",
    sub: [{ name: "请选择" }, { name: "天山区" }, { name: "沙依巴克区" }, { name: "新市区" }, { name: "水磨沟区" }, { name: "头屯河区" }, { name: "达坂城区" }, { name: "米东区" }, { name: "乌鲁木齐县" }],
    type: 0
  }, {
    name: "克拉玛依市",
    sub: [{ name: "请选择" }, { name: "克拉玛依区" }, { name: "独山子区" }, { name: "白碱滩区" }, { name: "乌尔禾区" }],
    type: 0
  }, {
    name: "吐鲁番市",
    sub: [{ name: "请选择" }, { name: "高昌区" }, { name: "鄯善县" }, { name: "托克逊县" }],
    type: 0
  }, {
    name: "哈密市",
    sub: [{ name: "请选择" }, { name: "哈密市" }, { name: "伊吾县" }, { name: "巴里坤哈萨克自治县" }],
    type: 0
  }, {
    name: "和田地区",
    sub: [{ name: "请选择" }, { name: "和田市" }, { name: "和田县" }, { name: "墨玉县" }, { name: "皮山县" }, { name: "洛浦县" }, { name: "策勒县" }, { name: "民丰县" }, { name: "于田县" }],
    type: 0
  }, {
    name: "阿克苏地区",
    sub: [{ name: "请选择" }, { name: "阿克苏市" }, { name: "温宿县" }, { name: "库车县" }, { name: "沙雅县" }, { name: "新和县" }, { name: "拜城县" }, { name: "阿瓦提县" }, { name: "柯坪县" }, { name: "乌什县" }],
    type: 0
  }, {
    name: "喀什地区",
    sub: [{ name: "请选择" }, { name: "喀什市" }, { name: "疏附县" }, { name: "疏勒县" }, { name: "英吉沙县" }, { name: "泽普县" }, { name: "莎车县" }, { name: "叶城县" }, { name: "巴楚县" }, { name: "伽师县" }, { name: "岳普湖县" }, { name: "麦盖提县" }, { name: "塔什库尔干塔吉克自治县" }],
    type: 0
  }, {
    name: "克孜勒苏柯尔克孜自治州",
    sub: [{ name: "请选择" }, { name: "阿图什市" }, { name: "阿合奇县" }, { name: "乌恰县" }, { name: "阿克陶县" }],
    type: 0
  }, {
    name: "巴音郭楞蒙古自治州",
    sub: [{ name: "请选择" }, { name: "库尔勒市" }, { name: "轮台县" }, { name: "尉犁县" }, { name: "若羌县" }, { name: "且末县" }, { name: "和静县" }, { name: "和硕县" }, { name: "博湖县" }, { name: "焉耆回族自治县" }],
    type: 0
  }, {
    name: "昌吉回族自治州",
    sub: [{ name: "请选择" }, { name: "昌吉市" }, { name: "阜康市" }, { name: "奇台县" }, { name: "呼图壁县" }, { name: "玛纳斯县" }, { name: "吉木萨尔县" }, { name: "木垒哈萨克自治县" }],
    type: 0
  }, {
    name: "博尔塔拉蒙古自治州",
    sub: [{ name: "请选择" }, { name: "博乐市" }, { name: "阿拉山口市" }, { name: "精河县" }, { name: "温泉县" }],
    type: 0
  }, {
    name: "塔城地区",
    sub: [{ name: "请选择" }, { name: "塔城市" }, { name: "乌苏市" }, { name: "额敏县" }, { name: "沙湾县" }, { name: "托里县" }, { name: "裕民县" }, { name: "和布克赛尔蒙古自治县" }],
    type: 0
  }, {
    name: "阿勒泰地区",
    sub: [{ name: "请选择" }, { name: "阿勒泰市" }, { name: "布尔津县" }, { name: "富蕴县" }, { name: "福海县" }, { name: "哈巴河县" }, { name: "青河县" }, { name: "吉木乃县" }],
    type: 0
  }, {
    name: "石河子市",
    sub: [],
    type: 0
  }, {
    name: "阿拉尔市",
    sub: [],
    type: 0
  }, {
    name: "图木舒克市",
    sub: [],
    type: 0
  }, {
    name: "五家渠市",
    sub: [],
    type: 0
  }, {
    name: "伊犁哈萨克自治州",
    sub: [{ name: "请选择" }, { name: "伊宁市" }, { name: "奎屯市" }, { name: "霍尔果斯市" }, { name: "伊宁县" }, { name: "察布查尔锡伯自治县" }, { name: "霍城县" }, { name: "巩留县" }, { name: "新源县" }, { name: "昭苏县" }, { name: "特克斯县" }, { name: "尼勒克县" }],
    type: 0
  }, { name: "北屯市" }, { name: "铁门关市" }, { name: "双河市" }, { name: "可克达拉市" }, { name: "昆玉市" }],
  type: 1
}, {
  name: "香港特别行政区",
  sub: [{ name: "请选择" }, { name: "中西区" }, { name: "湾仔区" }, { name: "东区" }, { name: "南区" }, { name: "深水埗区" }, { name: "油尖旺区" }, { name: "九龙城区" }, { name: "黄大仙区" }, { name: "观塘区" }, { name: "北区" }, { name: "大埔区" }, { name: "沙田区" }, { name: "西贡区" }, { name: "荃湾区" }, { name: "元朗区" }, { name: "屯门区" }, { name: "葵青区" }, { name: "离岛区" }],
  type: 0
}, {
  name: "澳门特别行政区",
  sub: [{ name: "请选择" }, { name: "花地玛堂区" }, { name: "圣安多尼堂区" }, { name: "大堂区" }, { name: "望德堂区" }, { name: "风顺堂区" }, { name: "嘉模堂区" }, { name: "圣方济各堂区" }, { name: "澳门新城" }, { name: "路氹城" }],
  type: 0
}, {
  name: "台湾省",
  sub: [{ name: "请选择" }, { name: "台北市",
    sub: [{ name: "请选择" }, { name: "正中区" }, { name: "大同区" }, { name: "中山区" }, { name: "万华区" }, { name: "信义区" }, { name: "松山区" }, { name: "大安区" }, { name: "南岗区" }, { name: "北投区" }, { name: "内湖区" }, { name: "士林区" }, { name: "文山区" }],
    type: 0
  }, { name: "新北区",
    sub: [{ name: "请选择" }, { name: "板桥区" }, { name: "土城区" }, { name: "新庄区" }, { name: "新店区" }, { name: "深坑区" }, { name: "石碇区" }, { name: "坪林区" }, { name: "乌来区" }, { name: "五股区" }, { name: "八里区" }, { name: "林口区" }, { name: "淡水区" }, { name: "中和区" }, { name: "永和区" }, { name: "三重区" }, { name: "芦洲区" }, { name: "泰山区" }, { name: "树林区" }, { name: "莺歌区" }, { name: "三峡区" }, { name: "汐止区" }, { name: "金山区" }, { name: "万里区" }, { name: "三芝区" }, { name: "石门区" }, { name: "瑞芳区" }, { name: "贡寮区" }, { name: "双溪区" }, { name: "平溪区" }],
    type: 0
  }, { name: "桃园市",
    sub: [{ name: "请选择" }, { name: "桃园区" }, { name: "中坜区" }, { name: "平镇区" }, { name: "八德区" }, { name: "杨梅区" }, { name: "芦竹区" }, { name: "大溪区" }, { name: "龙潭区" }, { name: "龟山区" }, { name: "大园区" }, { name: "观音区" }, { name: "新屋区" }, { name: "复兴区" }],
    type: 0
  }, { name: "台中市",
    sub: [{ name: "请选择" }, { name: "中区" }, { name: "东区" }, { name: "西区" }, { name: "南区" }, { name: "北区" }, { name: "西屯区" }, { name: "南屯区" }, { name: "北屯区" }, { name: "丰原区" }, { name: "大里区" }, { name: "太平区" }, { name: "东势区" }, { name: "大甲区" }, { name: "清水区" }, { name: "沙鹿区" }, { name: "梧栖区" }, { name: "后里区" }, { name: "神冈区" }, { name: "潭子区" }, { name: "大雅区" }, { name: "新小区" }, { name: "石冈区" }, { name: "外埔区" }, { name: "大安区" }, { name: "乌日区" }, { name: "大肚区" }, { name: "龙井区" }, { name: "雾峰区" }, { name: "和平区" }],
    type: 0 }, { name: "台南市",
    sub: [{ name: "请选择" }, { name: "中西区" }, { name: "东区" }, { name: "南区" }, { name: "北区" }, { name: "安平区" }, { name: "安南区" }, { name: "永康区" }, { name: "归仁区" }, { name: "新化区" }, { name: "左镇区" }, { name: "玉井区" }, { name: "楠西区" }, { name: "南化区" }, { name: "仁德区" }, { name: "关庙区" }, { name: "龙崎区" }, { name: "官田区" }, { name: "麻豆区" }, { name: "佳里区" }, { name: "西港区" }, { name: "七股区" }, { name: "将军区" }, { name: "学甲区" }, { name: "北门区" }, { name: "新营区" }, { name: "后壁区" }, { name: "白河区" }, { name: "东山区" }, { name: "六甲区" }, { name: "下营区" }, { name: "柳营区" }, { name: "盐水区" }, { name: "善化区" }, { name: "大内区" }, { name: "山上区" }, { name: "新市区" }, { name: "安定区" }],
    type: 0 }, { name: "高雄市",
    sub: [{ name: "请选择" }, { "name": "楠梓区" }, { "name": "左营区" }, { "name": "鼓山区" }, { "name": "三民区" }, { "name": "盐埕区" }, { "name": "前金区" }, { "name": "新兴区" }, { "name": "苓雅区" }, { "name": "前镇区" }, { "name": "旗津区" }, { "name": "小港区" }, { "name": "凤山区" }, { "name": "大寮区" }, { "name": "鸟松区" }, { "name": "林园区" }, { "name": "仁武区" }, { "name": "大树区" }, { "name": "大社区" }, { "name": "冈山区" }, { "name": "路竹区" }, { "name": "桥头区" }, { "name": "梓官区" }, { "name": "弥陀区" }, { "name": "永安区" }, { "name": "燕巢区" }, { "name": "阿莲区" }, { "name": "茄萣区" }, { "name": "湖内区" }, { "name": "旗山区" }, { "name": "美浓区" }, { "name": "内门区" }, { "name": "杉林区" }, { "name": "甲仙区" }, { "name": "六龟区" }, { "name": "茂林区" }, { "name": "桃源区" }, { "name": "那玛夏区" }],
    type: 0 }, { name: "基隆市",
    sub: [{ name: "请选择" }, { "name": "中正区" }, { "name": "七堵区" }, { "name": "暖暖区" }, { "name": "仁爱区" }, { "name": "中山区" }, { "name": "安乐区" }, { "name": "信义区" }],
    type: 0 }, { name: "新竹市",
    sub: [{ name: "请选择" }, { "name": "东区" }, { "name": "北区" }, { "name": "香山区" }],
    type: 0 }, { name: "嘉义市",
    sub: [{ name: "请选择" }, { "name": "东区" }, { "name": "北区" }],
    type: 0 }, { name: "宜兰县" }, { name: "新竹县" }, { name: "苗栗县" }, { name: "彰化县" }, { name: "南投县" }, { name: "云林县" }, { name: "嘉义县" }, { name: "屏东县" }, { name: "台东县" }, { name: "花莲县" }, { name: "澎湖县" }, { name: "金门县" }, { name: "连江县" }],
  type: 0
}];
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "SldU":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 * jQuery.bxPlayer.js
 * 
 * @author: wangzhenhua@cntv.cn
 */
(function($) {
    
    $.fn.bxPlayer = function(options, callback) {
        
        // Default Settings.
        var defaults = {
            id: '',
            item_id: '',
            pid: '100',
            width: 640,
            height: 385,
            poster: undefined,
            type: 'out',
            order: 'asc',
            autoplay: false,
            controls: false,
            callback: false
        };
        
        // Cached jQuery Object Variables
        var $base = this;
        var $video;
        
        // Variables for cached values or use across multiple functions
        var stats = [],
        videoData = null,
        videoList = null,
        nextAutoPlay = true,
        chapterURLs = [], 
        currentIndex = 0, 
        currentVideoId = '', 
        playEnded = false;
        
        var htmlTemplate = '<embed src="http://player.xiyou.cntv.cn/{id}.swf" quality="high" width="640" height="385" align="middle" allowScriptAccess="always" allowFullScreen="true" mode="transparent" type="application/x-shockwave-flash"></embed>';
        var flashTemplate = 'http://player.xiyou.cntv.cn/{id}.1.swf';
        
        // build main options before element iteration      
        options = $.extend(defaults, options);
        
        if (callback) {
            options.callback = callback;
        }
        
        // PUBLIC FUNCTIONS
        this.init = function() {
            //create html structure
            $video = $('<video' + ' webkit-playsinline playsinline' + (options.autoplay == true ? ' autoplay="true"' : ' preload="auto"') + (options.controls == true ? ' controls="true"' : '') + ' width="' + options.width + '" height="' +  options.height + '"></video>')
                    .appendTo(this);
            
            loadVideoInfo(options.id);
            
            $video.bind('ended', function() {
                if (currentIndex < chapterURLs.length - 1) {
                    currentIndex ++;
                    setVideoSource(true);
                } else {
                    if (isPlaylist() && nextAutoPlay == true) {
                        var index = getVideoPosition(currentVideoId) + 1;
                        if (index < videoList.length && videoList[index]) {
                            // play next video
                            options.autoplay = true;
                            loadVideoInfo(videoList[index]);
                            return ;
                        }
                    }
                    playEnded = true;                      
                    if (options.callback && $.isFunction(options.callback)) {
                        options.callback.call($video);
                    }                   
                }
            });
        };
        
        this.play = function() {
            $video[0].play();
        }; 
        
        this.pause = function() {  
            $video[0].pause();
        }; 
        
        // get video data
        this.getData = function() {
            return videoData;
        };
        
        // get video stat
        this.getStats = function() {
            return stats;
        };
        
        // get video list
        this.getPlaylist = function() {
            return videoList;
        };
        
        // change video
        this.changeVideo = function(id) {
            loadVideoInfo(id);
        };

        // set list autoplay
        this.setListAutoPlay = function(bool) {
            nextAutoPlay = bool;
        };
        
        // get current video id
        this.getVideoId = function() {
            return currentVideoId;
        };
        
        // get current video id
        this.resize = function(width, height) {
            return $video.attr({'width': height, 'height': height});
        };
        
        // PRIVATE FUNCTIONS    
        function isPlaylist() {
            return (options.type == 'playlist' || options.type == 'album' || options.type == 'my') ? true : false;
        }
        
        function loadVideoInfo(vid) {
            // reset data
            chapterURLs = []; currentIndex = 0; playEnded = false;
            videoData = null; stats = [];
            // 接口
            var hostUrl = document.location.href;
            var domainName = 'http://';
            if(hostUrl.split(':')[0] == 'https'){
              domainName = 'https://'
            }else{
              domainName = 'http://'
            }
            $.getScript(domainName + 'api.ishow.cctv.com/video/playAddress?varname=_xyVideoData_&showpath=1&pid=' + options.pid + '&videoId=' + vid + (isPlaylist() ? '&album=' + options.item_id : ''), function() {

            // $.getScript('http://xiyou.cctv.com/interface/index?varname=_xyVideoData_&showpath=1&pid=' + options.pid + '&videoId=' + vid + (isPlaylist() ? '&album=' + options.item_id : ''), function() {
      
                if (_xyVideoData_.status !== 'success') {
                    return errCode(4001, '获取视频信息失败');
                }
                videoData = _xyVideoData_.data[0];
                _xyVideoData_ = null;

                // Wraiting
                loadWraiting(options.type, currentVideoId, (videoData.outer_code ? videoData.outer_code : videoData.inner_code), videoData.timeSpan);
                
                currentVideoId = videoData.videoId;

                //if (supportM3U8() == false) {
                    if( "undefined" == typeof(videoData.videoList) && "undefined" != typeof(videoData.videoListHD)){
                        videoData.videoList = videoData.videoListHD;
                    }
                    for (var i = 0; i < videoData.videoList.length; i++) {
                        if (videoData.videoList[i].url != null && videoData.videoList[i].duration > 0) {
                            chapterURLs.push(videoData.videoList[i].url);
                        }
                    }

                    if (chapterURLs.length == 0) {
                        return errCode(4003, '获取视频地址失败');
                    } 

                    // 播放视频
                    setVideoSource(options.autoplay);
                    
                //} else {
                //    $.getScript('http://vdn.apps.cntv.cn/api/getIpadVideoInfo.do?pid='+ videoData.playid +'&tai=xiyou&from=html5', function() {
                //        if( "undefined" != typeof(html5VideoData.hls_url) && html5VideoData.hls_url.length > 0){
				//			if(html5VideoData.hls_url.indexOf("?") !== -1){
				//				html5VideoData.hls_url += "&minbr=400";
				//			} else{
				//				html5VideoData.hls_url += "?minbr=400";
				//			}
                //            chapterURLs.push(html5VideoData.hls_url);
                //        } else {
				//			if(html5VideoData.video.chapters)
				//			{
				//				for (var i = 0; i < html5VideoData.video.chapters.length; i++) {
				//				if (html5VideoData.video.chapters[i].url != null && html5VideoData.video.chapters[i].duration > 0) {
				//						chapterURLs.push(html5VideoData.video.chapters[i].url);
				//					}
				//				}
				//			}
                //        }
                //
                //        if (chapterURLs.length == 0) {
                //            return errCode(4003, '获取视频地址失败');
                //        } 
                //
                //        // 播放视频
                //        setVideoSource(options.autoplay);
                //    });
                //}         
                
                
                
                // refresh web
                if (typeof(refreshWebPage) != 'undefined' && $.isFunction(refreshWebPage)) {
                    refreshWebPage(currentVideoId, 'next');
                }
                    
                // 格式化数据
                videoData.time = gTimeFormat(videoData.timeSpan);
                videoData.refHtml = htmlTemplate.replace('{id}', currentVideoId);
                videoData.refFlash = flashTemplate.replace('{id}', currentVideoId);
                videoData.videoList = null;
                
           /*     if (isPlaylist() && videoList == null) {
                    $.getScript('http://xiyou.cctv.com/interface/relative?varname=_xyRelData_&item_type=' + (options.type == 'my' ? 'program' : options.type) + '&item_id=' + options.item_id + '&order=' + options.order, function() {
                        if (_xyRelData_.status !== 'success') {
                            return errCode(4004, '获取视频列表失败');
                        }
                        videoList = _xyRelData_.data;
                        _xyRelData_ = null;
                        return false;
                    }); 
                }*/
                return errCode(200, 'OK');
            });
        }
        
        function loadWraiting(type, vid, code, time) {
            var wratingUrl = 'http://cntv.wrating.com/v.gif?s=&ut=&t=&j=&f=&c={CODE}&l=&b={URL}&js=&a=&ck=&n=&st=A-1_3|3_1|-2_0&vlen={TIME}&z=&i=&vu={URL}&vid={CODE}';
            
            wratingUrl = wratingUrl.replace('{CODE}', code);
            wratingUrl = wratingUrl.replace('{CODE}', code);
            wratingUrl = wratingUrl.replace('{URL}', getVideoPageURL(vid));
            wratingUrl = wratingUrl.replace('{URL}', getVideoPageURL(vid));
            wratingUrl = wratingUrl.replace('{TIME}', time);
            $.getScript(wratingUrl);

            return;
        }
        
        function getVideoPageURL(vid) {
            var videoPageTemplate = 'http://xiyou.cctv.com/v-{id}.html';
            return encodeURIComponent(videoPageTemplate.replace('{id}', vid));
        }
        
        function setVideoSource(autoplay) {
            $video[0].pause();
            $video.attr('poster', options.poster ? options.poster : videoData.imagePath);
            $video.attr('src', chapterURLs[currentIndex]);
            if (autoplay) {
                $video[0].load();
                $video[0].play();
            };
        }
        
        function gTimeFormat (seconds) {
            var m = Math.floor(seconds/60) < 10 ? "0" + Math.floor(seconds/60) : Math.floor(seconds/60);
            var s = Math.floor(seconds-(m*60)) < 10 ? "0" + Math.floor(seconds-(m*60)) : Math.floor(seconds-(m*60));
            return m + ':' + s;
        }
        
        
        function getVideoPosition (id) {
            var len = videoList.length;
            for (var i = 0; i < len; i++) {
                if (id == videoList[i]) {
                    return i;
                    break;
                }
            }
            return -1;
        }
        
        function errCode  (c, m) {
            stats = {code: c, msg: m};
            return stats;
        }

        function supportM3U8() {
            if (/(iphone|ipad|ipod|ios)/i.test(navigator.userAgent))
                return true;

            if (/(firefox)/i.test(navigator.userAgent))
                return false;

            var version = 0;
            var clientInfo = navigator.userAgent.toLowerCase();
            var pos = clientInfo.indexOf("android");
            version = clientInfo.substr(pos+7);
            version = parseFloat(version);
            if(!version) {
                version = clientInfo.substr(pos+8);
                version = parseFloat(version);
            }
            return version > 4.1;
        }
        
        // iterate and reformat each matched element
        return this.each(function() {
            $base.init();
        });
        
        return this;
    };
    
})(jQuery);


var html5VideoData;
function getHtml5VideoData(data)
{
    html5VideoData = eval('(' + data + ')');;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "SyNO":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, $) {// QQ表情插件
(function($){  
	$.fn.qqFace = function(options){
		var defaults = {
			id : 'facebox',
			path : 'face/',
			assign : 'content',
			tip : 'em_'
		};
		var option = $.extend(defaults, options);
		var assign = $('#'+option.assign);
		var id = option.id;
		var path = option.path;
		var tip = option.tip;
		
		if(assign.length<=0){
			alert('缺少表情赋值对象。');
			return false;
		}

		// 按钮表情展示
		var strFace, labFace;
		if($('#'+id).length<=0){
			strFace = '<div id="'+id+'" style="background:#d0d0d0;overflow:hidden;" class="qqFace">' +
						  '<table border="0" cellspacing="0" cellpadding="0" style="margin:8px auto"><tr>';
			for(var i=1; i<=28; i++){
				labFace = '['+tip+i+']';
				strFace += '<td><img src="'+path+i+'.gif" onclick="$(\'#'+option.assign+'\').setCaret();$(\'#'+option.assign+'\').insertAtCaret(\'' + labFace + '\');" /></td>';
				if( i % 8 == 0 ) strFace += '</tr><tr>';
			}
			strFace += '</tr></table></div>';
		}
		$(this).parent().append(strFace);
		$('#'+id).css("height","0");

		// 标签编码转换
		function replace_em(str){
            str = str.replace(/\</g,'&lt;');
            str = str.replace(/\>/g,'&gt;');
            str = str.replace(/\n/g,'<br/>');
            str = str.replace(/\[em_([0-9]*)\]/g,'<img src="../dist/arclist/$1.gif" border="0" />');
            return str;
        }
		
		$(this).click(function(e){
			if($(this).hasClass("showsmile")){
				$(this).removeClass("showsmile");
				$('#'+id).animate({"height":"0"},500,function(){
					$('#'+id).css({"border-top":"none"});
					$(".icon-smile").removeClass("icon");
				});
			}else{
				$(this).addClass("showsmile");
				$('#'+id).css({"height":"0","border-top":"1px solid #ccc"});
				$(".icon-smile").addClass("icon");
				$('#'+id).animate({"height":"136px"},500);
			}
			e.stopPropagation();
		});
	};

})(jQuery);

jQuery.extend({ 
	unselectContents: function(){ 
		if(window.getSelection) 
		window.getSelection().removeAllRanges(); 
		else if(document.selection) 
		document.selection.empty(); 
	} 
});

jQuery.browser={};(function(){jQuery.browser.msie=false; jQuery.browser.version=0;if(navigator.userAgent.match(/MSIE ([0-9]+)./)){ jQuery.browser.msie=true;jQuery.browser.version=RegExp.$1;}})();
jQuery.fn.extend({ 
	selectContents: function(){ 
		$(this).each(function(i){ 
			var node = this; 
			var selection, range, doc, win; 
			if ((doc = node.ownerDocument) && (win = doc.defaultView) && typeof win.getSelection != 'undefined' && typeof doc.createRange != 'undefined' && (selection = window.getSelection()) && typeof selection.removeAllRanges != 'undefined'){ 
				range = doc.createRange(); 
				range.selectNode(node); 
				if(i == 0){ 
					selection.removeAllRanges(); 
				} 
				selection.addRange(range); 
			} else if (document.body && typeof document.body.createTextRange != 'undefined' && (range = document.body.createTextRange())){ 
				range.moveToElementText(node); 
				range.select(); 
			} 
		}); 
	},
	setCaret: function(){
        // $.browser.mozilla = /firefox/.test(navigator.userAgent.toLowerCase());
        // $.browser.webkit = /webkit/.test(navigator.userAgent.toLowerCase());
        // $.browser.opera = /opera/.test(navigator.userAgent.toLowerCase());
        // $.browser.msie = /msie/.test(navigator.userAgent.toLowerCase());
		if(!$.browser.msie) return;
		var initSetCaret = function(){ 
			var textObj = $(this).get(0); 
			textObj.caretPos = document.selection.createRange().duplicate(); 
		}; 
		$(this).click(initSetCaret).select(initSetCaret).keyup(initSetCaret); 
	}, 

	insertAtCaret: function(textFeildValue){ 
		var textObj = $(this).get(0); 
		if(document.all && textObj.createTextRange && textObj.caretPos){ 
			var caretPos=textObj.caretPos; 
			caretPos.text = caretPos.text.charAt(caretPos.text.length-1) == '' ? 
			textFeildValue+'' : textFeildValue; 
		} else if(textObj.setSelectionRange){ 
			var rangeStart=textObj.selectionStart; 
			var rangeEnd=textObj.selectionEnd; 
			var tempStr1=textObj.value.substring(0,rangeStart); 
			var tempStr2=textObj.value.substring(rangeEnd); 
			textObj.value=tempStr1+textFeildValue+tempStr2; 
			textObj.focus(); 
			var len=textFeildValue.length; 
			textObj.setSelectionRange(rangeStart+len,rangeStart+len); 
			textObj.blur(); 
		}else{ 
			textObj.value+=textFeildValue; 
		} 
	} 
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("7t+N")))

/***/ }),

/***/ "T4fS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signIn_vue__ = __webpack_require__("tS01");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4e8ba2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signIn_vue__ = __webpack_require__("T5Cv");
function injectStyle (ssrContext) {
  __webpack_require__("S0vE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4e8ba2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T5Cv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_SignIn"},[_c('div',{},[_c('div',{staticClass:"header login-header"},[_c('a',{staticClass:"icon-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.fn}}),_vm._v("\n     央视账号登录\n     ")]),_vm._v(" "),_c('div',{staticClass:"line-gray"}),_vm._v(" "),_c('div',{staticClass:"login-content"},[_c('form',{staticClass:"lg-tabbox",attrs:{"id":"punishformID"}},[_c('div',{staticClass:"group-item"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-box input-tel",staticStyle:{"padding-left":"5em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],attrs:{"type":"text","placeholder":"请输入邮箱或手机","name":"username","id":"username"},domProps:{"value":(_vm.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userName!= ''),expression:"userName!= ''"}],staticClass:"btn-del",staticStyle:{"display":"none"},on:{"click":function($event){_vm.userName = ''}}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger uname",staticStyle:{"display":"none"}},[_vm._v("输入格式有误，请使用邮箱或手机号登录")]),_vm._v(" "),_c('div',{staticClass:"group-item"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"input-box input-tel",staticStyle:{"padding-left":"5em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"请输入密码","name":"password","id":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.password!= ''),expression:"password!= ''"}],staticClass:"btn-del",staticStyle:{"display":"none"},on:{"click":function($event){_vm.password = ''}}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger upass",staticStyle:{"display":"none"}},[_vm._v("密码错误，请重输。")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"group-mess"},[_c('router-link',{attrs:{"to":"/repassword","tag":"a"}},[_vm._v("\n            忘记密码\n          ")]),_vm._v(" "),_c('a',{staticStyle:{"float":"right"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.table}},[_vm._v("\n            手机登录\n          ")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"icon-lg-accout"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"icon-lg-password"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-info"},[_c('a',{staticClass:"font-lgr",attrs:{"href":"javascript:void(0);"}},[_vm._v("\n            登  录\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "THR+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      globalUrl: API.GlobalUrl
    };
  },

  methods: {
    //操作按钮事件
  },
  mounted: function mounted() {
    //操作DOM
    var u = navigator.userAgent;
    if (u.indexOf('iPhone') > -1) {
      //苹果手机
      $('.footer').css('padding-bottom', '72px');
    }
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "TSqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_Quick"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"header login-header"},[_c('a',{staticClass:"icon-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.fn}}),_vm._v(" "),_vm._v("手机快捷登录\n    ")]),_vm._v(" "),_c('div',{staticClass:"line-gray"}),_vm._v(" "),_c('div',{staticClass:"content login-content"},[_c('form',{staticClass:"lg-tabbox"},[_c('div',{staticClass:"group-item"},[_c('label',[_vm._v("+86")]),_vm._v(" "),_c('div',{staticClass:"input-box input-tel"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobilePhone),expression:"mobilePhone"}],staticClass:"MobilePhone",attrs:{"type":"tel","placeholder":"请输入手机号","id":"MobilePhone","maxlength":"11"},domProps:{"value":(_vm.mobilePhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobilePhone=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobilePhone != ''),expression:"mobilePhone != ''"}],staticClass:"btn-del",staticStyle:{"display":"none"},on:{"click":function($event){_vm.mobilePhone = ''}}})])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.falseHints),expression:"falseHints"}],staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"MobilePhone-mess"}},[_vm._v(_vm._s(_vm.falseHintsHtml))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.telYzmMess),expression:"telYzmMess"}],staticClass:"text-danger",attrs:{"id":"tel-yzm-mess"}},[_vm._v(_vm._s(_vm.telYzmMessHtml))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.yzmMess),expression:"yzmMess"}],staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"img-yzm-mess"}}),_vm._v(" "),_c('div',{staticClass:"group-item"},[_c('label',[_vm._v("验证码")]),_vm._v(" "),_c('div',{staticClass:"input-box input-yzm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telYzm),expression:"telYzm"}],attrs:{"type":"text","placeholder":"请输入验证码","id":"tel_yzm"},domProps:{"value":(_vm.telYzm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telYzm=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"btn-yzm puts",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.puts}},[_vm._v("发送验证码")])])]),_vm._v(" "),_c('div',{staticClass:"group-info"},[_c('a',{staticClass:"font-lgr",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.login}},[_vm._v("登  录")])]),_vm._v(" "),_c('div',{staticClass:"group-mess"},[_c('router-link',{attrs:{"to":"/register","tag":"a"}},[_vm._v("\n            立即注册\n          ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/signIn","tag":"a"}},[_vm._v("\n            账户登录\n          ")])],1)])]),_vm._v(" "),(_vm.thirdParty)?_c('div',{staticClass:"login-other"},[_c('p',{staticClass:"lg-tit"},[_vm._v("第三方登录")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://oauth.passport.cntv.cn/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=https://act.ishow.cctv.com/h5/mymessage"}},[_c('img',{attrs:{"src":__webpack_require__("sgvI")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"http://oauth.passport.cntv.cn/OAuthSinaClient/OAuthSinaClientServlet.do?cntv_callback=https://act.ishow.cctv.com/h5/mymessage"}},[_c('img',{attrs:{"src":__webpack_require__("WrP+")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://reg.cctv.com/OauthAlipay/OauthAlipayServlet.action?method=login&cntv_callback=https://act.ishow.cctv.com/h5/mymessage"}},[_c('img',{attrs:{"src":__webpack_require__("IGXn")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TVK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('Loading'),_vm._v(" "),_c('div',{staticClass:"wrap detail-wrap"},[_c('div',{staticClass:"wrap-inner"},[_c('div',{staticClass:"content-inner-box"},[(_vm.detailsTxte.playbill_vertical)?_c('div',{staticClass:"detai-pic"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.detailsTxte.playbill_vertical,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content detail-content"},[(_vm.detailsTxte.page_config && _vm.detailsTxte.page_config.top_view == 'slideshow')?_c('div',{staticClass:"swiper-container banner"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.detailsTxte.top_view),function(item){return _c('div',{staticClass:"swiper-slide bg-cover"},[_c('img',{attrs:{"src":JSON.parse(item.img_path).h5}})])})),_vm._v(" "),_c('div',{staticClass:"swiper-pagination"})]):_c('div',[(_vm.detailsTxte.page_config && _vm.detailsTxte.page_config.top_view == 'trailer')?_c('div',{staticClass:"banner-video"},[_c('div',{staticClass:"video_left",staticStyle:{"margin":"0 auto"},attrs:{"id":"Trailer","uuid":_vm.detailsTxte.top_trailer.uuid}})]):_c('div',{staticClass:"dl-banner"},[(_vm.detailsTxte.playbill)?_c('img',{attrs:{"src":_vm.detailsTxte.playbill.playbill_h5,"alt":""}}):_vm._e(),_vm._v(" "),_c('em',{staticClass:"pic-box-em pic-box-em2"},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/off.png',"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"show-box"},[_c('div',{staticClass:"show-department"},[_c('div',{staticClass:"show-dl-top clearfix",on:{"click":_vm.contactFn}},[_c('h5',{staticClass:"detail-hostunit"},[_c('h3',[_vm._v(_vm._s(_vm._f("ellipsis")(_vm.detailsTxte.title,30)))])]),_vm._v(" "),_c('div',{staticClass:"show-logo"},[(_vm.detailsTxte.hostunit)?_c('img',{attrs:{"src":_vm.detailsTxte.hostunit.host_avatar,"alt":""}}):_vm._e()])])])]),_vm._v(" "),(_vm.ID != '100145')?_c('div',{staticClass:"show-box detail-time  show-dl-ldtxts"},[_c('div',[_c('h4',{staticStyle:{"font-size":"16px"}},[_vm._v("活动时间")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm._f("format")(_vm.detailsTxte.start_time))+"开始 -\n                  "+_vm._s(_vm._f("format")(_vm._f("orderByTime")(_vm.detailsTxte.end_time,_vm.detailsTxte.start_time))))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dl-detail"},[(!_vm.detailsTxte.page_config || _vm.detailsTxte.page_config.about_view != 0)?_c('div',{staticClass:"dl-bx"},[(_vm.detailsTxte.description)?_c('h5',{staticClass:"show-tit"},[_vm._v("详情介绍\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dl-mess-box dl-mess-last",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"dl-mess-inner"},[(_vm.detailsTxte.description)?_c('div',{staticClass:"dl-text",domProps:{"innerHTML":_vm._s(_vm.detailsTxte.description)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"more-display"},[(_vm.detailsTxte.detail)?_c('div',{staticClass:"dl-text 2111",domProps:{"innerHTML":_vm._s(_vm.detailsTxte.detail)}}):_vm._e(),_vm._v(" "),(_vm.detailsTxte.trailer_config)?_c('div',{staticClass:"dl-video-pic",staticStyle:{"margin":"5px 0 5px -15px"}},[(_vm.detailsTxte.trailer_config.pub_uuid)?_c('div',[_c('div',{staticClass:"video_left",staticStyle:{"margin-left":"10px"},attrs:{"id":"myFlash","uuid":_vm.detailsTxte.trailer_config.pub_uuid}}),_vm._v(" "),_c('div',{staticClass:"dl-texttit",staticStyle:{"margin":"0"}},[(_vm.detailsTxte.trailer_config)?_c('p',{staticStyle:{"margin-bottom":"0","padding":"0"}},[_vm._v("\n                              "+_vm._s(_vm.detailsTxte.trailer_config.pub_title))]):_vm._e()])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.detailsTxte.rule)?_c('div',{staticClass:"dl-text",domProps:{"innerHTML":_vm._s(_vm.detailsTxte.rule)}}):_vm._e(),_vm._v(" "),(_vm.detailsTxte.feedback)?_c('div',{staticClass:"dl-text",domProps:{"innerHTML":_vm._s(_vm.detailsTxte.feedback)}}):_vm._e(),_vm._v(" "),(_vm.detailsTxte.slogan)?_c('div',{staticClass:"dl-text-gray",domProps:{"innerHTML":_vm._s(_vm.detailsTxte.slogan)}}):_vm._e(),_vm._v(" "),(_vm.detailsTxte.website_url)?_c('a',{staticClass:"dl-text-entry",attrs:{"href":_vm.detailsTxte.website_url.url}},[(_vm.detailsTxte.website_url.text)?_c('i',{staticClass:"icon-entry"}):_vm._e(),_vm._v("\n                        "+_vm._s(_vm.detailsTxte.website_url.text)+"\n                      ")]):_vm._e()])])]),_vm._v(" "),(_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.accept&&_vm.detailsTxte.page_config.accept.is_show==1)?_c('div',{staticClass:"dl-detail-agree"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agreeState),expression:"agreeState"}],attrs:{"type":"checkbox","id":"agree"},domProps:{"checked":Array.isArray(_vm.agreeState)?_vm._i(_vm.agreeState,null)>-1:(_vm.agreeState)},on:{"change":function($event){var $$a=_vm.agreeState,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.agreeState=$$a.concat([$$v]))}else{$$i>-1&&(_vm.agreeState=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.agreeState=$$c}}}}),_vm._v(" "),_c('span',{on:{"click":_vm.agree}},[_vm._v(_vm._s(_vm.detailsTxte.page_config.accept.title))])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dl-join-box",attrs:{"id":"pos"}},[(_vm.detailsTxte)?_c('Series',{attrs:{"twoNumbers":_vm.twoNumbers,"detailsTxte":_vm.detailsTxte}}):_vm._e(),_vm._v(" "),(_vm.detailsTxte.page_config && _vm.detailsTxte.page_config.show_count)?_c('div',[(!(_vm.detailsTxte.page_config && _vm.detailsTxte.page_config.show_count && _vm.detailsTxte.page_config.show_count.is_show == 0))?_c('div',[(_vm.detailsTxte.part_num > 0)?_c('p',[_vm._l((String(_vm.detailsTxte.part_num)),function(val,i){return (_vm.detailsTxte.part_num)?_c('span',[_vm._v(_vm._s(val))]):_vm._e()}),_vm._v("\n                      人参与\n                    ")],2):_c('p',[_c('span',[_vm._v("0")]),_vm._v("\n                      人参与\n                    ")]),_vm._v(" "),(_vm.ID =='100145')?_c('p'):(_vm.detailsTxte.follow_num > 0)?_c('p',[_vm._l((String(_vm.detailsTxte.follow_num)),function(val,i){return (_vm.detailsTxte.follow_num)?_c('span',[_vm._v(_vm._s(val))]):_vm._e()}),_vm._v("\n                      人关注\n                    ")],2):_c('p',[_c('span',[_vm._v("0")]),_vm._v("\n                      人关注\n                    ")])]):_vm._e()]):_vm._e()],1)]),_vm._v(" "),(_vm.progressName)?_c('div',{staticClass:"line"}):_vm._e(),_vm._v(" "),(_vm.progressName)?_c('div',{staticClass:"show-box"},[_c('h5',{staticClass:"show-tit"},[_vm._v(_vm._s(_vm.progressTitle)+"\n                "),_c('router-link',{staticClass:"show-linkmore",attrs:{"tag":"a","to":{name:'list_image',params: {id: _vm.detailsTxte.id, init:1}}}},[_vm._v("\n                  更多\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"show-acty-info"},[_vm._v(_vm._s(_vm.detailsTxte.start_time)+" 被加入活动候选资料库")]),_vm._v(" "),_c('div',{staticClass:"swiper-container show-activiy-swiper"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.progressName),function(v,ind){return _c('div',{staticClass:"swiper-slide"},[_c('ul',{staticClass:"show-list-more"},_vm._l((_vm.threeNumbers),function(item,i){return (_vm.progress[ind*2+i])?_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.video(_vm.progress[ind*2+i].file_type,_vm.detailsTxte.id,_vm.detailsTxte.playbill.playbill_h5,i,_vm.progress[ind*2+i].uuid)}}},[_c('div',{staticClass:"pic-box-more"},[(_vm.progress[ind*2+i].file_type == 1)?_c('img',{attrs:{"src":_vm.progress[ind*2+i].thumb_path,"alt":""}}):_c('img',{attrs:{"src":_vm.progress[ind*2+i].file_path,"alt":""}}),_vm._v(" "),(_vm.progress[ind*2+i].time_span)?_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(_vm.progress[ind*2+i].time_span)))]):_c('i',{staticClass:"icon-time"},[_vm._v("图片")])])])]):_vm._e()}))])}))])]):_vm._e(),_vm._v(" "),(_vm.detailsTxte)?_c('Vote',{attrs:{"twoNumbers":_vm.twoNumbers,"detailsTxte":_vm.detailsTxte}}):_vm._e(),_vm._v(" "),(_vm.detailsTxte)?_c('Collection',{attrs:{"twoNumbers":_vm.twoNumbers,"detailsTxte":_vm.detailsTxte,"globalUrl":_vm.globalUrl}}):_vm._e(),_vm._v(" "),(_vm.marvellous.length>1)?_c('div',{staticClass:"line"}):_vm._e(),_vm._v(" "),(_vm.marvellous.length>1)?_c('div',{staticClass:"show-box"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"tag":"a","to":{name:'list_image', params: {id: _vm.detailsTxte.id,init:1}}}},[_c('h5',{staticClass:"show-tit"},[_vm._v(_vm._s(_vm.marvellousTitle)+"\n                  "),_c('a',{staticClass:"show-linkmore",attrs:{"href":"javascript:void(0);"}},[_vm._v("\n                    更多\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-container swiper-pic"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.marvellous),function(item,i){return _c('div',{staticClass:"swiper-slide"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.water(item)}}},[_c('img',{staticStyle:{"height":"120px","width":"auto"},attrs:{"src":item.file.image_url,"alt":""}})])])}))])],1):_vm._e(),_vm._v(" "),(_vm.detailsTxte)?_c('Release',{attrs:{"twoNumbers":_vm.twoNumbers,"detailsTxte":_vm.detailsTxte}}):_vm._e(),_vm._v(" "),(_vm.thirdParty)?_c('div',{staticClass:"line"}):_vm._e(),_vm._v(" "),(_vm.ID == '77066')?_c('div',{staticClass:"detail-everybody",staticStyle:{"background":"#f3f3f4"}},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/image/everybody.jpg',"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.thirdParty)?_c('div',{staticClass:"show-box"},[_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dl-message"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"dl-ms-link"},[_vm._l((_vm.leavingName),function(item,ind){return _c('div',{staticClass:"dl-ms"},[_c('div',{staticClass:"dl-ms-head"},[_c('div',{staticClass:"dl-head-pic"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"dl-head-name"},[_vm._v("\n                      "+_vm._s(item.author)),_c('span',[_vm._v("["+_vm._s(item.locale)+"]")])]),_vm._v(" "),_c('div',{staticClass:"dl-head-like"},[_vm._m(4,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.agree))]),_vm._v(" "),_c('i',{staticClass:"icon-ms-reply",attrs:{"attr-pid":item.pid,"attr-tip":item.tid}})])]),_vm._v(" "),_c('div',{staticClass:"dl-ms-chat"},[_c('div',{staticClass:"dl-ms-tit",domProps:{"innerHTML":_vm._s(_vm.$options.filters.msg(item.message))}}),_vm._v(" "),_c('div',{staticClass:"dl-ms-time"})]),_vm._v(" "),_c('div',{staticClass:"dl-time"},[_vm._v(_vm._s(_vm._f("timeToMillion")(new Date().getTime()/1000 - item.dateline)))]),_vm._v(" "),(item.replys)?_c('div',{staticClass:"dl-re-box"},_vm._l((item.replys),function(reps,idx){return _c('div',{staticClass:"dl-ms-re"},[_c('span',{staticClass:"re-user"},[_vm._v(_vm._s(reps.author))]),_vm._v("："),_c('span',{staticClass:"re-ms",domProps:{"innerHTML":_vm._s(_vm.$options.filters.msg(reps.message))}})])})):_vm._e()])}),_vm._v(" "),_c('p',{staticClass:"dl-ms-more",on:{"click":_vm.moreFn}},[_vm._v("查看更多留言")])],2)])],1),_vm._v(" "),(_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.cctvheader&&_vm.detailsTxte.page_config.cctvheader.is_show!=0)?_c('PointFooter',{staticStyle:{"margin-bottom":"50px"}}):_vm._e()],1)]),_vm._v(" "),(_vm.ID=='100145')?_c('div',{staticClass:"detail-bottom"},[_c('a',{staticClass:"dl-btn-join",staticStyle:{"float":"left","margin-left":"-7px","width":"50%"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.participateIn(_vm.detailsTxte.playbill,_vm.detailsTxte.id)}}},[_c('i',{staticClass:"icon-join"}),_vm._v(_vm._s(_vm.joinWord))]),_vm._v(" "),_c('a',{staticClass:"dl-btn-join",staticStyle:{"margin-right":"3px","width":"50%"},attrs:{"href":"https://vod.cctv.cn/cctv/download/share/index.html"}},[_vm._v("下载客户端")])]):_c('div',{staticClass:"detail-bottom"},[_c('router-link',{staticClass:"dl-btn-mine",attrs:{"to":"/MyMessage","tag":"a"}},[_c('i',{staticClass:"icon-mine"}),_vm._v("我的")]),_vm._v(" "),(!_vm.isSeries)?[_c('a',{staticClass:"dl-btn-attack",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.follow}},[_c('i',{class:_vm.followOn == true?'icon-attack icon-attack-on':'icon-attack'}),_vm._v("关注")]),_vm._v(" "),_c('a',{class:['dl-btn-join', _vm.agreeState?'':'disabled'],attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.participateIn(_vm.detailsTxte.playbill,_vm.detailsTxte.id)}}},[_c('i',{staticClass:"icon-join"}),_vm._v(_vm._s(_vm.joinWord))])]:_c('a',{staticClass:"dl-btn-attack dl-btn-attack-series",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.follow}},[_c('i',{staticClass:"icon-attack"}),_vm._v(_vm._s(_vm.followOn?'已':'')+"关注")])],2),_vm._v(" "),_c('div',{staticClass:"detail-bottom-ipx"}),_vm._v(" "),_vm._m(5),_vm._v(" "),(_vm.detailsTxte.playbill &&_vm.detailsTxte.is_vote == 1)?_c('router-link',{staticClass:"btn-detail-poll  btn-detail-anim",staticStyle:{"z-index":"9999","display":"none"},attrs:{"tag":"a","to":{name:'list_vote',params: {id: _vm.detailsTxte.id,active: 1}}}},[_c('span'),_vm._v(" "),_c('i')]):_vm._e()],1),_vm._v(" "),_c('VoteAlert'),_vm._v(" "),_c('div',{staticClass:"entry-modal large-info-modal modal fade",attrs:{"id":"Alert","role":"dialog","data-backdrop":"static","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"Prompt-p"},[_vm._v("活动已结束！")]),_vm._v(" "),_c('button',{staticClass:"buttonZ buttonDiv",attrs:{"data-dismiss":"modal"},on:{"click":_vm.toHome}},[_vm._v("确  定")])])])])]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"modal-confim large-info-modal modal fade",staticStyle:{"overflow":"hidden"},attrs:{"id":"login_Alert","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"margin-top":"0","width":"100%","height":"100%"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"left":"-1%","top":"-1%","width":"102%","height":"102%"}},[_c('div',{staticClass:"modal-body"},[_c('LoginAler')],1)])])]),_vm._v(" "),_vm._m(7)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-dl-download"},[_c('img',{attrs:{"src":"","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"show-dl-ldtxt show-dl-ldtxts"},[_c('span',[_c('a',{attrs:{"href":"/paike.html"}},[_vm._v("更多酷炫视频，尽在央视爱秀客户端！")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dl-ms-title"},[_c('i',{staticClass:"icon-message"}),_vm._v("留言\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dl-ms-edit"},[_c('i',{staticClass:"icon-edit"}),_vm._v("我有话说\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-like"},[_c('em',[_vm._v("+1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-messagebox"},[_c('div',{staticClass:"detail-messbox-inner"},[_c('h5',[_vm._v("我有话说")]),_vm._v(" "),_c('div',{staticClass:"dl-ms-btn"}),_vm._v(" "),_c('div',{staticClass:"dl-ms-wrap"},[_c('div',{staticClass:"dl-ms-inner"},[_c('textarea',{attrs:{"id":"saytext","rows":"6","placeholder":"最多可输入120字","maxlength":"120"}}),_vm._v(" "),_c('i',{staticClass:"icon-smile emotion"})])]),_vm._v(" "),_c('a',{staticClass:"btn-detail-edit",attrs:{"href":"javascript:void(0);"}},[_vm._v("\n            完  成\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"samll-info-modal modal fade",attrs:{"id":"chatModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('i',{staticClass:"icon-modal"}),_vm._v(" "),_c('p',{staticClass:"info-mess"},[_vm._v("留言发布成功啦！")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"samll-info-modal modal fade",attrs:{"id":"msg_Alert","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('p',{staticClass:"info-mess"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TXEu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TbAZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tn1W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TpSe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['detailsTxte'],
  data: function data() {
    return {
      detailsTxte1: []
    };
  },

  methods: {
    //操作按钮事件
  },
  created: function created() {
    var that = this;
    var id = this.$route.params.id;
    // this.$http.get(API.GetActivitieById, {params: {id: id}})
    // .then(function (res) {
    // if (res.code == 0) {
    //  console.log('attention_info');
    //  console.log(that.detailsTxte);
    if (that.detailsTxte) {
      if (that.detailsTxte.attention_info) {
        //  console.log(that.detailsTxte);
        that.detailsTxte1 = JSON.parse(that.detailsTxte.attention_info).attention_info;
      }
      //  console.log(that.detailsTxte1);
      //  else {
      //   that.detailsTxte1 = []
      // }
      that.$nextTick(function () {
        var et = $('.et-notice-link').eq(0);
        et.addClass('notice-down').find('.icon-r').css({
          'transform': 'rotate(180deg)',
          '-webkit-transform': 'rotate(180deg)',
          'transition': 'all 0.5s'
        });
        et.parent().siblings().children('dt').next().slideUp();
        et.next().slideDown();
      });
    }
    //console.log(that.detailsTxte1)
    /*  } else {
        var et = $('.et-notice-link').eq(0);
        et.addClass('notice-down').find('.icon-r').css({
          'transform': 'rotate(180deg)',
          '-webkit-transform': 'rotate(180deg)',
          'transition': 'all 0.5s'
        });
        et.parent().siblings().children('dt').next().slideUp();
        et.next().slideDown();
        console.log('请求数据信息出错')
      }*/

    // });
  },
  mounted: function mounted() {
    //操作DOM
    // 须知展开收起
    $('.et-tabox').on('click', '.et-notice-link', function () {
      if ($(this).hasClass('notice-down')) {
        $(this).removeClass('notice-down').find('.icon-r').css({
          'transform': 'rotate(90deg)',
          '-webkit-transform': 'rotate(90deg)',
          'transition': 'all 0.5s'
        });
        $(this).next().slideUp();
      } else {
        $(this).addClass('notice-down').find('.icon-r').css({
          'transform': 'rotate(180deg)',
          '-webkit-transform': 'rotate(180deg)',
          'transition': 'all 0.5s'
        });
        $(this).parent().siblings().children('dt').removeClass('notice-down').find('.icon-r').css({
          'transform': 'rotate(90deg)',
          '-webkit-transform': 'rotate(90deg)',
          'transition': 'all 0.5s'
        });
        $(this).parent().siblings().children('dt').next().slideUp();
        $(this).next().slideDown();
      }
    });
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "U24H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            globalUrl: API.GlobalUrl
        };
    },

    methods: {
        //操作按钮事件
    },

    mounted: function mounted() {
        //操作DOM
    }

});

/***/ }),

/***/ "UR6u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uac2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload uploadFile",attrs:{"is_require":this.UpFile.is_require,"name":this.UpFile.name}},[_c('div',{staticClass:"load-bl"},[_c('h5',{staticClass:"tit"},[_vm._v("\n      "+_vm._s(this.UpFile.title)+"\n      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.UpFile.is_require == 1),expression:"this.UpFile.is_require == 1"}],staticStyle:{"color":"#cf5454","margin-left":"5px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"uploa-bg"},[_c('div',{staticClass:"load-inner"},[_vm._l((_vm.MyUploadVideo),function(item,ind){return (_vm.MyUploadVideo.length>0)?_c('div',{staticClass:"load-link load-over",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"pic-b pic-v"},[_c('img',{attrs:{"src":item.file.thumb_url,"alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"padding-left":"10px"},attrs:{"attr-uuid":item.file_id,"attr-type":"3"}},[_vm._v(_vm._s('文档'+(ind+1)))])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.fileName3),function(item,ind){return _c('div',{staticClass:"load-link load-over videoFile2",staticStyle:{"margin-bottom":"15px"}},[_c('span',{staticClass:"pic-del",on:{"click":function($event){_vm.updateFile(ind)}}},[_vm._v("×")]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('p',{staticClass:"fileName fileName3",staticStyle:{"padding-left":"10px"},attrs:{"attr-uuid":_vm.arrayUuid3[ind],"attr-type":"3"}},[_vm._v(_vm._s(_vm.arrayName3[ind]))])])}),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),(this.UpFile.tip)?_c('p',{ref:"p_info",staticClass:"et-load-info et-file-info",class:_vm.classObj,on:{"click":_vm.allTetx3}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n        "+_vm._s(_vm.upfileTip)+"\n      ")]):_c('p',{staticClass:"et-load-info et-file-info",on:{"click":_vm.allTetx3}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n        支持所有格式\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.3)"},attrs:{"id":"uploadModal3","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"0"}},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('a',{staticClass:"btn-2 buttonW buttonR",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.cancel3}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start btn-pl-start3 buttonW buttonL",attrs:{"href":"javascript:void(0);"}},[_vm._v("开始上传")])])])])])])]),_vm._v(" "),_vm._m(4)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pic-b pic-v"},[_c('img',{attrs:{"src":"/images/audit_2.jpg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-link",attrs:{"id":"videoContainer3"}},[_c('div',{staticClass:"pic-b",attrs:{"id":"selectVideo3"}},[_c('input',{attrs:{"type":"file","id":"select3"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("名称"),_c('span',[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('input',{attrs:{"id":"TextFile","type":"text","placeholder":"请输入名称","maxlength":"20"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("描述"),_c('span',[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('textarea',{attrs:{"id":"TextareaFile","rows":"3","placeholder":"请输入描述信息,100字以内","maxlength":"100"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.4)"},attrs:{"id":"uploadFile_al","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"100px"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"detailAlert-p Prompt-p"},[_vm._v("上传格式错误")]),_vm._v(" "),_c('a',{staticClass:"buttonZ",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("确定")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UiOb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      router: '',
      imgUrl: ''
    };
  },


  methods: {
    //操作按钮事件
    ReturnTop: function ReturnTop() {
      //返回顶部
      $('html,body').stop().animate({ scrollTop: '0px' }, 500);
    }
  },
  created: function created() {
    var id = this.$route.params.id,
        that = this;
    this.$http.get(API.GetActivitieById, { params: { id: id } }).then(function (res) {
      //console.log(res.data.playbill.playbill)
      if (res.code == 0) {
        that.router = res.data.playbill.playbill;
        that.$nextTick(function () {
          var banWimg = $('.dl-banner').width();
          var banHimg = Math.ceil($('.dl-banner').width() / 2 * 1);
          var intervaLock;
          $('.dl-banner img').css({ width: banWimg, height: banHimg, visibility: 'visible' });
        });
      }
    });
    //判断是否pc
    if (that.IsPC()) {
      window.location.href = API.IsPcName;
    }
  },
  mounted: function mounted() {
    //操作DOM
    //setTimeout(function(){
    //_vjTrack('')
    //},500)


  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "VBaF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"ay-content-list",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"10","infinite-scroll-throttle-delay":"1000"}},[_vm._l((_vm.conten),function(item){return (_vm.conten)?_c('div',{staticClass:"ay-link ay-cor"},[_c('div',{staticClass:"ay-close",attrs:{"attr-id":item.id}}),_vm._v(" "),_c('p',{staticClass:"ay-title-time"},[_vm._v(_vm._s(_vm._f("datetime")(item.create_time)))]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('router-link',{staticClass:"ay-info",staticStyle:{"float":"left","width":"69%"},attrs:{"tag":"div","to":{name:'Detail',params: {id: item.activity_mini.id}}}},[_c('div',{staticStyle:{"width":"44px","height":"44px","display":"inline-block","float":"left","border-radius":"50%"}},[(item.activity_mini && item.activity_mini.hostunit)?_c('img',{staticClass:"ay-info-pic",staticStyle:{"width":"44px","height":"44px","margin-top":"12px","border-radius":"50%","overflow":"hidden"},attrs:{"src":item.activity_mini.hostunit.host_avatar,"alt":""}}):_vm._e()]),_vm._v(" "),(item.activity_mini && item.activity_mini.hostunit)?_c('p',{staticStyle:{"float":"none","line-height":"44px"}},[_vm._v("\n          "+_vm._s(item.activity_mini.hostunit.channel_name)+"\n          "),_c('span',[_vm._v("@")]),_vm._v("您\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"video-img",staticStyle:{"float":"right","width":"30%","margin-top":"10px","position":"relative"}},[_c('a',{staticClass:"ay-info",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.water(item)}}},[(item.file && item.file_type == 'video')?_c('img',{staticStyle:{"height":"100%"},attrs:{"src":item.file.thumb_url,"alt":""}}):_vm._e(),_vm._v(" "),(item.file && item.file_type == 'image')?_c('img',{staticStyle:{"height":"100%"},attrs:{"src":item.file.image_url,"alt":""}}):_vm._e(),_vm._v(" "),(item.msg_type == 1)?_c('img',{staticStyle:{"height":"100%"},attrs:{"src":item.image_url,"alt":""}}):_vm._e()]),_vm._v(" "),(item.file && item.file.time_span)?_c('i',{staticClass:"ay-pic-t",staticStyle:{"position":"absolute","right":"2px","bottom":"2px","font-size":"12px","font-style":"normal","background":"rgba(100, 100, 100, .5)","color":"#fff","padding":"0 2px","border-radius":"4px"}},[_vm._v(_vm._s(_vm._f("formatSeconds")(item.file.time_span)))]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"ay-info-text",staticStyle:{"margin":"5px"}},[_vm._v("\n      "+_vm._s(item.content.msg)+"\n    ")])]):_vm._e()}),_vm._v(" "),(_vm.conten.length==0)?_c('div',{staticClass:"foll_div"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.busy),expression:"!busy"}],staticClass:"content index-content",staticStyle:{"padding-top":"5px"}},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"editModals","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_c('h3',{staticClass:"Prompt-p",attrs:{"id":"file-h3"}},[_vm._v("你确定要删除此条信息？  ")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.DelFile}},[_vm._v("完成")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("取消")])])])])])])])]),_vm._v(" "),_c('Scan',{attrs:{"show":_vm.scan.show,"url":_vm.scan.url},on:{"update:show":function($event){_vm.$set(_vm.scan, "show", $event)}}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content index-content"},[_c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VTEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-file preview-files"},[_c('div',[_c('div',{staticClass:"file-title clearfix"},[_c('div',{staticClass:"title-left"},[_c('a',{staticClass:"icon-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.fn}}),_vm._v(" "),_c('i',{staticClass:"link-Whether",on:{"click":_vm.like}})]),_vm._v(" "),_c('div',{staticClass:"title-right"},[(_vm.item)?_c('span',[(_vm.item.user)?_c('img',{attrs:{"src":_vm.item.user.face_url,"alt":""}}):_vm._e(),_vm._v("\n        "+_vm._s(_vm._f("ellipsis")(_vm.item.nickname,8))+"\n       ")]):_vm._e()])]),_vm._v(" "),(_vm.item)?_c('div',{staticClass:"preview-conten preview-contenNext show-box",attrs:{"id":"videoName"}},[(_vm.item.image_url)?_c('div',{staticStyle:{"width":"100%","height":"auto"},attrs:{"id":"myImg"}},[_c('img',{attrs:{"src":_vm.item.image_url,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.item.time_span)?_c('div',{staticClass:"video_left",attrs:{"id":"myFlash"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-text show-v-box"},[_c('p',{staticClass:"file-browse"},[_c('span',[_vm._v(_vm._s(_vm.visitNum)+" 浏览")]),_vm._v(" "),_c('span',{staticClass:"gap-line"},[_vm._v(" | ")]),_vm._v(" "),(_vm.item.upload_time)?_c('i',[_vm._v(_vm._s(_vm._f("datetime")(_vm.item.upload_time))+" 上传")]):_c('i',[_vm._v(_vm._s(_vm._f("datetime")(_vm.item.upload_datetime))+" 上传")]),_vm._v(" "),_c('span',{staticClass:"btn-copy toCopy",on:{"click":_vm.copyUrl}},[_vm._v("复制地址")])]),_vm._v(" "),_c('h4',{staticClass:"file-tle"},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('p',{staticClass:"preview-p"},[_c('span',{staticClass:"preview-span"},[_vm._v(_vm._s(_vm.item.description))])]),_vm._v(" "),_c('p',{staticClass:"show-v-more",on:{"click":_vm.showVmore}},[_c('i',{staticClass:"icon-vs-show"})]),_vm._v(" "),_c('div',{staticClass:"file-div"},[(_vm.activeName)?_c('p',{staticClass:"icon-title"},[(_vm.activeName)?_c('router-link',{staticClass:"icon-title",attrs:{"to":'/detail/' + _vm.activeId,"tag":"p"}},[_vm._v("     参与了【"+_vm._s(_vm.activeName)+"】\n            ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"icon-ps"},[_c('i',{staticClass:"file-like"}),_c('span',{staticClass:"number numberName"},[_vm._v(_vm._s(_vm.favoriteNum))]),_vm._v(" 人喜欢")])])])]):_c('div',{staticClass:"yaVideo"},[_vm._v("加载中...")]),_vm._v(" "),_c('div',{staticClass:"content detail-content",staticStyle:{"margin-bottom":"60px"}},[_c('div',{staticClass:"dl-message",staticStyle:{"padding":"0 10px","background":"none"}},[_c('div',{staticClass:"dl-ms-link"},_vm._l((_vm.leavingName),function(item,ind){return (_vm.leavingName)?_c('div',{staticClass:"dl-ms",staticStyle:{"border-top":"1px solid #ccc","padding-top":"10px"}},[_c('div',{staticClass:"dl-ms-head"},[_c('div',{staticClass:"dl-head-pic"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"dl-head-name"},[_vm._v("\n                "+_vm._s(item.author)),_c('span',[_vm._v("["+_vm._s(item.locale)+"]")])]),_vm._v(" "),_c('div',{staticClass:"dl-head-like"},[_vm._m(0,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.agree))])])]),_vm._v(" "),_c('div',{staticClass:"dl-ms-chat"},[_c('div',{staticClass:"dl-ms-tit"},[_vm._v("\n                "+_vm._s(item.message)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"dl-time"},[_vm._v(_vm._s(_vm._f("timeToMillion")(new Date().getTime()/1000 - item.dateline)))])]):_vm._e()}))])])]),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"detailAlert","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"detailAlert-p",staticStyle:{"text-align":"center","padding-top":"30px","height":"80px","font-size":"18px"}},[_vm._v("\n            请先登录账号 ")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"buttonW buttonL",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.determine}},[_vm._v("确定")]),_vm._v(" "),_c('a',{staticClass:"buttonW buttonR",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("取消")])])])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"heart-shaped"},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/zhan.png',"alt":""}})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-confim large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"login_Alert","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"margin-top":"0","width":"100%","height":"100%"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"left":"-1%","top":"-1%","width":"102%","height":"102%"}},[_c('div',{staticClass:"modal-body"},[_c('LoginAler')],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-like"},[_c('em',[_vm._v("+1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"discoverAlert","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"detailAlert-p",staticStyle:{"text-align":"center","padding-top":"30px","height":"80px","font-size":"18px"}},[_vm._v("\n            该文件无法点赞")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"buttonZ",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("确定")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"samll-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"chatModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('i',{staticClass:"icon-modal"}),_vm._v(" "),_c('p',{staticClass:"info-mess",staticStyle:{"z-index":"999"}},[_vm._v("留言发布成功啦！")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-messagebox",staticStyle:{"position":"fixed"}},[_c('div',{staticClass:"detail-messbox-inner"},[_c('h5',[_vm._v("我有话说")]),_vm._v(" "),_c('div',{staticClass:"dl-ms-btn"}),_vm._v(" "),_c('div',{staticClass:"dl-ms-wrap"},[_c('div',{staticClass:"dl-ms-inner"},[_c('textarea',{attrs:{"id":"saytext","rows":"6","placeholder":"最多可输入120字","maxlength":"120"}})])]),_vm._v(" "),_c('a',{staticClass:"btn-detail-edit",attrs:{"href":"javascript:void(0);"}},[_vm._v("\n        完  成\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WVzJ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2017 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

/*!
 * Generated using the Bootstrap Customizer (http://v3.bootcss.com/customize/?id=096b5700835085d1e7390b26db9349c5)
 * Config saved to config.json and https://gist.github.com/096b5700835085d1e7390b26db9349c5
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(t){"use strict";var e=t.fn.jquery.split(" ")[0].split(".");if(e[0]<2&&e[1]<9||1==e[0]&&9==e[1]&&e[2]<1||e[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(t){"use strict";function e(e,o){return this.each(function(){var s=t(this),n=s.data("bs.modal"),r=t.extend({},i.DEFAULTS,s.data(),"object"==typeof e&&e);n||s.data("bs.modal",n=new i(this,r)),"string"==typeof e?n[e](o):r.show&&n.show(o)})}var i=function(e,i){this.options=i,this.$body=t(document.body),this.$element=t(e),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,t.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};i.VERSION="3.3.7",i.TRANSITION_DURATION=300,i.BACKDROP_TRANSITION_DURATION=150,i.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},i.prototype.toggle=function(t){return this.isShown?this.hide():this.show(t)},i.prototype.show=function(e){var o=this,s=t.Event("show.bs.modal",{relatedTarget:e});this.$element.trigger(s),this.isShown||s.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',t.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){o.$element.one("mouseup.dismiss.bs.modal",function(e){t(e.target).is(o.$element)&&(o.ignoreBackdropClick=!0)})}),this.backdrop(function(){var s=t.support.transition&&o.$element.hasClass("fade");o.$element.parent().length||o.$element.appendTo(o.$body),o.$element.show().scrollTop(0),o.adjustDialog(),s&&o.$element[0].offsetWidth,o.$element.addClass("in"),o.enforceFocus();var n=t.Event("shown.bs.modal",{relatedTarget:e});s?o.$dialog.one("bsTransitionEnd",function(){o.$element.trigger("focus").trigger(n)}).emulateTransitionEnd(i.TRANSITION_DURATION):o.$element.trigger("focus").trigger(n)}))},i.prototype.hide=function(e){e&&e.preventDefault(),e=t.Event("hide.bs.modal"),this.$element.trigger(e),this.isShown&&!e.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),t(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),t.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",t.proxy(this.hideModal,this)).emulateTransitionEnd(i.TRANSITION_DURATION):this.hideModal())},i.prototype.enforceFocus=function(){t(document).off("focusin.bs.modal").on("focusin.bs.modal",t.proxy(function(t){document===t.target||this.$element[0]===t.target||this.$element.has(t.target).length||this.$element.trigger("focus")},this))},i.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",t.proxy(function(t){27==t.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},i.prototype.resize=function(){this.isShown?t(window).on("resize.bs.modal",t.proxy(this.handleUpdate,this)):t(window).off("resize.bs.modal")},i.prototype.hideModal=function(){var t=this;this.$element.hide(),this.backdrop(function(){t.$body.removeClass("modal-open"),t.resetAdjustments(),t.resetScrollbar(),t.$element.trigger("hidden.bs.modal")})},i.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},i.prototype.backdrop=function(e){var o=this,s=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var n=t.support.transition&&s;if(this.$backdrop=t(document.createElement("div")).addClass("modal-backdrop "+s).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",t.proxy(function(t){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(t.target===t.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),n&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!e)return;n?this.$backdrop.one("bsTransitionEnd",e).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION):e()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var r=function(){o.removeBackdrop(),e&&e()};t.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",r).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION):r()}else e&&e()},i.prototype.handleUpdate=function(){this.adjustDialog()},i.prototype.adjustDialog=function(){var t=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&t?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!t?this.scrollbarWidth:""})},i.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},i.prototype.checkScrollbar=function(){var t=window.innerWidth;if(!t){var e=document.documentElement.getBoundingClientRect();t=e.right-Math.abs(e.left)}this.bodyIsOverflowing=document.body.clientWidth<t,this.scrollbarWidth=this.measureScrollbar()},i.prototype.setScrollbar=function(){var t=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",t+this.scrollbarWidth)},i.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},i.prototype.measureScrollbar=function(){var t=document.createElement("div");t.className="modal-scrollbar-measure",this.$body.append(t);var e=t.offsetWidth-t.clientWidth;return this.$body[0].removeChild(t),e};var o=t.fn.modal;t.fn.modal=e,t.fn.modal.Constructor=i,t.fn.modal.noConflict=function(){return t.fn.modal=o,this},t(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(i){var o=t(this),s=o.attr("href"),n=t(o.attr("data-target")||s&&s.replace(/.*(?=#[^\s]+$)/,"")),r=n.data("bs.modal")?"toggle":t.extend({remote:!/#/.test(s)&&s},n.data(),o.data());o.is("a")&&i.preventDefault(),n.one("show.bs.modal",function(t){t.isDefaultPrevented()||n.one("hidden.bs.modal",function(){o.is(":visible")&&o.trigger("focus")})}),e.call(n,r,this)})}(jQuery),+function(t){"use strict";function e(){var t=document.createElement("bootstrap"),e={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var i in e)if(void 0!==t.style[i])return{end:e[i]};return!1}t.fn.emulateTransitionEnd=function(e){var i=!1,o=this;t(this).one("bsTransitionEnd",function(){i=!0});var s=function(){i||t(o).trigger(t.support.transition.end)};return setTimeout(s,e),this},t(function(){t.support.transition=e(),t.support.transition&&(t.event.special.bsTransitionEnd={bindType:t.support.transition.end,delegateType:t.support.transition.end,handle:function(e){return t(e.target).is(this)?e.handleObj.handler.apply(this,arguments):void 0}})})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "WrP+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "X4Q9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__("U24H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d67ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__("0miA");
function injectStyle (ssrContext) {
  __webpack_require__("UR6u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d67ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XtEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_activity_vue__ = __webpack_require__("YrdL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lenNew: 0,
      num: false,
      scrill: false,
      busy: false,
      channel: '',
      nav_on: 0,
      searchText: '',
      len: 10,
      // find: {
      //   page: 1,
      //   pagesize: 10,
      //   type: 'indexhotactivity'
      // },
      find: {
        page: 1,
        pagesize: 10,
        progress: 'on'
      },

      total: 0,
      Page: 1, //页码
      pagesize: 10, //每页的歌个数
      searchName: [],
      findSearch: null,
      initUtil: {
        bodyEl: document.body,
        topNum: 0,
        stopBodyScroll: function stopBodyScroll(isFixed) {
          var _this = this;
          if (isFixed) {
            _this.topNum = window.scrollY;
            _this.bodyEl.style.position = 'fixed';
            _this.bodyEl.style.overflow = 'hidden';
            _this.bodyEl.style.top = -_this.topNum + 'px';
          } else {
            _this.bodyEl.style.position = '';
            _this.bodyEl.style.top = '';
            _this.bodyEl.style.overflow = '';
            window.scrollTo(0, _this.topNum); // 回到原先的top;
          }
        }
      },
      cancels: false,
      pageNmae: 1
    };
  },

  components: { //渲染页面
    activity: __WEBPACK_IMPORTED_MODULE_0__template_activity_vue__["a" /* default */]
  },
  methods: {
    //操作按钮事件
    route: function route(id) {
      var url = '';
      var hrefHTML = this.hrefHTML(0, id);
      if (hrefHTML) {
        window.location.href = hrefHTML;
      } else {
        window.location.href = API.UrlName + 'detail/' + id;
      }
    },

    //返回顶部
    fn: function fn() {
      $('html,body').stop().animate({ scrollTop: '0px' }, 500);
    },

    //取消
    cancel: function cancel() {
      $('.cancel').parents('.fd-sh-wrap').hide();
      this.initUtil.stopBodyScroll(false);
    },

    //tab切换
    Table: function Table(ind) {
      //console.log(ind)
      var that = this;
      that.nav_on = 2;
      that.initUtil.stopBodyScroll(false);
      that.len = 10;
      that.Page = 1;
      that.num = false;
      that.lenNew = 0;
      ind = 2;
      if (ind == 0) {
        that.busy = true;
      } else {
        that.busy = false;
      }

      if (ind == 0) {
        //推荐
        that.Page = 1;
        that.find = {
          type: 'indexhotactivity',
          page: that.Page,
          pagesize: that.pagesize
        };
      } else if (ind == 1) {
        //频道活动
        that.find = {
          channel_id: $('.icon-red').attr('data-id'),
          page: that.Page,
          pagesize: that.pagesize
        };
        if (!$('.id-nav-list').hasClass('show-none')) {
          // 导航展开收起效果
          $('.id-nav-list').addClass('nav-on show-none').siblings().removeClass('nav-on');
          $('.overplay').hide();
          $('.nav-list').slideUp(500);
        } else {
          $('.id-nav-list').removeClass('show-none');
          $('.overplay').show();
          $('.nav-list').slideDown(500);
        }
      } else if (ind == 2) {
        //进行中
        that.find = {
          progress: 'on',
          page: 1,
          pagesize: that.pagesize
        };
      } else if (ind == 3) {
        //已结束
        that.find = {
          progress: 'off',
          page: 1,
          pagesize: that.pagesize
        };
      }
      setTimeout(function () {
        that.num = true;
      }, 500);
    },
    channelClick: function channelClick(ind) {
      var that = this;
      var navList = $('.channel').eq(ind).attr('data-name');
      $('.id-nav-list').html(navList.slice(0, 4));
      $('.id-nav-list').addClass('show-none');
      $('.overplay').hide();
      $('.nav-list').slideUp(500);
      $('.channel').eq(ind).addClass('icon-red').parent().siblings().children().removeClass('icon-red');
      that.Page = 1;
      that.find = {
        channel_id: $('.icon-red').attr('data-id'),
        page: that.Page,
        pagesize: that.pagesize
      };
    },
    search: function search() {
      //搜索
      that = this;
      that.len = 10;
      var that = this;
      that.findSearch = {
        title: that.searchText,
        page: that.Page,
        pagesize: that.pagesize,
        version: 2
      };
      that.searchName = [];
      // console.log(find);
    },
    myupfun: function myupfun() {
      that = this;
      if ($('.fd-input-input').val()) {
        that.cancels = true;
      } else {
        that.cancels = false;
      }
      that.Page = 1;
      that.len = 10;
      var that = this;
      that.findSearch = {
        title: that.searchText,
        page: that.Page,
        pagesize: that.pagesize,
        version: 2
      };
      that.pageNmae = 1;
      that.searchName = [];
    },

    //显示搜索
    searchShow: function searchShow() {
      this.scrill = false;
      this.pageNmae = 1;
      $('.fd-input-input').val('');
      $('.fd-sh-wrap').show();
      this.initUtil.stopBodyScroll(true);
    },

    //加载更更多
    loadMore: function loadMore() {
      var that = this;
      //  if (that.num) {
      var page = ++that.Page;
      that.find.progress = 'on';
      if (that.find.type == 'indexhotactivity') {
        //热门
        that.find = {
          type: 'indexhotactivity',
          page: page,
          pagesize: that.pagesize
        };
      } else if (that.find.channel_id != undefined) {
        //频道列表
        that.find = {
          channel_id: $('.icon-red').attr('data-id'),
          page: page,
          pagesize: that.pagesize
        };
      } else if (that.find.progress == 'on') {
        //进行中
        that.find = {
          progress: 'on',
          page: page,
          pagesize: that.pagesize
        };
      } else if (that.find.progress == 'off') {
        //已结束
        that.find = {
          progress: 'off',
          page: page,
          pagesize: that.pagesize
        };
      } else {
        //搜索
        that.findSearch = {
          title: that.searchText,
          page: page,
          pagesize: that.pagesize,
          version: 2
        };
      }
      // }
      var len = $('.fd-content').find('li').length;
      if (that.lenNew > len) {
        that.busy = true;
      }
      that.lenNew = that.lenNew / 1 + 10;
      //  ++that.Page
    },
    contentMore: function contentMore() {
      this.pageNmae = ++this.pageNmae;
      this.findSearch = {
        title: this.searchText,
        page: this.pageNmae,
        pagesize: this.pagesize,
        version: 2
      };
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = false;
    next();
  },

  created: function created() {
    var that = this;
    //央视频道
    // this.$http.get(API.GetChannelList)
    //   .then(function (res) {
    //     if (res.code == 0) {
    //       that.channel = res.data;
    //       //console.log(res.data)
    //     }
    //   });
    that.Page = 1;
    // that.find = {
    //   type: 'indexhotactivity',
    //   page: 1,
    //   pagesize: that.pagesize
    // };
    that.find = {
      progress: 'on',
      page: 1,
      pagesize: that.pagesize
    };
    //  this.Table(2);
    // setTimeout(function () {
    //   that.num = true;
    // }, 500)
    // Table(2)
    //搜索选项
    // that.$watch('findSearch', function () {
    //   this.$http.get(API.GetActivities, {params: that.findSearch})
    //     .then(function (res) {
    //       if (res.code == 0) {
    //         for (var i = 0; i < res.data.length; i++) {
    //           that.searchName.push(res.data[i])
    //         }
    //         that.total = res.total
    //         if (that.searchName.length == res.total) {
    //           that.scrill = false
    //         } else {
    //           that.scrill = true
    //         }
    //         //console.log(res.data)
    //         that.$nextTick(function () {
    //           if (res.total > 0) {
    //             let metas = $('head').children('meta');
    //             var img = '';
    //             console.log(that.searchName[0])
    //             if (that.searchName && that.searchName[0].playbill && that.searchName[0].playbill.playbill_h5) {
    //               img = that.searchName[0].playbill.playbill_h5
    //             }
    //             var dataName = {
    //               title: document.title,  //分享标题
    //               desc: that.removeTAG(metas[1].content, 110),//分享简介(内容)
    //               imgAddress: img,//分享图片地址
    //               Retain: '',//保留
    //               url: API.UrlName + 'find' //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
    //             };
    //             that.weixinShare(dataName)
    //           }
    //           //图片尺寸控制 16:9
    //           var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
    //           $('.pic-box').find('img').css({height: picHimg, visibility: 'visible'});
    //         }, 500)
    //       }
    //     });
    // })
  },

  mounted: function mounted() {
    //操作DOM
    // var that = this;
    // var scrill = false;
    //  setTimeout(function(){
    // _vjTrack('')
    //},500)
    // $(window).scroll(function () {
    //   if ($(window).scrollTop() > 1000) {
    //     $('.back-top').show();
    //   } else {
    //     $('.back-top').hide();
    //   }
    // });

    // $(function () {
    //   // this.find = {
    //   //   type: 'indexhotactivity',
    //   //   page: 1,
    //   //   pagesize: that.pagesize
    //   // };

    //     // that.find = {
    //     //     progress: 'on',
    //     //     page: 1,
    //     //     pagesize: that.pagesize
    //     //   };
    //   setTimeout(function () {
    //     //图片比例
    //     that.PictureRatio();
    //     // that.num = true;
    //   }, 500)
    // })

  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Y5PF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YRgJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mobilePhone: '', // 手机号
      telYzm: '', // 验证码
      Time: 11,
      falseHints: false,
      falseHintsHtml: '',
      yzmMess: false,
      clicked: true,
      // thirdParty: true,
      num: 180,
      telYzmMess: false,
      telYzmMessHtml: ''
    };
  },

  methods: {
    fn: function fn() {
      $('#login_Alert').modal('hide');
      $('#myFlash').show();
    },
    table: function table() {
      $('.quick-alert').hide();
      $('.signIn-alert').show();
    },
    signIn: function signIn() {
      $('.quick-alert').hide();
      $('.signIn-alert').hide();
      //$('#login_Alert').modal('hide');
      //this.$router.push({name: 'login_SignIn'})
    },
    puts: function puts() {
      var that = this;
      if (that.num != 180) {
        return false;
      }
      that.num = 180;
      if (!that.mobilePhone) {
        that.falseHints = true;
        that.falseHintsHtml = '请输入手机号';
        return false;
      }
      // 验证手机号是否为空
      if (that.mobilePhone.match(/^1[3|5|7|8|9|][0-9]{9}$/) !== null) {
        that.falseHints = false;
      } else {
        that.falseHints = true;
        that.falseHintsHtml = '手机号格式不正确';
        return false;
      }
      var data = {
        method: 'getRequestVerifiCodeM',
        mobile: that.mobilePhone,
        verfiCodeType: '1',
        verificationCode: '4',
        isCheckCode: '1'
      };
      $.ajax({
        url: 'https://reg.cctv.com/mobile/regist/getVerifiCode.action',
        data: data,
        dataType: 'jsonp',
        success: function success(mes) {
          console.log(mes);
          if (mes.errtype == 'success' || mes.errmsg == '成功') {
            var set = setInterval(function () {
              that.num = that.num - 1;
              $('.btn-yzm').html(that.num + '秒');
              if (that.num <= 0) {
                $('.btn-yzm').html('发送验证码');
                clearInterval(set);
                that.num = 180;
              }
            }, 1000);
          } else if (mes.errtype == 'sendagain') {
            that.falseHints = true;
            that.falseHintsHtml = '验证过于频繁,请稍后重试';
          }

          if (mes.errtype == 'mobilecodeerror') {
            that.falseHints = true;
            that.falseHintsHtml = '验证过于频繁,请稍后重试';
          }
          if (mes.errtype == 'ipsendagain') {
            that.falseHints = true;
            that.falseHintsHtml = '验证过于频繁,请稍后重试';
          }
          if (mes.errtype == 'mobileoften') {
            that.falseHints = true;
            that.falseHintsHtml = '验证过于频繁,请稍后重试';
          }
          if (mes.errtype == 'registered') {
            $('#phone-mess').show();
            $('#phone-mess').html(mes.errmsg);
          }
        }
      });
    },
    login: function login() {
      var that = this;
      that.falseHints = false;
      that.yzmMess = false;
      that.telYzmMess = false;
      if (!that.mobilePhone) {
        that.falseHints = true;
        that.falseHintsHtml = '请输入手机号';
        return false;
      }
      // 验证手机号是否为空
      if (that.mobilePhone.match(/^1[3|5|7|8|9|][0-9]{9}$/) !== null) {
        // $('#MobilePhone-mess').hide();
        that.falseHints = false;
      } else {
        that.falseHints = true;
        that.falseHintsHtml = '手机号格式不正确';
        return false;
      }
      if (!that.telYzm) {
        that.telYzmMess = true;
        that.telYzmMessHtml = '请输入手机验证码';
        return false;
      }
      var url = encodeURI('https://ishow.xiyou.cctv.com/');
      $.ajax({
        url: 'https://reg.cctv.com/mobile/mobileRegAndLogin.action',
        data: {
          mobile: that.mobilePhone,
          verifyCode: that.telYzm,
          from: url,
          service: API.UrlName + '/home/index',
          checkCode: '1'
        },
        dataType: 'jsonp',
        success: function success(mes) {
          console.log(mes);
          if (mes.errType == '0' || mes.errMsg == '"成功"') {
            $('#login_Alert').modal('hide');
            $('#chatModal .info-mess').html('登录成功');
            $('#chatModal').modal('show');
            setTimeout(function () {
              $('#chatModal').modal('hide');
              var thisPathRoute = that.$route.path.split('/')[1];
              if (thisPathRoute === 'detail') {
                that.$http.get(API.IsJoin, { params: { activity_id: that.$route.params.id } }).then(function (res) {
                  if (res.code == 0) {
                    if (res.data.isJoin == 0) {
                      that.$router.push({ name: 'Notice', params: { id: that.$route.params.id } });
                    } else {
                      // that.$router.push({name: 'myActivity_MyParticipate', params: {id: that.$route.params.id}});
                      that.$router.push({ name: 'Revise', params: { id: that.$route.params.id, form_id: 0 } });
                      return false;
                    }
                  }
                });
              } else {
                window.location.reload();
              }
            }, 1500);
          }
          if (mes.errType != '0') {
            alert(mes.errMsg);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    // 判断是否是小程序
    // var that = this;
    // function ready() {
    //   if(window.__wxjs_environment === 'miniprogram'){
    //     that.thirdParty = false;
    //   }
    // }
    // if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
    //   document.addEventListener('WeixinJSBridgeReady', ready, false)
    // } else {
    //   ready()
    // }
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__("wUZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_index__ = __webpack_require__("H6Vf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_active__ = __webpack_require__("OO0n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_detail__ = __webpack_require__("lFou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_entryform__ = __webpack_require__("49Y+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_entryform_notice__ = __webpack_require__("o1H1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_entryform_signUp__ = __webpack_require__("R6WS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_myActivity_MyParticipate_message_vue__ = __webpack_require__("jcL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_video__ = __webpack_require__("kzMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_videoName__ = __webpack_require__("aYi9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_login__ = __webpack_require__("K31e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_login_signIn__ = __webpack_require__("Rtkl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_login_quick__ = __webpack_require__("ANZw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_login_register__ = __webpack_require__("5zCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_login_repassword__ = __webpack_require__("b6Ap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_myMessage__ = __webpack_require__("cCBF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_myActivity__ = __webpack_require__("0RFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_myActivity_participate__ = __webpack_require__("S6Kv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_myActivity_follow__ = __webpack_require__("cshL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_myActivity_upload__ = __webpack_require__("nYIW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_myActivity_notice__ = __webpack_require__("I1sH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_discovery__ = __webpack_require__("B7vk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_find__ = __webpack_require__("pTbw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_list__ = __webpack_require__("pjeT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_list_videoList__ = __webpack_require__("2YR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_list_voteList__ = __webpack_require__("ggkq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_list_preview__ = __webpack_require__("4Pb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_list_imgList__ = __webpack_require__("hdzJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_template_notFound_vue__ = __webpack_require__("OVcu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__util_js__ = __webpack_require__("yEpX");


/*import Resource from 'vue-resource'*/

 //首页
 //index


 //详情页面

 //爱秀报名表
 //表单渲染
 //报名须知
 //修改报名表

 //爱秀视频播放-分享

 //爱秀视频播放

 //登录页面
 //登录
 //快捷登录
 //注册
 //找回密码


 //登录后
 //登录后的活动





 //全部文件页面

 //活动页面

 //列表
 //视频列表
 //投票
 //投票信息
 //图片

 //活动下线


 //是否pc端打开
var isPc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__util_js__["a" /* IsPC */])();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/*Vue.use(Resource);*/

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  mode: 'history',
  base: '/h5/',
  // scrollBehavior (to, from, savedPosition) {
  //   if(savedPosition){
  //     $('html,body').stop().animate({scrollTop: savedPosition.y + 'px'}, 200);
  //     $('.content-inner-box').stop().animate({scrollTop: savedPosition.y + 'px'}, 200);
  //   }
  // },
  routes: [{
    path: '/',
    redirect: "/home",
    name: 'home',
    meta: {
      keepAlive: false,
      title: '央视喊你上电视',
      keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
    }
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home__["a" /* default */],
    meta: {
      keepAlive: false,
      title: '央视喊你上电视',
      keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/index.html';
      }
      next();
    },
    // redirect:'/index',
    children: [{ path: '', redirect: '/index' }, {
      path: "/index",
      name: "HomeIndex",
      meta: {
        keepAlive: false,
        title: '央视喊你上电视',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      component: __WEBPACK_IMPORTED_MODULE_3__components_home_index__["a" /* default */] //resolve => require(["@/components/home/index"],resolve) //首页推荐
    }, {
      path: "/channel/:id",
      name: "HomeChannel",
      meta: {
        keepAlive: true,
        title: '央视喊你上电视',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        if (isPc) {
          location.href = '/discovery.html?channel=' + to.params.id;
        }
        next();
      },
      component: __WEBPACK_IMPORTED_MODULE_4__components_home_active__["a" /* default */] //resolve => require(["@/components/home/active"],resolve) //首页活动
    }]
  }, {
    path: '/detail/:id',
    name: 'Detail',
    component: __WEBPACK_IMPORTED_MODULE_5__components_detail__["a" /* default */],
    meta: {
      keepAlive: true,
      title: '',
      keywords: ''
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/detail.html?ad=' + to.params.id;
      }
      next();
    }
  }, {
    path: '/discovery',
    name: 'Discovery',
    component: __WEBPACK_IMPORTED_MODULE_23__components_discovery__["a" /* default */],
    meta: {
      keepAlive: true,
      title: '优秀作品展播'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/morevideo.html';
      }
      next();
    }
  }, {
    path: '/find',
    name: 'Find',
    component: __WEBPACK_IMPORTED_MODULE_24__components_find__["a" /* default */],
    meta: {
      keepAlive: false,
      title: '全部征集活动',
      keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/discovery.html';
      }
      next();
    }
  }, {
    path: '/entryform',
    name: 'Entryform',
    component: __WEBPACK_IMPORTED_MODULE_6__components_entryform__["a" /* default */],
    children: [{ path: '', redirect: '/notice' }, {
      path: '/notice/:id',
      name: 'Notice',
      meta: {
        keepAlive: false,
        title: '参与活动'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        if (isPc) {
          location.href = '/signUp.html?ad=' + to.params.id;
        }
        next();
      },
      component: __WEBPACK_IMPORTED_MODULE_7__components_entryform_notice__["a" /* default */] //resolve => require(['@/components/entryform/notice'],resolve),//爱秀报名表单
    }, {
      path: '/signUp/:id/:init',
      name: 'SignUp',
      meta: {
        keepAlive: false,
        title: '参与活动'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        console.log(to);
        if (isPc) {
          location.href = '/detail.html?ad=' + to.params.id;
        }
        next();
      },
      component: __WEBPACK_IMPORTED_MODULE_8__components_entryform_signUp__["a" /* default */] //resolve => require(['@/components/entryform/signUp'],resolve),//爱秀报名须知
    }, {
      path: '/revise/:id/:form_id',
      name: 'Revise',
      meta: {
        keepAlive: false,
        title: '参与活动'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        console.log(to);
        if (isPc) {
          location.href = '/revise.html?ad=' + to.params.id + '&form=' + to.params.form_id;
        }
        next();
      },
      component: __WEBPACK_IMPORTED_MODULE_9__components_myActivity_MyParticipate_message_vue__["a" /* default */] //报名信息修改
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_12__components_login__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/index.html';
      }
      next();
    },
    meta: {
      keepAlive: false,
      title: '登录',
      keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
    },
    children: [{ path: '', redirect: '/signIn' }, {
      path: '/signIn',
      name: 'login_SignIn',
      meta: {
        keepAlive: false,
        title: '登录',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      component: __WEBPACK_IMPORTED_MODULE_13__components_login_signIn__["a" /* default */] //resolve => require(['@/components/login/signIn'],resolve) //登录
    }, {
      path: '/quick',
      name: 'login_Quick',
      meta: {
        keepAlive: false,
        title: '快捷登录',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      component: __WEBPACK_IMPORTED_MODULE_14__components_login_quick__["a" /* default */] //resolve => require(['@/components/login/quick'],resolve) //快捷登录
    }, {
      path: '/register',
      name: 'login_Register',
      meta: {
        keepAlive: false,
        title: '注册',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

      },
      component: __WEBPACK_IMPORTED_MODULE_15__components_login_register__["a" /* default */] //resolve => require(['@/components/login/register'],resolve) //注册
    }, {
      path: '/repassword',
      name: 'login_Repassword',
      meta: {
        keepAlive: false,
        title: '找回密码',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      component: __WEBPACK_IMPORTED_MODULE_16__components_login_repassword__["a" /* default */] //resolve => require(['@/components/login/repassword'],resolve) //找回密码
    }]
  },, {
    path: '/video/:id/:uuid',
    name: 'Video',
    component: __WEBPACK_IMPORTED_MODULE_10__components_video__["a" /* default */],
    meta: {
      keepAlive: false
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/video.html?d=' + to.params.uuid + '&&ad=' + to.params.id;
      }
      next();
    }
  }, {
    path: '/videoName/:id/:uuid/:type',
    name: 'VideoName',
    component: __WEBPACK_IMPORTED_MODULE_11__components_videoName__["a" /* default */],
    meta: {
      keepAlive: false
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/video.html?d=' + to.params.uuid + '&&ad=' + to.params.id;
      }
      next();
    }
  }, {
    path: '/mymessage',
    name: 'MyMessage',
    component: __WEBPACK_IMPORTED_MODULE_17__components_myMessage__["a" /* default */],
    meta: {
      keepAlive: false, // 需要被缓存
      title: '个人中心',
      keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/partake.html';
      }
      next();
    }
  }, {
    path: '/myActivity',
    name: 'myActivity',
    component: __WEBPACK_IMPORTED_MODULE_18__components_myActivity__["a" /* default */],
    meta: {
      keepAlive: false,
      title: '参与活动',
      keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/partake.html';
      }
      next();
    },
    children: [{ path: '/myActivity', redirect: '/myparticipate/:id' }, {
      path: '/myparticipate/:id',
      name: 'myActivity_MyParticipate',
      meta: {
        keepAlive: false,
        title: '我参与活动',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

      },
      component: __WEBPACK_IMPORTED_MODULE_19__components_myActivity_participate__["a" /* default */] //resolve => require(['@/components/myActivity/participate'],resolve) //参与
    }, {
      path: '/myfollow',
      name: 'myActivity_MyFollow',
      meta: {
        keepAlive: false,
        title: '我关注活动',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

      },
      component: __WEBPACK_IMPORTED_MODULE_20__components_myActivity_follow__["a" /* default */] //resolve => require(['@/components/myActivity/follow'],resolve) //关注
    }, {
      path: '/myupload',
      name: 'myActivity_MyUpload',
      meta: {
        keepAlive: false,
        title: '管理我的作品',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

      },
      component: __WEBPACK_IMPORTED_MODULE_21__components_myActivity_upload__["a" /* default */] //resolve => require(['@/components/myActivity/upload'],resolve) //上传
    }, {
      path: '/mynotice',
      name: 'myActivity_MyNotice',
      meta: {
        keepAlive: false,
        title: '官方提醒',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      component: __WEBPACK_IMPORTED_MODULE_22__components_myActivity_notice__["a" /* default */] //resolve => require(['@/components/myActivity/notice'],resolve) //我的
    }]
  }, {
    path: '/list',
    name: 'List',
    component: __WEBPACK_IMPORTED_MODULE_25__components_list__["a" /* default */],
    children: [{
      path: '/videoList/:id/:init',
      name: 'list_video',
      meta: {
        keepAlive: true,
        title: '视频作品',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        if (isPc) {
          location.href = '/videolists.html?ad=' + to.params.id;
        }
        next();
      },
      component: __WEBPACK_IMPORTED_MODULE_26__components_list_videoList__["a" /* default */] //resolve => require(['@/components/list/videoList'],resolve) //视频列表
    }, {
      path: '/vote/:id/:active',
      name: 'list_vote',
      meta: {
        keepAlive: true,
        title: '投票'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        if (isPc) {
          location.href = '/votelists.html?ad=' + to.params.id;
        }
        next();
      },
      component: __WEBPACK_IMPORTED_MODULE_27__components_list_voteList__["a" /* default */] //resolve => require(['@/components/list/voteList'],resolve) //投票
    }, {
      path: '/preview/:id/:uuid/:ind/:activityId',
      name: 'list_preview',
      meta: {
        keepAlive: false,
        title: '投票-信息'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        if (isPc) {
          location.href = '/video.html?d=' + to.params.uuid + '&&ad=' + to.params.id;
        }
        next();
      },
      component: __WEBPACK_IMPORTED_MODULE_28__components_list_preview__["a" /* default */] //resolve => require(['@/components/list/preview'],resolve) //投票
    }, {
      path: '/image/:id/:init',
      name: 'list_image',
      meta: {
        keepAlive: false,
        title: '图片作品',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        if (isPc) {
          location.href = '/picture.html?ad=' + to.params.id + '&k=' + to.params.init;
        }
        next();
      },
      component: __WEBPACK_IMPORTED_MODULE_29__components_list_imgList__["a" /* default */] //resolve => require(['@/components/list/imgList'],resolve) //图片
    }]

  }, {
    path: '/notFound',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_30__components_template_notFound_vue__["a" /* default */],
    meta: {
      title: '活动已下线'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (isPc) {
        location.href = '/index.html';
      }
      next();
    }
  }]
}));

/***/ }),

/***/ "YrdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_activity_vue__ = __webpack_require__("afht");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f6bb13d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_activity_vue__ = __webpack_require__("IpTy");
function injectStyle (ssrContext) {
  __webpack_require__("+FNL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_activity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f6bb13d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_activity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ys5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selmul uploa-bg",staticStyle:{"padding":"10px 0 10px 5%"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.prov),expression:"prov"}],staticStyle:{"height":"35px"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.prov=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onClickMe1]}},[_c('option',{attrs:{"value":""}},[_vm._v("请选择")]),_vm._v(" "),_vm._l((_vm.options),function(option,idx){return _c('option',{domProps:{"value":option.value}},[_vm._v("\n       "+_vm._s(option.value)+"\n     ")])})],2),_vm._v(" "),(_vm.idx >=0)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticStyle:{"height":"35px"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.city=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onClickMe2]}},[_c('option',{attrs:{"value":""}},[_vm._v("请选择")]),_vm._v(" "),_vm._l((_vm.options1),function(option){return _c('option',{domProps:{"value":option.value}},[_vm._v("\n       "+_vm._s(option.value)+"\n     ")])})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YvlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("THR+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1448b72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("zqrN");
function injectStyle (ssrContext) {
  __webpack_require__("8egW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1448b72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YzOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imgSan_vue__ = __webpack_require__("R4xh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e8f828_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imgSan_vue__ = __webpack_require__("Rkrw");
function injectStyle (ssrContext) {
  __webpack_require__("O/Mm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12e8f828"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imgSan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e8f828_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imgSan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZnQl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload uploadVideo",attrs:{"is_require":this.UpFile.is_require,"name":this.UpFile.name}},[_c('div',{staticClass:"load-bl"},[_c('h5',{staticClass:"tit"},[_vm._v("\n      "+_vm._s(this.UpFile.title)+"\n      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.UpFile.is_require == 1),expression:"this.UpFile.is_require == 1"}],staticStyle:{"color":"#cf5454","margin-left":"5px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"uploa-bg"},[_c('div',{staticClass:"load-inner"},[_vm._l((_vm.MyUploadVideo),function(item,ind){return (_vm.MyUploadVideo.length>0)?_c('div',{staticClass:"load-link load-over",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"pic-b pic-v"},[_c('img',{attrs:{"src":item.file.thumb_url,"alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"padding-left":"10px","max-height":"50px"},attrs:{"attr-uuid":item.file_id,"attr-type":"1"}},[_vm._v(_vm._s(item.file.title))])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.fileName),function(item,ind){return _c('div',{staticClass:"load-link load-over videoFile",staticStyle:{"margin-bottom":"15px"}},[_c('span',{staticClass:"pic-del",on:{"click":function($event){_vm.updateFile(ind)}}},[_vm._v("×")]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('p',{staticClass:"fileName",staticStyle:{"padding-left":"10px","max-height":"50px"},attrs:{"attr-uuid":_vm.arrayUuid[ind],"attr-type":"1"}},[_vm._v(_vm._s(_vm.arrayName[ind]))])])}),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),(this.UpFile.tip)?_c('p',{ref:"p_info",staticClass:"et-load-info et-video-info",class:_vm.classObj,on:{"click":_vm.allTetx}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n        "+_vm._s(_vm.upfileTip)+"\n      ")]):_c('p',{staticClass:"et-load-info et-video-info",on:{"click":_vm.allTetx}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n        支持MPG、MPEG、AVI、MP4、3GP、RM、RMVB、MOV、FLV、ASF格式，且文件大小不超过10gb。\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.4)"},attrs:{"id":"uploadModal","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"top":"0"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('a',{staticClass:"btn-2 buttonW buttonR",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.cancel}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start btn-pl-start1 btn-1 buttonW buttonL",attrs:{"href":"javascript:void(0);"}},[_vm._v("开始上传")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"uploadFile","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"0"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body",attrs:{"id":"modal-body"}},[_c('ul',{staticClass:"uploadFile-ul clearfix",attrs:{"id":"uploadFile-ul"}},_vm._l((_vm.allchannel),function(item,v){return _c('li',[_c('dl',[_c('dt',{staticClass:"pic-box"},[_c('img',{staticStyle:{"border":"none"},attrs:{"src":item.video.thumb_url,"alt":""}})]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(item.video.title))])])])})),_vm._v(" "),(_vm.scrill)?_c('div',{staticClass:"content index-content",staticStyle:{"padding-top":"0"}},[_vm._m(5)]):_vm._e()])])])]),_vm._v(" "),_vm._m(6)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pic-b pic-v"},[_c('img',{attrs:{"src":"/images/audit_2.jpg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-link",attrs:{"id":"videoContainer"}},[_c('div',{staticClass:"pic-b",attrs:{"id":"selectVideo"}},[_c('input',{attrs:{"type":"file","accept":"video/*","id":"select"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("名称"),_c('span',[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('input',{attrs:{"id":"Textvideo","type":"text","placeholder":"请输入名称","maxlength":"20"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("描述")]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('textarea',{attrs:{"id":"Textareavideo","rows":"3","placeholder":"请输入描述信息,100字以内","maxlength":"100"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-head"},[_vm._v("\n          我的视频\n          "),_c('span',{attrs:{"data-dismiss":"modal"}},[_vm._v("X")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.4)"},attrs:{"id":"uploadVideo-al","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"detailAlert-p Prompt-p"},[_vm._v("上传格式错误")]),_vm._v(" "),_c('a',{staticClass:"buttonZ",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("确定")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a0WO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_Quick"},[_c('div',{},[_c('div',{staticClass:"header login-header"},[_c('a',{staticClass:"icon-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.fn}}),_vm._v("\n      手机快捷登录\n      ")]),_vm._v(" "),_c('div',{staticClass:"line-gray"}),_vm._v(" "),_c('div',{staticClass:"login-content"},[_c('form',{staticClass:"lg-tabbox"},[_c('div',{staticClass:"group-item"},[_c('label',{staticStyle:{"width":"4em"}},[_vm._v("+86")]),_vm._v(" "),_c('div',{staticClass:"input-box input-tel",staticStyle:{"padding-left":"5em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobilePhone),expression:"mobilePhone"}],staticClass:"MobilePhone",attrs:{"type":"tel","placeholder":"请输入手机号","id":"MobilePhone","maxlength":"11"},domProps:{"value":(_vm.mobilePhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobilePhone=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobilePhone != ''),expression:"mobilePhone != ''"}],staticClass:"btn-del",staticStyle:{"display":"none"},on:{"click":function($event){_vm.mobilePhone = ''}}})])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.falseHints),expression:"falseHints"}],staticClass:"text-danger",attrs:{"id":"MobilePhone-mess"}},[_vm._v(_vm._s(_vm.falseHintsHtml))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.telYzmMess),expression:"telYzmMess"}],staticClass:"text-danger",attrs:{"id":"tel-yzm-mess"}},[_vm._v(_vm._s(_vm.telYzmMessHtml))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.yzmMess),expression:"yzmMess"}],staticClass:"text-danger",attrs:{"id":"img-yzm-mess"}}),_vm._v(" "),_c('div',{staticClass:"group-item",staticStyle:{"position":"relative"}},[_c('label',{staticStyle:{"width":"4em"}},[_vm._v("验证码")]),_vm._v(" "),_c('div',{staticClass:"input-box input-yzm",staticStyle:{"padding-left":"5em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telYzm),expression:"telYzm"}],attrs:{"type":"text","placeholder":"请输入验证码","id":"tel_yzm"},domProps:{"value":(_vm.telYzm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telYzm=$event.target.value}}})]),_vm._v(" "),_c('a',{staticClass:"btn-yzm puts",staticStyle:{"right":"-5px"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.puts}},[_vm._v("发送验证码")])]),_vm._v(" "),_c('div',{staticClass:"group-info"},[_c('a',{staticClass:"font-lgr",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.login}},[_vm._v("登  录")])]),_vm._v(" "),_c('div',{staticClass:"group-mess"},[_c('router-link',{attrs:{"to":"/register","tag":"a"}},[_vm._v("\n            立即注册\n          ")]),_vm._v(" "),_c('a',{staticStyle:{"float":"right"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.table}},[_vm._v("\n            账户登录\n          ")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aC8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thirdparty"},[_c('div',{staticClass:"login-other"},[_c('p',{staticClass:"lg-tit"},[_vm._v("第三方登录")])]),_vm._v(" "),_c('div',{staticClass:"login-other"},[_c('a',{staticClass:"os OAuthQzoneClient",attrs:{"href":"https://oauth.passport.cntv.cn/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=https://act.ishow.cctv.com/h5/detail/100066"}},[_c('img',{attrs:{"src":__webpack_require__("sgvI")}})]),_vm._v(" "),_c('a',{staticClass:"os OAuthSinaClient",attrs:{"href":"https://oauth.passport.cntv.cn/OAuthSinaClient/OAuthSinaClientServlet.do?cntv_callback=https://act.ishow.cctv.com/h5/detail/100066"}},[_c('img',{attrs:{"src":__webpack_require__("WrP+")}})]),_vm._v(" "),_c('a',{staticClass:"os OauthAlipay",attrs:{"href":"https://reg.cctv.com/OauthAlipay/OauthAlipayServlet.action?method=login&cntv_callback=https://act.ishow.cctv.com/h5/detail/100066"}},[_c('img',{attrs:{"src":__webpack_require__("IGXn")}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aG0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-box"},[_c('div',{staticClass:"swiper-container show-poll-swiper show-id-swiper"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.tablesName),function(v,ind){return _c('div',{staticClass:"swiper-slide"},[_c('ul',{staticClass:"show-list"},_vm._l((_vm.twoNumbers),function(val,i){return _c('li',{staticClass:"broadcast",attrs:{"attr-item":JSON.stringify({url: _vm.tables[ind*2+i].url,id: _vm.tables[ind*2+i].id,img_path: _vm.tables[ind*2+i].img_path,type:  _vm.tables[ind*2+i].type}),"attr-type":"tablesName"}},[_c('a',{attrs:{"href":"javascript:void(0);"}},[(_vm.tables[ind*2+i].hostunit)?_c('div',{staticClass:"show-remd-logo"},[_c('img',{attrs:{"src":_vm.tables[ind*2+i].hostunit.host_avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.tables[ind*2+i].hostunit)?_c('div',{staticClass:"show-remd-tit"},[_vm._v("\n                "+_vm._s(_vm.tables[ind*2+i].hostunit.channel_name)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.tables[ind*2+i].playbill)?_c('div',{staticClass:"pic-box"},[_c('img',{attrs:{"src":(_vm.tables[ind*2+i].playbill.playbill_small || _vm.tables[ind*2+i].playbill.playbill)+'?p=3&o=2&w=350&h=197',"alt":""}})]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.tables[ind*2+i].title))])])])}))])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aYi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videoName_vue__ = __webpack_require__("yY+m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a731351c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videoName_vue__ = __webpack_require__("VTEG");
function injectStyle (ssrContext) {
  __webpack_require__("TbAZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videoName_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a731351c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videoName_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "afht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*import infiniteScroll from 'vue-infinite-scroll'*/
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['find'],
  data: function data() {
    return {
      conduct: [],
      conductLength: '',
      numbers: '',
      scrill: 'true',
      globalUrl: API.GlobalUrl
    };
  },

  methods: {
    //操作按钮事件
    detail: function detail(item) {
      //跳转详情页面

      if (item.url) {
        if (item.type == 1 || item.type == 2) {
          var hrefHTML = this.hrefHTML(item.type, item.id);
          if (hrefHTML) {
            window.location.href = hrefHTML;
          } else {
            this.$router.push({ name: 'Detail', params: { id: item.id } });
          }
        } else {
          var hrefHTML = this.hrefHTML(item.url, item.id);
          if (hrefHTML) {
            window.location.href = hrefHTML;
          } else {
            if (item.url == 2) {
              this.$router.push({ name: 'Notice', params: { id: item.id } });
            } else if (item.url == 3) {
              this.$router.push({ name: 'list_vote', params: { id: item.id, active: 1 } });
            } else {
              this.$router.push({ name: 'Detail', params: { id: item.id } });
            }
          }
        }
      } else if (item.url_type) {
        var hrefHTML = this.hrefHTML(item.url_type, item.id);
        if (hrefHTML) {
          window.location.href = hrefHTML;
        } else {
          this.$router.push({ name: 'Detail', params: { id: item.id } });
        }
      } else {
        var hrefHTML = this.hrefHTML(0, item.id);
        if (hrefHTML) {
          window.location.href = hrefHTML;
        } else {
          this.$router.push({ name: 'Detail', params: { id: item.id } });
        }
      }
    }
  },
  created: function created() {
    var that = this;
    that.$watch(function () {
      console.log(this.find);
      if (that.find.page == 1) {
        that.conduct = [];
      }
      var Activities = '';
      if (that.find.type == 'indexhotactivity') {
        Activities = API.GetHotActivity;
      } else {
        Activities = API.GetActivities;
      }
      that.$http.get(Activities, { params: that.find }).then(function (res) {
        //  console.log(res)
        if (res.code == '0') {
          for (var i = 0; i < res.data.length; i++) {
            that.conduct.push(res.data[i]);
          }
          that.conductLength = res.total;
          that.numbers = that.conduct.length;
          if (that.numbers >= that.conductLength || that.conduct.length < 10 || res.data.length < 5) {
            that.scrill = false;
          } else {
            that.scrill = true;
          }

          that.$nextTick(function () {
            //是否显示
            //微信分享
            if (res.total > 0) {
              var metas = $('head').children('meta');
              var desc = metas[1].content;
              var dataName = {
                title: document.title, //分享标题
                desc: that.removeTAG(desc, 110), //metas[1].content,//分享简介(内容)
                imgAddress: that.conduct[0].playbill.playbill_h5, //分享图片地址
                Retain: '', //保留
                url: window.location.href //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
              };
              that.weixinShare(dataName);
            }
            //图片尺寸控制 16:9
            var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
            $('.pic-box').find('img').css({ height: picHimg, visibility: 'visible' });
          }, 500);
        }
      });
    });
  },
  mounted: function mounted() {
    //操作DOM
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "alKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"container"}},[_c('div',{staticClass:"myActivity"},[_c('div',{staticClass:"header ay-header"},[_c('h3',{staticClass:"header-nav"},[_vm._v("\n         个人信息\n      ")]),_vm._v(" "),_c('a',{staticClass:"icon-back",attrs:{"href":"javascript:;"},on:{"clcik":_vm.backFn}})])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page js_show home"},[_c('div',{staticClass:"page__bd"},[_c('div',{staticClass:"weui-cells"},[_c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":"javascript:;"}},[_c('div',{staticClass:"weui-cell__bd"},[_c('p',[_vm._v("头像")])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('img',{staticClass:"user_head",attrs:{"src":__webpack_require__("jCcC"),"alt":""}})])]),_vm._v(" "),_c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":"javascript:;"}},[_c('div',{staticClass:"weui-cell__bd"},[_c('p',[_vm._v("昵称")])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_vm._v("央视网友drweqr遥")])])]),_vm._v(" "),_c('div',{staticClass:"weui-cells"},[_c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":"javascript:;"}},[_c('div',{staticClass:"weui-cell__bd"},[_c('p',[_vm._v("真实姓名")])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_vm._v("王新")])]),_vm._v(" "),_c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":"javascript:;"}},[_c('div',{staticClass:"weui-cell__bd"},[_c('p',[_vm._v("性别")])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_vm._v("女")])]),_vm._v(" "),_c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":"javascript:;"}},[_c('div',{staticClass:"weui-cell__bd"},[_c('p',[_vm._v("手机号")])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_vm._v("180****3698")])]),_vm._v(" "),_c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":"javascript:;"}},[_c('div',{staticClass:"weui-cell__bd"},[_c('p',[_vm._v("所属地区")])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_vm._v("北京市  北京市  海淀区")])]),_vm._v(" "),_c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":"javascript:;"}},[_c('div',{staticClass:"weui-cell__bd"},[_c('p',[_vm._v("详细地址")])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_vm._v("街道门牌信息")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "av9n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b6Ap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_repassword_vue__ = __webpack_require__("qAJM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c3d71c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_repassword_vue__ = __webpack_require__("iW6+");
function injectStyle (ssrContext) {
  __webpack_require__("vAIT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_repassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c3d71c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_repassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bckt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginAler_vue__ = __webpack_require__("KDTg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d95577_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginAler_vue__ = __webpack_require__("5Uqv");
function injectStyle (ssrContext) {
  __webpack_require__("EDux")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginAler_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d95577_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginAler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "btoy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['UpFile', 'type', 'id', 'countArr', 'appId', 'audit_level'],
    data: function data() {
        return {
            uptoken2: '',
            fileId2: '',
            fileName2: 0,
            arrayName2: [],
            arrayUuid2: [],
            arrayImg: [],
            textTares: '',
            textName: '',
            allchannel: [],
            scrill: true,
            page: 1,
            key: '',
            allTyle2: false,
            numberSize2: 0,
            Uploaded2: 0,
            MyUploadImg: [],
            typeNmae2: '',
            scan: {
                isScan: false,
                url: ''
            },
            pngSds: API.GlobalUrl + 'static/dist/img/audit_2.jpg',
            reject_img: API.GlobalUrl + 'static/dist/img/reject_2.jpg',
            upload_success_img: '/images/upload_success_2.jpg',
            originArr: {
                "paike-hb": 'http://paike-hb.ishow.cctv.com',
                "paike-hd": 'http://paike-hd.ishow.cctv.com',
                "paike-sea": 'http://paike-sea.ishow.cctv.com'
            },
            moreInfo: false,
            classObj: {
                active: false,
                'down-arrow': false,
                all: false,
                elips: false
            },
            upfileTip: ''
        };
    },

    methods: {
        //操作按钮事件
        allTetx2: function allTetx2() {
            if (!this.moreInfo) return;
            this.allTyle2 = !this.allTyle2;
            if (this.allTyle2) {
                // $('.et-video-info').css('white-space','normal');
                this.classObj = {
                    active: true,
                    'down-arrow': true,
                    all: true
                    // elips: false,
                };
                this.upfileTip = this.UpFile.tip;
            } else {
                // $('.et-video-info').css('white-space','nowrap');
                this.classObj = {
                    active: false,
                    'down-arrow': true,
                    all: false
                    // elips: true,
                };
                this.upfileTip = this.UpFile.tip.substr(0, 50) + '...';
            }
        },
        fn: function fn() {
            var that = this;
            $('#uploadFile').modal('show');
            this.$http.get(API.GetUploadFileForMe, { params: { file_type: '2', page: '1', pagesize: '10', status: 'pass' } }).then(function (res) {
                if (res.code == '0') {
                    for (var i = 0; i < res.data.length; i++) {
                        that.allchannel.push(res.data[i]);
                    }
                    that.$nextTick(function () {
                        setTimeout(function () {
                            var picWimg = $('.pic-box').width();
                            var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                            $('.pic-box').css('height', picHimg);
                            $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
                        }, 200);
                    });
                }
            });
        },

        // Uptoken2() {
        //     var that = this
        //     var id = that.$route.params.id || that.id;
        //     this.$http.get(API.ImageToken, { params: { activity_id: id, app_id: that.appId } })
        //         .then(function(res) {
        //             console.log(res)
        //             if (res.code == 1) {
        //                 that.fileId2 = '';
        //                 that.uptoken2 = ''
        //             } else {
        //                 that.key = res.data.fileId;
        //                 that.fileId2 = res.data.fileId;
        //                 that.uptoken2 = res.data.uptoken
        //             }
        //         })
        // },
        cancel2: function cancel2() {
            $('#uploadModal2').modal('hide');
            $('#Textimg').val('');
            $('#Textareaimg').val('');
            $('#select2').val('');
        },
        updateFile: function updateFile(idx) {
            this.fileName2--;
            this.arrayImg.splice(idx, 1);
            this.arrayName2.splice(idx, 1);
            this.arrayUuid2.splice(idx, 1);

            if (this.numberSize2 > this.fileName2 + this.MyUploadImg) {
                $('#videoContainer2').show();
            }
        },
        delFile: function delFile(idx) {
            this.MyUploadImg.splice(idx, 1);
            if (this.numberSize2 > this.fileName2 + this.MyUploadImg) {
                $('#videoContainer2').show();
            }
        },
        needScan: function needScan(idx, url) {
            if (url) {
                this.scan.url = url + '?p=3&o=2&w=500&h=500';
            } else {
                this.scan.url = this.arrayImg[idx] + '?imageView2/2/w/500/h/500/ignore-error/1';
            }
            this.scan.isScan = true;
            $('body').addClass('modal-open');
        },
        closeScan: function closeScan() {
            this.scan.isScan = false;
            $('body').removeClass('modal-open');
        },
        initMoreInfo: function initMoreInfo() {
            var pinfo = this.$refs.p_info;
            if (pinfo) {
                var offH = pinfo.offsetHeight;
                var scrollH = pinfo.scrollHeight;
                // console.log(pinfo,offH,scrollH);
                if (scrollH > offH) {
                    this.moreInfo = true;
                    this.classObj = {
                        active: false,
                        all: false,
                        // elips:true,
                        'down-arrow': true
                    };
                    this.upfileTip = this.UpFile.tip.substr(0, 50) + '...';
                }
            }
        }
    },
    created: function created() {
        this.upfileTip = this.UpFile.tip;
    },
    mounted: function mounted() {
        //操作DOM

        var that = this,
            subscription2;
        var id = this.$route.params.id;
        that.typeNmae2 = that.UpFile.field_type;
        this.initMoreInfo();
        //if (this.UpFile.field_type == 'uploadimg') {
        if (that.UpFile.choose_num == '0') {
            $('.uploadImg').hide();
            return false;
        }
        /*   this.$http.get(API.GetUploadFileForMe,{params: {file_type: '1',page: '1',pagesize: '10',status: 'pass'}})
             .then(function (res) {
               console.log(res)
               if (res.code == '0') {
                 if(res.data.length == 0){
                   $('.uploadImgShow').hide()
                 }
               }
             });*/
        // console.log(that.UpFile.choose_num)
        if (that.type != 0) {
            that.ByUserid = {
                file_type: 2,
                activity_id: that.id
            };
            //  console.log(that.ByUserid)
            this.$http.get(API.GetActivityFileByUserid, { params: that.ByUserid }).then(function (res) {
                console.log(res);
                if (res.code == 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        that.MyUploadImg.push(res.data[i]);
                        // console.log(i)
                    }
                    that.arrayUuid2 = [];
                    that.arrayName2 = [];
                    that.fileName2 = 0;
                    if (!that.UpFile.choose_num) {
                        that.numberSize2 = 1;
                    } else {
                        that.numberSize2 = that.UpFile.choose_num;
                    }
                    if (that.numberSize2 == '' || that.numberSize2 == null || that.numberSize2 <= res.total) {
                        $('#videoContainer2').hide();
                    }
                }
            });
        } else {

            that.numberSize2 = that.UpFile.choose_num;
        }
        $('#select2').unbind().change(function () {
            if (id == '100071' || that.id == '100071') {
                $('#Textimg').val('我的观后感');
            } else {
                $('#Textimg').val('');
            }
            $('#Textareaimg').val('');

            var file = this.files[0]; //文件
            var key = file.name; //文件总名
            var name = key.split('.');
            var ext = name[name.length - 1].toLowerCase();
            if (ext != 'jpg' && ext != 'gif' && ext != 'png' && ext != 'jpeg') {
                $('#uploadImg-al .detailAlert-p').html('上传格式错误');
                $('#uploadImg-al').modal('show');
                return false;
            }
            var fileSize = file.size / 1024 / 1024;
            if (fileSize > 20) {
                $('#uploadImg-al .detailAlert-p').html('图片大小不能超过20MB');
                $('#uploadImg-al').modal('show');
                return false;
            }

            var params = key.split('.')[0]; //文件名
            // var domain ='upload-cc';  //域名
            var putExtra = {
                fname: key,
                params: {},
                mimeType: null
            };
            //文件配置
            var config = {
                useCdnDomain: true,
                disableStatisticsReport: false,
                retryCount: 6
                //region: ''  //上传区域
            };
            //进度
            var next = function next(response) {
                var file = response;
                //console.log(file);
                var size = file.size / 1024 / 1024;
                var loaded = file.loaded / 1024 / 1024;
                //总大小
                $('.SizeBox').html(size.toFixed(2));
                //已上传
                $('.SecondBox').html(loaded.toFixed(2));
                //上传进度
                $('.pl-num').children('span').html(file.percent.toFixed(2));
                //上传进度条
                $('.pl-gro-bar').css('width', file.percent + '%');
            };
            //保错
            var error = function error(err) {
                console.log(err);
                $('#uploadImg-al .detailAlert-p').html('上传出错');
                $('#uploadImg-al').modal('show');
                $('#select2').val('');
            };
            //上传成功
            var complete = function complete(isSuccess, code, backData) {
                if (isSuccess) {
                    ++that.fileName2;
                    var userData = JSON.parse(ALY.util.base64.decode(backData.userData)).Vod.UserData;
                    // if (res.data.file_path) {
                    //   var bucket = res.data.bucket;
                    //   that.arrayImg.push(that.originArr[bucket] + '/'+ res.data.file_path)
                    // }
                    that.arrayName2.push($('#Textimg').val());
                    that.arrayUuid2.push(userData.file_id);
                    $('#processModal').modal('hide');
                    $('#Textimg').val('');
                    $('#Textareaimg').val('');
                    $('#select2').val('');
                    if (that.numberSize2 <= that.fileName2 + that.MyUploadImg.length) {
                        $('#videoContainer2').hide();
                    } else {
                        //that.Uptoken2();
                    }
                } else {
                    $('#processModal').modal('hide');
                    $('#Textimg').val('');
                    $('#Textareaimg').val('');
                    $('#select2').val('');
                    $('#uploadImg-al .detailAlert-p').html(backData);
                    $('#uploadImg-al').modal('show');
                }
            };

            // 上传全家福100131
            var activeId = that.id;
            console.log(activeId);
            if (activeId == '100131') {
                var param = {};
                param.title = '我与地球全家福';
                param.description = '我与地球全家福'; //描述
                if (that.$route.params.id == 0) {
                    params.activity_id = that.id;
                } else {
                    params.activity_id = that.$route.params.id || that.id;
                }

                params.source = "1";
                params.app_id = that.appId;
                params.audit_level = that.audit_level;
                // console.log("imageupload" + params.audit_level);
                var content = {
                    file: file, //文件名 必填
                    file_type: "2",
                    Biography: params
                };

                $('#uploadModal2').modal('hide');
                $('#processModal').modal('show');
                $.fn.uploadHandle(content, function () {
                    console.log("开始上传！");
                }, next, complete);
            } else {
                $('#uploadModal2').modal('show');
            }
            //上传
            $('.btn-pl-start2').unbind('click').on('click', function () {
                if ($('#Textimg').val().trim() == '') {
                    $('#Textimg').focus();
                } else {
                    var params = {};
                    params.title = $('#Textimg').val();
                    if ($('#Textareaimg').val()) {
                        params.description = $('#Textareaimg').val();
                    } else {
                        params.description = $('#Textimg').val();
                    }
                    if (that.$route.params.id == 0) {
                        params.activity_id = that.id;
                    } else {
                        params.activity_id = that.$route.params.id || that.id;
                    }

                    params.source = "1";
                    // params.audit_level = '2';
                    params.audit_level = that.audit_level;
                    //  console.log("imageupload" + params.audit_level);
                    params.app_id = that.appId;
                    // console.log(params);
                    var content = {
                        file: file, //文件名 必填
                        file_type: "2",
                        Biography: params
                    };
                    $('#uploadModal2').modal('hide');
                    $('#processModal').modal('show');
                    $.fn.uploadHandle(content, function () {
                        console.log("开始上传！");
                    }, next, complete);
                }
            });
            //取消
            $('.btn-pl-giveup').unbind('click').on('click', function () {
                $.fn.stopUploadFile();
                $.fn.cancleUploadFile();
                $.fn.deleteUploadFile();
                $('#Textimg').val('');
                $('#Textareaimg').val('');
                $('#select2').val('');
            });
        });

        var nScrollHight = 0; //滚动距离总长(注意不是滚动条的长度)
        var nScrollTop = 0; //滚动到的当前位置
        var len = 10;
        //滚动加载
        $('#modal-body').scroll(function () {
            nScrollHight = $(this)[0].scrollHeight;
            nScrollTop = $(this)[0].scrollTop; //能获取到
            var nDivHight = $('#modal-body').height();
            //console.log(nScrollHight,nScrollTop,nDivHight)
            //console.log(that.allchannel.length >= len)
            if (that.allchannel.length >= len) {
                that.scrill = true;
            } else {
                that.scrill = false;
            }
            if (nScrollTop + nDivHight + 40 >= nScrollHight && that.scrill) {
                that.scrill = false;
                //正在进行二次加载
                var page = ++that.page;
                len = len / 1 + 10;
                $.getJSON(API.GetUploadFileForMe + '?jsoncallback=?&file_type=2&pagesize=10&page=' + page, function (res) {
                    if (res.code == '0') {
                        for (var i = 0; i < res.data.length; i++) {
                            that.allchannel.push(res.data[i]);
                        }
                        that.$nextTick(function () {
                            setTimeout(function () {
                                var picWimg = $('.pic-box').width();
                                var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                                $('.pic-box').css('height', picHimg);
                                $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
                            }, 200);
                        });
                    } else {
                        console.log();
                    }
                });
            }
        });
    }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "btv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function (to, from) {
  // console.log(to, from);
  var uuid = '';

  if (to.name == "VideoName") {
    uuid = to.params.uuid;
  }
  if (to.name !== 'Detail') {
    //detail埋码在detail.vue页面

    var q = window.goldlog_queue || (window.goldlog_queue = []);
    // q.push({
    //   action: 'goldlog.setPageSPM',
    //   arguments: ['spmA', 'spmB']
    // });
    q.push({
      action: 'goldlog.sendPV',
      arguments: [
      // 必填的配置项
      {
        is_auto: false
      },
      // 可选的自定义参数
      {
        uuid: uuid,
        ch_id: 'EPGC1386744804340101',
        col_id: 'EPGM1387361853673102'
      }]
    });
  }

  //百度统计
  var _hmt = window._hmt || (window._hmt = []);
  _hmt.push(['_trackPageview', to.fullPath]);
});

/***/ }),

/***/ "c72D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UploadToken_upload_vue__ = __webpack_require__("dPOJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadToken_FileUpload_vue__ = __webpack_require__("2cs+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadToken_VideoUpload_vue__ = __webpack_require__("j/bE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UploadToken_imageUpload_vue__ = __webpack_require__("fHf5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_linkage_vue__ = __webpack_require__("gqHj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__template_selectmul_vue__ = __webpack_require__("Lshr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import Cascader from '../template/cascader.vue'


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['detailsTxte'],
  data: function data() {
    // console.log("data:" );
    // console.log(this.detailsTxte);
    // console.log(that.detailsTxte);
    //  console.log(that.audit_level);
    return {
      userId: "",
      RegistrationForm: "",
      _Activity: "",
      setName: "", //性别
      UpFile: null, //上传需求
      region: "",
      agreement1: true,
      agreement2: false,
      agreement3: false,
      appId: "mp0qftl9iu",
      audit_level: 2,
      thirdParty: true,
      etComplete: false,
      paramsId: '',
      loading: false,
      casVal: {}
      // detailsTxte: this.detailsTxte
    };
  },

  methods: {
    //操作按钮事件"
    listenToMyBoy: function listenToMyBoy(somedata) {
      this.region = somedata;
    },
    agreement: function agreement(val) {
      this.agreement1 = this.agreement2 = this.agreement3 = false;
      if (val == 1) {
        this.agreement1 = true;
      } else if (val == 2) {
        this.agreement2 = true;
      } else if (val == 3) {
        this.agreement3 = true;
      }
      $('#agreement').modal('show');
      $('.niticeSroll').stop().animate({ scrollTop: '0' }, 200);
    },
    sexOn: function sexOn(ind, val, item) {
      // console.log(ind)
      this.setName = val;
      $('.' + item).eq(ind).parent().siblings().children('.' + item).removeClass('radio-on');
      $('.' + item).eq(ind).parents('li').siblings().find('.' + item).removeClass('radio-on');
      $('.' + item).eq(ind).addClass('radio-on');
    },
    SmallFocus: function SmallFocus(ind) {
      //小输入框获取焦点时
      //console.log(ind)
      $('.group').eq(ind).find('input').next('.icon-delete').show();
    },
    SmallKeyup: function SmallKeyup(event, ruleType, is_require) {
      if (ruleType != '' && ruleType) {
        var itself = event.target,
            val = $(itself).val(),
            itselfs = '//' + ruleType + '//',
            re = itselfs.replace(/\/\//g, "\/"),
            reg = eval(re);
        if (is_require == 0 && val == '') {
          $(itself).next().hide();
          $('.et-complete').css('pointer-events', 'visible');
        } else {
          if (!reg.test(val)) {
            $(itself).next().show();
            $('.et-complete').css('pointer-events', 'none');
            return false;
          } else {
            $(itself).next().hide();
            $('.et-complete').css('pointer-events', 'visible');
          }
        }
      }
    },
    SmallBlur: function SmallBlur(event, ind) {
      //小输入框失去焦点时
      setTimeout(function () {
        $('.group').eq(ind).find('.icon-delete').hide();
      }, 200);
    },
    SmallDelete: function SmallDelete(ind) {
      //小输入框删除
      $('.group').eq(ind).find('input').val(' ');
      $('.icon-delete').hide();
    },
    largeDelete: function largeDelete() {
      //文本输入框删除按钮
      $('.icon-delete').parent('.et-trbox').find('textarea').val(' ');
      $('.icon-delete').hide();
    },
    ReadAndAgree: function ReadAndAgree() {
      //阅读并同意
      if ($('.et-deal-check').hasClass('et-deal-on')) {
        $('.et-deal-check').removeClass('et-deal-on');
      } else {
        $('.et-deal-check').addClass('et-deal-on');
      }
    },
    complete: function complete() {
      //完成参与

      var that = this;
      if (that.loading) {
        return;
      } //加载中
      if ($('.et-complete').html() == '请先登录') {
        $('#login_Alert').modal('show');
        return false;
      }
      var file_id = {},
          fileName = $('.load-inner').find('.fileName'),
          that = this,
          content = {};
      //text文本
      var Text = $('.et-typeText');
      for (var t = 0; t < Text.length; t++) {
        //查找每一项
        var TextName = Text.eq(t).find('input');
        //判断是否必填
        if (TextName.attr('is_require') == 1) {
          if (TextName.val() == '') {
            TextName.focus();
            return false;
          }
          if (TextName.attr('name') == 'email') {
            var email = TextName.val();
            var reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
            if (reg.test(email)) {} else {
              TextName.focus();
              return false;
            }
          }
        }
        content[TextName.attr('name')] = TextName.val();
      }
      //多行文本
      var Textarea = $('.et-trbox');
      for (var te = 0; te < Textarea.length; te++) {
        //查找每一项
        var TextareaName = Textarea.eq(te).find('textarea');
        //判断是否为必填
        if (TextareaName.attr('is_require') == 1) {
          if (TextareaName.val() == '') {
            TextareaName.focus();
            return false;
          }
        }
        content[TextareaName.attr('name')] = TextareaName.val();
      }
      //单选
      var radio = $('.et-radiolink');
      for (var r = 0; r < radio.length; r++) {
        //查找每一项
        var radioName = radio.eq(r).find('.radio-on');
        //判断是否为必填
        if (radio.eq(r).find('.radio-box').attr('is_require') == 1) {
          if (radioName.length == 0) {
            var offset = $('.et-radiolink').eq(r).offset().top;
            $('.et-radiolink').eq(r).addClass('font');
            $(window).scrollTop(offset - 200);
            return false;
          }
        }
        content[radioName.attr('name')] = radioName.next().html();
      }
      //多选
      var checked = $('.et-checklink');
      for (var c = 0; c < checked.length; c++) {
        var che = [];
        //判断是否为必填
        if (checked.eq(c).attr('is_require') == 1) {
          //是否选中
          if (checked.eq(c).find('.check-on').length == 0) {
            var offChecked = $('.et-checklink').eq(c).offset().top;
            $('.et-checklink').eq(c).addClass('font');
            $(window).scrollTop(offChecked - 200);
            return false;
          }
        }
        //遍历多选内容
        for (var cc = 0; cc < checked.eq(c).find('.check-on').length; cc++) {
          che.push($(checked.eq(c).find('.check-on')[cc]).next().html());
        }
        content[checked.eq(c).attr('name')] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(che);
      }
      //下拉框
      var Select = $('.et-slebox');
      for (var s = 0; s < Select.length; s++) {
        var selectName = Select.eq(s).find('select');
        if (selectName.attr('is_require') == 1) {
          if (selectName.val() == '') {
            selectName.focus();
            return false;
          }
        }
        content[selectName.attr('name')] = selectName.val();
      }
      //日期
      var typeData = $('.et-typeData');
      for (var t = 0; t < typeData.length; t++) {
        var typeDateName = typeData.eq(t).find('input').eq(0);
        if (typeDateName.attr('is_require') == 1) {
          if (typeDateName.val() == '') {
            var etSlebox = $('.et-slebox').eq(c).offset().top;
            $('.et-slebox').eq(c).addClass('font');
            $(window).scrollTop(etSlebox - 200);
            return false;
          }
        }
        content[typeDateName.attr('name')] = typeDateName.val();
      }
      //地区
      var demolName = $('.demo1');
      if (demolName.length > 0) {
        for (var i = 0; i < demolName.length; i++) {
          var sel = $('.example').eq(i).find('select'),
              selName = '';
          for (var v = 0; v < 3; v++) {
            if (sel.eq(v).val() == '请选择') {
              var etSlebox = $('.content-block').offset().top;
              $('.example').addClass('font');
              $(window).scrollTop(etSlebox);
              return false;
            }
            if (sel.eq(v).length) {
              selName += sel.eq(v).val() + ',';
            } else {
              selName += '--' + ',';
            }
          }
          if (demolName.attr('is_require') == 1) {
            if ($('.detailed').find('input').val() == '') {
              $('#Alert').find('.Prompt-p').html('请填写详细地址');
              $('#Alert').modal('show');
              $('.example').addClass('font');
              return false;
            }
          }
          selName += $('.detailed').find('input').val();
          content[demolName.eq(i).attr('name')] = selName;
        }
      }
      // 所属类型
      var selmul = $('.group-selmul');
      // if(selmul.length>0){
      // debugger;
      for (var _i = 0; _i < selmul.length; _i++) {
        var seli = selmul.eq(_i);
        var name = seli.attr('name');
        var casVal = that.casVal[name];

        if (seli.attr('is_require') == 1) {
          // console.log(2)
          if (!casVal || casVal[0] == '' || casVal[1] == '') {
            var top = seli.offset().top;
            seli.find('.selmul').addClass('font');
            $(window).scrollTop(top);
            return false;
          }
        }
        if (casVal && casVal.length) {
          content[name] = casVal.join();
        }
      }
      // }

      var uploadVideo = $('.uploadVideo');
      var uploadImg = $('.uploadImg');
      var uploadFile = $('.uploadFile');
      var uploadAll = $('.uploadAll');

      // 获取上传文件上传字段
      // if (uploadFile.attr('name')) {
      //   content[uploadFile.attr('name')] = '上传文档';
      // }
      if (uploadFile.length) {
        var fLen = uploadFile.find('.fileName');
        var fName = '';
        for (var d = 0; d < fLen.length; d++) {
          fName += fLen.eq(d).attr('attr-uuid') + ',';
        }
        content[uploadFile.attr('name')] = fName;
      }
      // 获取上传图片或视频
      if (uploadAll.attr('name')) {
        var allLen = uploadAll.find('.fileName');
        var allName = '';
        for (var a = 0; a < allLen.length; a++) {
          allName += allLen.eq(a).attr('attr-uuid') + ',';
        }
        content[uploadAll.attr('name')] = allName;
      } else {
        // 获取上传视频字段
        if (uploadVideo.length) {
          var videoLen = uploadVideo.find('.fileName');
          var videoName = '';
          for (var d = 0; d < videoLen.length; d++) {
            videoName += videoLen.eq(d).attr('attr-uuid') + ',';
          }
          content[uploadVideo.attr('name')] = videoName;
        }
        // 获取上传图片字段
        if (uploadImg.length) {
          var imgLen = uploadImg.find('.fileName');
          var imgName = '';
          for (var m = 0; m < imgLen.length; m++) {
            imgName += imgLen.eq(m).attr('attr-uuid') + ',';
          }
          content[uploadImg.attr('name')] = imgName;
        }
      }
      //判断视频是否必填
      if (uploadVideo.attr('is_require') == 1) {
        if (!$(uploadVideo).find('.videoFile').length > 0) {
          $('#Alert').find('.Prompt-p').html('请您上传视频！');
          $('#Alert').modal('show');
          return false;
        }
      }
      //判断图片是否必填
      if (uploadImg.attr('is_require') == 1) {
        if (!$(uploadImg).find('.videoFile2').length > 0) {
          $('#Alert').find('.Prompt-p').html('请您上传图片！');
          $('#Alert').modal('show');
          return false;
        }
      }
      //判断文档是否必填
      if (uploadFile.attr('is_require') == 1) {
        if (!$(uploadFile).find('.videoFile2').length > 0) {
          $('#Alert').find('.Prompt-p').html('请您上传文档！');
          $('#Alert').modal('show');
          return false;
        }
      }
      //判断图片或视频
      if (that.thirdParty) {
        if (uploadAll.attr('is_require') == 1) {
          if (!$(uploadAll).find('.videoFile').length > 0) {
            $('#Alert').find('.Prompt-p').html('请您上传图片或视频');
            $('#Alert').modal('show');
            return false;
          }
        }
      }
      //上传文件key
      for (var i = 0; i < fileName.length; i++) {
        var key = fileName.eq(i).attr('attr-uuid');
        var val = fileName.eq(i).attr('attr-type');
        file_id[key] = val;
      }

      var ActivityForm = {
        activity_id: that.$route.params.id,
        //content: JSON.stringify(content),
        file_id: file_id,
        source: 1
      };

      for (var key in content) {
        if (content.hasOwnProperty(key)) {
          ActivityForm[key] = content[key];
        }
      }
      console.log(ActivityForm);
      if ($('.et-deal-on').length != 0) {
        $('.loading-notice').css({ 'top': '0', 'background': 'rgba(0,0,0,.5)' });
        $('.et-complete').addClass('dl-btn-active');
        that.loding = true;
        $.ajax({
          'url': API.AddActivityForm,
          'data': ActivityForm,
          'type': 'POST',
          'dataType': 'json',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          success: function success(res) {
            // $('#loading').hide().removeClass('loading-notice');
            if (res.code == 0) {
              $('.et-complete').removeClass('dl-btn-active');
              $('#entryModal').modal('show');
            } else if (res.code == 3002) {
              $('#Alert').find('.Prompt-p').html('活动异常-请联系管理员！');
              $('#Alert').modal('show');
              $('.et-complete').addClass('dl-btn-active');
            } else {
              $('.et-complete').removeClass('dl-btn-active');
              $('#Alert').find('.Prompt-p').html('请确定信息是否填写完成？');
              $('#Alert').modal('show');
              //   console.log(res)
            }
          },
          complete: function complete() {
            that.loading = false;
          }
        });
      } else {
        alert('请选择使用协议');
      }
    },
    casChange: function casChange(data) {
      console.log(data);
      this.casVal[data.name] = data.value;
    }
  },

  components: { //渲染页面
    Upload: __WEBPACK_IMPORTED_MODULE_1__UploadToken_upload_vue__["a" /* default */],
    ImageUpload: __WEBPACK_IMPORTED_MODULE_4__UploadToken_imageUpload_vue__["a" /* default */],
    FileUpload: __WEBPACK_IMPORTED_MODULE_2__UploadToken_FileUpload_vue__["a" /* default */],
    VideoUpload: __WEBPACK_IMPORTED_MODULE_3__UploadToken_VideoUpload_vue__["a" /* default */],
    Linkage: __WEBPACK_IMPORTED_MODULE_5__template_linkage_vue__["a" /* default */],
    // Cascader: Cascader,
    Selectmul: __WEBPACK_IMPORTED_MODULE_6__template_selectmul_vue__["a" /* default */]
  },
  created: function created() {
    //  console.log('notice created', detailsTxte);
    var id = this.$route.params.id,
        that = this;
    this.paramsId = id;
    if (window.isThisClient('cbox')) {
      console.log("notice");
      that.cboxregisterhandler();
    }
    //账户
    if (!that.loginFn()) {
      //that.$router.push({name: 'login_Quick'});
      $('#login_Alert').modal('show');
      return false;
      console.log(that.$router, id);
      that.$router.push({ name: 'login_Quick', params: { from: '/notice/' + id } });
    } else {
      // console.log('判断是否登录-已登录')
    }

    $('#agreement').modal('show');
    //详情

    // var detailsTxte = that.detailsTxte;

    // if(detailsTxte.page_config.wuxicheck && detailsTxte.page_config.wuxicheck.is_show==0){
    //     audit_level = 0;
    // }
    //  console.log("audit_level" + audit_level);
    //if(res.code == '0'){
    // if (detailsTxte.type == 1) {
    //   // that.$router.replace({name: 'Detail', params: {id: id}});
    //   that.$router.go(-1);
    // }
    // var data = new Date(detailsTxte.end_time).getTime() /*+ 86400000*/ - new Date().getTime();
    // if (data.status == 2) {
    //   $('.et-complete').addClass('dl-btn-active')
    // }
    // if (data > 0) {
    //   $('.et-complete').removeClass('dl-btn-active')
    // } else {
    //   $('.et-complete').addClass('dl-btn-active')
    // }
    // var startData = new Date(detailsTxte.start_time).getTime() - new Date().getTime();
    // if(startData > 0){
    //   // that.$router.replace({name: 'Detail', params: {id: id}});
    //   that.$router.go(-1);

    // }
    //是否参与
    that.$http.get(API.IsJoin, { params: { activity_id: id } }).then(function (res) {
      if (res.data.isJoin == 1) {
        // that.$router.replace({name: 'myActivity_MyParticipate', params: {id: id}});//继续参与
        that.$router.replace({ name: 'Revise', params: { id: id, form_id: 0 } }); //继续参与
        return false;
      }
    });
    this.$http.get(API.GetActivitieById, { params: { id: id } }).then(function (res) {
      // console.log(res,'entryform');
      if (res.code == 0) {
        that.detailsTxte = res.data;
        if (that.detailsTxte.page_config.wuxicheck && that.detailsTxte.page_config.wuxicheck.is_show == 0) {
          that.audit_level = 0;
        }
        console.log("notice audit_level:" + that.audit_level);
      }
    });
    //报名字段
    that.$http.get(API.GetActivityFormFields, { params: { activity_id: id } }).then(function (res) {
      var data = res.data;
      if (res.code == 0) {
        that.$http.get(API.GetUserActivityInfo).then(function (res) {
          var _data = res.data.userInfo;
          var _arr = data.map(function (item, val) {
            var name = '';
            if (_data) {
              name = _data[item.name];
            }
            return {
              activity_id: item.activity_id,
              name: item.name,
              title: item.title,
              tip: item.tip,
              field_type: item.field_type,
              is_require: item.is_require,
              option_json: item.option_json || '',
              default_value: name || '',
              choose_num: data[val].choose_num || '',
              rule_type: data[val].rule_type || ''
            };
          });
          that.RegistrationForm = _arr;
          console.log("GetActivityFormFields level:" + that.audit_level);
        });
        if (res.data.length == 0) {
          // that.$router.push({name: 'Detail', params: {id: id}});
          that.$router.go(-1);
        }
        that.$nextTick(function () {
          that.etComplete = true;
        });
      } else {
        $('#login_Alert').modal('show');
        $('.et-complete').html('请先登录');
        //that.$router.push({name: 'Detail', params: {id: id}});
        console.log('报名字段-请求数据信息出错');
      }
    });
  },
  mounted: function mounted() {
    //操作DOM
    var that = this;

    // function ready() {
    //   if (window.__wxjs_environment === 'miniprogram') {
    //     var str = navigator.userAgent.toLowerCase();
    //     var name = str.toLowerCase()
    //     var ver = name.match(/os (.*?) like/);
    //     var userName = that.getCookie('userSeqId')
    //     if (ver) {
    //       var n = ver[1].replace(/_/g, ".")
    //       var w = parseInt(n);
    //       if (w == 10 || n == "10.2.1") {
    //         that.thirdParty = false;
    //       }
    //     }
    //   }
    // }

    // if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
    //   document.addEventListener('WeixinJSBridgeReady', ready, false)
    // } else {
    //   ready()
    // }
    //单选触发
    $('.form').on('click', '.et-radiolink', function () {
      $('.et-radiolink').removeClass('font');
    });
    $('.form').on('click', '.et-checklink', function () {
      $('.et-checklink').removeClass('font');
    });
    //选择日期
    $('.date-show').on('focus', function () {
      $('.icon-date').trigger('click');
    });
    // $('.date-show').on('oninput', function () {
    //   $('.icon-date').trigger('click');
    // });

    //文本输入框根据内容自动变高
    $('textarea').unbind('input');
    $('textarea').bind('input', function () {
      handleTextareaHeight(this);
    });

    function handleTextareaHeight(element) {
      var textareaMinHeight = 72;
      element.style.height = textareaMinHeight + 'px';
      if (element.scrollHeight > textareaMinHeight) {
        element.style.height = element.scrollHeight + 'px';
      }
    }

    // checkbok 选中函数
    $('.form').on('click', '.et-checklink li', function () {
      if ($(this).find('.check-box').hasClass('check-on')) {
        $(this).find('.check-box').removeClass('check-on');
      } else {
        $(this).find('.check-box').addClass('check-on');
      }
    });
    //当前日期
    setTimeout(function () {
      var getMonth = '',
          getDate = '';
      if (new Date().getMonth() + 1 < 10) {
        getMonth = '0' + (new Date().getMonth() / 1 + 1);
      } else {
        getMonth = new Date().getMonth() / 1 + 1;
      }
      if (new Date().getDate() < 10) {
        getDate = '0' + new Date().getDate();
      } else {
        getDate = new Date().getDate();
      }
      var data = new Date().getFullYear() + '-' + getMonth + '-' + getDate;
      // $('.date-style').val(data);
      // $('.date-show').val(data);
      $('.date-new-show').val(data);
    }, 500);

    // 日期

    // $('.form').on('click', 'input[type ="date"]', function () {
    //   $(this).parents('.et-typeData').find('.date-show').focus();
    // });
    // $('.form').on('oninput', '.date-show', function () {
    //   $(this).next.click();
    // });
    // $('.form').on('change', 'input[type ="date"]', function () {
    //   $(this).prev('input').val($(this).val())
    // });
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "c9m6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fileItem: null,
      tops: '0',
      data: '',
      one: true,
      page: 1,
      scroll: true,
      busyDis: true
    };
  },

  methods: {
    //操作按钮事件
    getMinUl: function getMinUl() {
      //每次获取最短的ul,将图片放到其后
      var arrUl = $("#containerDis .col");
      var minUl = arrUl.eq(0);
      arrUl.each(function (index, elem) {
        if ($(elem).height() < minUl.height()) {
          minUl = $(elem);
        }
      });
      return minUl;
    },
    loadMeinv: function loadMeinv() {
      var that = this;
      // var data = 0;
      that.$http.get(API.FileList, { params: { page: that.page, pagesize: 15, version: 2, is_recommend: 1 } }).then(function (res) {
        console.log(res);
        if (res.code == 0) {
          var data = res.data;
          var pageSize = 0;
          for (var i = 0; i < data.length; i++) {
            //每次加载时模拟随机加载图片
            if (res.data[i].file && res.data[i].file != false) {
              pageSize = ++pageSize;
              var html = "";
              var img = '',
                  type = '';
              if (data[i].file_type == 'image') {
                img = data[i].file.image_url;
                type = '<em class="em-img">图片</em>';
              } else {
                img = data[i].file.thumb_url;
                type = '<em class="em-video">' + that.formatSeconds(data[i].file.time_span) + '</em>';
              }
              //预览图尺寸
              img += '?p=3&o=2&w=350&h=197';
              html += "<li>" + "<div class='WaterfallItem-div'>" + "<div class='Waterfall-Location' water='" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data[i]) + "' >" + "<img  class='Waterfall' src='" + img + "' alt=''/>" + type + "" + "</div>" + "<div class='WaterfallItem-tit'>" + data[i].file.title + "</div>" + "<p class='WaterfallItem-p'>" + "<img  src='" + data[i].user.face_url + "' alt=''/>" + data[i].file.nickname + "</p>" + "</div>" + "</li>";
              var minUl = that.getMinUl();
              minUl.append(html);
            }
          }
          that.$nextTick(function () {
            if (res.data.length === 0 || res.data.length < 10) {
              $('.containerDis').css({ 'padding-bottom': '44px' });
              that.scroll = false;
              that.busyDis = false;
            } else {
              that.scroll = true;
            }
            if (that.one) {
              if (res.total == 0) {
                $('.discoverys').find('.index-content').html('未查找到相关作品').css('margin-top', '40px');
              } else {
                $('.discoverys').find('.index-content').css('background', '#e3e3e3');
              }

              if ($('#containerDis').find('li').length > 0) {
                var img = $('#containerDis').find('li').find('img').attr('src');
              }
              var metas = $('head').children('meta');
              var desc = metas[1].content;
              var dataName = {
                title: document.title, //分享标题
                desc: that.removeTAG(desc, 110), //metas[1].content,//分享简介(内容)
                imgAddress: img, //分享图片地址
                Retain: '', //保留
                url: API.UrlName + 'discovery' //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
              };
              that.weixinShare(dataName);
              that.one = false;
            }
          });
        }
      });
    },
    water: function water(item) {
      this.$router.push({ name: 'VideoName', params: { id: item.activity_id, uuid: item.file_id, type: item.file_type } });
    },
    formatSeconds: function formatSeconds(value) {
      var theTime = parseInt(value); // 秒
      var theTime1 = 0; // 分
      var theTime2 = 0; // 小时
      // alert(theTime);
      if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        // alert(theTime1+'-'+theTime);
        if (theTime1 > 60) {
          theTime2 = parseInt(theTime1 / 60);
          theTime1 = parseInt(theTime1 % 60);
        }
      }
      var result = '' + parseInt(theTime);
      //分钟
      if (theTime1 > 0) {
        if (theTime1 >= 10) {
          if (result >= 10) {
            result = '00:' + parseInt(theTime1) + ':' + result;
          } else {
            result = '00:' + parseInt(theTime1) + ':0' + result;
          }
        } else {
          if (result >= 10) {
            result = '00:0' + parseInt(theTime1) + ':' + result;
          } else {
            result = '00:0' + parseInt(theTime1) + ':0' + result;
          }
        }
      } else {
        if (result >= 10) {
          result = '00:00:' + result;
        } else {
          result = '00:00:' + '0' + result;
        }
      }
      if (theTime2 > 0) {
        if (theTime2 >= 10) {
          result = parseInt(theTime2) + ':' + result.substring(2);
        } else {
          result = '0' + parseInt(theTime2) + result.substring(2);
        }
      } else {}
      return result;
    }
  },

  created: function created() {
    //第一次执行
    this.loadMeinv();
  },
  mounted: function mounted() {
    //操作DOM
    var that = this;
    //console.log(1)
    if (that.IsPC()) {
      window.location.href = API.IsPcName;
    }
    $('#containerDis').on('click', 'li', function () {
      var item = $(this).find('.Waterfall-Location').attr('water');
      that.water(JSON.parse(item));
    });
    $(window).on("scroll", function () {
      var minUl = that.getMinUl();
      if (minUl.height() + 100 <= $(window).scrollTop() + $(window).height() && that.scroll == true) {
        that.scroll = false;
        that.page = ++that.page;
        //console.log(that.page);
        //当最短的ul的高度比窗口滚出去的高度+浏览器高度大时加载新图片
        that.loadMeinv();
      }
    });
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "cCBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myMessage_vue__ = __webpack_require__("B1Td");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ccada9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myMessage_vue__ = __webpack_require__("SQkT");
function injectStyle (ssrContext) {
  __webpack_require__("lH9b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ccada9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cOOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_thirdparty_vue__ = __webpack_require__("d8pz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5ebc15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_thirdparty_vue__ = __webpack_require__("aC8g");
function injectStyle (ssrContext) {
  __webpack_require__("BICJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e5ebc15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_thirdparty_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5ebc15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_thirdparty_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cbNo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cshL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_follow_vue__ = __webpack_require__("h3cB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bcdc2e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_follow_vue__ = __webpack_require__("3OcI");
function injectStyle (ssrContext) {
  __webpack_require__("SXek")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_follow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bcdc2e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_follow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d8pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "thirdparty",
    data: function data() {
        return {
            loadUrl: ''
        };
    },

    methods: {
        // 操作按钮事件
    },
    created: function created() {},
    mounted: function mounted() {
        // 操作DOM
        this.loadUrl = window.location.href;
        $('.OAuthQzoneClient').prop('href', 'https://oauth.passport.cntv.cn/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=' + this.loadUrl);
        $('.OAuthSinaClient').prop('href', 'https://oauth.passport.cntv.cn/OAuthSinaClient/OAuthSinaClientServlet.do?cntv_callback=' + this.loadUrl);

        // $('.OAuthQzoneClient').prop('href','https://reg.cctv.com/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=' + this.loadUrl )
        // $('.OAuthSinaClient').prop('href','https://reg.cctv.com/OAuthSinaClient/OAuthSinaClientServlet.do?method=login&cntv_callback=' + this.loadUrl )
        $('.OauthAlipay').prop('href', 'https://reg.cctv.com/OauthAlipay/OauthAlipayServlet.action?method=login&cntv_callback=' + this.loadUrl);
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "dFj8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_vue__ = __webpack_require__("YRgJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f898c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_vue__ = __webpack_require__("a0WO");
function injectStyle (ssrContext) {
  __webpack_require__("8T4D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f898c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dPOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__ = __webpack_require__("uOyh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fefd04c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_vue__ = __webpack_require__("dWjY");
function injectStyle (ssrContext) {
  __webpack_require__("yKjA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fefd04c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dWjY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload uploadAll",attrs:{"id":"upload_file","is_require":this.UpFile.is_require,"name":this.UpFile.name}},[_c('div',{staticClass:"load-bl"},[_c('h5',{staticClass:"tit"},[_vm._v("\n      "+_vm._s(this.UpFile.title)+"\n      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.UpFile.is_require == 1),expression:"this.UpFile.is_require == 1"}],staticStyle:{"color":"#cf5454","margin-left":"5px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"uploa-bg"},[_c('div',{staticClass:"load-inner"},[_vm._l((_vm.MyUploadVideo),function(item,ind){return (_vm.MyUploadVideo.length>0)?_c('div',{staticClass:"load-link load-over",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"pic-b pic-v"},[(item.file_type === 'image')?_c('img',{attrs:{"src":item.file.image_url,"alt":""},on:{"click":function($event){_vm.needScan(ind, item.file.image_url )}}}):_c('img',{attrs:{"src":item.file.thumb_url,"alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"padding-left":"10px","max-height":"50px"},attrs:{"attr-uuid":item.file_id}},[_vm._v(_vm._s(item.file.title))])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.fileName),function(item,ind){return _c('div',{staticClass:"load-link load-over videoFile",staticStyle:{"margin-bottom":"15px"}},[_c('span',{staticClass:"pic-del",on:{"click":function($event){_vm.updateFile(ind)}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"pic-b pic-v"},[(_vm.arrType[ind]===2)?_c('img',{attrs:{"src":_vm.arrayFile[ind],"alt":""},on:{"click":function($event){_vm.needScan(ind)}}}):_c('img',{attrs:{"src":_vm.arrayFile[ind],"alt":""}})]),_vm._v(" "),_c('p',{staticClass:"fileName",staticStyle:{"padding-left":"10px","max-height":"50px"},attrs:{"attr-uuid":_vm.arrayUuid[ind],"attr-type":_vm.arrType[ind]}},[_vm._v(_vm._s(_vm.arrayName[ind]))])])}),_vm._v(" "),_c('div',{staticClass:"load-link",attrs:{"id":"videoContainer"},on:{"click":_vm.upload}},[_c('div',{staticClass:"pic-b"})])],2),_vm._v(" "),(this.UpFile.tip)?_c('p',{ref:"p_info",staticClass:"et-load-info et-video-info",class:_vm.classObj,staticStyle:{"margin-top":"10px","font-size":"14px"},on:{"click":_vm.allTetx}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n        "+_vm._s(_vm.upfileTip)+"\n      ")]):_c('p',{staticClass:"et-load-info et-video-info",staticStyle:{"margin-top":"10px","font-size":"14px"},on:{"click":_vm.allTetx}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n        支持MPG、MPEG、AVI、MP4、3GP、RM、RMVB、MOV、FLV、ASF格式，且文件大小不超过10gb。\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.4)"},attrs:{"id":"uploadAlet","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"top":"0"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticStyle:{"text-align":"center","margin-bottom":"30px","font-size":"16px"}},[_vm._v("\n            选择文件类型 "),_c('span',{staticStyle:{"float":"right"},on:{"click":_vm.uploadAlet}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"4.5rem"},attrs:{"id":"uploadAll"}},[_c('div',{staticClass:"uploadDiv active",attrs:{"attr-type":"1"},on:{"click":function($event){_vm.uploadDiv(1)}}},[_c('div',{staticClass:"pic-p"},[_c('p',{staticClass:"pin-video"},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/up-video.png',"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"uploadDiv",attrs:{"attr-type":"2"},on:{"click":function($event){_vm.uploadDiv(2)}}},[_c('div',{staticClass:"pic-p"},[_c('p',{staticClass:"pin-img"},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/up-Provinces.png',"alt":""}})])])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","font-size":"14px"}},[(this.UpFile.tip)?_c('p',{staticClass:"et-load-info et-video-info",on:{"click":_vm.allTetx}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n              "+_vm._s(this.UpFile.tip)+"\n            ")]):_c('p',{staticClass:"et-load-info et-video-info",on:{"click":_vm.allTetx}},[_c('span',[_vm._v("[要求]")]),_vm._v("\n              支持MPG、MPEG、AVI、MP4、3GP、RM、RMVB、MOV、FLV、ASF格式，且文件大小不超过10gb。\n            ")])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.4)"},attrs:{"id":"uploadModal","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"top":"0"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('a',{staticClass:"btn-2 buttonW buttonR",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.cancel4()}}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start btn-pl-start1 buttonW buttonL",attrs:{"href":"javascript:void(0);"}},[_vm._v("开始上传")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"uploadFile","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"0"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body",attrs:{"id":"modal-body"}},[_c('ul',{staticClass:"uploadFile-ul clearfix",attrs:{"id":"uploadFile-ul"}},_vm._l((_vm.allchannel),function(item,v){return _c('li',[_c('dl',[_c('dt',{staticClass:"pic-box"},[_c('img',{staticStyle:{"border":"none"},attrs:{"src":item.video.thumb_url,"alt":""}})]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(item.video.title))])])])})),_vm._v(" "),(_vm.scrill)?_c('div',{staticClass:"content index-content",staticStyle:{"padding-top":"0"}},[_vm._m(4)]):_vm._e()])])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scan.isScan),expression:"scan.isScan"}],staticClass:"scan-mask",on:{"click":_vm.closeScan}},[_c('div',{staticClass:"scan-box"},[_c('img',{attrs:{"src":_vm.scan.url}}),_c('span')])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-inner modal-upload",staticStyle:{"margin-top":"10px"}},[_c('a',{staticClass:"btn-pl-start btn-pl-start1",attrs:{"href":"javascript:void(0);"}},[_vm._v("\n              选择文件\n            ")]),_vm._v(" "),_c('input',{staticClass:"upload-input",attrs:{"type":"file","id":"upload_input"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("名称"),_c('span',[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('input',{attrs:{"id":"Textvideo","type":"text","placeholder":"请输入名称","maxlength":"20"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("描述")]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('textarea',{attrs:{"id":"Textareavideo","rows":"3","placeholder":"请输入描述信息,100字以内","maxlength":"100"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-head"},[_vm._v("\n          我的视频\n          "),_c('span',{attrs:{"data-dismiss":"modal"}},[_vm._v("X")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.4)"},attrs:{"id":"uploadVideo-al","data-backdrop":"static","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"detailAlert-p Prompt-p"},[_vm._v("上传格式错误")]),_vm._v(" "),_c('a',{staticClass:"buttonZ",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("确定")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "djmg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dpmo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"et-tabox"},[_c('div',{staticClass:"et-noticebox"},[(_vm.detailsTxte1.length == 0)?_c('dl',[_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.detailsTxte1),function(item){return _c('dl',[_c('dt',{staticClass:"et-notice-link",staticStyle:{"padding-right":"25px"}},[_c('p',[_vm._v(_vm._s(item.order)+". "+_vm._s(item.title)),_c('i',{staticClass:"icon-r"})])]),_vm._v(" "),_c('dd',{staticStyle:{"display":"none"}},[_c('p',{domProps:{"innerHTML":_vm._s(item.text)}})])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dt',{staticClass:"et-notice-link",staticStyle:{"padding-right":"25px"}},[_c('p',[_vm._v("1. 活动要求与规则"),_c('i',{staticClass:"icon-r"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dd',{staticStyle:{"display":"none"}},[_c('p',[_vm._v("\n          请务必如实填写您的真实信息，以便活动发起方能够及时的与您取得联系。（保密承诺：您的信息将会被保密，请您放心填写。）\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e6YN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-file"},[_c('div',[_c('div',{staticClass:"file-title clearfix"},[_c('div',{staticClass:"title-left",on:{"click":_vm.fn}},[_c('a',{staticClass:"icon-back",staticStyle:{"z-index":"9999"},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.fn}})]),_vm._v(" "),_c('div',{staticClass:"title-right"},[(_vm.item)?_c('span',[(_vm.item.user)?_c('img',{attrs:{"src":_vm.item.user.face_url,"alt":""}}):_vm._e(),_vm._v("\n        "+_vm._s(_vm._f("ellipsis")(_vm.item.nickname,8))+"\n       ")]):_vm._e()])]),_vm._v(" "),(_vm.item)?_c('div',{staticClass:"preview-conten preview-contenNext show-box",attrs:{"id":"videoName"}},[(_vm.item.image_url)?_c('div',{staticStyle:{"width":"100%","height":"auto"},attrs:{"id":"myImg"}},[_c('img',{attrs:{"src":_vm.item.image_url,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.item.time_span)?_c('div',{staticClass:"video_left",attrs:{"id":"myFlash"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-text show-v-box"},[_c('p',{staticClass:"file-browse"},[_c('span',[_vm._v(_vm._s(_vm.visitNum)+" 浏览")]),_vm._v(" "),_c('span',{staticClass:"gap-line"},[_vm._v(" | ")]),_vm._v(" "),(_vm.item.upload_time)?_c('i',[_vm._v(_vm._s(_vm._f("datetime")(_vm.item.upload_time))+" 上传")]):_c('i',[_vm._v(_vm._s(_vm._f("datetime")(_vm.item.upload_datetime))+" 上传")]),_vm._v(" "),_c('span',{staticClass:"btn-copy toCopy",on:{"click":_vm.copyUrl}},[_vm._v("复制地址")])]),_vm._v(" "),_c('h4',{staticClass:"file-tle"},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('p',{staticClass:"preview-p"},[_c('span',{staticClass:"preview-span"},[_vm._v(_vm._s(_vm.item.description))])]),_vm._v(" "),_c('p',{staticClass:"show-v-more",on:{"click":_vm.showVmore}},[_c('i',{staticClass:"icon-vs-show"})]),_vm._v(" "),_c('div',{staticClass:"file-div"},[(_vm.activeName)?_c('p',{staticClass:"icon-title"},[_c('router-link',{staticClass:"icon-title",attrs:{"to":'/detail/' + _vm.activeId,"tag":"p"}},[_vm._v("     参与了【"+_vm._s(_vm.activeName)+"】\n            ")])],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"icon-ps"},[_c('i',{staticClass:"file-like"}),_c('span',{staticClass:"number numberName"},[_vm._v(_vm._s(_vm.favoriteNum))]),_vm._v(" 人喜欢")])])])]):_c('div',{staticClass:"yaVideo"},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"content detail-content",staticStyle:{"margin-bottom":"60px"}},[_c('div',{staticClass:"dl-message",staticStyle:{"padding":"0 10px","background":"none"}},[_c('div',{staticClass:"dl-ms-link"},[_vm._l((_vm.leavingName),function(item,ind){return (_vm.leavingName)?_c('div',{staticClass:"dl-ms",staticStyle:{"border-top":"1px solid #ccc","padding-top":"10px"}},[_c('div',{staticClass:"dl-ms-head"},[_c('div',{staticClass:"dl-head-pic"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"dl-head-name"},[_vm._v("\n                "+_vm._s(item.author)),_c('span',[_vm._v("["+_vm._s(item.locale)+"]")])]),_vm._v(" "),_c('div',{staticClass:"dl-head-like"},[_vm._m(1,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.agree))])])]),_vm._v(" "),_c('div',{staticClass:"dl-ms-chat"},[_c('div',{staticClass:"dl-ms-tit"},[_vm._v("\n                "+_vm._s(item.message)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"dl-time"},[_vm._v(_vm._s(_vm._f("timeToMillion")(new Date().getTime()/1000 - item.dateline)))])]):_vm._e()}),_vm._v(" "),(_vm.item)?_c('p',{staticClass:"dl-ms-more",on:{"click":_vm.More}},[_vm._v("查看更多留言")]):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"dl-ms-title dl-video-title",staticStyle:{"display":"none"}},[_c('i',{staticClass:"icon-message icon-messages"},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/video-file.png',"alt":""}})]),_vm._v(" "),_c('span',{staticClass:"textarea"},[_vm._v("最多可输入120字")])]),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"detailAlert","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"detailAlert-p",staticStyle:{"text-align":"center","padding-top":"30px","height":"80px","font-size":"18px"}},[_vm._v("请先登录账号 ")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"buttonW buttonL",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.determine}},[_vm._v("确定")]),_vm._v(" "),_c('a',{staticClass:"buttonW buttonR",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("取消")])])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"heart-shaped"},[_c('img',{attrs:{"src":_vm.globalUrl + 'static/dist/img/zhan.png',"alt":""}})]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"modal-confim large-info-modal modal fade",attrs:{"id":"login_Alert","role":"dialog","aria-hidden":"true","attr-type":"load"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"margin-top":"0","width":"100%","height":"100%"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"left":"-1%","top":"-1%","width":"102%","height":"102%"}},[_c('div',{staticClass:"modal-body"},[_c('LoginAler')],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content index-content"},[_c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-like"},[_c('em',[_vm._v("+1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"discoverAlert","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"detailAlert-p",staticStyle:{"text-align":"center","padding-top":"30px","height":"80px","font-size":"18px"}},[_vm._v("该文件无法点赞")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"buttonZ",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("确定")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"samll-info-modal modal fade",staticStyle:{"background":"rgba(0,0,0,.5)"},attrs:{"id":"chatModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('i',{staticClass:"icon-modal"}),_vm._v(" "),_c('p',{staticClass:"info-mess",staticStyle:{"z-index":"999"}},[_vm._v("留言发布成功啦！")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-messagebox",staticStyle:{"position":"fixed"}},[_c('div',{staticClass:"detail-messbox-inner"},[_c('h5',[_vm._v("我有话说")]),_vm._v(" "),_c('div',{staticClass:"dl-ms-btn"}),_vm._v(" "),_c('div',{staticClass:"dl-ms-wrap"},[_c('div',{staticClass:"dl-ms-inner"},[_c('textarea',{attrs:{"id":"saytext","rows":"6","placeholder":"最多可输入120字","maxlength":"120"}})])]),_vm._v(" "),_c('a',{staticClass:"btn-detail-edit",attrs:{"href":"javascript:void(0);"}},[_vm._v("\n        完  成\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"samll-info-modal modal fade",attrs:{"id":"chatModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('i',{staticClass:"icon-modal"}),_vm._v(" "),_c('p',{staticClass:"info-mess"},[_vm._v("留言发布成功啦！")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e8Pc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: '',
      bestWorks: null,
      imgList: [],
      total: '',
      page: 1,
      nickname: '',
      title: '',
      description: '',
      init: 0,
      current: 1,
      currentName: ''
    };
  },

  methods: {
    //操作按钮事件
    detail: function detail() {
      this.$router.push({ name: 'Detail', params: { id: this.id } });
    }
  },

  created: function created() {

    this.id = this.$route.params.id;
    this.init = this.$route.params.init || 0;
    var that = this;
    $('.wrap').css('background', '#e8e8e8');
    if (this.init > 0) {
      var currentPage = Math.ceil(this.init / 10);
      that.bestWorks = {
        type: 2,
        activity_id: that.id,
        page: currentPage,
        pagesize: 10
      };
      that.page = currentPage;
      that.currentName = (currentPage - 1) * 10;
    } else {
      that.bestWorks = {
        type: 2,
        activity_id: that.id,
        page: that.page,
        pagesize: 10,
        version: 2
      };
    }

    that.$http.get(API.GetActivitieById, { params: { id: that.id } }).then(function (res) {
      //微信分享
      var metas = $('head').children('meta');
      var desc = '',
          img = res.data.playbill.playbill;
      if (res.data.description) {
        desc = res.data.description;
      } else {
        desc = metas[1].content;
      }
      var dataName = {
        title: res.data.title, //分享标题
        desc: desc, //分享简介(内容)
        imgAddress: img, //分享图片地址
        Retain: '', //保留
        url: window.location.href //点击分享结果跳转的地址(默认情况为分享页面当前地址)
      };
      //console.log(dataName)
      that.weixinShare(dataName);
    });
    that.$watch(function () {
      //console.log(that.bestWorks)
      that.$http.get(API.FileRelatedVideo, { params: that.bestWorks }).then(function (res) {
        //  console.log(res)
        var _data = res.data;
        if (res.code == 0) {
          that.total = res.total;
          that.imgList = that.imgList.concat(_data);

          // for(var i=0;i<_data.length;i++){
          //     that.imgList.push(_data[i])
          // }
        }
        that.$nextTick(function () {

          if (that.init == 1) {
            if (that.imgList[that.init - 1].height > that.imgList[that.init - 1].width) {
              var Pw = that.imgList[that.init - 1].width / $('.Exhibition').width();
              var H = that.imgList[that.init - 1].height / Pw;
              $('.imgList .Exhibition').find('.swiper-img').eq(that.init - 1).css('height', H);
            } else {
              $('.imgList .Exhibition').find('.swiper-img').eq(that.init - 1).css('height', 'auto');
            }
          }
          var swiperPic = new Swiper('.swiper-pic', {
            initialSlide: that.init - 1,
            onSlideChangeEnd: function onSlideChangeEnd(swiper) {
              that.current = swiper.activeIndex + 1;
              var index = swiper.activeIndex;
              var len = that.imgList.length - 1;
              if (that.imgList[index].height > that.imgList[index].width) {
                var Pw = that.imgList[index].width / $('.Exhibition').width();
                var H = that.imgList[index].height / Pw;
                $('.imgList .Exhibition').find('.swiper-img').eq(index).css('height', H);
              } else {
                $('.imgList .Exhibition').find('.swiper-img').eq(index).css('height', 'auto');
              }
              var dome = $('.imgList .Exhibition').find('.swiper-img').eq(index + 1).attr('src');
              that.init = index + 1;
              if (that.total != len + 1 && index + 1 >= len) {
                that.bestWorks = {
                  type: 2,
                  activity_id: that.id,
                  page: ++that.page,
                  pagesize: 10
                };
              }
            }
          });
        });
      });
    });
  },
  mounted: function mounted() {
    //操作DOM
    /*    $('ul').css('transform','translate3d(0px,0,0)');
        var t = 'translate3d(50px, 0px, 0px)';
        var m = 0;*/

  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "fHf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageUpload_vue__ = __webpack_require__("btoy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebd7a2b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageUpload_vue__ = __webpack_require__("Rwq8");
function injectStyle (ssrContext) {
  __webpack_require__("h/+S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ebd7a2b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebd7a2b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fyAu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g409":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ggkq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voteList_vue__ = __webpack_require__("PmP/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac54ad7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voteList_vue__ = __webpack_require__("QBsP");
function injectStyle (ssrContext) {
  __webpack_require__("H52a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac54ad7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voteList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac54ad7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voteList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gqHj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkage_vue__ = __webpack_require__("SaI2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5fa17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkage_vue__ = __webpack_require__("Guh9");
function injectStyle (ssrContext) {
  __webpack_require__("+W+0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5fa17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h/+S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h3cB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userId', 'initUtil'],
  data: function data() {
    return {
      MyFollow: [],
      id: '',
      ind: '',
      busy: false,
      page: 0
    };
  },

  methods: {
    // 操作按钮事件
    // 取消关注
    editcComplete: function editcComplete() {
      // 取消关注
      var that = this;
      var delFollo = {
        user_id: that.userId, // 账户id
        item_id: that.id, // 活动id
        type: 0
      };
      // console.log(delFollo)
      this.$http.get(API.DelActivityFollow, { params: delFollo }).then(function (res) {
        // console.log(res);
        if (res.code == 0) {
          $('#editModal').modal('hide');
          $('.ay-title-time').eq(that.ind).parents('.ay-cor').remove();
        }
      });
    },

    //加载更多
    loadMore: function loadMore() {
      var _this = this;

      this.busy = true;
      // 多次加载数据
      setTimeout(function () {
        _this.page++;
        _this.ajaxMore(true);
      }, 500);
    },
    ajaxMore: function ajaxMore(flag) {
      var that = this;
      this.$http.get(API.GetActivitieFollowByUserid, { params: { page: that.page, pagesize: 10 } }).then(function (res) {
        //console.log(res)
        if (res.code == 0) {
          if (flag) {
            for (var i = 0; i < res.data.length; i++) {
              that.MyFollow.push(res.data[i]);
            }
            if (res.data.length === 0 || that.MyFollow.length === res.total) {
              that.busy = true;
            } else {
              that.busy = false;
            }
          }
          if (res.total == 0) {
            $('.foll_div').html('您还没有关注活动！');
          }
        }
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = true;
    next();
  },

  created: function created() {
    $('.icon-back').removeClass('pointerEve');
  },
  mounted: function mounted() {
    // 操作DOM
    $('.icon-back').show();
    var that = this;
    this.initUtil.stopBodyScroll(false);
    $('.follow').on('click', '.btn-ay-red', function () {
      //console.log(1)
      that.ind = $(this).parents('.foll').index();
      that.id = $(this).attr('attr-id');
      // console.log(that.id,that.ind)
      $('#editModal').modal('show');
    });

    $('.nav').children('.id-nav-recom').eq(1).addClass('nav-on').siblings().removeClass('nav-on');
    $('.nav').find('.id-nav-recom').eq(1).addClass('router-link-exact-active').siblings().removeClass('router-link-exact-active');

    // 微信分享
    var metas = $('head').children('meta');
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "hCSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      relatedVideo: [],
      relatedVideoL: [],
      relatedVideoR: [],
      FileRelatedVideo: null,
      id: '',
      page: 0,
      limit: 10,
      total: '',
      scrill: true,
      category: false,
      is_recommend: 0,
      // len: 10,
      fileItem: null,
      tops: '0',
      data: '',
      busy: false,
      noMore: false,
      leave: false,
      LH: 0,
      RH: 0,
      LW: 0
    };
  },

  computed: {
    finite: function finite() {
      return this.busy || this.noMore || this.leave;
    }
  },
  methods: {
    //操作按钮事件
    detail: function detail() {
      this.$router.push({ name: 'Detail', params: { id: this.id } });
    },
    water: function water(item) {
      // this.data = new Date()
      if (item.file_type == 'video') {
        this.$router.push({ name: 'VideoName', params: { id: item.activity_mini.id, uuid: item.file.uuid, type: 'video' } });
      } else {
        this.$router.push({ name: 'VideoName', params: { id: item.activity_mini.id, uuid: item.file.uuid, type: 'image' } });
      }
    },
    form: function form(type) {
      var that = this;
      if (type == 0) {
        // that.len = that.limit;
        that.category = false;
      } else {
        // that.len = that.limit;
        that.category = true;
      }
      that.is_recommend = type;
      that.page = 0;
      that.relatedVideo = [];
      that.relatedVideoL = [];
      that.relatedVideoR = [];
      that.noMore = false;
      var FileRelatedVideo = {
        type: '1',
        activity_id: that.id,
        limit: that.limit,
        page: that.page,
        is_recommend: that.is_recommend
      };
      that.loadMore(FileRelatedVideo);
    },
    fetchData: function fetchData(fileRelated) {
      var that = this;
      // that.len = that.len/1+10;
      if (fileRelated) {
        that.FileRelatedVideo = fileRelated;
      } else {
        that.FileRelatedVideo = {
          type: 1,
          activity_id: that.id,
          pagesize: that.limit,
          page: that.page,
          is_recommend: that.is_recommend
        };
      }

      that.$http.get(API.FileRelatedVideo, { params: that.FileRelatedVideo }).then(function (res) {
        if (res.code == 0) {
          var _data = res.data;
          that.total = res.total;

          that.loadImg(res);
        }
      });
    },
    loadImg: function loadImg(res) {
      var that = this;
      var data = res.data;
      var total = res.total;
      var idx = 0;
      var NH,
          NW,
          CH,
          OH = 100;
      var img = new Image();
      function loadNext(idx) {
        if (idx >= data.length) {
          that.busy = false;
          if (that.relatedVideo.length >= total) {
            that.noMore = true;
          }
          return;
        }

        img.src = data[idx].file.thumb_url + '?p=3&o=2&w=350&h=197';
        img.onload = img.onerror = function () {
          // console.log(img.naturalHeight,img.naturalWidth,'img');
          NW = img.naturalWidth;
          NH = img.naturalHeight;
          CH = NH / NW * that.LW || OH;
          if (that.getMinUl()) {
            that.relatedVideoL.push(data[idx]);
            that.LH += CH;
          } else {
            that.relatedVideoR.push(data[idx]);
            that.RH += CH;
          }
          that.relatedVideo.push(data[idx]);
          idx++;
          loadNext(idx);
        };
      }
      loadNext(idx);
    },
    loadMore: function loadMore(FileRelatedVideo) {
      if (this.busy == false) {
        // setTimeout(() => {
        this.busy = true;
        this.page++;
        this.fetchData(FileRelatedVideo);
        // }, 500)
      }
    },
    getMinUl: function getMinUl() {
      //每次获取最短的ul,将图片放到其后

      // var L = this.$refs.listL;
      // var R = this.$refs.listR;
      // var LH = L.offsetHeight;
      // var RH = R.offsetHeight;
      // console.log(this.LH, this.RH)
      // return LH <= RH ? true : false;
      return this.LH <= this.RH ? true : false;
    }
  },

  created: function created() {
    this.id = this.$route.params.id;
    this.route = this.$route.params.route;
    var that = this;
    that.$http.get(API.GetActivitieById, { params: { id: that.id } }).then(function (res) {
      //console.log(res)
      var metas = $('head').children('meta');
      //document.title = res.data.title || '上电视/视频播放';
      // console.log(document.title)
      var desc = '',
          img = res.data.playbill.playbill;
      if (res.data.description) {
        desc = res.data.description;
      } else {
        desc = metas[1].content;
      }
      //console.log(img)
      var dataName = {
        title: res.data.title, //分享标题
        desc: desc, //metas[1].content,//分享简介(内容)
        imgAddress: img, //分享图片地址
        Retain: '', //保留
        url: window.location.href //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
      };
      //console.log(dataName)
      that.weixinShare(dataName);
    });
  },
  mounted: function mounted() {
    //操作DOM
    var that = this;

    this.LW = this.$refs.listL.offsetWidth;
  },
  activated: function activated() {
    this.leave = false;
  },
  deactivated: function deactivated() {
    this.leave = true;
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "hG2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loginAler_vue__ = __webpack_require__("bckt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['fileItem', 'data', 'tops'],
  data: function data() {
    return {
      item: '',
      activeId: '',
      activeName: '',
      leavingName: [],
      showVmoreName: false,
      uuid: '',
      pageName: 1,
      total: 0,
      userId: '',
      nickname: '',
      uuidPlace: '',
      num: '',
      visitNum: '',
      favoriteNum: '',
      type: '',
      fileId: '',
      globalUrl: API.GlobalUrl
    };
  },

  methods: {
    //操作按钮事件
    fn: function fn() {
      $('.preview-file').removeClass('preview-active');
      $('.dl-video-title').hide();
      $(document).unbind("scroll");
      $("#myFlash").html('');
    },
    determine: function determine() {
      $('#detailAlert').modal('hide');
      //this.$router.push({name: 'login_Quick'})
      $('#login_Alert').modal('show');
    },
    showVmore: function showVmore() {
      this.showVmoreName = !this.showVmoreName;
      if (this.showVmoreName) {
        $('.preview-p').css({ 'height': 'auto' });
        $('.show-v-more').css({ 'transform': 'rotate(180deg)' });
      } else {
        $('.preview-p').css({ 'height': '40px' });
        $('.show-v-more').css({ 'transform': 'rotate(0deg)' });
      }
    },
    More: function More() {
      var pageName = ++this.page;
      this.MoreFn(pageName);
    },
    MoreFn: function MoreFn(pageName) {
      var that = this;
      //评论渲染
      $('.dl-message').show();
      //留言
      var Leaving = {
        app: 'xiyou',
        itemid: 'ishow_' + that.uuidPlace,
        itemtype: '0',
        prepage: 10,
        avatar: 1,
        page: pageName
      };
      // console.log(Leaving)
      //xiyou
      $.getJSON('http://common.newcomment.cntv.cn/data/list?jsonp_callback=?', Leaving, function (res) {
        if (res.code == 0) {
          for (var m = 0; m < res.data.content.length; m++) {
            that.leavingName.push(res.data.content[m]);
            var pid = res.data.content[m].pid;
            var tip = res.data.content[m].tip;
            //回复列表
          }
        }
        //console.log(that.leavingName)
        that.total = res.data.total;
        if (res.data.total < 10 || that.leavingName.length == res.data.total) {
          $('.dl-ms-more').hide();
        }
      });
    },
    like: function like() {
      //点赞-喜欢
      var that = this;
      if (that.type == 'no') {
        $('#discoverAlert').modal('show');
        return false;
      }
      //console.log(that.item.uuid)
      if (that.uuid != '') {
        if ($('.link-Whether').hasClass('active')) {
          var videoFavorite = {
            file_id: that.uuid,
            op: 0
          };
          that.$http.get(API.VideoFavorite, { params: videoFavorite }).then(function (res) {
            $('.link-Whether').removeClass('active');
            $('.numberName').html(parseInt($('.numberName').text()) - 1);
          });
          return false;
        } else {
          var that = this;
          var videoFavorite = {
            file_id: that.uuid,
            op: 1
          };
          that.$http.get(API.VideoFavorite, { params: videoFavorite }).then(function (res) {
            //console.log(res)
            that.linkFn(res);
          });
        }
      } else {
        if ($('.link-Whether').hasClass('active')) {
          var videoFavorite = {
            file_id: that.fileId,
            op: 0
          };
          that.$http.get(API.ImageFavorite, { params: videoFavorite }).then(function (res) {
            $('.link-Whether').removeClass('active');
            $('.numberName').html(parseInt($('.numberName').text()) - 1);
          });
          return false;
        } else {
          var that = this;
          var videoFavorite = {
            file_id: that.fileId,
            op: 1
          };
          that.$http.get(API.ImageFavorite, { params: videoFavorite }).then(function (res) {
            //console.log(res)
            that.linkFn(res);
          });
        }
      }
    },
    linkFn: function linkFn(res) {
      var that = this;
      if (res.code == 0) {
        that.num = res.data.num;
        //动画
        $('.numberName').html(parseInt($('.numberName').text()) + 1);
        $('.link-Whether').addClass('active');
        $('.heart-shaped').show();
        $('.heart-shaped').addClass('heart-active');
        setTimeout(function () {
          $('.heart-shaped').addClass('heart-activex');
        }, 150);
        setTimeout(function () {
          $('.heart-shaped').removeClass('heart-activex');
          $('.heart-shaped').addClass('heart-active');
        }, 300);
        setTimeout(function () {
          $('.heart-shaped').removeClass('heart-active');
        }, 450);
        setTimeout(function () {
          $('.heart-shaped').fadeOut();
        }, 800);
      } else {
        $('#discoverAlert').modal('show');
      }
    },
    copyUrl: function copyUrl() {
      var origin = location.origin;
      var actId = this.fileItem.activity_id || 'actid';
      var file_id = this.fileItem.file_id;
      var url = origin + '/h5/videoName/' + actId + '/' + file_id + '/video';
      var clipboard = new ClipboardJS('.toCopy', {
        text: function text(trigger) {
          return url;
        }
      });
      clipboard.on('success', function () {
        $('#chatModal .info-mess').html('复制成功啦！');
        $('#chatModal').modal('show');
        setTimeout(function () {
          $('#chatModal').modal('hide');
          clipboard.destroy();
        }, 2000);
      });
    }
  },
  components: { //渲染页面
    LoginAler: __WEBPACK_IMPORTED_MODULE_0__loginAler_vue__["a" /* default */]
  },
  created: function created() {
    var that = this;

    that.$watch('data', function () {
      $("#loading").show();
      $('.link-Whether').removeClass('active');
      that.item = '';
      that.leavingName = [];
      that.uuid = '';
      that.fileId = '';
      that.activeId = '';
      that.activeName = '';
      if (that.fileItem.file_type == 'video') {
        that.uuid = that.fileItem.file_id || '';
      } else {
        that.fileId = that.fileItem.file_id || '';
      }
      that.activeId = that.fileItem.activity_id;
      that.activeName = that.fileItem.activity_mini.title || '';

      var getVideoInfo = '',
          APIName = '';
      if (that.uuid == '') {
        //图片
        getVideoInfo = {
          file_id: that.fileId,
          version: 2
        };
        APIName = API.GetImageInfo;
      } else {
        //视频
        getVideoInfo = {
          file_id: that.uuid,
          version: 2
        };
        APIName = API.GetVideoInfo;
      }
      that.userId = that.getCookie('userSeqId');
      // console.log(that.userId);
      that.$http.get(APIName, { params: getVideoInfo }).then(function (res) {
        $('.detail-content').hide();
        //console.log(res);
        if (res.code == 0) {
          that.item = res.data;
          that.visitNum = res.data.visit_num; //浏览
          that.favoriteNum = res.data.favorite_num; //点赞喜欢
          that.type = 'yes';
          $('.icon-ps').show();
          that.nickname = that.item.nickname; //用户名
          var dataName = '';
          if (that.uuid != '') {
            var len = $('.video_left').length;
            var W = document.documentElement.clientWidth; //播放窗口宽度
            var H = Math.ceil(document.documentElement.clientWidth / 1.78); //播放窗口高度
            that.VideoPlay(that.uuid, W, H, 'myFlash');
            that.uuidPlace = that.uuid.replace(/-/g, '_');
          } else {
            that.uuidPlace = that.fileId.replace(/-/g, '_');
            $('#myImg').html('<img src="' + that.item.image_url + '" alt=""/>');
          }
          that.$nextTick(function () {
            if (!that.item.user) {
              $('.title-right').children('span').css('padding', '8px 10px 8px 8px');
            }
            $("#loading").hide();
          });
        } else {
          that.type = 'no';
          $('.icon-ps').hide();
          $(".dl-ms-more").hide();
          $("#loading").hide();
          $('.yaVideo').html('呀！作品找不到了！');
          return false;
        }
        setTimeout(function () {
          //获取视频信息，预览
          if (that.item && that.uuidPlace) {
            that.MoreFn(1);
          }
          if ($('.preview-p').height() > 40) {
            $('.preview-p').css({ 'height': '40px' });
            $('.show-v-more').show();
          } else {
            $('.show-v-more').hide();
          }

          //关闭留言框面板
          $('.dl-ms-btn').on('click', function () {
            $('#saytext').val('');
            $('#myFlash').show();
            $('.detail-messagebox').css({ 'top': '120%' });
          });

          //打开留言面板
          // dl-ms-edit
          $('.dl-ms-title').on('click', function () {
            if (that.userId) {
              $('#saytext').val('');
              $('.detail-messagebox').css({ 'top': '0' });
              $('#myFlash').hide();
            } else {
              $('#login_Alert').modal('show');
              // that.$router.push({name: 'login_Quick'});
              return false;
            }
          });
          //查看结果留言表情
          function replace_em(str) {
            str = str.replace(/\</g, '&lt;');
            str = str.replace(/\>/g, '&gt;');
            str = str.replace(/\n/g, '<br/>');
            str = str.replace(/\[em_([0-9]*)\]/g, '<img src="../../static/dist/arclist/1.gif" border="0" />');
            return str;
          }

          var intervaLock;
          /*发布留言*/
          $('.btn-detail-edit').on('click', function () {
            if ($('#saytext').val() != '') {
              var Leaving = {
                app: 'xiyou',
                itemid: 'ishow_' + that.uuidPlace,
                authorid: that.userId,
                author: that.nickname,
                message: $('#saytext').val()
              };
              //console.log(Leaving)
              $.ajax({
                type: 'post',
                url: 'http://newcomment.cctv.com/comment/post',
                data: Leaving,
                dataType: 'jsonp',
                xhrFields: {
                  withCredentials: true
                },
                crossDomain: true,
                jsonp: 'jsonp_callback',
                success: function success(res) {
                  if (res.code == 0) {
                    //prepend
                    $('#myFlash').show();
                    $('.detail-messagebox').css({ 'top': '120%' });
                    $('#chatModal .info-mess').html('留言发布成功啦');
                    $('#chatModal').modal('show');
                    intervaLock = setTimeout(function () {
                      $('#chatModal').modal('hide');
                    }, 2000);
                  } else if (res.code == '20927') {
                    var userSeqId = that.getCookie('userSeqId');
                    var url = 'http://reg.cctv.com/authenicateAction/mobile/bind.html?service=https://act.ishow.cctv.com/h5/discovery&iid=' + that.activeId + '&formFlag=3&userSeqId=' + userSeqId + '&flag=H5';
                    window.location.href = url;
                  }
                },
                error: function error() {
                  alert('请求出错！');
                }
              });
              //  console.log(Leaving)
            }
          });
          $(document).bind("scroll", function () {

            $(document).scrollTop(that.tops);
          });
        }, 200);
      });
    });
  },
  mounted: function mounted() {
    //操作DOM
    var that = this;
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "hL7r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hdzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imgList_vue__ = __webpack_require__("e8Pc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779ea042_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imgList_vue__ = __webpack_require__("E5lx");
function injectStyle (ssrContext) {
  __webpack_require__("iNif")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imgList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779ea042_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imgList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "he/v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "he5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UploadToken_upload_vue__ = __webpack_require__("dPOJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadToken_FileUpload_vue__ = __webpack_require__("2cs+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadToken_VideoUpload_vue__ = __webpack_require__("j/bE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UploadToken_imageUpload_vue__ = __webpack_require__("fHf5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_linkage_vue__ = __webpack_require__("gqHj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__template_selectmul_vue__ = __webpack_require__("Lshr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import Cascader from '../template/cascader.vue'


/* harmony default export */ __webpack_exports__["a"] = ({
  props: [
  // 'id',
  // 'form_id',
  'countArr', 'userId'],
  data: function data() {
    return {
      id: '',
      form_id: '',
      RegistrationForm: '',
      region: '',
      UpFile: null, //上传需求
      appId: 'mp0qftl9iu',
      thirdParty: true,
      globalUrl: API.GlobalUrl,
      loading: false,
      modalTit: '信息已提交，感谢您的参与！',
      detailsTxte: '',
      audit_level: 2,
      casVal: {},
      noEdit: false,
      doEdit: '修改完成'

    };
  },

  methods: {
    //操作按钮事件'
    shareHide: function shareHide() {
      $('.shart').hide();
    },
    share: function share() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (isWeixin) {
        $('.shart').show();
      }
    },
    myActivity: function myActivity() {
      //继续参与
      var that = this;
      $('#entryModal').modal('hide');
      // $('.entry-content').hide();
      // this.$router.replace({name: 'myActivity_MyParticipate', params: {id: that.id}})
      this.$router.replace({ name: 'Detail', params: { id: that.id } });
    },
    myActivitys: function myActivitys() {
      //查看
      var that = this;
      $('#entryModal').modal('hide');
      this.$router.replace({ name: 'myActivity_MyParticipate', params: { id: 0 } });
      // window.location.reload();
    },
    CloseUpload: function CloseUpload() {
      $('#processModal').modal('hide');
    },
    listenToMyBoy: function listenToMyBoy(somedata) {
      this.region = somedata;
    },
    delmodify: function delmodify() {
      var id = this.$route.params.id;
      if (id && id > 0) {
        // this.$router.replace({name: 'Detail', params: {id: id}});
        this.$router.go(-1);
      } else {
        this.$router.replace({ name: 'myActivity_MyParticipate', params: { id: 0 } });
        location.reload();
      }
    },
    sexOn: function sexOn(ind, val, item) {
      // radio 选中
      $('.' + item).eq(ind).parent().siblings().children('.' + item).removeClass('radio-on');
      $('.' + item).eq(ind).parents('li').siblings().find('.' + item).removeClass('radio-on');
      $('.' + item).eq(ind).addClass('radio-on');
    },
    Determine: function Determine() {
      this.$router.replace({ name: 'myActivity_MyParticipate', params: { id: 0 } });
      location.reload();
    },
    SmallKeyup: function SmallKeyup(event, ruleType) {
      if (ruleType != '' && ruleType) {
        var itself = event.target,
            val = $(itself).val(),
            itselfs = '//' + ruleType + '//',
            re = itselfs.replace(/\/\//g, "\/"),
            reg = eval(re);
        if (!reg.test(val)) {
          $(itself).next().show();
          $('.et-complete').css('pointer-events', 'none');
          return false;
        } else {
          $(itself).next().hide();
          $('.et-complete').css('pointer-events', 'visible');
        }
      }
    },
    complete: function complete() {
      //完成参与
      var that = this;
      if (that.loading || that.noEdit) {
        return;
      } //信息提交中
      var file_id = {},
          fileName = $('.load-inner').find('.fileName'),
          that = this,
          content = {};
      //text文本
      var Text = $('.et-typeText');
      for (var t = 0; t < Text.length; t++) {
        //查找每一项
        var TextName = Text.eq(t).find('input');
        //判断是否必填
        if (TextName.attr('is_require') == 1) {
          if (TextName.val() == '') {
            TextName.focus();
            return false;
          }
          if (TextName.attr('name') == 'email') {
            var email = TextName.val();
            var reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
            if (reg.test(email)) {} else {
              TextName.focus();
              return false;
            }
          }
        }
        content[TextName.attr('name')] = TextName.val();
      }
      //多行文本
      var Textarea = $('.et-trbox');
      for (var te = 0; te < Textarea.length; te++) {
        //查找每一项
        var TextareaName = Textarea.eq(te).find('textarea');
        //判断是否为必填
        if (TextareaName.attr('is_require') == 1) {
          if (TextareaName.val() == '') {
            TextareaName.focus();
            return false;
          }
        }
        content[TextareaName.attr('name')] = TextareaName.val();
      }
      //单选
      var radio = $('.et-radiolink');
      for (var r = 0; r < radio.length; r++) {
        //查找每一项
        var radioName = radio.eq(r).find('.radio-on');
        //判断是否为必填
        if (radio.eq(r).find('.radio-box').attr('is_require') == 1) {
          if (radioName.length == 0) {
            var offset = $('.et-radiolink').eq(r).offset().top;
            $('.et-radiolink').eq(r).addClass('font');
            $(window).scrollTop(offset - 200);
            return false;
          }
        }
        content[radioName.attr('name')] = radioName.next().html();
      }
      //多选
      var checked = $('.et-checklink');
      for (var c = 0; c < checked.length; c++) {
        var che = [];
        //判断是否为必填
        if (checked.eq(c).attr('is_require') == 1) {
          //是否选中
          if (checked.eq(c).find('.check-on').length == 0) {
            var offChecked = $('.et-checklink').eq(c).offset().top;
            $('.et-checklink').eq(c).addClass('font');
            $(window).scrollTop(offChecked - 200);
            return false;
          }
        }
        //遍历多选内容
        for (var cc = 0; cc < checked.eq(c).find('.check-on').length; cc++) {
          che.push($(checked.eq(c).find('.check-on')[cc]).next().html());
        }
        content[checked.eq(c).attr('name')] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(che);
      }
      //下拉框
      var Select = $('.et-slebox');
      for (var s = 0; s < Select.length; s++) {
        var selectName = Select.eq(s).find('select');
        if (selectName.attr('is_require') == 1) {
          if (selectName.val() == '') {
            var etSlebox = $('.et-slebox').eq(c).offset().top;
            $('.et-slebox').eq(c).addClass('font');
            $(window).scrollTop(etSlebox - 200);
            return false;
          }
        }
        content[selectName.attr('name')] = selectName.val();
      }
      //日期
      var typeData = $('.et-typeData');
      for (var t = 0; t < typeData.length; t++) {
        var typeDateName = typeData.eq(t).find('input').eq(0);
        console.log(typeDateName);
        if (typeDateName.attr('is_require') == 1) {
          if (typeDateName.val() == '') {
            content[typeDateName.attr('name')] = typeDateName.val();
            return false;
          }
        }
        content[typeDateName.attr('name')] = typeDateName.val();
      }
      //地区
      var demolName = $('.demo1');
      if (demolName.length > 0) {
        for (var i = 0; i < demolName.length; i++) {
          var sel = $('.example').eq(i).find('select'),
              selName = '';
          for (var v = 0; v < 3; v++) {
            if (sel.eq(v).val() == '请选择') {
              var etSlebox = $('.content-block').offset().top;
              $('.example').addClass('font');
              $(window).scrollTop(etSlebox);
              return false;
            }
            if (sel.eq(v).length) {
              selName += sel.eq(v).val() + ',';
            } else {
              selName += '--' + ',';
            }
          }

          if (demolName.attr('is_require') == 1) {
            if ($('.detailed').find('input').val() == '') {
              $('#Alert').find('.Prompt-p').html('请填写详细地址');
              $('#Alert').modal('show');
              $('.example').addClass('font');
              return false;
            }
          }
          selName += $('.detailed').find('input').val();
          content[demolName.eq(i).attr('name')] = selName;
        }
      }

      // 所属类型
      var selmul = $('.group-selmul');
      // debugger;
      for (var _i = 0; _i < selmul.length; _i++) {
        var seli = selmul.eq(_i);
        var name = seli.attr('name');
        var casVal = that.casVal[name];

        if (seli.attr('is_require') == 1) {
          // console.log(2)
          if (!casVal || casVal[0] == '' || casVal[1] == '') {
            var top = seli.offset().top;
            seli.find('.selmul').addClass('font');
            $(window).scrollTop(top);
            return false;
          }
        }
        if (casVal && casVal.length) {
          content[name] = casVal.join();
        }
      }

      var uploadVideo = $('.uploadVideo');
      var uploadImg = $('.uploadImg');
      var uploadFile = $('.uploadFile');
      var uploadAll = $('.uploadAll');

      // 获取上传文件上传字段
      // if (uploadFile.attr('name')) {
      //   content[uploadFile.attr('name')] = '上传文档';
      // }
      if (uploadFile.length) {
        var fLen = uploadFile.find('.fileName');
        var fName = '';
        for (var d = 0; d < fLen.length; d++) {
          fName += fLen.eq(d).attr('attr-uuid') + ',';
        }
        content[uploadFile.attr('name')] = fName;
      }
      // 获取上传图片或视频
      if (uploadAll.attr('name')) {
        var allLen = uploadAll.find('.fileName');
        var allName = '';
        for (var a = 0; a < allLen.length; a++) {
          allName += allLen.eq(a).attr('attr-uuid') + ',';
        }
        content[uploadAll.attr('name')] = allName;
      } else {
        // 获取上传视频字段
        if (uploadVideo.length) {
          var videoLen = uploadVideo.find('.fileName');
          var videoName = '';
          for (var d = 0; d < videoLen.length; d++) {
            videoName += videoLen.eq(d).attr('attr-uuid') + ',';
          }
          content[uploadVideo.attr('name')] = videoName;
        }
        // 获取上传图片字段
        if (uploadImg.length) {
          var imgLen = uploadImg.find('.fileName');
          var imgName = '';
          for (var m = 0; m < imgLen.length; m++) {
            imgName += imgLen.eq(m).attr('attr-uuid') + ',';
          }
          content[uploadImg.attr('name')] = imgName;
        }
      }
      //上传文件key
      for (var i = 0; i < fileName.length; i++) {
        var key = fileName.eq(i).attr('attr-uuid');
        var val = fileName.eq(i).attr('attr-type');
        file_id[key] = val;
      }
      var ActivityForms = {
        activity_id: that.id,
        content: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content),
        form_id: that.form_id,
        file_id: file_id
      };

      that.loading = true;

      $.ajax({
        'url': API.UpdateActivityForm,
        'data': ActivityForms,
        'type': 'POST',
        'dataType': 'json',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function success(res) {
          if (res.code == 0) {
            $('#entryModal').modal('show');

            // $('#editModalsAler2').modal('show')
          } else if (res.code == 3002) {
            $('#Alert').find('.Prompt-p').html('活动异常-请联系管理员！');
            $('#Alert').modal('show');
          } else {
            $('#Alert').find('.Prompt-p').html('请确定信息是否填写完成？');
            $('#Alert').modal('show');
          }
        },
        complete: function complete() {
          that.loading = false;
        }
      });
    },
    casChange: function casChange(data) {
      console.log(data);
      this.casVal[data.name] = data.value;
    }
  },

  components: { //渲染页面
    Upload: __WEBPACK_IMPORTED_MODULE_1__UploadToken_upload_vue__["a" /* default */],
    ImageUpload: __WEBPACK_IMPORTED_MODULE_4__UploadToken_imageUpload_vue__["a" /* default */],
    FileUpload: __WEBPACK_IMPORTED_MODULE_2__UploadToken_FileUpload_vue__["a" /* default */],
    VideoUpload: __WEBPACK_IMPORTED_MODULE_3__UploadToken_VideoUpload_vue__["a" /* default */],
    Linkage: __WEBPACK_IMPORTED_MODULE_5__template_linkage_vue__["a" /* default */],
    // Cascader: Cascader,
    Selectmul: __WEBPACK_IMPORTED_MODULE_6__template_selectmul_vue__["a" /* default */]
  },
  created: function created() {
    var that = this;
    that.id = that.$route.params.id;
    that.form_id = that.$route.params.form_id;
    if (window.isThisClient('cbox')) {
      console.log("myparticipate-message");
      that.cboxregisterhandler();
    }

    //账户
    if (!that.loginFn()) {
      $('#login_Alert').modal('show');
      return false;
    } else {}
    // console.log('判断是否登录-已登录')

    //100131分享
    if (that.id == "100131") {
      that.modalTit = '全家福上传成功！点击分享按钮，邀请您的朋友参与活动吧！';
    }

    //仅判断报名信息是否可修改
    this.$http.get(API.IsJoin, { params: { activity_id: that.id } }).then(function (res) {
      if (res.code == 0 && res.data.isJoin != 0) {
        if (res.data.edit_form && res.data.edit_form.is_show == 0) {
          that.noEdit = true;
          that.doEdit = res.data.edit_form.title || that.doEdit;
        }
      }
    });

    //报名字段
    //
    function getFormConent(that) {
      that.$http.get(API.GetActivityFormContent, { params: { form_id: that.form_id } }).then(function (res) {
        if (res.code == 0) {
          var data = res.data;
          var op_default_value;

          var _arr = data.map(function (item, val) {
            op_default_value = item.default_value;
            //处理错误数据
            if (item.field_type == 'checkbox') {
              try {
                JSON.parse(item.default_value);
              } catch (e) {
                op_default_value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([item.default_value]);;
              }
            }

            // console.log(op_default_value);
            return {
              name: item.name,
              title: item.title,
              tip: item.tip,
              field_type: item.field_type,
              is_require: item.is_require,
              option_json: item.option_json || '',
              isChoose: op_default_value || '',
              choose_num: item.choose_num || '',
              rule_type: item.rule_type || ''
            };
          });
          // for()
          that.RegistrationForm = _arr;
        }
        that.$nextTick(function () {
          $('.et-complete').show();
        });
      });
    }

    if (that.form_id != 0) {
      getFormConent(that);
    } else {
      that.$http.get(API.GetMyActiviteInfo, { params: { activity_id: that.id } }).then(function (res) {
        if (res.code == 0) {
          that.form_id = res.data[0].form_id;
          getFormConent(that);
        }
      });
    }

    // 判断安卓机去掉动画
    // that.isAndroid();
    // if(that.id){
    //分享微信
    that.$http.get(API.GetActivitieById, { params: { id: that.id } }).then(function (res) {
      // console.log(res,2)
      if (res.code == 0) {
        if (!res.data || res.data.length == 0) {
          that.$router.push({ name: 'HomeIndex' });
        }
        var dataTime = new Date(res.data.end_time).getTime() / 1 - new Date().getTime();
        if (dataTime < 0) {
          that.$router.push({ name: 'Detail', params: { id: that.id } });
        }
        that.detailsTxte = res.data;
        that.route = that.detailsTxte.playbill.playbill;
        console.log(that.detailsTxte.page_config, 'mypart-mess');
        if (that.detailsTxte.page_config.wuxicheck && that.detailsTxte.page_config.wuxicheck.is_show == "0") {
          that.audit_level = 0;
        }
      }
    });

    // }
  },

  mounted: function mounted() {
    //操作DOM
    var that = this;

    //选择日期

    // $('.date-show').on('focus', function () {
    //   $('.icon-date').trigger('click');
    // });

    //文本输入框根据内容自动变高
    $('textarea').unbind('input');
    $('textarea').bind('input', function () {
      handleTextareaHeight(this);
    });

    function handleTextareaHeight(element) {
      var textareaMinHeight = 72;
      element.style.height = textareaMinHeight + 'px';
      if (element.scrollHeight > textareaMinHeight) {
        element.style.height = element.scrollHeight + 'px';
      }
    }

    // checkbok 选中函数
    $('.form').on('click', '.et-checklink li', function () {
      if ($(this).find('.check-box').hasClass('check-on')) {
        $(this).find('.check-box').removeClass('check-on');
      } else {
        $(this).find('.check-box').addClass('check-on');
      }
    });

    // 日期

    // $('.form').on('click', 'input[type ="date"]', function () {
    //   $(this).parents('.et-typeData').find('.date-show').focus();
    // });

    // $('.form').on('change', 'input[type ="date"]', function () {
    //   $(this).prev('input').val($(this).val())
    // });

    //分享
    var ua = navigator.userAgent.toLowerCase();

    function is_uc() {
      if (navigator.userAgent.indexOf('UCBrowser') > -1) {
        return true;
      } else {
        return false;
      }
    }

    function is_qq() {
      if (ua.indexOf('mqqbrowser') > -1 && ua.indexOf(" qq") < 0) {
        return true;
      } else {
        return false;
      }
    }

    setTimeout(function () {
      /* $('#entryModal').modal('show')*/
      //判断是否是微信
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (!isWeixin) {
        //判断是否是uc浏览器 或者 qq浏览器
        if (is_uc() || is_qq()) {
          var config = {
            url: API.UrlName + 'detail/' + that.id, // 分享的网页链接
            title: that.detailsTxte.title, // 标题
            desc: that.removeTAG(that.detailsTxte.description, 100), // 描述
            img: that.detailsTxte.playbill.playbill_h5 || that.detailsTxte.playbill.playbill, // 图片
            img_title: '', // 图片标题
            from: API.UrlName // 来源
          };
          var share_obj = new nativeShare('nativeShare', config);
          $('.btn-el-share').hide();
          $('.share').hide();
        } else {
          $('.btn-el-share').hide();
          $('.share').show();
        }
      }
      $('#share_1').share({
        url: API.UrlName + 'detail/' + that.id
      });
      var banWimg = $('.dl-banner').width();
      var banHimg = Math.ceil($('.dl-banner').width() / 2 * 1);
      $('.dl-banner img').css({ width: banWimg, height: banHimg, visibility: 'visible' });
    }, 500);
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "hugo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.excellentTitle.length > 0),expression:"excellentTitle.length > 0"}],staticClass:"line"}),_vm._v(" "),(_vm.excellentTitle.length > 0)?_c('div',{staticClass:"show-box show-Title",attrs:{"id":"excellentTitle"}},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"tag":"a","to":{name:'list_video',params: {id: _vm.detailsTxte.id,init: 1}}}},[(_vm.detailsTxte.playbill)?_c('h5',{staticClass:"show-tit"},[_vm._v("征集作品展播\n        "),_c('a',{staticClass:"show-linkmore",attrs:{"href":"javascript:void(0);"}},[_vm._v("更多")])]):_vm._e()]),_vm._v(" "),_vm._l((_vm.excellentTitle),function(e,m){return _c('div',[(_vm.imgTable[m] && _vm.imgTable[m].length && _vm.numbers[m] > 0)?_c('div',{staticClass:"show-sl-tit"},[_c('i',{staticClass:"icon-plt"}),_vm._v(_vm._s(_vm.excellentTitle[m])+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.excellentStyle[m] == 2 && _vm.imgTable[m] && _vm.imgTable[m].length && _vm.numbers[m] > 0)?_c('div',{staticClass:"swiper-container show-work-swiper1 show-work",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.numbers[m]),function(v,ind){return (_vm.numbers)?_c('div',{staticClass:"swiper-slide"},[_c('ul',{staticClass:"show-list"},_vm._l((2),function(val,i){return _c('li',[(_vm.imgTable[m][ind*2+i])?_c('router-link',{attrs:{"tag":"a","to":{name:'VideoName',params: {id:_vm.imgTable[m][ind*2+i].activity_id,uuid: _vm.imgTable[m][ind*2+i].file_id,type:_vm.imgTable[m][ind*2+i].file_type}}}},[_c('div',{staticClass:"pic-box"},[(_vm.imgTable[m][ind*2+i])?_c('img',{attrs:{"src":(_vm.imgTable[m].latest?_vm.imgTable[m][ind*2+i].file.thumb_url:_vm.imgTable[m][ind*2+i].recommend_image)+'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(_vm.imgTable[m][ind*2+i].file.time_span)))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.imgTable[m][ind*2+i].file.title))]),_vm._v(" "),(_vm.imgTable[m][ind*2+i].nickname)?_c('div',{staticClass:"vode-user"},[(_vm.imgTable[m][ind*2+i].user)?_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":_vm.imgTable[m][ind*2+i].user.face_url,"alt":""}})]):_vm._e(),_vm._v(_vm._s(_vm._f("ellipsis")(_vm.imgTable[m][ind*2+i].nickname,12))+"\n                  ")]):_c('div',{staticClass:"vode-user"},[(_vm.imgTable[m][ind*2+i].user)?_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":_vm.imgTable[m][ind*2+i].user.face_url,"alt":""}})]):_vm._e(),_vm._v(_vm._s(_vm._f("ellipsis")(_vm.imgTable[m][ind*2+i].user.nick_name,12))+"\n                  ")])]):_vm._e()],1)}))]):_vm._e()}))]):_vm._e(),_vm._v(" "),(_vm.excellentStyle[m] == 1 && _vm.imgTable[m] && _vm.imgTable[m].length && _vm.numbers[m] > 0)?_c('div',{staticClass:"detail-highlights"},[_c('ul',_vm._l((_vm.imgTable[m]),function(item,val){return _c('li',{staticClass:"clearfix"},[_c('div',{staticClass:"pic-boxs"},[_c('router-link',{attrs:{"tag":"div","to":{name:'VideoName',params: {id:item.activity_id,uuid: item.file_id,type:item.file_type}}}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:((_vm.imgTable[m].latest?item.file.thumb_url:item.recommend_image)+'?p=3&o=2&w=710&h=399'),expression:"(imgTable[m].latest?item.file.thumb_url:item.recommend_image)+'?p=3&o=2&w=710&h=399'"}],attrs:{"alt":""}})]),_vm._v(" "),_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(item.file.time_span)))])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("ellipsis")(item.file.title,20)))]),_vm._v(" "),(item.nickname)?_c('div',{staticClass:"vode-user vode-detail"},[(item.user)?_c('i',{staticClass:"icon-mine"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.user.face_url),expression:"item.user.face_url"}],attrs:{"alt":""}})]):_vm._e(),_vm._v(_vm._s(_vm._f("ellipsis")(item.nickname,25))+"\n            ")]):_c('div',{staticClass:"vode-user vode-detail"},[(item.user)?_c('i',{staticClass:"icon-mine"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.user.face_url),expression:"item.user.face_url"}],attrs:{"alt":""}})]):_vm._e(),_vm._v(_vm._s(_vm._f("ellipsis")(item.user.nick_name,25))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"vode-share"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.globalUrl + 'static/dist/img/da.png'),expression:"globalUrl + 'static/dist/img/da.png'"}],attrs:{"alt":""}})])])}))]):_vm._e()])})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i8r/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_imgSan_vue__ = __webpack_require__("YzOp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Scan: __WEBPACK_IMPORTED_MODULE_0__template_imgSan_vue__["a" /* default */] },
  props: ['userId', 'initUtil'],
  data: function data() {
    return {
      conten: [],
      ind: '',
      id: '',
      busy: false,
      page: 0,
      data: '',
      scan: {
        show: false,
        url: ''
      }
    };
  },

  methods: {
    //操作按钮事件
    DelFile: function DelFile() {
      var that = this;
      // console.log(that.id)
      $.getJSON(API.DelActivityMsgById + '?jsoncallback=?&msg_id=' + that.id, function (res) {
        //  console.log(res);
        if (res.code == 0) {
          $('.ay-close').eq(that.ind).parent().remove();
          $('#editModals').modal('hide');
        } else {
          alert('此条信息已被删除');
        }
      });
    },
    water: function water(item) {
      //console.log(item)
      var that = this;
      this.data = new Date();
      var fileItem = '';
      if (item.file) {
        if (item.file_type == 'video') {
          that.$router.push({ name: 'VideoName', params: { id: item.activity_mini.id, uuid: item.file.uuid, type: 'video' } });
        } else {
          that.$router.push({ name: 'VideoName', params: { id: item.activity_mini.id, uuid: item.file.image_id, type: 'image' } });
        }
      } else if (item.msg_type == 1) {
        this.scan = {
          show: true,
          url: item.image_url
        };
      }
    },

    //加载更多
    loadMore: function loadMore() {
      var _this = this;

      this.busy = true;
      // 多次加载数据
      setTimeout(function () {
        _this.page++;
        _this.ajaxMore(true);
      }, 500);
    },
    ajaxMore: function ajaxMore(flag) {
      var that = this;
      this.$http.get(API.GetActivityMsgList, { params: { page: that.page, pagesize: 10 } }).then(function (res) {
        // console.log(res)
        if (res.code == 0) {
          if (flag) {
            for (var i = 0; i < res.data.length; i++) {
              that.conten.push(res.data[i]);
            }
            if (res.data.length === 0 || that.conten.length === res.total) {
              that.busy = true;
            } else {
              that.busy = false;
            }
          }
          that.$nextTick(function () {
            var w = $('.video-img').width();
            $('.video-img').css("height", w / 16 * 9);
          });
          if (res.total == 0) {
            $('.foll_div').html('还没有活动@您！');
          }
        }
      });
    }
  },
  created: function created() {
    var that = this;
    this.initUtil.stopBodyScroll(false);
    //@我的
    $('.icon-back').removeClass('pointerEve');
  },
  mounted: function mounted() {
    //操作DOM
    $('.icon-back').show();
    var that = this;
    $('.ay-content-list').on('click', '.ay-close', function () {
      that.ind = $(this).parent().index();
      that.id = $(this).attr('attr-id');
      $('#editModals').modal('show');
    });

    $('.nav').children('.id-nav-recom').eq(3).addClass('nav-on').siblings().removeClass('nav-on');

    $('.nav').children('.id-nav-recom').eq(3).addClass('router-link-exact-active').siblings().removeClass('router-link-exact-active');

    //微信分享
    var metas = $('head').children('meta');
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "iNif":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iW6+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_Repassword"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"header login-header"},[_c('a',{staticClass:"icon-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.fn}}),_vm._v("找回密码\n    ")]),_vm._v(" "),_c('div',{staticClass:"line-gray"}),_vm._v(" "),_c('div',{staticClass:"content login-content"},[_c('form',{staticClass:"lg-tabbox"},[_c('div',{staticClass:"group-item"},[_c('label',[_vm._v("账号")]),_vm._v(" "),_c('div',{staticClass:"input-box input-tel"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MobilePhone),expression:"MobilePhone"}],attrs:{"type":"tel","placeholder":"请输入手机号","id":"MobilePhone","maxlength":"11"},domProps:{"value":(_vm.MobilePhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MobilePhone=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.MobilePhone != ''),expression:"MobilePhone != ''"}],staticClass:"btn-del",staticStyle:{"display":"none"},on:{"click":function($event){_vm.MobilePhone = ''}}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"MobilePhone-mess"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"pass-mess"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"repass-mess"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"img-yzm-mess"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"yzm-mess"}}),_vm._v(" "),_c('div',{staticClass:"group-terms"},[_c('div',{class:_vm.checked?'check-box oncheck':'check-box',on:{"click":function($event){_vm.checked = !_vm.checked}}},[_c('input',{attrs:{"type":"checkbox"}})]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('p',{staticClass:"text-danger",attrs:{"id":"xieyi-mess"}}),_vm._v(" "),_vm._m(5)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-item"},[_c('label',[_vm._v("新密码")]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{attrs:{"type":"password","id":"pass","placeholder":"6-20位任意字符区分大小写"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-item"},[_c('label',[_vm._v("确认密码")]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{attrs:{"type":"password","id":"repass","placeholder":"再次输入密码"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-item"},[_c('label',[_vm._v("图形验证")]),_vm._v(" "),_c('div',{staticClass:"input-box input-picyz"},[_c('input',{attrs:{"type":"text","placeholder":"","id":"img_yzm","placeholder":"请输入验证码"}}),_vm._v(" "),_c('img',{staticClass:"picyz",attrs:{"src":"http://reg.cctv.com/simple/verificationCode.action"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-item"},[_c('label',[_vm._v("验证码")]),_vm._v(" "),_c('div',{staticClass:"input-box input-yzm"},[_c('input',{attrs:{"type":"text","placeholder":"请输入验证码","id":"yzm"}}),_vm._v(" "),_c('a',{staticClass:"btn-yzm puts",attrs:{"href":"javascript:void(0);"}},[_vm._v("发送验证码")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"terms"},[_vm._v("\n            阅读并同意"),_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("《央视网网络服务使用协议》")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-info"},[_c('a',{staticClass:"font-lgr",attrs:{"href":"javascript:void(0);","id":"reback"}},[_vm._v("完  成")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iwob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"ay-content-list",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"10","infinite-scroll-throttle-delay":"1000"}},[_vm._l((_vm.MyUpload),function(item,ind){return (_vm.MyUpload)?_c('div',{staticClass:"ay-link ay-cor"},[(item.file_type == 'image')?_c('p',{staticClass:"ay-title-time"},[_vm._v(_vm._s(_vm._f("datetime")(item.file.upload_time)))]):_vm._e(),_vm._v(" "),(item.file_type == 'video')?_c('p',{staticClass:"ay-title-time"},[_vm._v(_vm._s(_vm._f("datetime")(item.file.upload_datetime)))]):_vm._e(),_vm._v(" "),(item.file)?_c('div',{staticClass:"ay-inr"},[_c('div',{staticClass:"ay-pic-box",on:{"click":function($event){_vm.video(item.file.status,item.ids,item.file_id,item.file_type,item,item.file.is_edit)}}},[(item.is_recommend == 1)?_c('em'):_vm._e(),_vm._v(" "),(item.file_type == 'video')?_c('img',{staticClass:"ay-pic",attrs:{"src":item.file.thumb_url +'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),(item.file_type == 'image')?_c('img',{staticClass:"ay-pic",attrs:{"src":(item.file.status === 'approved'?   item.file.image_url:(item.file.status === 'rejected'? _vm.reject_img :_vm.pngSds)) +'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e(),_vm._v(" "),(item.file_type == 'video')?_c('i',{staticClass:"ay-pic-t"},[_vm._v(_vm._s(_vm._f("formatSeconds")(item.file.time_span)))]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"ay-title"},[_vm._v(_vm._s(item.file.title))]),_vm._v(" "),_c('div',{staticClass:"btn-ay"},[(item.file.status == 'approved')?_c('a',{staticClass:"btn-ay-red btn-admin-work",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.edit(item.file_id,item.file_type,item)}}},[_vm._v("编辑")]):_vm._e()])]):_vm._e(),_vm._v(" "),(item.file)?_c('div',{staticClass:"ay-inr-bottom"},[(item.file.status == 'approved')?_c('span',{staticClass:"icon-ygs"},[(item.file.is_edit == '1')?_c('i',{staticStyle:{"font-style":"normal"}},[_vm._v("审核中（编辑）")]):_c('i',{staticStyle:{"font-style":"normal"}},[_vm._v("审核通过")])]):_vm._e(),_vm._v(" "),(item.file.status == 'none' && item.file.audit_level === 0)?_c('span',{staticClass:"icon-ygs"},[_c('i',{staticStyle:{"font-style":"normal"}},[_vm._v("上传成功")])]):_vm._e(),_vm._v(" "),(item.file.status == 'none'  && item.file.audit_level !== 0)?_c('span',{staticClass:"icon-ygs"},[_c('i',{staticStyle:{"font-style":"normal"}},[_vm._v("审核中")])]):_vm._e(),_vm._v(" "),(item.file.status == 'rejected')?_c('span',{staticClass:"icon-ygs"},[_vm._v("\n            审核未通过\n        ")]):_vm._e()]):_vm._e()]):_vm._e()}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.busy),expression:"!busy"}],staticClass:"content index-content",staticStyle:{"padding-top":"5px"}},[_vm._m(0)]),_vm._v(" "),(_vm.MyUpload.length == 0)?_c('div',{staticClass:"foll_div"},[_vm._m(1)]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"editModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.editcComplete()}}},[_vm._v("完成")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("取消")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"editModals","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"pl-form"},[_c('h3',{staticClass:"Prompt-p"},[_vm._v("你确定要删除上传文件？  ")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.DelFile}},[_vm._v("完成")]),_vm._v(" "),_c('a',{staticClass:"btn-pl-start",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("取消")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"picture-content",on:{"click":_vm.pictureHide}},[_vm._m(4),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('Filedetails',{attrs:{"fileItem":_vm.fileItem,"data":_vm.data,"tops":_vm.tops}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content index-content"},[_c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("名称")]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('input',{attrs:{"type":"text","id":"titleName","placeholder":"请输入名称"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('label',[_vm._v("描述")]),_vm._v(" "),_c('div',{staticClass:"pl-ipbox"},[_c('textarea',{attrs:{"rows":"3","id":"descriptionName","placeholder":"请输入描述信息"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picture-content-div"},[_c('img',{staticClass:"picture-img",attrs:{"src":__webpack_require__("n7la"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picture-ph"},[_c('h3',{staticClass:"picture-h3"},[_vm._v("详情title")]),_vm._v(" "),_c('p',{staticClass:"picture-p"},[_vm._v("详情title详情title详情title")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j/bE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoUpload_vue__ = __webpack_require__("sgEe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab711f1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoUpload_vue__ = __webpack_require__("ZnQl");
function injectStyle (ssrContext) {
  __webpack_require__("9jx/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab711f1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j/yj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_footer_vue__ = __webpack_require__("YvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loginAler_vue__ = __webpack_require__("bckt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__entryform_notice_vue__ = __webpack_require__("o1H1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__entryform_signUp_vue__ = __webpack_require__("R6WS");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      prompt: '',
      category: true,
      route: '',
      id: '',
      btn: '',
      et: '',
      detailItem: null,
      detailsTxte: null,
      audit_level: 2,
      globalUrl: API.GlobalUrl,
      modalTit: '信息已提交，感谢您的参与！',
      stashRoute: {},
      userId: ''
    };
  },

  methods: {
    //操作按钮事件
    share: function share() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (isWeixin) {
        $('.shart').show();
      }
    },
    shareHide: function shareHide() {
      $('.shart').hide();
    },
    form: function form() {
      //表单
      this.category = true;
      //console.log(this.route,this.id)
      // this.$router.replace({name: 'Notice', params: {id: this.id,route: this.route,init: 1}});
      this.$router.replace(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.stashRoute));
    },
    xz: function xz() {
      //须知
      this.category = false;
      this.$router.replace({ name: 'SignUp', params: { id: this.id, init: 2 } });
    },
    detail: function detail() {
      this.$router.push({ name: 'Detail', params: { id: this.id } });
    },
    Continue: function Continue() {
      //继续参与
      $('#entryModal').modal('hide');
      window.location.reload();
    },
    CloseUpload: function CloseUpload() {
      //上传进度弹窗关闭  取消上传
      $('#processModal').modal('hide');
    },
    myActivity: function myActivity() {
      //继续参与
      var that = this;
      $('#entryModal').modal('hide');
      this.$router.replace({ name: 'myActivity_MyParticipate', params: { id: that.id } });
    },
    myActivitys: function myActivitys() {
      //查看
      var that = this;
      $('#entryModal').modal('hide');
      this.$router.replace({ name: 'myActivity_MyParticipate', params: { id: 0 } });
    }
  },
  components: { //渲染页面
    PointFooter: __WEBPACK_IMPORTED_MODULE_1__template_footer_vue__["a" /* default */],
    LoginAler: __WEBPACK_IMPORTED_MODULE_2__loginAler_vue__["a" /* default */],
    Notice: __WEBPACK_IMPORTED_MODULE_3__entryform_notice_vue__["a" /* default */],
    SignUp: __WEBPACK_IMPORTED_MODULE_4__entryform_signUp_vue__["a" /* default */]
  },
  created: function created() {
    // console.log(this.$route);
    this.stashRoute = this.$route;
    this.id = this.$route.params.id;
    this.init = this.$route.params.init;
    var that = this;
    if (window.isThisClient('cbox')) {
      console.log("entryform");
      that.cboxregisterhandler();
    }
    that.userId = that.getCookie('userSeqId') || '';
    //100131分享
    if (that.id == "100131") {
      that.modalTit = '全家福上传成功！点击分享按钮，邀请您的朋友参与活动吧！';
    }

    if (!this.id) {
      this.$router.push({ name: 'Home' });
    }
    // 判断安卓机去掉动画
    that.isAndroid();
    //分享微信
    this.$http.get(API.GetActivitieById, { params: { id: that.id } }).then(function (res) {
      // console.log(res,'entryform');
      if (res.code == 0) {
        if (!res.data || res.data.length == 0) {
          that.$router.push({ name: 'HomeIndex' });
        }
        that.detailsTxte = res.data;
        if (that.detailsTxte.page_config.wuxicheck && that.detailsTxte.page_config.wuxicheck.is_show == 0) {
          that.audit_level = 0;
        }
        that.route = that.detailsTxte.playbill.playbill;
        var dataTime = new Date(that.detailsTxte.end_time).getTime() / 1 - new Date().getTime();
        var startData = new Date(that.detailsTxte.start_time).getTime() - new Date().getTime();

        if (dataTime < 0 || startData > 0 || that.detailsTxte.type == 1) {
          //type==1???
          that.$router.push({ name: 'Detail', params: { id: that.id } });
        }

        //分享微信
        var title = '',
            desc = '';
        if (that.detailsTxte.share_config) {
          var activity = that.detailsTxte.share_config.activity;
          if (activity && activity.share_title) {
            title = activity.share_title;
          } else if (that.detailsTxte.share_config.share_title) {
            title = that.detailsTxte.share_config.share_title;
          } else {
            title = that.detailsTxte.title;
          }
          if (activity && activity.share_contents) {
            desc = activity.share_contents;
          } else if (that.detailsTxte.share_config.share_contents) {
            desc = that.detailsTxte.share_config.share_contents;
          } else {
            desc = that.detailsTxte.description;
          }
        } else {
          title = that.detailsTxte.title;
          desc = that.detailsTxte.description;
        }
        document.title = title;
        var metas = $('head').children('meta');
        metas[1].content = desc;
        var img = '';
        if (that.detailsTxte.share_config && that.detailsTxte.share_config.activity && that.detailsTxte.share_config.activity.share_pic) {
          img = that.detailsTxte.share_config.activity.share_pic;
        } else if (that.detailsTxte.playbill && that.detailsTxte.playbill.playbill_h5) {
          img = that.detailsTxte.playbill.playbill_h5;
        }

        var dataName = {
          title: title, //分享标题
          desc: that.removeTAG(desc, 110), //metas[1].content,//分享简介(内容)
          imgAddress: img, //分享图片地址
          Retain: '', //保留
          url: API.UrlName + 'detail/' + that.id //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
        };
        that.weixinShare(dataName);
      }
    });
  },
  mounted: function mounted() {
    //操作DOM
    //setTimeout(function(){
    // _vjTrack('')
    //},500)
    var that = this;
    var ua = navigator.userAgent.toLowerCase();

    function is_uc() {
      if (navigator.userAgent.indexOf('UCBrowser') > -1) {
        return true;
      } else {
        return false;
      }
    }

    function is_qq() {
      if (ua.indexOf('mqqbrowser') > -1 && ua.indexOf(" qq") < 0) {
        return true;
      } else {
        return false;
      }
    }

    setTimeout(function () {
      // $('#entryModal').modal('show')
      //判断是否是微信
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (!isWeixin) {
        //判断是否是uc浏览器 或者 qq浏览器
        if (is_uc() || is_qq()) {
          var config = {
            url: API.UrlName + 'detail/' + that.id, // 分享的网页链接
            title: that.detailsTxte.title, // 标题
            desc: that.removeTAG(that.detailsTxte.description, 100), // 描述
            img: that.detailsTxte.playbill.playbill_h5 || that.detailsTxte.playbill.playbill, // 图片
            img_title: '', // 图片标题
            from: API.UrlName // 来源
          };
          var share_obj = new nativeShare('nativeShare', config);
          $('.btn-el-share').hide();
          $('.share').hide();
        } else {
          $('.btn-el-share').hide();
          $('.share').show();
        }
      }
      $('#share_1').share({
        url: API.UrlName + 'detail/' + that.id
      });
      var banWimg = $('.dl-banner').width();
      var banHimg = Math.ceil($('.dl-banner').width() / 2 * 1);
      $('.dl-banner img').css({ width: banWimg, height: banHimg, visibility: 'visible' });
    }, 500);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "jBjh":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by Administrator on 2018/1/2.
 */

exports.install = function (Vue, options) {
  // 判断小程序
  Vue.prototype.miniprogram = function () {
    function ready() {
      if (window.__wxjs_environment === 'miniprogram') {
        return true;
      } else {
        return false;
      }
    }
    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', ready, false);
    } else {
      return ready();
    }
  };
  // 判断安卓
  Vue.prototype.isAndroid = function () {
    var u = navigator.userAgent,
        app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    if (isAndroid) {
      setTimeout(function () {
        $('#login_Alert').removeClass('fade');
      }, 1000);
    }
  };
  // 判断跳转页面
  Vue.prototype.hrefHTML = function (type, actId) {
    /*    var addArr = [86453, 81424, 81680, 86746, 52985, 80727, 84237, 81741, 81752, 81758, 79059, 78685, 77066, 77761, 78618, 84357, 80513, 80469, 80465, 79394, 77703, 63536, 62611, 58826, 57722, 54618, 54394, 54385, 54373, 54222, 54223, 54224, 46362, 52875, 50399, 48644, 47992, 47693];
        //addArr.indexOf(actId)
        for (var i = 0; i < addArr.length; i++) {
          if (addArr[i] == actId) {
            //判断类型
            if (actId == '80727' || actId == '86453') {
              return 'http://ishow.xiyou.cctv.com/seriesactive.html?iid=' + actId
            } else {
              return 'http://ishow.xiyou.cctv.com/active.html?iid=' + actId;
            }
            }
        }*/
    return false;
  };
  //分享
  Vue.prototype.removeTAG = function (str, len) {
    var str = str.replace(/<[^>]+>/g, "");
    if (typeof str != 'string' || str == null || str == '') return '';
    return str.length > len ? str.slice(0, len) + '...' : str;
  };
  Vue.prototype.weixinShare = function (data) {
    $('#script').html('');
    var script = document.createElement('script');
    var head = document.getElementById('script');
    script.src = '/h5/static/lib/weixin/jweixin.js';
    // script.src = '../../../../static/lib/weixin/jweixin.js';//开发用
    var script2 = document.createElement('script');
    script2.src = '/h5/static/lib/jsddk1.js';
    // script2.src = '../../../../static/lib/jsddk1.js';//开发用
    head.appendChild(script);
    head.appendChild(script2);

    setTimeout(function () {
      var sdkInstance = new jssdk(169, 'https://wx.cctv.com');
      /*  var success_func = function () {
          console.log('分享成功后的回调');
        };*/
      sdkInstance.share(data.title, data.desc, data.imgAddress, data.title, '', data.url);
    }, 800);
  };
  Vue.prototype.$setgoindex = function () {
    if (window.history.length <= 1) {
      if (location.href.indexOf('?') === -1) {
        window.location.href = location.href + '?goindex=true';
      } else if (location.href.indexOf('?') !== -1 && location.href.indexOf('goindex') === -1) {
        window.location.href = location.href + '&goindex=true';
      }
    }
  };
  Vue.prototype.isWeiXin = function () {
    //判断是否微信
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  };
  Vue.prototype.IsPC = function () {
    //判断是否是移动 pc;
    var userAgentInfo = navigator.userAgent;
    var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'UCBrowser'];
    var flag = true;

    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    if (window.screen.width >= 768) {
      flag = true;
    }
    return false;
  };
  Vue.prototype.PictureRatio = function () {
    //图片尺寸比例
    //图片尺寸控制 16:9
    var banWimg = $('.dl-banner').width();
    var banHimg = Math.ceil($('.dl-banner').width() / 2 * 1);
    $('.dl-banner img').css({ width: banWimg, height: banHimg, visibility: 'visible' });

    var picWimg = $('.pic-box').width();
    var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
    $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });

    //图片尺寸控制 4:3
    var picmWimg = $('.pic-box-more').width();
    var picmHimg = Math.ceil($('.pic-box-more').width() / 4 * 3);
    $('.pic-box-more img').css({ width: picmWimg, height: picmHimg, visibility: 'visible' });
  };
  //验证登录
  Vue.prototype.loginFn = function () {
    /*
     var userId = this.getCookie('userSeqId')
    // var cbox = this.getCookie('cboxFrom')
    if (passport.isLoginedStatus()) {
    //if (passport.isLoginedStatus() || userId) {//本地开发用
      return true
    } else {
      //判断请求头 && cbox != 'cbox'
      if (window.isThisClient('cbox')) {
        window.location.href = 'login://qr.cntv.cn';
        return true;
      } else {
        return false
      }
    }*/
    var userId = this.getCookie('userSeqId');
    console.log(userId);
    if (window.isThisClient('cbox')) {
      data = Vue.prototype.cboxLogin();
      console.log('cbox--data -------');
      console.log(data);
      console.log('cbox--data ------- two');
      if (data == '') {
        console.log("loginFn false");
        return false;
      } else {
        console.log("loginFn true");
        return true;
      }
    } else {
      if (passport.isLoginedStatus() || userId) {
        //本地开发用
        return true;
      } else {
        return false;
      }
    }
  };
  Vue.prototype.cboxregisterhandler = function () {
    console.log("cbox init");
    // console.log(Vue.prototype.$bridge);
    console.log(this.$bridge);
    console.log('cctvWebMethod');
    // this.$bridge.registerHandler('cctvWebMethod',Vue.prototype.cboxregisterhandlercallback );
    this.$bridge.registerHandler('cctvWebMethod', function (data, responseCallback) {
      console.log("cbox init cctvWebMethod start");
      console.log(data);
      console.log("cbox init  cctvWebMethod end");
    });
  };

  // Vue.prototype.cboxregisterhandlercallback = function (data,responseCallback) {
  //     console.log("cboxregisterhandlercallback start");
  //      console.log(data);
  //      console.log("cboxregisterhandlercallback end");
  // }
  Vue.prototype.cboxLogin = function () {
    var params = { type: 1001, param: { needLogin: 1 } };
    console.log('cctvNativeMethod');
    this.$bridge.callHandler('cctvNativeMethod', params, function (responseData) {
      console.log('cboxlogin cctvNativeMethod cboxlogin start');
      console.log(responseData);
      // var user = JSON.parse(responseData);
      var jsonresponseData = JSON.parse(responseData);
      // 处理返回数据
      Vue.prototype.setCctvCookie('verifycode', jsonresponseData.verifyCode);
      Vue.prototype.setCctvCookie('userSeqId', jsonresponseData.userId);
      Vue.prototype.setCookie('verifycode', jsonresponseData.verifyCode);
      Vue.prototype.setCookie('userSeqId', jsonresponseData.userId);
      console.log('cboxlogin cctvNativeMethod cboxlogin end');
      return jsonresponseData.userId;
    });
  };

  Vue.prototype.cboxShare = function (shareImageUrl, shareUrl, shareTitle, shareContent) {
    var params = { type: 1005, param: { shareImageUrl: shareImageUrl, shareUrl: shareUrl, shareTitle: shareTitle, shareContent: shareContent } };
    this.$bridge.callhandler('cctvNativeMethod', params);
  };

  Vue.prototype.BuriedCode = function () {
    //var html =  $('<script>\
    //   var _hmt_citic = _hmt_citic || [];\
    //   _hmt_citic.u="http://data.qr.cntv.cn";\
    //   _hmt_citic.p="2018ishow";\
    //   (function () {\
    //     var hm = document.createElement("script");\
    //     hm.src = "http://static.qr.cntv.cn//qr/js/monitor.js?v=2017";\
    //     var s = document.getElementsByTagName("script")[0];\
    //     s.parentNode.insertBefore(hm, s);\
    //   })();\
    // </script>');
    // return html;
  };

  Vue.prototype.getCookie = function (name) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
  };
  Vue.prototype.setCookie = function (name, value) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  };
  Vue.prototype.setCctvCookie = function (name, value) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + '; path=/' + ";expires=" + exp.toGMTString() + ";domain=.cctv.com";
  };
  //视频播放
  /*
  Vue.prototype.VideoPlay = function (uuid, W, H, ID) {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      // 移动
      var _player_width = W || document.documentElement.clientWidth;  //播放窗口宽度
      var _player_height = H || Math.ceil(document.documentElement.clientWidth / 1.78);   //播放窗口高度 1.78
    } else {
      // pc
      var _player_width = 640;  // 播放窗口宽度
      var _player_height = 480;  // 播放窗口高度
    }
    var hostUrl = document.location.href;
    var domainName = 'http://';
    if (hostUrl.split(':')[0] == 'https') {
      domainName = 'https://'
    } else {
      domainName = 'http://'
    }
    
    setTimeout(function () {
      var flashvars = {};
      flashvars["id"] = uuid;
      flashvars["item_id"] = uuid;
      flashvars["type"] = 'video';
      flashvars["version"] = "3.054";
      flashvars["controls"] = true;
      flashvars["static_url"] = domainName + "ishow.cctv.com/";
      flashvars["width"] = _player_width;
      flashvars["height"] = _player_height;
      flashvars["lang"] = 'zh-CN';
      flashvars["autoplay"] = false;
      flashvars["playrelationlist"] = "false";
      flashvars["configxml"] = 'player.xml';
      if (ID) {
        _XYVideoPlayer = $('#' + ID).xyPlayer(flashvars);
      } else {
        _XYVideoPlayer = $('#myFlash').xyPlayer(flashvars);
      }
        var flashURL = domainName + "ishow.cctv.com/flash/";
    }, 0)
    }
  */
  Vue.prototype.VideoPlay = function (uuid, W, H, ID) {
    if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      //移动
      var _player_width = W || document.documentElement.clientWidth; //播放窗口宽度
      var _player_height = H || Math.ceil(document.documentElement.clientWidth / 1.78); //播放窗口高度 1.78
    } else {
      //pc
      var _player_width = 640; //播放窗口宽度
      var _player_height = 480; //播放窗口高度
    }
    //console.log(uuid,_player_width,_player_height,W)
    var fo = createCommonPlayer('vplayer', _player_width, _player_height, 'news');
    fo.addVariable('id', '');
    fo.addVariable('videoId', ''); //视频集id
    fo.addVariable('articleId', '');
    fo.addVariable('filePath', '');
    fo.addVariable('sysSource', 'xiyou'); //视频来源
    fo.addVariable('channelId', '');
    fo.addVariable('url', ''); //视频页面url，如http://tv.cntv.cn/video/C18472/a28126e5e0424a44af6a9bc4c5a47742
    fo.addVariable('scheduleId', 'ishow.cctv.com'); //关键字
    fo.addVariable('videoCenterId', uuid); //视频生产中心guid (必要值) d5df5fd8-cf90-11e2-b091-a4badb4696b6
    fo.addVariable('isLogin', ''); //用户中心相关
    fo.addVariable('userId', ''); //用户中心相关
    fo.addVariable('wideMode', 'normal');
    fo.addVariable('adCall', ''); //前贴片广告    //ad_Call
    fo.addVariable('adAfter', ''); //后贴广告  //ad_After
    fo.addVariable('adPause', ''); //暂停广告  //ad_Pause
    fo.addVariable('adCorner', ''); //角标广告  //ad_Corner
    fo.addVariable('vadCurtain', ''); //跑马灯广告  //ad_Curtain
    fo.addParam('wmode', 'opaque');
    fo.addVariable('repeat', 'true');
    if (ID) {
      writePlayer(fo, ID); //渲染页面的位置
    } else {
      fo.addVariable('isAutoPlay', 'true'); //是否自动播放
      writePlayer(fo, 'myFlash'); //渲染页面的位置
    }
  };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "jCcC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sds.e54b7b6.png";

/***/ }),

/***/ "jcL2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyParticipate_message_vue__ = __webpack_require__("he5Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe7e2e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyParticipate_message_vue__ = __webpack_require__("7D4Z");
function injectStyle (ssrContext) {
  __webpack_require__("9f9p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyParticipate_message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe7e2e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyParticipate_message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jgrU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

//这是必须要写的，用来创建一些设置
function setupWebViewJavascriptBridge(callback) {
    //Android使用
    if (isAndroid) {
        if (window.WebViewJavascriptBridge) {
            callback(WebViewJavascriptBridge);
        } else {
            document.addEventListener('WebViewJavascriptBridgeReady', function () {
                callback(WebViewJavascriptBridge);
                //如果发生ajax阻塞jsbrige的情况，尝试下方方式
                /*if(window.onWebViewJavascriptBridgeReady) window.onWebViewJavascriptBridgeReady(window.__bridge = WebViewJavascriptBridge);
                callback(WebViewJavascriptBridge)*/
            }, false);
        }
        sessionStorage.phoneType = 'android';
    }

    //iOS使用
    if (isiOS) {
        if (window.WebViewJavascriptBridge) {
            return callback(WebViewJavascriptBridge);
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe);
        }, 0);
        sessionStorage.phoneType = 'ios';
    }
}
//注册回调函数，第一次连接时调用 初始化函数(android需要初始化,ios不用)
setupWebViewJavascriptBridge(function (bridge) {
    if (isAndroid) {
        //初始化
        bridge.init(function (message, responseCallback) {
            var data = {
                'Javascript Responds': 'Wee!'
            };
            responseCallback(data);
        });
    }
});

/* harmony default export */ __webpack_exports__["a"] = ({
    // js调APP方法 （参数分别为:app提供的方法名  传给app的数据  回调）
    callHandler: function callHandler(name, data, callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(name, data, callback);
        });
    },

    // APP调js方法 （参数分别为:js提供的方法名  回调）
    registerHandler: function registerHandler(name, callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler(name, function (data, responseCallback) {
                callback(data, responseCallback);
            });
        });
    }
});

/***/ }),

/***/ "jpCD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kSqn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "series",
  props: ["detailsTxte", "twoNumbers"],
  data: function data() {
    return {
      series: [], // 系列
      seriesPage: 0,
      ID: '',
      sort: 'desc'
    };
  },

  methods: {
    seriesAll: function seriesAll() {
      var that = this;
      that.seriesPage = ++that.seriesPage;
      var activitie = {
        parent_id: that.ID,
        version: 2,
        page: that.seriesPage,
        pagesize: 10,
        sort: that.sort
      };
      that.$http.get(API.GetActivities, { params: activitie }).then(function (res) {
        if (res.code == 0) {
          that.seriesName = 'true';
          for (var i = 0; i < res.data.length; i++) {
            that.series.push(res.data[i]);
          }
          that.$nextTick(function () {
            if (res.total == that.series.length) {
              $('.seriesAll').hide();
            }
            var banWimg = $('.pic-box').width();
            var banHimg = Math.ceil($('.pic-box').width() / 16 * 9);
            $('.pic-box img').css({ width: banWimg, height: banHimg, visibility: 'visible' });
          });
        }
      });
    },

    joinSeries: function joinSeries(item) {
      //console.log(item);
      var that = this;
      if (that.loginFn()) {
        console.log('判断是否登录-已登录');
      } else {
        $('#login_Alert').modal('show');
        // that.$router.push({name: 'login_Quick'})
        return false;
      }
      that.$http.get(API.IsJoin, { params: { activity_id: item.id } }).then(function (res) {
        console.log(res);
        if (res.code == 0) {
          if (res.data.isJoin == 0) {
            that.$router.push({ name: 'Notice', params: { id: item.id } });
          } else if (res.data.child_sign && res.data.child_sign.is_show == "1") {
            // 只能参与一个子活动
            $("#msg_Alert").find(".info-mess").html(res.data.child_sign.title);
            $("#msg_Alert").modal();
          } else {
            that.$router.push({ name: 'Revise', params: { id: item.id, form_id: 0 } });
            return false;
          }
        }
      });
    }
  },
  created: function created() {
    var that = this;
    var pageConfig = that.detailsTxte.page_config;
    that.ID = this.$route.params.id;
    if (that.detailsTxte.type == 1) {
      if (pageConfig && pageConfig.display_order) {
        that.sort = pageConfig.display_order;
      }
      that.seriesAll();
    }
  },
  mounted: function mounted() {
    // 操作DOM
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "kzMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__ = __webpack_require__("KupL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad12d79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__ = __webpack_require__("rJ4t");
function injectStyle (ssrContext) {
  __webpack_require__("wP2W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad12d79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l+9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"videoList",attrs:{"id":"videoList","infinite-scroll-disabled":"finite","infinite-scroll-distance":"40"}},[_c('div',{staticClass:"et-tabhead"},[_c('span',{staticClass:"et-back",on:{"click":_vm.detail}},[_c('i',{staticClass:"icon-back"}),_vm._v("\n              详情\n            ")]),_vm._v(" "),_c('div',{staticClass:"et-tabtn"},[_c('div',{staticClass:"et-tabtn",attrs:{"id":"but-tabtn"}},[_c('span',{class:_vm.category?'btn-et-form et-form-on':'btn-et-form',on:{"click":function($event){_vm.form(1)}}},[_c('i',{staticClass:"icon-Recommend"}),_vm._v("推荐\n                ")]),_vm._v(" "),_c('span',{class:_vm.category?'btn-et-form':'btn-et-form et-form-on',on:{"click":function($event){_vm.form(0)}}},[_c('i',{staticClass:"icon-whole"}),_vm._v("全部\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"list show-box"},[_c('ul',{ref:"listL",staticClass:"show-list"},_vm._l((_vm.relatedVideoL),function(item,i){return (item)?_c('li',{staticClass:"video-border",staticStyle:{"margin-top":"10px"},on:{"click":function($event){_vm.water(item)}}},[_c('a',{attrs:{"href":"javascript:void(0);"}},[_c('div',{staticClass:"pic-box pic-margin"},[_c('img',{attrs:{"src":item.recommend_image+'?p=3&o=2&w=350&h=197'}}),_vm._v(" "),_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(item.file.time_span)))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("ellipsis")(item.file.title,14)))]),_vm._v(" "),(item.user.nick_name)?_c('div',{staticClass:"vode-user"},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":item.user.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(item.user.nick_name,9))+"\n            ")]):_c('div',{staticClass:"vode-user"},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":item.user.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(item.nickname,9))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"vote_bg"})]):_vm._e()})),_vm._v(" "),_c('ul',{ref:"listR",staticClass:"show-list"},_vm._l((_vm.relatedVideoR),function(item,i){return (item)?_c('li',{staticClass:"video-border",staticStyle:{"margin-top":"10px"},on:{"click":function($event){_vm.water(item)}}},[_c('a',{attrs:{"href":"javascript:void(0);"}},[_c('div',{staticClass:"pic-box pic-margin"},[_c('img',{attrs:{"src":item.recommend_image+'?p=3&o=2&w=350&h=197'}}),_vm._v(" "),_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(item.file.time_span)))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("ellipsis")(item.file.title,14)))]),_vm._v(" "),(item.user.nick_name)?_c('div',{staticClass:"vode-user"},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":item.user.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(item.user.nick_name,9))+"\n            ")]):_c('div',{staticClass:"vode-user"},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":item.user.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(item.nickname,9))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"vote_bg"})]):_vm._e()}))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.busy),expression:"busy"}],staticClass:"content index-content",staticStyle:{"padding-top":"0"}},[_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noMore),expression:"noMore"}],staticClass:"footer",staticStyle:{"text-align":"center","padding":"5px 0 10px 0","color":"#ccc","display":"none"}},[_vm._v("没有更多了")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id-content-inner"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l2Yr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"find"},[_c('div',{staticClass:"wrap fd-wrap"},[_c('activity',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],attrs:{"find":_vm.find,"infinite-scroll-disabled":"busy","infinite-scroll-distance":"200","infinite-scroll-throttle-delay":"1000"}}),_vm._v(" "),_c('div',{staticClass:"nav-bottom"},[_c('router-link',{staticClass:"icon-title",attrs:{"to":"/home"}},[_c('i',{staticClass:"icon-index"}),_vm._v("\n         推荐\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"icon-title",attrs:{"to":"/MyMessage"}},[_c('i',{staticClass:"icon-mine"}),_vm._v("\n        我的\n      ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"fd-sh-wrap",staticStyle:{"display":"none"}},[_c('div',{staticClass:"header fd-search"},[_c('div',{staticClass:"fd-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"fd-input-input",attrs:{"type":"text","placeholder":"活动名称"},domProps:{"value":(_vm.searchText)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value},_vm.myupfun]}}),_vm._v(" "),_c('i',{staticClass:"icon-search",on:{"click":_vm.search}})]),_vm._v(" "),_c('span',{staticClass:"cancel",on:{"click":_vm.cancel}},[_vm._v("取消")])])]),_vm._v(" "),_c('div',{staticClass:"overplay",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"back-top",staticStyle:{"display":"none"},on:{"click":_vm.fn}},[_vm._v("\n    返回顶部\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lFou":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_vue__ = __webpack_require__("mJiD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c3fc0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__ = __webpack_require__("TVK0");
function injectStyle (ssrContext) {
  __webpack_require__("mcqW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c3fc0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lH9b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "llRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userContenr_vue__ = __webpack_require__("BI2M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b43ddb16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userContenr_vue__ = __webpack_require__("alKE");
function injectStyle (ssrContext) {
  __webpack_require__("cbNo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userContenr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b43ddb16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userContenr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mJiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_footer_vue__ = __webpack_require__("YvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loginAler_vue__ = __webpack_require__("bckt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_voteAlert_vue__ = __webpack_require__("3NbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detailtmplate_vote__ = __webpack_require__("DUjB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detailtmplate_collection__ = __webpack_require__("BvAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__detailtmplate_release__ = __webpack_require__("yx2f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__detailtmplate_series__ = __webpack_require__("4H4o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__template_loading_vue__ = __webpack_require__("X4Q9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ID: '',
      NumberName: '10', // 显示条数
      twoNumbers: 2, // 轮播个数
      threeNumbers: 3, // 轮播个数
      contact: false, // 联系方式
      openOn: true,
      openText: '展开全文',
      textName: false,
      followOn: false, // 关注
      detailsTxte: '',
      progress: '', // 进展
      progressTitle: '', // 活动进展Title---
      progressName: '', // 进展数量
      marvellous: '', // 精彩图集
      marvellousTitle: '', // 精彩图集title---
      leavingName: [], //留言
      userId: '',
      nickname: '',
      poll: true,
      seriesName: 'false', // 是否留言
      leavingPage: 1,
      globalUrl: API.GlobalUrl,
      participate: true,
      aTitle: '成功',
      thirdParty: false,
      timer: null,
      joinWord: '我要参与',
      isSeries: false,
      activeStyle: '',
      myflashLoaded: false,
      agreeState: false

    };
  },

  filters: {
    msg: function msg(str) {
      str = str.replace(/\</g, '&lt;');
      str = str.replace(/\>/g, '&gt;');
      str = str.replace(/\n/g, '<br/>');
      str = str.replace(/\[em_([0-9]*)\]/g, '<img src="' + API.GlobalUrl + 'static/dist/arclist/$1.gif" border="0" />');
      return str;
    }
  },
  methods: {
    toHome: function toHome() {
      this.$router.push({ path: '/home' });
    },
    detail: function detail(type, id, route, customized, subUrl) {
      // 跳转详情页面
      if (customized == 2 || customized == 1) {
        this.$router.push({ name: 'Detail', params: { id: id } });
      } else {
        if (type == 2) {
          this.$router.push({ name: 'Notice', params: { id: id } });
        } else if (type == 3) {
          this.$router.push({ name: 'list_vote', params: { id: id, active: 1 } });
        } else {
          this.$router.push({ name: 'Detail', params: { id: id } });
        }
      }
    },
    video: function video(type, id, route, int, uuid) {
      if (type == 1) {
        this.$router.push({ name: 'Video', params: { id: id, uuid: uuid } });
      } else {
        this.$router.push({ name: 'list_image', params: { id: id, int: int } });
      }
    },
    water: function water(item) {
      this.data = new Date();
      this.$router.push({ name: 'VideoName', params: { id: item.activity_id, uuid: item.file_id, type: item.file_type } });
    },

    //登录
    determine: function determine() {
      $('#detailAlert').modal('hide');
    },
    contactFn: function contactFn() {
      var that = this;
      that.contact = !that.contact;
      if (that.contact) {
        $('.show-department').find('.detail-More').addClass('detail-MoreDeg');
      } else {
        $('.show-department').find('.detail-More').removeClass('detail-MoreDeg');
      }
    },

    // 关注
    fetchData: function fetchData() {
      window.location.reload();
    },
    follow: function follow() {
      // 点击关注按钮
      var that = this;
      if (!that.loginFn()) {
        if (!window.isThisClient('cbox')) {
          $('#login_Alert').modal('show');
          return false;
        }
      }
      if (that.followOn == false) {
        var add = {
          item_id: that.$route.params.id,
          type: '0'
        };
        that.$http.get(API.AddActivityFollow, { params: add }).then(function (res) {
          //console.log(res)
          if (res.code == 0) {
            that.followOn = true;
          } else if (res.code = '1001') {
            //$('#login_Alert').modal('show');
            //that.$router.push({name: 'login_Quick'})
          }
        });
      } else if (that.followOn == true) {
        var delFollo = {
          item_id: that.$route.params.id,
          type: '0'
        };
        that.$http.get(API.DelActivityFollow, { params: delFollo }).then(function (res) {
          if (res.code == 0) {
            that.followOn = false;
          } else if (res.code = '1001') {
            //$('#login_Alert').modal('show');
          }
        });
      }
    },

    //我要参与
    participateIn: function participateIn(router, id) {
      var that = this;
      if (!that.agreeState) {
        return;
      }
      var joinBtn = that.detailsTxte.page_config.joinBtn;
      if (that.loginFn()) {
        var routerName = '';
        if (router.playbill_small_h5) {
          routerName = router.playbill_small_h5;
        } else {
          routerName = router.playbill;
        }
        //判断参与和投票
        if (joinBtn && joinBtn.style == 1) {
          //参与
          this.$http.get(API.IsJoin, { params: { activity_id: id } }).then(function (res) {
            console.log(res);
            if (res.code == 0) {
              if (res.data.isJoin == 0) {
                that.$router.push({ name: 'Notice', params: { id: id } });
              } else if (res.data.child_sign && res.data.child_sign.is_show == "1") {
                // 只能参与一个子活动
                $("#msg_Alert").find(".info-mess").html(res.data.child_sign.title);
                $("#msg_Alert").modal();
              } else {
                // that.$router.push({name: 'myActivity_MyParticipate', params: {id: id}});
                that.$router.push({ name: 'Revise', params: { id: id, form_id: 0 } });
                return false;
              }
            } else {
              $('#login_Alert').modal('show');
            }
          });
        } else if (joinBtn.style == 2) {
          //投票
          that.$router.push({ name: 'list_vote', params: { id: id, active: 1 } });
        }
        // if ($('.dl-time').text().trim() != '活动已结束') {
        // 判读是否参加过


        // } else {
        //   alert('你要参与的活动已结束')
        // }
      } else {
        if (!window.isThisClient('cbox')) {
          $('#login_Alert').modal('show');
        }
      }
    },

    // 操作按钮事件
    Open: function Open() {
      // 点击“查看全文”按钮
      var that = this;
      this.openOn = !this.openOn;
      if (this.openOn == true) {
        this.openText = '展开全文';
      } else {
        this.openText = '收起全文';
        if (that.detailsTxte.trailer_config && that.detailsTxte.trailer_config.pub_uuid && !that.myflashLoaded) {
          // setTimeout(function () {
          that.myflashLoaded = true;
          that.textName = true;
          // var len = $('.video_left').length;
          var uuid = that.detailsTxte.trailer_config.pub_uuid;
          var W = $('#myFlash').width();
          var H = W / 1.78;
          that.VideoPlay(uuid, W, H, 'myFlash');
          // }, 500)
        }
      }
    },
    leavingMessage: function leavingMessage(ind) {
      // 留言查看更多dl-log-list
      if (!$('.dl-ms-more').eq(ind).hasClass('dl-ms-more-over')) {
        $('.dl-ms-more').eq(ind).parents('.dl-ms-log').css({ 'height': '100%' });
        $('.dl-ms-more').eq(ind).addClass('dl-ms-more-over');
      } else {
        $('.dl-ms-more').eq(ind).removeClass('dl-ms-more-over');
      }
    },
    moreFn: function moreFn() {
      var page = ++this.leavingPage;
      this.leavingFn(page);
    },
    leavingFn: function leavingFn(page) {
      // 留言
      var that = this;
      var Leaving = {
        app: 'xiyou',
        itemid: 'ishow_' + that.$route.params.id,
        // itemtype: '0',
        prepage: 10,
        avatar: 1,
        page: page,
        reply: 10
      };
      //xiyou
      $.getJSON('//common.newcomment.cntv.cn/data/list?jsonp_callback=?', Leaving, function (res) {
        //console.log(res)
        if (res.code == 0) {
          var content = res.data.content;
          var reply = res.data.reply;
          for (var m = 0; m < content.length; m++) {
            // (function(m){

            that.leavingName.push(content[m]);
            var pid = content[m].pid;
            var tip = content[m].tip;
            if (reply[pid]) {
              that.leavingName[m].replys = reply[pid].reverse();
            }
            //回复列表
            // var Reply = {
            //   app: 'xiyou',
            //   itemid: 'ishow_' + that.$route.params.id,
            //   replyid: pid
            // };
            // $.getJSON('http://common.newcomment.cntv.cn/comment/list?jsonp_callback=?', Reply, function (res) {
            //   if(res.code == 0){
            //     that.leavingName[m].replys = res.content;
            //   }
            // });
            // }(m));
          }
          if (content.length === 0 || that.leavingName.length == res.data.total) {
            $('.dl-ms-more').hide();
          }
        }
      });
    },
    interval: function interval(startTime) {
      //活动倒计时
      var that = this;
      var deta, detaTime;
      startTime = startTime.replace(/-/g, '/');
      var $btn = $('.dl-btn-join');
      var start = +new Date(startTime);
      this.timer = setInterval(function () {
        deta = start - new Date();
        if (deta > 0) {
          detaTime = +new Date(deta);
          setLeft(detaTime, $btn);
          console.log('timer');
        } else {
          clearInterval(that.timer);
          $btn.removeClass('dl-btn-active').html('<i class="icon-join"></i>' + that.joinWord);
        }
      }, 1000);

      function setLeft(leftTime, $btn) {
        var d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        var h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
        var m = Math.floor(leftTime / 1000 / 60 % 60);
        var s = Math.floor(leftTime / 1000 % 60);
        var str = geneStr({ d: d, h: h, m: m, s: s });
        $btn.html(str);
      }
      function geneStr(obj) {
        var str = '';
        if (obj.d > 0) {
          str += pre0(obj.d) + '天';
        }
        if (obj.d > 0 || obj.h > 0) {
          str += pre0(obj.h) + '时';
        }
        if (obj.d > 0 || obj.h > 0 || obj.m > 0) {
          str += pre0(obj.m) + '分';
        }
        if (obj.d > 0 || obj.h > 0 || obj.m > 0 || obj.s > 0) {
          str += pre0(obj.s) + '秒';
        }
        return str;
      }
      function pre0(t) {
        return t < 10 ? '0' + t : t;
      }
    },


    agree: function agree() {
      console.log("agree");
    }

  },
  components: { //渲染页面
    PointFooter: __WEBPACK_IMPORTED_MODULE_0__template_footer_vue__["a" /* default */],
    LoginAler: __WEBPACK_IMPORTED_MODULE_1__loginAler_vue__["a" /* default */],
    VoteAlert: __WEBPACK_IMPORTED_MODULE_2__template_voteAlert_vue__["a" /* default */],
    Vote: __WEBPACK_IMPORTED_MODULE_3__detailtmplate_vote__["a" /* default */],
    Collection: __WEBPACK_IMPORTED_MODULE_4__detailtmplate_collection__["a" /* default */],
    Release: __WEBPACK_IMPORTED_MODULE_5__detailtmplate_release__["a" /* default */],
    Series: __WEBPACK_IMPORTED_MODULE_6__detailtmplate_series__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_7__template_loading_vue__["a" /* default */]
  },
  // created() {
  //   var self = this;
  //   // self.fetchData();
  // },
  watch: {
    '$route.params.id': 'fetchData'
  },
  created: function created() {
    var that = this;
    var id = this.$route.params.id;
    that.ID = id;
    // 判断是否pc
    if (that.IsPC()) {
      window.location.href = API.IsPcName;
    }
    // 判断安卓机去掉动画
    that.isAndroid();
    if (!that.ID) {
      this.$router.push({ name: 'Home' });
    }
    $('html,body').css({ scrollTop: '0px' });
    //是否登录
    that.userId = that.getCookie('userSeqId') || '';
    if (that.userId) {
      var headPortrait = '//my.cntv.cn/intf/napi/api.php?cb=?&client=xiyou&method=user.getNickNameAndFace&userid=' + that.userId;
      //console.log(headPortrait)
      $.getJSON(headPortrait, function (res) {
        that.nickname = res.content.nickname;
      });
    }
    //是否关注
    // if (that.loginFn()) {
    that.$http.get(API.IsFollowByUserid, { params: { item_id: id } }).then(function (res) {
      if (res.code == '0') {
        if (res.data == 1) {
          that.followOn = true;
        }
      }
    });
    // }

    //活动详情
    if (window.isThisClient('cbox')) {
      that.cboxregisterhandler();
    }
    $(document).unbind("scroll");
    this.$http.get(API.GetActivitieById, { params: { id: id } }).then(function (res) {
      if (res.code == 0) {

        that.detailsTxte = res.data;
        console.log("detailsTxte:", that.detailsTxte);
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsCbox = sUserAgent.match(/cntv_app_client_cbox_mobile/i) == "cntv_app_client_cbox_mobile";
        var cBox = sUserAgent.match(/cntvcbox/i) == "cntvcbox";

        //活动下线
        if (!res.data.id) {
          that.$router.replace({ name: 'NotFound' });
        }

        if (bIsCbox || cBox) {
          $('.detail-header').hide();
        }

        if (that.ID == '100072') {
          $('.detail-header').hide();
        }

        if (!res.data || res.data.length == 0) {
          that.$router.push({ name: 'HomeIndex' });
        }

        if (that.detailsTxte.playbill_vertical) {
          setTimeout(function () {
            $('.detai-pic').hide();
          }, 1800);
        }

        that.$nextTick(function () {
          setTimeout(function () {
            $('#loading').hide();
          }, 1000);
          //是否 系列活动
          if (that.detailsTxte.type == 1) {
            that.isSeries = true;
            //$('.dl-btn-join').addClass('dl-btn-active');
          } else {
            var astyle = that.detailsTxte.page_config.joinBtn.style;
            if (astyle == 2) {
              that.detailsTxte.end_time = that.detailsTxte.vote_end_time;
              that.detailsTxte.start_time = that.detailsTxte.vote_start_time;
            }
            //是否进行中
            var dataTime = new Date(that.detailsTxte.end_time.replace(/-/g, '/')).getTime() / 1 /*+ 86400000 */ - new Date().getTime();
            var startTime = new Date(that.detailsTxte.start_time.replace(/-/g, '/')).getTime() / 1 - new Date().getTime();
            // startTime = new Date('2018-11-24 16:15:00').getTime() / 1 - new Date().getTime();
            that.joinWord = that.detailsTxte.page_config.joinBtn && that.detailsTxte.page_config.joinBtn.title || '我要参与';

            if (that.ID == '84203') {
              // $('.dl-btn-join').html('<i class="icon-join"></i>我要报名')
              that.joinWord = '我要报名';
            }
            if (dataTime > 0) {
              $('.pic-box-em').hide();
              //我要参加按钮
            } else {
              $('.dl-btn-join').addClass('dl-btn-active'); //.html('<i class="icon-join"></i>已结束');
              $('.pic-box-em').show();
              that.joinWord = '已结束';
              $('#Alert').find('.Prompt-p').html('活动已结束！');
              $('#Alert').modal('show');
            }
            if (startTime > 0) {
              $('.pic-box-em').hide();
              $('.dl-btn-join').addClass('dl-btn-active');
              //$('.dl-btn-join').html('<i class="icon-join"></i>即将开始');
              that.interval(that.detailsTxte.start_time);
              // that.interval('2018-1-24');
            }
          }

          // 征集活动
          /*  if (that.detailsTxte.type != 1) {
              // 是有报名表单项
              this.$http.get(API.GetActivityFormFields, {params: {activity_id: id}})
                .then(function (res) {
                  if (res.code == 0) {
                    if (res.data.length == 0) {
                      $('.dl-btn-join').addClass('dl-btn-active');
                      that.participate = false;
                    }
                  }
                });
            }*/
          // 背景颜色
          // console.log("detail");
          if (that.detailsTxte.background_img) {
            document.styleSheets[0].addRule('.detail::before', 'background: url("' + that.detailsTxte.background_img + '") no-repeat');
            document.styleSheets[0].insertRule('.detail::before { background: url("' + that.detailsTxte.background_img + '") no-repeat}', 0);
          } else {
            //
            // console.log("else");
            document.styleSheets[0].addRule('.detail::before', 'background: url(../dist/img/bzbg.jpg) no-repeat');
            document.styleSheets[0].insertRule('.detail::before { background: url(../dist/img/bzbg.jpg) no-repeat}', 0);
          }
          // 是否展示更多
          if ($('.dl-text').height() > 100) {
            that.textName = true;
          }
          // dl-mess-modal
          // 宣传片
          if (that.detailsTxte.detail == '' && that.detailsTxte.rule == '' && that.detailsTxte.feedback == '') {
            if (that.detailsTxte.trailer_config && that.detailsTxte.trailer_config.pub_title == '' && that.detailsTxte.trailer_config.pub_uuid == '') {
              $('.dl-mess-modal').hide();
              $('.detail-content').find('.dl-mess-last').css('margin-bottom', 0);
            } else {
              $('.dl-mess-modal').show();
            }
          } else {
            $('.dl-mess-modal').show();
          }

          if (that.detailsTxte.trailer_config && that.detailsTxte.trailer_config.pub_uuid) {
            that.myflashLoaded = true;
            that.textName = true;
            var uuid = that.detailsTxte.trailer_config.pub_uuid;
            var W = $('#myFlash').width();
            var H = W / 1.78;
            that.VideoPlay(uuid, W, H, 'myFlash');
          }

          // 宽高比例
          var banWimg = $('.dl-banner').width();
          var banHimg = Math.ceil($('.dl-banner').width() / 2);
          $('.dl-banner img').css({ width: banWimg, height: banHimg, visibility: 'visible' });

          var contact_info = that.detailsTxte.contact_info;
          // 判断联系方式模块是否显示
          if (contact_info) {
            if (contact_info.qq || contact_info.email || contact_info.phone || contact_info.weibo || contact_info.weixin) {} else {
              $('.detail-More').hide();
              $('.xians').hide();
            }
          } else {
            $('.detail-More').hide();
            $('.xians').hide();
          }

          // 判断是否是定制
          if (that.detailsTxte.type == 2) {
            window.location.href = that.detailsTxte.sub_url;
          }

          var pageConfig = that.detailsTxte.page_config;

          // 判断是否显示
          if (pageConfig) {

            //小程序屏蔽评论
            var ready = function ready() {
              if (window.__wxjs_environment === 'miniprogram') {
                $('.dl-message').hide();
                $('.dl-btn-joinTo').hide();
              }
            };

            // 免责声明
            if (pageConfig.accept && pageConfig.accept.is_show == 1) {
              that.agreeState = false;
            } else {
              that.agreeState = true;
            }

            if (pageConfig.cbox == 0) {
              $('.detail-header').hide();
            }
            //logo轮播
            if (pageConfig.top_view == 'slideshow') {
              var swiper1 = new Swiper('.banner', {
                pagination: '.swiper-pagination',
                paginationType: 'custom',
                paginationCustomRender: function paginationCustomRender(swiper, current, total) {
                  var lineWidth = 100 / total - 0.4;
                  var str = '';
                  for (var i = 0; i < total; i++) {
                    if (i == current - 1) {
                      str += '<span class="spanline-class spanline-active" style="width:' + lineWidth + '%"></span>';
                    } else {
                      str += '<span class="spanline-class" style="width:' + lineWidth + '%"></span>';
                    }
                  }
                  return str;
                },
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                autoplay: 4000,
                loop: true
              });
            }
            //头部 宣传片
            if (pageConfig.top_view == 'trailer' && that.detailsTxte.top_trailer.uuid) {
              var ZW = $('.banner-video').width();
              var uuid = $('#Trailer').attr('uuid'),
                  FH = ZW / 16 * 9,
                  W = ZW * 0.75,
                  H = W / 1.78;
              var dlH = ZW * 0.666;

              $('.banner-video').css({
                'height': dlH,
                'padding-top': (dlH - H) / 2 + 16 + 'px',
                'background': 'url(' + that.detailsTxte.top_trailer.img_path + ') no-repeat'
              });
              that.VideoPlay(uuid, W, H, 'Trailer');
            }

            //活动进展
            if (pageConfig.march && pageConfig.march.is_show == 1) {
              that.progressTitle = pageConfig.march.title;
              //活动进展
              var getRelatedVideo = {
                activity_id: id,
                page: 1,
                pagesize: 9
              };
              // 活动进展
              that.$http.get(API.GetRelatedVideo, { params: getRelatedVideo }).then(function (res) {
                if (res.code == 0) {
                  that.progressName = Math.floor(res.data.length / 2);
                  that.progress = res.data;
                  /* console.log(res)*/
                  // 图片比例
                  that.PictureRatio();
                  that.$nextTick(function () {
                    that.PictureRatio();
                    var swiperActivity = new Swiper('.show-activiy-swiper', {
                      loop: true
                    });
                  });
                } else {
                  console.log('活动进展-请求数据信息出错');
                }
              });
            }

            // 图片展示
            if (pageConfig.img && pageConfig.img.is_show == 1) {
              // 精彩图集
              that.marvellousTitle = pageConfig.img.title;
              // 精彩图集
              that.$http.get(API.FileRelatedVideo, {
                params: {
                  page: '1',
                  pagesize: '10',
                  type: '2',
                  activity_id: id,
                  version: 2
                }
              }).then(function (res) {
                //   console.log(res)
                if (res.code == 0) {
                  that.marvellous = res.data;
                  that.$nextTick(function () {
                    var spNum = $('.swiper-pic').find('img').length;
                    var swiperPic = new Swiper('.swiper-pic', {
                      slidesPerView: 'auto',
                      spaceBetween: 6,
                      loop: true,
                      loopedSlides: spNum
                    });
                  });
                } else {
                  console.log('精彩图集-请求数据信息出错');
                }
              });
            }
            //是否显示评论模块
            if (pageConfig.comment == 1) {
              //评论渲染
              // $('.dl-message').show();
              $('.dl-message').hide();
              //留言
              that.leavingFn(1);
            } else {
              $('.dl-message').hide();
              $('.dl-btn-joinTo').addClass('dl-btn-active');
            }
            if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
              document.addEventListener('WeixinJSBridgeReady', ready, false);
            } else {
              ready();
            }
          }
          // var script = document.createElement('script');
          // var head = document.getElementsByTagName('head')[0];
          // script.src = 'http://static.qr.cntv.cn/weixin/static/js/jssdk.js';
          //分享微信
          var title = '',
              desc = '',
              img = '';
          var obj = that.detailsTxte.share_config;
          var typeObj = '';
          if (obj instanceof Array) {
            if (obj.length > 0) {
              typeObj = true;
            } else {
              typeObj = false;
            }
          } else {
            if (that.detailsTxte.share_config) {
              typeObj = true;
            } else {
              typeObj = false;
            }
          }
          if (typeObj) {
            var activity = that.detailsTxte.share_config.activity;
            if (activity && activity.share_title) {
              title = activity.share_title;
            } else {
              title = that.detailsTxte.title;
            }
            if (activity && activity.share_contents) {
              desc = activity.share_contents;
            } else {
              desc = $('.dl-text').text();
            }
            if (activity && activity.share_pic) {
              img = activity.share_pic;
            } else {
              if (that.detailsTxte.playbill && that.detailsTxte.playbill.playbill_h5) {
                img = that.detailsTxte.playbill.playbill_h5;
              }
            }
          } else {
            title = that.detailsTxte.title;
            desc = $('.dl-text').text();
            if (that.detailsTxte.playbill && that.detailsTxte.playbill.playbill_h5) {
              img = that.detailsTxte.playbill.playbill_h5;
            } else {
              img = that.detailsTxte.playbill.playbill;
            }
          }
          document.title = title;
          var metas = $('head').children('meta');
          if (metas[1]) {
            metas[1].content = desc;
          }
          console.log(img);
          if (img == '') {
            img = that.detailsTxte.playbill.playbill_h5 || that.detailsTxte.playbill.playbill;
          }
          console.log(img);
          var dataName = {
            title: title,
            desc: that.removeTAG(desc, 110),
            imgAddress: img,
            Retain: '', //保留
            url: window.location.href
          };
          that.weixinShare(dataName);
          if (window.isThisClient('cbox')) {
            // window.ShareCbox({title:title, contents: that.removeTAG(desc, 110),pic: img,url: window.location.href});
            that.cboxShare(img, window.location.href, title, that.removeTAG(desc, 110));
          }
        });
        //活动是否结束
        if ($('.dl-time').text().trim() == '活动已结束') {
          $('.dl-but-join').addClass('dl-btn-off');
        }

        //埋码统计
        var stcode = that.detailsTxte.code;
        if (stcode) {
          stcode = JSON.parse(stcode);
        }
        var q = window.goldlog_queue || (window.goldlog_queue = []);
        q.push({
          action: 'goldlog.sendPV',
          arguments: [
          // 必填的配置项
          {
            is_auto: false
          },
          // 可选的自定义参数
          {
            ch_id: stcode && stcode.code && stcode.code.channel_code || 'EPGC1386744804340101',
            col_id: stcode && stcode.code && stcode.code.program_code || 'EPGM1387361853673102'
          }]
        });
      } else {
        that.$router.push({ name: 'HomeIndex' });
      }
    });
    //是否点击活动
    if (this.id == '') {
      this.$router.push({ name: 'Home' });
    }
  },

  mounted: function mounted() {
    // 操作DOM
    // 返回事件
    var that = this;
    $('body').attr('style', '');

    function getCookie(name) {
      var arr = document.cookie.split('; ');
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=');
        if (arr2[0] == name) {
          return arr2[1];
        }
      }
      return '';
    }

    var that = this,
        id = this.$route.params.id;
    setTimeout(function () {
      // 表情
      // poster的高度
      // 留言点赞
      $('.dl-message').on('click', '.dl-head-like', function () {
        if ($(this).hasClass('dl-head-like-over')) {
          $(this).find('em').removeClass('em-animt');
          $(this).removeClass('dl-head-like-over').find('span').html(Number($(this).find('span').html()) - 1);
        } else {
          $(this).find('em').addClass('em-animt');
          $(this).addClass('dl-head-like-over').find('span').html(Number($(this).find('span').html()) + 1);
        }
      });

      //关闭留言框面板
      $('.dl-ms-btn').on('click', function () {
        $('#saytext').val('');
        $('.detail-messagebox').css({ 'top': '120%' });
      });

      // 打开留言面板
      $('.detail').on('click', '.dl-ms-edit', function () {
        if (that.loginFn()) {
          console.log('判断是否登录-已登录');
        } else {
          $('#login_Alert').modal('show');
          // that.$router.push({name: 'login_Quick'})
          return false;
        }
        $('.emotion').qqFace({
          id: 'facebox',
          assign: 'saytext',
          path: API.GlobalUrl + '/static/dist/arclist/' //表情存放的路径
        });
        $('#saytext').val('');
        $('.detail-messagebox').css({ 'top': '0' });
        $('.btn-detail-edit').removeClass('btn-detail-reply');
      });
      var PID = '',
          TID = '';
      //回复留言 打开留言面板
      $('.dl-message').on('click', '.icon-ms-reply', function (e) {
        e.stopPropagation();
        if (that.loginFn()) {
          console.log('判断是否登录-已登录');
        } else {
          $('#login_Alert').modal('show');
          return false;
        }
        $('.emotion').qqFace({
          id: 'facebox',
          assign: 'saytext',
          path: API.GlobalUrl + '/static/dist/arclist/' // 表情存放的路径
        });
        PID = $(this).attr('attr-pid');
        TID = $(this).attr('attr-tip');
        $('#saytext').val('');
        $('.detail-messagebox').css({ 'top': '0' });
        $('.btn-detail-edit').addClass('btn-detail-reply');
      });
      var intervaLock;
      $('.btn-detail-edit').on('click', function () {
        if ($('#saytext').val() != '') {
          //回复留言
          if ($('.btn-detail-edit').hasClass('btn-detail-reply')) {
            var Leaving = {
              app: 'xiyou',
              itemid: 'ishow_' + that.$route.params.id,
              replyid: PID, // pid
              tid: TID,
              author: that.nickname, // 用户名
              authorid: that.userId, // 用户id
              message: $('#saytext').val()
            };
            //console.log(Leaving)
            $.ajax({
              type: 'post',
              url: '//newcomment.cntv.cn/comment/post',
              data: Leaving,
              dataType: 'jsonp',
              xhrFields: {
                withCredentials: true
              },
              jsonp: 'jsonp_callback',
              success: function success(res) {
                // console.log(res)
                if (res.code == 0) {
                  $('.detail-messagebox').css({ 'top': '120%' });
                  $('#chatModal').modal('show');
                  intervaLock = setTimeout(function () {
                    $('#chatModal').modal('hide');
                  }, 2000);
                } else if (res.code == '20927') {
                  var userSeqId = getCookie('userSeqId');
                  var urlHref = window.location.href;
                  var url = 'http://reg.cctv.com/authenicateAction/mobile/bind.html?service=' + urlHref + '&iid=' + id + '&formFlag=3&userSeqId=' + userSeqId + '&flag=H5';
                  window.location.href = url;
                }
              }
            });
            //发布留言
          } else {
            var Leaving = {
              app: 'xiyou',
              itemid: 'ishow_' + that.$route.params.id,
              authorid: that.userId,
              author: that.nickname,
              message: $('#saytext').val()
            };
            //  console.log(Leaving)
            $.ajax({
              type: 'post',
              url: '//newcomment.cctv.com/comment/post',
              data: Leaving,
              dataType: 'jsonp',
              xhrFields: {
                withCredentials: true
              },
              crossDomain: true,
              jsonp: 'jsonp_callback',
              success: function success(res) {
                //console.log(res)
                if (res.code == 0) {
                  $('.detail-messagebox').css({ 'top': '120%' });
                  $('#chatModal').modal('show');
                  intervaLock = setTimeout(function () {
                    $('#chatModal').modal('hide');
                  }, 2000);
                } else if (res.code == '20927') {
                  var userSeqId = getCookie('userSeqId');
                  var url = 'http://reg.cctv.com/authenicateAction/mobile/bind.html?service=' + API.UrlName + '/h5/index&iid=' + id + '&formFlag=3&userSeqId=' + userSeqId + '&flag=H5';
                  window.location.href = url;
                }
              },
              error: function error() {
                // alert('请求出错！');
              }
            });
          }
        }
      });
      $('.detail').on('click', '.dbroadcast', function () {
        var item = JSON.parse($(this).attr('attr-item'));
        var type = $(this).attr('attr-type');
        that.detail(item.url, item.id, item.img_path, item.type, item.sub_url);
      });

      if (window.isThisClient('cbox') && that.ID == '100071') {
        $('#pos').hide();
      }
      // 安卓 ios判断
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

      if (isAndroid) {
        //安卓
        $('.show-dl-download img').attr('src', 'http://static.qr.cntv.cn/ishow/images/wx-android.jpg');
      }
      if (isiOS) {
        //ios
        $('.show-dl-download img').attr('src', 'http://static.qr.cntv.cn/ishow/images/wx-ios.jpg');
      }
      // isIPhoneX()

      function isIPhoneX(fn) {
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isIOS) {
          if (screen.height == 812 && screen.width == 375) {
            $('.detail-bottom').css('bottom', '20px');
            $('.detail-bottom-ipx').show();
          } else {
            //不是iphoneX
            $('.detail-bottom-ipx').hide();
          }
        }
      }

      // 视频尺寸
      $('#my-video').width($('.dl-video-pic').width());
      $('#my-video').height($('.dl-video-pic').width() / 16 * 9);
      that.PictureRatio();
    }, 400);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "mcqW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n7la":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "nYIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__ = __webpack_require__("ERql");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b12fdf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_vue__ = __webpack_require__("iwob");
function injectStyle (ssrContext) {
  __webpack_require__("vHPj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b12fdf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o1H1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notice_vue__ = __webpack_require__("c72D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45baca86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notice_vue__ = __webpack_require__("wXXZ");
function injectStyle (ssrContext) {
  __webpack_require__("6sZU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45baca86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p+jy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pTbw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_find_vue__ = __webpack_require__("XtEi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268d1848_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_find_vue__ = __webpack_require__("l2Yr");
function injectStyle (ssrContext) {
  __webpack_require__("KGJr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_find_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268d1848_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_find_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pjeT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("UiOb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_746e64b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("5eia");
function injectStyle (ssrContext) {
  __webpack_require__("tH3c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_746e64b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q8Ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userName: '', //userN
      password: '', //password
      //thirdParty: navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1? false : true,
      thirdParty: true
    };
  },

  methods: {
    //操作按钮事件
    fn: function fn() {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'home' });
      } else {
        this.$router.back(-1);
      }
    }
  },
  mounted: function mounted() {
    // var form=$document.forms['eg']；
    var that = this;
    // 判断是否是小程序
    function ready() {
      if (window.__wxjs_environment === 'miniprogram') {
        that.thirdParty = false;
      }
    }
    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', ready, false);
    } else {
      ready();
    }
    //操作DOM
    $('.group-info').on('click', 'a', function () {
      if (document.getElementById('username').value == '') {
        //document.getElementById('username').style.display='';
        $('.uname').css('display', 'block');
        return;
      } else {
        $('.uname').css('display', 'none');
      }
      if (document.getElementById('password').value == '') {
        $('.upass').css('display', 'block');
        return;
      } else {
        $('.upass').css('display', 'none');
      }

      document.getElementById('punishformID')['from'] = '';

      passport.checkJsonpForm(document.getElementById('punishformID'), function (result) {
        var msg = result.msg; //提示信息
        var errorCode = result.errorCode; //错误码，i18n展示用
        if (passport.usernameError == result.type) {
          //如果是用户名有问题
          //alert(msg)
          $('.upass').css('display', 'block');

          $('#password').val('');
          //在用户名的位置展示错误提示信息
        } else if (passport.passwordError == result.type) {
          //如果是密码有问题
          //alert(msg)
          $('.uname').css('display', 'block');
          $('#password').val('');
          //在密码的位置展示错误提示信息
        } else if (passport.success == result.type) {
          //登录成功

          //处理用户id：result.usrid 或者 result.user_seq_id
          // that.setCookie('userSeqId', result.user_seq_id);//打包时要注释
          // that.$router.push({name: 'home'});
          that.$router.push({ name: 'MyMessage' });
        }
      });
    });
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "qAJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      MobilePhone: '',
      checked: false
    };
  },

  methods: {
    //操作按钮事件
    fn: function fn() {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'home' });
      } else {
        this.$router.back(-1);
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    //操作DOM
    $('.modal-backdrop').remove();
    // checkbok 选中函数
    $('.check-box').on('click', function () {
      if ($(this).hasClass('oncheck')) {
        $(this).removeClass('oncheck');
      } else {
        $(this).addClass('oncheck');
      }
    });

    $('.picyz').click(function () {
      $(this).attr('src', 'http://reg.cctv.com/simple/verificationCode.action?v=' + Math.random());
    });
    //发送验证码
    $('.puts').click(function () {
      $('#img-yzm-mess').hide();
      $('#MobilePhone-mess').hide();
      var acc = $('#MobilePhone').val(); //账号
      var yzm_img = $('#img_yzm').val(); //图形验证码
      var num = 180;
      if (!acc) {
        $('#MobilePhone-mess').show();
        $('#MobilePhone-mess').html('请输入手机号');
        return;
      }
      if (acc.match(/^1[3|5|7|8|9|][0-9]{9}$/) !== null || acc.match(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/) !== null) {} else {
        $('#MobilePhone-mess').show();
        $('#MobilePhone-mess').html('手机号格式不正确');
        return;
      }
      if (!yzm_img) {
        $('#img-yzm-mess').show();
        $('#img-yzm-mess').html('请输入图形验证码');
        return;
      }
      $.ajax({
        url: 'http://reg.cctv.com/regist/getVerifiCode.action',
        data: {
          method: 'getRequestVerifiCodeM',
          mobile: acc,
          verfiCodeType: 1,
          verificationCode: yzm_img,
          isCheckCode: 0
        },
        dataType: 'jsonp',
        success: function success(mes) {
          if (mes.errtype == 'success') {
            $('.puts').unbind('click');
            var set = setInterval(function () {
              num = num - 1;
              $('.btn-yzm').html(num + '秒后获取');
              if (num == 0) {
                $('.btn-yzm').html('发送验证码');
                getcode();
                clearInterval(set);
              }
            }, 1000);
          }
          if (mes.errtype == 'mobilecodeerror') {
            $('#yzm-img').show();
            $('#yzm-img').html(mes.errmsg);
            $(this).attr('src', 'http://reg.cctv.com/simple/verificationCode.action?v=' + Math.random());
          }
          if (mes.errtype == 'ipsendagain') {
            $('#yzm-img').show();
            $('#yzm-img').html('验证过于频繁,请稍后重试');
          }
          if (mes.errtype == 'mobileoften') {
            $('#yzm-img').show();
            $('#yzm-img').html('验证过于频繁,请稍后重试');
          }
          if (mes.errtype == 'registered') {
            $('#phone-mess').show();
            $('#phone-mess').html(mes.errmsg);
          }
          if (mes.errtype == 'sendagain') {
            $('#yzm-mess').show();
            $('#yzm-mess').html('验证过于频繁,请稍后重试');
          }
        }
      });
    });
    //完成按钮事件函数
    $('#reback').click(function () {

      $('#MobilePhone-mess').hide();
      $('#yzm-mess').hide();
      $('#pass-mess').hide();
      $('#repass-mess').hide();
      $('#img-yzm-mess').hide();
      $('#xieyi-mess').hide();

      var url = encodeURI('http://ishow.xiyou.cctv.com/');
      var phone = that.MobilePhone;
      var acc = $('#MobilePhone').val(); //账号
      var yzm_data = $('#yzm').val(); //手机验证码
      var pass = $('#pass').val(); //密码
      var repass = $('#repass').val(); //确认密码
      var yzm_img = $('#img_yzm').val(); //图形验证码
      var yzm = $('#yzm').val(); //手机验证码
      var num = 180;

      if (!acc) {

        $('#MobilePhone-mess').show();
        $('#MobilePhone-mess').html('手机号格式不正确');
        return;
      }
      if (acc.match(/^1[3|5|7|8|9|][0-9]{9}$/) !== null || acc.match(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/) !== null) {} else {
        $('#MobilePhone-mess').show();
        $('#MobilePhone-mess').html('请输入手机号');
        return;
      }
      if (pass.length < 6 || pass.length > 20) {
        $('#pass-mess').show();
        $('#pass-mess').html('请输入6-20位的密码');
        return;
      } else {
        $('#pass-mess-email').hide();
      }
      if (pass != repass) {
        $('#repass-mess').show();
        $('#repass-mess').html('两次输入密码不一致');
        return;
      } else {
        $('#repass-mess').hide();
      }

      if (!yzm_img) {
        $('#img-yzm-mess').show();
        $('#img-yzm-mess').html('请输入图形验证码');
        return;
      }

      if ($('.group-terms').find('.oncheck').length == 0) {
        $('#xieyi-mess').show();
        $('#xieyi-mess').html('请同意使用协议');
        return;
      }
      if ($('#yzm').val() == '') {
        $('.text-danger').show();
        return;
      }
      $.ajax({
        url: 'https://reg.cctv.com/regist/resetPasswdByMobile.action',
        data: {
          mobile: that.MobilePhone,
          verfiCode: yzm,
          passWd: pass,
          from: url
        },
        dataType: 'jsonp',
        jsonp: 'callback',
        success: function success(mes) {
          console.log(mes);
          if (mes.errtype == '0' || mes.msg == '成功') {
            that.$router.back(-1);
          }
          if (mes.errtype == 'registered') {
            $('#yzm-mess').show();
            $('#yzm-mess').html(mes.errmsg);
          }
          if (mes.errtype == 'error') {
            $('#yzm-mess').show();
            $('#yzm-mess').html(mes.errmsg);
          }
          if (mes.errtype == 'timeout') {
            $('#yzm-mess').show();
            $('#yzm-mess').html(mes.errmsg);
          }
        }
      });
    });
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "qEs0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qtTc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rGgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"header index-header home-header"},[_c('div',{staticClass:"nav"},_vm._l((_vm.channel),function(item,ind){return _c('a',{class:_vm.navOn == item.id?'id-nav-recom nav-on':'id-nav-recom',attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.fnTable(item.id)}}},[_vm._v("\n        "+_vm._s(item.slug)+"\n      ")])}))]),_vm._v(" "),_c('router-view',{staticStyle:{"margin-bottom":"5px"}}),_vm._v(" "),_c('div',{staticClass:"nav-bottom"},[_c('router-link',{staticClass:"nav-on",attrs:{"to":"/home"}},[_c('i',{staticClass:"icon-index"}),_vm._v("\n      发现\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"icon-title",attrs:{"to":"/mymessage"}},[_c('i',{staticClass:"icon-mine"}),_vm._v("\n      我的\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"overplay",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.upward),expression:"upward"}],staticClass:"back-top",on:{"click":_vm.returnTop}},[_vm._v("\n    返回顶部\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rJ4t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"login-header video-title",staticStyle:{"height":"40px"}},[_c('i',{staticClass:"icon-backVideo"},[_c('span',{staticStyle:{"font-size":"16px","font-style":"normal","display":"inline-block","width":"80px","padding-top":"15px"},on:{"click":function($event){_vm.fn()}}})])]),_vm._v(" "),_c('div',{staticClass:"video-box"},[_c('h5',{staticClass:"v-tit",staticStyle:{"padding":"0"},attrs:{"id":"v-tit"}}),_vm._v(" "),_c('div',{staticClass:"video_left",attrs:{"id":"myFlash"}}),_vm._v(" "),_c('div',{staticClass:"v-play"},[(_vm.videoDetails)?_c('div',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.videoDetails.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"play-up",on:{"click":function($event){_vm.playup(_vm.videoDetails.uuid)}}},[_c('em',[_vm._v("+1")]),_c('i',{staticClass:"icon-up"}),_c('span',[_vm._v(_vm._s(_vm.videoDetails.favorite_num))])])])]),_vm._v(" "),_c('div',{staticClass:"content video-content"},[_c('div',{staticClass:"content-scroll"},[_c('div',{staticClass:"video-content-up"},[_c('div',{staticClass:"video-activity"},[_c('div',{staticClass:"v-head",on:{"click":_vm.movableRetraction}},[(_vm.detailsTxte.playbill)?_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.detailsTxte.playbill.playbill_small_h5,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"title-cell"},[_c('p',[_vm._v(_vm._s(_vm.detailsTxte.title))])])])])]),_vm._v(" "),(_vm.videoDetails)?_c('div',{staticClass:"line-gray"}):_vm._e(),_vm._v(" "),(_vm.videoDetails)?_c('div',{staticClass:"show-box"},[_c('div',{staticClass:"show-department"},[_c('div',{staticClass:"show-dl-top clearfix",on:{"click":_vm.contactFn}},[_c('h5',{staticClass:"detail-hostunit",staticStyle:{"width":"100%","max-width":"100%"}},[(_vm.videoDetails.nickname)?_c('h3',[_vm._v("作品描述\n                  "),_c('a',{staticClass:"mess-more",attrs:{"href":"javascript:void(0);"}}),_vm._v(" "),_c('i',{staticClass:"icon-user"}),_c('span',{staticStyle:{"color":"#888","font-weight":"500","font-size":"14px"}},[_vm._v(_vm._s(_vm.videoDetails.nickname))])]):_c('h3',[_vm._v("作品描述\n                  "),_c('a',{staticClass:"mess-more",attrs:{"href":"javascript:void(0);"}}),_vm._v(" "),_c('i',{staticClass:"icon-user"}),_c('span',{staticStyle:{"color":"#888","font-weight":"500","font-size":"14px"}},[_vm._v(_vm._s(_vm.videoDetails.user.nick_name))])]),_vm._v(" "),_c('p',{staticClass:"videoDetails-p",staticStyle:{"white-space":"normal","height":"0","line-height":"20px","color":"#666"}},[_c('span',{staticClass:"videoDetails-span",staticStyle:{"line-height":"24px"}},[_vm._v(_vm._s(_vm.videoDetails.description))])])])])])]):_vm._e(),_vm._v(" "),(_vm.progress)?_c('div',{staticClass:"line-gray"}):_vm._e(),_vm._v(" "),(_vm.progress.length > 0)?_c('div',{staticClass:"show-box"},[_c('h5',{staticClass:"show-tit"},[_vm._v("相关视频")]),_vm._v(" "),_c('div',{staticClass:"show-v-box"},[_c('ul',{staticClass:"show-list show-list-less"},_vm._l((_vm.progress),function(val){return _c('li',[_c('router-link',{attrs:{"tag":"a","to":{name:'Video',params: {id: val.activity_id, uuid: val.file_id}}}},[_c('div',{staticClass:"pic-box"},[_c('img',{attrs:{"src":val.file.thumb_url,"alt":""}}),_vm._v(" "),_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(val.file.time_span)))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(val.file.title))]),_vm._v(" "),(val.file.nickname)?_c('div',{staticClass:"vode-user",staticStyle:{"margin-bottom":"10px"}},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":val.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(val.file.nickname,15))+"\n                  ")]):_c('div',{staticClass:"vode-user",staticStyle:{"margin-bottom":"10px"}},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":val.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(val.file.user.nick_name,15))+"\n                  ")])])],1)})),_vm._v(" "),_c('ul',{staticClass:"show-list show-list-all",staticStyle:{"display":"none"}},_vm._l((_vm.progress2),function(val){return _c('li',[_c('router-link',{attrs:{"tag":"a","to":{name:'Video',params: {id: val.activity_id, uuid: val.file_id}}}},[_c('div',{staticClass:"pic-box"},[_c('img',{attrs:{"src":val.file.thumb_url,"alt":""}}),_vm._v(" "),_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(val.file.time_span)))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(val.file.title))]),_vm._v(" "),(val.file.nickname)?_c('div',{staticClass:"vode-user",staticStyle:{"margin-bottom":"10px"}},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":val.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(val.file.nickname,10))+"\n                  ")]):_c('div',{staticClass:"vode-user",staticStyle:{"margin-bottom":"10px"}},[_c('i',{staticClass:"icon-mine"},[_c('img',{attrs:{"src":val.face_url,"alt":""}})]),_vm._v(_vm._s(_vm._f("ellipsis")(val.file.user.nick_name,10))+"\n                  ")])])],1)})),_vm._v(" "),(_vm.progress.length > 3)?_c('p',{staticClass:"show-v-more"},[_c('i',{staticClass:"icon-vs-show",on:{"click":_vm.relatedVideo}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"swiper-container"})]):_vm._e()]),_vm._v(" "),_c('PointFooter')],1),_vm._v(" "),_c('div',{staticClass:"video-content-down"},[_c('div',{staticClass:"video-activity",on:{"click":_vm.activityDeployment}},[_c('div',{staticClass:"v-head"},[_c('div',{staticClass:"title title-down"},[_c('div',{staticClass:"title-cell title-down-cell"},[_c('p',[_vm._v(_vm._s(_vm.detailsTxte.title))])])]),_vm._v(" "),_c('a',{staticClass:"mess-more rotate-more",attrs:{"href":"javascript:void(0);"}})])]),_vm._v(" "),_c('div',{staticClass:"v-mess"},[_c('div',{staticClass:"v-link"},[_c('span',[_vm._v("简介：")]),_vm._v(" "),_c('div',{staticClass:"hg-4",domProps:{"innerHTML":_vm._s(_vm.detailsTxte.description)}})]),_vm._v(" "),_c('div',{staticClass:"v-link"},[_c('span',[_vm._v("时间：")]),_vm._v(" "),_c('div',{staticClass:"hg-1"},[_vm._v(_vm._s(_vm.detailsTxte.start_time)+" - "+_vm._s(_vm.detailsTxte.end_time))])]),_vm._v(" "),_c('div',{staticClass:"v-link"},[_c('span',[_vm._v("发起：")]),_vm._v(" "),(_vm.detailsTxte.hostunit)?_c('div',{staticClass:"hg-1"},[_vm._v(_vm._s(_vm.detailsTxte.channel_title)+" "+_vm._s(_vm.detailsTxte.column_name)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('router-link',{staticClass:"btn-detail",attrs:{"to":{name:'Detail',params: {id: _vm.detailsTxte.id}}}},[_vm._v("\n          活动详情\n        ")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rkZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discoverys"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content index-content",staticStyle:{"padding-top":"0","margin-bottom":"54px","text-align":"center","font-size":"16px","color":"#888"}},[(_vm.busyDis)?_c('div',{staticClass:"id-content-inner"},[_vm._m(1)]):_c('div',{staticStyle:{"padding":"10px 0","text-align":"center","font-size":"14px"}},[_vm._v("到底了")])]),_vm._v(" "),_c('div',{staticClass:"nav-bottom",staticStyle:{"z-index":"8"}},[_c('router-link',{staticClass:"icon-title",attrs:{"to":"/home"}},[_c('i',{staticClass:"icon-index"}),_vm._v("\n      发现\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"icon-title",attrs:{"to":"/MyMessage"}},[_c('i',{staticClass:"icon-mine"}),_vm._v("\n    我的\n    ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix discovery",attrs:{"id":"containerDis"}},[_c('ul',{staticClass:"col",staticStyle:{"padding-right":"5px"}}),_vm._v(" "),_c('ul',{staticClass:"col",staticStyle:{"padding-right":"5px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-pulse",staticStyle:{"display":"block"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sgEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['UpFile', 'type', 'id', 'countArr', 'appId', 'audit_level'],
    data: function data() {
        return {
            uptoken: '',
            fileId: '',
            fileName: 0,
            arrayName: [],
            arrayVideo: [],
            allchannel: [],
            scrill: true,
            page: 1,
            key: '',
            allTyle: false,
            arrayUuid: [],
            numberSize: 0,
            MyUploadVideo: [],
            typeNmae: '',
            moreInfo: false,
            classObj: {
                active: false,
                'down-arrow': false,
                all: false,
                elips: false
            },
            upfileTip: ''

        };
    },

    methods: {
        //操作按钮事件
        allTetx: function allTetx() {
            if (!this.moreInfo) return;
            this.allTyle = !this.allTyle;
            if (this.allTyle == true) {
                // $('.et-video-info').css('white-space','normal');
                this.classObj = {
                    active: true,
                    'down-arrow': true,
                    all: true
                    // elips: false,
                };
                this.upfileTip = this.UpFile.tip;
            } else {
                // $('.et-video-info').css('white-space','nowrap');
                this.classObj = {
                    active: false,
                    'down-arrow': true,
                    all: false
                    // elips: true,
                };
                this.upfileTip = this.UpFile.tip.substr(0, 50) + '...';
            }
        },
        fn: function fn() {
            var that = this;
            $('#uploadFile').modal('show');
            this.$http.get(API.GetUploadFileForMe, { params: { file_type: '1', page: '1', pagesize: '10', status: 'pass' } }).then(function (res) {
                if (res.code == '0') {
                    for (var i = 0; i < res.data.length; i++) {
                        that.allchannel.push(res.data[i]);
                    }
                    that.$nextTick(function () {
                        setTimeout(function () {
                            var picWimg = $('.pic-box').width();
                            var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                            $('.pic-box').css('height', picHimg);
                            $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
                        }, 200);
                    });
                }
            });
        },

        // Uptoken(){
        //     var that = this;
        //     this.$http.get(API.UploadToken,{params: {activity_id: that.$route.params.id,app_id: that.appId}})
        //         .then(function (res) {
        //             console.log(res);
        //             if (res.code == 1 || res.data.userId == null) {
        //                 that.uptoken = ''
        //             } else {
        //                 that.key = res.data.fileId;
        //                 that.fileId = res.data.fileId;
        //                 that.uptoken = res.data.uptoken
        //             }
        //         })
        //     that.up
        // },
        cancel: function cancel() {
            $('#uploadModal').modal('hide');
            $('#Textvideo').val('');
            $('#Textareavideo').val('');
            $('#select').val('');
        },
        updateFile: function updateFile(idx) {
            this.arrayUuid.splice(idx, 1);
            this.arrayName.splice(idx, 1);
            this.fileName--;
            if (this.numberSize > this.arrayName.length + this.MyUploadVideo.length) {
                $('#videoContainer').show();
            }
        },
        delFile: function delFile(idx) {
            this.MyUploadVideo.splice(idx, 1);
            if (this.numberSize > this.arrayName.length + this.MyUploadVideo.length) {
                $('#videoContainer').show();
            }
        },
        initMoreInfo: function initMoreInfo() {
            var pinfo = this.$refs.p_info;
            if (pinfo) {
                var offH = pinfo.offsetHeight;
                var scrollH = pinfo.scrollHeight;
                // console.log(pinfo,offH,scrollH);
                if (scrollH > offH) {
                    this.moreInfo = true;
                    this.classObj = {
                        active: false,
                        all: false,
                        // elips:true,
                        'down-arrow': true
                    };
                    this.upfileTip = this.UpFile.tip.substr(0, 50) + '...';
                }
            }
        }
    },

    created: function created() {
        this.upfileTip = this.UpFile.tip;
    },
    mounted: function mounted() {
        //操作DOM
        var that = this,
            subscription;
        var id = this.$route.params.id;
        that.typeNmae = that.UpFile.field_type;
        this.initMoreInfo();
        // if (this.UpFile.field_type == 'uploadvideo') {
        if (that.UpFile.choose_num == '0') {
            $('.uploadVideo').hide();
            return false;
        }
        /*  this.$http.get(API.GetUploadFileForMe,{params: {file_type: '1',page: '1',pagesize: '10',status: 'pass'}})
            .then(function (res) {
              if (res.code == '0') {
                if(res.data.length == 0){
                  $('.uploadVideoShow').hide()
                }
              }
            });*/
        if (that.type != 0) {
            that.ByUserid = {
                file_type: 1,
                activity_id: that.id
            };
            // console.log( that.ByUserid )
            this.$http.get(API.GetActivityFileByUserid, { params: that.ByUserid }).then(function (res) {
                //  console.log(res)
                if (res.code == 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        that.MyUploadVideo.push(res.data[i]);
                        // console.log(i)
                    }
                }
                that.arrayUuid = [];
                that.arrayName = [];
                that.fileName = 0;
                if (!that.UpFile.choose_num) {
                    that.numberSize = 1;
                } else {
                    that.numberSize = that.UpFile.choose_num;
                }
                if (that.numberSize == '' || that.numberSize == null || that.numberSize <= res.total) {
                    $('#videoContainer').hide();
                }
            });
        } else {
            that.numberSize = that.UpFile.choose_num;
        }
        //that.Uptoken();
        // }
        $('#select').unbind().change(function () {
            $('#Textareavideo').val('');
            if (id == '100071' || that.id == '100071') {
                $('#Textvideo').val('我的观后感');
            } else [$('#Textvideo').val('')];
            var file = this.files[0]; //文件
            var key = file.name; //文件总名
            var name = key.split('.');
            var ext = name[name.length - 1].toLowerCase();
            // var ext =  key.split('.')[1].toLowerCase();

            if (ext != 'mkv' && ext != 'm4v' && ext != 'dv' && ext != 'dvix' && ext != 'hlv' && ext != 'f4v' && ext != 'dat' && ext != 'wmv' && ext != 'mpg' && ext != 'mpeg' && ext != 'avi' && ext != 'mp4' && ext != '3gp' && ext != 'rm' && ext != 'rmvb' && ext != 'mov' && ext != 'flv' && ext != 'asf') {
                $('#uploadVideo-al .detailAlert-p').html('上传格式错误');
                $('#uploadVideo-al').modal('show');
                return false;
            }
            var fileSize = file.size / 1024 / 1024 / 1024;
            if (fileSize > 20) {
                $('#uploadVideo-al .detailAlert-p').html('视频大小不能超过20GB');
                $('#uploadVideo-al').modal('show');
                return false;
            }
            var params = key.split('.')[0]; //文件名

            //进度
            var next = function next(response) {
                var file = response;
                var size = file.size / 1024 / 1024;
                var loaded = file.loaded / 1024 / 1024;
                //总大小
                $('.SizeBox').html(size.toFixed(2));
                //已上传
                $('.SecondBox').html(loaded.toFixed(2));
                //上传进度
                $('.pl-num').children('span').html(file.percent.toFixed(2));
                //上传进度条
                $('.pl-gro-bar').css('width', file.percent + '%');
            };
            //保错
            var error = function error(err) {
                console.log("失败", err);
                $('#processModal').modal('hide');
                $('#uploadVideo-al .detailAlert-p').html('上传失败，请重新上传');
                $('#uploadVideo-al').modal('show');
                $('#Textvideo').val('');
                $('#Textareavideo').val('');
                $('#select').val('');
            };
            //上传成功
            var complete = function complete(isSuccess, code, backData) {
                console.log("上传", backData, isSuccess);
                if (isSuccess) {
                    var userData = JSON.parse(ALY.util.base64.decode(backData.userData)).Vod.UserData;
                    ++that.fileName;
                    that.arrayUuid.push(userData.file_id);
                    that.arrayName.push($('#Textvideo').val());
                    $('#Textvideo').val('');
                    $('#Textareavideo').val('');
                    $('#select').val('');
                    $('#processModal').modal('hide');
                    if (that.numberSize <= that.arrayName.length + that.MyUploadVideo.length) {
                        $('#videoContainer').hide();
                    } else {
                        //  that.Uptoken();
                    }
                } else {
                    $('#processModal').modal('hide');
                    $('#Textvideo').val('');
                    $('#Textareavideo').val('');
                    $('#select').val('');
                    $('#processModal').modal('hide');
                    $('#uploadVideo-al .detailAlert-p').html(backData);
                    $('#uploadVideo-al').modal('show');
                }
            };
            $('#uploadModal').modal('show');
            //上传
            $('.btn-pl-start1').unbind('click').on('click', function () {
                if ($('#Textvideo').val().trim() == '') {
                    $('#Textvideo').focus();
                } else {
                    var params = {};
                    params.title = $('#Textvideo').val();

                    if ($('#Textareavideo').val()) {
                        params.description = $('#Textareavideo').val();
                    } else {
                        params.description = $('#Textvideo').val();
                    }

                    if (that.$route.params.id == 0) {
                        params.activity_id = that.id;
                    } else {
                        params.activity_id = that.$route.params.id || that.id;
                    }

                    params.source = "1";
                    params.audit_level = that.audit_level;
                    params.app_id = that.appId;
                    console.log("videoupload" + params.audit_level);
                    var content = {
                        file: file, //文件名 必填
                        file_type: "1",
                        Biography: params
                    };

                    $('#uploadModal').modal('hide');
                    $('#processModal').modal('show');
                    $.fn.uploadHandle(content, function () {
                        console.log("开始上传！");
                    }, next, complete);
                }
            });
            //取消
            $('.btn-pl-giveup').unbind('click').on('click', function () {
                $.fn.stopUploadFile();
                $.fn.cancleUploadFile();
                $.fn.deleteUploadFile();
                $('#select').val('');
                $('#Textimg').val('');
                $('#Textareavideo').val('');
            });
        });

        var nScrollHight = 0; //滚动距离总长(注意不是滚动条的长度)
        var nScrollTop = 0; //滚动到的当前位置
        var len = 10;
        //滚动加载
        $('#modal-body').scroll(function () {
            nScrollHight = $(this)[0].scrollHeight;
            nScrollTop = $(this)[0].scrollTop; //能获取到
            var nDivHight = $('#modal-body').height();
            //console.log(nScrollHight,nScrollTop,nDivHight)
            //console.log(that.allchannel.length >= len)
            if (that.allchannel.length >= len) {
                that.scrill = true;
            } else {
                that.scrill = false;
            }
            if (nScrollTop + nDivHight + 40 >= nScrollHight && that.scrill) {
                that.scrill = false;
                //正在进行二次加载
                var page = ++that.page;
                len = len / 1 + 10;
                $.getJSON(API.GetUploadFileForMe + '?jsoncallback=?&file_type=1&pagesize=10&page=' + page, function (res) {
                    if (res.code == '0') {
                        for (var i = 0; i < res.data.length; i++) {
                            that.allchannel.push(res.data[i]);
                        }
                        that.$nextTick(function () {
                            setTimeout(function () {
                                var picWimg = $('.pic-box').width();
                                var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                                $('.pic-box').css('height', picHimg);
                                $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
                            }, 200);
                        });
                    }
                });
            }
        });
    }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "sgvI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "tFxH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tH3c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tS01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userName: '', //userN
      password: '' //password
    };
  },

  methods: {
    //操作按钮事件
    fn: function fn() {
      $('#login_Alert').modal('hide');
      $('#myFlash').show();
    },
    table: function table() {
      $('.quick-alert').show();
      $('.signIn-alert').hide();
    },
    signIn: function signIn() {
      $('.quick-alert').hide();
      $('.signIn-alert').hide();
      // $('#login_Alert').modal('hide');
      // this.$router.push({name:'login_SignIn'})
    }
  },
  mounted: function mounted() {
    // var form=$document.forms['eg']；
    var that = this;
    //操作DOM
    $('.group-info').on('click', 'a', function () {
      if (document.getElementById('username').value == '') {
        //document.getElementById('username').style.display='';
        $('.uname').css('display', 'block');
        return;
      } else {
        $('.uname').css('display', 'none');
      }
      if (document.getElementById('password').value == '') {
        $('.upass').css('display', 'block');
        return;
      } else {
        $('.upass').css('display', 'none');
      }

      document.getElementById('punishformID')['from'] = '';

      passport.checkJsonpForm(document.getElementById('punishformID'), function (result) {
        var msg = result.msg; //提示信息
        var errorCode = result.errorCode; //错误码，i18n展示用
        if (passport.usernameError == result.type) {
          //如果是用户名有问题
          $('.upass').css('display', 'block');

          $('#password').val('');
          //在用户名的位置展示错误提示信息
        } else if (passport.passwordError == result.type) {
          //如果是密码有问题
          //alert(msg)
          $('.uname').css('display', 'block');
          $('#password').val('');
          //在密码的位置展示错误提示信息
        } else if (passport.success == result.type) {
          //登录成功
          $('#login_Alert').modal('hide');
          $('#chatModal .info-mess').html('登录成功');
          $('#chatModal').modal('show');
          setTimeout(function () {
            $('#chatModal').modal('hide');
            var thisPathRoute = that.$route.path.split('/')[1];
            if (thisPathRoute === 'detail') {
              that.$http.get(API.IsJoin, { params: { activity_id: that.$route.params.id } }).then(function (res) {
                if (res.code == 0) {
                  if (res.data.isJoin == 0) {
                    that.$router.push({ name: 'Notice', params: { id: that.$route.params.id } });
                  } else {
                    // that.$router.push({name: 'myActivity_MyParticipate', params: {id: that.$route.params.id}});
                    that.$router.push({ name: 'Revise', params: { id: that.$route.params.id, form_id: 0 } });
                    return false;
                  }
                }
              });
            } else {
              window.location.reload();
            }
          }, 1500);
        }
      });
    });
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "toje":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_Register"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"header login-header"},[_c('a',{staticClass:"icon-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.fn}}),_vm._v("注册账号\n    ")]),_vm._v(" "),_c('div',{staticClass:"line-gray"}),_vm._v(" "),_c('div',{staticClass:"content login-content"},[_vm._m(0),_vm._v(" "),_c('form',{staticClass:"lg-tabbox"},[_c('div',{staticClass:"group-item"},[_c('label',[_vm._v("手机")]),_vm._v(" "),_c('div',{staticClass:"input-box input-tel"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"in",attrs:{"type":"tel","placeholder":"请输入常用手机号","id":"phone","maxlength":"11"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.phone != ''),expression:"phone != ''"}],staticClass:"btn-del",staticStyle:{"display":"none"},on:{"click":function($event){_vm.phone = ''}}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"phone-mess"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"yzm-mess"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"pass-mess"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"repass-mess"}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"yzm-img"}}),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"xieyi-mess"}}),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg-tab"},[_c('span',{staticClass:"lg-active"},[_c('i',{staticClass:"icon-phone"}),_vm._v("手机")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"icon-email"}),_vm._v("邮箱")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-item"},[_c('label',[_vm._v("验证码")]),_vm._v(" "),_c('div',{staticClass:"input-box input-yzm"},[_c('input',{attrs:{"type":"tel","placeholder":"请输入验证码","id":"yzm"}}),_vm._v(" "),_c('a',{staticClass:"btn-yzm puts",attrs:{"href":"javascript:void(0);"}},[_vm._v("发送验证码")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-item"},[_c('label',[_vm._v("密码")]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{attrs:{"type":"password","id":"pass","placeholder":"6-20位任意字符区分大小写"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-item"},[_c('label',[_vm._v("确认密码")]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{attrs:{"type":"password","id":"repass","placeholder":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-item"},[_c('label',[_vm._v("图形验证")]),_vm._v(" "),_c('div',{staticClass:"input-box input-picyz"},[_c('input',{attrs:{"type":"text","placeholder":"","id":"yzm-data"}}),_vm._v(" "),_c('img',{staticClass:"picyz",attrs:{"src":"http://reg.cctv.com/simple/verificationCode.action"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-terms"},[_c('div',{staticClass:"check-box"},[_c('input',{attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('p',{staticClass:"terms"},[_vm._v("\n            阅读并同意"),_c('a',{attrs:{"id":"cctvmess","href":"javascript:void(0);"}},[_vm._v("《央视网网络服务使用协议》")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-info"},[_c('a',{staticClass:"font-lgr",attrs:{"href":"javascript:void(0);","id":"logined"}},[_vm._v("注  册")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"lg-tabbox",staticStyle:{"display":"none"}},[_c('div',{staticClass:"group-item"},[_c('label',[_vm._v("邮箱")]),_vm._v(" "),_c('div',{staticClass:"input-box input-tel"},[_c('input',{attrs:{"type":"email","id":"email","placeholder":"请使用常用邮箱"}}),_vm._v(" "),_c('div',{staticClass:"btn-del",staticStyle:{"display":"none"}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"email-mess"}}),_vm._v(" "),_c('div',{staticClass:"group-item"},[_c('label',[_vm._v("密码")]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{attrs:{"type":"password","id":"pass_email","placeholder":"6-20位任意字符区分大小写"}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"pass-mess-email"}}),_vm._v(" "),_c('div',{staticClass:"group-item"},[_c('label',[_vm._v("确认密码")]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{attrs:{"type":"password","id":"repass_email","placeholder":""}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"repass-mess-email"}}),_vm._v(" "),_c('div',{staticClass:"group-item"},[_c('label',[_vm._v("图形验证")]),_vm._v(" "),_c('div',{staticClass:"input-box input-picyz"},[_c('input',{attrs:{"type":"text","placeholder":"","id":"yzm_email"}}),_vm._v(" "),_c('img',{staticClass:"picyz",attrs:{"src":"https://reg.cctv.com/simple/verificationCode.action"}})])]),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"yzm-img-email"}}),_vm._v(" "),_c('div',{staticClass:"group-terms group-terms-email"},[_c('div',{staticClass:"check-box"},[_c('input',{attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('p',{staticClass:"terms"},[_vm._v("\n            阅读并同意"),_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("《央视网网络服务使用协议》")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger",staticStyle:{"display":"none"},attrs:{"id":"xieyi-mess-email"}}),_vm._v(" "),_c('div',{staticClass:"group-info"},[_c('a',{staticClass:"font-lgr",attrs:{"href":"javascript:void(0);","id":"loginede"}},[_vm._v("注  册")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-confim large-info-modal modal fade",attrs:{"id":"modalConfim","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"margin-top":"80px"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"top":"0","overflow-y":"auto","height":"500px"}},[_c('div',{staticClass:"protocol-bg"},[_c('div',{staticClass:"protocol",staticStyle:{"padding":"20px"}},[_c('div',{staticClass:"pro-close"}),_vm._v(" "),_c('h5',[_vm._v("央视网网络服务使用协议")]),_vm._v(" "),_c('div',{staticClass:"protocol-txt"},[_c('p',[_vm._v("第一章 服务使用协议的确认和接纳")]),_vm._v(" "),_c('p',[_vm._v("第一条\n                央视网网络服务使用协议（以下简称“协议”）是由用户（您）与央视国际网络有限公司（央视网）就央视网提供的网络服务所订立的相关权利义务规范，本协议对您及央视网均具有法律效力，未成年人需在法定监护人的陪同下审阅。")]),_vm._v(" "),_c('p',[_vm._v("第二条 央视网（网址：www.cctv.com、\n                www.cntv.cn）完全按照其发布的服务条款和操作规则向用户提供服务。本协议所称的用户（您）是指完全同意所有协议条款并完成注册程序或未经注册而使用央视网提供各项服务的个人或机构。")]),_vm._v(" "),_c('p',[_vm._v("第三条 您同意接受本协议，方可注册成为央视网正式用户。您注册成功后，央视网将给予您一个帐号及相应的密码，该帐号和密码由您负责保管；您对以该帐号进行的所有活动和事件负法律责任。")]),_vm._v(" "),_c('p',[_vm._v("第四条 您注册前，请认真阅读本协议。注册成功后，即视为同意接受本协议的全部内容，受本协议的约束。")]),_vm._v(" "),_c('p',[_vm._v("第二章 服务使用协议的变更和修改")]),_vm._v(" "),_c('p',[_vm._v("第五条 本协议的订立、执行、解释及争议的解决均应遵守中华人民共和国有关法律、法规，如协议之任何一部分与中华人民共和国法律、法规相抵触，则该部分条款应按法律规定执行。")]),_vm._v(" "),_c('p',[_vm._v("第六条 央视网有权随时修改本协议的任何条款，并在央视网上公示，而无需另行单独通知您，您可随时通过央视网浏览最新服务使用协议条款。")]),_vm._v(" "),_c('p',[_vm._v("第七条 当您使用央视网的特殊服务时，应接受央视网随时提供的与该特殊服务相关的规则或说明，并且此规则或说明均构成本协议的一部分。")]),_vm._v(" "),_c('p',[_vm._v("第八条 如果不同意央视网对本协议相关条款所做的修改，您可以主动向客服要求取消已经获得的网络服务；如果您继续使用网络服务，则视为您接受央视网对本协议相关条款所做的修改。")]),_vm._v(" "),_c('p',[_vm._v("第三章 服务说明")]),_vm._v(" "),_c('p',[_vm._v("第九条\n                央视网网络服务的具体内容由央视网根据实际情况提供，包括论坛（BBS）、博客、微博、播客、跟帖评论、边看边聊、邮箱、搜索等。除非另有明确规定，增强或强化目前服务的任何新功能，包括新产品，均无条件地适用本协议。")]),_vm._v(" "),_c('p',[_vm._v("第十条\n                您接受本协议，须同意并提供完整、真实、准确、最新的身份信息，并不断更新注册资料。若您提供任何错误、不实、过时或不完整的身份信息，并为央视网所确知；或者央视网有合理理由怀疑前述信息为错误、不实、过时或不完整，央视网有权暂停或终止您的帐号权限，并拒绝现在或将来向您提供本服务的全部或一部分。")]),_vm._v(" "),_c('p',[_vm._v("第十一条\n                您理解：央视网仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均由您自行负担。")]),_vm._v(" "),_c('p',[_vm._v("第四章 您应遵守以下法律及法规")]),_vm._v(" "),_c('p',[_vm._v("第十二条 您承诺遵守中华人民共和国有关法律法规和规范性文件，承担一切因您的行为直接或间接引起的法律责任。")]),_vm._v(" "),_c('p',[_vm._v("第十三条 您也应了解国际互联网的无国界性，还应特别注意遵守所在国家和地区所有有关的法律和法规。")]),_vm._v(" "),_c('p',[_vm._v("第五章 使用规则")]),_vm._v(" "),_c('p',[_vm._v("第十四条\n                您要注意保管好帐号及密码，不应将您的帐号、密码转让或出借给他人使用。如您发现帐号遭他人非法使用，应立即联系央视网客服中心。因黑客行为或您保管疏忽导致帐号、密码遭他人非法使用，央视网不承担任何责任。")]),_vm._v(" "),_c('p',[_vm._v("第十五条\n                您同意央视网有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在央视网的任何传播形式上投放广告），并且，您同意接受央视网通过电子邮件或其他方式向您发送商品促销或其他相关商业信息。")]),_vm._v(" "),_c('p',[_vm._v("第十六条\n                对于您通过央视网网络服务（包括但不限于论坛、博客、微博、播客、跟帖评论）上传到央视网上可公开获取区域的任何内容，您同意央视网在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的下述权利：以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。")]),_vm._v(" "),_c('p',[_vm._v("第十七条 您在使用央视网服务过程中，必须遵循以下原则：")]),_vm._v(" "),_c('p',[_vm._v("(一) 遵守所有与网络服务有关的网络协议、规定和程序；")]),_vm._v(" "),_c('p',[_vm._v("(二) 不得为任何非法目的而使用网络服务系统；")]),_vm._v(" "),_c('p',[_vm._v("(三) 不得以任何形式使用央视网的网络服务侵犯央视网的商业利益，包括并不限于发布非经央视网许可的商业广告；")]),_vm._v(" "),_c('p',[_vm._v("(四) 不得利用央视网的网络服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；")]),_vm._v(" "),_c('p',[_vm._v("(五) 不得利用央视网的网络服务功能传播任何具有欺诈、胁迫、淫秽性的和损害他人人格尊严的信息资料；")]),_vm._v(" "),_c('p',[_vm._v("(六) 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；")]),_vm._v(" "),_c('p',[_vm._v("(七) 不得利用央视网的网络服务系统进行任何不利于央视网的行为。")]),_vm._v(" "),_c('p',[_vm._v("第十八条 您在使用央视网所提供的网络服务时，不得产生下列信息：")]),_vm._v(" "),_c('p',[_vm._v("(一) 违反宪法或法律法规规定的；")]),_vm._v(" "),_c('p',[_vm._v("(二) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；")]),_vm._v(" "),_c('p',[_vm._v("(三) 损害国家荣誉和利益的，损害公共利益的；")]),_vm._v(" "),_c('p',[_vm._v("(四) 煽动民族仇恨、民族歧视，破坏民族团结的；")]),_vm._v(" "),_c('p',[_vm._v("(五) 破坏国家宗教政策，宣扬邪教和封建迷信的；")]),_vm._v(" "),_c('p',[_vm._v("(六) 散布谣言，扰乱社会秩序，破坏社会稳定的；")]),_vm._v(" "),_c('p',[_vm._v("(七) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；")]),_vm._v(" "),_c('p',[_vm._v("(八) 侮辱或者诽谤他人，侵害他人合法权益的；")]),_vm._v(" "),_c('p',[_vm._v("(九) 含有法律、行政法规禁止的其他内容的。")]),_vm._v(" "),_c('p',[_vm._v("第十九条\n                您在设置帐号名称、头像和简介等注册信息时须遵守本协议第十八条的要求，不得出现违法和不良信息，并承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。")]),_vm._v(" "),_c('p',[_vm._v("第二十条\n                央视网有权对您使用其网络服务的情况进行审查和监督（包括但不限于对您存储在央视网的内容进行审核），如您在使用网络服务时违反本协议任何规定，央视网或其授权主体有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除您已张贴的内容、暂停或终止您使用网络服务的权利等）以减轻因您的不当行为造成的影响。对于违反有关法律法规、侵犯他人隐私和名誉等内容，央视网有保存相关记录，并依法向有关部门提供的权利。")]),_vm._v(" "),_c('p',[_vm._v("第二十一条\n                央视网针对某些特定网络服务的使用通过各种方式（包括但不限于网页公告、电子邮件等）作出的任何声明、通知、警示等内容视为本协议的一部分，您如使用该等网络服务，视为您同意该等声明、通知、警示的内容。")]),_vm._v(" "),_c('p',[_vm._v("第二十二条 您认为自己在央视网的权益受到侵害，有权根据央视网相关规定进行投诉、申诉。")]),_vm._v(" "),_c('p',[_vm._v("第二十三条 您有权对央视网互动平台管理提出批评、意见、建议，有权就互动平台管理工作提出咨询。")]),_vm._v(" "),_c('p',[_vm._v("第二十四条 您需遵守网络道德，注意网络礼仪，做到文明上网。")]),_vm._v(" "),_c('p',[_vm._v("第六章 服务变更、中断或终止")]),_vm._v(" "),_c('p',[_vm._v("第二十五条 鉴于网络服务的特殊性，您同意央视网有权随时变更、中断或终止部分或全部的网络服务。")]),_vm._v(" "),_c('p',[_vm._v("第二十六条\n                您理解：央视网需要定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，央视网无需为此承担任何责任，但应通过央视网尽可能事先进行通告。")]),_vm._v(" "),_c('p',[_vm._v("第二十七条 如发生下列任何一种情形，央视网有权随时中断或终止向您提供本协议项下的网络服务而无需对您或任何第三方承担任何责任：")]),_vm._v(" "),_c('p',[_vm._v("(一) 在任何情况下，央视网合理地认为您的行为可能违反中华人民共和国有关法律法规和规范性文件；")]),_vm._v(" "),_c('p',[_vm._v("(二) 您提供的个人资料不真实；")]),_vm._v(" "),_c('p',[_vm._v("(三) 您违反本协议中的部分条款。")]),_vm._v(" "),_c('p',[_vm._v("第二十八条您的帐号和密码遭到未授权的使用或发生其他任何安全问题，您可以立即通知央视网。在您每次连线结束时，应结束帐号使用，否则您可能得不到央视网的安全保护。\n              ")]),_c('p',[_vm._v("第七章 知识产权")]),_vm._v(" "),_c('p',[_vm._v("第二十九条\n                央视网提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。央视网不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式，向您或任何第三方负责。")]),_vm._v(" "),_c('p',[_vm._v("第三十条\n                央视网为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，您不得对该软件进行反向工程（reverse\n                engineer）、反向编译（decompile）或反汇编（disassemble）。")]),_vm._v(" "),_c('p',[_vm._v("第八章 隐私权保护")]),_vm._v(" "),_c('p',[_vm._v("第三十一条 保护用户隐私是央视网的一项基本政策，央视网保证不对外公开或向第三方提供您的注册资料及您在使用网络服务时存储在央视网的非公开内容，但下列情况除外：")]),_vm._v(" "),_c('p',[_vm._v("(一) 事先获得您的明确授权。")]),_vm._v(" "),_c('p',[_vm._v("(二) 依据有关法律规定，国家有关机关按照法律程序要求查询时，提供您的注册信息、您在央视网上发布的信息内容及其发布时间、互联网地址或者域名。")]),_vm._v(" "),_c('p',[_vm._v("(三) 为维护用户及社会公共利益的需要。")]),_vm._v(" "),_c('p',[_vm._v("(四) 为维护央视网的合法权益。")]),_vm._v(" "),_c('p',[_vm._v("第三十二条 央视网可能会与第三方合作向您提供相关的网络服务，在此情况下，如该第三方同意承担与央视网同等的保护用户隐私的责任，则央视网有权将您的注册资料等提供给该第三方。")]),_vm._v(" "),_c('p',[_vm._v("第三十三条 在不透露您的隐私资料前提下，央视网有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。")]),_vm._v(" "),_c('p',[_vm._v("第九章 免责声明")]),_vm._v(" "),_c('p',[_vm._v("第三十四条 您明确同意您在使用央视网网络服务所存在的风险将完全由您自己承担；因您使用央视网网络服务而产生的一切后果也由您自己承担，央视网对您不承担任何责任。")]),_vm._v(" "),_c('p',[_vm._v("第三十五条 您对央视网提供的网络服务承担使用风险。央视网不保证服务一定会满足您的使用要求，也不保证服务不会中断，央视网对服务的及时性、安全性、准确性也不作担保。")]),_vm._v(" "),_c('p',[_vm._v("第三十六条 央视网不保证为向您提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由央视网实际控制的任何网页上的内容，央视网不承担任何责任。")]),_vm._v(" "),_c('p',[_vm._v("第三十七条 对于因不可抗力或央视网不能控制的原因造成的网络服务中断或其它缺陷，央视网不承担任何责任，但将尽力减少由此给您造成的损失和影响。")]),_vm._v(" "),_c('p',[_vm._v("第三十八条 您同意：对于央视网向您提供的下列产品或者服务的质量缺陷引发的任何损失，央视网无需承担任何责任：")]),_vm._v(" "),_c('p',[_vm._v("(一)央视网向您免费提供的各项网络服务；")]),_vm._v(" "),_c('p',[_vm._v("(二)央视网向您赠送的任何产品或者服务；")]),_vm._v(" "),_c('p',[_vm._v("(三)央视网向收费网络服务用户附赠的各种产品或者服务。")]),_vm._v(" "),_c('p',[_vm._v("第十章 违约赔偿")]),_vm._v(" "),_c('p',[_vm._v("第三十九条 如因央视网违反有关法律、法规或本协议项下的任何条款而给您造成损失，央视网同意承担由此造成的损害赔偿责任。")]),_vm._v(" "),_c('p',[_vm._v("第四十条 您同意保障和维护央视网及其他用户的利益，如因您违反有关法律、法规或本协议项下的任何条款而给央视网或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。\n              ")]),_c('p',[_vm._v("第十一章 通知送达")]),_vm._v(" "),_c('p',[_vm._v("第四十一条 本协议项下央视网对您的所有通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。")]),_vm._v(" "),_c('p',[_vm._v("第四十二条 您对于央视网的通知应当通过央视网对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。")]),_vm._v(" "),_c('p',[_vm._v("第十二章 争议解决方式")]),_vm._v(" "),_c('p',[_vm._v("第四十三条 本协议及其修订本的有效性、履行和与本协议及其修订本效力有关的所有事宜，将受中华人民共和国法律管辖，任何争议仅适用中华人民共和国法律。")]),_vm._v(" "),_c('p',[_vm._v("第四十四条 因本协议所引起的您与央视网的任何纠纷或争议，首先应友好协商解决，协商不成的，您在此完全同意将纠纷或争议提交央视网所在地即北京市有管辖权的人民法院诉讼解决。")]),_vm._v(" "),_c('p',[_vm._v("第十三章 其他规定")]),_vm._v(" "),_c('p',[_vm._v("第四十五条 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。")]),_vm._v(" "),_c('p',[_vm._v("第四十六条 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。")]),_vm._v(" "),_c('p',[_vm._v("第四十七条 本协议将取代您先前与央视网签署的任何网络服务使用协议。本协议和央视网的其他服务条款构成完整的协议。")]),_vm._v(" "),_c('p',[_vm._v("第四十八条 本协议中的标题仅为方便而设，在解释本协议时应被忽略。")]),_vm._v(" "),_c('p',[_vm._v("第四十九条 本协议最终解释权归央视国际网络有限公司所有 。")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"active-modal large-info-modal modal fade",attrs:{"id":"activeModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('p',{staticClass:"active-info"},[_vm._v("进入邮箱激活后才能完成注册!")]),_vm._v(" "),_c('a',{staticClass:"btn-at-sure",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("确  认")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "txGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      MobilePhone: '',
      phone: ''
    };
  },

  methods: {
    //操作按钮事件
    fn: function fn() {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'home' });
      } else {
        this.$router.back(-1);
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    $('.modal-backdrop').remove();
    // 大陆电话删除按钮
    $('.input-tel input').on('focus', function () {
      $(this).next('.btn-del').show();
    });
    $('.input-tel input').on('blur', function () {
      setTimeout(function () {
        $('.input-tel').find('.btn-del').hide();
      }, 100);
    });
    $('.input-tel').on('click', '.btn-del', function () {
      $(this).prev('input').val('');
      $(this).hide();
    });

    //操作DOM

    // checkbok 选中函数
    $('.check-box').on('click', function () {
      if ($(this).hasClass('oncheck')) {
        $(this).removeClass('oncheck');
      } else {
        $(this).addClass('oncheck');
      }
    });

    //tab 切换
    $('.lg-tab span').on('click', function () {
      var tabIndex = '';
      if (!$(this).hasClass('lg-active')) {
        $(this).addClass('lg-active').siblings('span').removeClass('lg-active');
        tabIndex = $(this).index();
        $('.lg-tabbox').eq(tabIndex).show().siblings('.lg-tabbox').hide();
      }
    });

    //$('#modalConfim').modal('show')

    $('.protocol-bg').on('click', function () {
      $('#modalConfim').modal('hide');
    });

    $('.terms').on('click', function () {
      $('#modalConfim').modal('show');
    });

    function getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }

    var url_name = getQueryString('name');
    var iid = getQueryString('iid');

    $('#login').click(function () {
      if (iid) {
        window.location.href = 'accountlogin.html?name=' + url_name + '&iid=' + iid;
      } else {
        window.location.href = 'accountlogin.html?name=' + url_name;
      }
    });

    var that = this;
    getcode();

    function getcode() {
      $('.puts').click(function () {

        var num = 180;

        $('#yzm-img').hide();

        $('#phone-mess').hide();
        $('#yzm-mess').hide();

        // var phone=that.phone;
        var phone = $('#phone').val();
        var yzm_data = $('#yzm-data').val();

        if (!phone) {

          $('#phone-mess').show();
          $('#phone-mess').html('请输入手机号');
          return;
        }

        if (phone.match(/^1[3|5|7|8|9|][0-9]{9}$/) === null) {
          $('#phone-mess').show();
          $('#phone-mess').html('手机号格式不正确');
          return;
        }
        if (!yzm_data) {
          $('#yzm-img').show();
          $('#yzm-img').html('请输入图形验证码');
        }
        $.ajax({
          url: 'http://reg.cctv.com/regist/getVerifiCode.action',
          data: {
            method: 'getRequestVerifiCodeM',
            mobile: phone,
            verfiCodeType: 1,
            verificationCode: yzm_data,
            isCheckCode: 0
          },
          dataType: 'jsonp',
          success: function success(mes) {
            if (mes.errtype == 'success') {
              $('.puts').unbind('click');
              var set = setInterval(function () {
                num = num - 1;
                $('.btn-yzm').html(num + '秒后获取');
                if (num == 0) {
                  $('.btn-yzm').html('发送验证码');
                  getcode();
                  clearInterval(set);
                }
              }, 1000);
            }
            if (mes.errtype == 'mobilecodeerror') {
              $('#yzm-img').show();
              $('#yzm-img').html(mes.errmsg);
            }
            if (mes.errtype == 'ipsendagain') {
              $('#yzm-img').show();
              $('#yzm-img').html('验证过于频繁,请稍后重试');
            }
            if (mes.errtype == 'mobileoften') {
              $('#yzm-img').show();
              $('#yzm-img').html('验证过于频繁,请稍后重试');
            }
            if (mes.errtype == 'registered') {
              $('#phone-mess').show();
              $('#phone-mess').html(mes.errmsg);
            }
            if (mes.errtype == 'sendagain') {
              $('#yzm-mess').show();
              $('#yzm-mess').html('验证过于频繁,请稍后重试');
            }
          }
        });
      });
    }

    $('.picyz').click(function () {
      $(this).attr('src', 'http://reg.cctv.com/simple/verificationCode.action?v=' + Math.random());
    });

    //手机注册
    $('#logined').click(function () {

      var url = encodeURI('http://ishow.xiyou.cctv.com/');
      $('#phone-mess').html('');
      var phone = $('#phone').val();
      var yzm = $('#yzm').val();
      var pass = $('#pass').val();
      var repass = $('#repass').val();
      var yzm_data = $('#yzm-data').val();
      $('#phone-mess').hide();
      $('#yzm-mess').hide();
      $('#pass-mess').hide();
      $('#repass-mess').hide();
      $('#xieyi-mess').hide();
      $('#yzm-img').hide();

      if (phone == '') {
        $('#phone-mess').show();
        $('#phone-mess').html('请输入手机号');
        return;
      }

      if (phone.match(/^1[3|5|7|8|9|][0-9]{9}$/) === null) {
        $('#phone-mess').show();
        $('#phone-mess').html('手机号格式不正确');
        return;
      }

      if (!yzm) {
        $('#yzm-mess').show();
        $('#yzm-mess').html('请输入验证码');
        return;
      }

      if (pass.length < 6 || pass.length > 20) {
        $('#pass-mess').show();
        $('#pass-mess').html('请输入6-20位的密码');
        return;
      }
      if (pass != repass) {
        $('#repass-mess').show();
        $('#repass-mess').html('两次输入密码不一致');
        return;
      }

      if (!yzm_data) {
        $('#yzm-img').show();
        $('#yzm-img').html('请输入图形验证码');
        return;
      }

      if ($('.group-terms').find('.oncheck').length == 0) {
        $('#xieyi-mess').show();
        $('#xieyi-mess').html('请同意使用协议');
        return;
      }
      $.ajax({
        url: 'https://reg.cctv.com/regist/mobileRegist.do',
        data: {
          method: 'saveMobileRegisterM',
          mobile: phone,
          verfiCodeType: 1,
          verfiCode: yzm,
          passWd: pass,
          addons: url
        },
        dataType: 'jsonp',
        success: function success(mes) {
          if (mes.errtype == 'success') {
            that.$router.back(-1);
            /*  if(iid){
                  this.$router.push({name: 'login_SignIn', query: {id: iid}})
               }else{
                  this.$router.push({name: 'login_SignIn'})
              }*/
          }
          if (mes.errtype == 'registered') {
            $('#yzm-mess').show();
            $('#yzm-mess').html(mes.errmsg);
          }
          if (mes.errtype == 'error') {
            $('#yzm-mess').show();
            $('#yzm-mess').html(mes.errmsg);
          }
          if (mes.errtype == 'timeout') {
            $('#yzm-mess').show();
            $('#yzm-mess').html(mes.errmsg);
          }
        }
      });
    });

    //邮箱注册
    $('#loginede').click(function () {

      var url = encodeURI('http://ishow.xiyou.cctv.com/');

      var email = $('#email').val();

      var pass = $('#pass_email').val();
      var repass = $('#repass_email').val();
      var yzm_data = $('#yzm_email').val();
      $('#email-mess').hide();

      $('#pass-mess').hide();
      $('#repass-mess').hide();
      $('#xieyi-mess-email').hide();
      $('#yzm-img-email').hide();

      if (email == '') {
        $('#email-mess').show();
        $('#email-mess').html('请输入邮箱地址');
        return;
      }

      if (email.match(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/) === null) {
        $('#email-mess').show();
        $('#email-mess').html('邮箱格式不正确');
        return;
      }

      if (pass.length < 6 || pass.length > 20) {
        $('#pass-mess-email').show();
        $('#pass-mess-email').html('请输入6-20位的密码');
        return;
      } else {
        $('#pass-mess-email').hide();
      }
      if (pass != repass) {
        $('#repass-mess-email').show();
        $('#repass-mess-email').html('两次输入密码不一致');
        return;
      } else {
        $('#repass-mess-email').hide();
      }

      if (!yzm_data) {
        $('#yzm-img-email').show();
        $('#yzm-img-email').html('请输入图形验证码');
        return;
      }

      if ($('.group-terms-email').find('.oncheck').length == 0) {
        $('#xieyi-mess-email').show();
        $('#xieyi-mess-email').html('请同意使用协议');
        return;
      }
      $.ajax({
        url: 'https://reg.cctv.com/api/register.action',
        data: {
          mailAdd: email,
          passWd: pass,
          verificationCode: yzm_data,
          addons: API.UrlName,
          backurl: '/index.html'
        },
        dataType: 'jsonp',
        success: function success(mes) {
          //console.log(mes)
          if (mes.msg == '成功') {
            /*  that.setCookie('userSeqId',mes.user_seq_id);*/
            that.$router.back(-1);
            //$('#activeModal').modal('show');
            $('#activeModal').modal('show');
          }
          if (mes.errtype == 'registered') {
            $('#yzm-mess-email').show();
            $('#yzm-mess-email').html(mes.errmsg);
          }
          if (mes.errtype != '0') {
            alert(mes.msg);
            $('.picyz').attr('src', 'http://reg.cctv.com/simple/verificationCode.action?v=' + Math.random());
            // $('#yzm-mess-email').show();
            // $('#yzm-mess-email').html(mes.msg);
          }
          if (mes.errtype == 'timeout') {
            $('#yzm-mess-email').show();
            $('#yzm-mess-email').html(mes.errmsg);
          }
        }
      });
    });
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "u1cn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      channelId: 0,
      channelPic: '',
      items: [],
      itemTotal: 0,
      busy: false,
      pageNum: 0,
      pageSize: 10,
      num: true,
      globalUrl: API.GlobalUrl
    };
  },

  created: function created() {

    this.channelId = this.$route.params.id;
    $('.id-nav-recom').eq(this.channelId).addClass('nav-on').siblings().removeClass('nav-on');

    this.$watch(function () {
      this.items = [];
    });
  },
  watch: {
    '$route': function $route() {
      this.channelId = this.$route.params.id;
      this.pageNum = 1;
      this.fetchData(false);
    }
  },
  methods: {
    route: function route(id) {
      var url = '';
      var hrefHTML = this.hrefHTML(0, id);
      if (hrefHTML) {
        window.location.href = hrefHTML;
      } else {
        window.location.href = API.UrlName + 'detail/' + id;
      }
    },
    fetchData: function fetchData(flag) {
      var _this = this;

      var param = {
        'channel_id': this.channelId,
        'page': this.pageNum,
        'pagesize': this.pageSize,
        version: 2
      };
      this.$http.get(API.GetActivities, { params: param }).then(function (res) {
        if (res.code === 0) {
          _this.itemTotal = res.total;
          if (flag) {
            // 多次加载数据
            _this.items = _this.items.concat(res.data);
            if (res.data.length === 0 || _this.items.length === res.total) {
              _this.busy = true;
            } else {
              _this.busy = false;
            }
          } else {
            // 第一次加载数据
            _this.items = res.data;
          }
          if (res.data.length === 0 || _this.items.length === res.total) {
            _this.busy = true;
          } else {
            _this.busy = false;
          }
          if (res.total == 0) {
            setTimeout(function () {
              $('.fd-search-none').html('没有找到您感兴趣的活动，再试一次！');
            }, 200);
          }
          if (_this.num) {
            _this.num = false;
          }

          _this.$nextTick(function () {
            this.PictureRatio();
          }, 500);
        }
      });
    },

    loadMore: function loadMore() {
      var _this2 = this;

      if (this.busy == false) {
        setTimeout(function () {
          _this2.pageNum++;
          _this2.fetchData(true);
        }, 500);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "uOyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['UpFile', 'type', 'id', 'countArr', 'appId', 'audit_level'],
    data: function data() {
        return {
            uptoken: '',
            fileId: '',
            fileName: 0,
            arrayName: [],
            arrayFile: [],
            arrType: [],
            allchannel: [],
            scrill: true,
            page: 1,
            key: '',
            allTyle: false,
            arrayUuid: [],
            numberSize: 0,
            MyUploadVideo: [],
            typeNmae: '',
            globalUrl: API.GlobalUrl,
            scan: {
                isScan: false,
                url: ''
            },
            pngSds: API.GlobalUrl + 'static/dist/img/audit_2.jpg',
            reject_img: API.GlobalUrl + 'static/dist/img/reject_2.jpg',
            upload_success_img: '/images/upload_success_2.jpg',
            moreInfo: false,
            classObj: {
                active: false,
                'down-arrow': false,
                all: false,
                elips: false
            },
            upfileTip: ''
        };
    },

    methods: {
        //操作按钮事件
        allTetx: function allTetx() {
            if (!this.moreInfo) return;
            this.allTyle = !this.allTyle;
            if (this.allTyle == true) {
                // $('.et-video-info').css('white-space','normal');
                this.classObj = {
                    active: true,
                    'down-arrow': true,
                    all: true
                    // elips: false,
                };
                this.upfileTip = this.UpFile.tip;
            } else {
                // $('.et-video-info').css('white-space','nowrap');
                this.classObj = {
                    active: false,
                    'down-arrow': true,
                    all: false
                    // elips: true,
                };
                this.upfileTip = this.UpFile.tip.substr(0, 50) + '...';
            }
        },
        upload: function upload() {
            $('#uploadAlet').modal('show');
        },
        uploadAlet: function uploadAlet() {
            $('#uploadAlet').modal('hide');
        },
        uploadDiv: function uploadDiv(type) {
            if (type == 1) {
                $('.uploadDiv').eq(0).addClass('active').siblings().removeClass('active');
            } else {
                $('.uploadDiv').eq(1).addClass('active').siblings().removeClass('active');
            }
        },
        fn: function fn() {
            var that = this;
            $('#uploadFile').modal('show');
            this.$http.get(API.GetUploadFileForMe, { params: { file_type: '1', page: '1', pagesize: '10', status: 'pass' } }).then(function (res) {
                if (res.code == '0') {
                    for (var i = 0; i < res.data.length; i++) {
                        that.allchannel.push(res.data[i]);
                    }
                    that.$nextTick(function () {
                        setTimeout(function () {
                            var picWimg = $('.pic-box').width();
                            var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                            $('.pic-box').css('height', picHimg);
                            $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
                        }, 200);
                    });
                }
            });
        },
        cancel4: function cancel4() {
            $('#uploadModal').modal('hide');
            $('#Textvideo').val('');
            $('#Textareavideo').val('');
            $('#upload_input').val('');
        },
        updateFile: function updateFile(idx) {
            this.arrayUuid.splice(idx, 1);
            this.arrayName.splice(idx, 1);
            this.fileName--;
            if (this.numberSize > this.arrayName.length + this.MyUploadVideo.length) {
                $('#videoContainer').show();
            }
        },
        delFile: function delFile(idx) {
            this.MyUploadVideo.splice(idx, 1);
            if (this.numberSize > this.arrayName.length + this.MyUploadVideo.length) {
                $('#videoContainer').show();
            }
        },
        needScan: function needScan(idx, url) {
            if (url) {
                this.scan.url = url;
            } else {

                this.scan.url = this.arrayFile[idx];
            }
            this.scan.isScan = true;
            $('body').addClass('modal-open');
        },
        closeScan: function closeScan() {
            this.scan.isScan = false;
            $('body').removeClass('modal-open');
        },
        initMoreInfo: function initMoreInfo() {
            var pinfo = this.$refs.p_info;
            var offH = pinfo.offsetHeight;
            var scrollH = pinfo.scrollHeight;
            // console.log(pinfo,offH,scrollH);
            if (scrollH > offH) {
                this.moreInfo = true;
                this.classObj = {
                    active: false,
                    all: false,
                    // elips:true,
                    'down-arrow': true
                };
                this.upfileTip = this.UpFile.tip.substr(0, 50) + '...';
            }
        }
    },

    created: function created() {
        this.upfileTip = this.UpFile.tip;
    },
    mounted: function mounted() {
        //操作DOM
        var that = this,
            subscription;
        var id = this.$route.params.id;
        this.initMoreInfo();
        that.typeNmae = that.UpFile.field_type;
        // if (this.UpFile.field_type == 'uploadvideo') {
        if (that.UpFile.choose_num == '0') {
            $('.uploadVideo').hide();
            return false;
        }
        if (that.type != 0) {
            that.ByUserid = {
                activity_id: that.id
            };
            // console.log( that.ByUserid )
            this.$http.get(API.GetActivityFileByUserid, { params: that.ByUserid }).then(function (res) {
                //  console.log(res)
                if (res.code == 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        that.MyUploadVideo.push(res.data[i]);
                        // console.log(i)
                    }
                }
                that.arrayUuid = [];
                that.arrayName = [];
                that.fileName = 0;
                if (!that.UpFile.choose_num) {
                    that.numberSize = 1;
                } else {
                    that.numberSize = that.UpFile.choose_num;
                }
                if (that.numberSize == '' || that.numberSize == null || that.numberSize <= res.total) {
                    $('#videoContainer').hide();
                }
            });
        } else {
            // console.log(that.UpFile)
            that.numberSize = that.UpFile.choose_num;
        }
        //that.Uptoken();
        // }
        //$('#uploadAlet').modal('show')


        $('#upload_input').unbind().change(function () {
            if (id == '100071' || that.id == '100071') {
                $('#Textvideo').val('我的观后感');
            } else {
                $('#Textvideo').val('');
            }
            $('#Textareavideo').val('');
            var file = this.files[0]; //文件
            var key = file.name; //文件总名
            var name = key.split('.');
            var ext = name[name.length - 1].toLowerCase();
            // var ext =  key.split('.')[1].toLowerCase();
            var tokenUrl = '';
            var type = $('#uploadAll').find('.active').attr('attr-type');
            var file_type = "0";
            if (type == 1) {
                // tokenUrl = API.UploadToken;
                if (ext != 'mkv' && ext != 'm4v' && ext != 'dv' && ext != 'dvix' && ext != 'hlv' && ext != 'f4v' && ext != 'dat' && ext != 'wmv' && ext != 'mpg' && ext != 'mpeg' && ext != 'avi' && ext != 'mp4' && ext != '3gp' && ext != 'rm' && ext != 'rmvb' && ext != 'mov' && ext != 'flv' && ext != 'asf') {
                    $('#uploadImg-al .detailAlert-p').html('上传格式错误');
                    $('#uploadVideo-al').modal('show');
                    $('#upload_input').val('');
                    return false;
                }
                var fileSize = file.size / 1024 / 1024 / 1024;
                if (fileSize > 20) {
                    $('#uploadImg-al .detailAlert-p').html('视频大小不能超过20GB');
                    $('#uploadVideo-al').modal('show');
                    $('#upload_input').val('');
                    return false;
                }
                file_type = "1";
            } else {
                // tokenUrl = API.ImageToken;
                if (ext != 'jpg' && ext != 'gif' && ext != 'png' && ext != 'jpeg') {
                    $('#uploadImg-al .detailAlert-p').html('上传格式错误');
                    $('#uploadVideo-al').modal('show');
                    $('#upload_input').val('');
                    return false;
                }
                var fileSize = file.size / 1024 / 1024;
                if (fileSize > 20) {
                    $('#uploadImg-al .detailAlert-p').html('图片大小不能超过20MB');
                    $('#uploadVideo-al').modal('show');
                    $('#upload_input').val('');
                    return false;
                }
                file_type = "2";
            }

            var params = key.split('.')[0]; //文件名


            //进度
            var next = function next(response) {
                var file = response;
                //console.log(file);
                var size = file.size / 1024 / 1024;
                var loaded = file.loaded / 1024 / 1024;
                //总大小
                $('.SizeBox').html(size.toFixed(2));
                //已上传
                $('.SecondBox').html(loaded.toFixed(2));
                //上传进度
                $('.pl-num').children('span').html(file.percent.toFixed(2));
                //上传进度条
                $('.pl-gro-bar').css('width', file.percent + '%');
            };
            //保错
            var error = function error(err) {
                console.log(err);
                $('#uploadImg-al .detailAlert-p').html('上传错误');
                $('#uploadVideo-al').modal('show');
            };
            //上传成功
            var complete = function complete(isSuccess, code, backData) {
                // console.log(res);
                if (isSuccess) {
                    var userData = JSON.parse(ALY.util.base64.decode(backData.userData)).Vod.UserData;
                    ++that.fileName;
                    // if(res.data.file_path){
                    //     that.arrType.push(2);
                    //     that.arrayFile.push('https://' + res.data.bucket +  'ishow.cctv.com/' +res.data.file_path + '?imageView2/1/w/60/h/60')
                    // }else{
                    //     that.arrType.push(1);
                    //     that.arrayFile.push('https://ishow.cctv.com/images/video.jpg')
                    // }
                    if (userData.file_type == "2") {
                        that.arrType.push(2);
                        that.arrayFile.push('/images/video.jpg');
                    } else {
                        that.arrType.push(1);
                        that.arrayFile.push('/images/video.jpg');
                    }
                    that.arrayUuid.push(userData.file_id);
                    that.arrayName.push($('#Textvideo').val());
                    $('#processModal').modal('hide');
                    $('#Textvideo').val('');
                    $('#Textareavideo').val('');
                    $('#upload_input').val('');
                    if (that.numberSize <= that.arrayName.length + that.MyUploadVideo.length) {
                        $('#videoContainer').hide();
                    } else {
                        //  that.Uptoken();
                    }
                } else {
                    $('#processModal').modal('hide');
                    $('#Textvideo').val('');
                    $('#Textareavideo').val('');
                    $('#upload_input').val('');
                    $('.detailAlert-p').html('上传失败');
                    $('#uploadVideo-al').modal('show');
                }
            };
            //console.log(observable)
            $('#uploadModal').modal('show');
            //上传
            $('.btn-pl-start1').unbind('click').on('click', function () {
                if ($('#Textvideo').val().trim() == '') {
                    $('#Textvideo').focus();
                } else {
                    // putExtra.params['x:title'] = $('#Textvideo').val();
                    // if($('#Textareavideo').val()){
                    //     putExtra.params['x:description'] = $('#Textareavideo').val();
                    // }else{
                    //     putExtra.params['x:description'] = $('#Textvideo').val();
                    // }
                    //
                    // if(that.$route.params.id == 0){
                    //     putExtra.params['x:activity_id'] =  that.id;
                    // }else{
                    //     putExtra.params['x:activity_id'] = that.$route.params.id || that.id;
                    // }
                    // /* putExtra.params['x:activity_id'] = that.$route.params.id || that.id;*/
                    // putExtra.params['x:source'] = '1';
                    // putExtra.params['x:audit_level'] = '2';
                    // putExtra.params['x:app_id'] = that.appId;
                    // //putExtra.params['x:event_id'] = '1000';

                    var params = {};
                    params.title = $('#Textvideo').val();

                    if ($('#Textareavideo').val()) {
                        params.description = $('#Textareavideo').val();
                    } else {
                        params.description = $('#Textvideo').val();
                    }

                    if (that.$route.params.id == 0) {
                        params.activity_id = that.id;
                    } else {
                        params.activity_id = that.$route.params.id || that.id;
                    }

                    params.source = "1";
                    // params.audit_level = '2';
                    params.app_id = that.appId;
                    params.audit_level = that.audit_level;
                    console.log("upload" + params.audit_level);
                    var content = {
                        file: file, //文件名 必填
                        file_type: file_type,
                        Biography: params
                    };
                    $('#uploadAlet').modal('hide');
                    $('#uploadModal').modal('hide');
                    $('#processModal').modal('show');
                    $.fn.uploadHandle(content, function () {
                        console.log("开始上传！");
                    }, next, complete);
                }
            });
            //取消
            $('.btn-pl-giveup').unbind('click').on('click', function () {
                $.fn.stopUploadFile();
                $.fn.cancleUploadFile();
                $.fn.deleteUploadFile();
                $('#Textimg').val('');
                $('#Textareavideo').val('');
                $('#upload_input').val('');
            });
            // that.$http.get(tokenUrl,{params: {activity_id: that.$route.params.id,app_id: that.appId}})
            //     .then(function (res) {
            //         if(res.code == 0){
            //             $('#uploadAlet').modal('hide');
            //             that.key = res.data.fileId;
            //             that.fileId = res.data.fileId;
            //             that.uptoken = res.data.uptoken;
            //
            //             that.$nextTick(function(){
            //                 var params = key.split('.')[0]; //文件名
            //                 // var domain ='upload-cc';  //域名
            //                 var putExtra = {
            //                     fname: key,
            //                     params: {},
            //                     mimeType: null
            //                 };
            //                 //文件配置
            //                 var config = {
            //                     useCdnDomain: true,
            //                     disableStatisticsReport: false,
            //                     retryCount: 6
            //                     //region: ''  //上传区域
            //                 };
            //                 //进度
            //                 var next = function(response) {
            //                     var file = response.total;
            //                     //console.log(file);
            //                     var size = file.size/1024/1024;
            //                     var loaded = file.loaded/1024/1024;
            //                     //总大小
            //                     $('.SizeBox').html(size.toFixed(2));
            //                     //已上传
            //                     $('.SecondBox').html(loaded.toFixed(2));
            //                     //上传进度
            //                     $('.pl-num').children('span').html(file.percent.toFixed(2));
            //                     //上传进度条
            //                     $('.pl-gro-bar').css('width',file.percent + '%');
            //                 };
            //                 //保错
            //                 var error = function(err) {
            //                     console.log(err);
            //                     $('#uploadImg-al .detailAlert-p').html('上传错误')
            //                     $('#uploadVideo-al').modal('show')
            //                 };
            //                 //上传成功
            //                 var complete = function(res) {
            //                     // console.log(res);
            //                     if(res.code == 0){
            //                         ++that.fileName;
            //                         if(res.data.file_path){
            //                             that.arrType.push(2);
            //                             that.arrayFile.push('https://' + res.data.bucket +  'ishow.cctv.com/' +res.data.file_path + '?imageView2/1/w/60/h/60')
            //                         }else{
            //                             that.arrType.push(1);
            //                             that.arrayFile.push('https://ishow.cctv.com/images/video.jpg')
            //                         }
            //                         that.arrayUuid.push(res.data.uuid);
            //                         that.arrayName.push($('#Textvideo').val());
            //                         $('#processModal').modal('hide');
            //                         $('#Textvideo').val('');
            //                         $('#Textareavideo').val('');
            //                         $('#upload_input').val('');
            //                         if(that.numberSize  <= that.arrayName.length + that.MyUploadVideo.length){
            //                             $('#videoContainer').hide();
            //                         }else{
            //                             //  that.Uptoken();
            //                         }
            //                     }else{
            //                         $('#processModal').modal('hide');
            //                         $('#Textvideo').val('');
            //                         $('#Textareavideo').val('');
            //                         $('#upload_input').val('');
            //                         $('.detailAlert-p').html('上传失败')
            //                         $('#uploadVideo-al').modal('show')
            //                     }
            //                 };
            //                 var observable = qiniu.upload(file, that.key + '.' + ext, that.uptoken, putExtra, config);
            //                 //console.log(observable)
            //                 var subObject = {
            //                     next: next,
            //                     error: error,
            //                     complete: complete
            //                 };
            //                 $('#uploadModal').modal('show');
            //                 //上传
            //                 $('.btn-pl-start1').unbind('click').on('click', function () {
            //                     if ($('#Textvideo').val().trim() == '') {
            //                         $('#Textvideo').focus()
            //                     }  else {
            //                         putExtra.params['x:title'] = $('#Textvideo').val();
            //                         if($('#Textareavideo').val()){
            //                             putExtra.params['x:description'] = $('#Textareavideo').val();
            //                         }else{
            //                             putExtra.params['x:description'] = $('#Textvideo').val();
            //                         }
            //
            //                         if(that.$route.params.id == 0){
            //                             putExtra.params['x:activity_id'] =  that.id;
            //                         }else{
            //                             putExtra.params['x:activity_id'] = that.$route.params.id || that.id;
            //                         }
            //                         /* putExtra.params['x:activity_id'] = that.$route.params.id || that.id;*/
            //                         putExtra.params['x:source'] = '1';
            //                         putExtra.params['x:audit_level'] = '2';
            //                         putExtra.params['x:app_id'] = that.appId;
            //                         //putExtra.params['x:event_id'] = '1000';
            //                         $('#uploadModal').modal('hide');
            //                         $('#processModal').modal('show');
            //                         subscription = observable.subscribe(subObject);
            //                     }
            //                 });
            //                 //取消
            //                 $('.btn-pl-giveup').unbind('click').on('click', function () {
            //                     subscription.unsubscribe();
            //                     $('#Textimg').val('');
            //                     $('#Textareavideo').val('');
            //                     $('#upload_input').val('');
            //                 });
            //             })
            //         }else{
            //             that.uptoken = ''
            //         }
            //     })
        });
    }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "uSqW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vAIT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vHPj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vHxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vote"},[(_vm.activityName)?_c('div',{staticClass:"line"}):_vm._e(),_vm._v(" "),(_vm.activityName)?_c('div',{staticClass:"show-box"},[_c('router-link',{staticClass:"show-tit",attrs:{"tag":"h5","to":{name:'list_vote',params: {id: _vm.detailsTxte.id,active: 1}}}},[_vm._v("\n      "+_vm._s(_vm.activityTitle)+"\n      "),_c('a',{staticClass:"show-linkmore",attrs:{"href":"javascript:void(0);"}},[_vm._v("更多")])]),_vm._v(" "),_c('div',{staticClass:"swiper-container show-poll-swiper"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.activityName),function(v,ind){return _c('div',{staticClass:"swiper-slide"},[_c('ul',{staticClass:"show-list"},_vm._l((_vm.twoNumbers),function(val,i){return (_vm.activity[ind*2+i])?_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_c('router-link',{attrs:{"tag":"a","to":{name:'list_preview',params: {id: _vm.detailsTxte.id,uuid: _vm.activity[ind*2+i].uuid,ind: _vm.activity[ind*2+i].file_type,activityId: _vm.activity[ind*2+i].activity_id}}}},[_c('div',{staticClass:"pic-box"},[(_vm.activity[ind*2+i].thumb_path)?_c('img',{attrs:{"src":_vm.activity[ind*2+i].thumb_path,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.activity[ind*2+i].file_path)?_c('img',{attrs:{"src":_vm.activity[ind*2+i].file_path,"alt":""}}):_vm._e(),_vm._v(" "),(!_vm.activity[ind*2+i] && !_vm.activity[ind*2+i].file_path)?_c('img',{attrs:{"src":"","alt":""}}):_vm._e(),_vm._v(" "),(_vm.activity[ind*2+i].time_span)?_c('i',{staticClass:"icon-time"},[_vm._v(_vm._s(_vm._f("formatSeconds")(_vm.activity[ind*2+i].time_span)))]):_vm._e(),_vm._v(" "),_c('em',{staticClass:"icon-ranknum",staticStyle:{"top":"-5px"}},[_vm._v(_vm._s(ind*2+i+1))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.activity[ind*2+i].title))]),_vm._v(" "),_c('div',{staticClass:"show-pro"},[_c('div',{staticClass:"show-bar",style:('width:'+ _vm.activity[ind*2+i].vote_count/_vm.activity[ind*2+i].vote_sum*100+'%')})])]),_vm._v(" "),_c('p',{staticClass:"show-poll"},[_c('span',[_vm._v(_vm._s(_vm.activity[ind*2+i].vote_count))]),_vm._v("票")]),_vm._v(" "),_c('div',{class:_vm.activity[ind*2+i].end_time/1 >new Date(new Date()).getTime() && (new Date()).getTime()>_vm.activity[ind*2+i].start_time?'show-btn-poll':'show-btn-poll show-btn-poll-over',attrs:{"data-id":_vm.activity[ind*2+i].uuid,"activity_id":_vm.activity[ind*2+i].activity_id}},[_vm._m(0,true),_vm._v("投票\n                ")])],1)]):_vm._e()}))])}))])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-poll"},[_c('em',[_vm._v("+1")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vhe0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            globalUrl: API.GlobalUrl
        };
    },

    methods: {
        //操作按钮事件
    },

    mounted: function mounted() {
        //操作DOM
    }

});

/***/ }),

/***/ "vi+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aTitle: '成功',
      imgUrl: ''
    };
  },

  methods: {
    //操作按钮事件
  },

  mounted: function mounted() {
    //操作DOM
    var id = this.$route.params.id;
    var that = this;
    var intervaLock;
    setTimeout(function () {
      // 投票按钮
      $('.show-box').on('click', '.show-btn-poll', function () {
        $('#Button1').css('pointer-events', 'visible');
        var tha = this;
        //show-btn-poll-over
        if (!$(this).hasClass('show-btn-poll-over')) {
          var imgUrl = API.GetGetVCode + '?' + Math.random() * 10;
          setTimeout(function () {
            that.imgUrl = imgUrl;
          }, 200);
          that.$http.get(API.GetVoteConfig, { params: { activity_id: id } }).then(function (res) {
            //console.log(res)
            var data = res.data;
            //show-btn-poll-over  end_time  start_time  verify
            var cyrrend = new Date().getTime(),
                end_time = new Date(data.end_time).getTime(),
                start_time = new Date(data.start_time).getTime();
            //判断是否在投票时间内
            if (!cyrrend < end_time / 1 && !cyrrend > start_time) {
              $(tha).addClass('show-btn-poll-over');

              //不开启验证
            } else if (data.verify == 0) {
              //直接投票
              that.$http.get(API.GetIpLimit, {
                params: {
                  activity_id: $(tha).attr('activity_id'),
                  item_id: $(tha).attr('data-id'),
                  code: ''
                }
              }).then(function (res) {
                //console.log(res)
                if (res.code == 0) {
                  var voteNumber = $(tha).parent().children('.show-poll').children();
                  var n = voteNumber.html();
                  //console.log(n)
                  voteNumber.html(++n);
                  $(tha).find('em').addClass('em-animt');
                  that.aTitle = '投票成功';
                  $('#infoModal').modal('show');
                  intervaLock = setTimeout(function () {
                    $('#infoModal').modal('hide');
                    $(tha).find('em').removeClass('em-animt');
                  }, 2000);
                } else {
                  that.aTitle = res.ext ? res.ext : res.msg;
                  $('#infoModal').modal('show');
                  $(tha).addClass('show-btn-poll-over');
                  intervaLock = setTimeout(function () {
                    $('#infoModal').modal('hide');
                  }, 2000);
                }
              });
            } else {
              //开启验证
              $('#modal-confim').modal('show');
              //点击投票
              $('#Button1').unbind('click').on('click', function () {
                //验证
                $('#Button1').css('pointer-events', 'none');
                var n = $('#inputCode').val();
                // var getValidvode = {
                //   'code': n
                // };
                that.$http.get(API.GetIpLimit, {
                  params: {
                    activity_id: $(tha).attr('activity_id'),
                    item_id: $(tha).attr('data-id'),
                    code: n
                  }
                }).then(function (res) {
                  //console.log(res)
                  if (res.code == 0) {
                    $('#modal-confim').modal('hide');
                    $('#inputCode').val('');
                    $('.ModalConfimP').hide();
                    var voteNumber = $(tha).parent().children('.show-poll').children();
                    var n = voteNumber.html();
                    //console.log(n)
                    voteNumber.html(++n);
                    $(tha).find('em').addClass('em-animt');
                    that.aTitle = '投票成功';
                    $('#infoModal').modal('show');
                    intervaLock = setTimeout(function () {
                      $('#infoModal').modal('hide');
                      $(tha).find('em').removeClass('em-animt');
                    }, 2000);
                  } else if (res.code == 1004) {
                    that.imgUrl = API.GetGetVCode + '?' + Math.random() * 10;
                    $('.ModalConfimP').show();
                    $('#Button1').css('pointer-events', 'visible');
                  } else {
                    $('#modal-confim').modal('hide');
                    $('#inputCode').val('');
                    $('.ModalConfimP').hide();
                    that.aTitle = res.ext ? res.ext : res.msg;
                    $('#infoModal').modal('show');
                    $(tha).addClass('show-btn-poll-over');
                    intervaLock = setTimeout(function () {
                      $('#infoModal').modal('hide');
                    }, 2000);
                  }
                });
                // that.$http.get(API.GetValidvode, {params: getValidvode})
                //   .then(function (res) {
                //     if (res.code == 0) {
                //       $('#modal-confim').modal('hide');
                //       $('#inputCode').val('');
                //       $('.ModalConfimP').hide();
                //       //判断验证码是否正确
                //       console.log($(tha).attr('data-id'), $(tha).attr('activity_id'))
                //       that.$http.get(API.GetIpLimit, {
                //         params: {
                //           activity_id: $(tha).attr('activity_id'),
                //           item_id: $(tha).attr('data-id'),
                //           code:getValidvode
                //         }
                //       }).then(function (res) {
                //         console.log(res)
                //         if (res.code == 0) {
                //           var voteNumber = $(tha).parent().children('.show-poll').children();
                //           var n = voteNumber.html();
                //           voteNumber.html(++n);
                //           $(tha).find('em').addClass('em-animt');
                //           that.aTitle = '投票成功';
                //           $('#infoModal').modal('show');
                //           intervaLock = setTimeout(function () {
                //             $('#infoModal').modal('hide');
                //             $(tha).find('em').removeClass('em-animt');
                //           }, 2000);
                //         } else {
                //           $(tha).addClass('show-btn-poll-over');
                //           that.aTitle = res.ext ? res.ext : res.msg;
                //           $('#infoModal').modal('show');
                //           intervaLock = setTimeout(function () {
                //             $('#infoModal').modal('hide');
                //           }, 2000);
                //         }
                //       })
                //     } else {
                //       that.imgUrl = API.GetGetVCode + '?' + Math.random() * 10;
                //       $('.ModalConfimP').show();
                //       $('#Button1').css('pointer-events', 'visible');
                //     }
                //   })
              });
              //取消
              $('#cancel').on('click', function () {
                $('#modal-confim').modal('hide');
                $('#inputCode').val('');
                $('.ModalConfimP').hide();
              });
              //更换验证码
              $('#checkCode').on('click', function () {
                that.imgUrl = API.GetGetVCode + '?' + Math.random() * 10;
              });
            }
          });
        }
      });
    }, 1800);
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "wP2W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0defeb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("rGgT");
function injectStyle (ssrContext) {
  __webpack_require__("Fo7c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0defeb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wUpx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wXXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"et-tabox"},[_c('div',{staticClass:"form"},_vm._l((_vm.RegistrationForm),function(item,ind){return _c('div',[(item.field_type == 'text')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"et-typebox et-typeText"},[_c('input',{staticClass:"form-control",attrs:{"is_require":item.is_require,"type":item.field_type,"name":item.name,"placeholder":item.tip},domProps:{"value":item.default_value},on:{"focus":function($event){_vm.SmallFocus(ind)},"keyup":function($event){_vm.SmallKeyup($event,item.rule_type,item.is_require)},"blur":function($event){_vm.SmallBlur(ind)}}}),_vm._v(" "),_c('p',{staticClass:"prompt",staticStyle:{"font-size":"14px","color":"#C8494E","line-height":"25px","display":"none"}},[_vm._v("\n            请输入正确的"+_vm._s(item.title)+"格式！")]),_vm._v(" "),_c('i',{staticClass:"icon-delete",on:{"click":function($event){_vm.SmallDelete(ind)}}})])]):_vm._e(),_vm._v(" "),(item.field_type == 'textarea')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"et-trbox"},[_c('textarea',{staticClass:"form-control",attrs:{"rows":"3","is_require":item.is_require,"name":item.name,"placeholder":item.tip},domProps:{"value":item.default_value}}),_vm._v(" "),_c('i',{staticClass:"icon-delete",on:{"click":_vm.largeDelete}})])]):_vm._e(),_vm._v(" "),(item.field_type == 'radio')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),(JSON.parse(item.option_json))?_c('ul',{staticClass:"et-radiolink"},_vm._l((Math.ceil(JSON.parse(item.option_json).length/2)),function(val,ind){return _c('li',_vm._l((2),function(val,i){return (JSON.parse(item.option_json)[ind*2 + i])?_c('div',{staticClass:"et-libox",on:{"click":function($event){_vm.sexOn(ind*2 + i,JSON.parse(item.option_json)[ind*2 + i],item.name)}}},[_c('div',{class:JSON.parse(item.option_json)[ind*2 + i] == item.default_value?'radio-box radio-on'+' '+item.name:'radio-box'+' '+item.name,attrs:{"is_require":item.is_require,"name":item.name}},[_c('input',{attrs:{"type":item.field_type,"name":item.name}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(JSON.parse(item.option_json)[ind*2 + i]))])]):_vm._e()}))})):_vm._e()]):_vm._e(),_vm._v(" "),(item.field_type == 'checkbox')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('ul',{staticClass:"et-checklink",attrs:{"is_require":item.is_require,"name":item.name}},_vm._l((JSON.parse(item.option_json)),function(val,ind){return _c('li',[_c('div',{staticClass:"check-box",attrs:{"attr-name":val}},[_c('input',{attrs:{"type":"checkbox","name":item.name}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(val))])])}))]):_vm._e(),_vm._v(" "),(item.field_type == 'select')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"et-slebox form-control"},[_c('select',{staticClass:"form-control select",attrs:{"name":item.name,"is_require":item.is_require}},_vm._l((JSON.parse(item.option_json)),function(val,ind){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(val))])})),_vm._v(" "),_c('i',{staticClass:"icon-select"})])]):_vm._e(),_vm._v(" "),(item.field_type == 'date')?_c('div',{staticClass:"group"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"et-typebox et-typeData"},[_c('input',{staticClass:"form-control date-new-show",attrs:{"type":"date","name":item.name,"is_require":item.is_require,"value":""}})])]):_vm._e(),_vm._v(" "),(item.field_type == 'address')?_c('div',{staticClass:"group content-block"},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('Linkage',{attrs:{"text":item.default_value},on:{"message":_vm.listenToMyBoy}}),_vm._v(" "),_c('input',{staticClass:"demo1",staticStyle:{"display":"none"},attrs:{"title":item.title,"name":item.name,"is_require":item.is_require,"type":"text"}}),_vm._v(" "),_c('div',{staticClass:"group detailed",staticStyle:{"display":"block"}},[_c('label',[_vm._v("详细地址"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_vm._m(0,true)])],1):_vm._e(),_vm._v(" "),(item.field_type == 'selectmul')?_c('div',{staticClass:"group group-selmul content-block",attrs:{"is_require":item.is_require,"name":item.name}},[_c('label',[_vm._v(_vm._s(item.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.is_require == 1),expression:"item.is_require == 1"}]},[_vm._v("*")])]),_vm._v(" "),_c('Selectmul',{attrs:{"item_data":item},on:{"change":_vm.casChange}})],1):_vm._e(),_vm._v(" "),(item.field_type == 'upload' && _vm.thirdParty)?_c('Upload',{attrs:{"UpFile":item,"type":"0","appId":_vm.appId,"audit_level":_vm.audit_level}}):_vm._e(),_vm._v(" "),(item.field_type == 'uploadvideo' && _vm.thirdParty)?_c('VideoUpload',{attrs:{"UpFile":item,"type":"0","appId":_vm.appId,"audit_level":_vm.audit_level}}):_vm._e(),_vm._v(" "),(item.field_type == 'uploadimg' && _vm.thirdParty)?_c('ImageUpload',{attrs:{"UpFile":item,"type":"0","appId":_vm.appId,"id":_vm.paramsId,"audit_level":_vm.audit_level}}):_vm._e(),_vm._v(" "),(item.field_type == 'uploadfile' && _vm.thirdParty)?_c('FileUpload',{attrs:{"UpFile":item,"type":"0","appId":_vm.appId,"id":_vm.paramsId,"audit_level":_vm.audit_level}}):_vm._e()],1)})),_vm._v(" "),(!_vm.detailsTxte||!_vm.detailsTxte.page_config||!_vm.detailsTxte.page_config.notice||_vm.detailsTxte.page_config.notice.is_show!='3')?_c('div',{staticClass:"et-deal"},[_c('div',{staticClass:"et-deal-check et-deal-on",on:{"click":_vm.ReadAndAgree}},[_c('input',{attrs:{"type":"checkbox","name":"checkdeal"}})]),_vm._v(" "),(_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.notice&&_vm.detailsTxte.page_config.notice.is_show=='2')?_c('p',[_vm._v("\n      "+_vm._s(_vm.detailsTxte.page_config.notice.text)+"\n    ")]):_c('p',[_vm._v("\n      阅读并同意"),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.agreement(1)}}},[_vm._v("央视网网络服务使用协议")]),_vm._v("和"),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.agreement(2)}}},[_vm._v("网站声明")]),(_vm.paramsId == 57722)?_c('span',[_vm._v("以及"),_c('a',{staticClass:"chengnuo",attrs:{"href":"javascript:void(0);","id":"chengnuo"},on:{"click":function($event){_vm.agreement(3)}}},[_vm._v("报名承诺书")])]):_vm._e(),(_vm.detailsTxte && _vm.detailsTxte.page_config.notice && _vm.detailsTxte.page_config.notice.is_show==1)?_c('span',[_vm._v("以及"),_c('a',{staticClass:"chengnuo",attrs:{"href":_vm.detailsTxte.page_config.notice.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.detailsTxte.page_config.notice.title))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.etComplete&&_vm.detailsTxte&&_vm.detailsTxte.page_config&&_vm.detailsTxte.page_config.formSubmitBtn&&_vm.detailsTxte.page_config.formSubmitBtn.is_show=='1')?_c('a',{class:['et-complete',_vm.loading? 'bg_grey': ''],style:('background:'+_vm.detailsTxte.page_config.formSubmitBtn.style),attrs:{"href":"javascript:void(0);"},on:{"click":_vm.complete}},[_vm._v("\n   "+_vm._s(_vm.detailsTxte.page_config.formSubmitBtn.title)+"\n  ")]):_c('a',{class:['et-complete',_vm.loading? 'bg_grey': ''],attrs:{"href":"javascript:void(0);"},on:{"click":_vm.complete}},[_vm._v("\n    提 交\n  ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-confim large-info-modal modal fade",attrs:{"id":"agreement","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"margin-top":"0"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"height":"450px","padding-bottom":"20px"}},[_c('div',{staticClass:"modal-body",staticStyle:{"height":"430px"}},[_c('div',{attrs:{"id":"page_body"}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"yonghuzhongxin10764A_ind16",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),(_vm.agreement1)?_c('h3',{staticClass:"h3_1",staticStyle:{"font-weight":"bold"}},[_vm._v("央视网网络服务使用协议")]):_vm._e(),_vm._v(" "),(_vm.agreement2)?_c('h3',{staticClass:"h3_1",staticStyle:{"font-weight":"bold"}},[_vm._v("网站声明")]):_vm._e(),_vm._v(" "),(_vm.agreement3)?_c('h3',{staticClass:"h3_1",staticStyle:{"font-weight":"bold"}},[_vm._v("报名承诺书")]):_vm._e(),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('div',{staticClass:"niticeSroll",staticStyle:{"margin":"0 5px","height":"350px","overflow-y":"auto","padding-top":"15px","padding-bottom":"15px","background":"#fff","border-top":"1px solid #e0e0e0","border-bottom":"1px solid #e0e0e0"}},[(_vm.agreement1)?_c('div',{staticClass:"ind16_main",attrs:{"id":"jsSroll"}},[_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第一章 服务使用协议的确认和接纳")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第一条\n                      央视网网络服务使用协议（以下简称“协议”）是由用户（您）与央视国际网络有限公司（央视网）就央视网提供的网络服务所订立的相关权利义务规范，本协议对您及央视网均具有法律效力，未成年人需在法定监护人的陪同下审阅。")]),_vm._v(" "),_c('p',[_vm._v("第二条 央视网（网址：www.cctv.com、\n                      www.cntv.cn）完全按照其发布的服务条款和操作规则向用户提供服务。本协议所称的用户（您）是指完全同意所有协议条款并完成注册程序或未经注册而使用央视网提供各项服务的个人或机构。")]),_vm._v(" "),_c('p',[_vm._v("第三条 您同意接受本协议，方可注册成为央视网正式用户。您注册成功后，央视网将给予您一个帐号及相应的密码，该帐号和密码由您负责保管；您对以该帐号进行的所有活动和事件负法律责任。")]),_vm._v(" "),_c('p',[_vm._v("第四条 您注册前，请认真阅读本协议。注册成功后，即视为同意接受本协议的全部内容，受本协议的约束。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第二章 服务使用协议的变更和修改")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第五条 本协议的订立、执行、解释及争议的解决均应遵守中华人民共和国有关法律、法规，如协议之任何一部分与中华人民共和国法律、法规相抵触，则该部分条款应按法律规定执行。")]),_vm._v(" "),_c('p',[_vm._v("第六条 央视网有权随时修改本协议的任何条款，并在央视网上公示，而无需另行单独通知您，您可随时通过央视网浏览最新服务使用协议条款。")]),_vm._v(" "),_c('p',[_vm._v("第七条 当您使用央视网的特殊服务时，应接受央视网随时提供的与该特殊服务相关的规则或说明，并且此规则或说明均构成本协议的一部分。")]),_vm._v(" "),_c('p',[_vm._v("第八条 如果不同意央视网对本协议相关条款所做的修改，您可以主动向客服要求取消已经获得的网络服务；如果您继续使用网络服务，则视为您接受央视网对本协议相关条款所做的修改。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第三章 服务说明")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第九条\n                      央视网网络服务的具体内容由央视网根据实际情况提供，包括论坛（BBS）、博客、微博、播客、跟帖评论、边看边聊、邮箱、搜索等。除非另有明确规定，增强或强化目前服务的任何新功能，包括新产品，均无条件地适用本协议。")]),_vm._v(" "),_c('p',[_vm._v("第十条 您接受本协议，须同意并提供完整、真实、准确、最新的身份信息，并不断更新注册资料。")]),_vm._v(" "),_c('p',[_vm._v("\n                      若您提供任何错误、不实、过时或不完整的身份信息，并为央视网所确知；或者央视网有合理理由怀疑前述信息为错误、不实、过时或不完整，央视网有权暂停或终止您的帐号权限，并拒绝现在或将来向您提供本服务的全部或一部分。")]),_vm._v(" "),_c('p',[_vm._v("第十一条\n                      您理解：央视网仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均由您自行负担。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第四章 您应遵守以下法律及法规")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第十二条 您承诺遵守中华人民共和国有关法律法规和规范性文件，承担一切因您的行为直接或间接引起的法律责任。")]),_vm._v(" "),_c('p',[_vm._v("第十三条 您也应了解国际互联网的无国界性，还应特别注意遵守所在国家和地区所有有关的法律和法规。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第五章 使用规则")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第十四条\n                      您要注意保管好帐号及密码，不应将您的帐号、密码转让或出借给他人使用。如您发现帐号遭他人非法使用，应立即联系央视网客服中心。因黑客行为或您保管疏忽导致帐号、密码遭他人非法使用，央视网不承担任何责任。")]),_vm._v(" "),_c('p',[_vm._v("第十五条\n                      您同意央视网有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在央视网的任何传播形式上投放广告），并且，您同意接受央视网通过电子邮件或其他方式向您发送商品促销或其他相关商业信息。")]),_vm._v(" "),_c('p',[_vm._v("第十六条\n                      对于您通过央视网网络服务（包括但不限于论坛、博客、微博、播客、跟帖评论）上传到央视网上可公开获取区域的任何内容，您同意央视网在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的下述权利：以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。")]),_vm._v(" "),_c('p',[_vm._v("第十七条 您在使用央视网服务过程中，必须遵循以下原则：")]),_vm._v(" "),_c('p',[_vm._v("(一) 遵守所有与网络服务有关的网络协议、规定和程序；")]),_vm._v(" "),_c('p',[_vm._v("(二) 不得为任何非法目的而使用网络服务系统；")]),_vm._v(" "),_c('p',[_vm._v("(三) 不得以任何形式使用央视网的网络服务侵犯央视网的商业利益，包括并不限于发布非经央视网许可的商业广告；")]),_vm._v(" "),_c('p',[_vm._v("(四) 不得利用央视网的网络服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；")]),_vm._v(" "),_c('p',[_vm._v("(五) 不得利用央视网的网络服务功能传播任何具有欺诈、胁迫、淫秽性的和损害他人人格尊严的信息资料；")]),_vm._v(" "),_c('p',[_vm._v("(六) 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；")]),_vm._v(" "),_c('p',[_vm._v("(七) 不得利用央视网的网络服务系统进行任何不利于央视网的行为。")]),_vm._v(" "),_c('p',[_vm._v("第十八条 您在使用央视网所提供的网络服务时，不得产生下列信息：")]),_vm._v(" "),_c('p',[_vm._v("(一) 违反宪法或法律法规规定的；")]),_vm._v(" "),_c('p',[_vm._v("(二) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；")]),_vm._v(" "),_c('p',[_vm._v("(三) 损害国家荣誉和利益的，损害公共利益的；")]),_vm._v(" "),_c('p',[_vm._v("(四) 煽动民族仇恨、民族歧视，破坏民族团结的；")]),_vm._v(" "),_c('p',[_vm._v("(五) 破坏国家宗教政策，宣扬邪教和封建迷信的；")]),_vm._v(" "),_c('p',[_vm._v("(六) 散布谣言，扰乱社会秩序，破坏社会稳定的；")]),_vm._v(" "),_c('p',[_vm._v("(七) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；")]),_vm._v(" "),_c('p',[_vm._v("(八) 侮辱或者诽谤他人，侵害他人合法权益的；")]),_vm._v(" "),_c('p',[_vm._v("(九) 含有法律、行政法规禁止的其他内容的。")]),_vm._v(" "),_c('p',[_vm._v("第十九条\n                      您在设置帐号名称、头像和简介等注册信息时须遵守本协议第十八条的要求，不得出现违法和不良信息，并承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。")]),_vm._v(" "),_c('p',[_vm._v("第二十条\n                      央视网有权对您使用其网络服务的情况进行审查和监督（包括但不限于对您存储在央视网的内容进行审核），如您在使用网络服务时违反本协议任何规定，央视网或其授权主体有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除您已张贴的内容、暂停或终止您使用网络服务的权利等）以减轻因您的不当行为造成的影响。\n                      对于违反有关法律法规、侵犯他人隐私和名誉等内容，央视网有保存相关记录，并依法向有关部门提供的权利。")]),_vm._v(" "),_c('p',[_vm._v("第二十一条\n                      央视网针对某些特定网络服务的使用通过各种方式（包括但不限于网页公告、电子邮件等）作出的任何声明、通知、警示等内容视为本协议的一部分，您如使用该等网络服务，视为您同意该等声明、通知、警示的内容。")]),_vm._v(" "),_c('p',[_vm._v("第二十二条 您认为自己在央视网的权益受到侵害，有权根据央视网相关规定进行投诉、申诉。")]),_vm._v(" "),_c('p',[_vm._v("第二十三条 您有权对央视网互动平台管理提出批评、意见、建议，有权就互动平台管理工作提出咨询。")]),_vm._v(" "),_c('p',[_vm._v("第二十四条 您需遵守网络道德，注意网络礼仪，做到文明上网。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第六章 服务变更、中断或终止")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第二十五条 鉴于网络服务的特殊性，您同意央视网有权随时变更、中断或终止部分或全部的网络服务。")]),_vm._v(" "),_c('p',[_vm._v("第二十六条\n                      您理解：央视网需要定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，央视网无需为此承担任何责任，但应通过央视网尽可能事先进行通告。")]),_vm._v(" "),_c('p',[_vm._v("第二十七条 如发生下列任何一种情形，央视网有权随时中断或终止向您提供本协议项下的网络服务而无需对您或任何第三方承担任何责任：")]),_vm._v(" "),_c('p',[_vm._v("(一) 在任何情况下，央视网合理地认为您的行为可能违反中华人民共和国有关法律法规和规范性文件；")]),_vm._v(" "),_c('p',[_vm._v("(二) 您提供的个人资料不真实；")]),_vm._v(" "),_c('p',[_vm._v("(三) 您违反本协议中的部分条款。")]),_vm._v(" "),_c('p',[_vm._v("第二十八条 您的帐号和密码遭到未授权的使用或发生其他任何安全问题，您可以立即通知央视网。在您每次连线结束时，应结束帐号使用，否则您可能得不到央视网的安全保护。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第七章 知识产权")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第二十九条\n                      央视网提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。央视网不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式，向您或任何第三方负责。")]),_vm._v(" "),_c('p',[_vm._v("第三十条\n                      央视网为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，您不得对该软件进行反向工程（reverse\n                      engineer）、反向编译（decompile）或反汇编（disassemble）。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第八章 隐私权保护")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第三十一条 保护用户隐私是央视网的一项基本政策，央视网保证不对外公开或向第三方提供您的注册资料及您在使用网络服务时存储在央视网的非公开内容，但下列情况除外：")]),_vm._v(" "),_c('p',[_vm._v("(一) 事先获得您的明确授权。")]),_vm._v(" "),_c('p',[_vm._v("(二) 依据有关法律规定，国家有关机关按照法律程序要求查询时，提供您的注册信息、您在央视网上发布的信息内容及其发布时间、互联网地址或者域名。")]),_vm._v(" "),_c('p',[_vm._v("(三) 为维护用户及社会公共利益的需要。")]),_vm._v(" "),_c('p',[_vm._v("(四) 为维护央视网的合法权益。")]),_vm._v(" "),_c('p',[_vm._v("第三十二条 央视网可能会与第三方合作向您提供相关的网络服务，在此情况下，如该第三方同意承担与央视网同等的保护用户隐私的责任，则央视网有权将您的注册资料等提供给该第三方。")]),_vm._v(" "),_c('p',[_vm._v("第三十三条 在不透露您的隐私资料前提下，央视网有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第九章 免责声明")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第三十四条 您明确同意您在使用央视网网络服务所存在的风险将完全由您自己承担；因您使用央视网网络服务而产生的一切后果也由您自己承担，央视网对您不承担任何责任。")]),_vm._v(" "),_c('p',[_vm._v("第三十五条 您对央视网提供的网络服务承担使用风险。央视网不保证服务一定会满足您的使用要求，也不保证服务不会中断，央视网对服务的及时性、安全性、准确性也不作担保。")]),_vm._v(" "),_c('p',[_vm._v("第三十六条 央视网不保证为向您提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由央视网实际控制的任何网页上的内容，央视网不承担任何责任。")]),_vm._v(" "),_c('p',[_vm._v("第三十七条 对于因不可抗力或央视网不能控制的原因造成的网络服务中断或其它缺陷，央视网不承担任何责任，但将尽力减少由此给您造成的损失和影响。")]),_vm._v(" "),_c('p',[_vm._v("第三十八条 您同意：对于央视网向您提供的下列产品或者服务的质量缺陷引发的任何损失，央视网无需承担任何责任：")]),_vm._v(" "),_c('p',[_vm._v("(一)央视网向您免费提供的各项网络服务；")]),_vm._v(" "),_c('p',[_vm._v("(二)央视网向您赠送的任何产品或者服务；")]),_vm._v(" "),_c('p',[_vm._v("(三)央视网向收费网络服务用户附赠的各种产品或者服务。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第十章 违约赔偿")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第三十九条 如因央视网违反有关法律、法规或本协议项下的任何条款而给您造成损失，央视网同意承担由此造成的损害赔偿责任。")]),_vm._v(" "),_c('p',[_vm._v("第四十条 您同意保障和维护央视网及其他用户的利益，如因您违反有关法律、法规或本协议项下的任何条款而给央视网或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第十一章 通知送达")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第四十一条 本协议项下央视网对您的所有通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。")]),_vm._v(" "),_c('p',[_vm._v("第四十二条 您对于央视网的通知应当通过央视网对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第十二章 争议解决方式")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第四十三条 本协议及其修订本的有效性、履行和与本协议及其修订本效力有关的所有事宜，将受中华人民共和国法律管辖，任何争议仅适用中华人民共和国法律。")]),_vm._v(" "),_c('p',[_vm._v("第四十四条 因本协议所引起的您与央视网的任何纠纷或争议，首先应友好协商解决，协商不成的，您在此完全同意将纠纷或争议提交央视网所在地即北京市有管辖权的人民法院诉讼解决。")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('h3',{staticClass:"h3_2"},[_vm._v("第十三章 其他规定")]),_vm._v(" "),_c('div',{staticClass:"vspace"}),_vm._v(" "),_c('p',[_vm._v("第四十五条 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。")]),_vm._v(" "),_c('p',[_vm._v("第四十六条 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。")]),_vm._v(" "),_c('p',[_vm._v("第四十七条 本协议将取代您先前与央视网签署的任何网络服务使用协议。本协议和央视网的其他服务条款构成完整的协议。")]),_vm._v(" "),_c('p',[_vm._v("第四十八条 本协议中的标题仅为方便而设，在解释本协议时应被忽略。")]),_vm._v(" "),_c('p',[_vm._v("第四十九条 本协议最终解释权归央视国际网络有限公司所有 。")])]):_vm._e(),_vm._v(" "),(_vm.agreement2)?_c('div',{staticClass:"ind16_main",attrs:{"id":"jsSrolls"}},[_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.agreement3)?_c('div',{staticClass:"ind16_main"},[_vm._m(4),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("参赛者在报名前必须仔细阅读如下法律文本，在了解并理解的基础上承诺并签署，报名即意味着遵守法律文本中的条款，否则报名无效。")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',{staticStyle:{"display":"block"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10)]):_vm._e()])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"et-typebox"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"请输入详细地址"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sing-modal upload-modal large-info-modal modal fade",attrs:{"id":"participateIn","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"Prompt-p",attrs:{"id":"fileMessage"}},[_vm._v("请确定信息是否填写完成？ ")]),_vm._v(" "),_c('div',{staticClass:"btn-modal-tw"},[_c('a',{staticClass:"buttonZ",attrs:{"href":"javascript:void(0);","data-dismiss":"modal"}},[_vm._v("确定")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_Quick",staticStyle:{"float":"right","position":"relative"}},[_c('a',{staticClass:"icon-out",staticStyle:{"top":"-50px"},attrs:{"data-dismiss":"modal","href":"javascript:void(0);"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("央视网（www.cctv.com）和中国网络电视台（www.cntv.cn）（以下统称“本网”）由央视国际网络有限公司主办。"),_c('br'),_vm._v("\n\n                      　　本网是中央电视台的新媒体业务平台。经中央电视台授权，本网独占性通过信息网络向公众传播中央电视台享有著作权及相关权利的电视频道及其所包含的全部电视节目。"),_c('br'),_vm._v("\n\n                      　　本网所呈现的所有内容，包括但不限于文字、图像、图片、照片、图表、音频、视频、标志、标识、广告、商标、商号、域名、程序、版面设计、专栏目录与名称、内容分类标准以及为注册用户提供的任何信息，均受到《中华人民共和国著作权法》、《中华人民共和国商标法》、《中华人民共和国专利法》、《中华人民共和国反不正当竞争法》等相关法律法规的保护，为本网或权利人所有。\n                      "),_c('br'),_vm._v("\n                      　　任何第三方不得歪曲和篡改本网所呈现的内容。未经本网授权，任何第三方不得擅自引用、复制、转载、摘编或以其他任何方式非法使用本网站所呈现的内容。\n                      "),_c('br'),_vm._v("\n                      　　任何第三方不得擅自转载本网提供的信息和服务内容，如需转载，必须取得相应权利人的合法授权。经本网授权使用的，不得超越所获授权范围，且在转载时须保留原有信息和服务内容的来源。\n                      "),_c('br'),_vm._v("\n                      　　任何第三方不得盗用本网名义发布信息，或擅自使用本网名义引用、转载来源不规范或权属不明晰的信息。\n                      "),_c('br'),_vm._v("\n                      　　凡本网注明“来源：央视网／中国网络电视台”的所有内容，均为本网合法拥有著作权或相关权利的内容，未经本网授权，任何第三方不得转载、链接、摘编或以其他方式使用上述内容。已经本网授权使用的，应在授权范围内使用，并注明“来源：央视网／中国网络电视台”。\n                      "),_c('br'),_vm._v("\n                      　　凡本网未标有“来源：央视网／中国网络电视台”的内容，均为转载稿，转载目的在于传递更多信息，并不代表本网赞同其观点或对其真实性负责。任何第三方在以转载、链接、摘编或者下载等方式使用时，必须保留本网注明的“来源”，并自行承担相关法律责任。\n                      "),_c('br'),_vm._v("\n                      　　对于违反上述规定侵犯本网站知识产权等合法权益的行为，本网将依法追究其法律责任。\n                      "),_c('br'),_vm._v("\n                      　　鉴于本网呈现的内容来源广泛、数量较多，如著作权人发现本网转载了其拥有著作权的作品且没有事先与著作权人沟通联络，请主动与本网联系，提供相关证明材料，本网将依法处理。如权利人认为本网呈现的内容侵犯其肖像权、名誉权或其他合法权益的，请主动与本网联系，提供相关投诉材料，本网亦将依法处理。\n                      "),_c('br'),_vm._v("\n                      　　本网联系电话：010-88047123。"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"right"}},[_vm._v("          合同编号：                      "),_c('br'),_vm._v("          参赛者姓名：                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("一．参赛资格"),_c('br'),_vm._v("         1参赛者须为中国公民。18岁以下的参赛者应在父母或监护人的许可下报名。参赛者应准确、如实、完整地填写一份个人背景资料，并确保自己在生理或心理上处于良好状况，并由本人或监护人在该资料上签字确认。如果参赛者的任何信息被查证失实，参赛者丧失参赛资格，制作方保留追究法律责任的权力；"),_c('br'),_vm._v("         2参赛者须具备如下资质：a 参赛者承诺是该项发明的发明人或专利权人；b 如果是该发明是共同发明。参赛者承诺其参赛行为已经获得其他所有发明人或专利权人的许可；"),_c('br'),_vm._v("         3鉴于“我爱发明”栏目作为电视媒体，故对参赛者提供的个人资料及发明的权利归属做实质审查不具有可行性，因此参赛者应保证其展示的发明不存在任何权利瑕疵和争议，自行承担侵犯专利权、名誉权、商业秘密等可能法律后果并保证“我爱发明”栏目不会因此受到任何诉讼和追索。"),_c('br'),_vm._v("         4参赛者必须提供10分钟的视频资料，其内容是发明人对自己发明项目的功能、原理、特点和使用效果的介绍。制作格式为DVD光盘。"),_c('br'),_vm._v("         5参赛者如有多个发明项目想申请展示，每一项目需单独填写一张项目表。"),_c('br'),_vm._v("         6参赛者必须配合制作单位的安排，包括宣传、摄制等活动。对于进入节目录制环节的参赛者，必须保证按照节目录制的日程进行录制，否则制作方有权取消其录制资格。无正当理由退出或做出有损节目的行为，制作方将保留追究法律责任的权力；"),_c('br'),_vm._v("         7未经制作方许可，参赛者承诺不在“我爱发明”电视制作和播放期内参加其他与该发明有关的“电视评选比赛”活动、参与或签署任何商业或赞助条款或安排、出席或参与任何不是制作单位的出镜或媒体采访活动。"),_c('br'),_vm._v("         8参赛者承诺其个人及家属朋友是自愿参与“我爱发明”的节目录制，不涉及任何节目录制酬劳。节目录制期间有任何意外均由本人自行负责。"),_c('br'),_vm._v("         9即使参赛者满足所有申请要求，节目制作方没有必须面试或者选择其参赛的义务；参赛者将不会因签署这份承诺书并让渡这些权利而获得任何货币收入；"),_c('br'),_vm._v("         10参赛者同意并完全理解节目规程，并愿意遵守所有与之相关的规则，承担因违反此规则所产生的后果；")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-indent":"2em","display":"block"}},[_vm._v("二．发明的参赛资格"),_c('br'),_vm._v("         1 该发明必须是新颖性、实用性和创造性的产品或方法，具有良好的市场前景。"),_c('br'),_vm._v("         2 自面试的时起至该节目录制结束，发明人[和/或]专利权人不得在此期间自行或许可他人大量生产。"),_c('br'),_vm._v("         3 呈交的发明必须附上完整的发明产品表格，详细的描述，必须能提供可操作或能实际应用的原型或样品。仅有概念设计的发明，将不被栏目组采用。"),_c('br'),_vm._v("         4若该发明已申请专利，已公开技术文件[和/或]已取得专利权证书。发明人应向栏目组提交一份发明专利证书的复印件或相关证明文件。"),_c('br'),_vm._v("         5下列类别的发明将不被栏目组接受："),_c('br'),_vm._v("            药品、食品和保健品；"),_c('br'),_vm._v("            农作物；"),_c('br'),_vm._v("            医用器械；"),_c('br'),_vm._v("            危险化学品或材料；"),_c('br'),_vm._v("            电脑软件；"),_c('br'),_vm._v("            爆破装置；"),_c('br'),_vm._v("            成人用品；"),_c('br'),_vm._v("            以及其他有可能危及公共安全或引发不良影响的发明。")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-indent":"2em","display":"block"}},[_vm._v("三．“我爱发明”节目制作"),_c('br'),_vm._v("         1  参赛者了解并同意自报名生效之日起，中央电视台有权无偿并不须本人另行同意对本人基于参赛行为[包括但不限于：报名、各场次比赛录制等阶段]填写的资料、提供的DVD视频、节目彩排、录制过程中所产生的包含本人及发明的资料、名称、肖像、声音等的照片、图片、动画、视音频等资料在“我爱发明”节目中使用。"),_c('br'),_vm._v("         2“我爱发明”电视节目的版权归中央电视台所有，中央电视台有权在无需另外付费的前提下使用该节目或节目片断。使用方式包括但不限于：各频道各种传播方式的国内外电视播放,将节目重新编辑后电视播放，素材使用，出版发行VCD、DVD 、CD等载体的音像制品，基于互联网、移动终端、IPTV、公共视频载体等新媒体平台上的信息网络传播权，出版发行基于电视节目的图书、画册、挂历、连环画等文字或文字加图片的出版物，在报纸、杂志上刊发基于电视节目的文字内容、图片，声音广播等。"),_c('br'),_vm._v("         3   中央电视台有权录制播出或直播选手面试、淘汰赛、决赛阶段的实况，参赛者不得对电视台播出、使用电视节目的方式进行任何干涉。")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"display":"block","margin":"0","line-height":"1.5"}},[_vm._v("         承诺人： "),_c('br'),_vm._v("         身份证号：")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"display":"block","margin":"0","line-height":"1.5"}},[_vm._v("         监护人： "),_c('br'),_vm._v("         身份证号：")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"display":"block","margin":"0","line-height":"1.5"}},[_vm._v("         发明名称： "),_c('br'),_vm._v("         日    期：")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x3XZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"samll-info-modal modal fade",attrs:{"id":"infoModal","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('i',{staticClass:"icon-modal"}),_vm._v(" "),_c('p',{staticClass:"info-mess"},[_vm._v(_vm._s(_vm.aTitle))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-confim large-info-modal modal fade",attrs:{"id":"modal-confim","role":"dialog","aria-hidden":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"margin-top":"0"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"code",attrs:{"id":"checkCode"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.imgUrl,"alt":""}})]),_vm._v(" "),_c('p',{staticClass:"ModalConfimP",staticStyle:{"color":"red","display":"none"}},[_vm._v("验证码错误")]),_vm._v(" "),_c('input',{staticClass:"code-input",attrs:{"type":"text","id":"inputCode","value":"","placeholder":"请输入验证码"}}),_vm._v(" "),_c('button',{staticClass:"btn-1 buttonW buttonL",attrs:{"id":"Button1","type":"button"}},[_vm._v("投票")]),_vm._v(" "),_c('button',{staticClass:"btn-2 buttonW buttonR",attrs:{"id":"cancel","data-dismiss":"modal"}},[_vm._v("取消")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xBaD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['UpFile', 'id', 'appId', 'audit_level'],
    data: function data() {
        return {
            uptoken3: '',
            fileId3: '',
            fileName3: 0,
            arrayName3: [],
            arrayUuid3: [],
            arrayFile: [],
            allTyle3: false,
            key: '',
            numberSize: 0,
            MyUploadVideo: [],
            moreInfo: false,
            classObj: {
                active: false,
                'down-arrow': false,
                all: false,
                elips: false
            },
            upfileTip: ''
        };
    },

    methods: {
        allTetx3: function allTetx3() {
            if (!this.moreInfo) return;
            this.allTyle3 = !this.allTyle3;
            if (this.allTyle3) {
                // $('.et-video-info').css('white-space','normal');
                this.classObj = {
                    active: true,
                    'down-arrow': true,
                    all: true
                    // elips: false,
                };
                this.upfileTip = this.UpFile.tip;
            } else {
                // $('.et-video-info').css('white-space','nowrap');
                this.classObj = {
                    active: false,
                    'down-arrow': true,
                    all: false
                    // elips: true,
                };
                this.upfileTip = this.UpFile.tip.substr(0, 50) + '...';
            }
        },

        //操作按钮事件
        Uptoken3: function Uptoken3() {
            var that = this;
            this.$http.get(API.WorldToken, { params: { activity_id: that.$route.params.id, app_id: that.appId } }).then(function (res) {
                if (res.code == 1) {
                    that.fileId3 = '';
                    that.uptoken3 = '';
                    that.key = '';
                } else {
                    that.key = res.data.fileId;
                    that.fileId3 = res.data.fileId;
                    that.uptoken3 = res.data.uptoken;
                }
            });
        },
        cancel3: function cancel3() {
            $('#uploadModal3').modal('hide');
            $('#Textvideo').val('');
            $('#Textareavideo').val('');
            $('#select').val('');
        },
        updateFile: function updateFile(idx) {
            this.arrayUuid3.splice(idx, 1);
            this.arrayName3.splice(idx, 1);
            this.fileName3--;
            if (this.numberSize > this.arrayName3.length + this.MyUploadVideo.length) {
                $('#videoContainer3').show();
            }
        },
        delFile: function delFile(idx) {
            this.fileName3--;
            this.arrayUuid3.splice(idx, 1);
            this.arrayName3.splice(idx, 1);
            if (this.UpFile.choose_num > this.arrayName3.length) {
                $('#videoContainer3').show();
            }
        },
        initMoreInfo: function initMoreInfo() {
            var pinfo = this.$refs.p_info;
            if (pinfo) {
                var offH = pinfo.offsetHeight;
                var scrollH = pinfo.scrollHeight;
                // console.log(pinfo,offH,scrollH);
                if (scrollH > offH) {
                    this.moreInfo = true;
                    this.classObj = {
                        active: false,
                        all: false,
                        // elips:true,
                        'down-arrow': true
                    };
                    this.upfileTip = this.UpFile.tip.substr(0, 50) + '...';
                }
            }
        }
    },
    created: function created() {
        this.upfileTip = this.UpFile.tip;
    },
    mounted: function mounted() {
        //操作DOM

        var that = this,
            subscription3;
        this.initMoreInfo();

        // if(this.UpFile.field_type == 'uploadfile'){
        if (that.UpFile.choose_num == '0') {
            $('.uploadFile').hide();
            return false;
        }

        if (that.type != 0) {
            that.ByUserid = {
                file_type: 3,
                activity_id: that.id
            };
            console.log("byuserID", that.ByUserid);
            this.$http.get(API.GetActivityFileByUserid, { params: that.ByUserid }).then(function (res) {
                //  console.log(res)
                if (res.code == 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        that.MyUploadVideo.push(res.data[i]);
                        // console.log(i)
                    }
                }
                console.log(that.MyUploadVideo);
                that.arrayUuid3 = [];
                that.arrayName3 = [];
                that.fileName3 = 0;
                if (!that.UpFile.choose_num) {
                    that.numberSize = 1;
                } else {
                    that.numberSize = that.UpFile.choose_num;
                }
                if (that.numberSize == '' || that.numberSize == null || that.numberSize <= res.total) {
                    $('#videoContainer3').hide();
                }
            });
        } else {
            that.numberSize = that.UpFile.choose_num;
        }
        // that.Uptoken3();
        // }

        $('#select3').change(function () {
            //$('#uploadModal3').modal('show');
            var file = this.files[0]; //文件
            var key = file.name; //文件总名
            var name = key.split('.'); //
            var ext = name[name.length - 1].toLowerCase();

            //进度
            var next = function next(response) {
                var file = response;
                //console.log(file);
                var size = file.size / 1024 / 1024;
                var loaded = file.loaded / 1024 / 1024;
                //总大小
                $('.SizeBox').html(size.toFixed(2));
                //已上传
                $('.SecondBox').html(loaded.toFixed(2));
                //上传进度
                $('.pl-num').children('span').html(file.percent.toFixed(2));
                //上传进度条
                $('.pl-gro-bar').css('width', file.percent + '%');
            };
            //保错
            var error = function error(err) {
                console.log(err);
                $('#processModal').modal('hide');
                $('#uploadFile_al .detailAlert-p').html('上传出错');
                $('#uploadFile_al').modal('show');
                $('#select3').val('');
            };
            //上传成功
            var complete = function complete(isSuccess, code, backData) {
                if (isSuccess) {
                    var userData = JSON.parse(ALY.util.base64.decode(backData.userData)).Vod.UserData;

                    // var obj = document.getElementById('select3') ;
                    // obj.value = '';
                    // obj.outerHTML=obj.outerHTML;
                    // that.Uptoken3();
                    ++that.fileName3;
                    that.arrayUuid3.push(userData.file_id);
                    that.arrayName3.push(key);
                    $('#TextFile').attr('value', '');
                    $('#TextareaFile').attr('value', '');
                    $('#select3').val('');
                    $('#processModal').modal('hide');
                    if (that.numberSize <= that.arrayName3.length + that.MyUploadVideo.length) {
                        // if(that.UpFile.choose_num <= that.arrayName3.length){
                        $('#videoContainer3').hide();
                    }
                } else {
                    $('#processModal').modal('hide');
                    $('#TextFile').attr('value', '');
                    $('#TextareaFile').attr('value', '');
                    $('#select3').val('');
                    $('#uploadFile_al .detailAlert-p').html(backData);
                    $('#uploadFile_al').modal('show');
                }
            };
            var params = {};
            //上传
            if (that.$route.params.id == 0) {
                params.activity_id = that.id;
            } else {
                params.activity_id = that.$route.params.id || that.id;
            }

            params.source = "1";
            params.app_id = that.appId;
            params.audit_level = that.audit_level;
            console.log("fileupload" + params.audit_level);
            var content = {
                file: file, //文件名 必填
                file_type: "3",
                Biography: params
            };
            $('#processModal').modal('show');
            $.fn.uploadHandle(content, function () {
                console.log("开始上传！");
            }, next, complete);
            // $('.btn-pl-start3').on('click', function () {
            // if ($('#TextFile').val().trim() == '') {
            //   $('#TextFile').focus()
            // } else if ($('#TextareaFile').val().trim() == '') {
            //   $('#TextareaFile').focus()
            // } else {
            //
            // }
        });
        //取消
        $('.btn-pl-giveup').unbind('click').on('click', function () {
            $.fn.stopUploadFile();
            $.fn.cancleUploadFile();
            $.fn.deleteUploadFile();
            $('#TextFile').attr('value', '');
            $('#TextareaFile').attr('value', '');
            $('#select3').val('');
            var obj = document.getElementById('select3');
            obj.value = '';
            obj.outerHTML = obj.outerHTML;
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app',
  data: function data() {
    return {
      globalUrl: '..', // API.GlobalUrl
      MSIE: false
    };
  },

  methods: {
    //操作按钮事件
  },
  mounted: function mounted() {
    var that = this;
    var browser = navigator.appName;
    var b_version = navigator.appVersion;
    var version = b_version.split(";");
    var trim_Version = version[1].replace(/[ ]/g, "");
    if (browser == "Microsoft Internet Explorer") {
      if (trim_Version == "MSIE6.0" || trim_Version == "MSIE7.0" || trim_Version == "MSIE8.0") {
        that.MSIE = true;
      }
    }
  }
});

/***/ }),

/***/ "yEpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IsPC;


// 检验是否在电脑端打开
function IsPC() {
   var userAgentInfo = navigator.userAgent;
   var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
   var flag = true;
   for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
         flag = false;
         break;
      }
   }
   return flag;
}

/***/ }),

/***/ "yKjA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ySwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-series"},[(_vm.series.length)?_c('div',{staticClass:"detail-details show-box",staticStyle:{"margin-top":"0","padding-top":"15px"}},[_c('ul',{staticClass:"show-list clearfix"},_vm._l((_vm.series),function(item,i){return _c('li',{staticStyle:{"margin-bottom":"20px"}},[(new Date(item.end_time).getTime() / 1  - new Date().getTime() > 0 && new Date(item.start_time).getTime() / 1 - new Date().getTime() < 0)?_c('div',[(item.url_type && item.url_type == '2')?_c('router-link',{attrs:{"tag":"a","to":{name:'Notice',params: {id: item.id}}}},[_c('div',{staticClass:"pic-box"},[(item.playbill)?_c('img',{attrs:{"src":item.playbill.playbill_h5+'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e()]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm._f("ellipsis")(item.title, 20)))])]):_vm._e(),_vm._v(" "),(item.url_type && item.url_type == '3')?_c('router-link',{attrs:{"tag":"a","to":{name:'list_vote',params: {id: item.id,active: 0}}}},[_c('div',{staticClass:"pic-box"},[(item.playbill)?_c('img',{attrs:{"src":item.playbill.playbill_h5+'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e()]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm._f("ellipsis")(item.title,20)))])]):_vm._e(),_vm._v(" "),(item.url_type && item.url_type != '3'&& item.url_type != '2')?_c('router-link',{attrs:{"tag":"a","to":{name:'Detail',params: {id: item.id}}}},[_c('div',{staticClass:"pic-box"},[(item.playbill)?_c('img',{attrs:{"src":item.playbill.playbill_h5+'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e()]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm._f("ellipsis")(item.title,20)))])]):_vm._e()],1):_c('div',[_c('router-link',{attrs:{"tag":"a","to":{name:'Detail',params: {id: item.id}}}},[_c('div',{staticClass:"pic-box"},[(item.playbill)?_c('img',{attrs:{"src":item.playbill.playbill_h5+'?p=3&o=2&w=350&h=197',"alt":""}}):_vm._e()]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm._f("ellipsis")(item.title, 20)))])])],1),_vm._v(" "),(new Date(item.end_time).getTime() / 1  - new Date().getTime() > 0 && new Date(item.start_time).getTime() / 1 - new Date().getTime() < 0)?_c('a',{staticClass:"detail-details-a",on:{"click":function($event){$event.preventDefault();_vm.joinSeries(item)}}},[_vm._v("\n            马上参与\n          ")]):_vm._e(),_vm._v(" "),(new Date(item.end_time).getTime() / 1  - new Date().getTime() < 0)?_c('router-link',{staticClass:"detail-details-a",attrs:{"tag":"a","to":{name:'Detail',params: {id: item.id}},"href":"javascript:void(0);"}},[_vm._v("\n            活动结束\n          ")]):_vm._e(),_vm._v(" "),(new Date(item.start_time).getTime() / 1 - new Date().getTime() > 0)?_c('router-link',{staticClass:"detail-details-a",attrs:{"tag":"a","to":{name:'Detail',params: {id: item.id}},"href":"javascript:void(0);"}},[_vm._v("\n            即将开始\n          ")]):_vm._e()],1)})),_vm._v(" "),_c('p',{staticClass:"seriesAll",staticStyle:{"color":"#cf5454","font-size":"14px","margin-top":"-10px"},on:{"click":_vm.seriesAll}},[_vm._v("\n        加载更多\n      ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yY+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loginAler_vue__ = __webpack_require__("bckt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: '',
      activeId: '',
      activeName: '',
      leavingName: [],
      showVmoreName: false,
      uuid: '',
      pageName: 1,
      total: 0,
      userId: '',
      nickname: '',
      uuidPlace: '',
      num: '',
      visitNum: '',
      favoriteNum: '',
      type: '',
      fileId: '',
      fileItem: '',
      globalUrl: API.GlobalUrl
    };
  },

  methods: {
    //操作按钮事件
    fn: function fn() {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'Discovery' });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
    determine: function determine() {
      $('#detailAlert').modal('hide');
      $('#login_Alert').modal('show');
      // this.$router.push({name: 'login_Quick'})
    },
    showVmore: function showVmore() {
      this.showVmoreName = !this.showVmoreName;
      if (this.showVmoreName) {
        $('.preview-p').css({ 'height': 'auto' });
        $('.show-v-more').css({ 'transform': 'rotate(180deg)' });
      } else {
        $('.preview-p').css({ 'height': '40px' });
        $('.show-v-more').css({ 'transform': 'rotate(0deg)' });
      }
    },
    More: function More() {
      var pageName = ++this.page;
      this.MoreFn(pageName);
    },
    MoreFn: function MoreFn(pageName) {
      var that = this;
      //评论渲染
      $('.dl-message').show();
      //留言
      var Leaving = {
        app: 'xiyou',
        itemid: 'ishow_' + that.uuidPlace,
        itemtype: '0',
        prepage: 10,
        avatar: 1,
        page: pageName
      };
      // console.log(Leaving)
      //xiyou
      $.getJSON('http://common.newcomment.cntv.cn/data/list?jsonp_callback=?', Leaving, function (res) {
        if (res.code == 0) {
          for (var m = 0; m < res.data.content.length; m++) {
            that.leavingName.push(res.data.content[m]);
            var pid = res.data.content[m].pid;
            var tip = res.data.content[m].tip;
            //回复列表
          }
        }
        //console.log(that.leavingName)
        that.total = res.data.total;
        if (res.data.total < 10 || that.leavingName.length == res.data.total) {
          $('.dl-ms-more').hide();
        }
      });
    },
    like: function like() {
      //点赞-喜欢
      var that = this;

      if (that.type == 'no') {
        $('#discoverAlert').modal('show');
        return false;
      }
      if (that.uuid != '') {
        if ($('.link-Whether').hasClass('active')) {
          var videoFavorite = {
            file_id: that.uuid,
            op: 0
          };
          that.$http.get(API.VideoFavorite, { params: videoFavorite }).then(function (res) {
            $('.link-Whether').removeClass('active');
            $('.numberName').html(parseInt($('.numberName').text()) - 1);
          });
          return false;
        } else {
          var that = this;
          var videoFavorite = {
            file_id: that.uuid,
            op: 1
          };
          that.$http.get(API.VideoFavorite, { params: videoFavorite }).then(function (res) {
            that.linkFn(res);
          });
        }
      } else {
        if ($('.link-Whether').hasClass('active')) {
          var videoFavorite = {
            file_id: that.fileId,
            op: 0
          };
          that.$http.get(API.ImageFavorite, { params: videoFavorite }).then(function (res) {
            $('.link-Whether').removeClass('active');
            $('.numberName').html(parseInt($('.numberName').text()) - 1);
          });
          return false;
        } else {
          var that = this;
          var videoFavorite = {
            file_id: that.fileId,
            op: 1
          };
          that.$http.get(API.ImageFavorite, { params: videoFavorite }).then(function (res) {
            that.linkFn(res);
          });
        }
      }
    },
    linkFn: function linkFn(res) {
      var that = this;
      if (res.code == 0) {
        that.num = res.data.num;
        //动画
        $('.numberName').html(parseInt($('.numberName').text()) + 1);
        $('.link-Whether').addClass('active');
        $('.heart-shaped').show();
        $('.heart-shaped').addClass('heart-active');
        setTimeout(function () {
          $('.heart-shaped').addClass('heart-activex');
        }, 150);
        setTimeout(function () {
          $('.heart-shaped').removeClass('heart-activex');
          $('.heart-shaped').addClass('heart-active');
        }, 300);
        setTimeout(function () {
          $('.heart-shaped').removeClass('heart-active');
        }, 450);
        setTimeout(function () {
          $('.heart-shaped').fadeOut();
        }, 800);
      } else {
        $('#discoverAlert').modal('show');
      }
    },
    copyUrl: function copyUrl() {

      var url = location.href;
      var clipboard = new ClipboardJS('.toCopy', {
        text: function text(trigger) {
          return url;
        }
      });
      clipboard.on('success', function () {
        $('#chatModal .info-mess').html('复制成功啦！');
        $('#chatModal').modal('show');
        setTimeout(function () {
          $('#chatModal').modal('hide');
          clipboard.destroy();
        }, 2000);
      });
    }
  },

  components: { //渲染页面
    LoginAler: __WEBPACK_IMPORTED_MODULE_0__loginAler_vue__["a" /* default */]
  },
  created: function created() {
    var that = this;
    // 判断安卓机去掉动画
    that.isAndroid();
    if (that.$route.params.type == 'video') {
      that.uuid = that.$route.params.uuid || '';
    } else {
      that.fileId = that.$route.params.uuid || '';
    }
    that.activeId = that.$route.params.id;
    var getVideoInfo = '',
        APIName = '';
    if (that.uuid == '') {
      //图片
      getVideoInfo = {
        file_id: that.fileId,
        version: 2
      };
      APIName = API.GetImageInfo;
    } else {
      //视频
      getVideoInfo = {
        file_id: that.uuid,
        version: 2
      };
      APIName = API.GetVideoInfo;
    }

    function getCookie(name) {
      var arr,
          reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
      if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
      } else {
        return null;
      }
    }

    that.userId = getCookie('userSeqId');

    this.$http.get(API.GetActivitieById, { params: { id: that.activeId } }).then(function (res) {
      if (res.code == 0) {
        that.activeName = res.data.title;
      }
      getVideo(that);
    });

    function getVideo(that) {

      that.$http.get(APIName, { params: getVideoInfo }).then(function (res) {
        //console.log(that.uuid);
        if (res.code == 0) {
          that.item = res.data;

          that.visitNum = res.data.visit_num; //浏览
          that.favoriteNum = res.data.favorite_num; //点赞喜欢
          that.type = 'yes';
          $('.icon-ps').show();
          that.nickname = that.item.nickname; //用户名
          if (that.activeId == 100171) {
            that.item.description = '';
          }
          var dataName = '';
          if (that.uuid != '') {
            var len = $('.video_left').length;
            var W = document.documentElement.clientWidth; //播放窗口宽度
            var H = Math.ceil(document.documentElement.clientWidth / 1.78); //播放窗口高度
            that.VideoPlay(that.uuid, W, H, 'myFlash');
            that.uuidPlace = that.uuid.replace(/-/g, '_');

            document.title = that.item.title;
            var metas = $('head').children('meta');
            if (metas[1]) {
              metas[1].content = that.item.description;
            }
            if (res.data.thumb_url) {
              imgAdd = res.data.thumb_url;
            } else {
              imgAdd = '/images/video.jpg';
            }
            dataName = {
              title: that.item.title, //分享标题
              // desc: that.removeTAG(that.item.description, 110),//metas[1].content,//分享简介(内容)
              desc: that.removeTAG('我参与了【' + that.activeName + '】', 110), //metas[1].content,//我参与了（活动名称）；
              imgAddress: imgAdd, //分享图片地址
              Retain: '', //保留
              url: API.UrlName + 'videoName/' + that.activeId + '/' + that.uuid + '/video' //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
            };
            // console.log(dataName)
            that.weixinShare(dataName);
          } else {
            that.uuidPlace = that.fileId.replace(/-/g, '_');
            $('#myImg').html('<img src="' + that.item.image_url + '" alt=""/>');
            document.title = that.item.title;
            var _metas = $('head').children('meta');
            if (_metas[1]) {
              _metas[1].content = that.item.description;
            }
            var imgAdd = '';
            if (res.data.image_url) {
              imgAdd = res.data.image_url;
            } else {
              imgAdd = '/images/login-img.jpg';
            }
            dataName = {
              title: that.item.title, //分享标题
              // desc: that.removeTAG(that.item.description, 110),//metas[1].content,//分享简介(内容)
              desc: that.removeTAG('我参与了【' + that.activeName + '】', 110), //metas[1].content,//我参与了（活动名称）；
              imgAddress: imgAdd, //分享图片地址
              Retain: '', //保留
              url: API.UrlName + 'videoName/' + that.activeId + '/' + that.uuid + '/image' //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
            };
            that.weixinShare(dataName);
          }
          that.$nextTick(function () {

            if (!that.item.user) {
              $('.title-right').children('span').css('padding', '8px 10px 8px 8px');
            }
          });
        } else {
          that.type = 'no';
          $('.icon-ps').hide();
          $(".dl-ms-more").hide();
          $('.yaVideo').html('呀！作品找不到了！');
          //alert('没有对应信息');
          //that.$router.back(-1)
        }
        $('.detail-content').hide();
      });
    }
  },
  mounted: function mounted() {
    //操作DOM
    var that = this;
    if (that.IsPC()) {
      window.location.href = API.IsPcName;
    }
    setTimeout(function () {
      //获取视频信息，预览
      if (that.item && that.uuidPlace) {
        that.MoreFn(1);
      }
      if ($('.preview-p').height() > 40) {
        $('.preview-p').css({ 'height': '40px' });
        $('.show-v-more').show();
      } else {
        $('.show-v-more').hide();
      }

      //关闭留言框面板
      $('.dl-ms-btn').on('click', function () {
        $('#saytext').val('');
        $('#myFlash').show();
        $('.detail-messagebox').css({ 'top': '120%' });
      });

      // 打开留言面板
      // dl-ms-edit
      $('.dl-ms-title').on('click', function () {
        $('video')[0].pause();
        if (that.userId) {
          $('#saytext').val('');
          $('.detail-messagebox').css({ 'top': '0' });
          $('#myFlash').hide();
        } else {
          $('#myFlash').hide();
          $('#login_Alert').modal('show');
          return false;
        }
      });

      //查看结果留言表情
      function replace_em(str) {
        str = str.replace(/\</g, '&lt;');
        str = str.replace(/\>/g, '&gt;');
        str = str.replace(/\n/g, '<br/>');
        str = str.replace(/\[em_([0-9]*)\]/g, '<img src="../../static/dist/arclist/1.gif" border="0" />');
        return str;
      }

      function getCookie(name) {
        var arr = document.cookie.split('; ');

        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == name) {
            return arr2[1];
          }
        }
        return '';
      }

      var intervaLock;
      /*发布留言*/
      $('.btn-detail-edit').on('click', function () {
        if ($('#saytext').val() != '') {
          var Leaving = {
            app: 'xiyou',
            itemid: 'ishow_' + that.uuidPlace,
            authorid: that.userId,
            author: that.nickname,
            message: $('#saytext').val()
          };
          //console.log(Leaving)
          $.ajax({
            type: 'post',
            url: 'http://newcomment.cctv.com/comment/post',
            data: Leaving,
            dataType: 'jsonp',
            xhrFields: {
              withCredentials: true
            },
            crossDomain: true,
            jsonp: 'jsonp_callback',
            success: function success(res) {
              if (res.code == 0) {
                //prepend
                $('#myFlash').show();
                $('.detail-messagebox').css({ 'top': '120%' });
                $('#chatModal .info-mess').html('留言发布成功啦');
                $('#chatModal').modal('show');
                intervaLock = setTimeout(function () {
                  $('#chatModal').modal('hide');
                }, 2000);
              } else if (res.code == '20927') {
                var userSeqId = getCookie('userSeqId');
                var urlHref = window.location.href;
                var url = 'http://reg.cctv.com/authenicateAction/mobile/bind.html?service=' + API.UrlName + ' /index&iid=' + that.activeId + '&formFlag=3&userSeqId=' + userSeqId + '&flag=H5';
                window.location.href = url;
              }
            },
            error: function error() {
              alert('请求出错！');
            }
          });
          //  console.log(Leaving)
        }
      });
    }, 1000);
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "yx2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_release_vue__ = __webpack_require__("0JSV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_160f23e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_release_vue__ = __webpack_require__("ISSo");
function injectStyle (ssrContext) {
  __webpack_require__("av9n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-160f23e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_release_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_160f23e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_release_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zqrN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("中央广播电视总台  央视网  版权所有")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8048830e12d455226836.js